export const schools = [
  { text: 'COLEGIO ALEMAN DE ARICA', value: '60' },
  { text: 'COLEGIO CARDENAL ANTONIO SAMORE', value: '10915' },
  { text: 'COLEGIO INTEGRADO EDUARDO FREI MONTALVA', value: '8' },
  { text: 'COLEGIO SAN JORGE', value: '59' },
  { text: 'COLEGIO SAUCACHE', value: '12547' },
  { text: 'JUNIOR COLLEGE', value: '69' },
  { text: 'LICEO OCTAVIO PALMA PEREZ', value: '4' },
  { text: 'NORTH AMERICAN COLLEGE', value: '10892' },
  { text: 'ESC. BASICA Y PARV. KRONOS SCHOOL', value: '12602' },
  { text: 'COLEGIO HISPANO BRITANICO IQUIQUE', value: '12669' },
  { text: 'COLEGIO HUMBERSTONE', value: '12667' },
  { text: 'COLEGIO LIRIMA', value: '10900' },
  { text: 'COLEGIO MARIA REINA', value: '12573' },
  { text: 'COLEGIO UNIVERSITARIO UNAP', value: '12735' },
  { text: 'COLEGIO IQUIQUE YOUNG SCHOOL', value: '144' },
  { text: 'LICEO ACADEMIA IQUIQUE', value: '132' },
  { text: 'LICEO ATENEA', value: '134' },
  { text: 'LICEO LIBERT. GRAL.BERNARDO OHIGGINS', value: '107' },
  { text: 'LICEO MARIA AUXILIADORA', value: '127' },
  { text: 'LICEO SAMCA ARUMANTI', value: '12591' },
  { text: 'COLEGIO LITTLE COLLEGE', value: '12504' },
  { text: 'COL. ANTOFAGASTA', value: '364' },
  { text: 'COLEGIO SAN AGUSTIN', value: '12885' },
  { text: 'COL. SAN LUIS', value: '357' },
  { text: 'COLEGIO SANTA EMILIA', value: '344' },
  { text: 'ESCUELA PARTICULAR SANTA TERESITA', value: '337' },
  { text: 'HRVATSKA SKOLA S. ESTEBAN (EX-J. SKOLA)', value: '366' },
  { text: 'INS. SANTA MARIA', value: '358' },
  { text: 'LICEO ANDRES SABELLA', value: '304' },
  { text: 'LICEO EXPERIMENTAL ARTISTICO-APLICACION', value: '336' },
  { text: 'LICEO MARTA NAREA DIAZ', value: '285' },
  { text: 'LICEO PARTICULAR EBEN EZER II', value: '12891' },
  { text: 'NORTH COLLEGE', value: '12970' },
  { text: 'THE ANTOFAGASTA BAPTIST COLLEGE', value: '12963' },
  { text: 'COL. THE ANTOFAGASTA BRITISH SCHOOL', value: '361' },
  { text: 'COLEGIO CHUQUICAMATA', value: '257' },
  { text: 'COLEGIO ECOLOGICO MONTESSORI', value: '12838' },
  { text: 'COLEGIO JUAN PABLO II', value: '10962' },
  { text: 'COL  LEONARDO DA VINCI', value: '12829' },
  { text: 'COL  LICANCABUR', value: '12867' },
  { text: 'FUNDACION EDUC.COLEGIO NUESTRA SRA.DE AYQUINA', value: '254' },
  { text: 'COLEGIO PADRE ALBERTO HURTADO', value: '12851' },
  { text: 'COL  SAN IGNACIO', value: '12832' },
  { text: 'INSTITUTO OBISPO SILVA LEZAETA', value: '256' },
  { text: 'LICEO FRANCISCO DE AGUIRRE', value: '218' },
  { text: 'LICEO LUIS CRUZ MARTINEZ', value: '217' },
  { text: 'LOESS SCHOOL', value: '12876' },
  { text: 'LICEO FEDERICO VARELA', value: '379' },
  { text: 'LICEO DIEGO DE ALMEIDA', value: '392' },
  { text: 'COLEGIO CERVANTINO', value: '13188' },
  { text: 'COLEGIO PARTICULAR   SAN LORENZO', value: '13117' },
  { text: 'LICEO CATOLICO ATACAMA', value: '429' },
  { text: 'LICEO DE MUSICA', value: '415' },
  { text: 'LICEO MERCEDES FRITIS MACKENNEY', value: '400' },
  { text: 'LICEO PEDRO TRONCOSO MACHUCA', value: '448' },
  { text: 'LICEO SAN FRANCISCO', value: '479' },
  { text: 'LICEO DOMINGO ORTIZ DE ROZAS', value: '967' },
  { text: 'COLEGIO  SAN FRANCISCO JAVIER', value: '13486' },
  { text: 'LICEO NICOLAS FEDERICO LOHSE VARGAS', value: '1048' },
  { text: 'COLEGIO SAINT MARY SCHOOL', value: '13332' },
  { text: 'COLEGIO BERNARDO OHIGGINS', value: '646' },
  { text: 'COLEGIO FRANCIS SCHOOL', value: '13313' },
  { text: 'COLEGIO SANTA FAMILIA', value: '13442' },
  { text: 'COLEGIO SANTA MARTA', value: '648' },
  { text: 'LIC.DE CIENC.Y HUM.SAN JOSEMARIA ESCRIVA', value: '13561' },
  { text: 'COLEGIO PARTICULAR ADVENTISTA MARANATA', value: '565' },
  { text: 'COLEGIO ALBERT EINSTEIN', value: '13356' },
  { text: 'COLEGIO ALEMAN', value: '13300' },
  { text: 'COLEGIO ANDRES BELLO - PAMPA', value: '13450' },
  { text: 'COLEGIO ANDRES BELLO', value: '582' },
  { text: 'COLEGIO FRANCISCO PALAU', value: '13372' },
  { text: 'COLEGIO GABRIEL GONZALEZ VIDELA', value: '530' },
  { text: 'COLEGIO GERONIMO RENDIC', value: '580' },
  { text: 'COLEGIO SERENA', value: '587' },
  { text: 'COLEGIO SAGRADOS CORAZONES', value: '583' },
  { text: 'COLEGIO SAN JOAQUIN', value: '13434' },
  { text: 'COLEGIO SANTO TOMAS  LA SERENA', value: '13388' },
  {
    text: 'ESCUELA EXPERIMENTAL DE MUSICA JORGE PE\u00c3\u2018A HEN',
    value: '581',
  },
  { text: 'LICEO GABRIELA MISTRAL DE LA SERENA', value: '516' },
  { text: 'LICEO GREGORIO CORDOVEZ', value: '517' },
  { text: 'LICEO PADRE COLL', value: '13537' },
  { text: 'SAINT JOHNS SCHOOL', value: '13384' },
  { text: 'SCUOLA ITALIANA ALCIDE DE GASPERI', value: '13319' },
  { text: 'COLEGIO THE INTERNATIONAL SCHOOL', value: '585' },
  { text: 'COLEGIO ANTONIO VARAS', value: '690' },
  { text: 'COLEGIO AMALIA ERRAZURIZ', value: '770' },
  { text: 'COLEGIO PARTICULAR SANTA MARIA', value: '11106' },
  { text: 'COLEGIO PUCARA', value: '13439' },
  { text: 'COLEGIO SAN VIATOR', value: '769' },
  { text: 'COLEGIO PART.SANTA TERESA DE JESUS', value: '11107' },
  { text: 'ESCUELA DE ARTES Y MUSICA', value: '13387' },
  { text: 'SUN VALLEY COLLEGE', value: '14217' },
  { text: 'INSTITUTO CHACABUCO', value: '1225' },
  { text: 'LICEO MAXIMILIANO SALAS MARCHAN', value: '1194' },
  { text: 'COLEGIO ANDRES BELLO', value: '12177' },
  { text: 'COLEGIO DOMINGO ORTIZ DE ROZAS', value: '14416' },
  { text: 'COLEGIO PARROQUIAL FRANCISCO DIDIER', value: '1190' },
  { text: 'ESCUELA SAN GABRIEL DE LA RIVERA', value: '11240' },
  { text: 'COLEGIO TERESA BROWN DE ARIZTIA', value: '1437' },
  { text: 'COLEGIO APUMANQUE', value: '14506' },
  { text: 'LICEO SAN ISIDRO', value: '1421' },
  { text: 'COLEGIO NACIONAL', value: '14510' },
  { text: 'COLEGIO FRANCISCO DE MIRANDA', value: '1392' },
  { text: 'COLEGIO NUEVA ERA SIGLO XXI  QUILLOTA', value: '14673' },
  { text: 'COLEGIO SAN IGNACIO DE LA SSALLE', value: '12295' },
  { text: 'COLEGIO TIERRA DEL FUEGO', value: '14671' },
  { text: 'INSTITUTO RAFAEL ARIZTIA', value: '1404' },
  { text: 'COLEGIO ARAUCARIAS', value: '14626' },
  { text: 'COLEGIO CRISTO REY SALVADOR', value: '14568' },
  { text: 'COLEGIO JOSE LUIS NORRIS', value: '14373' },
  { text: 'COLEGIO PARTICULAR SARA CRUCHAGA', value: '2047' },
  { text: 'COLEGIO FUND.EDUC. FERNANDEZ LEON', value: '2049' },
  { text: 'INSTITUTO DEL PUERTO DE SAN ANTONIO', value: '2042' },
  { text: 'INSTITUTO ERCILLA', value: '2043' },
  { text: 'LICEO GABRIELA MISTRAL', value: '2045' },
  { text: 'LICEO SANTA TERESITA DE LLOLLEO', value: '2041' },
  { text: 'COLEGIO PEOPLE HELP PEOPLE', value: '2091' },
  { text: 'LICEO POLITECNICO LLAY LLAY', value: '1335' },
  { text: 'COLEGIO ALEMAN DE SAN FELIPE', value: '11237' },
  { text: 'COLEGIO JOSE AGUSTIN GOMEZ', value: '1291' },
  { text: 'COLEGIO VEDRUNA', value: '14614' },
  { text: 'INSTITUTO ABDON CIFUENTES', value: '1288' },
  { text: 'COLEGIO INTERNACIONAL SEK DEL PACIFICO', value: '14379' },
  { text: 'COL.PARROQUIAL SANTA MARIA GORETTI', value: '1743' },
  { text: 'COLEGIO RAYEN CAVEN', value: '1769' },
  { text: 'COLEGIO VILLA ACONCAGUA', value: '14605' },
  { text: 'COLEGIO GENERAL JOSE VELASQUEZ BORQUEZ', value: '1863' },
  { text: 'COLEGIO ACONCAGUA', value: '1757' },
  { text: 'COLEGIO  AMUILLAN', value: '14790' },
  { text: 'COLEGIO CARLOMAGNO', value: '14771' },
  { text: 'COLEGIO COEDUC', value: '14508' },
  { text: 'COL.COEDUCACIONAL PART. QUILPUE', value: '1937' },
  { text: 'COLEGIO CRISTIANO DE QUILPUE', value: '1923' },
  { text: 'COLEGIO EL BELLOTO', value: '1941' },
  { text: 'COLEGIO ESPERANZA', value: '1934' },
  { text: 'COLEGIO LIAHONA', value: '1909' },
  { text: 'COLEGIO LOS FUNDADORES DE QUILPUE', value: '14576' },
  { text: 'LICEO GUILLERMO GRONEMEYER ZAMORANO', value: '1882' },
  { text: 'COLEGIO DON ORIONE', value: '1858' },
  { text: 'LICEO POLITECNICO QUINTERO', value: '1851' },
  { text: 'COLEGIO AGUSTIN EDWARDS', value: '1635' },
  { text: 'COLEGIO ALBORADA DE CURAUMA', value: '14466' },
  { text: 'COLEGIO CARLOS COUSINO', value: '1586' },
  { text: 'COLEGIO DE LOS SAGRADOS CORAZONES', value: '1631' },
  { text: 'COLEGIO LEONARDO MURIALDO', value: '1604' },
  { text: 'COLEGIO MARIA AUXILIADORA', value: '1587' },
  { text: 'COLEGIO PRESBIT. DAVID TRUMBULL', value: '1580' },
  { text: 'COLEGIO SALESIANO VALPARAISO', value: '1590' },
  { text: 'LICEO COEDUCACIONAL LA IGUALDAD', value: '1585' },
  { text: 'LICEO EDUARDO DE LA BARRA', value: '1515' },
  { text: 'LICEO JUANA ROSS DE EDWARDS', value: '1581' },
  { text: 'LICEO SANTA TERESA', value: '1579' },
  { text: 'LICEO VALPARAISO', value: '1520' },
  { text: 'SCUOLA ITALIANA ARTURO DELLORO', value: '1638' },
  { text: 'AMERICAN COLLEGE', value: '14211' },
  { text: 'LICEO ALEXANDER FLEMING DE LAS CONDES', value: '8818' },
  { text: 'COLEGIO BUCKINGHAM', value: '14585' },
  { text: 'COLEGIO HISPANO', value: '14363' },
  { text: 'COLEGIO NACIONAL', value: '1977' },
  { text: 'COLEGIO NACIONAL SANTA ANA', value: '14358' },
  { text: 'COLEGIO CHAMPAGNAT', value: '11176' },
  { text: 'SCUOLA ITALIANA GIROLAMO LONGHI', value: '1988' },
  { text: 'ALLIANCE FRANCAISE DE VALPARAISO', value: '1781' },
  { text: 'COLEGIO ALEMAN DE VALPARAISO', value: '1839' },
  { text: 'COLEGIO ANA MARIA JANER', value: '1755' },
  { text: 'COLEGIO CAPELLAN PASCAL', value: '14334' },
  { text: 'COLEGIO CLAUDIO MATTE', value: '1756' },
  { text: 'COL.SS.CC.MONJAS FRANCESAS', value: '1792' },
  { text: 'COLEGIO DEL SAGRADO CORAZON RE\u00c3\u2018ACA', value: '1793' },
  { text: 'COLEGIO LORD COCHRANE ANEXO', value: '14260' },
  { text: 'COLEGIO MARIA AUXILIADORA', value: '1801' },
  { text: 'COLEGIO MONTEMAR', value: '14498' },
  { text: 'COLEGIO PATMOS', value: '1780' },
  { text: 'COLEGIO PROFESOR HUGUET', value: '1789' },
  { text: 'COLEGIO SAINT DOMINIC', value: '1777' },
  { text: 'COLEGIO SAN IGNACIO', value: '1795' },
  { text: 'COLEGIO WINTERHILL', value: '1778' },
  { text: 'LICEO PARROQUIAL SAN ANTONIO', value: '1735' },
  { text: 'LICEO RENE DESCARTES', value: '14284' },
  { text: 'SAINT PAULS SCHOOL', value: '1791' },
  { text: 'SEMINARIO SAN RAFAEL', value: '1774' },
  { text: 'THE INTEGRITY COLLEGE', value: '14563' },
  { text: 'THE MACKAY SCHOOL', value: '1788' },
  { text: 'VINA DEL MAR COLLEGE', value: '14428' },
  { text: 'LICEO CLAUDIO ARRAU LEON', value: '2411' },
  { text: 'INSTITUTO SANTA TERESA DE LOS ANDES', value: '15646' },
  { text: 'LICEO PROFESOR MISAEL LOBOS MONROY', value: '2205' },
  { text: 'COLEGIO PARTICULAR ARTURO PRAT', value: '2259' },
  { text: 'COLEGIO COYA', value: '2260' },
  { text: 'COLEGIO SAN IGNACIO', value: '15534' },
  { text: 'LICEO MACHALI', value: '15759' },
  { text: 'VILLA MARIA COLLEGE', value: '11291' },
  { text: 'LICEO ALBERTO HURTADO', value: '2222' },
  { text: 'COLEGIO ALCALDE PEDRO URBINA', value: '15589' },
  { text: 'COLEGIO ALONSO DE ERCILLA', value: '2185' },
  { text: 'COLEGIO CUISENAIRE', value: '2163' },
  { text: 'COLEGIO PARTICULAR SUBV.DON BOSCO', value: '11256' },
  { text: 'COLEGIO HISPANO CHILENO EL PILAR', value: '15676' },
  { text: 'COLEGIO INGLES SAINT JOHN', value: '15521' },
  { text: 'COLEGIO LA CRUZ', value: '15564' },
  { text: 'COLEGIO LA MERCED', value: '2198' },
  { text: 'COLEGIO QUIMAHUE', value: '15510' },
  { text: 'COLEGIO RANCAGUA', value: '15707' },
  { text: 'COLEGIO SAGRADO CORAZON', value: '2191' },
  { text: 'INSTITUTO INGLES RANCAGUA', value: '2194' },
  { text: 'INSTITUTO OHIGGINS', value: '2200' },
  { text: 'INSTITUTO REGIONAL DE EDUCACION', value: '2166' },
  { text: 'INSTITUTO SAGRADO CORAZON', value: '2150' },
  { text: 'COLEGIO PARTICULAR INSTITUTO SAN ANDRES', value: '2183' },
  { text: 'LICEO MUNICIPAL OSCAR CASTRO ZUNIGA', value: '2110' },
  { text: 'CENTRO EDUCACIONAL ASUNCION', value: '2309' },
  { text: 'COLEGIO ANTILEN', value: '15601' },
  { text: 'COLEGIO SAN ANTONIO DEL BALUARTE', value: '2308' },
  { text: 'LICEO LUIS URBINA FLORES', value: '2283' },
  { text: 'LICEO SAN JOSE DE REQUINOA', value: '2278' },
  { text: 'COLEGIO EL SALVADOR', value: '2355' },
  { text: 'COLEGIO NEHUEN', value: '15657' },
  { text: 'COLEGIO SANTA INES', value: '2356' },
  { text: 'LICEO IGNACIO CARRERA PINTO', value: '2329' },
  { text: 'COLEGIO DE LA PRECIOSA SANGRE', value: '2656' },
  { text: 'COLEGIO ARRAYANES', value: '15576' },
  { text: 'INSTITUTO HANS CHRISTIAN ANDERSEN', value: '15684' },
  { text: 'FUNDACION EDUCACIONAL INSTITUTO SAN FERNANDO', value: '2482' },
  { text: 'LICEO JOS\u00c9 GREGORIO ARGOMEDO', value: '2453' },
  { text: 'LICEO DE HOMBRES NEANDRO SCHILLING', value: '2447' },
  { text: 'SAN FERNANDO COLLEGE', value: '2454' },
  { text: 'COLEGIO MANQUEMAVIDA', value: '15664' },
  { text: 'INSTITUTO REGIONAL FEDERICO ERRAZURIZ', value: '2579' },
  { text: 'LICEO MARIA AUXILIADORA', value: '2580' },
  { text: 'LICEO MUNICIPAL DE SANTA CRUZ', value: '2551' },
  { text: 'LICEO ANTONIO VARAS', value: '3538' },
  { text: 'C.EDUC.MONS.MANUEL LARRAIN ERRAZURIZ.', value: '2785' },
  { text: 'COLEGIO DIEGO THOMPSON', value: '16512' },
  { text: 'COLEGIO HISPANOCHILENO EL PILAR', value: '16508' },
  { text: 'COLEGIO RAUQUEN', value: '16415' },
  { text: 'COLEGIO SAN RAMON NONATO', value: '2782' },
  { text: 'COLEGIO VICHUQUEN', value: '2790' },
  { text: 'INSTITUTO SAN MARTIN', value: '2786' },
  { text: 'LICEO FERNANDO LAZCANO', value: '2732' },
  { text: 'ALIANZA FRANCESA JEAN MERMOZ', value: '2789' },
  { text: 'COLEGIO  ORCHARD COLLEGE', value: '16431' },
  { text: 'LICEO HUALANE', value: '2882' },
  { text: 'LICEO JUAN AGUSTIN MORALES GONZALEZ', value: '2836' },
  { text: 'COLEGIO AQUELARRE', value: '16477' },
  { text: 'INSTITUTO LINARES', value: '3300' },
  { text: 'LICEO NUESTRA SE\u00c3\u2018ORA DEL ROSARIO', value: '3298' },
  { text: 'LICEO VALENTIN LETELIER', value: '3247' },
  { text: 'COLEGIO PARTICULAR PROVIDENCIA', value: '3432' },
  { text: 'INSTITUTO REGIONAL DEL MAULE', value: '3531' },
  { text: 'LICEO SAGRADOS CORAZONES', value: '3533' },
  { text: 'COLEGIO BOSQUES DE GAIA', value: '16476' },
  { text: 'COLEGIO CONSTITUCION', value: '3204' },
  { text: 'LICEO CONSTITUCION', value: '3165' },
  { text: 'LICEO LUIS EDMUNDO CORREA ROJAS', value: '3205' },
  { text: 'COLEGIO PAULA MONTAL', value: '3108' },
  { text: 'COLEGIO CONCEPCION TALCA', value: '16470' },
  { text: 'COLEGIO DE LA SALLE', value: '3012' },
  { text: 'COLEGIO INGLES', value: '3014' },
  { text: 'COLEGIO INTEGRADO SAN PIO X', value: '3009' },
  { text: 'COLEGIO JUAN IGNACIO MOLINA', value: '3013' },
  { text: 'COLEGIO LOS AGUSTINOS EDUCA Y DEPORTE', value: '16678' },
  { text: 'COLEGIO PARTICULAR MONTESSORI', value: '3015' },
  { text: 'COLEGIO SAN IGNACIO DE TALCA', value: '16627' },
  { text: 'LICEO ABATE MOLINA', value: '2973' },
  { text: 'LICEO MARTA DONOSO ESPEJO', value: '2935' },
  { text: 'LICEO SANTA MARTA', value: '16441' },
  { text: 'COLEGIO ARAUCO', value: '5083' },
  { text: 'LICEO GABRIELA MISTRAL', value: '5150' },
  { text: 'LICEO MARIANO LATORRE', value: '5084' },
  { text: 'COLEGIO SAN JORGE', value: '4499' },
  {
    text: 'LICEO POLITECNICO HEROES DE LA CONCEPCI\u00c3\u201cN',
    value: '4483',
  },
  { text: 'CENTRO EDUC.ADVENTISTA LOS ANGELES', value: '4277' },
  { text: 'COLEGIO INGLES WOODLAND', value: '17605' },
  { text: 'SAINT GEORGE SCHOOL', value: '17918' },
  { text: 'COLEGIO SAN IGNACIO', value: '17736' },
  { text: 'COLEGIO CONCEPCION', value: '4689' },
  { text: 'COLEGIO AURORA DE CHILE CHIGUAYANTE', value: '17843' },
  { text: 'COLEGIO PARTICULAR ANDRES BELLO', value: '4631' },
  { text: 'COLEGIO PINARES', value: '12036' },
  { text: 'COLEGIO ALEMAN DE CONCEPCI\u00c3\u201cN', value: '4687' },
  { text: 'COLEGIO CARMELA ROMERO DE ESPINOSA', value: '18007' },
  { text: 'COLEGIO DEL SAGRADO CORAZON', value: '4630' },
  { text: 'COLEGIO MARIA INMACULADA', value: '4663' },
  { text: 'COLEGIO METODISTA CONCEPCION', value: '17900' },
  { text: 'COLEGIO REPUBLICA DEL BRASIL', value: '4564' },
  { text: 'COLEGIO SAN IGNACIO', value: '4662' },
  { text: 'SAN PEDRO NOLASCO', value: '4698' },
  { text: 'ESCUELA PARTICULAR SANTA SABINA', value: '4646' },
  { text: 'SAINT JOHNS SCHOOL', value: '4694' },
  { text: 'COLEGIO INMACULADA CONCEPCION', value: '17855' },
  { text: 'INSTITUTO DE HUMANIDADES ALFREDO SILVA S', value: '4686' },
  { text: 'KINGSTON COLLEGE', value: '4679' },
  { text: 'LICEO CREACION CONCEPCION', value: '17913' },
  { text: 'LICEO DE NINAS', value: '4553' },
  { text: 'LICEO ENRIQUE MOLINA GARMENDIA', value: '4555' },
  { text: 'LICEO EXPERIMENTAL LUCILA GODOY ALCAYAGA', value: '4557' },
  { text: 'COLEGIO GRAN BRETA\u00c3\u2018A', value: '4572' },
  { text: 'COLEGIO JUAN GREGORIO LAS HERAS', value: '4588' },
  { text: 'LICEO LORENZO ARENAS OLIVO', value: '4559' },
  { text: 'COLEGIO MARINA DE CHILE', value: '4531' },
  { text: 'LICEO SALESIANO DOMINGO SAVIO', value: '4632' },
  { text: 'THE WESSEX SCHOOL', value: '12024' },
  { text: 'COLEGIO EINSTEIN', value: '17815' },
  { text: 'LICEO CORONEL ANTONIO SALAMANCA', value: '4982' },
  { text: 'COLEGIO PADRE MANUEL DALZON', value: '17850' },
  { text: 'LICEO PENCOPOLITANO', value: '4805' },
  { text: 'COLEGIO CONCEPCION SAN PEDRO', value: '17606' },
  { text: 'COLEGIO DE LA SANTISIMA TRINIDAD', value: '17634' },
  { text: 'ESCUELA PARTICULAR INSTITUTO  SAN PEDRO', value: '4656' },
  { text: 'COLEGIO ADVENTISTA DE TALCAHUANO', value: '18049' },
  { text: 'COLEGIO ETCHEGOYEN TALCAHUANO', value: '17833' },
  { text: 'COLEGIO MIXTO INMACULADA CONCEPCION', value: '17858' },
  { text: 'COLEGIO SANTA BERNARDITA', value: '4785' },
  { text: 'COLEGIO PARTICULAR TALCAHUANO', value: '4778' },
  { text: 'COLEGIO SAN CRISTOBAL', value: '17708' },
  { text: 'SAGRADOS CORAZONES', value: '4798' },
  { text: 'LICEO ALMTE.PEDRO ESPINA RITCHIE', value: '4702' },
  { text: 'THE THOMAS JEFFERSON SCHOOL', value: '12063' },
  { text: 'LICEO VICENTE ALBERTO PALACIOS VALDES', value: '4829' },
  { text: 'COLEGIO ADVENTISTA DE CHILE', value: '3865' },
  { text: 'COLEGIO CHILLAN', value: '3735' },
  { text: 'COLEGIO CONCEPCION DE CHILLAN', value: '17794' },
  { text: 'COLEGIO CREACION CHILLAN', value: '17907' },
  { text: 'COLEGIO DA VINCI', value: '17734' },
  { text: 'COLEGIO DE LA PURISIMA CONCEPCION', value: '3711' },
  { text: 'COLEGIO SEMINARIO PADRE ALBERTO HURTADO', value: '3713' },
  { text: 'COLEGIO PARTICULAR SAN VICENTE', value: '3724' },
  { text: 'INSTITUTO SANTA MARIA', value: '3718' },
  { text: 'COLEGIO FRANCISCO DE ASIS', value: '3885' },
  { text: 'LICEO POLITECNICO CARLOS MONTANE  CASTRO', value: '4102' },
  { text: 'COLEGIO SAGRADO CORAZON DE JESUS', value: '3797' },
  { text: 'INSTITUTO SANTA MARIA DE SAN CARLOS', value: '3795' },
  { text: 'LICEO SAN NICOLAS', value: '4140' },
  { text: 'COLEGIO CHOLGUAN', value: '12032' },
  { text: 'COLEGIO DIVINA PASTORA', value: '3960' },
  { text: 'LICEO DE YUNGAY', value: '3940' },
  { text: 'LICEO MUNICIPAL ATENEA', value: '5957' },
  { text: 'LICEO H-C JORGE TEILLIER SANDOVAL', value: '5823' },
  { text: 'LICEO SAN FCO DE ASIS DE NVA IMPERIAL', value: '6644' },
  { text: 'COLEGIO LEONARDO DA VINCI SCHOOL', value: '20090' },
  { text: 'LICEO DE CIENCIAS Y HUMANIDADES', value: '6223' },
  { text: 'COLEGIO LIAHONA', value: '20167' },
  { text: 'COMPLEJO EDUCACIONAL PABLO SEXTO', value: '6070' },
  { text: 'COLEGIO BAUTISTA', value: '5810' },
  { text: 'COLEGIO DE LA SALLE', value: '5808' },
  { text: 'COLEGIO METODISTA', value: '5816' },
  { text: 'COLEGIO SAN FRANCISCO', value: '5670' },
  { text: 'COLEGIO SCOLE CREARE', value: '20048' },
  { text: 'GREEN HOUSE SCHOOL', value: '19908' },
  { text: 'INSTITUTO CLARET', value: '5654' },
  { text: 'LICEO HUMANISTA CIENTIFICO BRAINSTORM', value: '20173' },
  { text: 'LICEO CAMILO HENRIQUEZ DE TEMUCO', value: '5666' },
  { text: 'LICEO PARTICULAR JAN COMENIUS', value: '20159' },
  { text: 'LICEO PABLO NERUDA', value: '5570' },
  { text: 'LICEO ESPANA DE TEMUCO', value: '5662' },
  { text: 'ESCUELA Y LICEO MONTESSORI', value: '5659' },
  { text: 'COLEGIO DE HUMANIDADES DE VILLARICA', value: '6112' },
  { text: 'COLEGIO CONCEPCION ANGOL', value: '19972' },
  { text: 'LICEO LAS ARAUCARIAS', value: '5344' },
  { text: 'LICEO MARIA AURORA GUINEZ RAMIREZ', value: '5507' },
  { text: 'COLEGIO INSTITUTO VICTORIA', value: '5434' },
  { text: 'COLEGIO SANTA CRUZ DE VICTORIA', value: '5435' },
  { text: 'LICEO JORGE ALESSANDRI RODRIGUEZ', value: '5394' },
  { text: 'COLEGIO ALEMAN R.A. PHILIPPI', value: '7180' },
  { text: 'LICEO RECTOR ABDON ANDRADE COLOMA', value: '7129' },
  { text: 'UNION COLLEGE', value: '22305' },
  { text: 'LICEO ANTONIO VARAS', value: '7299' },
  { text: 'SEMINARIO SAN FIDEL', value: '6896' },
  { text: 'LICEO RODULFO AMANDO PHILIPPI', value: '7200' },
  { text: 'COLEGIO ALONSO DE ERCILLA', value: '6836' },
  { text: 'COLEGIO DOMUS MATER', value: '22231' },
  { text: 'COLEGIO MARIA AUXILIADORA', value: '6832' },
  { text: 'COLEGIO SAN LUIS DE ALBA', value: '22177' },
  { text: 'COLEGIO TORNAGALEONES', value: '22442' },
  { text: 'COLEGIO WINDSOR SCHOOL', value: '6843' },
  { text: 'INSTITUTO ALEMAN CARLOS ANWANDTER', value: '6844' },
  { text: 'INSTITUTO INMACULADA CONCEPCION', value: '22351' },
  { text: 'INSTITUTO ITALIA DE VALDIVIA', value: '22540' },
  { text: 'INSTITUTO SALESIANO', value: '6829' },
  { text: 'LICEO ARMANDO ROBLES RIVERA', value: '6754' },
  { text: 'LICEO SANTA MARIA LA BLANCA', value: '6753' },
  { text: 'CENTRO EDUCACIONAL SAN ANDRES', value: '22210' },
  { text: 'COLEGIO CHARLES DARWIN DE ANCUD', value: '22505' },
  { text: 'LICEO EL PILAR', value: '8109' },
  { text: 'LICEO DOMINGO ESPINEIRA RIESCO', value: '8044' },
  { text: 'COLEGIO CARPE DIEM', value: '22155' },
  { text: 'COLEGIO SAN FRANCISCO DE ASIS', value: '22065' },
  { text: 'LICEO GALVARINO RIVEROS CARDENAS', value: '8002' },
  { text: 'LICEO RAYEN MAPU', value: '8255' },
  { text: 'LICEO POLIVALENTE QUEMCHI', value: '8111' },
  { text: 'LICEO RAMON FREIRE', value: '8194' },
  { text: 'LICEO IGNACIO CARRERA PINTO', value: '22022' },
  { text: 'COLEGIO RAMON ANGEL JARA', value: '7907' },
  { text: 'COLEGIO CATOLICO BEATO FEDERICO OZANAZ', value: '22192' },
  { text: 'COLEGIO INMACULADA CONCEPCION', value: '7707' },
  { text: 'COLEGIO PUMAHUE PUERTO MONTT', value: '22506' },
  { text: 'COLEGIO SAN FRANCISCO JAVIER', value: '7700' },
  { text: 'INSTITUTO ALEMAN DE PUERTO MONTT', value: '7717' },
  { text: 'INSTITUTO DEL PACIFICO', value: '22200' },
  { text: 'LICEO ISIDORA ZEGERS DE HUNEEUS', value: '7628' },
  { text: 'LICEO DE HOMBRES MANUEL MONTT', value: '7627' },
  { text: 'COLEGIO GERMANIA DEL VERBO DIVINO', value: '7742' },
  { text: 'LICEO PEDRO AGUIRRE CERDA', value: '7720' },
  { text: 'COLEGIO CREACION OSORNO', value: '22410' },
  { text: 'COLEGIO SAN MATEO DE OSORNO', value: '7406' },
  { text: 'INSTITUTO ALEMAN DE OSORNO', value: '7415' },
  { text: 'LICEO ELEUTERIO RAMIREZ', value: '7329' },
  { text: 'LICEO OSORNO COLLEGE', value: '7416' },
  { text: 'COLEGIO INGLES', value: '22358' },
  { text: 'COLEGIO SANTA TERESA DE LOS ANDES', value: '24213' },
  { text: 'LICEO RAUL BROUSSAIN CAMPINO', value: '24203' },
  { text: 'LICEO SAN JOSE U.R.', value: '24207' },
  { text: 'LICEO ARTURO PRAT CHACON', value: '24204' },
  { text: 'LICEO AUSTRAL LORD COCHRANE', value: '24201' },
  { text: 'COLEGIO ALIANZA AUSTRAL DE COYHAIQUE', value: '24212' },
  { text: 'COLEGIO ANTOINE DE SAINT EXUPERY', value: '24224' },
  { text: 'COLEGIO BAUTISTA EL SHADDAI', value: '24227' },
  { text: 'COLEGIO DIEGO PORTALES', value: '24231' },
  { text: 'LICEO REPUBLICA ARGENTINA', value: '8352' },
  { text: 'LICEO JOSEFINA AGUIRRE MONTENEGRO', value: '8345' },
  { text: 'LICEO SAN FELIPE BENICIO DE COYHAIQUE', value: '8365' },
  { text: 'COLEGIO ALEMAN', value: '8464' },
  { text: 'COLEGIO CHARLES DARWIN', value: '11680' },
  { text: 'COLEGIO CRUZ DEL SUR', value: '24314' },
  { text: 'LICEO JUAN BAUTISTA CONTARDI', value: '24307' },
  { text: 'LICEO LUIS ALBERTO BARRERA', value: '8429' },
  { text: 'LICEO MARIA AUXILIADORA', value: '8455' },
  { text: 'LICEO NOBELIUS', value: '24303' },
  { text: 'LICEO SAN JOSE', value: '24329' },
  { text: 'COLEGIO BRITANICO THE BRITISH', value: '8463' },
  { text: 'LICEO GABRIELA MISTRAL', value: '24300' },
  { text: 'COLEGIO POLIVALENTE SEMBRADOR', value: '25032' },
  { text: 'COLEGIO SAN  ANSELMO', value: '24927' },
  { text: 'COLEGIO MUNICIPAL INSTITUTO CHACABUCO', value: '25855' },
  { text: 'CENTRO EDUC. PRINCIPADO DE ASTURIAS', value: '25171' },
  { text: 'CENTRO EDUCACIONAL SAN CARLOS DE ARAGON', value: '25439' },
  { text: 'COLEGIO ALICANTE DEL SOL', value: '25999' },
  { text: 'COLEGIO PARTICULAR ALTAZOR', value: '25558' },
  { text: 'COLEGIO ARTURO PRAT', value: '10482' },
  { text: 'COLEGIO CORDILLERA', value: '10484' },
  { text: 'COLEGIO ESTELA SEGURA', value: '10479' },
  { text: 'EXTREMADURA DE PUENTE ALTO', value: '25218' },
  { text: 'INTERNATIONAL COUNTRY SCHOOL', value: '24491' },
  { text: 'COLEGIO LOS AROMOS', value: '10512' },
  { text: 'COLEGIO LOS NOGALES', value: '24648' },
  { text: 'COLEGIO MONTE DE ASIS', value: '25223' },
  { text: 'COLEGIO PARTICULAR NIDAL', value: '10513' },
  { text: 'COLEGIO OBISPO ALVEAR', value: '25389' },
  { text: 'COLEGIO ALMENAR DEL MAIPO', value: '24988' },
  { text: 'COLEGIO PARTICULAR MIRADOR', value: '25580' },
  { text: 'COLEGIO PARTICULAR SAN JOSE DE PUENTE ALTO', value: '25571' },
  { text: 'COLEGIO PEDRO APOSTOL', value: '25613' },
  { text: 'COLEGIO POLIV.  ARZOBISPO CRESCENTE ERRAZURIZ', value: '25781' },
  { text: 'COLEGIO SAN LUIS DE GONZAGA II', value: '10493' },
  { text: 'COLEGIO SANTA MARIA DE LA CORDILLERA', value: '24410' },
  { text: 'COLEGIO SENDA DEL SABER', value: '10506' },
  { text: 'ESCUELA CONSOLIDADA', value: '10450' },
  { text: 'LICEO NUESTRA SENORA DE LAS MERCEDES', value: '10489' },
  { text: 'LICEO PARTICULAR ROSA TOCORNAL', value: '11839' },
  { text: 'LICEO PUENTE ALTO', value: '10452' },
  { text: 'COLEGIO BUIN', value: '24719' },
  { text: 'COLEGIO LA CANTERA', value: '25058' },
  { text: 'COLEGIO SAN ISIDRO', value: '24836' },
  { text: 'LICEO 131', value: '10638' },
  { text: 'LICEO POLIVALENTE MODERNO CARDENAL CARO', value: '10658' },
  { text: 'COLEGIO LA MISION', value: '25477' },
  { text: 'COLEGIO SAN BARTOLOME DE NOS', value: '24874' },
  { text: 'COLEGIO SAN FELIPE DIACONO', value: '24976' },
  { text: 'COLEGIO PART. MARIA ANA MOGAS', value: '10685' },
  { text: 'COLEGIO AMERICAN ACADEMY', value: '10611' },
  { text: 'COLEGIO  INGLES ISAAC NEWTON', value: '10615' },
  { text: 'COLEGIO POLIV. PDTE. JOSE MANUEL BALMACEDA', value: '12111' },
  { text: 'COLEGIO SANTO TOMAS DE AQUINO', value: '25655' },
  { text: 'COLEGIO SUPERIOR DEL MAIPO', value: '10608' },
  { text: 'COLEGIO PART. INSTITUTO CORINTIO', value: '25714' },
  { text: 'INSTITUTO SAGRADO CORAZON', value: '10635' },
  { text: 'INSTITUTO SAN PABLO MISIONERO', value: '10618' },
  { text: 'MASTER COLLEGE', value: '11843' },
  { text: 'ESCUELA PART.  CURACAVI COLLEGE', value: '25526' },
  { text: 'LICEO PRESIDENTE BALMACEDA', value: '10845' },
  { text: 'COLEGIO PARTICULAR ALONSO DE ERCILLA', value: '10828' },
  { text: 'COLEGIO PART. MANSO DE VELASCO MELIPILLA', value: '25692' },
  { text: 'COLEGIO PARTICULAR MELIPILLA', value: '10831' },
  { text: 'COLEGIO PART.SAN SEBASTIAN DE MELIPILLA', value: '25012' },
  { text: 'LICEO POLIV. HNOS. SOTOMAYOR BAEZA', value: '10780' },
  { text: 'COLEGIO LOS CONQUISTADORES', value: '9903' },
  { text: 'COLEGIO PARTICULAR MATER DEI', value: '9919' },
  { text: 'COLEGIO PETER COLLEGE', value: '9979' },
  { text: 'COLEGIO CRISTOBAL COLON', value: '10315' },
  { text: 'COLEGIO HELLENS COLLEGE', value: '10344' },
  { text: 'COLEGIO LIBERTADOR SAN MARTIN', value: '10329' },
  { text: 'COLEGIO POLIVALENTE SAN AGUSTIN DE EL BOSQUE', value: '25464' },
  { text: 'COLEGIO PARTICULAR TANTAUCO  EL BOSQUE', value: '25249' },
  { text: 'LICEO CHRISTA MC AULIFFE', value: '9687' },
  { text: 'ESCUELA Y LICEO LIAHONA', value: '9768' },
  { text: 'COLEGIO GREENLAND SCHOOL', value: '25001' },
  { text: 'COLEGIO PIAMARTA', value: '24685' },
  { text: 'ESCUELA PARTICULAR VILLA ESPANA', value: '9960' },
  { text: 'LICEO METROPOLITANO', value: '8648' },
  { text: 'ESCUELA LICEO MADRE VICENCIA', value: '9940' },
  { text: 'LICEO RUIZ TAGLE', value: '8634' },
  { text: 'COLEGIO  PUMAHUE HUECHURABA', value: '25202' },
  { text: 'COLEGIO FRANCISCO JAVIER', value: '25143' },
  { text: 'COLEGIO ELENA BETTINI', value: '10350' },
  { text: 'COLEGIO SANTA MARIA CERVELLON', value: '8769' },
  { text: 'LICEO IGNACIO CARRERA PINTO', value: '8612' },
  { text: 'LICEO MIGUEL RAFAEL PRADO', value: '8589' },
  { text: 'LICEO ROSA ESTER ALESANDRI RODRIGUEZ', value: '8514' },
  {
    text: 'LICEO POLIVALENTE A80 PRESIDENTE JOSE MANUEL BALMACEDA',
    value: '10199',
  },
  { text: 'LICEO SANTA TERESITA', value: '10223' },
  { text: 'CENTRO EDUCACIONAL SANTA CLARA', value: '9757' },
  { text: 'COLEGIO ANTIL MAWIDA', value: '25265' },
  { text: 'COLEGIO IDOP LIMITADA', value: '9827' },
  { text: 'COLEGIO SANTA ISABEL DE HUNGRIA', value: '9758' },
  { text: 'COLEGIO SANTA MARIA DE LOS ANGELES', value: '9766' },
  { text: 'FROILAN YA\u00c3\u2018EZ DE LA BARRA', value: '11918' },
  { text: 'LICEO LAURA VICUNA', value: '9759' },
  { text: 'LICEO MADRE CECILIA LAZZERI', value: '9767' },
  { text: 'LICEO PART. SALESIANO MANUEL ARRIARAN BARROS', value: '25727' },
  { text: 'COLEGIO PRINCESS ANNE SCHOOL', value: '9855' },
  { text: 'COLEGIO PART. BOSTON COLLEGE LA FLORIDA', value: '25709' },
  { text: 'CENTRO EDUCACIONAL LA FLORIDA', value: '9347' },
  { text: 'CHILEAN EAGLES COLLEGE', value: '9312' },
  { text: 'COLEGIO ALAIN DE LA FLORIDA', value: '9330' },
  { text: 'COLEGIO PART. ALCANTARA DE LA CORDILLERA', value: '25704' },
  { text: 'COLEGIO PART. ALCANTARA DE LA FLORIDA', value: '25703' },
  { text: 'COLEGIO ALICANTE DE LA FLORIDA', value: '26001' },
  { text: 'COLEGIO ALMENDRAL', value: '24766' },
  { text: 'AMERICAN BRITISH SCHOOL', value: '25134' },
  { text: 'COLEGIO PART. ANDARES DE LA FLORIDA', value: '25712' },
  { text: 'COLEGIO PARTICULAR ANTILHUE', value: '25724' },
  { text: 'COLEGIO ARTISTICO EL SALVADOR ANEXO', value: '24448' },
  { text: 'BERNADETTE COLLEGE', value: '9373' },
  { text: 'COLEGIO DIVINA PASTORA', value: '25842' },
  { text: 'COLEGIO PART. FAMILIA DE NAZARETH', value: '25577' },
  { text: 'COLEGIO  LATINOAMERICANO', value: '25366' },
  { text: 'COLEGIO LIAONA CORDILLERA', value: '25751' },
  { text: 'COLEGIO LICARAYEN', value: '9372' },
  { text: 'COLEGIO NAZARET DE LA FLORIDA', value: '24756' },
  { text: 'COLEGIO PARTICULAR NUEVA ERA SIGLO XXI', value: '25153' },
  { text: 'COLEGIO PARTICULAR LA CONCEPCION', value: '9362' },
  { text: 'COLEGIO LE MONDE', value: '9385' },
  { text: 'COLEGIO MAURICIO RUGENDAS', value: '9318' },
  { text: 'COLEGIO PARTICULAR PLAYGROUND', value: '250457' },
  { text: 'COLEGIO PARTICULAR THE GARDEN SCHOOL', value: '9331' },
  { text: 'COLEGIO PART. PATRONA SENORA DE LOURDES', value: '25722' },
  { text: 'PIERRE TEILHARD DE CHARDIN', value: '25196' },
  { text: 'COLEGIO POLIV. SAN SEBASTIAN DE LA FLORIDA', value: '9328' },
  { text: 'COLEGIO PUELCHE', value: '24802' },
  { text: 'COLEGIO QUINTO CENTENARIO CORDILLERA', value: '25393' },
  { text: 'COLEGIO SAN CRISTOBAL DE LAS CASAS', value: '24864' },
  { text: 'COLEGIO PARTICULAR SAN FRANCISCO DE ASIS', value: '9356' },
  { text: 'SANTA MARIA DE LO CANAS', value: '24798' },
  { text: 'COLEGIO SANTA MARIA', value: '9340' },
  { text: 'COLEGIO SHIRAYURI', value: '11947' },
  { text: 'ESCUELA PARTICULAR ROSARIO CONCHA', value: '9369' },
  { text: 'INSTITUTO LA SALLE', value: '9317' },
  { text: 'LICEO ANDRES BELLO', value: '9294' },
  { text: 'LICEO BENJAMIN VICUNA MACKENNA', value: '9281' },
  { text: 'LICEO INDIRA GANDHI', value: '9298' },
  { text: 'COLEGIO PART. NEW LITTLE COLLEGE', value: '25644' },
  { text: 'COLEGIO SAINT JOSEPH C. THOMAS SCHOOL', value: '8724' },
  { text: 'COLEGIO SAN GREGORIO DE LA SALLE', value: '9684' },
  { text: 'ESC. BASICA PART.IBEROAMERICANO', value: '25114' },
  { text: 'COLEGIO JORGE HUNEEUS ZEGERS', value: '24946' },
  { text: 'COLEGIO POLIV. NUEVA NAZARET', value: '25027' },
  { text: 'LICEO VILLA LA PINTANA', value: '9603' },
  { text: 'COLEGIO ANDREE ENGLISH SCHOOL', value: '9051' },
  { text: 'COLEGIO BRITISH ROYAL SCHOOL', value: '12087' },
  { text: 'COLEGIO CORONEL ELEUTERIO RAMIREZ MOLINA', value: '25101' },
  { text: 'COLEGIO DE LA SALLE', value: '9042' },
  { text: 'COLEGIO  EPULLAY', value: '24873' },
  { text: 'COLEGIO NUESTRA SE\u00c3\u2018ORA DEL CAMINO', value: '24944' },
  { text: 'COLEGIO WOLFGANG AMADEUS MOZART', value: '24902' },
  { text: 'COLEGIO RUBEN DARIO', value: '9039' },
  { text: 'COLEGIO SAINT JOHNS VILLA ACADEMY', value: '9054' },
  { text: 'COLEGIO SANTA CATALINA LABOUR\u00c3\u2030', value: '9020' },
  { text: 'COLEGIO STA MARIA REINA', value: '9033' },
  { text: 'COLEGIO SANTIAGO EVANGELISTA', value: '24690' },
  { text: 'COLEGIO SANTO DOMINGO_PADRES DOMINICOS', value: '11971' },
  { text: 'COLEGIO TERESIANO ENRIQUE DE OSSO', value: '9053' },
  { text: 'COLEGIO TERRANOVA', value: '12090' },
  { text: 'COLEGIO LA ABADIA', value: '24671' },
  { text: 'COLEGIO THE GRANGE SCHOOL', value: '9046' },
  { text: 'COLEGIO ALCAZAR DE LAS CONDES', value: '24884' },
  { text: 'COLEGIO ALEMAN DE SANTIAGO', value: '8979' },
  { text: 'COLEGIO ARABE', value: '8911' },
  { text: 'COLEGIO COMPANIA DE MARIA APOQUINDO', value: '8870' },
  { text: 'COLEGIO CONCORDIA EX.THE MARSHALL SCHOOL', value: '8883' },
  { text: 'COLEGIO CORDILLERA DE LAS CONDES', value: '8902' },
  { text: 'COLEGIO COYANCURA', value: '12086' },
  { text: 'COLEGIO CRECES', value: '24494' },
  { text: 'COLEGIO CUMBRES', value: '11968' },
  { text: 'COLEGIO DALCAHUE', value: '8895' },
  { text: 'COLEGIO DEL SAGRADO CORAZON DE APOQUINDO', value: '8878' },
  { text: 'COLEGIO DEL VERBO DIVINO', value: '8888' },
  { text: 'COLEGIO DUNALASTAIR', value: '8978' },
  { text: 'COLEGIO INSTITUCION TERESIANA', value: '25055' },
  { text: 'COLEGIO INTERNACIONAL SEK CHILE', value: '8893' },
  { text: 'JOHN DEWEY COLLEGE', value: '24666' },
  { text: 'COLEGIO LA GIROUETTE', value: '8868' },
  { text: 'COLEGIO LO CASTILLO', value: '8866' },
  { text: 'COLEGIO NTRA. SRA. DEL ROSARIO LAS CONDES', value: '8827' },
  { text: 'COLEGIO NUESTRA SENORA DEL LORETO', value: '24826' },
  { text: 'COLEGIO PADRE HURTADO Y JUANITA DE LOS ANDES', value: '8991' },
  { text: 'COLEGIO PEDRO DE VALDIVIA LAS CONDES', value: '24908' },
  { text: 'COLEGIO PUCARA DE LOS ANDES', value: '11966' },
  { text: 'COLEGIO SAN FRANCISCO DEL ALBA', value: '8815' },
  { text: 'COLEGIO SAN NICOLAS DE MYRA', value: '24409' },
  { text: 'COLEGIO WENLOCK SCHOOL', value: '8872' },
  { text: 'COLEGIO WILLIAM KILPATRICK', value: '8914' },
  { text: 'COLEGIO SAN JUAN EVANGELISTA', value: '8892' },
  { text: 'INSTITUTO PRESIDENTE ERRAZURIZ', value: '8854' },
  { text: 'LICEO RAFAEL SOTOMAYOR', value: '8819' },
  { text: 'COLEGIO REDLAND SCHOOL', value: '8885' },
  { text: 'COLEGIO SCUOLA ITALIANA VITTORIO MONTIGLIO', value: '8863' },
  { text: 'COLEGIO SEMINARIO PONTIFICIO MENOR', value: '8900' },
  { text: 'COLEGIO THE MAYFLOWER SCHOOL', value: '11776' },
  { text: 'COLEGIO THE SOUTHERN CROSS SCHOOL', value: '12265' },
  { text: 'COLEGIO VILLA MARIA ACADEMY', value: '8873' },
  { text: 'COLEGIO BERTAIT COLLEGE', value: '25224' },
  { text: 'COLEGIO APOQUINDO FEMENINO', value: '8889' },
  { text: 'COLEGIO APOQUINDO HOMBRES', value: '8881' },
  { text: 'COLEGIO CRAIGHOUSE', value: '8917' },
  { text: 'COLEGIO LOS ALERCES', value: '24979' },
  { text: 'COLEGIO MONTESSORI HUELQUEN', value: '24718' },
  { text: 'COLEGIO POLIVALENTE SAN RAFAEL', value: '24486' },
  { text: 'COLEGIO TABOR Y NAZARETH', value: '24624' },
  { text: 'INSTITUTO HEBREO DR CHAIM WEIZMANN', value: '9237' },
  { text: 'COLEGIO LINCOLN INTERNATIONAL ACADEMY', value: '8903' },
  { text: 'COLEGIO THE NEWLAND SCHOOL', value: '8869' },
  { text: 'COLEGIO ADVENTISTA SANTIAGO PONIENTE', value: '24730' },
  { text: 'LICEO TENIENTE DAGOBERTO GODOY NO.3', value: '10162' },
  { text: 'COLEGIO PARTICULAR EL ALBA DE MACUL', value: '25525' },
  { text: 'COLEGIO PART. SWEDENBORG COLLEGE', value: '25625' },
  { text: 'COLEGIO SAN MARCOS', value: '9277' },
  { text: 'COLEGIO SAN VIATOR', value: '24427' },
  { text: 'LICEO SALESIANO CAMILO ORTUZAR MONTT', value: '9185' },
  { text: 'Liceo Villa Macul Academia', value: '9072' },
  { text: 'SAINT MARY JOSEPH SCHOOL', value: '24762' },
  {
    text: 'CENTRO EDUCACIONAL PIAMARTINO CAROLINA LLONA DE CUEVAS',
    value: '9909',
  },
  { text: 'COLEGIO ANGLO MAIPU', value: '8681' },
  { text: 'ESC. BASICA PART. BOSTON COLLEGE LA FARFANA', value: '25550' },
  { text: 'ESC. BASICA BOSTON COLLEGE MAIPU', value: '25091' },
  { text: 'ESC. BOSTON COLLEGE SAN MARTIN', value: '25766' },
  { text: 'COLEGIO CENTENARIO', value: '24986' },
  { text: 'COLEGIO DE LA PROVIDENCIA C.LARRAIN DE I', value: '9911' },
  { text: 'COLEGIO DEL VALLE', value: '25850' },
  { text: 'ESCUELA PARTICULAR INSTITUTO AMERICA', value: '9906' },
  { text: 'COLEGIO INTERCULTURAL TREMEMN', value: '25885' },
  { text: 'COLEGIO INTERNACIONAL  ALBA', value: '24670' },
  { text: 'COLEGIO PARTICULAR KRONBERG COLLEGE', value: '24460' },
  { text: 'ESCUELA BASICA PART.MADRE DE JESUS', value: '25025' },
  { text: 'COLEGIO NTRA. SRA. DEL CARMEN DE MAIPU', value: '25739' },
  { text: 'COLEGIO PARTICULAR ALICANTE', value: '25369' },
  { text: 'COLEGIO POLIVALENTE CAMILO HENRIQUEZ', value: '9907' },
  { text: 'COLEGIO PARTICULAR SAN FELIX', value: '9910' },
  { text: 'COLEGIO LICEO COMERCIAL SAN JOSE', value: '9925' },
  { text: 'COLEGIO SAN LEONARDO', value: '9970' },
  { text: 'COLEGIO SANTA MARIA DE MAIPU', value: '25198' },
  { text: 'COLEGIO SANTA URSULA', value: '9973' },
  { text: 'COMPLEJO EDUCACIONAL MAIPU', value: '9959' },
  { text: 'COLEGIO INSTITUTO O\u00c2\u00a6HIGGINS DE MAIPU', value: '25481' },
  { text: 'LICEO ALCALDE GONZALO PEREZ LLONA', value: '9896' },
  { text: 'LICEO SAN PEDRO POVEDA', value: '9905' },
  { text: 'LICEO SANTIAGO BUERAS Y AVARIA', value: '9863' },
  { text: 'COLEGIO PART. ROYAL AMERICAN SCHOOL', value: '25785' },
  { text: 'COLEGIO CALASANZ', value: '9250' },
  { text: 'COLEGIO DIVINA PASTORA NUNOA', value: '25852' },
  { text: 'COLEGIO FRANCISCO ENCINA', value: '12133' },
  { text: 'INSTITUTO SANTA MARIA', value: '9278' },
  { text: 'COLEGIO ISABEL LA CATOLICA', value: '9230' },
  { text: 'LA FONTAINE', value: '24842' },
  { text: 'COLEGIO MAYA SCHOOL  ANEXO', value: '24830' },
  { text: 'COLEGIO SANTA MARGARITA DE ESCOCIA', value: '9151' },
  { text: 'COLEGIO SUIZO DE SANTIAGO', value: '9216' },
  { text: 'COLEGIO TALINAY', value: '24507' },
  { text: 'COLEGIO THE ANGELS SCHOOL', value: '8969' },
  { text: 'COLEGIO TRIGAL', value: '25686' },
  { text: 'COLEGIO UNIVERSITARIO EL SALVADOR', value: '9276' },
  { text: 'LICEO AUGUSTO D HALMAR', value: '9071' },
  { text: 'COLEGIO MANUEL DE SALAS', value: '9267' },
  { text: 'LICEO JOSE TORIBIO MEDINA', value: '9074' },
  { text: 'LICEO LENKA FRANULIC', value: '9078' },
  { text: 'LICEO PARTICULAR INSUME', value: '11893' },
  { text: 'LICEO REPUBLICA DE SIRIA', value: '9100' },
  { text: 'COLEGIO SAN AGUSTIN', value: '9246' },
  { text: 'COLEGIO SAINT GASPAR COLLEGE', value: '9249' },
  { text: 'LICEO MUNICIPAL ENRIQUE BACKAUSSE', value: '9419' },
  {
    text: 'COLEGIO ALC\u00c3\u0081NTARA DE LOS ALTOS DE PE\u00c3\u2018ALOLEN',
    value: '25717',
  },
  { text: 'COLEGIO ALTAMIRA', value: '9221' },
  { text: 'COLEGIO FRANCISCO DE MIRANDA', value: '9239' },
  { text: 'COLEGIO MONTEVERDE ANEXO', value: '24789' },
  { text: 'COLEGIO LOS ANDES COUNTRY DAY COLLEGE', value: '25489' },
  { text: 'COLEGIO PART. ANTUPIREN', value: '25804' },
  { text: 'COLEGIO PARTICULAR JORGE PRIETO LETELIER', value: '9200' },
  { text: 'COLEGIO PEDRO DE VALDIVIA DE PE\u00c3\u2018ALOLEN', value: '25065' },
  { text: 'COLEGIO PUMAHUE PE\u00d1ALOLEN', value: '25172' },
  { text: 'COLEGIO CAMBRIDGE COLLEGE', value: '8998' },
  { text: 'COLEGIO ALEMAN ST. THOMAS MORUS', value: '8992' },
  { text: 'COLEGIO ARGENTINO DEL SAGRADO CORAZON DE JESUS', value: '25680' },
  { text: 'COLEGIO COMPANIA DE MARIA-SEMINARIO', value: '8950' },
  { text: 'COLEGIO DE LOS SAGRADOS CORAZONES PROVIDENCIA', value: '8981' },
  { text: 'COL.  PART. SALES. EL PATROCINIO DE SAN JOSE', value: '25402' },
  { text: 'COLEGIO PART. JOSEFINO SANTISIMA TRINIDAD', value: '25541' },
  { text: 'COLEGIO MARIANO', value: '8988' },
  { text: 'COLEGIO PARTICULAR REGINA PACIS', value: '8944' },
  { text: 'COLEGIO PEDRO DE VALDIVIA', value: '11871' },
  { text: 'COLEGIO SAN IGNACIO EL BOSQUE', value: '8996' },
  { text: 'COLEGIO UNIVERSITARIO INGLES', value: '9004' },
  { text: 'COLEGIO SANTIAGO COLLEGE', value: '8995' },
  { text: 'COLEGIO INSTITUTO DE HUMANIDADES LUIS CAMPINO', value: '8761' },
  { text: 'LICEO CARMELA CARVAJAL DE PRAT', value: '8927' },
  { text: 'LICEO JOSE VICTORINO LASTARRIA', value: '8928' },
  { text: 'LICEO POLIVALENTE ARTURO ALESSANDRI P.', value: '8925' },
  {
    text: 'LICEO DE NI\u00c3\u2018AS N 7 LUISA SAAVEDRA DE GONZALEZ',
    value: '8926',
  },
  { text: 'LICEO B 42 TAJAMAR', value: '8930' },
  { text: 'SAINT GABRIELS SCHOOL SEDE BILBAO', value: '8966' },
  { text: 'COLEGIO THE ENGLISH INSTITUTE', value: '9003' },
  { text: 'COLEGIO THE KENT SCHOOL', value: '9271' },
  { text: 'COLEGIO TREWHELAS ENGLISH SCHOOL', value: '8984' },
  { text: 'COLEGIO  UNITED COLLEGE', value: '25666' },
  { text: 'WEXFORD COLLEGE N 2', value: '8997' },
  { text: 'COLEGIO SANTIAGO DE PUDAHUEL', value: '25895' },
  { text: 'COLEGIO  MANQUECURA VALLE LO CAMPINO', value: '25487' },
  { text: 'COLEGIO PARTICULAR NOVO MUNDO', value: '25386' },
  { text: 'COLEGIO POLIVALENTE SAN PEDRO DE QUILICURA', value: '26168' },
  { text: 'COLEGIO PARTICULAR SAN SEBASTIAN DE QUILICURA', value: '25387' },
  { text: 'COLEGIO POLIV. SANTA MARIA', value: '10246' },
  { text: 'COLEGIO PART. SAN ADRIAN DE QUILICURA', value: '25829' },
  { text: 'COLEGIO PART. GABRIELA MISTRAL SOCIEDAD EDUCA', value: '25508' },
  { text: 'LICEO POLIV.SAN JOSE DE LA PRECIOSA SANG', value: '10030' },
  { text: 'COLEGIO ACADEMIA DE HUMANIDADES', value: '8750' },
  { text: 'COLEGIO MARIA TERESA CANCINO AGUILAR', value: '8614' },
  { text: 'COLEGIO POLIV. ALEJANDRO FLORES', value: '10313' },
  { text: 'COLEGIO RAFAEL SANHUEZA LIZARDI', value: '8682' },
  { text: 'COLEGIO SAN BENILDO', value: '8650' },
  { text: 'LICEO LEONARDO MURIALDO', value: '8636' },
  { text: 'LICEO AVENIDA RECOLETA', value: '10320' },
  { text: 'LICEO PAULA JARAQUEMADA', value: '8510' },
  { text: 'LICEO POLIVALENTE SANTA JULIANA', value: '8632' },
  { text: 'COLEGIO SAN JOAQUIN', value: '24498' },
  { text: 'COLEGIO POLIV. SAN JOSE DE RENCA', value: '24812' },
  { text: 'COLEGIO PART. NUESTRA SRA DEL HUERTO', value: '9500' },
  { text: 'ESC. BASICA Y LICEO IND.SAINT LAWRENCE', value: '9477' },
  { text: 'ESCUELA PARTICULAR Y COLEGIO CHILE', value: '9504' },
  { text: 'COLEGIO PART. CORAZON DE MARIA DE SAN MIGUEL', value: '25675' },
  { text: 'COLEGIO PART. LOS ANGELES SANTIAGO DE SAN MIG', value: '25718' },
  { text: 'COLEGIO MANANTIAL DE SAN MIGUEL', value: '25894' },
  { text: 'COLEGIO PARROQUIAL SAN MIGUEL', value: '9564' },
  { text: 'COLEGIO  PART. RELIGIOSO SAN JAVIER', value: '25798' },
  { text: 'COLEGIO SAN CRISTOBAL COLLEGE', value: '24625' },
  { text: 'COLEGIO SANTA ROSA', value: '9484' },
  { text: 'COLEGIO SANTO CURA DE ARS', value: '9519' },
  { text: 'INSTITUTO MIGUEL LEON PRADO', value: '9570' },
  { text: 'LICEO ANDRES BELLO', value: '9406' },
  { text: 'LICEO BETSABE HORMAZABAL DE ALARCON', value: '9405' },
  { text: 'COLEGIO PART. PAN AMERICAN COLLEGE SANTIAGO', value: '25832' },
  { text: 'LICEO SAINT PATRICKS SCHOOL', value: '9471' },
  { text: 'LICEO MUNICIPAL PURKUYEN', value: '9599' },
  { text: 'ESCUELA COLEGIO ALBERTO BLEST GANA', value: '9659' },
  { text: 'LICEO SAN FRANCISCO', value: '9647' },
  { text: 'COLEGIO ADVENTISTA PORVENIR', value: '8680' },
  { text: 'COLEGIO EXCELSIOR', value: '8756' },
  { text: 'COLEGIO FILIPENSE', value: '8791' },
  { text: 'COLEGIO FRANCISCO ARRIARAN', value: '8658' },
  { text: 'COLEGIO HISPANO AMERICANO', value: '8754' },
  {
    text: 'COLEGIO PARTICULAR MAR\u00c3\u008dA AUXILIADORA DE SANTIAGO',
    value: '25509',
  },
  { text: 'COLEGIO MARIA LUISA VILLALON', value: '8740' },
  { text: 'COLEGIO NUESTRA SENORA DE ANDACOLLO', value: '8611' },
  { text: 'COLEGIO ORATORIO DON BOSCO', value: '8697' },
  { text: 'COLEGIO PARTICULAR OZANAM', value: '25185' },
  { text: 'COLEGIO LORENZO SAZIE', value: '8649' },
  { text: 'COLEGIO  PEDRO DE VALDIVIA', value: '11962' },
  { text: 'COLEGIO POLIV. MANUEL BAQUEDANO', value: '8646' },
  { text: 'ESCUELA COLEGIO POLIVALENTE STA FAMILIA', value: '8615' },
  { text: 'COLEGIO SAN ANTONIO', value: '8652' },
  { text: 'COLEGIO SAN IGNACIO', value: '8609' },
  { text: 'COLEGIO SAN SEBASTIAN', value: '8620' },
  { text: 'COLEGIO SANTA CECILIA', value: '8759' },
  { text: 'COLEGIO SANTA CRUZ', value: '8604' },
  { text: 'COLEGIO ST ELENA CARMELITAS MISION TERESIANA', value: '8762' },
  { text: 'COLEGIO SANTA MARIA DE SANTIAGO', value: '8627' },
  { text: 'COLEGIO SANTA TERESITA DEL NINO JESUS', value: '8675' },
  { text: 'ESCUELA PARTICULAR VICTORIA PRIETO', value: '8671' },
  { text: 'COLEGIO DE LOS SAGRADOS CORAZONES ALAMEDA', value: '8757' },
  { text: 'COLEGIO  ALONSO DE ERCILLA', value: '8748' },
  {
    text: 'INSTITUTO ART\u00c3\u008dSTICO DE ESTUDIOS SECUNDARIOS DE LA UNIVERSIDAD DE CHILE',
    value: '11766',
  },
  { text: 'INSTITUTO DE ENS.MEDIA CLAUDIO MATTE', value: '8618' },
  { text: 'LICEO INSTITUTO NACIONAL', value: '8485' },
  { text: 'INTERNADO NACIONAL BARROS ARANA', value: '8499' },
  { text: 'LICEO MANUEL BARROS BORGONO', value: '8492' },
  { text: 'LICEO CONFEDERACION SUIZA', value: '8495' },
  { text: 'LICEO DARIO SALAS', value: '8498' },
  { text: 'LICEO DE APLICACION RECTOR JORGE E SCHNE', value: '8491' },
  { text: 'LICEO FRANCES', value: '8630' },
  { text: 'LICEO ISAURA DINATOR DE GUZMAN', value: '8488' },
  { text: 'LICEO JOSE MIGUEL CARRERA', value: '8768' },
  { text: 'LICEO JOSE MIGUEL INFANTE', value: '8592' },
  { text: 'LICEO JUAN BOSCO', value: '8765' },
  { text: 'LICEO NRO 2 MIGUEL LUIS AMUNATEGUI', value: '8490' },
  { text: 'LICEO MIGUEL DE CERVANTES Y SAAVEDRA', value: '24638' },
  { text: 'LICEO Y COLEGIO NUEVO HISPANO CHILENO', value: '8639' },
  { text: 'LICEO JAVIERA CARRERA', value: '8487' },
  { text: 'LICEO PART.OB.AUGUSTO SALINAS FUENZALIDA', value: '12260' },
  { text: 'LICEO REPUBLICA DE BRASIL', value: '8535' },
  { text: 'LICEO TERESA PRAT DE SARRATEA', value: '8489' },
  { text: 'COLEGIO SAINT ROSE SCHOOL', value: '8755' },
  { text: 'COLEGIO ANTARTICA CHILENA', value: '8825' },
  { text: 'COLEGIO BRADFORD SCHOOL', value: '8909' },
  { text: 'COLEGIO EL CARMEN TERESIANO I', value: '8905' },
  { text: 'COLEGIO HUELEN', value: '8953' },
  { text: 'COLEGIO INMACULADA CONCEPCION', value: '8846' },
  { text: 'COLEGIO LA MAISONNETTE', value: '8894' },
  { text: 'COLEGIO LOS ANDES DE VITACURA', value: '8871' },
  { text: 'COLEGIO SAN BENITO', value: '8972' },
  { text: 'COLEGIO SAN ESTEBAN DIACONO', value: '12094' },
  { text: 'COLEGIO SAN PEDRO NOLASCO', value: '8919' },
  { text: 'COLEGIO TABANCURA', value: '8862' },
  { text: 'COLEGIO DE LOS SAGRADOS CORAZONES', value: '8877' },
  { text: 'LICEO MUNICIPALIZADO AMANDA LABARCA', value: '8821' },
  {
    text: 'LYC\u00c3\u2030E ANTOINE DE SAINT-EXUP\u00c3\u2030RY',
    value: '8923',
  },
  { text: 'COLEGIO SAINT GEORGE S COLLEGE', value: '8906' },
  { text: 'COLEGIO JOSE MANUEL BALMACEDA', value: '11851' },
  { text: 'COL.PART.INMAC.CONC. DE NTRA.SRA. DE LOURDES', value: '10772' },
  { text: 'COLEGIO TERRANOVA', value: '10777' },
  { text: 'COLEGIO ALCANTARA DE TALAGANTE', value: '10710' },
  { text: 'COLEGIO CARAMPANGUE', value: '10724' },
  { text: 'COLEGIO LEONARDO DA VINCI', value: '25127' },
  { text: 'COLEGIO PARTICULAR BLUMENTHAL', value: '25795' },
  { text: 'COLEGIO PART. SAGRADO CORAZON DE TALAGANTE', value: '25843' },
  { text: 'ENGLISH COLLEGE', value: '10721' },
  { text: 'C EST SUP  ESANE DEL NORTE', value: '12834' },
  { text: 'CENTRO EDUC.INTEGRAL DE ADULTOS C.E.I.A', value: '222' },
  { text: 'CENTRO INTEGRAL DE EDUCACION DE ADULTOS', value: '14208' },
  { text: 'LIC.EDUC.DE ADULTOS JUAN F.GONZALEZ R.', value: '14454' },
  { text: 'CENTRO DE EDUC. DE ADULTOS PITAGORAS', value: '14852' },
  { text: 'COLEGIO JUAN LUIS VIVES', value: '14389' },
  { text: 'COLEGIO NOCTURNO RUBEN CASTRO', value: '1584' },
  { text: 'INSTITUTO ITEP', value: '14338' },
  { text: 'LICEO DE ADULTOS JACQUES COUSTEAU', value: '14467' },
  { text: 'INSTITUTO CIEC', value: '12294' },
  { text: 'COLEGIO DE ADULTOS SILOB CHILE', value: '14556' },
  { text: 'INSTITUTO BALDOR', value: '14439' },
  { text: 'COL.CORPORACION EDUC.LA ARAUCANA', value: '16458' },
  { text: 'COLEGIO CORPOR.DE EDUC.LA ARAUCANA', value: '16414' },
  { text: 'C.E.I.A. JANEQUEO', value: '178799' },
  { text: 'C.E.I.A.MONSENOR ALFREDO SILVA SANTIAGO', value: '4661' },
  { text: 'CENTRO ED  ADULTOS EINSTEIN', value: '17658' },
  { text: 'COLEGIO INGLES BRITISH ROYAL SCHOOL', value: '17607' },
  { text: 'C.E.I.A SAN LUIS DE POTOSI REP.DE MEXICO', value: '4965' },
  { text: 'ESCUELA ADULTOS LAS AMERICAS', value: '11417' },
  { text: 'COLEGIO DE EDUCACION DE ADULTOS HORIZONTE', value: '20231' },
  { text: 'CENTRO EDUC.ADULTOS LUIS MOLL BRIONES', value: '6787' },
  { text: 'CENTRO EDUCACION ADULTOS ANDRES BELLO', value: '22188' },
  { text: 'ESCUELA PARTICULAR LOS VOLCANES', value: '7970' },
  { text: 'COLEGIO SALESIANO PADRE JOSE FERNANDEZ PEREZ', value: '7699' },
  { text: 'COLEGIO EMPRENDER OSORNO', value: '22191' },
  { text: 'ESCUELA PARTICULAR SAN JOSE OBRERO', value: '8368' },
  { text: 'COLEGIO DE ADULTOS TIRSO DE MOLINA', value: '26146' },
  { text: 'LICEO DE ADULTOS ESTACION CENTRAL', value: '8587' },
  { text: 'WASHINGTON CENTER LA FLORIDA', value: '25183' },
  { text: 'INSTITUTO DE A MANUEL BULNES PRIETO', value: '24703' },
  { text: 'COLEGIO PART. DE ADULTOS STA. MARIA DEL TRABA', value: '25775' },
  { text: 'COLEGIO DE AD. ANTONIO ACEVEDO', value: '26143' },
  { text: 'COLEGIO DE AD. INSTITUTO SAN SEBASTIAN DE BEL', value: '26112' },
  { text: 'INSTITUTO SAN SEBASTIAN DE PROVIDENCIA', value: '24933' },
  { text: 'COLEGIO DE ADULT.ACADEMIA ESTUDIOS MIRAFLORES', value: '25057' },
  { text: 'CENTRO DE EDUCACION INTEGRADA DE AD. CREANDO', value: '26023' },
  { text: 'COLEGIO CTRO. INTEG  ADULTOS ALTAZOL', value: '25463' },
  { text: 'COLEGIO DE ADULCENTRO DE ESTUDIOS LA ARAUCANA', value: '8763' },
  { text: 'COLEGIO DE ADULTOS CEIA FORJANDO FUTURO', value: '26162' },
  { text: 'COLEGIO PART. ADULTOS INSTITUTO ICEL', value: '25818' },
  { text: 'INSTITUTO ANDES', value: '25099' },
  { text: 'COLEGIO DE ADULT. INS. TABANCURA SEDE LONDRES', value: '24840' },
  { text: 'COLEGIO ADUL. INSTITUTO TABANCURA DE VITACURA', value: '25190' },
  { text: 'LICEO LOS CONDORES', value: '12603' },
  { text: 'COLEGIO INGLES', value: '12631' },
  { text: 'LICEO INDUSTRIAL JOSE TOMAS DE URMENETA', value: '610' },
  { text: 'ESCUELA  INDUSTRIAL SALESIANA SAN RAMON', value: '574' },
  { text: 'LICEO POLITECNICO DE OVALLE', value: '705' },
  { text: 'LICEO COMERCIAL DE LOS ANDES', value: '1195' },
  { text: 'ESC.PART INDUSTRIAL E.BERTELSEN TEMPLE', value: '1397' },
  { text: 'ESCUELA AGRICOLA SALESIANA F. HUIDOBRO', value: '1362' },
  { text: 'LICEO GASTRONOMIA Y TURISMO', value: '14720' },
  { text: 'LICEO TECNICO FEMENINO DE QUILPUE', value: '14470' },
  { text: 'LICEO POLITECNICO ALFREDO NAZAR FERES', value: '1516' },
  { text: 'INSTITUTO SUPERIOR DE COMERCIO ALBERTO BL', value: '1663' },
  { text: 'LICEO JEAN BUCHANAN DE LARRAIN', value: '2378' },
  { text: 'LICEO COMERCIAL DIEGO PORTALES', value: '2104' },
  { text: 'LICEO INDUSTRIAL PRESIDENTE PEDRO AGUIRRE', value: '2103' },
  {
    text: 'INSTITUTO COMERCIAL ALBERTO VALENZUELA LLANOS DE SAN FERNANDO',
    value: '2444',
  },
  { text: 'COLEGIO POLITECNICO SAN JOSE', value: '16417' },
  { text: 'LICEO POLITECNICO DE CURICO', value: '16452' },
  { text: 'LICEO TECNOLOGICO MATAQUITO', value: '16582' },
  { text: 'LICEO POLIVALENTE DE MOLINA', value: '2835' },
  {
    text: 'LICEO AGR\u00c3\u008dCOLA NICOL\u00c3\u0081S MORENO VERGARA',
    value: '2833',
  },
  { text: 'INSTITUTO COMERCIAL', value: '3248' },
  { text: 'LICEO MARIA AUXILIADORA', value: '3290' },
  { text: 'LICEO MANUEL MONTT', value: '3479' },
  { text: 'INSTITUTO POLITECNICO SUPERIOR EGIDIO ROZ', value: '3163' },
  { text: 'LICEO AGROINDUSTRIAL RIO CLARO', value: '3033' },
  { text: 'CENTRO EDUCATIVO SALESIANOS TALCA', value: '3006' },
  { text: 'INST.SUP.DE COMERCIO ENRIQUE MALDONADO S', value: '2938' },
  { text: 'LICEO DIEGO PORTALES', value: '2939' },
  { text: 'LICEO INDUSTRIAL SUPERIOR', value: '2937' },
  { text: 'LICEO NUEVO MUNDO', value: '17790' },
  { text: 'ESC.INDUSTRIAL SALESIANA SAN JOSE', value: '17750' },
  { text: 'LICEO COMERCIAL ENRIQUE OYARZUN MONDACA', value: '4534' },
  { text: 'LICEO COMERCIAL FEMENINO DE CONCEPCION', value: '4536' },
  { text: 'LICEO INDUSTRIAL DE CONCEPCION', value: '4535' },
  { text: 'LICEO MAURICIO HOCHSCHILD', value: '12062' },
  { text: 'LICEO TECNICO FEMENINO A-29 DE CONCEPCION', value: '4533' },
  { text: 'LICEO TECN. PROFESIONAL JORGE SANCHEZ U.', value: '4672' },
  { text: 'LICEO COMERCIAL PROFESOR SERGIO MORAGA ARCIL', value: '4707' },
  { text: 'LICEO INDUSTRIAL DE LA CONSTRUCCION HERNA', value: '4700' },
  { text: 'LICEO INDUSTRIAL JUAN ANTONIO RIOS M.', value: '4703' },
  { text: 'LICEO PEDRO DEL RIO ZANARTU', value: '4706' },
  { text: 'LICEO INDUSTRIAL DE TOME', value: '4824' },
  { text: 'LICEO POLIVALENTE TOME - ALTO', value: '17885' },
  {
    text: 'Colegio Polivalente Padre Alberto Hurtado de Chill\u00e1n',
    value: '17908',
  },
  { text: 'COLEGIO TECNOLOGICO DARIO SALAS', value: '17838' },
  { text: 'INSTITUTO SUPERIOR DE COMERCIO PROFESOR F', value: '3640' },
  { text: 'LICEO Y ESCUELA NUESTRA SRA DE LA MERCED', value: '3796' },
  { text: 'COMPLEJO EDUCACIONAL JUAN BOSCO', value: '5992' },
  { text: 'LICEO COMERCIAL DEL DESARROLLO', value: '20037' },
  { text: 'LICEO COMERCIAL TIBURCIO SAAVEDRA', value: '5565' },
  { text: 'LICEO INDUSTRIAL A-27 TEMUCO', value: '5566' },
  { text: 'LICEO PARTICULAR COMERCIAL TEMUCO', value: '5655' },
  { text: 'COMPLEJO EDUCACIONAL LA GRANJA', value: '5613' },
  { text: 'LICEO COMERCIAL ARMANDO BRAVO BRAVO', value: '5216' },
  { text: 'COMPLEJO EDUCACIONAL COLLIPULLI', value: '5282' },
  { text: 'INSTITUTO COMERCIAL DE VALDIVIA', value: '6751' },
  { text: 'INST. SUPERIOR DE ADMINISTRACION Y TURISMO', value: '22415' },
  { text: 'LICEO POLITECNICO BENJAMIN VICUNA MACKENNA', value: '6757' },
  { text: 'LICEO TECNICO PROFESIONAL INMACULADA CONCEPCI', value: '22329' },
  { text: 'LICEO POLITECNICO DE CASTRO', value: '8001' },
  { text: 'LICEO INDUSTRIAL CHILENO ALEMAN', value: '7973' },
  { text: 'COLEGIO EJERCITO DE SALVACI\u00c3\u201cN', value: '7704' },
  { text: 'LICEO COMERCIAL MIRAMAR', value: '22543' },
  { text: 'LICEO INDUSTRIAL DE PUERTO MONTT', value: '7625' },
  { text: 'ESCUELA AGRICOLA DE LA PATAGONIA', value: '8369' },
  { text: 'LICEO MUNIC. TEC. PROF. EL LLANO', value: '10516' },
  { text: 'ESCUELA AGROECOLOGICA DE PIRQUE', value: '24652' },
  { text: 'CENTRO EDUCACIONAL FERNANDO DE ARAGON', value: '24878' },
  { text: 'COLEGIO PART.POLITECNICO EYZAGUIRRE', value: '24978' },
  { text: 'CARDENAL JUAN FRANCISCO FRESNO LARRAIN', value: '25523' },
  { text: 'COLEGIO POLIV. CARDENAL RAUL SILVA HENRIQUEZ', value: '25282' },
  { text: 'ESCUELA INDUSTRIAL LAS NIEVES', value: '10496' },
  { text: 'ESCUELA TECNICA LAS NIEVES', value: '10507' },
  { text: 'LICEO COMERCIAL DE PUENTE ALTO', value: '10456' },
  { text: 'LICEO INDUSTRIAL DOMINGO MATTE MESIAS', value: '10481' },
  { text: 'LICEO POLIVALENTE MARIA REINA', value: '10505' },
  { text: 'LICEO POLIVALENTE SAN JOSE DE MAIPO', value: '10526' },
  { text: 'LICEO REINA PAOLA DE BELGICA', value: '10683' },
  { text: 'LICEO COMERCIAL DE SAN BERNARDO', value: '10541' },
  { text: 'LICEO ELVIRA BRADY MALDONADO-SN.BERNARDO', value: '10544' },
  { text: 'COLEGIO POLIVALENTE SAN AGUSTIN', value: '10832' },
  {
    text: 'LICEO POLIVALENTE LOS HEROES DE LA CONCEPCI\u00c3\u201cN',
    value: '10075',
  },
  { text: 'CENTRO POLITECNICO PARTICULAR CONCHALI', value: '25396' },
  { text: 'COLEGIO PAUL HARRIS SCHOOL', value: '25304' },
  { text: 'COMPLEJO EDUC.PARTICULAR DE LAS ACACIAS', value: '11818' },
  { text: 'COLEGIO POLIVALENTE PRINCIPE DE GALES', value: '10058' },
  { text: 'COLEGIO INDUSTRIAL VASCO NUNEZ DE BALBOA', value: '8644' },
  { text: 'COLEGIO POLITECNICO AVDA INDEPENDENCIA', value: '24777' },
  { text: 'ESCUELA TECNICA L.BDO.OHIGGINS-DIURNA', value: '8621' },
  { text: 'INST.COMERCIAL L.BERNARDO OHIGGINS', value: '8656' },
  { text: 'COLEGIO MIGUEL DE CERVANTES', value: '9829' },
  { text: 'ESCUELA TECNICA SANTA ROSA', value: '9779' },
  { text: 'CENTRO POLITECNICO PARTICULAR SAN RAMON', value: '9781' },
  { text: 'COMPLEJO EDUCACIONAL LOS ANDES', value: '25029' },
  { text: 'INSTITUTO COMERCIAL PARTICULAR LA CISTERNA', value: '9754' },
  { text: 'LICEO POLITECNICO CIENCIA Y TECNOLOGIA', value: '9693' },
  { text: 'LICEO INDUSTRIAL DE ELECTROTECNIA RAMON B', value: '9860' },
  { text: 'COLEGIO LONDON ANEXO', value: '24599' },
  { text: 'COMPLEJO EDUC. MUNICIPAL CARDEN.A.SAMORE', value: '9292' },
  { text: 'COLEGIO CHRISTIAN GARDEN SCHOOL', value: '9637' },
  { text: 'COLEGIO POLIV. ALMENDRAL DE LA PINTANA', value: '25250' },
  { text: 'COLEGIO TECNICO PROFESIONAL NOCEDAL', value: '24956' },
  { text: 'LICEO SERGIO SILVA BASCUNAN', value: '25824' },
  { text: 'LICEO POLITECNICO PART.SAGRADO CORAZON', value: '9810' },
  { text: 'COMPLEJO EDUCACIONAL PEDRO PRADO', value: '10076' },
  { text: 'COMPLEJO EDUC. JOAQUIN EDWARDS BELLO.', value: '9075' },
  { text: 'COMPLEJO EDUCACIONAL ALBERTO WIDMER', value: '24626' },
  { text: 'LICEO POLITECNICO PARTICULAR HANNOVER', value: '9897' },
  { text: 'CENTRO EDUC PROFES GMO GONZALEZ HEINRICH', value: '9194' },
  { text: 'CENTRO POLITECNICO PARTICULAR DE NUNOA', value: '12217' },
  { text: 'COL TEC PROFESIONAL REPUBLICA ARGENTINA', value: '9082' },
  { text: 'INST. POLITEC. PROF. GUILLERMO GONZALEZ HEINR', value: '9159' },
  { text: 'LICEO COMERCIAL GABRIEL GONZALEZ VIDELA', value: '9065' },
  {
    text: 'LICEO COMERCIAL PARTICULAR \u00c3\u2018U\u00c3\u2018OA',
    value: '9177',
  },
  {
    text: 'LICEO INDUSTRIAL CHILENO-ALEMAN DE \u00c2\u00beU\u00c3\u008fOA',
    value: '9063',
  },
  {
    text: 'LICEO TECNICO B N\u00c3\u2022 58 JOSE MARIA NARBONA',
    value: '9064',
  },
  { text: 'Escuela Consolidada Davila', value: '9410' },
  { text: 'Liceo T\u00e9cnico Clotario Blest Riffo', value: '9686' },
  { text: 'CENTRO EDUC. DIEGO DE ALMAGRO', value: '25028' },
  { text: 'LICEO POLITEC.PARTICULAR CARMEN ARRIARAN', value: '9164' },
  { text: 'COLEGIO POLIVALENTE YORK', value: '9182' },
  { text: 'ESCUELA Y LICEO PAULINA VON MALLINCKRODT', value: '8945' },
  { text: 'INSTITUTO TECNOLOGICO SAN MATEO', value: '25496' },
  { text: 'INSTITUTO COMERCIAL SAN PABLO', value: '11923' },
  { text: 'COLEGIO POLIVALENTE MONTE CARMELO', value: '25694' },
  { text: 'COLEGIO POLIVALENTE NOVO HORIZONTE', value: '25853' },
  { text: 'CENTRO EDUCACIONAL ALBERTO HURTADO', value: '10044' },
  { text: 'COLEGIO POLIT\u00c3\u2030CNICO SANTA ANA', value: '8629' },
  { text: 'LICEO COMERCIAL MOLINA LAVIN', value: '9982' },
  { text: 'LICEO EXPERIMENTAL ARTISTICO B-65', value: '8511' },
  { text: 'LICEO INDUSTRIAL BENJAMIN FRANKLIN', value: '11831' },
  { text: 'LICEO GUILLERMO LABARCA HUBERTSON', value: '9985' },
  { text: 'CENTRO EDUCACIONAL SAN LORENZO', value: '11965' },
  { text: 'LICEO COMERCIAL LUIS CORREA PRIETO', value: '8502' },
  { text: 'LICEO INDUSTRIAL Y DE MINAS IGNACIO DOMEY', value: '8813' },
  { text: 'CENTRO EDUCACIONAL RENCA', value: '25085' },
  { text: 'LICEO INDUSTRIAL BENJAMIN DAVILA LARRAIN', value: '10196' },
  { text: 'LICEO POLITEC.PARTIC.EL SENOR DE RENCA', value: '24828' },
  { text: 'LICEO POLITECNICO PARTICULAR ANDES', value: '24482' },
  { text: 'COLEGIO POLIV. ARZOBISPO MANUEL VICUNA', value: '25783' },
  { text: 'ESC. TECNICA E INST. COMER. SAINT LAWRENCE', value: '9483' },
  { text: 'CENTRO EDUC. PARTICULAR SAN LUIS', value: '11869' },
  { text: 'ESCUELA DE LA INDUSTRIA GRAFICA HECTOR GO', value: '9407' },
  { text: 'INSTIT.POLIT.SAN MIGUEL ARCANGEL', value: '9474' },
  { text: 'LICEO TECNICO A-100 DE SAN MIGUEL', value: '9581' },
  { text: 'CENTRO EDUCACIONAL MIRADOR', value: '9608' },
  { text: 'COLEGIO POLIVALENTE FRANCISCO RAMIREZ', value: '9646' },
  { text: 'INSTITUTO COMERCIAL BLAS CANAS', value: '8643' },
  { text: 'INST.SUP.DE COMERCIO EDUARDO FREI M.', value: '8503' },
  { text: 'LICEO COMERCIAL JOAQUIN VERA MORALES', value: '8507' },
  { text: 'LICEO INDUSTRIAL ELIODORO GARCIA ZEGERS', value: '8500' },
  { text: 'LICEO POLIT. SARA BLINDER DARGOLTZ', value: '8617' },
  { text: 'LICEO POLIVALENTE A-28 EMILIA TORO DE BAL', value: '8505' },
  { text: 'LICEO PROFESIONAL ABDON CIFUENTES', value: '8811' },
  {
    text: 'LICEO TECNICO A N\u00c2\u00b0 27 CLELIA CLAVEL DINAT',
    value: '8504',
  },
  { text: 'CENTRO EDUC. PART. MARIA REINA INMACULADA', value: '10734' },
  { text: 'CENTRO EDUCACIONAL ISLA DE MAIPO', value: '10725' },
  { text: 'LICEO COMERCIAL REPUBLICA DE BRASIL', value: '10751' },
  { text: 'LICEO TECNICO PROFESIONAL MALLOCO', value: '25207' },
  { text: 'LICEO COMERCIAL TALAGANTE', value: '10711' },
  { text: 'LICEO POLITECNICO DE TALAGANTE', value: '10697' },
  { text: 'COLEGIO  MAYOR DE PE\u00c3\u2018ALOLEN', value: '25478' },
  { text: 'LICEO ANTONIO HERMIDA FABRES', value: '9088' },
  { text: 'COLEGIO ARICA COLLEGE', value: '12587' },
  { text: 'LICEO ZAPALLAR', value: '16716' },
  { text: 'COLEGIO MARIA INMACULADA', value: '8954' },
  { text: 'COLEGIO SANTO TOMAS', value: '24714' },
  { text: 'CENTRO EDUCATIVO SALESIANOS ALAMEDA', value: '8603' },
  { text: 'COLEGIO MAYOR TOBALABA', value: '24977' },
  { text: 'COLEGIO POLIV. CARDENAL JOSE MARIA CARO', value: '25779' },
  { text: 'COLEGIO EL ALMENDRO', value: '9844' },
  { text: 'COLEGIO SAN MIGUEL DE LOS ANDES', value: '12077' },
  { text: 'COLEGIO LAS AMERICAS', value: '14717' },
  {
    text: 'LICEO COMERCIAL INSTITUTO SUPERIOR DE COMERCIO DE CHILE (EX A99)',
    value: '9409',
  },
  { text: 'COLEGIO SAN DAMIAN', value: '9534' },
  { text: 'LICEO MUNICIPAL PABLO NERUDA', value: '2657' },
  { text: 'INSTITUTO POLITECNICO', value: '2552' },
  { text: 'COLEGIO PALMARES', value: '25961' },
  { text: 'LICEO COMERCIAL JERARDO MUNOZ CAMPO', value: '280' },
  { text: 'COLEGIO NUEVA ESPERANZA', value: '14313' },
  { text: 'ESCUELA PARTICULAR RUBEN DARIO', value: '9967' },
  { text: 'LICEO LOS ANGELES A-59', value: '4163' },
  { text: 'ESCUELA PARTICULAR ELVIRA HURTADO DE M.', value: '10042' },
  { text: 'COLEGIO PRESIDENTE ALESSANDRI', value: '10220' },
  { text: 'COLEGIO CAMBRIDGE SCHOOL', value: '13383' },
  { text: 'LICEO POLITECNICO TOMAS MARIN DE POVEDA', value: '2280' },
  { text: 'COLEGIO BRITANICO ST. MARGARETS S.A.', value: '1783' },
  { text: 'COLEGIO DE LA INMACULADA CONCEPCI\u00c3\u201cN', value: '25695' },
  { text: 'COLEGIO LA VIRGEN DE POMPEYA', value: '8849' },
  { text: 'INSTITUTO FEMENINO SUPERIOR DE COMERCIO E', value: '8506' },
  { text: 'LICEO JORGE ALESSANDRI RODRIGUEZ', value: '10970' },
  { text: 'COLEGIO INDUSTRIAL PART. DON ORIONE', value: '9947' },
  { text: 'COLEGIO EL ROBLE DE SANTO DOMINGO', value: '14751' },
  { text: 'COLEGIO SANTO TOMAS NUNOA', value: '9259' },
  { text: 'COLEGIO RUBEN CASTRO-DIURNO', value: '1734' },
  { text: 'ESC.BAS. EMPRENDER LARAPINTA', value: '26135' },
  { text: 'COLEGIO REAL DE CAREN', value: '15792' },
  { text: 'COLEGIO ADVENTISTA LA CISTERNA', value: '9797' },
  { text: 'ESCUELA LA PROVIDENCIA', value: '4659' },
  { text: 'LICEO TECNOLOGICO VILLA ALEMANA', value: '1958' },
  { text: 'ESCUELA PARTICULAR SAN ENRIQUE', value: '1000' },
  { text: 'LICEO SIMON BOLIVAR', value: '8828' },
  { text: 'COLEGIO El NINO JESUS', value: '10713' },
  { text: 'COLEGIO SANTO TOMAS DE CURICO', value: '2787' },
  { text: 'COLEGIO UNIVERSITARIO ANTONIO RENDIC', value: '12864' },
  { text: 'COLEGIO MONTESSORI', value: '10600' },
  { text: 'COLEGIO DOMINGO SANTA MARIA', value: '22434' },
  { text: 'COLEGIO TUPAHUE', value: '26115' },
  { text: 'COLEGIO CRISTIANO LA UNION', value: '22559' },
  { text: 'LICEO AMERICA', value: '220' },
  { text: 'COLEGIO CASTELGANDOLFO', value: '25048' },
  { text: 'LICEO CLARA SOLOVERA', value: '10592' },
  { text: 'COLEGIO BORDEMAR', value: '14232' },
  { text: 'LICEO MANUEL MAGALHAES MEDLING', value: '384' },
  { text: 'LICEO POLIVALENTE MERCEDES MARIN DEL SOLAR', value: '9069' },
  { text: 'INSTITUTO TECNOLOGICO DEL SUR', value: '22374' },
  { text: 'INSTITUTO COMERCIAL PITAGORAS', value: '8590' },
  { text: 'CENTRO DE EDUCACION DE ADULTOS APRENDER', value: '22508' },
  { text: 'L. POLI. ANTONIO VARAS DE LA BARRA', value: '7' },
  { text: 'INST.SUP.COMERCIO FCO.ARAYA BENNET', value: '1502' },
  { text: 'ESCUEA RAMON VINAY SEPULVEDA', value: '17698' },
  { text: 'COLEGIO JESUS SERVIDOR', value: '25589' },
  { text: 'COLEGIO POLIV. PROF. GUILLERMO GONZALEZ HEIN', value: '8938' },
  { text: 'COLEGIO MARIA MONTESSORI', value: '1226' },
  { text: 'COLEGIO MANANTIALES', value: '8876' },
  { text: 'COLEGIO MISTRAL', value: '15624' },
  { text: 'LICEO GABRIELA MISTRAL', value: '16632' },
  { text: 'COLEGIO SAGRADO CORAZON DE JESUS', value: '2326' },
  { text: 'COLEGIO  PABLO APOSTOL', value: '25221' },
  { text: 'COLEGIO FORD COLLEGE', value: '10906' },
  { text: 'GEORGE CHAYTOR ENGLISH COLLEGE', value: '20235' },
  {
    text: 'LICEO CIENT.HUM.BENJAMIN VICU\u00c3\u2018A MACKENNA',
    value: '22544',
  },
  { text: 'COLEGIO HENRY FAYOL', value: '24801' },
  { text: 'COLEGIO CORDILLERA', value: '22523' },
  { text: 'COLEGIO UMBRAL DE CURAUMA', value: '14764' },
  { text: 'COLEGIO STA CATALINA DE SIENA SN ALBERTO HURT', value: '24432' },
  { text: 'ESCUELA TECNICO PROFESIONAL', value: '437' },
  { text: 'COLEGIO AURORA', value: '16635' },
  { text: 'COLEGIO LIBERTADOR SIMON BOLIVAR', value: '11157' },
  { text: 'PAN AMERICAN COLLEGE VINA DEL MAR', value: '14716' },
  { text: 'ESCUELA VILLA CULENAR', value: '3111' },
  { text: 'COLEGIO PUNTA ARENAS', value: '24319' },
  { text: 'COLEGIO SOCHIDES', value: '25556' },
  { text: 'LICEO REPUBLICA DE ITALIA', value: '10727' },
  { text: 'LICEO COMERCIAL ALEJANDRO LUBET V', value: '1884' },
  { text: 'LICEO LUIS CRUZ MARTINEZ', value: '124' },
  { text: 'COLEGIO SAINT LOUIS SCHOOL', value: '26268' },
  { text: 'ESCUELA DARIO SALAS', value: '7639' },
  { text: 'COLEGIO EL BOSQUE PROVINCIA CORDILLERA', value: '24713' },
  { text: 'LICEO TECNICO DE ANTOFAGASTA', value: '283' },
  { text: 'LICEO POLITECNICO DE CALBUCO', value: '7772' },
  { text: 'ESCUELA PARTICULAR JOSE ANTONIO LECAROS', value: '9930' },
  { text: 'INSTITUTO TECN.PROF.MARITIMO DE VALPSO', value: '1525' },
  { text: 'LICEO ADVENTISTA DE TEMUCO', value: '5661' },
  { text: 'COLEGIO NAHUELCURA', value: '15817' },
  { text: 'COLEGIO SAINT PATRICK SCHOOL', value: '20181' },
  { text: 'COLEGIO ALBERTO PEREZ', value: '9924' },
  { text: 'LICEO JOSE CORTES BROWN', value: '1747' },
  { text: 'COLEGIO ALEMAN LOS ANGELES', value: '4286' },
  { text: 'COLEGIO  SAN JOSE DE CHICUREO', value: '25348' },
  { text: 'CENTRO EDUCACIONAL DE HUECHURABA', value: '10250' },
  { text: 'COLEGIO MAIMONIDES SCHOOL', value: '25107' },
  { text: 'COLEGIO TREBULCO', value: '25452' },
  { text: 'COLEGIO SANTA CRUZ DE CHICUREO', value: '25329' },
  { text: 'SYDNEY COLLEGE', value: '17800' },
  { text: 'COLEGIO PARTICULAR MARTIN RUCKER', value: '3730' },
  { text: 'COLEGIO SANTIAGO - QUILICURA', value: '26110' },
  { text: 'COLEGIO SAN ALBERTO HURTADO', value: '3202' },
  { text: 'HARVEST CHRISTIAN SCHOOL', value: '12977' },
  { text: 'COLEGIO KING`S SCHOOL', value: '9553' },
  { text: 'LICEO BICENTENARIO ALTOS DEL MACKAY', value: '24240' },
  { text: 'CENTRO INTEGRAL DE EDUCACI\u00c3\u201cN ALBORADA', value: '24206' },
  { text: 'LICEO TECNICO PROFESIONAL JUAN PABLO II', value: '11608' },
  { text: 'COLEGIO MATER DEI DE COYHAIQUE', value: '8367' },
  { text: 'COLEGIO KALEM', value: '24230' },
  { text: 'LICEO POLITECNICO DE AYSEN', value: '8375' },
  { text: 'LICEO LUISA RABANAL DE PALMA', value: '8394' },
  { text: 'ESCUELA EUSEBIO IBR SCHEPELER', value: '8391' },
  { text: 'LICEO TECNICO AMELIA COURBIS', value: '2934' },
  { text: 'COLEGIO POLIVALENTE DE LA PINTANA', value: '25082' },
  { text: 'CENTRO EDUC.EVANGELICO DE HUALPENCILLO', value: '4782' },
  { text: 'COLEGIO MAHATMA GANDHI', value: '40295' },
  { text: 'EAGLES COLLEGE', value: '12657' },
  { text: 'COLEGIO ALTO DEL VALLE', value: '26269' },
  { text: 'COLEGIO SAN FERNANDO DE BUIN', value: '31040' },
  { text: 'PUMAHUE CHICUREO', value: '26399' },
  { text: 'LICEO POLITECNICO ARICA', value: '1' },
  { text: 'PARVULARIO LAS ESPIGUITAS', value: '2' },
  { text: 'ESC. PEDRO VICENTE GUTIERREZ TORRES', value: '3' },
  { text: 'JOVINA NARANJO FERNANDEZ', value: '5' },
  { text: 'ESCUELA REPUBLICA DE ISRAEL', value: '9' },
  { text: 'ESCUELA REPUBLICA DE FRANCIA', value: '10' },
  { text: 'ESC. GRAL. PEDRO LAGOS MARCHANT', value: '11' },
  { text: 'ESCUELA GRAL JOSE MIGUEL CARRERA', value: '12' },
  { text: 'ESCUELA MANUEL RODRIGUEZ ERDOYZA', value: '13' },
  { text: 'ESCUELA ROMULO J. PENA MATURANA', value: '14' },
  { text: 'LICEO ARTISTICO DR. JUAN NOE CREVANI', value: '15' },
  { text: 'ESCUELA REGIMIENTO RANCAGUA', value: '16' },
  { text: 'ESCUELA SUBTTE. LUIS CRUZ MARTINEZ', value: '17' },
  { text: 'ESC. COMTE. JUAN JOSE SAN MARTIN', value: '18' },
  { text: 'ESC. HUMBERTO VALENZUELA GARCIA', value: '19' },
  { text: 'ESCUELA TUCAPEL', value: '20' },
  { text: 'ESCUELA LINCOYAN', value: '21' },
  { text: 'ESCUELA GABRIELA MISTRAL', value: '22' },
  { text: 'ESCUELA CENTENARIO', value: '25' },
  { text: 'ESCUELA REPUBLICA DE ARGENTINA', value: '26' },
  { text: 'ESCUELA ESMERALDA', value: '27' },
  { text: 'ESCUELA RICARDO SILVA ARRIAGADA', value: '28' },
  { text: 'ESCUELA AMERICA', value: '29' },
  { text: 'ESCUELA DR. RICARDO OLEA GUERRA', value: '30' },
  { text: 'ESCUELA DARIO SALAS DIAZ', value: '31' },
  { text: 'LICEO AGRICOLA JOSE ABELARDO NUNEZ M.', value: '32' },
  { text: 'ESCUELA CARLOS CONDELL DE LA HAZA', value: '33' },
  { text: 'ESCUELA GRAL. MANUEL BAQUEDANO', value: '35' },
  { text: 'ESCUELA IGNACIO CARRERA PINTO', value: '36' },
  { text: 'ESCUELA ESPA\u00c3\u2018A', value: '38' },
  { text: 'ESCUELA PAMPA ALGODONAL', value: '39' },
  { text: 'ESCUELA VALLE DE CHACA', value: '41' },
  { text: 'ESCUELA MOLINOS LLUTA', value: '42' },
  { text: 'JARDIN INFANTIL CEPILLIN', value: '43' },
  { text: 'COLEGIO ITALIANO SANTA ANA', value: '45' },
  { text: 'JARDIN INFANTIL SAN ANDRES', value: '46' },
  { text: 'JARDIN INFANTIL PADRE LUIS GALLARDO', value: '49' },
  { text: 'COLEGIO ADVENTISTA DE ARICA', value: '50' },
  { text: 'ESCUELA PARTICULAR REP\u00c3\u0161BLICA DEL ECUADOR', value: '51' },
  { text: 'LICEO DOMINGO SANTA MARIA', value: '52' },
  { text: 'JARDIN INFANTIL MONTESSORI GARDEN', value: '55' },
  { text: 'COLEGIO SAN MARCOS DE ARICA', value: '56' },
  { text: 'JARDIN INFANTIL PETETE J.M. BORGO\u00c3\u0090O', value: '58' },
  { text: 'JARDIN INFANTIL PLUTO', value: '66' },
  { text: 'ABRAHAM LINCOLN SCHOOL', value: '67' },
  { text: 'ESCUELA VALLE DE ESQUINA', value: '70' },
  { text: 'LICEO  VALLE DE CODPA', value: '72' },
  { text: 'ESCUELA VALLE DE COBIJA', value: '73' },
  { text: 'ESCUELA VALLE DE CAMARONES', value: '74' },
  { text: 'ESCUELA VALLE DE GUANACAGUA', value: '75' },
  { text: 'ESCUELA VALLE DE CUYA', value: '76' },
  { text: 'LICEO GRANADEROS', value: '78' },
  { text: 'ESCUELA EL MARQUEZ', value: '79' },
  { text: 'ESCUELA PAYACHATAS', value: '81' },
  { text: 'ESCUELA SAN FRANCISCO DE ASIS', value: '82' },
  { text: 'ESCUELA COTA COTANI', value: '83' },
  { text: 'ESCUELA LOS ALAMOS', value: '84' },
  { text: 'ESCUELA SAN SANTIAGO DE BELEN', value: '86' },
  { text: 'ESCUELA ANCOLACANE', value: '87' },
  { text: 'ESCUELA ALCERRECA', value: '88' },
  { text: 'ESCUELA HUMAPALCA', value: '89' },
  { text: 'ESCUELA INTERNADO VISVIRI', value: '90' },
  { text: 'ESCUELA COSAPILLA', value: '91' },
  { text: 'ESCUELA CHISLLUMA', value: '92' },
  { text: 'ESCUELA CHUJLLUTA', value: '93' },
  { text: 'ESCUELA GUACOYO', value: '94' },
  { text: 'ESCUELA COLPITAS', value: '95' },
  { text: 'INST. COM. DE IQUIQUE BALDOMERO WOLNITZKY', value: '97' },
  { text: 'ESC.EDUC.ESPECIAL FLOR DEL INCA', value: '102' },
  { text: 'ESC.EDUC.GRAL.BAS.Y DES.ART.VIOLETA PARRA', value: '103' },
  { text: 'CENTRO DE CAPACITACION LABORAL', value: '105' },
  { text: 'INSTITUTO DEL MAR ALMIRANTE CARLOS CONDEL', value: '106' },
  { text: 'LICEO POLITEC. JOSE GUTIERREZ DE LA FUEN', value: '108' },
  { text: 'LICEO ELENA DUVAUCHELLE CABEZON', value: '109' },
  { text: 'ESCUELA DOMINGO SANTA MARIA', value: '110' },
  { text: 'ESCUELA GABRIELA MISTRAL', value: '111' },
  { text: 'ESCUELA EDUARDO LLANOS', value: '112' },
  { text: 'ESCUELA ALMIRANTE PATRICIO LYNCH', value: '113' },
  { text: 'ESCUELA PLACIDO VILLARROEL', value: '114' },
  { text: 'ESCUELA JAVIERA CARRERA VERDUGO', value: '115' },
  { text: 'COLEGIO REPUBLICA DE CROACIA', value: '116' },
  { text: 'ESCUELA PAULA JARAQUEMADA ALQUIZAR', value: '117' },
  { text: 'ESCUELA CENTENARIO', value: '119' },
  { text: 'LICEO COM.Y TEC.ARTURO PRAT CHACON', value: '120' },
  { text: 'ESCUELA THILDA PORTILLO OLIVARES', value: '122' },
  { text: 'COLEGIO ESPANA', value: '123' },
  { text: 'ESCUELA PROFESOR MANUEL CASTRO RAMOS', value: '125' },
  { text: 'COLEGIO REPUBLICA DE ITALIA', value: '126' },
  { text: 'LICEO SUPERIOR GABRIELA MISTRAL', value: '129' },
  { text: 'COLEGIO NORTH COLLEGE', value: '130' },
  { text: 'LICEO PARTICULAR MIXTO ESCASCE', value: '131' },
  { text: 'COLEGIO ADVENTISTA DE IQUIQUE', value: '133' },
  { text: 'J.  I.  CAPULLITO', value: '136' },
  { text: 'JARDIN INFANTIL CONEJITO', value: '139' },
  { text: 'ESCUELA BASICA FRONTERIZA', value: '154' },
  { text: 'ESCUELA PISAGUA', value: '156' },
  { text: 'ESCUELA CHIAPA', value: '158' },
  { text: 'ESCUELA JAINA', value: '159' },
  { text: 'ESCUELA PACHICA', value: '160' },
  { text: 'LICEO DE HUARA', value: '161' },
  { text: 'ESCUELA SIBAYA', value: '162' },
  { text: 'ESCUELA CHUSMIZA', value: '165' },
  { text: 'ESCUELA CAMINA', value: '167' },
  { text: 'ESCUELA CUISAMA', value: '168' },
  { text: 'ESCUELA QUISTAGAMA', value: '169' },
  { text: 'ESCUELA NAMA', value: '170' },
  { text: 'ESCUELA APAMILCA', value: '171' },
  { text: 'ESCUELA CHAPIQUILTA', value: '172' },
  { text: 'ESCUELA MOQUELLA', value: '173' },
  { text: 'ESCUELA FRANCIA', value: '174' },
  { text: 'ESCUELA YALA YALA', value: '175' },
  { text: 'ESCUELA BASICA CARIQUIMA', value: '177' },
  { text: 'LICEO TECNICO PROFESIONAL COLCHANE', value: '178' },
  { text: 'ESCUELA BASICA MAUQUE', value: '179' },
  { text: 'ESCUELA BASICA PISIGA-CHOQUE', value: '185' },
  { text: 'ESCUELA BASICA ENQUELGA', value: '186' },
  { text: 'ESCUELA VERTIENTE DEL SABER', value: '187' },
  { text: 'ESC. MATILLA DE NUEVA EXTREMADURA', value: '188' },
  { text: 'LIC. ALCDE.SERGIO GONZALEZ GUTIERREZ', value: '191' },
  { text: 'ESCUELA BASICA MAMINA', value: '192' },
  { text: 'ESCUELA BASICA POZO ALMONTE', value: '193' },
  { text: 'ESCUELA BASICA LA TIRANA', value: '195' },
  { text: 'ESCUELA BASICA HUATACONDO', value: '196' },
  { text: 'ESCUELA BASICA LA HUAYCA', value: '198' },
  { text: 'LICEO DOMINGO LATRILLE LASTAUNOU', value: '199' },
  { text: 'LICEO POLITECNICO DIEGO PORTALES P.', value: '200' },
  { text: 'ESCUELA CARLOS CONDELL DE LA HAZA', value: '201' },
  { text: 'ESCUELA PABLO NERUDA', value: '203' },
  { text: 'ESCUELA L.GRAL.BERNARDO OHIGGINS R.', value: '204' },
  { text: 'ESCUELA ARTURO PRAT CHACON', value: '205' },
  { text: 'ESCUELA ESTADOS UNIDOS DE NORTEAMERICA', value: '206' },
  { text: 'ESC. ESPECIAL PEDRO AGUIRRE CERDA', value: '207' },
  { text: 'COLEGIO SAGRADA FAMILIA', value: '208' },
  { text: 'ESCUELA ARTURO PEREZ CANTO', value: '210' },
  { text: 'LICEO  H.C. T.P.  MARIA ELENA', value: '211' },
  { text: 'ESCUELA IGNACIO CARRERA PINTO', value: '214' },
  { text: 'LICEO POLITECNICO CESAREO AGUIRRE G.', value: '219' },
  { text: 'ESCUELA CLAUDIO ARRAU', value: '223' },
  { text: 'ESCUELA GRECIA', value: '224' },
  { text: 'ESCUELA REPUBLICA DE BOLIVIA', value: '225' },
  { text: 'ESCUELA BASICA EMILIO SOTOMAYOR', value: '226' },
  { text: 'ESCUELA BASICA PRESIDENTE BALMACEDA', value: '227' },
  { text: 'ESCUELA BASICA VADO DE TOPATER', value: '228' },
  { text: 'ESCUELA REPUBLICA DE CHILE', value: '229' },
  { text: 'ESCUELA BASICA ANDRES BELLO', value: '230' },
  { text: 'ESCUELA BASICA JOHN FITZGERALD KENNEDY', value: '231' },
  { text: 'ESCUELA BASICA PEDRO VERGARA KELLER', value: '232' },
  { text: 'ESCUELA DE PARVULOS LAS ABEJITAS', value: '236' },
  { text: 'ESCUELA DE PARVULOS LLAMITO BLANCO', value: '237' },
  { text: 'ESCUELA DIFERENCIAL LOA', value: '238' },
  { text: 'ESCUELA BASICA 21 DE MAYO', value: '239' },
  { text: 'ESCUELA BASICA REPUBLICA DE FRANCIA', value: '240' },
  { text: 'ESCUELA PARVULARIA LAS ARDILLAS', value: '241' },
  { text: 'ESCUELA BASICA PUKARA', value: '243' },
  { text: 'ESCUELA DE PARVULOS LOS ENANITOS', value: '244' },
  { text: 'ESCUELA DE PARVULOS PAPELUCHO', value: '245' },
  { text: 'ESCUELA BASICA SENORA DE LA CANDELARIA', value: '246' },
  { text: 'ESCUELA BASICA SAN JOSE', value: '248' },
  { text: 'ESCUELA BASICA SAN FRANCISCO', value: '252' },
  { text: 'COLEGIO ADVENTISTA DE CALAMA', value: '253' },
  { text: 'COLEGIO  EJERCITO DE SALVACION', value: '255' },
  { text: 'ESC. PARV. JESUS DE NAZARETH', value: '259' },
  { text: 'ESCUELA DE PARVULOS MICKEY MOUSE', value: '262' },
  { text: 'ESCUELA DE PARVULOS LOS CONEJITOS', value: '265' },
  { text: 'ESC. BASICA RURAL SAN ANTONIO DE PADUA', value: '268' },
  { text: 'ESCUELA BASICA SAN PEDRO DE ATACAMA', value: '269' },
  { text: 'ESCUELA BASICA TOCONAO', value: '270' },
  { text: 'ESCUELA BASICA CAMAR', value: '271' },
  { text: 'ESCUELA BASICA SOLOR', value: '273' },
  { text: 'ESCUELA BASICA SAN ROQUE', value: '274' },
  { text: 'ESCUELA BASICA ANDINA', value: '275' },
  { text: 'ESCUELA BASICA TALABRE', value: '276' },
  { text: 'ESCUELA BASICA SAN BARTOLOME', value: '277' },
  { text: 'LICEO INDUSTRIAL EULOGIO GORDO MONEO', value: '279' },
  { text: 'LICEO A. RENDIC I. ANEXO C. REHABILIT. SOCIAL', value: '282' },
  { text: 'LICEO MARIO BAHAMONDE SILVA', value: '284' },
  { text: 'LICEO LA PORTADA', value: '286' },
  { text: 'LICEO DOMINGO HERRERA RIVERA', value: '287' },
  { text: 'ESCUELA JAPON', value: '288' },
  { text: 'ESCUELA ESPANA', value: '289' },
  { text: 'ESCUELA PADRE GUSTAVO LE PAIGE WALQUE', value: '291' },
  { text: 'ESCUELA REPUBLICA DE ITALIA', value: '292' },
  { text: 'ESCUELA JOSE PAPIC RADNIC', value: '293' },
  { text: 'ESCUELA PROFESORA LJUBICA DOMIC WUTH', value: '294' },
  { text: 'ESCUELA REPUBLICA DE LOS ESTADOS UNIDOS', value: '296' },
  { text: 'ESCUELA ALCALDE MAXIMILIANO POBLETE', value: '297' },
  { text: 'ESCUELA DARIO SALAS DIAZ', value: '298' },
  { text: 'ESCUELA ROMULO J. PENA MATURANA', value: '301' },
  { text: 'ESCUELA JUAN LOPEZ', value: '302' },
  { text: 'ESCUELA REPUBLICA ARGENTINA', value: '303' },
  { text: 'ESCUELA GONZALEZ ECHEGOYEN', value: '305' },
  { text: 'ESCUELA HUANCHACA', value: '306' },
  { text: 'ESCUELA DE PARVULOS MARCELA PAZ', value: '307' },
  { text: 'ESCUELA CLAUDIO MATTE PEREZ', value: '310' },
  { text: 'ESC  DIFERENCIAL JUAN SANDOVAL CARRASCO', value: '311' },
  { text: 'ESCUELA ECUADOR', value: '312' },
  { text: 'ESCUELA ARTURO PRAT', value: '313' },
  { text: 'ESCUELA HEROES DE LA CONCEPCION', value: '315' },
  { text: 'ESCUELA LAS AMERICAS', value: '316' },
  { text: 'ESCUELA LAS ROCAS', value: '317' },
  { text: 'ESCUELA EDDA CUNEO DONNAGIO', value: '318' },
  { text: 'ESCUELA LA BANDERA', value: '319' },
  { text: 'ESCUELA ARMANDO CARRERA GONZALEZ', value: '320' },
  { text: 'ESCUELA GENERAL MANUEL BAQUEDANO', value: '322' },
  { text: 'ESCUELA FUNDACION MINERA ESCONDIDA', value: '324' },
  { text: 'ESCUELA SANTIAGO AMENGUAL B.', value: '326' },
  { text: 'ESCUELA LIBERTADORES DE CHILE', value: '329' },
  { text: 'ESCUELA DE PARVULOS LOS PINGUINITOS', value: '330' },
  { text: 'ESCUELA GABRIELA MISTRAL', value: '332' },
  { text: 'ESCUELA DE PARVULOS BLANCA NIEVES', value: '333' },
  { text: 'COLEGIO EVANGELICO JOSE LANCASTER', value: '335' },
  { text: 'CENTRO TRATAMIEN.INTEGRAL RAYITO DE SOL', value: '340' },
  { text: 'ESCUELA PARTICULAR ADVENTISTA', value: '341' },
  { text: 'COLEGIO INGLES SAN JOSE', value: '342' },
  { text: 'ESCUELA PRESBITERIANA', value: '343' },
  { text: 'ESC. PARV. LAS ARDILLITAS 1', value: '349' },
  { text: 'ESCUELA PARTICULAR LIDIA MORENO', value: '350' },
  { text: 'ESC. PARV. PAPELUCHO', value: '352' },
  { text: 'COL. KIDS SCHOOL', value: '354' },
  { text: 'INS. CHILENO NORTEAMERICANO CULTURA', value: '355' },
  { text: 'ESCUELA PARTICULAR CORAZON DE MARIA', value: '356' },
  { text: 'COLEGIO EAGLE SCHOOL', value: '365' },
  { text: 'COMPLEJO EDUCATIVO JUAN JOSE LATORRE BENAVENT', value: '367' },
  { text: 'ESCUELA BASICA JULIA HERRERA VARAS', value: '368' },
  { text: 'ESCUELA LUCILA GODOY ALCAYAGA', value: '369' },
  { text: 'ESCUELA ESTACION BAQUEDANO', value: '370' },
  { text: 'ESCUELA CARACOLES', value: '371' },
  { text: 'LICEO POLITECNICO JOSE MIGUEL QUIROZ', value: '372' },
  { text: 'LICEO JUAN CORTES-MONROY CORTES', value: '373' },
  { text: 'ESCUELA HOGAR VICTORIANO QUINTEROS SOTO', value: '374' },
  { text: 'ESCUELA VICTOR CARVAJAL MEZA', value: '375' },
  { text: 'ESCUELA PARANAL', value: '377' },
  { text: 'ESCUELA BASICA DIEGO PORTALES PALAZUELOS', value: '380' },
  { text: 'ESCUELA BASICA PEDRO LUJAN', value: '381' },
  { text: 'ESCUELA BASICA GASPAR CABRALES', value: '382' },
  { text: 'ESC. BAS. DIFERENCIAL JOSE LUIS OLIVARES A.', value: '383' },
  { text: 'ESCUELA ALIRO LAMAS CASTILLO', value: '386' },
  { text: 'ESC. BASICA EMPERATRIZ SEPULVEDA LANDEROS', value: '387' },
  { text: 'ESCUELA ESPECIAL ROSITA AZUL', value: '389' },
  { text: 'ESCUELA COEDUCACIONAL PARTICULAR', value: '390' },
  { text: 'ESCUELA COEDUCACIONAL PARTICULAR OSCAR Y', value: '391' },
  { text: 'INSTITUTO COMERCIAL ALEJANDRO RIVERA DIAZ', value: '396' },
  { text: 'ESCUELA MEDARDO CANO GODOY', value: '397' },
  { text: 'LICEO JOSE ANTONIO CARVAJAL', value: '399' },
  { text: 'ESCUELA BERNARDO O HIGGINS', value: '401' },
  { text: 'ESCUELA LAURA ROBLES SILVA', value: '403' },
  { text: 'ESC.EDUC.DIFERENCIAL MARIA LUZ LANZA PIZARRO', value: '404' },
  { text: 'ESCUELA LOS ESTANDARTES', value: '405' },
  { text: 'ESCUELA VICENTE SEPULVEDA ROJO', value: '406' },
  { text: 'ESCUELA JESUS FERNANDEZ HIDALGO', value: '407' },
  { text: 'ESCUELA PEDRO LEON GALLO', value: '408' },
  { text: 'ESCUELA JOSE MANSO DE VELASCO', value: '410' },
  { text: 'ESCUELA LAS CANTERAS', value: '411' },
  { text: 'ESCUELA LAS BRISAS', value: '413' },
  { text: 'ESCUELA ABRAHAM SEPULVEDA PIZARRO', value: '416' },
  { text: 'COLEGIO BUEN PASTOR', value: '417' },
  { text: 'ESCUELA ISABEL PENA MORALES', value: '418' },
  { text: 'ESCUELA HERNAN MARQUEZ HUERTA', value: '419' },
  { text: 'ESCUELA FUNDICION PAIPOTE', value: '420' },
  { text: 'ESCUELA BRUNO ZAVALA FREDES', value: '421' },
  { text: 'ESCUELA SAN PEDRO', value: '423' },
  { text: 'ESCUELA LUIS CRUZ MARTINEZ', value: '427' },
  { text: 'LICEO POLITECNICO BELEN', value: '430' },
  { text: 'LICEO SAGRADO CORAZON', value: '431' },
  { text: 'COLEGIO ADVENTISTA DE COPIAPO', value: '433' },
  { text: 'ESCUELA SAN VICENTE DE PAUL', value: '434' },
  { text: 'LICEO MANUEL BLANCO ENCALADA', value: '438' },
  { text: 'ESCUELA TOTORAL', value: '439' },
  { text: 'COLEGIO PARROQUIAL PADRE NEGRO', value: '440' },
  { text: 'ESCUELA DE CONCENTRACION', value: '441' },
  { text: 'ESCUELA VICTOR MANUEL SANCHEZ CABANAS', value: '442' },
  { text: 'ESCUELA LUIS URIBE ORREGO', value: '444' },
  { text: 'ESCUELA PAUL HARRIS', value: '445' },
  { text: 'ESCUELA AMOLANAS', value: '446' },
  { text: 'ESCUELA SAN ANTONIO', value: '447' },
  { text: 'LICEO JOSE SANTOS OSSA', value: '449' },
  { text: 'ESCUELA HERMANOS CARRERA', value: '450' },
  { text: 'ESCUELA GABRIELA MISTRAL', value: '452' },
  { text: 'ESCUELA IGNACIO CARRERA PINTO', value: '453' },
  { text: 'ESCUELA GREGORIO CASTILLO MAR\u00c3\u008dN', value: '454' },
  { text: 'ESCUELA REPUBLICA DE LOS E.E.U.U.', value: '455' },
  { text: 'ESC. EDUC.DIFERENC LUIS IRIARTE IRIARTE', value: '456' },
  { text: 'ESCUELA ARTURO PEREZ CANTO', value: '458' },
  { text: 'ESCUELA BASICA ESPANA', value: '459' },
  { text: 'ESCUELA LUIS CRUZ MARTINEZ', value: '461' },
  { text: 'ESCUELA JOSE CAROCA LAFLOR', value: '462' },
  { text: 'ESCUELA BASICA ROBERTO CUADRA ALQUINTA', value: '463' },
  { text: 'ESCUELA BASICA GUALBERTO KONG FERNANDEZ', value: '464' },
  { text: 'ESCUELA BASICA JAVIERA CARRERA', value: '466' },
  { text: 'ESCUELA HERNAN ARAVENA CONTRERAS', value: '467' },
  { text: 'ESCUELA BASICA IGNACIO FRANCO GALLO', value: '468' },
  { text: 'ESCUELA BASICA JUSTINO LEIVA AMOR', value: '469' },
  { text: 'ESCUELA BASICA SARA BEMBOW VILLEGAS', value: '471' },
  { text: 'ESCUELA BASICA SOR TERESA DE LOS ANDES', value: '476' },
  { text: 'LICEO SANTA MARTA', value: '478' },
  { text: 'ESCUELA BASICA ALEJANDRO NOEMI HUERTA', value: '481' },
  { text: 'ESCUELA FORTUNATO SOZA RODRIGUEZ', value: '482' },
  { text: 'ESCUELA SAMUEL E. CASTILLO LOPEZ', value: '483' },
  { text: 'ESCUELA DE MAITENCILLO', value: '484' },
  { text: 'ESCUELA BASICA YERBAS BUENAS', value: '485' },
  { text: 'LICEO JAPON', value: '486' },
  { text: 'ESCUELA BASICA JOSE MIGUEL CARRERA', value: '487' },
  { text: 'ESCUELA EL OLIVAR', value: '489' },
  { text: 'ESCUELA PABLO NERUDA', value: '490' },
  { text: 'COLEGIO PARTICULAR ENGLISH COLLEGE', value: '492' },
  { text: 'EDUCADOR ARTURO ALVEAR RAMOS', value: '493' },
  { text: 'ESCUELA AGLADE MARIN VARGAS', value: '495' },
  { text: 'ESCUELA DE CHOLLAY', value: '496' },
  { text: 'ESCUELA DE LA PAMPA', value: '497' },
  { text: 'ESCUELA ALGARROBILLA', value: '498' },
  { text: 'ESCUELA RICARDO CAMPILLAY CONTRERAS', value: '499' },
  { text: 'ESCUELA BASICA RURAL EL TAMBO', value: '500' },
  { text: 'ESCUELA DE LAS MARQUESAS', value: '502' },
  { text: 'ESCUELA DE LAS BREAS', value: '503' },
  { text: 'ESCUELA GABRIELA MISTRAL', value: '504' },
  { text: 'ESCUELA DE LOS PERALES', value: '506' },
  { text: 'ESCUELA DE CHIGUINTO', value: '508' },
  { text: 'ESC.BASICA ALDECIRA ALVAREZ A.', value: '509' },
  { text: 'ESCUELA DE EL CORRAL', value: '514' },
  { text: 'LICEO TECNICO MARTA BRUNET', value: '518' },
  { text: 'COLEGIO ARTURO PRAT CHACON', value: '519' },
  { text: 'COLEGIO VICTOR DOMINGO SILVA', value: '521' },
  { text: 'COLEGIO JAVIERA CARRERA', value: '522' },
  { text: 'ESCUELA ALONSO DE ERCILLA', value: '523' },
  { text: 'COLEGIO JAPON', value: '525' },
  { text: 'COLEGIO JOSE MANUEL BALMACEDA', value: '526' },
  { text: 'COLEGIO HEROES DE LA CONCEPCION', value: '527' },
  { text: 'ESCUELA GERMAN RIESCO', value: '528' },
  { text: 'COLEGIO MANUEL RODRIGUEZ', value: '529' },
  { text: 'COLEGIO PEDRO AGUIRRE CERDA', value: '531' },
  { text: 'CEN.ED.INT.DE ADUL.ESTER VILLARREAL CASTILLO', value: '532' },
  { text: 'COLEGIO DARIO SALAS', value: '533' },
  { text: 'COLEGIO VILLA SAN BARTOLOME', value: '534' },
  { text: 'COLEGIO JOSE MIGUEL CARRERA', value: '535' },
  { text: 'COLEGIO BERNARDA MORIN', value: '536' },
  { text: 'COLEGIO LUIS BRAILLE', value: '537' },
  { text: 'COLEGIO DE ALGARROBITO', value: '539' },
  { text: 'ESCUELA DE ISLON', value: '540' },
  { text: 'ESCUELA DE LAMBERT', value: '542' },
  { text: 'COLEGIO ALTOVALSOL', value: '543' },
  { text: 'ESCUELA DE EL MILAGRO', value: '544' },
  { text: 'COLEGIO COQUIMBITO', value: '546' },
  { text: 'ESCUELA DE COLONIA ALFALFARES', value: '548' },
  { text: 'ESCUELA DE LOS CORRALES', value: '549' },
  { text: 'ESCUELA DE ALMIRANTE LATORRE', value: '550' },
  { text: 'ESCUELA DE LAS ROJAS', value: '551' },
  { text: 'ESCUELA DE CHACAY ALTO', value: '552' },
  { text: 'ESCUELA DE PELICANA', value: '554' },
  { text: 'ESCUELA DE ROMERO', value: '556' },
  { text: 'ESCUELA DE SATURNO', value: '557' },
  { text: 'COLEGIO PUNTA DE TEATINOS', value: '558' },
  { text: 'COLEGIO QUEBRADA DE TALCA', value: '560' },
  { text: 'COLEGIO EL ROMERAL', value: '561' },
  { text: 'COLEGIO CALETA SAN PEDRO', value: '562' },
  { text: 'COLEGIO LA LAJA', value: '563' },
  { text: 'COLEGIO LA ESTRELLA', value: '564' },
  { text: 'COLEGIO ISABEL RIQUELME', value: '566' },
  { text: 'ESCUELA PARTICULAR OSCAR ALDUNATE ABBOTT', value: '567' },
  { text: 'COLEGIO SAN ANTONIO', value: '568' },
  { text: 'COLEGIO ELENA BETTINI', value: '570' },
  { text: 'ESC.ESPEC.LOS PENSAMIENTOS DE JUAN XXIII', value: '571' },
  { text: 'ESCUELA PARTICULAR TERESA VIDELA DE G', value: '573' },
  { text: 'COLEGIO PROVIDENCIA', value: '575' },
  { text: 'LICEO IGNACIO CARRERA PINTO', value: '578' },
  { text: 'COLEGIO SEMINARIO CONCILIAR', value: '579' },
  { text: 'COLEGIO SANTO DOMINGO', value: '589' },
  { text: 'COLEGIO PARTICULAR SAN JOSE', value: '590' },
  { text: 'COLEGIO INGLES CATOLICO', value: '591' },
  { text: 'COLEGIO FRANCISCO DE AGUIRRE', value: '594' },
  { text: 'ESCUELA BASICA PEDRO PABLO MUNOZ', value: '597' },
  { text: 'ESCUELA DE PUNTA DE CHOROS', value: '598' },
  { text: 'ESCUELA JOSE SANTOS OSSA', value: '599' },
  { text: 'ESCUELA DE LOS MORROS', value: '601' },
  { text: 'ESCUELA BASICA CARLOS CONDELL', value: '602' },
  { text: 'ESCUELA DE PUNTA COLORADA', value: '604' },
  { text: 'ESCUELA DE CRUZ GRANDE', value: '606' },
  { text: 'ESCUELA DE LOS CHOROS', value: '608' },
  { text: 'INSTITUTO SUPERIOR DE COMERCIO DE COQUIMBO', value: '609' },
  { text: 'LICEO DIEGO PORTALES', value: '611' },
  { text: 'ESCUELA GUILLERMO CERECEDA', value: '612' },
  { text: 'COLEGIO DE ARTES CLAUDIO ARRAU', value: '613' },
  { text: 'ESCUELA PRESIDENTE ANIBAL PINTO', value: '614' },
  { text: 'ESCUELA COQUIMBO', value: '615' },
  { text: 'ESCUELA CARDENAL JOSE MARIA CARO', value: '616' },
  { text: 'COLEGIO SANTA CECILIA', value: '617' },
  { text: 'ESCUELA SANTO TOMAS DE AQUINO', value: '618' },
  { text: 'ESCUELA JOSE ALFARO ALFARO', value: '620' },
  { text: 'ESCUELA BASICA MARIO MUNOZ SILVA', value: '621' },
  { text: 'CENTRO LABORAL JEAN PIAGET', value: '623' },
  { text: 'ESCUELA DIFERENCIAL JUAN SANDOVAL C.', value: '624' },
  { text: 'ESCUELA TOMASA OLIVARES CAAMANO', value: '625' },
  { text: 'ESCUELA BASICA DAVID LEON TAPIA', value: '626' },
  { text: 'ESCUELA DE PENUELAS', value: '628' },
  { text: 'ESCUELA PABLO NERUDA', value: '629' },
  { text: 'COLEGIO LA HERRADURA', value: '630' },
  { text: 'ESCUELA DE PAN DE AZUCAR', value: '631' },
  { text: 'ESCUELA BASICA MANUEL DE SALAS', value: '632' },
  { text: 'ESCUELA DE HUACHALALUME', value: '634' },
  { text: 'ESCUELA DE TOTORALILLO', value: '635' },
  { text: 'ESCUELA LUCILA GODOY ALACAYAGA', value: '637' },
  { text: 'ESCUELA DE CAMARONES', value: '638' },
  { text: 'ESCUELA DE LAS BARRANCAS', value: '639' },
  { text: 'ESCUELA DE EL MOLLACO', value: '640' },
  { text: 'ESCUELA DE LAS CARDAS', value: '641' },
  { text: 'ESCUELA DE EL PENON', value: '642' },
  { text: 'ESCUELA DE TAMBILLOS', value: '643' },
  { text: 'ESCUELA DE PUERTO ALDEA', value: '644' },
  { text: 'ESCUELA DE EL TANGUE', value: '645' },
  { text: 'COLEGIO MANUEL MONTT', value: '647' },
  { text: 'COLEGIO PARTICULAR GABRIELA MISTRAL', value: '649' },
  { text: 'ESCUELA PARTICULAR METODISTA', value: '650' },
  { text: 'COLEGIO PARTICULAR SAN IGNACIO', value: '655' },
  { text: 'LICEO PEDRO REGALADO S. VIDELA O.', value: '656' },
  { text: 'ESCUELA LUIS CRUZ MARTINEZ', value: '657' },
  { text: 'ESCUELA PATRICIO LYNCH', value: '658' },
  { text: 'ESCUELA PADRE BLAS HERNANDEZ SANCHEZ', value: '659' },
  { text: 'ESCUELA LUIS AMENABAR OSSA', value: '661' },
  { text: 'ESCUELA DE MAITENCILLO', value: '662' },
  { text: 'COLEGIO PARROQUIAL DE ANDACOLLO', value: '664' },
  { text: 'LICEO CARLOS ROBERTO MONDACA CORTES', value: '665' },
  { text: 'ESCUELA BASICA LUCILA GODOY ALCAYAGA', value: '666' },
  { text: 'ESCUELA EDMUNDO VIDAL CARDENAS', value: '668' },
  { text: 'ESCUELA NEFTALI REYES', value: '669' },
  { text: 'ESCUELA RIOS DE ELQUI', value: '671' },
  { text: 'ESCUELA DE DIAGUITAS JUAN TORRES M.', value: '672' },
  { text: 'ESCUELA JOSE ABELARDO NUNEZ', value: '673' },
  { text: 'ESCUELA DE VINITA ALTA', value: '674' },
  { text: 'ESCUELA DE SAN CARLOS', value: '676' },
  { text: 'ESCUELA AMELIA BARAHONA MUJICA', value: '678' },
  { text: 'ESCUELA FEDERICO BARNES PAYNE', value: '680' },
  { text: 'ESCUELA DE EL ARENAL', value: '681' },
  { text: 'ESCUELA DAGOBERTO CAMPOS NUNEZ', value: '682' },
  { text: 'ESCUELA DE LA CALERA', value: '683' },
  { text: 'ESCUELA DE LA POLVADA', value: '685' },
  { text: 'ESCUELA MARIO AQUILES RODRIGUEZ', value: '686' },
  { text: 'ESCUELA DE HUANTA', value: '687' },
  { text: 'ESCUELA DE CHAPILCA', value: '688' },
  { text: 'ESCUELA DE VARILLAR', value: '689' },
  { text: 'ESCUELA MUNICIPAL CIELO CLARO--PAIHUANO', value: '691' },
  { text: 'ESCUELA JERONIMO GODOY VILLANUEVA', value: '692' },
  { text: 'ESCUELA MUNICIPAL QUEBRADA DE PAIHUANO', value: '693' },
  { text: 'ESCUELA GABRIELA MISTRAL', value: '694' },
  { text: 'ESCUELA MUNICIPAL TRES CRUCES', value: '695' },
  { text: 'ESCUELA MUNICIPAL LA ORTIGA', value: '696' },
  { text: 'ESCUELA MUNICIPAL ALCOHUAZ', value: '697' },
  { text: 'ESCUELA MARIA ISABEL PERALTA P.', value: '699' },
  { text: 'LICEO ESTELA AVILA DE PERRY', value: '701' },
  { text: 'LICEO ALEJANDRO ALVAREZ JOFRE', value: '704' },
  { text: 'COLEGIO FRAY JORGE', value: '706' },
  { text: 'ESCUELA BASICA HELENE LANG', value: '707' },
  { text: 'ESCUELA ANTONIO TIRADO LANAS', value: '708' },
  { text: 'ESCUELA BASICA OSCAR ARAYA MOLINA', value: '709' },
  { text: 'ESCUELA BASICA JOSE TOMAS OVALLE B.', value: '710' },
  { text: 'ESCUELA GUARDIAMARINA ERNESTO RIQUELME V', value: '711' },
  { text: 'ESCUELA B\u00c3\u0081SICA ARTURO ALESSANDRI PALMA', value: '712' },
  { text: 'ESCUELA ARTURO VILLALON SIEULANNE', value: '713' },
  { text: 'ESCUELA BASICA VISTA HERMOSA', value: '714' },
  {
    text: 'ESCUELA BASICA BERNARDO O\u00c2\u00a6HIGGINS RIQUELME',
    value: '715',
  },
  { text: 'ESC.PADRE JOSEPH BENEDIKT STEGMEIER', value: '716' },
  { text: 'ESCUELA MARCOS MACUADA OGALDE', value: '718' },
  { text: 'COLEGIO YUNGAY', value: '719' },
  { text: 'ESCUELA BASICA FLORENCIO ESPINOZA LOPEZ', value: '721' },
  { text: 'ESC. HEBERTO VELAZQUEZ VELAZQUEZ', value: '722' },
  { text: 'ESCUELA VILLORRIO EL TALHUEN', value: '723' },
  { text: 'ESCUELA BASICA CALETA EL MAITEN', value: '724' },
  { text: 'ESCUELA EL CRISOL', value: '725' },
  { text: 'ESCUELA LA PALOMA', value: '727' },
  { text: 'ESCUELA EL ALGARROBO', value: '728' },
  { text: 'ESCUELA BASICA LOS OLIVOS', value: '729' },
  { text: 'ESCUELA BASICA LUCIA NUNEZ DE LA CUADRA', value: '730' },
  { text: 'ESCUELA EL TRAPICHE', value: '731' },
  { text: 'ESCUELA PADRE DAMIAN HEREDIA', value: '733' },
  { text: 'ESCUELA LA QUIROGA', value: '735' },
  { text: 'ESCUELA BASICA LOS SOSSAS', value: '736' },
  { text: 'ESCUELA BASICA VALENTIN LETELIER', value: '737' },
  { text: 'ESCUELA PEDRO ENRIQUE ALFONSO BARRIOS', value: '740' },
  { text: 'ESCUELA CARACHILLA', value: '743' },
  { text: 'ESCUELA ORURO', value: '744' },
  { text: 'ESCUELA LA HIGUERA DE PALOMA', value: '745' },
  { text: 'ESCUELA EL SAUCE', value: '746' },
  { text: 'ESCUELA CERRO TAMAYA', value: '747' },
  { text: 'ESCUELA TRANQUE RECOLETA', value: '749' },
  { text: 'ESCUELA ELVIRA DEL CARMEN OCHOA  AVILES', value: '750' },
  { text: 'ESCUELA VALLE HERMOSO', value: '752' },
  { text: 'ESC.BAS.JUAN PABLO ARTIGUES PENAFIEL', value: '753' },
  { text: 'ESCUELA LA ARAUCANA', value: '754' },
  { text: 'ESCUELA CANELILLA', value: '755' },
  { text: 'ESCUELA SANTA CATALINA', value: '756' },
  { text: 'ESCUELA BASICA EL GUINDO', value: '757' },
  { text: 'ESCUELA CORDILLERA', value: '758' },
  { text: 'ESCUELA BASICA GASPAR CABRALES', value: '759' },
  { text: 'ESCUELA LAS LOMAS DE PUNILLA', value: '760' },
  { text: 'ESCUELA CALETA EL TORO', value: '762' },
  { text: 'COLEGIO SAN JUAN BAUTISTA', value: '763' },
  { text: 'COLEGIO SANTA MARIA EUFRASIA', value: '766' },
  { text: 'COLEGIO PARTICULAR GABRIELA MISTRAL', value: '767' },
  { text: 'COLEGIO LA PROVIDENCIA', value: '768' },
  { text: 'ESCUELA PARTICULAR EL ARRAYAN', value: '771' },
  { text: 'LICEO AGRICOLA DE OVALLE TADEO PERRY BARN', value: '772' },
  { text: 'ESCUELA SAMO ALTO', value: '773' },
  { text: 'COLEGIO PICHASCA', value: '774' },
  { text: 'ESCUELA BASICA DE FUNDINA', value: '775' },
  { text: 'ES.BAS.SAN PEDRO DE RIO HURTADO', value: '776' },
  { text: 'ESC.BASICA  HIJOS DE EL CHANAR', value: '777' },
  { text: 'ESCUELA BASICA LAS BREAS', value: '778' },
  { text: 'ESCUELA BASICA TABAQUEROS', value: '780' },
  { text: 'ESCUELA DOCTOR JOSE LUIS ARRANO', value: '783' },
  { text: 'ESCUELA BASICA  HUAMPULLA', value: '784' },
  { text: 'ESCUELA BASICA LOS MAITENES DE SAMO ALTO', value: '785' },
  { text: 'ESCUELA BASICA  LA HUERTA', value: '786' },
  { text: 'ESCUELA BASICA MORRILLOS', value: '787' },
  { text: 'ESCUELA BASICA VADO DE MORRILLOS', value: '788' },
  { text: 'ESCUELA EL ESPINAL DE RIO HURTADO', value: '789' },
  { text: 'ESCUELA BASICA EL ROMERAL', value: '790' },
  { text: 'ESCUELA BASICA  ESTANCIA EL SAUCE', value: '792' },
  { text: 'ESCUELA BASICA DE  SERON', value: '793' },
  { text: 'ESC.BASICA DOMINGO SANTA MARIA GONZALEZ', value: '795' },
  { text: 'ESCUELA LOS MAITENES DE SERON', value: '797' },
  { text: 'ESCUELA EL PALQUI', value: '798' },
  { text: 'COLEGIO REPUBLICA DE CHILE', value: '799' },
  { text: 'ESCUELA HUATULAME', value: '800' },
  { text: 'LICEO PRESIDENTE EDUARDO FREI MONTALVA', value: '802' },
  { text: 'ESC.CONCENTRACION FRONTERIZA DE TULAHUEN', value: '803' },
  { text: 'ESCUELA BASICA WENCESLAO VARGAS', value: '804' },
  { text: 'ESCUELA EL MAQUI', value: '805' },
  { text: 'ESCUELA FRONTERA LAS RAMADAS', value: '806' },
  { text: 'ESCUELA EL MAITEN', value: '807' },
  { text: 'ESCUELA DE HUANILLA', value: '809' },
  { text: 'ESCUELA CENTRAL HIDROELECTRICA LOS MOLLE', value: '810' },
  { text: 'ESCUELA SOL DE LAS PRADERAS', value: '812' },
  { text: 'ESCUELA BASICA LA UNION', value: '813' },
  { text: 'ESCUELA BASICA EL TAYAN', value: '814' },
  { text: 'ESCUELA GUSTAVO CONTRERAS CASTRO', value: '816' },
  { text: 'ESCUELA NUEVA ESPERANZA DE PEJERREYES', value: '817' },
  { text: 'ESCUELA LOS CLONQUIS', value: '818' },
  { text: 'ESCUELA BUENAVENTURA', value: '819' },
  { text: 'ESCUELA SOL DEL CUYANO', value: '820' },
  { text: 'ESCUELA DE FLOR DEL VALLE', value: '821' },
  { text: 'ESCUELA JUNTAS', value: '822' },
  { text: 'ESCUELA BASICA COLLIGUAY', value: '823' },
  { text: 'ESCUELA HEROES DE CHILE', value: '824' },
  { text: 'ESCUELA BASICA PABLO NERUDA', value: '825' },
  { text: 'ESCUELA BASICA HACIENDA VALDIVIA', value: '826' },
  { text: 'COLEGIO RIO GRANDE', value: '827' },
  { text: 'ESCUELA MARCELA PAZ', value: '830' },
  { text: 'ESCUELA VALLE NEVADO', value: '831' },
  { text: 'ESCUELA SANTA BERNARDITA', value: '833' },
  { text: 'ESCUELA SARGENTO CANDELARIA PEREZ', value: '834' },
  { text: 'ESCUELA CARMELA PRAT', value: '835' },
  { text: 'ESCUELA INES DE SUAREZ', value: '836' },
  { text: 'ESCUELA ESPERANZA DE HUANA', value: '837' },
  { text: 'ESCUELA PROFESOR MANUEL ORTIZ QUINTANA', value: '838' },
  { text: 'ESCUELA CHILECITO', value: '839' },
  { text: 'ESCUELA OMAR ELORZA SMITH', value: '840' },
  { text: 'ESCUELA PULPICA', value: '841' },
  { text: 'ESCUELA LOS PERALES DE CAMPANARIO', value: '843' },
  { text: 'ESCUELA PARTICULAR CERRILLOS DE RAPEL', value: '844' },
  { text: 'LICEO SAMUEL ROMAN ROJAS', value: '845' },
  { text: 'ESCUELA BASICA AMERICA', value: '847' },
  { text: 'ESCUELA ALEJANDRO CHELEN ROZAS', value: '848' },
  { text: 'ESCUELA BASICA JUANITA FERNANDEZ SOLAR', value: '849' },
  { text: 'ESCUELA JUAN LUIS SAN FUENTES', value: '850' },
  { text: 'ESCUELA BASICA ARTURO PEREZ CANTO', value: '851' },
  { text: 'ESCUELA BASICA PEDRO DE VALDIVIA', value: '852' },
  { text: 'ESCUELA RAFAEL SOTOMAYOR', value: '854' },
  { text: 'ESCUELA IRENE MORALES', value: '856' },
  { text: 'ESCUELA LOS MORALES', value: '857' },
  { text: 'ESCUELA REBECA MATTE DE INIGUEZ', value: '859' },
  { text: 'ESCUELA BASICA MANUEL BAQUEDANO', value: '861' },
  { text: 'ESCUELA ESTRELLA DE BELEN', value: '862' },
  { text: 'ESCUELA BASICA ALBERTO ORREGO LUCO', value: '864' },
  { text: 'ESCUELA BASICA DANIEL BARROS GREZ', value: '865' },
  { text: 'ESCUELA BASICA OSCAR CASTRO ZUNIGA', value: '866' },
  { text: 'ESCUELA AMERICA DE SUR', value: '868' },
  { text: 'ESCUELA BASICA REBECA PONCE DE LEON V.', value: '869' },
  { text: 'ESCUELA BASICA CAMILO HENRIQUEZ GONZALEZ', value: '870' },
  { text: 'ESCUELA BASICA LUIS ENRIQUE BOU PEREZ', value: '871' },
  { text: 'ESCUELA BASICA ROSITA OHIGGINS', value: '872' },
  { text: 'ESCUELA BASICA LAURITA VICUNA', value: '874' },
  { text: 'ESCUELA BASICA PEDRO LIRA RENCORET', value: '875' },
  { text: 'ESCUELA BASICA CLAUDIO MATTE', value: '876' },
  { text: 'ESCUELA JOSE JOAQUIN VALLEJOS', value: '878' },
  { text: 'ESCUELA BASICA BENJAMIN VICUNA MACKENNA', value: '879' },
  { text: 'ESCUELA CINCO DE ABRIL', value: '882' },
  { text: 'ESCUELA BASICA SAN LUIS AMIGO Y FERRER', value: '883' },
  { text: 'ESCUELA BASICA JUAN FRANCISCO GONZALEZ', value: '884' },
  { text: 'ESCUELA LA VARIOLA', value: '886' },
  { text: 'ESCUELA BASICA CAUPOLICAN', value: '887' },
  { text: 'ESCUELA BASICA BOSQUE DE QUILLAY', value: '888' },
  { text: 'ESCUELA BASICA PAUL HARRIS', value: '889' },
  { text: 'ESCUELA PARTICULAR LOS SAPOS', value: '890' },
  { text: 'ESCUELA PARTICULAR RINCON DE LAS CHILCAS', value: '891' },
  { text: 'ESCUELA PARTICULAR EL DURAZNO', value: '892' },
  { text: 'ESCUELA PARTICULAR LA COLORADA', value: '896' },
  { text: 'ESCUELA BELGICA', value: '897' },
  { text: 'ESCUELA LUZ DE LUNA', value: '899' },
  { text: 'ESCUELA BASICA LA HIGUERA DE QUILE', value: '900' },
  { text: 'ESCUELA BASICA EL TABACO', value: '902' },
  { text: 'ESCUELA CAMPO LINDO', value: '904' },
  { text: 'ESCUELA CHALINGA', value: '905' },
  { text: 'ESCUELA LOS CANELOS', value: '906' },
  { text: 'ESCUELA HIJOS DEL PERAL', value: '907' },
  { text: 'ESCUELA TABALI', value: '908' },
  { text: 'ESCUELA LOS AZAHARES DE CERRO BLANCO', value: '909' },
  { text: 'ESC.BASICA SAN ANTONIO DE LA VILLA', value: '910' },
  { text: 'ESCUELA LOS TRIGOS', value: '911' },
  { text: 'ESCUELA PENA BLANCA', value: '914' },
  { text: 'ESCUELA MARCOS RIGOBERTO  PIZARRO ARAYA', value: '915' },
  { text: 'ESCUELA BARRAZA BAJO', value: '916' },
  { text: 'ESCUELA RINCON DE LA CALERA', value: '917' },
  { text: 'ESCUELA BASICA LAS NIPAS', value: '922' },
  { text: 'ESCUELA EL MAQUI DE QUILE', value: '923' },
  { text: 'ESCUELA LOS ACACIOS', value: '924' },
  { text: 'ESCUELA BASICA VILLA LOS QUILES', value: '925' },
  { text: 'ESCUELA ALTAR ALTO', value: '926' },
  { text: 'ESCUELA BASICA GRANEROS', value: '928' },
  { text: 'ESCUELA LOS NOGALES', value: '929' },
  { text: 'ESCUELA SAN ANTONIO DE PADUA', value: '931' },
  { text: 'ESCUELA UNION CAMPESINA', value: '932' },
  { text: 'ESCUELA LAS CRUCES', value: '933' },
  { text: 'ESCUELA BEATRIZ VEGA VEGA', value: '934' },
  { text: 'ESCUELA SALALA', value: '935' },
  { text: 'ESCUELA EL ESPINAL', value: '936' },
  { text: 'ESCUELA ALCONES BAJOS', value: '937' },
  { text: 'ESCUELA ALMENDRO DE QUILE', value: '939' },
  { text: 'ESCUELA SAN PEDRO', value: '940' },
  { text: 'ESCUELA PADRE PABLO DIEHL HARTMAN', value: '943' },
  { text: 'ESCUELA SOL NACIENTE', value: '945' },
  { text: 'ESCUELA TERESITA DE LOS ANDES', value: '946' },
  { text: 'ESCUELA AURORA DE CHILE', value: '947' },
  { text: 'ESCUELA BASICA LAS AGUILAS', value: '948' },
  { text: 'ESCUELA EL DURAZNO DE QUILE', value: '949' },
  { text: 'ESCUELA LA CEBADAS', value: '950' },
  { text: 'ESCUELA LA CALERA DE SAN JULIAN', value: '951' },
  { text: 'ESCUELA BASICA LOS CIENAGOS', value: '952' },
  { text: 'ESCUELA PATRICIO ZEBALLOS', value: '953' },
  { text: 'ESCUELA EL AJIAL DE QUILE', value: '954' },
  { text: 'ESCUELA VILLA LOS CORRALES', value: '955' },
  { text: 'ESCUELA PORTEZUELOS BLANCOS', value: '956' },
  { text: 'ESCUELA EL CIENAGO', value: '957' },
  { text: 'COLEGIO PARTICULAR SALI HOCHSCHILD', value: '959' },
  { text: 'ESCUELA PARTICULAR EL LLANITO', value: '960' },
  { text: 'ESCUELA ALGARROBO DE HORNILLOS', value: '962' },
  { text: 'ESCUELA PARTICULAR EL TENIENTE', value: '963' },
  { text: 'ESCUELA BASICA MUNICIPAL DE ADULTOS', value: '964' },
  { text: 'LICEO POLITECNICO PABLO RODRIGUEZ CAVIEDES', value: '968' },
  { text: 'ESCUELA BASICA VALLE DEL CHOAPA', value: '969' },
  { text: 'ESCUELA JUAN CARRASCO RISCO', value: '970' },
  { text: 'ESCUELA BASICA SAN RAFAEL DE ROZAS', value: '971' },
  { text: 'ESCUELA BASICA JORGE ARACENA RAMOS', value: '972' },
  { text: 'ESCUELA BASICA CLEMENCIA VILLARROEL', value: '973' },
  { text: 'ESCUELA BASICA CAMILO HENRIQUEZ', value: '974' },
  { text: 'ESCUELA BASICA LAS PALMERAS DE LIMAHUIDA', value: '976' },
  { text: 'ESCUELA BASICA GRACIELA DIAZ ALLENDE', value: '977' },
  { text: 'ESCUELA BASICA MATANCILLA', value: '978' },
  { text: 'ESCUELA BASICA CHOAPA LINDO', value: '981' },
  { text: 'ESCUELA BASICA VILLA LOS NARANJOS', value: '982' },
  { text: 'ESCUELA BASICA LAS LILAS DE TUNGA NORTE', value: '983' },
  { text: 'ESCUELA BASICA TUNGA SUR', value: '984' },
  { text: 'ESCUELA BASICA ASIENTO VIEJO', value: '985' },
  { text: 'ESCUELA BASICA LAS CHINCHILLAS DE COCOU', value: '986' },
  { text: 'COLEGIO SANTA TERESA', value: '987' },
  { text: 'LICEO PARTICULAR LUIS ALBERTO VERA', value: '988' },
  { text: 'ESCUELA PARTICULAR LAS CANAS', value: '990' },
  { text: 'ESCUELA PARTICULAR QUEBRADA EL PERAL', value: '991' },
  { text: 'ESCUELA PARTICULAR CANELILLO ALTO', value: '993' },
  { text: 'ESCUELA PARTICULAR RINCON DEL ROMERO', value: '994' },
  { text: 'ESCUELA PARTICULAR CAREN', value: '995' },
  { text: 'ESCUELA PARTICULAR EL LANCO', value: '996' },
  { text: 'ESCUELA PARTICULAR QUEBRADA DE CARCAMO', value: '997' },
  { text: 'ESCUELA PARTICULAR ILTA', value: '998' },
  { text: 'ESCUELA PARTICULAR 18 DE SEPTIEMBRE', value: '999' },
  { text: 'ESCUELA PARTICULAR HERMINIA RAMOS', value: '1001' },
  { text: 'ESCUELA PARTICULAR EL SOCAVON', value: '1002' },
  { text: 'ESCUELA PARTICULAR SAN ROMUALDO', value: '1003' },
  { text: 'ESCUELA PARTICULAR LA CAPILLA', value: '1004' },
  { text: 'ESCUELA PARTICULAR RINCON DE TUNGA', value: '1005' },
  { text: 'ESCUELA MANUEL JOSE IRARRAZAVAL', value: '1006' },
  { text: 'ESCUELA PARTICULAR CANAS DE MICHIO', value: '1007' },
  { text: 'ESCUELA PARTICULAR QUILLAICILLO', value: '1008' },
  { text: 'ESCUELA PARTICULAR CUYUNTAGUA', value: '1010' },
  { text: 'ESCUELA PARTICULAR MACUCO', value: '1011' },
  { text: 'LICEO DE SALAMANCA', value: '1013' },
  { text: 'ESCUELA MATILDE SALAMANCA', value: '1014' },
  { text: 'ESCUELA BASICA DIAGUITAS DE CHALINGA', value: '1015' },
  { text: 'ESCUELA TRANQUILLA', value: '1016' },
  { text: 'ESCUELA BASICA BERTA HIDALGO BARAHONA', value: '1017' },
  { text: 'ESCUELA EL TAMBO', value: '1018' },
  { text: 'ESCUELA BASICA  CHILLEPIN', value: '1019' },
  { text: 'ESCUELA BASICA GUISELA GAMBOA SALINAS', value: '1020' },
  { text: 'ESCUELA ZAPALLAR', value: '1021' },
  { text: 'ESCUELA COIRON', value: '1022' },
  { text: 'ESCUELA BASICA QUELEN BAJO', value: '1027' },
  { text: 'ESC.BASICA GUILLERMO BARRIOS VARGAS', value: '1030' },
  { text: 'ESCUELA BASICA JULIO ECHAVARRIA', value: '1031' },
  { text: 'ESCUELA BASICA SAN AGUSTIN', value: '1032' },
  { text: 'ESCUELA BASICA PANGUESILLO', value: '1033' },
  { text: 'ESCUELA LOS CORRALES', value: '1034' },
  { text: 'COLEGIO PARTICULAR SAN FRANCISCO DE ASIS', value: '1036' },
  { text: 'ESCUELA PARTICULAR HUANQUE', value: '1037' },
  { text: 'ESCUELA PARTICULAR EL PALQUIAL', value: '1038' },
  { text: 'ESCUELA PARTICULAR LAS JARILLAS', value: '1040' },
  { text: 'ESCUELA PARTICULAR CAJON DE QUELEN', value: '1041' },
  { text: 'ESCUELA MUNICIPAL COLLIGUAY', value: '1042' },
  { text: 'ESCUELA PARTICULAR MANQUEHUA', value: '1044' },
  { text: 'ESCUELA PARTICULAR PUNTA NUEVA', value: '1045' },
  { text: 'ESCUELA PARTICULAR PLANTA PELADEROS', value: '1046' },
  { text: 'ESCUELA PARTICULAR VALLE CAMISAS', value: '1047' },
  { text: 'COLEGIO DIEGO DE ALMAGRO', value: '1049' },
  { text: 'ESCUELA BASICA ERCOLE BENCINI', value: '1050' },
  { text: 'ESCUELA BASICA TERESA CANNON DE B.', value: '1051' },
  { text: 'ESCUELA BASICA PABLO BARRIOLHET', value: '1052' },
  { text: 'ESCUELA BASICA FORJADORES DE CHILE', value: '1053' },
  { text: 'ESCUELA LOS MAQUIS', value: '1055' },
  { text: 'ESCUELA CLARA VIAL ORREGO', value: '1059' },
  { text: 'ESCUELA TILAMA', value: '1061' },
  { text: 'ESC.PDTE.FEDERICO ERRAZURIZ ECHAURREN', value: '1062' },
  { text: 'ESCUELA', value: '1063' },
  { text: 'ESCUELA BASICA EL QUELON', value: '1064' },
  { text: 'ESCUELA BASICA EL MANZANO', value: '1065' },
  { text: 'ESCUELA PARTICULAR DIVINA PROVIDENCIA', value: '1066' },
  { text: 'ESCUELA PARTICULAR CULIMO', value: '1068' },
  { text: 'ESCUELA PARTICULAR MINA LAS VACAS', value: '1069' },
  { text: 'ESCUELA PARTICULAR PUPIO', value: '1070' },
  { text: 'ESCUELA PARTICULAR EL ROMERO', value: '1071' },
  { text: 'ESCUELA PARTICULAR INFIERNILLO', value: '1072' },
  { text: 'ESCUELA PARTICULAR EL RINCON', value: '1073' },
  { text: 'ESCUELA PARTICULAR MAIMALICAN', value: '1076' },
  { text: 'ESCUELA MUNICIPAL CANELA BAJA', value: '1077' },
  { text: 'ESCUELA BASICA JUAN ANTONIO RIOS', value: '1078' },
  { text: 'ESC.BASICA JOSE ANTONIO ECHAVARRIA', value: '1080' },
  { text: 'ESC.BASICA EUSEBIO LILLO ROBLES', value: '1081' },
  { text: 'ESC.BASICA MERCEDES MARIN DEL SOLAR', value: '1082' },
  { text: 'ESCUELA BASICA CARQUINDANO', value: '1083' },
  { text: 'ESCUELA BASICA JABONERIA', value: '1084' },
  { text: 'ESCUELA BASICA PABLO NERUDA', value: '1085' },
  { text: 'ESCUELA BASICA MARIANO LATORRE', value: '1086' },
  { text: 'ESCUELA BASICA CANELA ALTA', value: '1087' },
  { text: 'ESC.BASICA CARLOS IBANEZ DEL CAMPO', value: '1090' },
  { text: 'ESCUELA BASICA MINCHA NORTE', value: '1092' },
  { text: 'ESCUELA BASICA ATELCURA ALTA', value: '1093' },
  { text: 'ESCUELA BASICA POZA HONDA', value: '1094' },
  { text: 'ESCUELA BASICA SARGENTO ALDEA', value: '1095' },
  { text: 'ESCUELA BASICA  LOS POZOS', value: '1096' },
  { text: 'ESCUELA BASICA ESPIRITU SANTO', value: '1097' },
  { text: 'ESCUELA VIOLETA PARRA', value: '1099' },
  { text: 'ESC.BASICA CARLOS VIAL ESPANTOSO', value: '1100' },
  { text: 'ESCUELA BASICA JOSE MIGUEL CARRERA', value: '1101' },
  { text: 'ESCUELA BASICA  BALDOMERO LILLO FIGUEROA', value: '1102' },
  { text: 'ESCUELA LA CORTADERA', value: '1104' },
  { text: 'ESCUELA BASICA MARTA BRUNETT', value: '1108' },
  { text: 'ESCUELA BASICA GABRIELA MISTRAL', value: '1109' },
  { text: 'ESCUELA PARTICULAR EL POTRERO', value: '1112' },
  { text: 'ESCUELA BASICA SALVADOR REYES', value: '1113' },
  { text: 'ESCUELA PARTICULAR EL CHILCAL', value: '1114' },
  { text: 'ESCUELA PARTICULAR CANELILLA', value: '1116' },
  { text: 'ESCUELA PARTICULAR LOS TOMES', value: '1117' },
  { text: 'COLEGIO PARTICULAR SANTA MARIA', value: '1119' },
  { text: 'CENTRO DE EDUCACION DE ADULTOS LA LIGUA', value: '1120' },
  { text: 'LICEO PULMAHUE DE LA LIGUA', value: '1121' },
  { text: 'ESCUELA REPUBLICA DE VENEZUELA', value: '1122' },
  { text: 'ESCUELA GABRIELA MISTRAL', value: '1123' },
  { text: 'ESCUELA DIEGO PORTALES', value: '1125' },
  { text: 'ESCUELA ESPECIAL SOL NACIENTE', value: '1126' },
  { text: 'ESCUELA COMUNIDADES DE VALLE HERMOSO', value: '1128' },
  { text: 'ESCUELA ANGEL MENAY', value: '1129' },
  { text: 'ESC. BASICA LOS HORNOS DE HUAQUEN', value: '1130' },
  { text: 'ESC. BASICA CASAS VIEJAS DE LONGOTOMA', value: '1131' },
  { text: 'ESCUELA BASICA POZA VERDE', value: '1132' },
  { text: 'ESC.BASICA LAS CASAS DE HUAQUEN', value: '1133' },
  { text: 'CARMEN SANCHEZ ARAYA', value: '1134' },
  { text: 'ESCUELA BASICA LOS MOLLES', value: '1135' },
  { text: 'ESCUELA BASICA PUYANCON', value: '1136' },
  { text: 'ESCUELA BASICA HORTENCIA POWELL S.', value: '1137' },
  { text: 'ESCUELA MINISTRO GOMEZ MILLAS', value: '1139' },
  { text: 'ESCUELA BASICA CARLOS ARIZTIA RUIZ', value: '1140' },
  { text: 'ESCUELA LA CANELA', value: '1142' },
  { text: 'ESCUELA BASICA QUEBRADILLA', value: '1143' },
  { text: 'ESCUELA BASICA PICHICUY', value: '1144' },
  { text: 'ESCUELA ENRIQUE DOLL ROJAS', value: '1145' },
  { text: 'ESCUELA FERNANDO GARCIA OLDINI', value: '1147' },
  { text: 'LICEO JOSE MANUEL BORGONO NUNEZ', value: '1148' },
  { text: 'LICEO CORDILLERA', value: '1149' },
  { text: 'ESCUELA BASICA NEFTALI REYES B.', value: '1150' },
  { text: 'ESCUELA BASICA VILLA SANTA ANA', value: '1151' },
  { text: 'ESCUELA EDUARDO FREI MONTALVA', value: '1152' },
  { text: 'ESCUELA BASICA EL CRUCERO', value: '1153' },
  { text: 'ESCUELA RAUL ESCOBAR VARAS', value: '1154' },
  { text: 'ESCUELA BASICA G-24', value: '1156' },
  { text: 'ESCUELA BASICA LOS ALAMOS  EL SOBRANTE', value: '1157' },
  { text: 'ESCUELA BASICA BENANCIO PEREZ', value: '1158' },
  { text: 'ESCUELA HOGAR FRONTERIZA DE CHALACO', value: '1160' },
  { text: 'ESCUELA BASICA PEDEGUA', value: '1161' },
  { text: 'ESCUELA PARTICULAR JUAN PABLO II', value: '1162' },
  { text: 'COL. CATOLICO  PDTE.MANUEL MONTT', value: '1164' },
  { text: 'COLEGIO SAGRADO CORAZON', value: '1166' },
  { text: 'LICEO Y ESCUELA MUNICIPAL', value: '1167' },
  { text: 'ESCUELA HANS WENKE MENGERS', value: '1168' },
  { text: 'ESCUELA BASICA VALLE DE ARTIFICIO', value: '1170' },
  { text: 'ESCUELA BASICA LA FRONTERA DE ALICAHUE', value: '1171' },
  { text: 'ESCUELA ESTER SILVA SOMARRIVA BARTOLILLO', value: '1173' },
  { text: 'ESCUELA BASICA SAN LORENZO', value: '1174' },
  { text: 'ESCUELA LOS MOLINOS', value: '1176' },
  { text: 'ESCUELA BASICA LA VINA', value: '1178' },
  { text: 'ESCUELA BASICA G-45', value: '1180' },
  { text: 'ESCUELA BASICA LOS ANGELES', value: '1181' },
  { text: 'ESCUELA BASICA G-47', value: '1182' },
  { text: 'LICEO DE ZAPALLAR', value: '1183' },
  { text: 'ESCUELA BASICA MERCEDES MATURANA GALLARDO', value: '1184' },
  { text: 'ESCUELA BALNEARIO CACHAGUA', value: '1185' },
  { text: 'ESCUELA RURAL CRUCE FUTAHUENTE', value: '1189' },
  { text: 'ESCUELA PAPUDO', value: '1191' },
  { text: 'ESCUELA RURAL PULLALLY', value: '1192' },
  { text: 'LICEO TECNICO AMANCAY', value: '1196' },
  { text: 'ESCUELA ESPANA', value: '1197' },
  { text: 'LICEO DE NINAS REPUBLICA ARGENTINA', value: '1198' },
  { text: 'LICEO DE HOMBRES AMERICA', value: '1199' },
  { text: 'ESCUELA JOHN KENNEDY', value: '1200' },
  { text: 'ESCUELA ESPECIAL VALLE ANDINO', value: '1201' },
  { text: 'ESCUELA BASICA F-128', value: '1202' },
  { text: 'ESCUELA GABRIELA MISTRAL', value: '1203' },
  { text: 'ESCUELA BASICA GRAL.JOSE MIGUEL CARRERA', value: '1204' },
  { text: 'C.E.I.A  DR. OSVALDO ROJAS GONZALEZ', value: '1206' },
  { text: 'ESCUELA BASICA RIO BLANCO', value: '1208' },
  { text: 'ESCUELA EL SAUCE', value: '1210' },
  { text: 'ESCUELA IGNACIO CARRERA PINTO', value: '1211' },
  { text: 'ESCUELA JUAN GOMEZ MILLAS', value: '1212' },
  { text: 'LICEO PARTICULAR MIXTO LOS ANDES', value: '1213' },
  { text: 'COLEGIO MARIA AUXILIADORA', value: '1214' },
  { text: 'ESCUELA PARTICULAR SAN JOSE', value: '1215' },
  { text: 'ESCUELA PARTICULAR HUMBERTO CASARINO', value: '1216' },
  { text: 'LICEO SANTA CLARA', value: '1217' },
  { text: 'ESCUELA PARTICULAR JEAN PIAGET', value: '1218' },
  { text: 'ESCUELA PARTICULAR METODISTA E.DEL NINO', value: '1220' },
  { text: 'COLEGIO  ALCAZAR', value: '1221' },
  { text: 'COLEGIO PARTICULAR BREGA COLLEGE', value: '1229' },
  { text: 'ESCUELA BASICA REPUBLICA DEL BRASIL', value: '1233' },
  { text: 'ESC. BASICA SILVIO ZENTENO VERGARA', value: '1234' },
  { text: 'ESCUELA LO CALVO', value: '1235' },
  { text: 'ESCUELA PADRE ALBERTO MUNOZ', value: '1237' },
  { text: 'ESCUELA INCLUSIVA SAN LORENZO', value: '1238' },
  { text: 'ESCUELA HERMANO FERNANDO DE LA FUENTE', value: '1239' },
  { text: 'ESCUELA RIO COLORADO', value: '1240' },
  { text: 'ESCUELA EL COBRE', value: '1243' },
  { text: 'ESCUELA SAN FRANCISCO', value: '1244' },
  { text: 'ESCUELA EL CORAZON', value: '1245' },
  { text: 'ESCUELA EL HIGUERAL', value: '1246' },
  { text: 'ESCUELA BASICA MARIA ISABEL DE BROWN', value: '1247' },
  { text: 'ESCUELA BASICA LA PAMPILLA', value: '1248' },
  { text: 'ESCUELA BASICA PEDRO AGUIRRE CERDA', value: '1249' },
  { text: 'ESCUELA VICTOR KOERNER', value: '1250' },
  { text: 'ESCUELA BASICA CRISTO REDENTOR', value: '1251' },
  { text: 'ESCUELA BASICA VALLE ALEGRE', value: '1252' },
  { text: 'INSTITUTO AGRICOLA PASCUAL BABURIZZA', value: '1255' },
  { text: 'COLEGIO PARTICULAR SAN JOSE', value: '1256' },
  { text: 'ESCUELA PERFECTO DE LA FUENTE DEL VILLAR', value: '1257' },
  { text: 'ESCUELA BASICA EMIGDIO GALDAMES ROBLES', value: '1258' },
  { text: 'ESCUELA BASICA MANUEL LEON SALINAS', value: '1259' },
  { text: 'LICEO PARROQUIAL TERESITA DE LOS ANDES', value: '1260' },
  { text: 'LICEO DOCTOR ROBERTO HUMERES O.', value: '1261' },
  { text: 'LICEO INDUSTRIAL GUILLERMO RICHARDS CUEVA', value: '1262' },
  { text: 'LICEO DE NINAS CORINA URBINA', value: '1263' },
  { text: 'LICEO SAN FELIPE', value: '1264' },
  { text: 'ESCUELA BASICA BERNARDO O HIGGINS R.', value: '1265' },
  { text: 'ESCUELA MANUEL RODRIGUEZ ERDOIZA', value: '1266' },
  { text: 'ESCUELA BASICA JOSE DE SAN MARTIN', value: '1268' },
  { text: 'ESCUELA JOHN F KENNEDY', value: '1269' },
  { text: 'ESCUELA JOS\u00c3\u2030 ANTONIO MANSO DE VELASCO', value: '1271' },
  { text: 'ESCUELA SAN RAFAEL', value: '1273' },
  { text: 'ESCUELA ALMENDRAL', value: '1274' },
  { text: 'ESCUELA BUEN PASTOR', value: '1275' },
  { text: 'ESCUELA ESPECIAL SAGRADO CORAZON', value: '1276' },
  { text: 'ESCUELA CARMELA CARVAJAL DE PRAT', value: '1279' },
  { text: 'ESCUELA 21 DE MAYO', value: '1280' },
  { text: 'ESCUELA REPUBLICA ARGENTINA', value: '1281' },
  { text: 'ESCUELA BUCALEMITO', value: '1282' },
  { text: 'ESCUELA HERIBERTO BERMUDEZ CRUZ', value: '1283' },
  { text: 'ESCUELA MATEO COKLJAT K', value: '1285' },
  { text: 'ESCUELA BASICA CAROLINA OCAMPO GARCIA', value: '1286' },
  { text: 'ESCUELA JOSE BERNARDO SUAREZ', value: '1287' },
  { text: 'COLEGIO ASSUNTA PALLOTA', value: '1289' },
  { text: 'COLEGIO SANTA JUANA DE ARCO', value: '1290' },
  { text: 'COLEGIO ALONSO DE ERCILLA', value: '1292' },
  { text: 'COLEGIO PARTICULAR PUMANQUE', value: '1294' },
  { text: 'ESCUELA AGRICOLA DE SAN FELIPE', value: '1300' },
  { text: 'LICEO MANUEL MARIN', value: '1301' },
  { text: 'LICEO   REPUBLICA DE ESTADOS UNIDOS', value: '1302' },
  { text: 'ESCUELA PASO HISTORICO EL TARTARO', value: '1304' },
  { text: 'ESCUELA RENACER', value: '1305' },
  { text: 'ESCUELA SAN ALBERTO', value: '1307' },
  { text: 'ESCUELA ALEJANDRINA CARVAJAL ASPEE', value: '1308' },
  { text: 'ESCUELA EDUARDO BECERRA BASCUNAN', value: '1309' },
  { text: 'ESCUELA MARIA LEIVA DE IBANEZ', value: '1310' },
  { text: 'ESCUELA EL AVE MARIA', value: '1311' },
  { text: 'ESC. BAS. GASTON ORMAZABAL CABRERA', value: '1312' },
  { text: 'ESCUELA CATAN DABIKE', value: '1313' },
  { text: 'ESCUELA MARIE POUSSEPIN', value: '1316' },
  { text: 'LICEO DARIO SALAS', value: '1318' },
  { text: 'ESCUELA MARIA ESPINDOLA CASTRO', value: '1319' },
  { text: 'ESCUELA GUILLERMO BANADOS HONORATO', value: '1321' },
  { text: 'ESCUELA LA HIGUERA', value: '1322' },
  { text: 'ESCUELA DAVID DEL CURTO', value: '1323' },
  { text: 'ESCUELA BASICA LAS CABRAS', value: '1325' },
  { text: 'ESCUELA JULIO TEJEDOR ZUNIGA', value: '1326' },
  { text: 'COLEGIO SANTA MARIA DE ACONCAGUA', value: '1327' },
  { text: 'ESCUELA INDEPENDENCIA', value: '1328' },
  { text: 'ESCUELA EMA LOBOS REYES', value: '1329' },
  { text: 'ESCUELA EL ESCORIAL', value: '1330' },
  { text: 'ESCUELA BASICA FRAY CAMILO HENRIQUEZ', value: '1331' },
  { text: 'ESCUELA BASICA VINA ERRAZURIZ', value: '1332' },
  { text: 'ESCUELA JORGE BARROS BEAUCHEF', value: '1333' },
  { text: 'ESCUELA AGUSTIN EDWARDS', value: '1336' },
  { text: 'ESCUELA HEROES DE IQUIQUE', value: '1337' },
  { text: 'ESCUELA NACIONES UNIDAS', value: '1338' },
  { text: 'ESCUELA ELISA LATTAPIAT VARGAS', value: '1339' },
  { text: 'ESCUELA HERMINIA ORTEGA DE CROXATO', value: '1340' },
  { text: 'ESCUELA BASICA EL PORVENIR', value: '1341' },
  { text: 'ESCUELA LAS PALMAS', value: '1342' },
  { text: 'ESCUELA LAS PENAS', value: '1343' },
  { text: 'ESCUELA ENRIQUE MEIGGS', value: '1344' },
  { text: 'ESCUELA LAS VEGAS', value: '1345' },
  { text: 'ESCUELA JORGE PRIETO LETELIER', value: '1346' },
  { text: 'LICEO MENESIANO SAGRADO CORAZON', value: '1347' },
  { text: 'COLEGIO SALVADOR GONZALEZ', value: '1349' },
  { text: 'ESC.PARTICULAR MARIA LETELIER DE PRIETO', value: '1350' },
  { text: 'ESCUELA MARIA TERESA DEL CANTO', value: '1352' },
  { text: 'ESCUELA SAN JOSE DE CATEMU', value: '1353' },
  { text: 'LICEO CHAGRES', value: '1354' },
  { text: 'ESCUELA EL COBRE', value: '1355' },
  { text: 'ESC REBECA JOHNSON GARCIA-HUIDOBRO', value: '1356' },
  { text: 'ESCUELA BASICA EL NILHUE', value: '1358' },
  { text: 'ESCUELA BASICA LOS CERRILLOS', value: '1359' },
  { text: 'ESCUELA BASICA SANTA MARGARITA', value: '1360' },
  { text: 'COLEGIO PARTICULAR CALIFORNIA', value: '1361' },
  { text: 'LICEO SANTIAGO ESCUTI ORREGO', value: '1363' },
  { text: 'LICEO CIUDAD DE QUILLOTA', value: '1364' },
  { text: 'LICEO COMERCIAL DE QUILLOTA', value: '1366' },
  { text: 'ESCUELA BASICA REPUBLICA ARGENTINA', value: '1367' },
  { text: 'ESCUELA BASICA CANADA', value: '1368' },
  { text: 'ESCUELA BASICA ABRAHAM LINCOLN', value: '1369' },
  { text: 'ESCUELA BASICA REPUBLICA DE MEXICO', value: '1370' },
  { text: 'ESCUELA BASICA ARAUCO', value: '1371' },
  { text: 'ESCUELA ESPECIAL LOS PALTOS', value: '1374' },
  { text: 'ESCUELA BASICA RAMON FREIRE', value: '1376' },
  { text: 'ESCUELA NUESTRO MUNDO', value: '1377' },
  { text: 'ESCUELA BASICA ABEL GUERRERO AGUIRRE', value: '1378' },
  { text: 'ESCUELA BASICA EL BOCO', value: '1384' },
  { text: 'ESCUELA BASICA LA PALMA', value: '1385' },
  { text: 'ESCUELA  CRISTINA DURAN', value: '1389' },
  { text: 'ESCUELA BASICA LAS PATAGUAS', value: '1390' },
  { text: 'LICEO COMERCIAL PARTICULAR', value: '1391' },
  { text: 'COLEGIO NI\u00c3\u2018O JESUS DE PRAGA', value: '1393' },
  { text: 'ESCUELA PART. SAGRADOS CORAZONES', value: '1394' },
  { text: 'COLEGIO SAN PEDRO NOLASCO DE QUILLOTA', value: '1395' },
  { text: 'COLEGIO SAN LUIS', value: '1400' },
  { text: 'CENTRO EDUCACIONAL ARCO IRIS BAJO EL SOL', value: '1402' },
  { text: 'COL.NTRA.SE\u00c3\u2018ORA DEL HUERTO', value: '1403' },
  { text: 'COLEGIO INGLES DE QUILLOTA', value: '1405' },
  { text: 'JARDIN INFANTIL OSO YOGUI', value: '1409' },
  { text: 'COLEGIO ROBERT AND ROSE', value: '1412' },
  { text: 'COLEGIO QUILLOTA ENGLISH COLLEGE', value: '1413' },
  { text: 'COLEGIO LEONARDO DA VINCI', value: '1414' },
  { text: 'ESCUELA BASICA MARIA ALONSO CHACON', value: '1416' },
  { text: 'ESCUELA  DE BOLONIA', value: '1417' },
  { text: 'ESCUELA BASICA', value: '1418' },
  { text: 'ESCUELA DOMINGO SANTA CRUZ WILSON', value: '1419' },
  { text: 'LICEO PEDRO DE VALDIVIA', value: '1422' },
  { text: 'ESCUELA BASICA JOSEFINA HUICI', value: '1423' },
  { text: 'ESCUELA BASICA IRMA SAPIAIN', value: '1424' },
  { text: 'ESCUELA BASICA LAS ACACIAS', value: '1425' },
  { text: 'ESCUELA BASICA PALESTINA', value: '1427' },
  { text: 'ESCUELA ESPECIAL JESUS DE NAZARETH', value: '1428' },
  { text: 'ESCUELA BASICA GABRIELA MISTRAL', value: '1430' },
  { text: 'ESCUELA BASICA SANTA ROSA DEL HUERTO', value: '1431' },
  { text: 'ESCUELA BASICA EL LIBERTADOR', value: '1433' },
  { text: 'ESCUELA BASICA VILLA LA FLORIDA', value: '1435' },
  { text: 'LICEO PARTICULAR SAN JOSE', value: '1436' },
  { text: 'COLEGIO SAULO DE TARSO', value: '1438' },
  { text: 'ESCUELA PARTICULAR LUCERO', value: '1440' },
  { text: 'COLEGIO JOHN CRANE', value: '1442' },
  { text: 'LICEO INDUSTRIAL A-16 OSCAR CORONA BARAHO', value: '1443' },
  { text: 'LICEO MUNICIPAL JUAN RUSQUE PORTAL', value: '1444' },
  { text: 'ESCUELA BASICA EL MELON', value: '1445' },
  { text: 'ESCUELA BASICA ULDA ARACENA GONZALEZ', value: '1447' },
  { text: 'ESCUELA BASICA LA PENA', value: '1448' },
  { text: 'LICEO FELIPE CORTES', value: '1449' },
  { text: 'COLEGIO SANTA ISABEL', value: '1450' },
  { text: 'LICEO MUNICIPAL LUIS LABORDA', value: '1453' },
  { text: 'ESCUELA ADRIANA RIQUELME NUNEZ', value: '1454' },
  { text: 'ESCUELA MONICA HURTADO EDWARDS', value: '1455' },
  { text: 'ESCUELA ANA JESUS IBACACHE', value: '1456' },
  { text: 'ESCUELA BASICA BENJAMIN MATTE LARRAIN', value: '1457' },
  { text: 'ESCUELA BASICA LA SOMBRA', value: '1458' },
  { text: 'ESCUELA BASICA RABUCO', value: '1459' },
  { text: 'ESCUELA BASICA CALIXTO OVALLE URZUA', value: '1460' },
  { text: 'ESCUELA MONTE CARMELO', value: '1461' },
  { text: 'ESCUELA BASICA LOS TILOS DE HUALCAPO', value: '1462' },
  { text: 'LICEO DE LIMACHE', value: '1464' },
  { text: 'ESCUELA COEDUC TTE HERNAN MERINO CORREA', value: '1465' },
  { text: 'ESCUELA BASICA', value: '1466' },
  { text: 'ESCUELA BASICA BRASILIA', value: '1468' },
  { text: 'ESCUELA BASICA HEROES DE CHILE', value: '1469' },
  { text: 'ESCUELA LIMACHITO', value: '1471' },
  { text: 'ESCUELA BASICA LOS MAITENES', value: '1472' },
  { text: 'ESCUELA TABOLANGO', value: '1473' },
  { text: 'ESCUELA BASICA PUENTE COLMO', value: '1474' },
  { text: 'ESC. BASICA TRANQUE LLIU LLIU', value: '1475' },
  { text: 'COLEGIO DE LA SANTA CRUZ', value: '1478' },
  { text: 'ESCUELA ROSA MARTINEZ', value: '1479' },
  { text: 'COLEGIO INGLES RELIGIOSAS PASIONISTAS', value: '1481' },
  { text: 'COLEGIO LIMACHE COLLEGE', value: '1482' },
  { text: 'ESC PART MICAELA DESMAISSIERES', value: '1483' },
  { text: 'ESCUELA PARTICULAR INST. SANTA MARIA', value: '1484' },
  { text: 'JARDIN INFANT. LAS ARDILLITAS SALTARINA', value: '1485' },
  { text: 'ESCUELA MONTEVIDEO', value: '1488' },
  { text: 'LICEO DE OLMUE', value: '1489' },
  { text: 'ESCUELA B\u00c3\u0081SICA QUEBRADA DE ALVARADO', value: '1490' },
  { text: 'ESCUELA BASICA LO NARVAEZ', value: '1491' },
  { text: 'ESCUELA LA DORMIDA', value: '1493' },
  { text: 'ESCUELA LA RAMAYANA', value: '1495' },
  { text: 'ESCUELA LAS PALMAS', value: '1496' },
  { text: 'ESCUELA LA LOMA DE LA VEGA', value: '1497' },
  { text: 'ESCUELA LAS BELLOTAS DE LA VEGA', value: '1498' },
  { text: 'COLEGIO PART. IGNACIO CARRERA PINTO', value: '1500' },
  { text: 'ESCUELA INDUSTRIAL SUPERIOR DE VALPARAISO', value: '1503' },
  {
    text: 'LICEO T\u00c3\u2030CNICO FEMENINO DE VALPARA\u00c3\u008dSO',
    value: '1504',
  },
  { text: 'CENTRO EDUCATIVO FLORIDA', value: '1506' },
  { text: 'ESCUELA ESPECIAL DE ADULTOS CARCEL', value: '1507' },
  { text: 'ESC. ESPEC. DE DEF. MENTAL GRAN BRETA_A', value: '1508' },
  { text: 'ESC. ESPEC. DE DEF. MENTAL LUZ DE ESPERANZA', value: '1509' },
  { text: 'ESC.LIB. GRAL.BERNARDO OHIGGINS R.', value: '1510' },
  { text: 'CENTRO EDUCATIVO REINO DE SUECIA', value: '1511' },
  { text: 'ESCUELA  HERNAN OLGUIN', value: '1514' },
  { text: 'LICEO MATILDE BRANDAU DE ROSS', value: '1517' },
  { text: 'LICEO MARIA LUISA BOMBAL', value: '1518' },
  { text: 'LICEO BARON', value: '1519' },
  { text: 'LICEO DE NINAS MARIA FRANCK DE MACDOUGAL', value: '1521' },
  { text: 'COLEGIO PEDRO MONTT', value: '1522' },
  { text: 'ESCUELA NACIONES UNIDAS', value: '1523' },
  { text: 'ESCUELA REPUBLICA ARABE SIRIA', value: '1524' },
  { text: 'ESCUELA REPUBLICA DEL PARAGUAY', value: '1526' },
  { text: 'ESCUELA  GASPAR CABRALES', value: '1528' },
  { text: 'ESCUELA GRECIA', value: '1529' },
  { text: 'ESCUELA ALEMANIA', value: '1533' },
  { text: 'ESCUELA REPUBLICA DEL URUGUAY', value: '1534' },
  { text: 'ESCUELA AMERICA', value: '1536' },
  { text: 'ESCUELA RAMON BARROS LUCO', value: '1537' },
  { text: 'ESCUELA JUAN JOSE LATORRE B', value: '1538' },
  { text: 'ESCUELA BLAS CUEVAS RAMON ALLENDE', value: '1540' },
  { text: 'ESCUELA REPUBLICA DE EL SALVADOR', value: '1541' },
  { text: 'ESCUELA JOAQUIN EDWARDS BELLO', value: '1542' },
  { text: 'ESCUELA JORGE ALESSANDRI RODRIGUEZ', value: '1543' },
  { text: 'ESCUELA CARABINERO PEDRO A.CARIAGA M.', value: '1547' },
  { text: 'ESCUELA DIEGO PORTALES PALAZUELOS', value: '1548' },
  { text: 'ESCUELA REPUBLICA DE MEXICO', value: '1549' },
  { text: 'ESCUELA PACIFICO', value: '1550' },
  { text: 'ESCUELA MONTEDONICO', value: '1551' },
  { text: 'ESCUELA ESPANA', value: '1553' },
  { text: 'ESCUELA REPUBLICA DE BOLIVIA', value: '1554' },
  { text: 'ESCUELA REPUBLICA DE ISRAEL', value: '1555' },
  { text: 'ESCUELA ELEUTERIO RAMIREZ', value: '1556' },
  { text: 'ESCUELA VILLA BERLIN', value: '1557' },
  { text: 'ESCUELA BASICA FEDERICO ALBERT', value: '1559' },
  { text: 'ESCUELA JUAN WACQUEZ MOURFIN', value: '1563' },
  { text: 'ESCUELA BASICA DAVID BEN GURION', value: '1567' },
  { text: 'ESCUELA REPUBLICA ARGENTINA', value: '1568' },
  { text: 'ESCUELA  PILOTO 1\u00c2\u00b0 LUIS PARDO VILLALON', value: '1569' },
  { text: 'ESCUELA BASICA CIRUJANO VIDELA', value: '1570' },
  { text: 'ESCUELA SAN JUDAS TADEO', value: '1571' },
  { text: 'ESCUELA  DR. ERNESTO QUIROZ WEBER', value: '1573' },
  { text: 'ESCUELA BASICA LAGUNA VERDE', value: '1577' },
  { text: 'ESCUELA TTE. JULIO A. ALLENDE OVALLE', value: '1578' },
  { text: 'COLEGIO LUTERANO CONCORDIA', value: '1582' },
  { text: 'COLEGIO JEANNE DARC VALPARAISO', value: '1583' },
  { text: 'COLEGIO NTRA.SRA.DE LA MISERICORDIA', value: '1588' },
  { text: 'ESCUELA PARTICULAR SANTA ANA', value: '1593' },
  { text: 'COLEGIO PARTICULAR SAN DAMIAN', value: '1594' },
  { text: 'COLEGIO ARTURO EDWARDS', value: '1595' },
  { text: 'COLEGIO SAN IGNACIO DE LOYOLA', value: '1596' },
  { text: 'ESCUELA PARTICULAR SAN LUIS', value: '1597' },
  { text: 'COLEGIO PARTICULAR ADVENTISTA', value: '1598' },
  { text: 'COLEGIO SAGRADO CORAZON DE JESUS', value: '1599' },
  { text: 'COLEGIO PATROCINIO SAN JOSE', value: '1600' },
  { text: 'ESC SAGRADA FAMILIA DE NAZARET', value: '1601' },
  { text: 'COLEGIO ESPERANZA', value: '1602' },
  { text: 'COLEGIO PARTICULAR SAN PIO X', value: '1603' },
  { text: 'COLEGIO TERESITA DE LISIEUX', value: '1607' },
  { text: 'ESC PART FRAY LUIS BELTRAN', value: '1609' },
  { text: 'COLEGIO ALBERTO HURTADO SEGUNDO', value: '1610' },
  { text: 'COLEGIO DABRUNA', value: '1617' },
  { text: 'COLEGIO PARTICULAR JUNIOR SCHOOL 2', value: '1619' },
  { text: 'COLEGIO MIGUEL DE UNAMUNO', value: '1620' },
  { text: 'LICEO MIXTO JOSE MIGUEL CARRERA', value: '1621' },
  { text: 'JARDIN INFANTIL SEMILLITA', value: '1623' },
  { text: 'JARDIN INFANTIL CARACOL', value: '1624' },
  { text: 'COLEGIO INTERNACIONAL', value: '1629' },
  { text: 'COL. IDA.CONCEPC. NTRA.SRA.LOURDES', value: '1632' },
  { text: 'SEMINARIO SAN RAFAEL', value: '1634' },
  { text: 'COLEGIO SAN PEDRO NOLASCO', value: '1641' },
  { text: 'COL. PART. CONSTANCIO VIGIL', value: '1650' },
  { text: 'COLEGIO SAN VICENTE', value: '1653' },
  { text: 'COL.PRESB.DAVID TRUMBULL ANEXO', value: '1657' },
  { text: 'ENGLISH COLLEGE VILLA PLACERES', value: '1662' },
  { text: 'LICEO INDUSTRIAL DE VINA DEL MAR', value: '1664' },
  { text: 'C.E.I.A. LOS CASTANOS', value: '1666' },
  { text: 'ESCUELA ESPECIAL ADOLFO TANNENBAUM  B.', value: '1667' },
  { text: 'ESCUELA ESPECIAL RAPA NUI', value: '1668' },
  { text: 'ESCUELA ESPECIAL JUANITA DE AGUIRRE CERDA', value: '1669' },
  { text: 'LICEO JOSE FRANCISCO VERGARA ETCHEVERS', value: '1672' },
  { text: 'LICEO BENJAMIN VICUNA MACKENA', value: '1674' },
  { text: 'LICEO GUILLERMO RIVERA COTAPOS', value: '1675' },
  { text: 'ESCUELA BASICA REPUBLICA DEL ECUADOR', value: '1677' },
  { text: 'ESCUELA UNESCO', value: '1678' },
  { text: 'ESCUELA ORLANDO PENA CARVAJAL', value: '1680' },
  { text: 'COLEGIO REPUBLICA DE COLOMBIA', value: '1681' },
  { text: 'COLEGIO MIRAFLORES', value: '1682' },
  { text: 'ESCUELA BASICA SANTA JULIA', value: '1683' },
  { text: 'ESCUELA LIBERTADOR  BERNARDO O^HIGGINS', value: '1684' },
  { text: 'ESCUELA DR. OSCAR MARIN SOCIAS', value: '1685' },
  { text: 'ESCUELA TEODORO LOWEY', value: '1686' },
  { text: 'ESCUELA ALMIRANTE LUIS GOMEZ CARRENO', value: '1688' },
  { text: 'ESCUELA ORO NEGRO', value: '1689' },
  { text: 'ESCUELA LORD COCHRANE', value: '1691' },
  { text: 'ESCUELA REPUBLICA DE GUATEMALA', value: '1692' },
  { text: 'ESCUELA BASICA 21 DE MAYO', value: '1693' },
  { text: 'ESCUELA PEDRO AGUIRRE CERDA', value: '1695' },
  { text: 'ESCUELA BASICA CHORRILOS', value: '1696' },
  { text: 'ESCUELA GASTON OSSA SAINT MARIE', value: '1697' },
  { text: 'ESCUELA PAUL HARRIS', value: '1698' },
  { text: 'ESCUELA BASICA IRMA SALAS SILVA', value: '1699' },
  { text: 'ESCUELA DOCTOR ADRIANO MACHADO PARDO', value: '1700' },
  { text: 'ESCUELA LA PARVA', value: '1701' },
  { text: 'ESCUELA CANAL BEAGLE', value: '1702' },
  { text: 'ESCUELA PRESIDENTE JOSE MANUEL BALMACEDA', value: '1703' },
  { text: 'ESCUELA BASICA JOHN KENNEDY', value: '1704' },
  { text: 'ESCUELA PRESIDENTE SALVADOR ALLENDE', value: '1705' },
  { text: 'ESCUELA MINISTRO ZENTENO', value: '1707' },
  { text: 'ESCUELA ENRIQUE CARDENAS RIVERA', value: '1708' },
  { text: 'ESCUELA PATRICIO LYNCH Z.', value: '1709' },
  { text: 'CENTRO DE EDUCACION DE ADULTOS', value: '1710' },
  { text: 'ESCUELA VILLA MONTE', value: '1712' },
  { text: 'ESCUELA SANTA MARIA DE AGUA SANTA', value: '1714' },
  { text: 'ESCUELA VILLA INDEPENDENCIA', value: '1716' },
  { text: 'ESCUELA CARDENAL JOSE MARIA CARO', value: '1717' },
  { text: 'ESCUELA EDUARDO LEZANA PINCHEIRA', value: '1718' },
  { text: 'ESCUELA  MARCELA PAZ', value: '1720' },
  { text: 'ESCUELA BASICA REPUBLICA DEL LIBANO', value: '1721' },
  { text: 'ESCUELA BASICA DR ALDO FRANCIA BOIDO', value: '1722' },
  { text: 'ESCUELA PRESIDENTE EDUARDO FREI MONTALVA', value: '1724' },
  { text: 'ESCUELA BASICA LUISA NIETO DE HAMEL', value: '1728' },
  { text: 'ESCUELA VIOLETA PARRA', value: '1732' },
  { text: 'LICEO NUESTRA SRA.DE LA PAZ', value: '1738' },
  { text: 'ESC. DE TRIPULANTES Y PORTUARIA DE VALPARAISO', value: '1739' },
  { text: 'LICEO SANTA TERESA DE LOS ANDES', value: '1741' },
  { text: 'COLEGIO SAN AGUSTIN', value: '1742' },
  { text: 'INST. DESARR. PARA NINOS CON S.DOWN', value: '1746' },
  { text: 'COLEGIO ESPANOL MARIA REINA', value: '1748' },
  { text: 'COLEGIO EXCMO.  CARDENAL RAUL SILVA HENRIQUEZ', value: '1749' },
  { text: 'COL. INMACULADA DE LOURDES', value: '1750' },
  { text: 'ESCUELA PARTICULAR HUGO ERRAZURIZ', value: '1751' },
  { text: 'ESCUELA PARTICULAR SANTA FILOMENA', value: '1752' },
  { text: 'ESCUELA DE PARVULOS CRISOLITO', value: '1758' },
  { text: 'COLEGIO SAN LUIS DE MIRAFLORES', value: '1759' },
  { text: 'ESCUELA ESPECIAL JUAN SANDOVAL C.', value: '1760' },
  { text: 'COLEGIO FRIENDLY HIGH SCHOOL', value: '1761' },
  { text: 'CENTRO TRAT. INTEGRAL LAS DALIAS', value: '1763' },
  { text: 'ESCUELA ILUSION', value: '1765' },
  { text: 'ESCUELA PARTICULAR CHILDRENS SCHOOL', value: '1767' },
  { text: 'COLEGIO BLANCA VERGARA', value: '1772' },
  { text: 'COLEGIO ARABE', value: '1775' },
  { text: 'SAINT PETERS SCHOOL', value: '1776' },
  { text: 'COLEGIO INGLES SAN PATRICIO', value: '1786' },
  { text: 'HEBREO DR. JAIM WEITZMAN', value: '1787' },
  { text: 'COLEGIO COMPA\u00c3\u2018IA DE MARIA', value: '1796' },
  { text: 'ESC. STA. TERESITA DE JESUS', value: '1803' },
  { text: 'ESCUELA JEFFERSON SCHOOL', value: '1807' },
  { text: 'COL. MARIA RAQUEL CERECEDA', value: '1810' },
  { text: 'COLLEGE CHRETIEN FRANCAIS LE BEAU JOUR', value: '1819' },
  { text: 'ESCUELA N\u00c2\u00b0 340 LORD COCHRANE', value: '1823' },
  { text: 'JARDIN INFANTIL CONEJITO COSTALIN', value: '1826' },
  { text: 'JARDIN INFANTIL ARCO IRIS', value: '1828' },
  { text: 'COLEGIO  SAN ANDRES', value: '1842' },
  { text: 'COLEGIO FRANCO INGLES', value: '1844' },
  { text: 'COLEGIO SAINT MICHAEL', value: '1847' },
  { text: 'ESCUELA BASICA LIDIA IRATCHET ZAVALA', value: '1853' },
  { text: 'ESCUELA BASICA REPUBLICA DE FRANCIA', value: '1855' },
  { text: 'ESCUELA MANTAGUA', value: '1856' },
  { text: 'ESCUELA JUAN JOSE TORTEL', value: '1857' },
  { text: 'COLEGIO SANTA FILOMENA', value: '1859' },
  { text: 'COLEGIO INGLES', value: '1860' },
  { text: 'COMPLEJO EDUCACIONAL SARGENTO ALDEA', value: '1864' },
  { text: 'ESCUELA LA GREDA', value: '1867' },
  { text: 'ESCUELA LA CHOCOTA', value: '1868' },
  { text: 'ESCUELA LOS MAQUIS', value: '1869' },
  { text: 'ESCUELA CAMPICHE', value: '1870' },
  { text: 'ESCUELA BASICA EL RINCON', value: '1871' },
  { text: 'ESCUELA HORCON', value: '1873' },
  { text: 'ESCUELA BASICA LA LAGUNA', value: '1874' },
  { text: 'ESCUELA MAITENCILLO', value: '1875' },
  { text: 'ESCUELA BASICA LA QUEBRADA', value: '1876' },
  { text: 'ESCUELA PUCALAN', value: '1877' },
  { text: 'ESCUELA BASICA  EL RUNGUE', value: '1878' },
  { text: 'COLEGIO ANDRES BELLO LOPEZ', value: '1880' },
  { text: 'ESCUELA LUIS CRUZ MARTINEZ', value: '1881' },
  { text: 'COLEGIO CAPITAN IGNACIO CARRERA PINTO', value: '1885' },
  { text: 'ESCUELA MANUEL BULNES PRIETO', value: '1886' },
  { text: 'ESCUELA GUARDIAMARINA GUILLERMO ZANARTU I.', value: '1887' },
  { text: 'ESC.CDTE. ELEUTERIO RAMIREZ MOLINA', value: '1888' },
  { text: 'COLEGIO FERNANDO DURAN VILLARREAL', value: '1889' },
  { text: 'COLEGIO JOSE MIGUEL INFANTE', value: '1890' },
  { text: 'ESCUELA BASICA JORGE ROCK LARA', value: '1891' },
  { text: 'ESCUELA BASICA GASPAR CABRALES', value: '1892' },
  { text: 'ESCUELA BASICA DARIO SALAS', value: '1893' },
  { text: 'CENTRO DE EDUCACION DE ADULTOS', value: '1894' },
  { text: 'LICEO TECNICO PROFESIONAL MANNHEIM', value: '1895' },
  { text: 'ESCUELA THEODOR HEUSS', value: '1898' },
  { text: 'ESCUELA TENIENTE IGNACIO SERRANO MONTANER', value: '1899' },
  { text: 'ESCUELA LOS MOLLES DE MARGA MARGA', value: '1900' },
  { text: 'ESCUELA SANTIAGO BUERAS', value: '1901' },
  { text: 'ESCUELA VICENTE EDWARDS PINTO', value: '1903' },
  { text: 'GABRIELA MISTRAL DE LA RETUCA', value: '1905' },
  { text: 'ESCUELA DELFINA ALARCON HENRIQUEZ', value: '1906' },
  { text: 'LICEO DE NINAS JAVIERA CARRERA', value: '1908' },
  { text: 'COLEGIO CREP', value: '1911' },
  { text: 'LICEO  JUAN XXIII  EL BELLOTO', value: '1914' },
  { text: 'ESCUELA PARTICULAR EXEQUIEL PUELMA SILVA', value: '1917' },
  { text: 'COLEGIO LOS LEONES DE QUILPUE', value: '1918' },
  { text: 'COLEGIO H. F. CAMILO HENRIQUEZ', value: '1919' },
  { text: 'COLEGIO ADVENTISTA', value: '1920' },
  { text: 'ESCUELA PARTICULAR SUN VALLEY SCHOOL', value: '1922' },
  { text: 'ESCUELA PARTICULAR INFANTES DEL SOL', value: '1924' },
  { text: 'ESCUELA JUAN DE SAAVEDRA', value: '1927' },
  { text: 'ABRAHAM LINCOLN MEMORIAL COLLEGE', value: '1930' },
  { text: 'KING EDWARD SCHOOL', value: '1931' },
  { text: 'COLEGIO PANAL II', value: '1932' },
  { text: 'JARDIN INFANTIL COLIBRI', value: '1949' },
  { text: 'WINDMILL COLLEGE ANEXO', value: '1959' },
  { text: 'ESCUELA LATINA INES GALLARDO ORELLANA', value: '1961' },
  { text: 'WINDMILL COLLEGE', value: '1962' },
  { text: 'ESCUELA BASICA DIEGO BARROS ARANA', value: '1963' },
  { text: 'COLEGIO ITALO COMPOSTO SCARPATI', value: '1965' },
  { text: 'ESCUELA BASICA CATALUNYA', value: '1966' },
  { text: 'LICEO TECNICO MARY GRAHAM', value: '1967' },
  { text: 'ESCUELA MELVIN JONES', value: '1968' },
  { text: 'COLEGIO CHARLES DARWIN', value: '1969' },
  { text: 'ESCUELA DIEGO PORTALES', value: '1970' },
  { text: 'ESCUELA MANUEL MONTT', value: '1971' },
  { text: 'ESCUELA DE EDUC. DIFERENCIAL NUEVO AMANECER', value: '1972' },
  { text: 'ESCUELA VICEALMIRANTE ARTURO WILSON N.', value: '1973' },
  { text: 'ESCUELA JUAN BAUTISTA ALBERTI', value: '1975' },
  { text: 'ESCUELA  EL  PATAGUAL', value: '1976' },
  { text: 'COLEGIO PARTICULAR JEAN PIAGET', value: '1980' },
  { text: 'CENTRO INFANTIL EL BUEN CAMINO', value: '1985' },
  { text: 'COLEGIO NUEVO CHILENO BRITANICO', value: '1987' },
  { text: 'INTERNADO ALEMAN', value: '1989' },
  { text: 'LICEO MANUEL DE SALAS', value: '1996' },
  { text: 'ESCUELA DOMINGO ORTIZ DE ROZAS', value: '1997' },
  { text: 'ESCUELA ARTURO ECHAZARRETA LARRAIN', value: '1998' },
  { text: 'ESCUELA MANUEL BRAVO REYES', value: '1999' },
  { text: 'ESCUELA LOS MAITENES', value: '2000' },
  { text: 'ESCUELA BASICA EL BATRO', value: '2002' },
  { text: 'ESCUELA  SAN PEDRO DE QUINTAY', value: '2003' },
  { text: 'ESCUELA BASICA LAGUNILLAS', value: '2005' },
  { text: 'COLEGIO PARTIC. JULIO MONTT SALAMANCA', value: '2007' },
  { text: 'ESCUELA PURISIMA DE LO VASQUEZ', value: '2008' },
  { text: 'COLEGIO INSULAR ROBINSON CRUSOE', value: '2009' },
  { text: 'ESCUELA ESPECIAL DIVINO MAESTRO', value: '2011' },
  { text: 'PROFESOR JUAN DANTE PARRAGUEZ ARELLANO', value: '2012' },
  { text: 'INST.COMERCIAL MARITIMO PACIFICO SUR', value: '2013' },
  { text: 'ESCUELA POETA PABLO NERUDA', value: '2014' },
  { text: 'ESCUELA VILLA LAS DUNAS', value: '2017' },
  { text: 'ESCUELA MOVILIZADORES PORTUARIOS', value: '2018' },
  { text: 'ESCUELA ESPANA', value: '2019' },
  { text: 'GRUPO ESCOLAR SOR TERESA DE LOS ANDES', value: '2020' },
  { text: 'PADRE ANDRE COINDRE', value: '2021' },
  { text: 'ESCUELA BASICA SAN JOSE DE CALASANZ', value: '2022' },
  { text: 'ESCUELA CRISTO DEL MAIPO', value: '2023' },
  { text: 'PROFESOR PEDRO VIVEROS ORMENO', value: '2024' },
  { text: 'ESCUELA PRE-BASICA PETER PAN', value: '2025' },
  { text: 'ESCUELA BASICA CERRO PLACILLA', value: '2026' },
  { text: 'ESCUELA POETA HUIDOBRO', value: '2027' },
  { text: 'PARVULARIO RAYITO DE SOL', value: '2028' },
  { text: 'ESCUELA BASICA CUNCUMEN', value: '2035' },
  { text: 'ESCUELA BASICA LEYDA', value: '2036' },
  { text: 'EDUARDO FERNANDEZ DE ASTURIAS', value: '2037' },
  { text: 'ESCUELA BASICA EL ASILO', value: '2038' },
  { text: 'LICEO NACIONAL DE LLO LLEO', value: '2040' },
  { text: 'ESCUELA INDUSTRIAL SAN ANTONIO', value: '2044' },
  { text: 'COLEGIO SAGRADA FAMILIA', value: '2048' },
  { text: 'COLEGIO NUESTRA SENORA DE POMPEYA', value: '2050' },
  { text: 'ESC. PARTICULAR N_ 22 SAN RAFAEL', value: '2051' },
  { text: 'COLEGIO PROVIDENCIA', value: '2052' },
  { text: 'INSTITUTO PSICOPEDAGOGICO', value: '2053' },
  { text: 'COLEGIO PART.GUILLERMO BLEST GANA', value: '2054' },
  { text: 'COLEGIO EL RETIRO', value: '2055' },
  { text: 'ESCUELA PARTICULAR N. 33 MARIA KONIG', value: '2057' },
  { text: 'LICEO POETA VICENTE HUIDOBRO', value: '2064' },
  { text: 'ESCUELA PRESIDENTE AGUIRRE CERDA', value: '2065' },
  { text: 'ESCUELA EUGENIA SUBERCASEAUX', value: '2066' },
  { text: 'ESCUELA CARMEN ROMERO AGUIRRE', value: '2068' },
  { text: 'ESCUELA LO ZARATE', value: '2069' },
  { text: 'ESCUELA BASICA SAN FRANCISCO', value: '2071' },
  { text: 'ESCUELA BASICA LAS CRUCES', value: '2074' },
  { text: 'COLEGIO EL TABO', value: '2075' },
  { text: 'LICEO  CLARA SOLOVERA', value: '2078' },
  { text: 'ESCUELA POETA NERUDA DE ISLA NEGRA', value: '2079' },
  { text: 'ESCUELA EL TOTORAL', value: '2081' },
  { text: 'ESC.PART.  SAN MIGUEL ARCANGEL', value: '2083' },
  { text: 'COLEGIO CARLOS ALESSANDRI ALTAMIRANO', value: '2084' },
  { text: 'ESCUELA BASICA RURAL EL YECO', value: '2085' },
  { text: 'ESCUELA BASICA RURAL SAN JOSE', value: '2087' },
  { text: 'ESCUELA PARTICULAR SAN JOSE', value: '2089' },
  { text: 'COLEGIO TERESA DE LOS ANDES-ALGARROBO', value: '2090' },
  { text: 'ESCUELA EL CONVENTO', value: '2092' },
  { text: 'ESCUELA BUCALEMITO', value: '2093' },
  { text: 'ESCUELA BASICA JUANITA FERNANDEZ S.', value: '2095' },
  { text: 'ESCUELA BASICA CLAUDIO VICUNA', value: '2096' },
  { text: 'ESCUELA JUDITH VARELA DE ESTURILLO', value: '2097' },
  { text: 'ESC. BASICA ELISA RUIZ-TAGLE FERNANDEZ', value: '2098' },
  { text: 'COLEGIO STO. DOMINGO HELEN LEE LASSEN', value: '2099' },
  { text: 'COLEGIO BASICO LORENZO BAEZA VEGA', value: '2101' },
  { text: 'LICEO TECNICO A-4', value: '2102' },
  { text: 'LICEO INDUSTRIAL ERNESTO PINTO LAGARRIGUE', value: '2105' },
  { text: 'LICEO MARIA LUISA BOMBAL', value: '2109' },
  { text: 'LICEO MUNICIPAL JOSE VICTORINO LASTARRIA', value: '2111' },
  { text: 'ESCUELA MUNICIPAL MOISES MUSSA', value: '2112' },
  { text: 'ESCUELA MUNICIPAL MARCELA PAZ', value: '2114' },
  { text: 'ESCUELA MUNICIPAL RENE SCHNEIDER CHEREAU', value: '2115' },
  { text: 'COLEGIO MUNICIPAL EDUARDO DE GEYTER', value: '2116' },
  { text: 'COLEGIO ESPANA', value: '2118' },
  { text: 'ESCUELA MUNICIPAL MANUEL RODRIGUEZ', value: '2119' },
  { text: 'ESCUELA MUNICIPAL MINERAL EL TENIENTE', value: '2120' },
  { text: 'COLEGIO REPUBLICA ARGENTINA', value: '2121' },
  { text: 'ESCUELA MUNICIPAL EL COBRE', value: '2122' },
  { text: 'ESCUELA MUNICIPAL BERNARDO O HIGGINS', value: '2123' },
  { text: 'COLEGIO LIBERTADOR SIMON BOLIVAR', value: '2124' },
  { text: 'COLEGIO PABLO GARRIDO', value: '2125' },
  { text: 'COL. JOSE A. MANSO DE VELASCO Y S.', value: '2126' },
  { text: 'COLEGIO AURORA DE CHILE', value: '2129' },
  { text: 'ESCUELA MUNICIPAL CARLOS MIRANDA MIRANDA', value: '2131' },
  { text: 'ESCUELA MUNICIPAL PATRICIO MEKIS', value: '2132' },
  { text: 'COL.ESPECIAL DR. RICARDO OLEA GULDEMONT', value: '2133' },
  { text: 'LICEO COMERCIAL JORGE ALESSANDRI R.', value: '2134' },
  { text: 'ESCUELA MUNICIPAL JEAN PIAGET', value: '2135' },
  { text: 'ESCUELA MUNICIPAL ISABEL RIQUELME', value: '2136' },
  { text: 'ESCUELA MUNICIPAL ALBERTO BLEST GANA', value: '2138' },
  { text: 'ESCUELA MUNICIPAL VIRGINIA BRAVO', value: '2139' },
  { text: 'ESCUELA MUNICIPAL AUGUSTO D HALMAR', value: '2140' },
  { text: 'ESCUELA MUNICIPAL HERMANOS CARRERA', value: '2143' },
  { text: 'ESCUELA MUNICIPAL MARTA BRUNET', value: '2145' },
  { text: 'COLEGIO MANUEL ROJAS', value: '2146' },
  { text: 'ESCUELA MUNICIPAL J.M. BALMACEDA', value: '2147' },
  { text: 'COLEGIO PARTICULAR SANTA MARIA', value: '2151' },
  { text: 'COLEGIO PARTICULAR SANTA MARIA GORETTI', value: '2153' },
  { text: 'COLEGIO PARTICULAR WHIPPLE SCHOOL', value: '2155' },
  { text: 'COLEGIO PARTICULAR INFANTES DE OHIGGINS', value: '2159' },
  { text: 'ESCUELA PARTICULAR JULIO VALENZUELA', value: '2160' },
  { text: 'COLEGIO PARTICULAR ADVENTISTA', value: '2162' },
  { text: 'COLEGIO PARTICULAR GABRIELA MISTRAL', value: '2164' },
  { text: 'ESCUELA PARTICULAR NINO JESUS DE PRAGA', value: '2165' },
  { text: 'INSTITUTO SEWELL', value: '2167' },
  { text: 'COLEGIO PARTICULAR COONILIR', value: '2169' },
  { text: 'COLEGIO PARTICULAR JAVIERA CARRERA', value: '2170' },
  { text: 'COLEGIO PARTICULAR ANDRES BELLO', value: '2171' },
  { text: 'COLEGIO SAN LUIS', value: '2172' },
  { text: 'COLEGIO PARTICULAR BERNARDO OHIGGINS', value: '2173' },
  { text: 'COLEGIO SANTO TOMAS', value: '2174' },
  { text: 'COLEGIO WEBER SCHOOL', value: '2177' },
  { text: 'ESCUELA PARTICULAR SAINT PAUL COLLEGE', value: '2178' },
  { text: 'COLEGIO PARTICULAR LOS CONQUISTADORES', value: '2179' },
  { text: 'COLEGIO PARTICULAR INSTITUTO EINSTEN', value: '2182' },
  { text: 'ESCUELA PARTICULAR BUEN PASTOR', value: '2184' },
  { text: 'ESCUELA SIXTO MENDEZ PARADA', value: '2206' },
  { text: 'ESCUELA HERNAN OLGUIN MAYBE', value: '2207' },
  { text: 'COLEGIO ANTONIO TRDAN ARKO', value: '2209' },
  { text: 'ESCUELA MUNICIPAL VILLA LA COMPANIA', value: '2210' },
  { text: 'ESCUELA MUNICIPAL DE TUNICHE', value: '2212' },
  { text: 'COLEGIO PARTICULAR NUESTRA SENORA', value: '2217' },
  { text: 'COLEGIO PARTICULAR GRANEROS', value: '2218' },
  { text: 'ESCUELA AGRICOLA CRISTO OBRERO', value: '2219' },
  { text: 'COLEGIO PARTICULAR SAN MARTIN', value: '2220' },
  { text: 'COLEGIO ANDRES BELLO', value: '2223' },
  { text: 'LICEO ELVIRA SANCHEZ DE GARCES', value: '2224' },
  { text: 'ESC. HIJOS DEL SOL', value: '2226' },
  { text: 'ESC. SAN FRANCISCO DE ASIS', value: '2227' },
  { text: 'ESCUELA EL RINCON', value: '2228' },
  { text: 'COLEGIO DEL CAMINO REAL', value: '2231' },
  { text: 'ESC. DE PARV. LAURITA VICUNA', value: '2232' },
  { text: 'COLEGIO PARTICULAR SAN ANDRES', value: '2233' },
  { text: 'COLEGIO JESUS ANDINO', value: '2234' },
  { text: 'COLEGIO MARIANO LATORRE', value: '2235' },
  { text: 'ESCUELA EUGENIO GARCIA FERNANDEZ', value: '2236' },
  { text: 'COLEGIO MUNICIPAL DE CALLEJONES', value: '2237' },
  { text: 'COLEGIO SANTA TERESA DE TUNCA', value: '2238' },
  { text: 'COLEGIO MUNICIPAL CRISTO DEL PARQUE', value: '2240' },
  { text: 'COLEGIO NATALIA PERALTA P', value: '2243' },
  { text: 'INSTITUTO LAUTARO DE CODEGUA', value: '2244' },
  { text: 'COLEGIO JUAN TACHOIRE MOENA', value: '2246' },
  { text: 'COLEGIO GABRIELA MISTRAL', value: '2247' },
  { text: 'PARVULARIO GRAL. O. BONILLA', value: '2248' },
  { text: 'COLEGIO LOS LLANOS', value: '2249' },
  { text: 'COL. STA. TERESA DE LOS ANDES', value: '2250' },
  { text: 'COLEGIO BELLAVISTA', value: '2251' },
  { text: 'ESC. SAN JUAQUIN DE LOS MAYOS', value: '2255' },
  { text: 'ESCUELA CHACAYES', value: '2257' },
  { text: 'ESCUELA PARTICULAR SAN LORENZO', value: '2258' },
  { text: 'COL.MARIA VILLALOBOS ARTEAGA', value: '2262' },
  { text: 'ESCUELA MUNICIPAL DE GULTRO', value: '2263' },
  { text: 'ESCUELA NUESTRA SRA. DE LA MERCED', value: '2264' },
  { text: 'ESCUELA BERTA SAAVEDRA SEGURA', value: '2265' },
  { text: 'ESCUELA BASICA CAMPO LINDO', value: '2266' },
  { text: 'ESC. REPUBLICA DE FRANCIA', value: '2267' },
  { text: 'ESCUELA MUNICIPAL SANTA AMALIA', value: '2268' },
  { text: 'ESCUELA MUNICIPAL EL RINCON', value: '2269' },
  { text: 'ESCUELA MUNICIPAL SUECIA', value: '2271' },
  { text: 'COLEGIO LA PIMPINELA', value: '2274' },
  { text: 'ESCUELA DAVID DEL CURTO', value: '2275' },
  { text: 'ESCUELA MARTA LEON VARGAS', value: '2276' },
  { text: 'ESCUELA PARTICULAR DOMINGO SAAVEDRA', value: '2277' },
  { text: 'ESCUELA CANADA', value: '2279' },
  { text: 'COLEGIO MUNICIPAL LO DE LOBO', value: '2282' },
  { text: 'ESCUELA LA PAZ', value: '2284' },
  { text: 'COLEGIO MANUEL FRANCISCO CORREA', value: '2285' },
  { text: 'COLEGIO MUNICIPAL LUIS GALDAMES', value: '2286' },
  { text: 'ESCUELA CARLOS CONDELL DE LA HAZA', value: '2288' },
  { text: 'ESCUELA REPUBLICA DE ALEMANIA', value: '2289' },
  { text: 'ESCUELA DIFERENCIAL TERESA NARETTO DE NICOLETTI', value: '2291' },
  { text: 'ESCUELA VICENTE HUIDOBRO', value: '2292' },
  { text: 'COLEGIO MUNICIPAL LOS CHOAPINOS', value: '2293' },
  { text: 'COLEGIO MUNICIPAL LA ESMERALDA', value: '2294' },
  { text: 'COLEGIO MUNICIPAL LO CARTAGENA', value: '2296' },
  { text: 'ESCUELA GUSTAVO BISQUERTT S.', value: '2297' },
  { text: 'COLEGIO MUNICIPAL RINCONADA DE MALAMBO', value: '2298' },
  { text: 'COLEGIO MUNICIPAL EL CERRILLO', value: '2299' },
  { text: 'ESCUELA LA ISLA EMMA ESCOBAR DE LAGOS', value: '2300' },
  { text: 'COLEGIO MUNICIPAL DE APALTA', value: '2301' },
  { text: 'ESCUELA BASICA VICTOR NICOLETTI TAMANINI', value: '2302' },
  { text: 'COLEGIO MUNICIPAL VILLA DEL COBIL', value: '2304' },
  { text: 'ESCUELA MARTA AVARIA SALVATIERRA', value: '2307' },
  { text: 'ESC.ALCIDES REYES FRIAS', value: '2310' },
  { text: 'ESCUELA PELEQUEN', value: '2311' },
  { text: 'ESCUELA MUNICIPAL DE PANQUEHUE', value: '2312' },
  { text: 'ESCUELA MUNICIPAL DE LIMAHUE', value: '2313' },
  { text: 'ESCUELA MUNICIPAL DE CORCOLEN', value: '2314' },
  { text: 'ESCUELA MUNICIPAL DE PELEQUEN VIEJO', value: '2318' },
  { text: 'LICEO REPUBLICA DE ITALIA', value: '2319' },
  { text: 'VIOLETA FUENTES CARVAJAL', value: '2320' },
  { text: 'ESCUELA AMPARO RAYO HORTA', value: '2321' },
  { text: 'ESCUELA RURAL LA VINILLA', value: '2322' },
  { text: 'ESCUELA JAIME FELDMAN MILLER', value: '2324' },
  { text: 'COLEGIO RA\u00c3\u0161L RAM\u00c3\u008dREZ MAYOL', value: '2325' },
  { text: 'COLEGIO MUNICIPAL DE EDUCACION ESPECIAL', value: '2327' },
  { text: 'ESCUELA ESPECIAL PAULA JARAQUEMADA', value: '2328' },
  { text: 'ESC.CARMEN GALLEGOS DE ROBLE', value: '2330' },
  { text: 'CENTRO EDUC. REQUEGUA', value: '2331' },
  { text: 'ESC.GUIDO ASSIS GONZALEZ', value: '2333' },
  { text: 'ESCUELA MUNICIPAL RASTROJOS', value: '2334' },
  { text: 'ESC. ENRIQUE YANEZ GONZALEZ', value: '2335' },
  { text: 'ESCUELA EL LIBERTADOR', value: '2336' },
  { text: 'ESC.JUAN BARROS ROLDAN', value: '2338' },
  { text: 'ESCUELA MUNICIPAL ZUNIGA', value: '2339' },
  { text: 'ESCUELA MUNICIPAL EL NARANJAL', value: '2341' },
  { text: 'ESCUELA MUNICIPAL MILLAHUE', value: '2342' },
  { text: 'ESCUELA MUNICIPAL TOQUIHUA', value: '2343' },
  { text: 'ESC.PARROCO M.BUSTAMANTE', value: '2347' },
  { text: 'ESCUELA MUNICIPAL VINA TAGUA TAGUA', value: '2348' },
  { text: 'ESCUELA MUNICIPAL LA LAGUNA', value: '2349' },
  { text: 'ESCUELA SAN ALBERTO DE IDAHUE', value: '2350' },
  { text: 'ESCUELA LAS PATAGUAS', value: '2352' },
  { text: 'ESCUELA MUNICIPAL CUCHIPUY', value: '2353' },
  { text: 'JARDIN INFANTIL EL PRINCIPITO VALIENTE', value: '2358' },
  { text: 'ESCUELA LARMAHUE', value: '2359' },
  { text: 'CENTRO EDUCATIVO SIGLO XXI', value: '2360' },
  { text: 'ESCUELA ENRIQUE SERRANO DE VIALE RIGO', value: '2361' },
  { text: 'ESCUELA AMELIA LYNCH DE LYON', value: '2362' },
  { text: 'ESCUELA MUNICIPAL DE SAN ROBERTO', value: '2363' },
  { text: 'ESCUELA REINO DE DINAMARCA', value: '2364' },
  { text: 'ESCUELA BASICA PATAGUAS CERRO', value: '2365' },
  { text: 'ESCUELA FERNANDO HUERTA PENA', value: '2366' },
  { text: 'ESCUELA BASICA JOSE BERNALES CASTILLO', value: '2367' },
  { text: 'ESCUELA MUNICIPAL EL SALTO', value: '2372' },
  { text: 'ESCUELA BASICA SAN JOSE', value: '2373' },
  { text: 'ESCUELA MUNICIPAL DE CALEUCHE', value: '2374' },
  { text: 'LICEO LATINOAMERICANO', value: '2375' },
  { text: 'ESCUELA ESPECIAL DE ADULTOS F N\u00c2\u00ba 142', value: '2377' },
  { text: 'ESCUELA BASICA ANTONIO DE ZUNIGA', value: '2379' },
  { text: 'ESCUELA MUNICIPAL ALCALDE G. BURMESTER', value: '2380' },
  { text: 'ESCUELA JUAN VALDES ORTUZAR', value: '2381' },
  { text: 'ESCUELA BASICA ROSARIO DE CODAO', value: '2384' },
  { text: 'ESCUELA PART. LUIS GARCIA DE LA HUERTA', value: '2386' },
  { text: 'ESCUELA MUNICIPAL OSVALDO RUIZ GARCIA', value: '2387' },
  { text: 'ESCUELA MUNIC.SBTE LUIS CRUZ MARTINEZ', value: '2388' },
  { text: 'COLEGIO NUESTRA SE\u00c3\u2018ORA DE LORETO', value: '2389' },
  { text: 'COLEGIO QUILLAYQUEN RINCONADA DE PARRAL', value: '2390' },
  { text: 'ESC. SUBTENIENTE JULIO MONTT SALAMANCA', value: '2391' },
  { text: 'ESC. LUCILA GODOY ALCAYAGA', value: '2392' },
  { text: 'ESCUELA MUNICIPAL DE LO DE CUEVAS', value: '2393' },
  { text: 'ESCUELA MUNICIPAL JOSEFINA VIAL DE VIAL', value: '2394' },
  { text: 'ESCUELA MUNICIPAL DE VINA LA CRUZ', value: '2395' },
  { text: 'ESCUELA MUNICIPAL DE RINCONADA DE IDAHUE', value: '2396' },
  { text: 'ESCUELA CAPITAN IGNACIO CARRERA PINTO', value: '2397' },
  { text: 'ESCUELA SUBTTE. ARTURO PEREZ CANTO', value: '2398' },
  { text: 'ESCUELA PARTICULAR AMADA SOFIA GARCIA', value: '2400' },
  { text: 'ESCUELA AGRICOLA SAN VICENTE DE PAUL', value: '2401' },
  { text: 'LICEO MUNICIPAL LUIS GREGORIO VALENZUELA LAVIN', value: '2406' },
  { text: 'ESCUELA MUNICIPAL CHILLEHUE', value: '2407' },
  { text: 'ESCUELA MUNICIPAL COPEQUEN', value: '2409' },
  { text: 'ESCUELA MUNICIPAL EL RULO', value: '2410' },
  { text: 'ESCUELA LAURA MATUS MELENDEZ', value: '2412' },
  { text: 'ESC. DE PARVULOS MIS PRIMEROS PASOS', value: '2413' },
  { text: 'COLEGIO MUNICIPAL LA ISLA', value: '2414' },
  { text: 'ESCUELA LO MIRANDA', value: '2415' },
  { text: 'COLEGIO REPUBLICA DE CHILE', value: '2416' },
  { text: 'ESCUELA CERRILLOS', value: '2417' },
  { text: 'COLEGIO JULIO SILVA LAZO', value: '2419' },
  { text: 'ESCUELA PLAZUELA', value: '2420' },
  { text: 'LICEO FRANCISCO ANTONIO ENCINA ARMANET', value: '2422' },
  { text: 'ESCUELA BASICA ROMILIO ARELLANO TRONCOSO', value: '2423' },
  { text: 'ESCUELA OSVALDO CORREA FUENZALIDA', value: '2424' },
  { text: 'ESCUELA MUNICIPAL DE LOS AROMOS', value: '2425' },
  { text: 'ESC. CONTRAMAESTRE CONSTANTINO MICALVI', value: '2426' },
  { text: 'ESCUELA MUNICIPAL MAESTRO JORGE LOPEZ OSORIO', value: '2427' },
  { text: 'ESCUELA REPUBLICA DE GRECIA', value: '2428' },
  { text: 'COLEGIO INES DE SUAREZ', value: '2429' },
  { text: 'ESCUELA MUNICIPAL VILMA ALIAGA CALDERON', value: '2432' },
  { text: 'ESCUELA MUNICIPAL DE SANTA EUGENIA', value: '2436' },
  { text: 'ESCUELA TENIENTE HERNAN MERINO CORREA', value: '2437' },
  { text: 'ESCUELA MUNICIPAL DE LOS QUILLAYES', value: '2438' },
  { text: 'ESCUELA MUNICIPAL DE PALMERIA', value: '2439' },
  { text: 'ESCUELA MUNICIPAL DE VALDEBENITO', value: '2440' },
  { text: 'COLEGIO PART.SANT.VIRGEN MARIA', value: '2441' },
  { text: 'LICEO TECNICO FELISA CLARA TOLUP ZEIMAN', value: '2442' },
  { text: 'LICEO INDUSTRIAL DE SAN FERNANDO', value: '2443' },
  { text: 'LICEO DE NINAS EDUARDO CHARME', value: '2448' },
  { text: 'COLEGIO INMACULADA CONCEPCION', value: '2455' },
  { text: 'ESCUELA OLEGARIO LAZO BAEZA', value: '2456' },
  { text: 'ESCUELA BASICA ISABEL LA CATOLICA', value: '2457' },
  { text: 'ESCUELA JORGE MUNOZ SILVA', value: '2458' },
  { text: 'COLEGIO GIUSEPPE BERTOLUZZI DE FELIP', value: '2459' },
  { text: 'ESCUELA HOGAR MARIA LUISA BOUCHON', value: '2460' },
  { text: 'ESCUELA VILLA CENTINELA', value: '2461' },
  { text: 'ESCUELA WASHINGTON OMAR VENEGAS', value: '2462' },
  { text: 'COLEGIO HERMANO FERNANDO DE LA FUENTE', value: '2463' },
  { text: 'ESCUELA JOSE DE SAN MARTIN', value: '2464' },
  { text: 'ESCUELA CONCENTRAC. RURAL SERGIO VERDUGO HERRERA', value: '2465' },
  { text: 'ESCUELA BAS.ABEL BOUCHON FAURE', value: '2467' },
  { text: 'ESCUELA BAS.ANA MARIA DE RIVADENEIRA', value: '2468' },
  { text: 'ESCUELA ABRAHAM LINCOLN DE AGUA BUENA', value: '2469' },
  { text: 'ESCUELA BAS.SAN JOSE DE LOS LINGUES', value: '2470' },
  { text: 'ESCUELA BERNARDO MORENO FREDES', value: '2471' },
  { text: 'ESCUELA BASICA ANTONIO LARA MEDINA', value: '2472' },
  { text: 'ESCUELA LOS MAQUIS', value: '2475' },
  { text: 'ESCUELA BASICA GASPAR MARIN', value: '2476' },
  { text: 'COLEGIO SAN FRANCISCO DE AS\u00c3\u008dS', value: '2481' },
  { text: 'LICEO AGRICOLA EL CARMEN', value: '2485' },
  { text: 'LICEO MUNICIPAL COMPLEJO EDUC. CHIMBARONGO', value: '2486' },
  { text: 'ESCUELA BAS.FERNANDO ARENAS  ALMARZA', value: '2487' },
  { text: 'ESCUELA MUNICIPAL', value: '2488' },
  { text: 'ESCUELA BAS. VILLA CONVENTO VIEJO', value: '2489' },
  { text: 'ESCUELA MUNICIPAL', value: '2490' },
  { text: 'ESCUELA MUNICIPAL', value: '2491' },
  { text: 'ESCUELA MUNICIPAL', value: '2492' },
  { text: 'ESCUELA BAS. JOSE MIGUEL CARRERA VERDUGO', value: '2493' },
  { text: 'ESCUELA MUNICIPAL', value: '2494' },
  { text: 'ESCUELA MUNICIPAL', value: '2495' },
  { text: 'ESCUELA MUNICIPAL', value: '2496' },
  { text: 'ESCUELA MUNICIPAL', value: '2498' },
  { text: 'ESCUELA MUNICIPAL', value: '2500' },
  { text: 'ESCUELA BAS. PEDRO ETCHEVERRY', value: '2501' },
  { text: 'ESCUELA MUNICIPAL', value: '2505' },
  { text: 'ESCUELA MUNICIPAL', value: '2506' },
  { text: 'ESCUELA MUNICIPAL', value: '2507' },
  { text: 'ESCUELA MUNICIPAL', value: '2508' },
  { text: 'ESCUELA MUNICIPAL', value: '2509' },
  { text: 'ESCUELA MUNICIPAL', value: '2513' },
  { text: 'ESCUELA AGRICOLA LAS GARZAS', value: '2514' },
  { text: 'ESCUELA PARTICULAR MELECIA TOCORNAL', value: '2517' },
  { text: 'LICEO SAN FRANCISCO', value: '2518' },
  { text: 'ESCUELA BASICA RAUL CACERES PACHECO', value: '2519' },
  { text: 'ESCUELA MUNICIPAL LA DEHESA', value: '2520' },
  { text: 'ESCUELA MUNICIPAL LA TUNA', value: '2521' },
  { text: 'ESCUELA MUNICIPAL SN LUIS DE MANANTIALES', value: '2522' },
  { text: 'ESCUELA EL AMANECER', value: '2523' },
  { text: 'ESCUELA DANY GERMAN GONZALEZ SOTO', value: '2524' },
  { text: 'COLEGIO BASICO CONSOLIDADO', value: '2525' },
  { text: 'ESCUELA BAS. IGNACIO CARRERA PINTO', value: '2526' },
  { text: 'ESCUELA B\u00c3\u0081SICA PUQUILLAY', value: '2527' },
  { text: 'ESCUELA BAS. ADRIANA LYON VIAL', value: '2528' },
  { text: 'ESCUELA MUNICIPAL YAQUIL', value: '2529' },
  { text: 'LICEO MUNICIPAL JUAN PABLO II', value: '2530' },
  { text: 'COLEGIO PARTICULAR EL PRINCIPITO', value: '2531' },
  { text: 'COLEGIO B\u00c3\u0081SICO DE CH\u00c3\u2030PICA', value: '2532' },
  { text: 'ESCUELA EUGENIO RUIZ-TAGLE MONTES', value: '2534' },
  { text: 'COLEGIO MUNICIPAL LAS ALAMEDAS', value: '2535' },
  { text: 'COLEGIO MUNICIPAL EMILIA SALINAS DIAZ', value: '2536' },
  { text: 'ESCUELA LUIS ATHAS', value: '2537' },
  { text: 'ESCUELA LINDORFO MONTERO FUENZALIDA', value: '2538' },
  { text: 'ESCUELA LUIS ARTURO ZUNIGA FUENTES', value: '2539' },
  { text: 'ESCUELA MARIA MARTA DEL REAL CORREA', value: '2540' },
  { text: 'ESCUELA HECTOR RODOLFO CASTILLO MORENO', value: '2541' },
  { text: 'ESCUELA LUZ MARIA CRESPO URETA DE KERESTEGIAN', value: '2542' },
  { text: 'ESCUELA CARLOS DONOSO REBOLLEDO', value: '2543' },
  { text: 'COLEGIO CRUZ MARIA', value: '2544' },
  { text: 'ESCUELA GABRIELA MISTRAL', value: '2545' },
  {
    text: 'ESCUELA NUESTRA SE\u00c3\u2018ORA DE LA CANDELARIA 1',
    value: '2546',
  },
  { text: 'ESCUELA ESTRELLA DE DAVID', value: '2548' },
  { text: 'ESCUELA DE ADULTOS', value: '2549' },
  { text: 'ESCUELA MUNICIPAL DE SANTA CRUZ', value: '2553' },
  { text: 'ESCUELA ESPECIAL DE SANTA CRUZ', value: '2554' },
  { text: 'ESCUELA MARIA  ARAYA VALDES', value: '2555' },
  { text: 'ESCUELA MUNICIPAL DE PANIAHUE', value: '2556' },
  { text: 'ESCUELA GRANJA ADEODATO GARCIA VALENZUELA', value: '2557' },
  { text: 'ESCUELA LA FINCA', value: '2558' },
  { text: 'ESCUELA MUNICIPAL DE BARREALES', value: '2559' },
  { text: 'ESC. MUNICIPAL LA LAJUELA', value: '2560' },
  { text: 'ESCUELA MUNICIPAL DE QUINAHUE', value: '2561' },
  { text: 'ESCUELA MUNICIPAL DE ISLA DE YAQUIL', value: '2562' },
  { text: 'ESCUELA MUNICIPAL DE LA PATAGUA', value: '2563' },
  { text: 'ESCUELA MUNICIPAL DE MILLAHUE DE APALTA', value: '2565' },
  { text: 'ESCUELA MUNICIPAL DE CUNACO', value: '2566' },
  { text: 'ESCUELA MUNICIPAL DE LAS CORTADERAS', value: '2567' },
  { text: 'ESCUELA MUNICIPAL DE PANAMA', value: '2568' },
  { text: 'ESCUELA MUNICIPAL DE LOS MAITENES', value: '2570' },
  { text: 'ESCUELA MUNICIPAL DE RINCON DE YAQUIL', value: '2572' },
  { text: 'ESCUELA MUNICIPAL', value: '2575' },
  { text: 'ESCUELA MUNICIPAL DE GUINDO ALTO', value: '2576' },
  { text: 'ESCUELA ANGEL ARRIGORRIAGA', value: '2577' },
  { text: 'LICEO DE LOLOL', value: '2583' },
  { text: 'ESCUELA OCTAVIO MUJICA VALENZUELA', value: '2584' },
  { text: 'ESCUELA BAS. DAMASO DUARTE', value: '2586' },
  { text: 'ESCUELA MUNICIPAL ANIBAL DUQUE ZUNIGA', value: '2589' },
  { text: 'ESCUELA MUNICIPAL RINCONADA DE QUIAHUE', value: '2590' },
  { text: 'ESCUELA MUNICIPAL JUANA GONZALEZ', value: '2591' },
  { text: 'ESCUELA MUNICIPAL EDUVIGIS PANTOJA L', value: '2592' },
  { text: 'ESCUELA BASICA  HUGO URZUA URZUA', value: '2594' },
  { text: 'ESCUELA BASICA OLGA DE GOMEZ', value: '2598' },
  { text: 'ESCUELA MUNICIPAL DE PUMANQUE', value: '2599' },
  { text: 'ESCUELA MUNICIPAL DE NILAHUE CORNEJO', value: '2601' },
  { text: 'ESCUELA MUNICIPAL DE MATA REDONDA', value: '2603' },
  { text: 'ESCUELA PENABLANCA', value: '2604' },
  { text: 'ESCUELA MUNICIPAL DE RINCON LOS PERALES', value: '2607' },
  { text: 'ESCUELA MUNICIPAL DE PALMILLA DE RETO', value: '2609' },
  { text: 'ESCUELA MUNICIPAL DE PALMILLA', value: '2611' },
  { text: 'ESCUELA MUNICIPAL SN.JOSE DEL CARMEN', value: '2612' },
  { text: 'ESCUELA MUNICIPAL SANTA MATILDE', value: '2613' },
  { text: 'ESCUELA JORGE ERRAZURIZ ECHE\u00c3\u2018IQUE', value: '2615' },
  { text: 'ESCUELA MUNICIPAL SN. FCO. DEL HUIQUE', value: '2617' },
  { text: 'ESCUELA REBECA CADIZ VALENZUELA', value: '2621' },
  { text: 'ESCUELA MUNICIPAL VALLE HERMOSO', value: '2622' },
  { text: 'ESCUELA MUNICIPAL LIHUEIMO', value: '2624' },
  { text: 'LICEO VICTOR JARA', value: '2625' },
  { text: 'COLEGIO MANUEL RODRIGUEZ ERDOIZA', value: '2626' },
  { text: 'ESCUELA GUSTAVO RIVERA BUSTOS', value: '2627' },
  { text: 'ESCUELA MUNICIPAL SARA RAVELLO PARRAGUEZ', value: '2629' },
  { text: 'ESCUELA ARTURO PRAT CHACON', value: '2630' },
  { text: 'ESCUELA MUNICIPAL CORONEL RAMON DIAZ A.', value: '2632' },
  { text: 'ESCUELA MARTA VALDES ECHE\u00c3\u2018IQUE', value: '2633' },
  { text: 'ESCUELA PABLO NERUDA', value: '2634' },
  { text: 'LICEO AGUSTIN ROSS EDWARDS', value: '2635' },
  { text: 'ESCUELA PUEBLO DE VIUDAS', value: '2636' },
  { text: 'ESCUELA MUNICIPAL VILLA SAN PEDRO', value: '2637' },
  { text: 'ESCUELA ALTO RAMIREZ', value: '2639' },
  { text: 'ESCUELA COGUIL', value: '2642' },
  { text: 'ESCUELA PADRE ALBERTO HURTADO C.', value: '2643' },
  { text: 'ESCUELA TANUME', value: '2644' },
  { text: 'ESCUELA LA AGUADA', value: '2646' },
  { text: 'ESCUELA RODEILLO', value: '2647' },
  { text: 'ESCUELA CAHUIL', value: '2650' },
  { text: 'ESCUELA CIRUELOS', value: '2652' },
  { text: 'COLEGIO LIBERTADORES', value: '2654' },
  { text: 'ESCUELA ESPINILLO', value: '2655' },
  { text: 'COLEGIO MUNICIPAL DIVINA GABRIELA', value: '2658' },
  { text: 'ESCUELA FRANCISCO CHAVEZ CIFUENTES', value: '2660' },
  { text: 'ESCUELA MUNICIPAL EL MANZANO', value: '2661' },
  { text: 'ESCUELA MUNICIPAL CARLOS IBANEZ DEL C', value: '2663' },
  { text: 'ESCUELA BASICA CONFEDERACION HELVETICA', value: '2664' },
  { text: 'ESCUELA MUNICIPAL LA BOCA DE RAPEL', value: '2666' },
  { text: 'ESCUELA MUNICIPAL PADRE ALBERTO HURTADO', value: '2673' },
  { text: 'ESCUELA MUNICIPAL LA AGUADA', value: '2675' },
  { text: 'ESCUELA MUNICIPAL MARIA WILLIAMS', value: '2678' },
  { text: 'LICEO EL ROSARIO DE LITUECHE', value: '2681' },
  { text: 'ESCUELA MUNICIPAL QUELENTARO', value: '2682' },
  { text: 'ESCUELA MUNICIPAL MATANCILLA', value: '2685' },
  { text: 'ESCUELA MUNICIPAL PULIN', value: '2686' },
  { text: 'ESCUELA MUNICIPAL PASO DEL SOLDADO', value: '2687' },
  { text: 'ESCUELA MUNICIPAL SANTA JULIA', value: '2691' },
  { text: 'ESCUELA MUNICIPAL MANQUEHUA', value: '2692' },
  { text: 'ESCUELA PROF. MONICA SILVA GOMEZ', value: '2694' },
  { text: 'ESCUELA MUNICIPAL GUADALAO', value: '2698' },
  { text: 'ESCUELA MUNICIPAL LA AGUADA', value: '2700' },
  { text: 'LICEO MUNICIPAL INSTITUTO CARDENAL CARO', value: '2701' },
  { text: 'ESCUELA MUNICIPAL LA QUEBRADA', value: '2702' },
  { text: 'ESCUELA MUNICIPAL EL SAUCE', value: '2703' },
  { text: 'ESCUELA MUNICIPAL EL PARQUE', value: '2704' },
  { text: 'ESCUELA TRINIDAD', value: '2705' },
  { text: 'ESCUELA MUNICIPAL LO MARCHANT', value: '2706' },
  { text: 'ESCUELA MUNICIPAL NOBELES DE CHILE', value: '2707' },
  { text: 'ESCUELA MUNICIPAL PAILIMO', value: '2708' },
  { text: 'ESCUELA MUNICIPAL SAN MIGUEL VILUCO', value: '2711' },
  { text: 'ESCUELA UNION DE MUJERES AMERICANAS', value: '2714' },
  { text: 'ESC.BASICA MERCEDES URZUA DIAZ', value: '2715' },
  { text: 'ESCUELA MUNICIPAL SAN PEDRO DE ALCANTARA', value: '2716' },
  { text: 'ESCUELA MUNICIPAL ALBERTINA VALENZUELA', value: '2717' },
  { text: 'ESCUELA LUIS ARTEMON PEREZ A.', value: '2719' },
  { text: 'ESCUELA SANTA ANA DE LA POBLACION', value: '2721' },
  { text: 'ESCUELA LOS COPIHUES DEL CALVARIO', value: '2722' },
  { text: 'ESCUELA MUNICIPAL LOS BRIONES', value: '2723' },
  { text: 'ESCUELA MUNICIPAL EL CARDAL', value: '2724' },
  { text: 'ESCUELA MUNICIPAL LO VALDIVIA', value: '2725' },
  { text: 'ESCUELA MUNICIPAL ESMERALDA', value: '2727' },
  { text: 'ESCUELA LAS CARMELITAS', value: '2728' },
  { text: 'ESCUELA ESPECIAL CURICO', value: '2730' },
  { text: 'ESC.CAPLLAN JOSE LUIS LOPEZ CARRASCO', value: '2731' },
  { text: 'LICEO LUIS CRUZ MARTINEZ DE CURICO', value: '2733' },
  { text: 'ESCUELA INGENIERO JORGE ALESSANDRI R.', value: '2734' },
  { text: 'ESCUELA PRESIDENTE J.M.BALMACEDA', value: '2735' },
  { text: 'ESCUELA PALESTINA', value: '2736' },
  { text: 'ESCUELA JAPON', value: '2737' },
  { text: 'ESCUELA REPUBLICA DE BRASIL', value: '2738' },
  { text: 'ESCUELA GRECIA', value: '2740' },
  { text: 'ESCUELA ERNESTO CASTRO ARELLANO', value: '2741' },
  { text: 'ESC.REPUBLICA ORIENTAL DEL URUGUAY', value: '2742' },
  { text: 'ESCUELA ESPANA', value: '2744' },
  { text: 'ESCUELA CATALUNA', value: '2745' },
  { text: 'ESCUELA SAN ANTONIO', value: '2747' },
  { text: 'ESCUELA REPUBLICA ARGENTINA', value: '2748' },
  { text: 'ESCUELA AGUAS NEGRAS', value: '2749' },
  { text: 'ESCUELA MARIA INES RODRIGUEZ', value: '2750' },
  { text: 'ESCUELA REPUBLICA DE VENEZUELA', value: '2751' },
  { text: 'ESCUELA REPUBLICA ESTADOS UNIDOS', value: '2753' },
  { text: 'ESCUELA INTERNADO POTRERO GRANDE', value: '2754' },
  { text: 'ESCUELA MARIA OLGA FIGUEROA LEYTON', value: '2755' },
  { text: 'ESCUELA DIEGO PORTALES P.', value: '2756' },
  { text: 'ESCUELA OSVALDO CORREA FUENZALIDA', value: '2758' },
  { text: 'ESCUELA EL MAITENAL', value: '2759' },
  { text: 'ESCUELA LA OBRA', value: '2761' },
  { text: 'ESCUELA EL PORVENIR', value: '2762' },
  { text: 'ESCUELA REPUBLICA DE ITALIA', value: '2763' },
  { text: 'ESCUELA ISLA DE MARCHANT', value: '2764' },
  { text: 'ESCUELA RAMON FREIRE', value: '2765' },
  { text: 'ESCUELA VICTOR VERGARA CAMPOS', value: '2766' },
  { text: 'ESCUELA LOS CRISTALES', value: '2767' },
  { text: 'ESCUELA JOSE D. MORALES DIAZ', value: '2768' },
  { text: 'ESCUELA PABLO NERUDA', value: '2771' },
  { text: 'ESCUELA MONTE OSCURO', value: '2775' },
  { text: 'ESCUELA EL MAITEN', value: '2776' },
  { text: 'ESCUELA HOLANDA', value: '2780' },
  { text: 'INSTITUTO POLITECNICO SUPERIOR JUAN TERRI', value: '2793' },
  { text: 'LICEO TENO', value: '2794' },
  { text: 'ESCUELA TENO', value: '2795' },
  { text: 'ESCUELA COMALLE', value: '2796' },
  { text: 'ESCUELA HACIENDA TENO', value: '2797' },
  { text: 'ESCUELA LA PURISIMA', value: '2799' },
  { text: 'ESCUELA MORZA', value: '2800' },
  { text: 'ESCUELA MONTERILLA', value: '2801' },
  { text: 'ESCUELA SUSANA MONTES VELASCO', value: '2802' },
  { text: 'ESCUELA LAS ARBOLEDAS', value: '2803' },
  { text: 'ESC. MANUEL RODRIGUEZ ERDOIZA', value: '2804' },
  { text: 'ESCUELA ALBORADA VENTANA DEL BAJO', value: '2805' },
  { text: 'ESCUELA HUEMUL', value: '2806' },
  { text: 'ESCUELA LAS LIRAS', value: '2809' },
  { text: 'ESCUELA SAN RAFAEL', value: '2814' },
  { text: 'ESCUELA EL CULENAR', value: '2815' },
  { text: 'ESCUELA PDTE CARLOS IBANEZ DEL CAMPO', value: '2816' },
  { text: 'ESCUELA SAN CRISTOBAL', value: '2817' },
  { text: 'ESCUELA TENIENTE CRUZ', value: '2819' },
  { text: 'ESCUELA LOS ALISOS', value: '2820' },
  { text: 'ESCUELA BASICA SAN SEBASTIAN', value: '2821' },
  { text: 'LICEO ARTURO ALESSANDRI PALMA', value: '2822' },
  { text: 'ESCUELA RAMON FREIRE', value: '2823' },
  { text: 'ESCUELA AMERICA LATINA', value: '2825' },
  { text: 'ESCUELA TRES ESQUINAS', value: '2826' },
  { text: 'ESCUELA GUAICO CENTRO', value: '2827' },
  { text: 'ESCUELA BASICA LUIS ESCOBAR LARA', value: '2829' },
  { text: 'ESCUELA GUAICO TRES', value: '2830' },
  { text: 'ESCUELA EL CALABOZO', value: '2831' },
  { text: 'ESCUELA FRANCISCO DE PAULA SANTANDER', value: '2832' },
  { text: 'ESCUELA SUPERIOR DE HOMBRES', value: '2837' },
  { text: 'ESCUELA PRESIDENTE EDUARDO FREI MONTALVA', value: '2839' },
  { text: 'ESCUELA SUPERIOR DE NINAS DE MOLINA', value: '2840' },
  { text: 'LUIS MALDONADO BOGGIANO', value: '2842' },
  { text: 'ESCUELA EL PROGRESO', value: '2843' },
  { text: 'ESC.INTERN.LAS PALMAS TRES ESQUINAS', value: '2844' },
  { text: 'ESCUELA SAN PEDRO DE MOLINA', value: '2845' },
  { text: 'ESCUELA BUENA PAZ', value: '2846' },
  { text: 'ESCUELA CASA BLANCA', value: '2847' },
  { text: 'ESCUELA QUECHEREGUAS DE PICHINGAL', value: '2848' },
  { text: 'ESCUELA JULIA CATAN DABIKE', value: '2850' },
  { text: 'ESCUELA BUENA FE', value: '2851' },
  { text: 'ESCUELA SAN JORGE DE ROMERAL', value: '2854' },
  { text: 'ESCUELA EL RADAL', value: '2856' },
  { text: 'ESCUELA LA PALMILLA', value: '2858' },
  { text: 'ESCUELA BAJO LOS ROMEROS', value: '2859' },
  { text: 'ESCUELA EL CERRILLO', value: '2860' },
  { text: 'ESCUELA ALBERTO GIRARDI FONTANA', value: '2861' },
  { text: 'ESCUELA PARTICULAR NTRA.SRA.DEL TRANSITO', value: '2862' },
  { text: 'COLEGIO ADVENTISTA DE MOLINA', value: '2863' },
  { text: 'LICEO GONZALO CORREA UGARTE', value: '2864' },
  { text: 'ESCUELA AGRICOLA SUPERIOR DE MOLINA', value: '2865' },
  { text: 'ESCUELA VILLA PRAT', value: '2866' },
  { text: 'ESC.DE EDUC.GRAL. BASICA MONSENOR ENRIQUE COR', value: '2867' },
  { text: 'ESCUELA SANTA ROSA', value: '2868' },
  { text: 'ESCUELA LA ISLA', value: '2870' },
  { text: 'ESCUELA LO VALDIVIA', value: '2871' },
  { text: 'ESCUELA PETEROA', value: '2873' },
  { text: 'ESCUELA EL DURAZNO', value: '2874' },
  { text: 'ESCUELA SANTA EMILIA', value: '2875' },
  { text: 'ESCUELA EUGENIO TAGLE VALDES', value: '2876' },
  { text: 'ESCUELA LA HIGUERILLA', value: '2877' },
  { text: 'ESCUELA SANTA MARIA', value: '2879' },
  { text: 'ESCUELA LA HUERTA DE MATAQUITO', value: '2883' },
  { text: 'ESCUELA CARLOS CORREA NUNEZ', value: '2884' },
  { text: 'ESCUELA ORILLA DE NAVARRO', value: '2885' },
  { text: 'ESCUELA EDUARDO NUNEZ FUENZALIDA', value: '2888' },
  { text: 'ESCUELA JOSE SANTOS ALIAGA ROJAS', value: '2890' },
  { text: 'ESCUELA EL BUCHE', value: '2891' },
  { text: 'ESCUELA DE BARBA RUBIA', value: '2892' },
  { text: 'ESCUELA CAONE', value: '2893' },
  { text: 'ESCUELA AMELIA VIAL DE CONCHA', value: '2894' },
  { text: 'ESCUELA PARTICULAR LOS COIPOS', value: '2895' },
  { text: 'LICEO AUGUSTO SANTELICES VALENZUELA', value: '2896' },
  { text: 'ESCUELA LOS COPIHUES', value: '2901' },
  { text: 'ESCUELA SALVADOR ALLENDE GOSSENS', value: '2903' },
  { text: 'ESCUELA JULIAN RUIZ DE GAMBOA', value: '2904' },
  { text: 'ESCUELA PLAYA LINDA DE LIPIMAVIDA', value: '2907' },
  { text: 'ESCUELA ALEJANDRO ROJAS SIERRA', value: '2908' },
  { text: 'LICEO NUEVO HORIZONTE', value: '2909' },
  { text: 'ESCUELA ENTRE AGUAS DE LLICO', value: '2910' },
  { text: 'ESCUELA LAGO VICHUQUEN', value: '2911' },
  { text: 'ESCUELA EMA CORNEJO DE CARDOEN', value: '2914' },
  { text: 'ESCUELA SAN MANUEL DE RARIN', value: '2915' },
  { text: 'ESCUELA QUIRICO SANTELICES SANTELICES', value: '2916' },
  { text: 'ESCUELA RAUCO', value: '2917' },
  { text: 'ESCUELA LOS ALMENDROS', value: '2918' },
  { text: 'ESCUELA QUILPOCO', value: '2920' },
  { text: 'ESCUELA LA ALBORADA', value: '2921' },
  { text: 'ESCUELA TRICAO', value: '2923' },
  { text: 'ESCUELA EL PLUMERO', value: '2927' },
  { text: 'ESCUELA EL PARRON', value: '2928' },
  { text: 'LICEO DE CULTURA Y DIFUSION ARTISTICA', value: '2930' },
  { text: 'ESCUELA INES SYLVESTER DE ORTOZON', value: '2931' },
  { text: 'ESCUELA ESPECIAL ESPANA', value: '2932' },
  { text: 'ESCUELA CENTRO DE CAPACITACION LABORAL', value: '2933' },
  { text: 'LICEO CARLOS CONDELL', value: '2940' },
  { text: 'ESCUELA SARGENTO 2DO DANIEL REBOLLEDO', value: '2941' },
  { text: 'ESCUELA JUAN LUIS SANFUENTES', value: '2942' },
  { text: 'LICEO HECTOR PEREZ BIOTT', value: '2943' },
  { text: 'ESCUELA JOSE M. BALMACEDA Y FERNANDEZ', value: '2944' },
  { text: 'ESCUELA PROSPERIDAD', value: '2945' },
  { text: 'ESCUELA CARLOS SPANO', value: '2946' },
  { text: 'ESCUELA LAS ARAUCARIAS', value: '2947' },
  { text: 'ESCUELA CARLOS SALINAS LAGOS', value: '2948' },
  { text: 'ESCUELA BASICA', value: '2949' },
  { text: 'ESCUELA EL EDEN', value: '2950' },
  { text: 'ESCUELA LA FLORIDA', value: '2951' },
  { text: 'ESCUELA VILLA LA PAZ', value: '2952' },
  { text: 'ESCUELA NEMESIO ANTUNEZ ZANARTU', value: '2954' },
  { text: 'ESCUELA BRILLA EL SOL', value: '2955' },
  { text: 'ESCUELA AURORA DE CHILE', value: '2956' },
  { text: 'ESCUELA UNO SAN AGUSTIN', value: '2957' },
  { text: 'ESCUELA JOSE ABELARDO NUNEZ', value: '2958' },
  { text: 'LORENZO VAROLI GHERARDI', value: '2959' },
  { text: 'ESCUELA AULAS DE ESPERANZA', value: '2961' },
  { text: 'ESCUELA LAS AMERICAS', value: '2964' },
  { text: 'ESCUELA COOPERATIVA LIRCAY', value: '2965' },
  { text: 'ESCUELA COSTANERA', value: '2966' },
  { text: 'ESCUELA EL TABACO', value: '2968' },
  { text: 'ESCUELA ESPERANZA', value: '2972' },
  { text: 'LICEO IGNACIO CARRERA PINTO', value: '2974' },
  { text: 'ESCUELA HUILQUILEMU', value: '2975' },
  { text: 'ESCUELA RAMADILLAS DE LIRCAY', value: '2976' },
  { text: 'ESCUELA VINA PURISIMA', value: '2977' },
  { text: 'ESCUELA SAN MIGUEL', value: '2978' },
  { text: 'ESCUELA EL SAUCE', value: '2979' },
  { text: 'ESCUELA SANTA MARTA', value: '2980' },
  { text: 'ESCUELA PANGUILEMO', value: '2981' },
  { text: 'ESCUELA BASICA PUERTAS NEGRAS', value: '2983' },
  { text: 'ESCUELA EL ORIENTE', value: '2986' },
  { text: 'ESCUELA CENTINELA', value: '2989' },
  { text: 'ESCUELA PARTICULAR AMOR DE DIOS', value: '2990' },
  { text: 'COLEGIO MONSENOR MANUEL LARRAIN', value: '2991' },
  { text: 'COLEGIO INTEGRADO SAN PIO X SECTOR PTE.', value: '2992' },
  { text: 'COLEGIO MARIA RAQUEL', value: '2993' },
  { text: 'ESCUELA ESPECIAL EVANGEL.PRESBITERIANA', value: '2994' },
  { text: 'INSTITUTO ANDRES BELLO', value: '2995' },
  { text: 'COLEGIO DARIO SALAS', value: '2997' },
  { text: 'COLEGIO CAMILO HENRIQUEZ', value: '2999' },
  { text: 'ESCUELA PARTICULAR MARIA MAZZARELLO', value: '3002' },
  { text: 'COLEGIO PIAGET', value: '3003' },
  { text: 'LICEO SANTA TERESITA', value: '3005' },
  { text: 'ESCUELA ABATE MOLINA DE TALCA', value: '3008' },
  { text: 'COLEGIO SAN FRANCISCO DE ASIS', value: '3010' },
  { text: 'LICEO DE PELARCO', value: '3016' },
  { text: 'ESCUELA SAN RAFAEL', value: '3017' },
  { text: 'ESCUELA SANTA RITA', value: '3019' },
  { text: 'ESCUELA ALTO PANGUE', value: '3020' },
  { text: 'ESCUELA PABLO CORREA MONTT', value: '3022' },
  { text: 'ESCUELA EL MANZANO', value: '3023' },
  { text: 'ESCUELA DANTE RONCAGLIOLO BAVESTRELLO', value: '3024' },
  { text: 'ESCUELA PANGUE ARRIBA', value: '3025' },
  { text: 'ESCUELA PANGUE ABAJO', value: '3026' },
  { text: 'ESCUELA EL MILAGRO', value: '3028' },
  { text: 'ESCUELA WILIBALDO NUNEZ', value: '3029' },
  { text: 'ESCUELA LIHUENO', value: '3030' },
  { text: 'ESCUELA PARTICULAR SAN SEBASTIAN', value: '3032' },
  { text: 'ESCUELA LUIS SANFUENTES ANDONAEGUI', value: '3034' },
  { text: 'ESCUELA EL BOLSICO', value: '3036' },
  { text: 'ESCUELA PORVENIR', value: '3037' },
  { text: 'ESCUELA LA CHISPA', value: '3038' },
  { text: 'ESCUELA ODESSA', value: '3039' },
  { text: 'ESCUELA LAS MERCEDES', value: '3040' },
  { text: 'ESCUELA EL GUINDO', value: '3042' },
  { text: 'ESCUELA EL AROMO', value: '3043' },
  { text: 'ESCUELA PENAFLOR NUEVO', value: '3044' },
  { text: 'ESCUELA SANTA HERMINIA', value: '3045' },
  { text: 'ESCUELA CASAS VIEJAS', value: '3047' },
  { text: 'ESCUELA PASO ANCHO', value: '3048' },
  { text: 'ESCUELA MAITENES', value: '3051' },
  { text: 'LICEO SAN CLEMENTE ENTRE RIOS', value: '3055' },
  { text: 'ESCUELA SAN CLEMENTE', value: '3056' },
  { text: 'ESCUELA ARTURO PRAT CHACON', value: '3057' },
  { text: 'ESCUELA AURORA', value: '3058' },
  { text: 'ESCUELA DEIDAMIA PAREDES BELLO', value: '3059' },
  { text: 'ESCUELA RAMADILLAS', value: '3060' },
  { text: 'ESCUELA PUNTA DE DIAMANTE', value: '3061' },
  { text: 'ESCUELA PEUMO NEGRO', value: '3062' },
  { text: 'ESCUELA CORRALONES', value: '3063' },
  { text: 'ESCUELA ENRIQUE CORREA GUZMAN', value: '3065' },
  { text: 'ESCUELA LEOPOLDO GUARDA GEYNTES', value: '3067' },
  { text: 'ESCUELA BELLA UNION', value: '3068' },
  { text: 'ESCUELA QUERI', value: '3069' },
  { text: 'ESCUELA CHEQUEN DE LA PENA', value: '3070' },
  { text: 'ESCUELA BAJO LIRCAY', value: '3073' },
  { text: 'ESCUELA BRAMADERO', value: '3076' },
  { text: 'ESCUELA COREL', value: '3077' },
  { text: 'ESCUELA JUAN VERGARA', value: '3078' },
  { text: 'ESCUELA ELENA BURGOS MOREIRA', value: '3079' },
  { text: 'ESCUELA SAN VALERIANO', value: '3080' },
  { text: 'ESCUELA BAJO PERQUIN', value: '3081' },
  { text: 'ESCUELA SAN DIEGO', value: '3082' },
  { text: 'ESCUELA LOS ROBLES DE VILCHES CENTRO', value: '3084' },
  { text: 'ESCUELA PASO NEVADO', value: '3085' },
  { text: 'ESCUELA LOS MONTES', value: '3086' },
  { text: 'ESCUELA VILCHES ALTO', value: '3088' },
  { text: 'ESCUELA EL COLORADO', value: '3090' },
  { text: 'ESCUELA LA CALOR', value: '3091' },
  { text: 'ESCUELA NACIONES UNIDAS', value: '3092' },
  { text: 'ESCUELA CARRETONES', value: '3093' },
  { text: 'ESCUELA LOS ALMENDROS', value: '3096' },
  { text: 'ESCUELA BASICA LA MINA', value: '3098' },
  { text: 'ESCUELA LOS TREGUILES', value: '3100' },
  { text: 'ESCUELA DE ORION', value: '3103' },
  { text: 'ESCUELA LA PLACETA', value: '3104' },
  { text: 'ESCUELA FLOR DEL LLANO', value: '3106' },
  { text: 'ESCUELA SANTA ELENA', value: '3107' },
  { text: 'ESCUELA MAULE', value: '3110' },
  { text: 'ESCUELA CALLEJONES', value: '3112' },
  { text: 'ESCUELA COLIN', value: '3113' },
  { text: 'ESCUELA CHACARILLA', value: '3114' },
  { text: 'ESCUELA RURAL DUAO', value: '3115' },
  { text: 'ESCUELA RURAL NUMPAY', value: '3117' },
  { text: 'ESCUELA QUINIPEUMO', value: '3118' },
  { text: 'ESCUELA EL BOLSICO', value: '3119' },
  { text: 'ESCUELA EL FUERTE', value: '3121' },
  { text: 'ESCUELA EL CANELO', value: '3122' },
  { text: 'ESCUELA SANTA ROSA DE LAVADEROS', value: '3123' },
  { text: 'ESCUELA LINARES DE PERALES', value: '3124' },
  { text: 'ESCUELA VILLA COBIN', value: '3125' },
  { text: 'LICEO TECNICO AGRICOLA MARIA AUXILIADORA', value: '3126' },
  { text: 'ESCUELA AGRICOLA SAN JOSE DE DUAO', value: '3127' },
  { text: 'LICEO SAN IGNACIO', value: '3128' },
  { text: 'ESCUELA SAN SEBASTIAN DE PUICO', value: '3129' },
  { text: 'ESCUELA PEDRO ANTONIO TEJOS TEJOS', value: '3130' },
  { text: 'ESCUELA MARIA OLGA VEGA VEGA', value: '3134' },
  { text: 'COMPLEJO EDUCACIONAL PENCAHUE', value: '3138' },
  { text: 'ESCUELA PADRE LUIS OLIVA NAVARRETE', value: '3139' },
  { text: 'ESCUELA CORINTO', value: '3140' },
  { text: 'ESCUELA JOSE MANUEL SALCEDO RAMIREZ', value: '3141' },
  { text: 'ESCUELA SANTA LAURA DE LO FIGUEROA', value: '3143' },
  { text: 'ESCUELA LA ESPERANZA DEL FUTURO', value: '3146' },
  { text: 'ESCUELA TAPIHUE', value: '3156' },
  { text: 'ESCUELA LA PATAGUA', value: '3158' },
  { text: 'ESCUELA RIVERA DEL MAULE', value: '3159' },
  { text: 'ESCUELA PALMAS DE TOCONEY', value: '3161' },
  { text: 'ESCUELA BANOS DE  TANHUAO', value: '3162' },
  { text: 'ESCUELA ENRIQUE DONN MULLER', value: '3166' },
  { text: 'ESCUELA SUPERIOR NUEVA BILBAO', value: '3168' },
  { text: 'ESCUELA CERRO ALTO JOSE OPAZO DIAZ', value: '3169' },
  { text: 'MAESTRA M.FRESIA HORMAZABAL LETELIER', value: '3170' },
  { text: 'LICEO RURAL PUTU', value: '3172' },
  { text: 'LICEO RURAL ENRIQUE MAC IVER', value: '3173' },
  { text: 'ESCUELA LAS CORRIENTES', value: '3174' },
  { text: 'ESCUELA JUNQUILLAR', value: '3176' },
  { text: 'ESCUELA MARIA INES MAROMILLAS', value: '3177' },
  { text: 'ESCUELA BARRANQUILLAS', value: '3179' },
  { text: 'ESCUELA RURAL LAGUNILLAS', value: '3182' },
  { text: 'ESCUELA PROSPERO GONZALEZ CIENFUEGOS', value: '3183' },
  { text: 'ESCUELA COSTA BLANCA', value: '3185' },
  { text: 'ESCUELA LOS PINOS DE SAN PEDRO', value: '3186' },
  { text: 'ESCUELA CARRIZALILLO', value: '3187' },
  { text: 'ESCUELA RURAL RIVERA DEL MAULE', value: '3188' },
  { text: 'ESCUELA TERESA CONSUELO', value: '3189' },
  { text: 'ESCUELA RURAL QUEBRADA VERDE', value: '3190' },
  { text: 'ESCUELA SANTA AURORA DE CARRIZAL', value: '3191' },
  { text: 'ESCUELA BELLAS BRISAS  COIPUE', value: '3193' },
  { text: 'ESCUELA LEONTINA LETELIER LETELIER', value: '3196' },
  { text: 'ESCUELA LA QUEBRADA   PICHAMAN', value: '3197' },
  { text: 'ESCUELA EDUARDO MACHADO CORSI', value: '3198' },
  { text: 'ESCUELA PARTICULAR SANTA ROSA', value: '3201' },
  { text: 'COLEGIO SANTIAGO ONEDERRA', value: '3203' },
  { text: 'ESCUELA FRAY PEDRO ARMENGOL VALENZUELA', value: '3206' },
  { text: 'ESCUELA PEDRO ANTONIO GONZALEZ', value: '3207' },
  { text: 'ESCUELA LAS MERCEDES', value: '3208' },
  { text: 'ESCUELA ELENA ARMIJO MORALES', value: '3209' },
  { text: 'ESCUELA ANA LUISA ESPINA RIVERO', value: '3212' },
  { text: 'ESCUELA LA TRICHERA', value: '3213' },
  { text: 'ESCUELA EL SANTO DE TABUNCO', value: '3215' },
  { text: 'ESCUELA CAPILLA DE RAPILERMO', value: '3216' },
  { text: 'ESCUELA JUAN JESUS GONZALEZ AVENDA\u00c3\u2018O', value: '3217' },
  { text: 'ESCUELA LA ORILLA', value: '3219' },
  { text: 'ESCUELA DOCAMAVIDA', value: '3221' },
  { text: 'ESCUELA CARMEN ROSA MARTINEZ BAEZA', value: '3222' },
  { text: 'ESCUELA DOMULGO', value: '3223' },
  { text: 'ESCUELA HORNILLOS', value: '3225' },
  { text: 'ESCUELA MANANTIALES', value: '3229' },
  { text: 'ESCUELA JOSE LUIS RICHARDS GONZALEZ', value: '3230' },
  { text: 'ESCUELA PUPILLA', value: '3232' },
  { text: 'ESCUELA JOSE MIGUEL CARRERA', value: '3233' },
  { text: 'ESCUELA MAURICIO LETELIER LETELIER', value: '3235' },
  { text: 'ESCUELA QUEBRADA DE LOS GUINDOS', value: '3236' },
  { text: 'ESCUELA MARINA ROJAS SANDOVAL', value: '3238' },
  { text: 'ESCUELA MARIA PETRONILA CASTRO G.', value: '3239' },
  { text: 'ESCUELA GASPAR HERRERA HERRERA', value: '3240' },
  { text: 'ESCUELA SAN FRANCISCO DE ASIS', value: '3242' },
  { text: 'ESCUELA ALAMEDA LINARES', value: '3243' },
  { text: 'ESCUELA ESPECIAL LAS VIOLETAS', value: '3244' },
  { text: 'ESCUELA MAIPU', value: '3249' },
  { text: 'ESCUELA PRESIDENTE CARLOS IBANEZ DEL C.', value: '3250' },
  { text: 'ESCUELA REPUBLICA DE FRANCIA', value: '3251' },
  { text: 'LICEO TECNICO PROFESIONAL DIEGO PORTALES', value: '3252' },
  { text: 'JUAN MARTINEZ DE ROZAS', value: '3253' },
  { text: 'ESCUELA ISABEL RIQUELME', value: '3254' },
  { text: 'ESCUELA SANTA BARBARA', value: '3255' },
  { text: 'ESCUELA RAMON BELMAR SALDIAS', value: '3256' },
  { text: 'ESCUELA ALEJANDRO GIDI', value: '3257' },
  { text: 'ESCUELA BASICA ESPANA', value: '3258' },
  { text: 'ESCUELA LOS LEONES', value: '3260' },
  { text: 'PEDRO AGUIRRE CERDA', value: '3261' },
  { text: 'ESCUELA MAITENES', value: '3263' },
  { text: 'ESCUELA SAN VICTOR ALAMOS', value: '3264' },
  { text: 'ESCUELA LAS TOSCAS', value: '3265' },
  { text: 'ESCUELA SAN ANTONIO', value: '3266' },
  { text: 'ESCUELA GRACIELA LETELIER', value: '3267' },
  { text: 'ESCUELA SALOMON SALMAN DABUD', value: '3268' },
  { text: 'ESCUELA LAS HORNILLAS', value: '3269' },
  { text: 'JANUARIO ESPINOSA', value: '3270' },
  { text: 'ESCUELA LOS HUALLES', value: '3271' },
  { text: 'ESCUELA CHUPALLAR', value: '3272' },
  { text: 'ESCUELA MATIAS COUSINO', value: '3273' },
  { text: 'ESCUELA CAJON DE PEJERREY', value: '3274' },
  { text: 'ESCUELA HUAPI BAJO', value: '3275' },
  { text: 'ESCUELA DE PEJERREY', value: '3277' },
  { text: 'ESCUELA EL EMBOQUE', value: '3278' },
  { text: 'ESCUELA LOS MONTECILLOS', value: '3279' },
  { text: 'ESCUELA EMBALSE ANCOA', value: '3280' },
  { text: 'ESCUELA LOS BATROS', value: '3281' },
  { text: 'ESCUELA EL CULMEN', value: '3282' },
  { text: 'ESCUELA PAUL HARRIS', value: '3283' },
  { text: 'ESCUELA VIOLETA PARRA', value: '3284' },
  { text: 'ESCUELA FRANCISCO MESA SECO', value: '3285' },
  { text: 'ESCUELA BELLAVISTA', value: '3286' },
  { text: 'ESCUELA LOS MOGOTES', value: '3287' },
  { text: 'ESCUELA CAMILO HENRIQUEZ', value: '3288' },
  { text: 'ESCUELA DE ROBLERIA', value: '3289' },
  { text: 'ESCUELA BASICA ALCALDE HECTOR PINOCHET C', value: '3291' },
  { text: 'ESCUELA PARTICULAR GABRIELA MISTRAL', value: '3292' },
  { text: 'COLEGIO PARTICULAR MANUEL BULNES', value: '3294' },
  { text: 'ESC.AGRIC.PART.SALESIANA DON BOSCO', value: '3296' },
  { text: 'ESCUELA PARTICULAR PROSPERO VILLAR BRAVO', value: '3297' },
  { text: 'ESCUELA MARCELA PAZ', value: '3299' },
  { text: 'COLEGIO LA PROVIDENCIA', value: '3302' },
  { text: 'COLEGIO AMELIA TRONCOSO', value: '3303' },
  { text: 'COLEGIO SAN MIGUEL ARCANGEL', value: '3304' },
  { text: 'LICEO POLITECNICO DE LINARES', value: '3305' },
  { text: 'COLEGIO CONCEPCION LINARES', value: '3308' },
  { text: 'COLEGIO EVANGELICO ADONAY', value: '3310' },
  { text: 'ESCUELA LUCILA GODOY', value: '3311' },
  { text: 'LICEO JUAN DE DIOS PUGA', value: '3313' },
  { text: 'ESCUELA MAITENCILLO', value: '3314' },
  { text: 'ESCUELA SILVANO FERNANDEZ', value: '3315' },
  { text: 'ESCUELA SANTA ANA DE QUERI', value: '3316' },
  { text: 'LICEO JUAN GOMEZ MILLAS', value: '3317' },
  { text: 'ESCUELA JORGE SALGADO PICA', value: '3318' },
  { text: 'ESCUELA ALFREDO NOGUERA PRIETO', value: '3319' },
  { text: 'ESCUELA BERNARDO OHIGGINS', value: '3320' },
  { text: 'ESCUELA SANTA ELENA', value: '3321' },
  { text: 'ESCUELA COIRONAL', value: '3322' },
  { text: 'ESCUELA LUIS AMBROSIO CONCHA', value: '3323' },
  { text: 'ESCUELA PARTICULAR ARTURO PRAT', value: '3325' },
  { text: 'ESCUELA AGRICOLA MARTA MARTINEZ CRUZ', value: '3327' },
  { text: 'LICEO CAPITAN IGNACIO CARRERA PINTO', value: '3328' },
  { text: 'ESCUELA MAULE SUR', value: '3329' },
  { text: 'ESCUELA LA FLORESTA', value: '3330' },
  { text: 'ESCUELA ANDRES BELLO', value: '3332' },
  { text: 'ESCUELA CARLOS DEL CAMPO RIVERA', value: '3333' },
  { text: 'ESCUELA MONSENOR MANUEL LARRAIN E.', value: '3334' },
  { text: 'ESCUELA PANIMAVIDA', value: '3335' },
  { text: 'ESCUELA RARI', value: '3336' },
  { text: 'ESCUELA AMALIA AMSTRONG DE TORRES', value: '3337' },
  { text: 'ESCUELA KURT MOLLER BOCHERENS', value: '3338' },
  { text: 'ESCUELA LA GUARDIA', value: '3340' },
  { text: 'ESCUELA LOS BOLDOS', value: '3344' },
  { text: 'ESCUELA  LOMAS DE PUTAGAN', value: '3345' },
  { text: 'ESCUELA SANTA ELENA', value: '3346' },
  { text: 'ESCUELA PARTICULAR MARTA BRUNET', value: '3347' },
  { text: 'LICEO ARTURO ALESSANDRI PALMA', value: '3348' },
  { text: 'ESCUELA JUAN DE LA CRUZ DOMINGUEZ G.', value: '3349' },
  { text: 'ESCUELA ANSELMO DEL CARMEN TAPIA LOYOLA', value: '3352' },
  { text: 'ESCUELA ROBERTO OPAZO GALVEZ', value: '3353' },
  { text: 'ESCUELA ONOFRE VASQUEZ NORAMBUENA', value: '3354' },
  { text: 'ESCUELA GABRIELA MISTRAL', value: '3355' },
  { text: 'ESCUELA CARDENAL JOSE MARIA CARO', value: '3356' },
  { text: 'ESCUELA JOSE MIGUEL CARRERA', value: '3358' },
  { text: 'LICEO LAURA URRUTIA BENAVENTE', value: '3359' },
  { text: 'ESCUELA FRANCISCO URRUTIA URRUTIA', value: '3361' },
  { text: 'ESCUELA GABRIEL BENAVENTE BENAVENTE', value: '3362' },
  { text: 'ESCUELA LUIS PEREIRA INIGUEZ', value: '3364' },
  { text: 'ESCUELA MARIA AMBROSIA TAPIA MENDEZ', value: '3365' },
  { text: 'ESCUELA CARLOS MONTERO JARAMILLO', value: '3366' },
  { text: 'ESCUELA DOMINGA CUELLAR IBANEZ', value: '3367' },
  { text: 'ESCUELA JUAN SEGUNDO MUNOZ BRIONES', value: '3368' },
  { text: 'ESCUELA ROBERTO MUNOZ VALDES', value: '3369' },
  { text: 'ESCUELA PAULA JARAQUEMADA', value: '3371' },
  { text: 'ESCUELA EL CARMEN', value: '3373' },
  { text: 'ESCUELA CARLOS CONDELL', value: '3375' },
  { text: 'ESCUELA MARCELA PAZ', value: '3376' },
  { text: 'ESCUELA MANUEL ROZAS ARISTIA', value: '3377' },
  { text: 'ESCUELA SOFIA VASQUEZ REBOLLEDO', value: '3378' },
  { text: 'ESCUELA ANGEL CRUCHAGA SANTA MARIA', value: '3381' },
  { text: 'ESCUELA PEDRO ALESSANDRI VARGAS', value: '3382' },
  { text: 'ESCUELA SANTIAGO BUERAS AVARIA', value: '3383' },
  { text: 'ESCUELA RAMBERTO CARRERA MARTINEZ', value: '3384' },
  { text: 'ESCUELA PARTICULAR NRO 9 LOS CERRILLOS', value: '3385' },
  { text: 'LICEO FEDERICO HEISE MARTI', value: '3387' },
  { text: 'ESCUELA SANTIAGO URRUTIA BENAVENTE', value: '3389' },
  { text: 'ESCUELA LUIS ARMANDO GOMEZ MUNOZ', value: '3390' },
  { text: 'ESCUELA ARRAU MENDEZ', value: '3393' },
  { text: 'ESCUELA NIDER ORREGO QUEVEDO', value: '3395' },
  { text: 'ESCUELA JUANITA ZUNIGA FUENTES', value: '3396' },
  { text: 'ESCUELA MAGDALENA HERNANDEZ BELMAR', value: '3397' },
  { text: 'ESCUELA JOSE MATTA CALLEJON', value: '3398' },
  { text: 'COLEGIO ALBERTO MOLINA CASTILLO', value: '3400' },
  { text: 'ESCUELA EL LIBERTADOR', value: '3401' },
  { text: 'ESCUELA PALMA ROSA', value: '3402' },
  { text: 'ESCUELA MANUEL MEJIAS MILLAR', value: '3403' },
  { text: 'ESCUELA IGNACIO URRUTIA DE LA SOTTA', value: '3404' },
  { text: 'ESCUELA ARMANDO GUZMAN MORALES', value: '3405' },
  { text: 'ESCUELA CARLOS ZINIGA FUENTES', value: '3406' },
  { text: 'ESCUELA FRANCISCO MAUREIRA', value: '3408' },
  { text: 'ESCUELA TITINVILO', value: '3409' },
  { text: 'ESC.HORACIO VILLABLANCA HERNANDEZ', value: '3411' },
  { text: 'ESCUELA FUERTE VIEJO', value: '3412' },
  { text: 'ESCUELA VILLA REINA', value: '3413' },
  { text: 'ESCUELA PERQUILAUQUEN SANTA MARIA', value: '3415' },
  { text: 'ESCUELA SOLANO CASTILLO TAPIA', value: '3417' },
  { text: 'ESCUELA RAFAEL RETAMAL LOPEZ', value: '3418' },
  { text: 'ESCUELA EL CIENAGO', value: '3419' },
  { text: 'ESCUELA UNICAVEN', value: '3420' },
  { text: 'ESCUELA JUAN BULNES ALDUNATE', value: '3421' },
  { text: 'ESCUELA LA FORTUNA', value: '3429' },
  { text: 'INSTITUTO PARRAL', value: '3430' },
  { text: 'COLEGIO SAN JOSE', value: '3431' },
  { text: 'COLEGIO CONCEPCION  DE PARRAL', value: '3433' },
  { text: 'LICEO GUILLERMO MARIN LARRAIN', value: '3434' },
  { text: 'ESCUELA MANUEL MONTT', value: '3435' },
  { text: 'ESCUELA COPIHUE', value: '3436' },
  { text: 'ESCUELA RAMON BARROS LUCO', value: '3437' },
  { text: 'ESCUELA SAN ISIDRO', value: '3439' },
  { text: 'ESCUELA GERTRUDIS ALARCON ARCE', value: '3440' },
  { text: 'COLEGIO AJIAL', value: '3442' },
  { text: 'ESCUELA LOS CUARTELES', value: '3443' },
  { text: 'ESCUELA AMANDA BENAVENTE D.', value: '3444' },
  { text: 'ESCUELA ROMERAL', value: '3445' },
  { text: 'ESCUELA SANTA ADRIANA', value: '3447' },
  { text: 'ESCUELA SANTA ISABEL', value: '3448' },
  { text: 'ESCUELA SAN RAMON', value: '3449' },
  { text: 'ESCUELA SANTA DELFINA', value: '3450' },
  { text: 'ESCUELA SAN NICOLAS', value: '3451' },
  { text: 'ESCUELA PATRICIO LARRAIN VALENZUELA', value: '3452' },
  { text: 'ESCUELA SANTA CECILIA', value: '3453' },
  { text: 'ESCUELA LOS ROBLES', value: '3454' },
  { text: 'ESCUELA MANTUL', value: '3457' },
  { text: 'ESCUELA MARIA IGNACIA MENA MONROY', value: '3458' },
  { text: 'ESCUELA LA CAPILLA', value: '3459' },
  { text: 'COLEGIO POLIVALENTE LAS CAMELIAS', value: '3460' },
  { text: 'LICEO FRANCISCO ANTONIO ENCINA ARMANET', value: '3461' },
  { text: 'ESCUELA TIMOTEO ARAYA ALEGRIA', value: '3462' },
  { text: 'ESCUELA MALAQUIAS CONCHA ORTIZ', value: '3463' },
  { text: 'ESCUELA HERNAN LOBOS ARIAS', value: '3464' },
  { text: 'ESCUELA ALCALDE SERAFIN GUTIERREZ F.', value: '3465' },
  { text: 'ESCUELA ALCALDE ORLANDO RODRIGUEZ DEL C.', value: '3466' },
  { text: 'ESCUELA ALCALDE MANUEL SALVADOR DEL C.', value: '3467' },
  { text: 'ESCUELA ASCENCIO ASTORQUIZA ZABALA', value: '3468' },
  { text: 'ESCUELA TRINIDAD ALCAINO TAPIA', value: '3470' },
  { text: 'ESCUELA PROFESOR RAMON LEIVA NARVAEZ', value: '3471' },
  { text: 'ESCUELA JOSE PALMA FERNANDEZ', value: '3475' },
  { text: 'ESCUELA AGRICOLA SAGRADOS CORAZONES', value: '3478' },
  { text: 'ESCUELA JOSE MANUEL BALMACEDA', value: '3480' },
  { text: 'ESCUELA MANUEL DE SALAS', value: '3481' },
  { text: 'ESCUELA JUSTA NARVAEZ', value: '3482' },
  { text: 'ESCUELA GERONIMO LAGOS LISBOA', value: '3483' },
  { text: 'ESCUELA DE EDUCACION DIFERENCIAL', value: '3484' },
  { text: 'ESCUELA IRENE MORALES', value: '3488' },
  { text: 'ESCUELA JORGE GONZALEZ BASTIAS', value: '3489' },
  { text: 'ESCUELA JULIO MONTT SALAMANCA', value: '3490' },
  { text: 'ESCUELA JUAN DE DIOS ALDEA', value: '3491' },
  { text: 'ESCUELA BERNARDO OHIGGINS', value: '3492' },
  { text: 'ESCUELA MANUEL RODRIGUEZ', value: '3494' },
  { text: 'ESCUELA PEDRO LAGOS', value: '3495' },
  { text: 'ESCUELA JOSE MIGUEL CARRERA', value: '3497' },
  { text: 'ESCUELA AURORA DE CHILE', value: '3499' },
  { text: 'ESCUELA DIEGO DE ALMAGRO', value: '3501' },
  { text: 'ADELAIDA RIQUELME MESA', value: '3502' },
  { text: 'ESCUELA PATRICIO LINCH', value: '3503' },
  { text: 'ESCUELA INES DE SUAREZ', value: '3506' },
  { text: 'ESCUELA ERNESTO RIQUELME', value: '3509' },
  { text: 'ESCUELA IGNACIO SERRANO', value: '3513' },
  { text: 'ESCUELA RAMON CARNICER', value: '3515' },
  { text: 'ESCUELA CANDELARIA PEREZ', value: '3517' },
  { text: 'ESCUELA MARIANO EGANA', value: '3518' },
  { text: 'ESCUELA MARIANO LATORRE', value: '3520' },
  { text: 'ESCUELA ELEUTERIO RAMIREZ', value: '3521' },
  { text: 'ESCUELA CARLOS CONDELL', value: '3523' },
  { text: 'ESCUELA MANUEL BULNES', value: '3524' },
  { text: 'ESCUELA AURELIO MEZA RIVERA', value: '3526' },
  { text: 'ESCUELA CAMILA MATTA VIAL', value: '3527' },
  { text: 'ESCUELA LA CONCEPCION', value: '3528' },
  { text: 'COLEGIO PARTICULAR SAN JOSE', value: '3530' },
  { text: 'COLEGIO PARTICULAR PIAGET', value: '3532' },
  { text: 'COLEGIO AMANECER', value: '3534' },
  { text: 'ESCUELA MARIANO LATORRE', value: '3535' },
  { text: 'ESCUELA ESPECIAL HORIZONTE', value: '3537' },
  { text: 'LICEO CLAUDINA URRUTIA DE LAVIN', value: '3539' },
  { text: 'LICEO POLITECNICO PEDRO AGUIRRE CERDA', value: '3540' },
  { text: 'ESCUELA ANIBAL PINTO', value: '3541' },
  { text: 'COLEGIO BLANCO ENCALADA', value: '3544' },
  { text: 'ESCUELA BARRIO ESTACION', value: '3545' },
  { text: 'ESCUELA INDEPENDENCIA', value: '3546' },
  { text: 'ESCUELA ROSITA OHIGGINS', value: '3548' },
  { text: 'ESCUELA PORONGO', value: '3549' },
  { text: 'ESCUELA PURISIMA CONCEPCION DE POCILLAS', value: '3550' },
  { text: 'ESCUELA LOS CONQUISTADORES', value: '3551' },
  { text: 'ESCUELA ADOLFO QUIROZ HERNANDEZ', value: '3552' },
  { text: 'ESCUELA CLORINDO ALVEAR', value: '3554' },
  { text: 'ESCUELA OCTAVIO PALMA PEREZ', value: '3555' },
  { text: 'ESCUELA IVAN ALEJANDRO DE LA CUADRA', value: '3559' },
  { text: 'ESCUELA HECTOR SILVESTRE PAIVA MANRIQUEZ', value: '3564' },
  { text: 'ESCUELA CARLOS RODRIGUEZ URRUTIA', value: '3566' },
  { text: 'ESCUELA GUSTAVO ILUFI ILUFI', value: '3568' },
  { text: 'ESCUELA JAVIERA CARRERA', value: '3569' },
  { text: 'ESCUELA PEDRO DE VALDIVIA', value: '3573' },
  { text: 'ESCUELA RINCON DE PILEN', value: '3579' },
  { text: 'ESCUELA PEDERNALES', value: '3580' },
  { text: 'ESCUELA PADRE HURTADO', value: '3582' },
  { text: 'ESCUELA MARIA GONZALEZ VERA', value: '3583' },
  { text: 'ESCUELA CHORRILLOS', value: '3586' },
  { text: 'ESCUELA ESTER URRUTIA DE RUIZ', value: '3588' },
  { text: 'ESCUELA MARIA RUIZ MARTINEZ', value: '3594' },
  { text: 'ESCUELA LA CAPILLA DE PILEN ALTO', value: '3596' },
  { text: 'ESCUELA MIXTA ATENEA', value: '3599' },
  { text: 'ESCUELA LA  PATAGUA', value: '3601' },
  { text: 'ESCUELA EL TROZO', value: '3602' },
  { text: 'ESCUELA CABRERIA', value: '3604' },
  { text: 'ESCUELA SANTA ADRIANA', value: '3607' },
  { text: 'LICEO INMACULADA CONCEPCION', value: '3608' },
  { text: 'LICEO PELLUHUE', value: '3609' },
  { text: 'ESCUELA CURANIPE', value: '3610' },
  { text: 'ESCUELLA BLANCA BUSTOS CASTILLO', value: '3611' },
  { text: 'ESCUELA SAN ALFONSO CANELILLO', value: '3612' },
  { text: 'ESCUELA LAS POCILLAS', value: '3613' },
  { text: 'ESCUELA JOSE RIVAS HERNANDEZ', value: '3614' },
  { text: 'ESCUELA ESCRITORA MARCELA PAZ', value: '3615' },
  { text: 'ESCUELA JOSE JUVENAL MANCILLA', value: '3616' },
  { text: 'LICEO FEDERICO ALBERT FAUPP', value: '3618' },
  { text: 'ESCUELA LOS HEROES', value: '3619' },
  { text: 'ESCUELA SAN AMBROSIO', value: '3621' },
  { text: 'ESCUELA PAHUIL', value: '3622' },
  { text: 'ESCUELA CARRERAS CORTAS', value: '3623' },
  { text: 'ESCUELA LOS PEUMOS', value: '3624' },
  { text: 'ESCUELA GABRIELA MISTRAL', value: '3625' },
  { text: 'ESCUELA RELOCA', value: '3626' },
  { text: 'ESCUELA EL SAUCE', value: '3629' },
  { text: 'ESCUELA RICARDO SALGADO', value: '3630' },
  { text: 'ESCUELA EMA VASQUEZ GUTIERREZ', value: '3631' },
  { text: 'ESCUELA ANTONIETA LEON VERDUGO', value: '3632' },
  { text: 'ESCUELA QUINIPATO', value: '3633' },
  { text: 'ESCUELA SANTA ROSA', value: '3635' },
  { text: 'ESCUELA LOANCO', value: '3636' },
  { text: 'ESCUELA EL PORVENIR', value: '3637' },
  { text: 'LICEO MARTA BRUNET', value: '3638' },
  { text: 'LICEO NARCISO TONDREAU', value: '3639' },
  { text: 'INSTITUTO INDUSTRIAL SUPERIOR DE CHILLAN', value: '3641' },
  { text: 'INSTITUTO TECNICO MABEL CONDEMARIN GRIMBE', value: '3642' },
  { text: 'LICEO MARTIN RUIZ DE GAMBOA', value: '3643' },
  { text: 'ESCUELA NUEVA ESPERANZA', value: '3644' },
  { text: 'LICEO NUEVA VIDA', value: '3645' },
  { text: 'ESCUELA ESPECIAL LAS ACACIAS', value: '3649' },
  { text: 'ESCUELA PARVULARIA FEDERICO FROEBEL', value: '3650' },
  { text: 'ESCUELA BASICA DIEGO BARROS ARANA', value: '3653' },
  { text: 'ESCUELA BASICA LOS HEROES', value: '3654' },
  { text: 'LICEO JUAN PACHECO ALTAMIRANO', value: '3656' },
  { text: 'ESC. BASICA GRAL. L. BERNARDO OHIGGINS', value: '3657' },
  { text: 'ESCUELA REPUBLICA DE ISRAEL', value: '3658' },
  { text: 'ESCUELA ARTURO MERINO BENITEZ', value: '3659' },
  { text: 'ESCUELA GABRIELA MISTRAL', value: '3660' },
  { text: 'ESCUELA JAVIERA CARRERA VERDUGO', value: '3661' },
  { text: 'ESCUELA REPUBLICA DE ITALIA', value: '3662' },
  { text: 'ESCUELA REPUBLICA DE MEXICO', value: '3663' },
  { text: 'ESCUELA BASICA EL TEJAR', value: '3664' },
  { text: 'ESCUELA MARIA AMALIA SAAVEDRA MARTINEZ', value: '3666' },
  { text: 'ESCUELA BASICA LA CASTILLA', value: '3667' },
  { text: 'ESCUELA PALESTINA', value: '3668' },
  { text: 'ESCUELA BASICA ROSITA OHIGGINS R', value: '3669' },
  { text: 'ESCUELA BASICA REYES DE ESPANA', value: '3670' },
  { text: 'ESCUELA BASICA JUAN MADRID AZOLA', value: '3671' },
  { text: 'ESC. BASICA ARTURO MUTIZABAL SOTOMAYOR', value: '3672' },
  { text: 'ESCUELA BASICA QUILAMAPU', value: '3673' },
  { text: 'ESCUELA REPUBLICA DE PORTUGAL', value: '3674' },
  { text: 'ESCUELA BASICA JOSE MARIA CARO RODRIGUEZ', value: '3675' },
  { text: 'ESCUELA BASICA LAS CANOAS', value: '3677' },
  { text: 'ESCUELA 27 DE ABRIL', value: '3678' },
  { text: 'ESCUELA BASICA CAPILLA COX', value: '3681' },
  { text: 'ESCUELA BASICA RUCAPEQUEN', value: '3683' },
  { text: 'ESCUELA BASICA QUINCHAMALI', value: '3685' },
  { text: 'ESCUELA BASICA NEBUCO', value: '3686' },
  { text: 'ESCUELA BASICA EL PEUMO', value: '3687' },
  { text: 'ESCUELA BASICA CURICA', value: '3688' },
  { text: 'ESCUELA BASICA CASERIO LINARES', value: '3689' },
  { text: 'ESCUELA BASICA NUBLE ALTO', value: '3690' },
  { text: 'ESCUELA PAUL HARRIS', value: '3691' },
  { text: 'ESCUELA BASICA LAS COLES', value: '3692' },
  { text: 'ESCUELA BASICA LLOLLINCO', value: '3694' },
  { text: 'ESCUELA BASICA ORO VERDE', value: '3695' },
  { text: 'ESCUELA BASICA CONFLUENCIA', value: '3697' },
  { text: 'ESCUELA BASICA QUILMO', value: '3698' },
  { text: 'ESCUELA BASICA RINCONADA DE CATO', value: '3699' },
  { text: 'ESCUELA ANTONIO MACHADO', value: '3703' },
  { text: 'ESCUELA BASICA COLLIGUAY', value: '3704' },
  { text: 'ESCUELA BASICA BOVEN', value: '3705' },
  { text: 'ESCUELA LOS JARDINES DE LAUTARO', value: '3707' },
  { text: 'ESCUELA BASICA LOS COLIGUES', value: '3709' },
  { text: 'ESCUELA BASICA PUENTE EL ALA', value: '3710' },
  { text: 'ESCUELA PARTICULAR ADVENTISTA', value: '3714' },
  { text: 'ESCUELA BASICA PARTICULAR EL LIBERTADOR', value: '3716' },
  { text: 'ESCUELA PARTICULAR HISPANO AMERICANO', value: '3717' },
  { text: 'COLEGIO COYAM', value: '3719' },
  { text: 'DEUTSCHE SCHULE CHILLAN', value: '3720' },
  { text: 'COLEGIO DARIO SALAS', value: '3723' },
  { text: 'CENTRO INTEGRAL DE EDUCACION ESPECIAL', value: '3725' },
  { text: 'ESCUELA PAULA JARA QUEMADA', value: '3726' },
  { text: 'ESCUELA BASICA DIFERENCIAL EL ROBLE', value: '3727' },
  { text: 'COLEGIO SAN BUENAVENTURA', value: '3728' },
  { text: 'COLEGIO SAN VALENTIN', value: '3731' },
  { text: 'COLEGIO PARTICULAR GABRIELA MISTRAL', value: '3733' },
  { text: 'COLEGIO COMEWEALTH SCHOOL', value: '3734' },
  { text: 'LICEO TECNICO PROFESIONAL SAN RAFAEL', value: '3738' },
  { text: 'LICEO AGRICOLA A-8 DE CHILLAN', value: '3739' },
  { text: 'ESCUELA GENERAL DOMINGO URRUTIA', value: '3740' },
  { text: 'LICEO POLITECNICO CAP. IGNACIO CARRERA P', value: '3742' },
  { text: 'ESCUELA DIEGO PORTALES PALAZUELOS', value: '3743' },
  { text: 'ESCUELA GRAL.JOSE MIGUEL CARRERA VERDUGO', value: '3744' },
  { text: 'ESCUELA GRAL SOFANOR PARRA HERMOSILLA', value: '3745' },
  { text: 'ESCUELA FRANCISCO MOYA CLEMENT', value: '3747' },
  { text: 'ESC.DE EDUC.DIF.DE NINOS DEF.MEN.RENACER', value: '3748' },
  { text: 'ESCUELA JOAQUIN DEL PINO ROZAS Y NEGRETE', value: '3749' },
  { text: 'ESCUELA SANTA LAURA', value: '3752' },
  { text: 'ESCUELA BULI', value: '3754' },
  { text: 'ESCUELA NINQUIHUE', value: '3755' },
  { text: 'ESCUELA QUILLAHUA', value: '3756' },
  { text: 'ESCUELA AGUA BUENA', value: '3757' },
  { text: 'ESCUELA EL CARBON', value: '3758' },
  { text: 'ESCUELA CACHAPOAL', value: '3759' },
  { text: 'ESCUELA RIBERA DE NUBLE', value: '3760' },
  { text: 'ESCUELA MONTE BLANCO', value: '3762' },
  { text: 'ESCUELA GAONA', value: '3764' },
  { text: 'ESCUELA QUINQUEHUA', value: '3766' },
  { text: 'ESCUELA LAS ARBOLEDAS', value: '3768' },
  { text: 'ESCUELA MUTICURA', value: '3770' },
  { text: 'ESCUELA QUILELTO', value: '3776' },
  { text: 'ESCUELA MILLAUQUEN', value: '3781' },
  { text: 'ESC. MANUEL ANTONIO CASTILLO VELASCO', value: '3782' },
  { text: 'ESCUELAS LAS JUNTAS', value: '3783' },
  { text: 'ESCUELA JUNQUILLO', value: '3784' },
  { text: 'ESCUELA TRES ESQUINAS', value: '3785' },
  { text: 'ESCUELA EL SAUCE', value: '3786' },
  { text: 'ESCUELA SANTA ROSA', value: '3789' },
  { text: 'ESCUELA EL TORREON', value: '3791' },
  { text: 'ESCUELA SAN JORGE DE NIQUEN', value: '3798' },
  { text: 'ESCUELA CHACAY', value: '3799' },
  { text: 'LICEO TIUQUILEMU', value: '3800' },
  { text: 'ESCUELA NIQUEN', value: '3801' },
  { text: 'LICEO SAN GREGORIO', value: '3802' },
  { text: 'ESCUELA HUENUTIL DE LA CABRERIA', value: '3803' },
  { text: 'ESCUELA ZEMITA', value: '3804' },
  { text: 'ESCUELA BELEN', value: '3807' },
  { text: 'ESCUELA LA GLORIA', value: '3808' },
  { text: 'ESCUELA LAS ROSAS', value: '3814' },
  { text: 'ESCUELA PUERTAS DE VIRGUIN', value: '3815' },
  { text: 'ESCUELA COLVINDO', value: '3818' },
  { text: 'ESCUELA BULI-CASERIO', value: '3820' },
  { text: 'LICEO JORGE ALESSANDRI RODRIGUEZ', value: '3823' },
  { text: 'ESCUELA BASICA LOS COIGUES', value: '3828' },
  { text: 'ESCUELA BASICA EL CARACOL', value: '3829' },
  { text: 'ESCUELA BASICA PASO ANCHO', value: '3831' },
  { text: 'ESCUELA BASICA FABIAN DE LA FUENTE', value: '3832' },
  { text: 'ESCUELA BASICA TRABUNCURA', value: '3833' },
  { text: 'ESCUELA BASICA GUILLERMINA DRAKE WOOD', value: '3835' },
  { text: 'ESCUELA DOMITILA URREJOLA MENCHAC', value: '3836' },
  { text: 'ESCUELA ENRIQUE GRAF REYES', value: '3837' },
  { text: 'ESCUELA BASICA TANILVORO', value: '3838' },
  { text: 'ESCUELA TALQUIPEN', value: '3839' },
  { text: 'ESCUELA BASICA NIBLINTO', value: '3840' },
  { text: 'ESCUELA GUARDIA MARINA ERNESTO RIQUELME', value: '3841' },
  { text: 'ESCUELA HEROES DE IQUIQUE', value: '3842' },
  { text: 'ESCUELA PORVENIR DE CATO', value: '3843' },
  { text: 'ESCUELA MANUEL MONTT', value: '3845' },
  { text: 'ESCUELA BASICA EMBALSE', value: '3846' },
  { text: 'ESCUELA CAMILO HENRIQUEZ', value: '3849' },
  { text: 'ESCUELA JUAN JOSE SAN MARTIN', value: '3850' },
  { text: 'ESCUELA HERNAN MERINO CORREA', value: '3851' },
  { text: 'ESCUELA ANIBAL PINTO', value: '3852' },
  { text: 'ESCUELA JULIO MONTT SALAMANCA', value: '3853' },
  { text: 'ESCUELA CANCHA RAYADA', value: '3854' },
  { text: 'ESCUELA GRAL. PEDRO LAGOS MARCHANT', value: '3855' },
  { text: 'ESCUELA MANUEL MATUS HERMOSILLA', value: '3856' },
  { text: 'ESCUELA BENJAMIN VICUNA MACKENNA', value: '3857' },
  { text: 'ESCUELA SAN ANTONIO DE FRUTILLARES', value: '3859' },
  { text: 'ESCUELA JUAN DE DIOS ALDEA', value: '3862' },
  { text: 'ESCUELA JOSE JOAQUIN PRIETO', value: '3863' },
  { text: 'ESCUELA PARTICULAR LAS MARIPOSAS', value: '3866' },
  { text: 'ESCUELA PARTIC.LOS ALTOS DE MIRAFLORES', value: '3867' },
  { text: 'ESCUELA BASICA PARTICULAR LAS ISLAS', value: '3869' },
  { text: 'ESCUELA PARTICULAR AMANECER', value: '3870' },
  { text: 'LICEO POLITEC. JOSE MANUEL PINTO ARIAS', value: '3871' },
  { text: 'ESCUELA JOSE TOHA SOLDEVILLA', value: '3872' },
  { text: 'ESCUELA JAVIER JARPA SOTOMAYOR', value: '3874' },
  { text: 'ESCUELA HECTOR MANUEL ARIAS CORTES', value: '3876' },
  { text: 'ESCUELA SANTA EDUVIGES', value: '3877' },
  { text: 'ESCUELA PASO DEL SOLDADO', value: '3879' },
  { text: 'ESCUELA LA MONTANA', value: '3880' },
  { text: 'ESCUELA PUERTA DEL SOL', value: '3881' },
  { text: 'ESCUELA NIDO DE GOLONDRINAS', value: '3882' },
  { text: 'ESCUELA BASICA JUAN JORGE', value: '3883' },
  { text: 'ESCUELA SAN ALFONSO', value: '3884' },
  { text: 'LICEO MANUEL JESUS ORTIZ', value: '3886' },
  { text: 'LICEO PUEBLO SECO', value: '3887' },
  { text: 'COLEGIO POLITECNICO VICTOR JARA', value: '3888' },
  { text: 'ESCUELA MARIA L.ESPINOZA RUIZ', value: '3890' },
  { text: 'ESCUELA LAS QUILAS', value: '3891' },
  { text: 'ESCUELA SANTA MARIA', value: '3894' },
  { text: 'ESCUELA CALLE ALEGRE', value: '3897' },
  { text: 'ESCUELA SANTA JUANA', value: '3898' },
  { text: 'ESCUELA COLTON VARIANTE', value: '3899' },
  { text: 'ESCUELA JOSE HUMBERTO BARRERA BARRERA', value: '3900' },
  { text: 'ESCUELA LA ERMITA DE DIGUILLIN', value: '3901' },
  { text: 'ESCUELA MAYULERMO', value: '3903' },
  { text: 'ESCUELA LOURDES', value: '3904' },
  { text: 'ESCUELA SELVA NEGRA', value: '3906' },
  { text: 'LICEO POLITECNICO MARIA WARD.', value: '3907' },
  { text: 'LICEO JUVENAL HERNANDEZ JAQUE', value: '3909' },
  { text: 'ESCUELA VIRGEN DEL CARMEN', value: '3910' },
  { text: 'ESCUELA PUENTE URRUTIA', value: '3912' },
  { text: 'ESCUELA NAVIDAD-TREHUALEMU', value: '3913' },
  { text: 'ESCUELA BERNARDINO MUNOZ GONZALEZ', value: '3914' },
  { text: 'ESCUELA CAPILLA NORTE', value: '3916' },
  { text: 'ESCUELA VALLE DE ATACALCO', value: '3917' },
  { text: 'ESCUELA LUIS TEODORO ORTEGA OYARCE', value: '3918' },
  { text: 'ESCUELA TREHUALEMU ORIENTE', value: '3919' },
  { text: 'ESCUELA SAN RICAEL', value: '3920' },
  { text: 'ESCUELA LAS HORMIGAS', value: '3921' },
  { text: 'ESCUELA MATA REDONDA', value: '3922' },
  { text: 'ESCUELA CASTANAL', value: '3923' },
  { text: 'ESCUELA VERGARA', value: '3924' },
  { text: 'ESCUELA SAN JOSE SUR', value: '3926' },
  { text: 'ESCUELA CHAMIZAL', value: '3927' },
  { text: 'ESCUELA HUEMUL', value: '3930' },
  { text: 'ESCUELA CARDEMIO FRANCO GUTIERREZ', value: '3931' },
  { text: 'ESCUELA MAIPO', value: '3932' },
  { text: 'ESCUELA SAN ISIDRO', value: '3934' },
  { text: 'ESCUELA DE SAN VICENTE ALTO', value: '3935' },
  { text: 'ESCUELA TEMUCUTILLO', value: '3936' },
  { text: 'ESCUELA BALSA ZAPALLAR', value: '3937' },
  { text: 'ESC. BASICA ADULTOS YUNGAY', value: '3938' },
  { text: 'ESCUELA CAMPANARIO', value: '3941' },
  { text: 'ESCUELA EL AVELLANO', value: '3944' },
  { text: 'ESCUELA LOS PUQUIOS', value: '3945' },
  { text: 'ESCUELA PANGAL DEL LAJA', value: '3947' },
  { text: 'ESCUELA SAN MIGUEL DE ITATA', value: '3948' },
  { text: 'ESCUELA EL ROBLE', value: '3949' },
  { text: 'ESCUELA SANTA IRMA', value: '3952' },
  { text: 'ESCUELA EL CASTILLO', value: '3954' },
  { text: 'ESCUELA BASICA RANCHILLOS', value: '3955' },
  { text: 'ESCUELA LOS MAYOS', value: '3957' },
  { text: 'ESCUELA LOS LAURELES', value: '3958' },
  { text: 'ESCUELA PALLAHUALA', value: '3959' },
  { text: 'LICEO POLIVALENTE TOMAS HERRERA VEGA', value: '3961' },
  { text: 'ESCUELA BASICA EL CIPRES', value: '3962' },
  { text: 'ESCUELA JOSE FRANCISCO ZAPATA DOMINGUEZ', value: '3964' },
  { text: 'ESCUELA BASICA SANTA JULIA', value: '3965' },
  { text: 'ESCUELA VILLA SAN PEDRO', value: '3966' },
  { text: 'ESCUELA BASICA GENERAL CRUZ', value: '3967' },
  { text: 'ESCUELA BASICA MONTE EL LEON', value: '3968' },
  { text: 'ESCUELA BASICA CANELILLO', value: '3970' },
  { text: 'ESCUELA BASICA', value: '3971' },
  { text: 'ESCUELA ARTURO MATTE ALESSANDRI', value: '3972' },
  { text: 'ESCUELA BASICA VALLE HERMOSO', value: '3974' },
  { text: 'ESCUELA BASICA SALTO DE DANICALQUI', value: '3975' },
  { text: 'LICEO MANUEL BULNES', value: '3976' },
  { text: 'LICEO SANTA CRUZ DE LARQUI', value: '3977' },
  { text: 'ESCUELA CELIA URRUTIA PRIETO', value: '3978' },
  { text: 'ESCUELA ESPECIAL ADULTOS ITATA', value: '3979' },
  { text: 'ESCUELA BASICA PUEBLO SECO SANTA CLARA', value: '3980' },
  { text: 'ESCUELA EL PALPAL DE SANTA CLARA', value: '3981' },
  { text: 'ESCUELA BATALLA DEL ROBLE', value: '3982' },
  { text: 'ESCUELA EVARISTA OGALDE ORTEGA', value: '3983' },
  { text: 'ESCUELA CANTA RANA', value: '3984' },
  { text: 'ESCUELA LAS CARMELITAS', value: '3988' },
  { text: 'ESCUELA RINCONADA DE COLTON', value: '3989' },
  { text: 'ESCUELA COLTON QUILLAY', value: '3991' },
  { text: 'ESCUELA MILAHUE', value: '3992' },
  { text: 'ESCUELA LOS ESTANQUES', value: '3994' },
  { text: 'ESCUELA LOS TILOS', value: '3995' },
  { text: 'ESCUELA EL CARACOL', value: '3997' },
  { text: 'LICEO LUIS CRUZ MARTINEZ', value: '3998' },
  { text: 'ESCUELA BASICA HEROES DEL ITATA', value: '3999' },
  { text: 'ESC. BASICA AMANDA CHAVEZ NAVARRETE', value: '4000' },
  { text: 'ESCUELA PEDRO ENRIQUE TORRES SABELLE', value: '4001' },
  { text: 'ESCUELA BASICA EL CASINO', value: '4002' },
  { text: 'ESCUELA BASICA HUACAMALA', value: '4003' },
  { text: 'ESCUELA BASICA QUEIME', value: '4004' },
  { text: 'ESC. BAS.PUERTO LOS FRUTALES DE COYANCO', value: '4005' },
  { text: 'ESCUELA BASICA LIUCURA BAJO', value: '4006' },
  { text: 'ESCUELA BASICA CHANCAL', value: '4012' },
  { text: 'ESCUELA BASICA TALCAMO', value: '4014' },
  { text: 'ESCUELA BASICA PASO EL ROBLE', value: '4016' },
  { text: 'ESCUELA BASICA MANUEL BAQUEDANO GONZALEZ', value: '4017' },
  { text: 'ESCUELA BASICA LAGUNA AVENDANO', value: '4019' },
  { text: 'ESCUELA QUINEL', value: '4022' },
  { text: 'ESCUELA BASICA SANTA ANA DEL BAUL', value: '4023' },
  { text: 'LICEO VIRGINIO ARIAS', value: '4025' },
  { text: 'ESCUELA BASICA NUEVA ALDEA', value: '4026' },
  { text: 'ESCUELA BASICA VEGAS DE CONCHA', value: '4027' },
  { text: 'ESC. BASICA EMILIA WERNER DE WOODERMANN', value: '4028' },
  { text: 'ESCUELA BASICA SAN IGNACIO DE PALOMARES', value: '4029' },
  { text: 'ESCUELA BASICA BLANCA ROSA GUZMAN REYES', value: '4030' },
  { text: 'LICEO NIBALDO SEPULVEDA FERNANDEZ', value: '4032' },
  { text: 'ESCUELA LOMAS DE CHUDAL', value: '4034' },
  { text: 'ESCUELA MEMBRILLAR', value: '4037' },
  { text: 'ESCUELA SAN FRANCISCO DE ASIS', value: '4039' },
  { text: 'ESCUELA CUCHA URREJOLA', value: '4040' },
  { text: 'COLEGIO NUESTRA SENORA DEL CARMEN', value: '4043' },
  { text: 'ESCUELA PARTICULAR SANTA TERESITA', value: '4044' },
  { text: 'ESCUELA PARTICULAR ALONSO DE ERCILLA', value: '4045' },
  { text: 'ESCUELA PART.INMACULADO CORAZON DE MARIA', value: '4046' },
  { text: 'ESCUELA VILLA JESUS DE COELEMU', value: '4048' },
  { text: 'LICEO DOMINGO ORTIZ DE ROZAS', value: '4049' },
  { text: 'ESCUELA MARIA TERESA MARCHANT CONTRERAS', value: '4050' },
  { text: 'ESCUELA RANGUELMO', value: '4051' },
  { text: 'ESCUELA GUARILIHUE ALTO', value: '4052' },
  { text: 'ESCUELA MAGDALENA', value: '4054' },
  { text: 'ESCUELA LA ERMITA', value: '4056' },
  { text: 'ESCUELA GUARILIHUE BAJO', value: '4057' },
  { text: 'ESCUELA HUARO', value: '4058' },
  { text: 'ESCUELA PERALES', value: '4059' },
  { text: 'ESCUELA CARAVANCHEL', value: '4060' },
  { text: 'ESCUELA BASICA AMERICA', value: '4061' },
  { text: 'ESCUELA VEGAS DE ITATA', value: '4062' },
  { text: 'ESCUELA BASICA VALLE LOS CASTANOS', value: '4063' },
  { text: 'ESCUELA MEIPO', value: '4064' },
  { text: 'ESCUELA SANTA FILOMENA', value: '4067' },
  { text: 'ESCUELA BUENA FE DE TUBUL', value: '4068' },
  { text: 'ESCUELA BASICA MAITENCO', value: '4070' },
  { text: 'ESCUELA BASICA REPUBLICA DEL PARAGUAY', value: '4071' },
  { text: 'ESCUELA BASICA MONTE OLIMPO', value: '4073' },
  { text: 'ESCUELA BASICA TAUCO', value: '4074' },
  { text: 'CERRO ALTO', value: '4075' },
  { text: 'ESCUELA BASICA MINAS DE LEUQUE', value: '4076' },
  { text: 'ESCUELA BASICA VILLA DENECAN', value: '4077' },
  { text: 'ESCUELA BASICA MATACO', value: '4079' },
  { text: 'ESCUELA BASICA ANTIQUEREO', value: '4081' },
  { text: 'ESCUELA PARTICULAR MARIA GORETTI', value: '4083' },
  { text: 'LICEO PROFESOR DIEGO MISSENE BURGOS', value: '4084' },
  { text: 'ESCUELA BASICA EL TOLLO', value: '4085' },
  { text: 'ESCUELA BASICA BUCHUPUREO', value: '4087' },
  { text: 'ESCUELA BASICA LA ANTENA', value: '4088' },
  { text: 'ESCUELA BASICA LA ACHIRA', value: '4089' },
  { text: 'ESCUELA BASICA COLMUYAO', value: '4090' },
  { text: 'ESCUELA BASICA EL AVELLANAL', value: '4091' },
  { text: 'ESCUELA BASICA LAS VERTIENTES', value: '4092' },
  { text: 'ESCUELA BASICA LOS NEDANOS', value: '4093' },
  { text: 'ESCUELA BASICA TAUCU', value: '4094' },
  { text: 'ESCUELA BASICA MONTANA DE COPIHUES G 54A', value: '4095' },
  { text: 'ESCUELA BASICA QUILE', value: '4096' },
  { text: 'ESCUELA BASICA LOS CORRALES', value: '4097' },
  { text: 'ESCUELA BASICA MELA', value: '4100' },
  { text: 'ESCUELA BASICA PULLAY', value: '4101' },
  { text: 'ESCUELA GRUMETE CORTES', value: '4103' },
  { text: 'ESCUELA NUEVA AMERICA', value: '4104' },
  { text: 'ESCUELA BASICA HORIZONTE', value: '4106' },
  { text: 'ESCUELA BASICA SANTA CAROLINA', value: '4107' },
  { text: 'ESCUELA BASICA SANTA RITA DE LAS NIEVES', value: '4109' },
  { text: 'ESCUELA BASICA CAJON EL MANZANO', value: '4110' },
  { text: 'ESCUELA BASICA SANTA ELENA', value: '4112' },
  { text: 'ESCUELA BASICA EL PAJONAL', value: '4113' },
  { text: 'ESCUELA BASICA LOS TEMOS', value: '4114' },
  { text: 'ESCUELA BASICA SANTA EFIGENIA', value: '4115' },
  { text: 'ESCUELA BASICA EL CONCUYO', value: '4116' },
  { text: 'ESCUELA BASICA SAN JUAN LA RAYA', value: '4117' },
  { text: 'ESCUELA BASICA ALTO DE PIEDRA', value: '4118' },
  { text: 'ESCUELA BASICA LOS REMATES', value: '4120' },
  { text: 'ESCUELA BASICA EL SOL', value: '4121' },
  { text: 'ESCUELA BASICA SANTA MERCEDES', value: '4123' },
  { text: 'LICEO ARTURO PRAT CHACON', value: '4124' },
  { text: 'ESCUELA ROSARIO CHACON BARRIOS', value: '4125' },
  { text: 'ESCUELA BASICA DE RELOCA', value: '4128' },
  { text: 'ESCUELA BASICA EL RINCON', value: '4130' },
  { text: 'ESCUELA DR. DAVID BENAVENTE SEPULVEDA', value: '4131' },
  { text: 'ESCUELA ALIPIA ACEVEDO', value: '4133' },
  { text: 'ESCUELA BASICA TALHUAN', value: '4134' },
  { text: 'ESCUELA B\u00c3\u0081SICA QUITRIP\u00c3\u008dN', value: '4135' },
  { text: 'ESCUELA PARTICULAR ADVENTISTA QUIRAO', value: '4139' },
  { text: 'LICEO T\u00c3\u2030CNICO PUENTE \u00c3\u2018UBLE', value: '4141' },
  { text: 'ESCUELA LA MERCED', value: '4142' },
  { text: 'ESCUELA BASICA LA LOMA', value: '4146' },
  { text: 'ESCUELA BASICA COIPIN', value: '4147' },
  { text: 'ESCUELA BASICA PENA SANTA ROSA', value: '4148' },
  { text: 'ESCUELA BASICA PIEDRA LISA', value: '4150' },
  { text: 'ESCUELA BASICA PUYAMAVIDA', value: '4151' },
  { text: 'ESCUELA BASICA LAJUELAS', value: '4154' },
  { text: 'ESCUELA BASICA DADINCO', value: '4155' },
  { text: 'ESCUELA BASICA TRILICO', value: '4157' },
  { text: 'ESCUELA BASICA MONTELEON', value: '4158' },
  { text: 'LICEO COMERCIAL CAMILO HENRIQUEZ', value: '4160' },
  { text: 'LICEO COEDUCACIONAL STA. MARIA DE LOS ANGELES', value: '4164' },
  { text: 'LICEO INDUSTRIAL SAMUEL VIVANCO P.', value: '4165' },
  { text: 'LICEO TECNICO JUANITA FERNANDEZ SOLAR', value: '4166' },
  { text: 'ESCUELA GENERAL BERNARDO O HIGGINS', value: '4168' },
  { text: 'ESCUELA ESPANA', value: '4169' },
  { text: 'ESCUELA COLONIA ARABE', value: '4171' },
  { text: 'ESCUELA GENERAL JOSE DE SAN MARTIN', value: '4172' },
  { text: 'ESCUELA BLANCO ENCALADA', value: '4173' },
  { text: 'ESCUELA HOGAR NIEVES VASQUEZ PALACIOS', value: '4174' },
  { text: 'ESCUELA THOMAS JEFFERSON', value: '4175' },
  { text: 'ESCUELA JOSE MANSO DE VELASCO', value: '4176' },
  { text: 'ESCUELA CLARA REBOLLEDO DE GODOY', value: '4177' },
  { text: 'ESCUELA PEDRO RUIZ ALDEA', value: '4179' },
  { text: 'ESCUELA ARTURO ALESSANDRI PALMA', value: '4180' },
  { text: 'ESCUELA BASICA REPUBLICA DE ISRAEL', value: '4181' },
  { text: 'ESCUELA BASICA 21 DE MAYO', value: '4183' },
  { text: 'ESCUELA ISLA DE LAJA', value: '4185' },
  { text: 'ESCUELA BASICA REPUBLICA DE ALEMANIA', value: '4186' },
  { text: 'ESCUELA BASICA ESPERANZA', value: '4187' },
  { text: 'ESCUELA REPUBLICA DE GRECIA', value: '4188' },
  { text: 'ESCUELA BASICA 11 DE SEPTIEMBRE', value: '4189' },
  { text: 'LICEO SANTA FE', value: '4190' },
  { text: 'ESCUELA BASICA SANTA CLARA DE CHACAYAL', value: '4191' },
  { text: 'ESCUELA BASICA LOS MOLINOS', value: '4193' },
  { text: 'ESCUELA BASICA LA QUEBRADA', value: '4194' },
  { text: 'LICEO LLANO BLANCO', value: '4195' },
  { text: 'ESCUELA CORONEL GUILLERMO MARIN CARMONA', value: '4197' },
  { text: 'ESCUELA BASICA LA AGUADA DE CUEL', value: '4199' },
  { text: 'ESCUELA BASICA VIRQUENCO', value: '4200' },
  { text: 'ESCUELA BASICA HITILHUE', value: '4201' },
  { text: 'ESCUELA BASICA LOS TRONCOS', value: '4202' },
  { text: 'ESCUELA BASICA MILLANTU', value: '4204' },
  { text: 'ESCUELA DIEGO PORTALES PALAZUELOS', value: '4205' },
  { text: 'ESCUELA BASICA LA RINCONADA DEL SALTO', value: '4207' },
  { text: 'ESCUELA BASICA COYANCO', value: '4210' },
  { text: 'ESCUELA BASICA LAS QUINTAS', value: '4212' },
  { text: 'ESCUELA BASICA EL CHEQUEN', value: '4216' },
  { text: 'ESCUELA BASICA LA CAPILLA', value: '4221' },
  { text: 'ESCUELA BASICA LA MANCHA', value: '4228' },
  { text: 'ESCUELA BASICA LA LEYENDA', value: '4231' },
  { text: 'ESCUELA BASICA EL AMANECER DE DUQUECO', value: '4235' },
  { text: 'ESCUELA BASICA HARAS EL LAJA', value: '4239' },
  { text: 'ESCUELA TENIENTE IGNACIO SERRANO', value: '4241' },
  { text: 'ESCUELA PUENTE PERALES', value: '4254' },
  { text: 'ESCUELA BASICA EL NOGAL.', value: '4255' },
  { text: 'ESCUELA STA. MARIA DE LOS ANGELES', value: '4258' },
  { text: 'COLEGIO SAN NICOL\u00c3\u0081S', value: '4259' },
  { text: 'CENTRO EDUC. Y CAPAC. LABORAL CECAP', value: '4260' },
  { text: 'COLEGIO PARTICULAR MARTA BRUNET', value: '4262' },
  { text: 'COLEGIO SAN RAFAEL ARCANGEL', value: '4263' },
  { text: 'COLEGIO LOS ANGELES', value: '4266' },
  { text: 'ESCUELA PARTICULAR ADVENTISTA', value: '4268' },
  { text: 'COLEGIO HISPANOAMERICANO', value: '4269' },
  { text: 'LICEO PARTICULAR CARLOS CONDELL', value: '4270' },
  { text: 'LICEO PARTICULAR SANTA RITA', value: '4271' },
  { text: 'ESCUELA PARTICULAR DIEGO DE ALMAGRO', value: '4272' },
  { text: 'COLEGIO PARTICULAR MARIA JESUS', value: '4274' },
  { text: 'ESCUELA PARTICULAR LA VICTORIA', value: '4275' },
  { text: 'ESCUELA PARTICULAR SAN LUIS', value: '4276' },
  { text: 'ESCUELA PARTICULAR SAN JOSE', value: '4280' },
  { text: 'ESCUELA PARTICULAR RURAL LOS COPIHUES', value: '4281' },
  { text: 'ESCUELA PARTICULAR SAN MANUEL', value: '4284' },
  { text: 'LICEO ALEMAN DEL VERBO DIVINO', value: '4285' },
  { text: 'LICEO AGRICOLA A-62 LOS ANGELES', value: '4287' },
  { text: 'LICEO POLITECNICO GRAL.BONILLA', value: '4288' },
  { text: 'ESCUELA CHARRUA', value: '4290' },
  { text: 'ESCUELA SALTO EL LAJA', value: '4292' },
  { text: 'ESCUELA LOS CANELOS', value: '4293' },
  { text: 'ESCUELA LOS OLMOS', value: '4294' },
  { text: 'ESCUELA PILLANCO', value: '4295' },
  { text: 'ESCUELA LAS OBRAS', value: '4297' },
  { text: 'ESCUELA EL MANZANO', value: '4298' },
  { text: 'ESCUELA EL PARAISO', value: '4299' },
  { text: 'ESCUELA LOMAS DE ANGOL', value: '4300' },
  { text: 'ESCUELA COLICHEU', value: '4302' },
  { text: 'LOS CAULLES', value: '4303' },
  { text: 'ESCUELA LOS LEONES', value: '4304' },
  { text: 'HACIENDA MONTE \u00c3\u0081GUILA', value: '4305' },
  { text: 'ESCUELA EL PROGRESO', value: '4306' },
  { text: 'COLEGIO SAN JOSE', value: '4307' },
  { text: 'COLEGIO ABEL INOSTROZA GUTIERREZ', value: '4308' },
  { text: 'LICEO DE HUEPIL', value: '4309' },
  { text: 'ESCUELA BASICA TUCAPEL', value: '4310' },
  { text: 'ESCUELA LOS AVELLANOS', value: '4311' },
  { text: 'ESCUELA ALEJANDRO PEREZ URBANO', value: '4312' },
  { text: 'ESCUELA LAS HIJUELAS', value: '4314' },
  { text: 'ESCUELA LA OBRA', value: '4316' },
  { text: 'ESCUELA LOS AROMOS', value: '4317' },
  { text: 'ESCUELA LAS ASTAS', value: '4320' },
  { text: 'ESCUELA LOMAS DE TUCAPEL', value: '4321' },
  { text: 'ESCUELA MANIHUAL', value: '4322' },
  { text: 'ESCUELA LA COLONIA', value: '4323' },
  { text: 'LICEO  DOCTOR VICTOR RIOS RUIZ', value: '4324' },
  { text: 'ESCUELA VOLCAN ANTUCO', value: '4327' },
  { text: 'ESCUELA BASICA CERRO PILQUE', value: '4328' },
  { text: 'ESCUELA OLGA RIOS DE PINOCHET', value: '4330' },
  { text: 'LICEO FRANCISCO BASCUNAN GUERRERO', value: '4331' },
  { text: 'LICEO ISABEL RIQUELME', value: '4333' },
  { text: 'ESCUELA BASICA VILLA MERCEDES', value: '4334' },
  { text: 'ESCUELA BASICA NUEVO AMANECER', value: '4335' },
  { text: 'ESCUELA BASICA LA HOYADA', value: '4337' },
  { text: 'ESCUELA BASICA CANICURA', value: '4338' },
  { text: 'ESCUELA BASICA CENTINELA', value: '4339' },
  { text: 'ESCUELA PROFESORA ALBERTINA SANCHEZ', value: '4340' },
  { text: 'ESCUELA LAS ARENAS', value: '4341' },
  { text: 'ESCUELA ERMINDA GOMEZ DE POLIC.', value: '4342' },
  { text: 'ESCUELA BASICA RIO PARDO', value: '4345' },
  { text: 'ESCUELA BLANCA ESTRELLA', value: '4347' },
  { text: 'ESCUELA BASICA EL ESFUERZO', value: '4348' },
  { text: 'ESCUELA BASICA LA MESETA', value: '4349' },
  { text: 'ESCUELA PARTICULAR LAS AGUILAS', value: '4350' },
  { text: 'ESCUELA MSR.OROZIMBO FUENZALIDA', value: '4351' },
  { text: 'ESCUELA BASICA ENRIQUE BERNSTEIN C.', value: '4352' },
  { text: 'LICEO CARDENAL ANTONIO SAMORE', value: '4353' },
  { text: 'ESCUELA FRONTERIZA DE CONCENTRACION', value: '4354' },
  { text: 'ESCUELA DE E.G.B. EL HUACHI', value: '4355' },
  { text: 'ESCUELA LOS BOLDOS', value: '4356' },
  { text: 'ESCUELA BASICA VILLACURA', value: '4357' },
  { text: 'ESCUELA MARIANO PUGA VEGA', value: '4358' },
  { text: 'ESCUELA BASICA MANIL', value: '4359' },
  { text: 'ESCUELA BASICA', value: '4361' },
  { text: 'ESCUELA LO NIEVE', value: '4362' },
  { text: 'ESCUELA RINCONADA', value: '4365' },
  { text: 'ESCUELA LOS NOTROS', value: '4368' },
  { text: 'ESCUELA QUILLAILEO', value: '4372' },
  { text: 'ESCUELA BASICA', value: '4373' },
  { text: 'ESCUELA BASICA PITRIL', value: '4374' },
  { text: 'ESCUELA RALCO LEPOY', value: '4375' },
  { text: 'ESCUELA CALLAQUI', value: '4379' },
  { text: 'CENTRO DE LENGUAJE Y APRENDIZAJE', value: '4381' },
  { text: 'COLEGIO SANTA BARBARA', value: '4382' },
  { text: 'ESCUELA PARTICULAR AGUA SANTA', value: '4383' },
  { text: 'ESCUELA PARTICULAR QUEPUCA RALCO', value: '4384' },
  { text: 'ESCUELA PARTICULAR NUEVA GUAYALI', value: '4386' },
  { text: 'ESCUELA LAS PARCELAS', value: '4387' },
  { text: 'ESCUELA PARTICULAR TRAPA TRAPA', value: '4389' },
  { text: 'ESCUELA EL CASTILLO', value: '4391' },
  { text: 'ESCUELA BASICA QUILACO', value: '4392' },
  { text: 'ESCUELA BASICA RUCALHUE', value: '4393' },
  { text: 'ESCUELA BASICA CERRO EL PADRE', value: '4395' },
  { text: 'ESCUELA BASICA CAMPAMENTO', value: '4396' },
  { text: 'ESCUELA BASICA DANICALQUI', value: '4397' },
  { text: 'ESCUELA BASICA DE BELLAVISTA', value: '4398' },
  { text: 'ESCUELA BASICA LONCOPANGUE', value: '4402' },
  { text: 'ESCUELA DE ADULTOS RIO SUR', value: '4403' },
  { text: 'LICEO MIGUEL ANGEL CERDA LEIVA', value: '4404' },
  { text: 'ESCUELA BLANCO ENCALADA', value: '4405' },
  { text: 'ESCUELA BASICA MULCHEN', value: '4406' },
  { text: 'ESCUELA IGNACIO VERDUGO CAVADA', value: '4407' },
  { text: 'ESCUELA BASICA CRISOL', value: '4408' },
  { text: 'ESCUELA SACERDOTE ALEJANDRO MANERA', value: '4409' },
  { text: 'ESCUELA BASICA VILLA LAS PENAS', value: '4410' },
  { text: 'ESCUELA ALHUELEMU', value: '4412' },
  { text: 'ESCUELA BASICA MUNILQUE IZAURIETA', value: '4414' },
  { text: 'ESCUELA BASICA SAN LUIS DE MALVEN', value: '4417' },
  { text: 'ESCUELA BASICA BUREO', value: '4419' },
  { text: 'ESCUELA BASICA PILGUEN', value: '4421' },
  { text: 'ESCUELA BASICA EL PARRON', value: '4426' },
  { text: 'ESCUELA BASICA EL EDEN', value: '4432' },
  { text: 'ESCUELA BASICA RAPELCO', value: '4433' },
  { text: 'ESCUELA BASICA TRES VIENTOS', value: '4434' },
  { text: 'ESCUELA BASICA LOS HINOJOS', value: '4435' },
  { text: 'ESCUELA BASICA SANTA ADRIANA', value: '4436' },
  { text: 'ESCUELA BASICA AURORA DE ENERO', value: '4437' },
  { text: 'ESCUELA BASICA  CASAS DE PILE', value: '4441' },
  { text: 'ESCUELA SAN BERNARDINO DE SENA', value: '4443' },
  { text: 'ESCUELA PART.SUBV.EL MIRADOR DEL BIO BIO', value: '4445' },
  { text: 'LICEO LA FRONTERA', value: '4446' },
  { text: 'ESCUELA BASICA RIHUE', value: '4447' },
  { text: 'ESCUELA BASICA VILLA COIGUE', value: '4448' },
  { text: 'ESCUELA BASICA VAQUERIA', value: '4449' },
  { text: 'LICEO MUNICIPAL DE NACIMIENTO', value: '4451' },
  { text: 'ESCUELA EL SABER', value: '4452' },
  { text: 'ESCUELA OSCAR GUERRERO QUINSAC', value: '4453' },
  { text: 'ESCUELA CANADA', value: '4454' },
  { text: 'ESCUELA TOQUI LAUTARO', value: '4455' },
  { text: 'ESCUELA BASICA DOLLINCO', value: '4456' },
  { text: 'ESCUELA SAN RAMON', value: '4459' },
  { text: 'ESCUELA LOS PATOS', value: '4460' },
  { text: 'ESCUELA BASICA EL PERAL', value: '4462' },
  { text: 'ESCUELA CHOROICO', value: '4466' },
  { text: 'ESCUELA SANTA LUISA', value: '4467' },
  { text: 'ESCUELA PALMILLA', value: '4469' },
  { text: 'ESCUELA SAN FRANCISCO DE MILLAPOA', value: '4470' },
  { text: 'ESCUELA CARRIZAL', value: '4471' },
  { text: 'ESCUELA SAN ROQUE', value: '4472' },
  { text: 'ESCUELA LAS CORRIENTES', value: '4473' },
  { text: 'ESCUELA MILLAPOA DIUQUIN', value: '4474' },
  { text: 'ESCUELA LOS GUINDOS ALTO', value: '4476' },
  { text: 'ESCUELA LOS CASTANOS', value: '4478' },
  { text: 'ESCUELA CHEQUENAL', value: '4479' },
  { text: 'ESCUELA PARTICULAR EL CARRIZAL', value: '4480' },
  { text: 'ESCUELA JOSE ABELARDO NUNEZ', value: '4481' },
  { text: 'ESCUELA NIVEQUETEN', value: '4482' },
  { text: 'ESCUELA BASICA LA COLONIA', value: '4484' },
  { text: 'ESCUELA FRANCISCO PEDRO ZATTERA GUELFI', value: '4485' },
  { text: 'LICEO LAS CIENAGAS', value: '4486' },
  { text: 'ESCUELA JUAN LUIS SANFUENTE', value: '4488' },
  { text: 'ESCUELA LOS CERRILLOS', value: '4491' },
  { text: 'ESCUELA SANTIAGO AMENGUAL BALBONTIN', value: '4493' },
  { text: 'ESCUELA RUCAHUE', value: '4494' },
  { text: 'ESCUELA DIEGO JOSE BENAVENTE BUSTAMANTE', value: '4495' },
  { text: 'COLEGIO PARTICULAR SAN MAURICIO', value: '4496' },
  { text: 'ESCUELA PARTICULAR ALFA Y OMEGA', value: '4497' },
  { text: 'LICEO ISIDORA AGUIRRE TUPPER', value: '4500' },
  { text: 'ESCUELA MIGUEL LUIS AMUNATEGUI', value: '4501' },
  { text: 'ESCUELA BASICA TURQUIA', value: '4502' },
  { text: 'ESCUELA BASICA LOS CALLEJONES', value: '4503' },
  { text: 'LICEO PADRE LUIS ALBERTO SALDES IRARRAZABAL', value: '4505' },
  { text: 'ESCUELA MUNICIPAL H\u00c3\u2030ROES DE CHILE', value: '4506' },
  { text: 'LICEO TEC PROFESIONAL GONZALO GUGLIELMI M.', value: '4507' },
  { text: 'LICEO MUNICIPAL RIO CLARO', value: '4509' },
  { text: 'ESCUELA MUNICIPAL CAMBRALES', value: '4510' },
  { text: 'ESCUELA ENRIQUE PUFFE KIND', value: '4512' },
  { text: 'ESC. MUNICIPAL PADRE PEDRO CAMPOS M', value: '4513' },
  { text: 'ESCUELA MUNICIPAL RERE', value: '4514' },
  { text: 'ESCUELA MUNICIPAL LAS NIEVES', value: '4516' },
  { text: 'ESCUELA MUNICIPAL CANCHILLAS', value: '4517' },
  { text: 'ESCUELA MUNICIPAL CERRO PARRA', value: '4527' },
  { text: 'ESC. PART. INSTITUTO SAN SEBASTIAN.', value: '4530' },
  { text: 'ESCUELA DE ADULTOS CHACABUCO', value: '4538' },
  { text: 'ESCUELA PARVULARIA BLANCA ESTELA', value: '4540' },
  { text: 'ESCUELA DIFERENCIAL CHILE ESPANA', value: '4543' },
  { text: 'ESCUELA NUEVO HORIZONTES', value: '4544' },
  { text: 'CENTRO INTEGRADO DE EDUC. DIFERENCIAL', value: '4546' },
  { text: 'COLEGIO BIO-BIO', value: '4548' },
  { text: 'ESCUELA DIFERENCIAL PIERRE MENDES FRANCE', value: '4550' },
  { text: 'ESCUELA BASICA COMUN HOSPITAL', value: '4551' },
  { text: 'LICEO ANDALIEN', value: '4554' },
  { text: 'LICEO DE ADULTOS JOSE MANUEL BALMACEDA', value: '4558' },
  { text: 'LICEO CHIGUAYANTE', value: '4560' },
  { text: 'LICEO JUAN MARTINEZ DE ROZAS', value: '4561' },
  { text: 'LICEO SAN PEDRO', value: '4562' },
  { text: 'ESCUELA BASICA REPUBLICA DE ECUADOR', value: '4563' },
  { text: 'ESCUELA DOMINGO SANTA MARIA', value: '4565' },
  { text: 'ESCUELA BASICA REPUBLICA ARGENTINA', value: '4566' },
  { text: 'ESCUELA DIEGO PORTALES', value: '4569' },
  { text: 'ESCUELA JOSE HIPOLITO SALAS Y TORO', value: '4571' },
  { text: 'COLEGIO ESPA\u00d1A', value: '4574' },
  { text: 'ESCUELA BASICA JOHN F. KENNEDY', value: '4575' },
  { text: 'ESCUELA BELGICA', value: '4576' },
  { text: 'ESCUELA BASICA REPUBLICA DE ISRAEL', value: '4577' },
  { text: 'ESCUELA DARIO SALAS MARCHANT', value: '4578' },
  { text: 'ESCUELA BASICA RENE LOUVEL BERT', value: '4579' },
  { text: 'ESCUELA OSCAR CASTRO ZUNIGA', value: '4581' },
  { text: 'ESCUELA ESTHER HUNNEUS DE CLARO', value: '4582' },
  { text: 'ESCUELA REPUBLICA FEDERAL ALEMANA', value: '4584' },
  { text: 'LICEO REBECA MATTE BELLO', value: '4585' },
  { text: 'ESCUELA BASICA MANQUIMAVIDA', value: '4586' },
  { text: 'ESCUELA LEOPOLDO LUCERO GONZALEZ', value: '4589' },
  { text: 'ESCUELA BASICA REPUBLICA DE GRECIA', value: '4591' },
  { text: 'ESCUELA BASICA IRENE FREI DE CID', value: '4592' },
  { text: 'BASICA SARGENTO CANDELARIA PEREZ', value: '4593' },
  { text: 'ESCUELA MIGUEL JOSE ZANARTU SANTA MARIA', value: '4594' },
  { text: 'ESCUELA ENRIQUE SORO BARRIGA', value: '4595' },
  { text: 'ESCUELA DE PARVULOS LA ESPERANZA', value: '4597' },
  { text: 'ESCUELA BASICA LAGOS DE CHILE', value: '4603' },
  { text: 'ESCUELA PALESTINA DE PALOMARES', value: '4609' },
  { text: 'ESCUELA BASICA LUIS ALBERTO ACEVEDO', value: '4611' },
  { text: 'ESCUELA LUIS ALFREDO MU\u00c3\u2018OZ BURBOA', value: '4612' },
  { text: 'ESCUELA BASICA LAUTARO', value: '4613' },
  { text: 'ESCUELA BASICA AGUA DE LA GLORIA', value: '4614' },
  { text: 'ESCUELA BASICA BOCA DEL BIO BIO SUR', value: '4615' },
  { text: 'ESCUELA BASICA  MICHAIHUE', value: '4616' },
  { text: 'COLEGIO GALVARINO DE LOMAS COLORADAS', value: '4617' },
  { text: 'ESCUELA BASICA FUNDO CHANCO', value: '4622' },
  { text: 'ESCUELA JOSE MIGUEL CARRERA', value: '4626' },
  { text: 'COLEGIO PARTICULAR AURORA DE CHILE', value: '4627' },
  { text: 'ESC.PARTIC.PDTE.GABRIEL GONZALEZ VIDELA', value: '4628' },
  { text: 'ESCUELA PARTICULAR PEDRO DE ONA', value: '4629' },
  { text: 'COLEGIO PARTICULAR SANTA INES', value: '4633' },
  { text: 'COLEGIO LAGUNA REDONDA', value: '4635' },
  { text: 'ESCUELA MARCELA PAZ', value: '4636' },
  { text: 'UNIDAD DE INTEG.DEL LIMITADO VISUAL', value: '4638' },
  { text: 'ESCUELA PARTICULAR SANTA EMILIA', value: '4639' },
  { text: 'COLEGIO PARTICULAR ALBORADA', value: '4641' },
  { text: 'COLEGIO PARTICULAR JUAN BOSCO', value: '4644' },
  { text: 'COLEGIO PARTICULAR EL LIBERTADOR', value: '4645' },
  { text: 'COLEGIO PARTICULAR ALONSO DE ERCILLA', value: '4647' },
  { text: 'ESCUELA BASICA MALVINA ROMERO VIDAL', value: '4648' },
  { text: 'COLEGIO PARTICULAR EL ARRAYAN', value: '4649' },
  { text: 'COLEGIO PIECECITOS', value: '4650' },
  { text: 'COLEGIO ADVENTISTA DE CONCEPCION', value: '4655' },
  { text: 'ESCUELA PARTICULAR MANQUIMAVIDA', value: '4658' },
  { text: 'ESC. PART. SANTA CATALINA DE SIENA', value: '4660' },
  { text: 'COLEGIO SANTA EUFRASIA', value: '4664' },
  { text: 'COLEGIO EDWARD', value: '4665' },
  { text: 'COLEGIO SANTA LUISA DE CONCEPCION', value: '4666' },
  { text: 'COLEGIO SAN PATRICIO', value: '4667' },
  { text: 'LICEO SAN AGUSTIN DE CONCEPCION', value: '4669' },
  { text: 'ESCUELA PARTICULAR EL NAZARENO', value: '4670' },
  { text: 'ESCUELA PARTICULAR ANDRES BELLO', value: '4675' },
  { text: 'ESCUELA PARTICULAR SAN JOSE', value: '4677' },
  { text: 'COLEGIO BAUTISTA DE CONCEPCION', value: '4680' },
  { text: 'CHARLES DE GAULLE', value: '4688' },
  { text: 'CHILENO ARABE', value: '4691' },
  { text: 'LICEO LAS SALINAS', value: '4708' },
  { text: 'LICEO TECNICO', value: '4709' },
  { text: 'ARTURO PRAT CHACON', value: '4711' },
  { text: 'ESCUELA SANTA LEONOR', value: '4712' },
  { text: 'THOMAS JEFFERSON D 465', value: '4713' },
  { text: 'ESCUELA HELEN KELLER ADAMS', value: '4714' },
  { text: 'ESCUELA SIMON BOLIVAR', value: '4715' },
  { text: 'LICEO COMERCIAL LUCILA GODOY ALCAYAGA', value: '4717' },
  { text: 'ESCUELA REPUBLICA DEL PERU', value: '4719' },
  { text: 'ESCUELA D N\u00c2\u00b0 475', value: '4720' },
  { text: 'ESCUELA ESTELA PRAT CARVAJAL', value: '4722' },
  { text: 'ESCUELA MEXICO ESTADO DE GUERRERO', value: '4723' },
  { text: 'ESCUELA BASICA LA DAMA BLANCA', value: '4724' },
  { text: 'ESCUELA VILLA INDEPENDENCIA', value: '4725' },
  { text: 'ESCUELA BASICA LAS HIGUERAS', value: '4726' },
  { text: 'COLEGIO HUACHIPATO', value: '4727' },
  { text: 'COLEGIO LOS CONDORES', value: '4728' },
  { text: 'ESCUELA BASICA', value: '4730' },
  { text: 'ESCUELA BASICA CRISTOBAL COLON', value: '4731' },
  { text: 'ESCUELA BASICA CRUZ DEL SUR', value: '4732' },
  { text: 'ESC.BAS. ANITA SERRANO SEPULVEDA', value: '4733' },
  { text: 'ESCUELA BASICA LIBERTAD', value: '4734' },
  { text: 'ESCUELA CORNETA CABRALES', value: '4736' },
  { text: 'COLEGIO BASICO VILLA ACERO', value: '4737' },
  { text: 'C.E.I.A.  HUALPENCILLO', value: '4740' },
  { text: 'ESCUELA DE EDUCACION DIFERENCIAL', value: '4741' },
  { text: 'COLEGIO REMODELACION SIMONS', value: '4742' },
  { text: 'ESCUELA BASICA  CERRO CORNOU', value: '4744' },
  { text: 'ESCUELA BASICA BUENA VISTA', value: '4746' },
  { text: 'ESCUELA F 500 HUERTOS FAMILIARES', value: '4747' },
  { text: 'ESCUELA BASICA', value: '4748' },
  { text: 'ESCUELA BASICA F 509 MANUEL MONTT', value: '4750' },
  { text: 'ESCUELA DE EDUCACION DIFERENCIAL', value: '4751' },
  { text: 'ESCUELA BASICA PENINSULA DE TUMBES', value: '4753' },
  { text: 'ESCUELA BASICA CERRO SAN FRANCISCO', value: '4754' },
  { text: 'ESCUELA BASICA CALETA LENGA', value: '4757' },
  { text: 'COLEGIO CARMELA CARVAJAL DE PRAT', value: '4758' },
  { text: 'COLEGIO BERNARDO OHIGGINS', value: '4760' },
  { text: 'LICEO LA ASUNCION', value: '4762' },
  { text: 'ESCUELA PARTICULAR MANUEL RODRIGUEZ', value: '4767' },
  { text: 'CTRO TRATAMIENTO INTEGRAL NO6 LOS AROMOS', value: '4768' },
  { text: 'ESCUELA ADVENTISTA DE HUALPEN', value: '4772' },
  { text: 'ESCUELA PARTICULAR GABRIELA MISTRAL', value: '4773' },
  { text: 'ESC. PART. ENRIQUE MOLINA GARMENDIA', value: '4774' },
  { text: 'COLEGIO PARTICULAR LOS ARAUCANOS', value: '4776' },
  { text: 'ESCUELA PARTICULAR ESMERALDA', value: '4777' },
  { text: 'COLEGIO ADVENTISTA DE TALCAHUANO CENTRO', value: '4779' },
  { text: 'ESCUELA  BASICA ELIEZER', value: '4781' },
  { text: 'ESCUELA SANTA TERESITA', value: '4786' },
  { text: 'COLEGIO MIRAMAR', value: '4787' },
  { text: 'ESC.PARTICULAR SAN JUAN EVANGELISTA', value: '4788' },
  { text: 'COLEGIO MONTANER DE HUALPEN', value: '4790' },
  { text: 'ESCUELA PARTICULAR DIEGO PORTALES', value: '4791' },
  { text: 'ESCUELA SANTA CECILIA', value: '4792' },
  { text: 'ARTURO PRAT CHACON', value: '4796' },
  { text: 'ESC.DIFERENCIAL MARTA STOWHAS', value: '4803' },
  { text: 'ESCUELA REPUBLICA DE ITALIA', value: '4806' },
  { text: 'ESCUELA ISLA DE PASCUA', value: '4807' },
  { text: 'ESCUELA PENCO', value: '4808' },
  { text: 'ESCUELA EDO. CAMPBELL SAAVEDRA', value: '4809' },
  { text: 'ESCUELA ALTE.JORGE MONTT ALVAREZ', value: '4810' },
  { text: 'ESCUELA ALMIRANTE PATRICIO LYNCH', value: '4811' },
  { text: 'ESCUELA LA GREDA', value: '4812' },
  { text: 'ESCUELA VIPLA', value: '4813' },
  { text: 'ESCUELA ETHEL HENCK DE GRANT', value: '4814' },
  { text: 'ESCUELA BASICA PRIMER AGUA ABAJO', value: '4817' },
  { text: 'COL. PARTICULAR FUNNY SCHOOL', value: '4818' },
  { text: 'ESC. PART. QUEEN ELIZABETH SCHOOL.', value: '4820' },
  { text: 'COLEGIO EL REFUGIO', value: '4822' },
  { text: 'LICEO COMERCIAL DE TOME', value: '4825' },
  { text: 'ESCUELA ESPECIAL DE TOME', value: '4827' },
  { text: 'REPUBLICA DE ECUADOR', value: '4830' },
  { text: 'ESCUELA BASICA BELLAVISTA', value: '4831' },
  { text: 'ESCUELA BASICA IGNACIO SERRANO MONTANER', value: '4832' },
  { text: 'ESCUELA BASICA DICHATO', value: '4834' },
  { text: 'ESCUELA BASICA ARTURO PRAT', value: '4835' },
  { text: 'ESCUELA BASICA REPUBLICA DE PANAMA', value: '4836' },
  { text: 'ESCUELA BASICA RAFAEL', value: '4837' },
  { text: 'ESCUELA BASICA CARLOS MAHNS CHOUPAY', value: '4838' },
  { text: 'ESCUELA BASICA COCHOLGUE', value: '4839' },
  { text: 'ESCUELA BASICA Y ADULTOS CALIFORNIA', value: '4840' },
  { text: 'ESCUELA BASICA CERRO ESTANQUE', value: '4841' },
  { text: 'ESCUELA MARIANO EGANA', value: '4842' },
  { text: 'ESCUELA BAS.LISA ENRIQUETA PETER TEUBNER', value: '4843' },
  { text: 'ESCUELA BASICA MENQUE', value: '4844' },
  { text: 'ESCUELA BASICA PUNTA DE PARRA', value: '4845' },
  { text: 'ESCUELA BASICA SAN CARLITOS', value: '4848' },
  { text: 'ESCUELA BASICA BURCA', value: '4851' },
  { text: 'ESCUELA BASICA CALETA DEL MEDIO', value: '4852' },
  { text: 'ESCUELA BASICA SAN FRANCISCO', value: '4854' },
  { text: 'ESCUELA BASICA MILLAHUE', value: '4855' },
  { text: 'ESCUELA BASICA CORONEY', value: '4858' },
  { text: 'ESCUELA BASICA CHUPALLAR', value: '4859' },
  { text: 'ESCUELA BASICA VEGAS DE COLIUMO', value: '4860' },
  { text: 'ESCUELA BASICA SAN ANTONIO', value: '4861' },
  { text: 'ESCUELA PARTICULAR MARGARITA NASEAU', value: '4865' },
  { text: 'COLEGIO DR.GUILLERMO VELASCO BARROS', value: '4866' },
  { text: 'ESCUELA BASICA RAFAEL AMPUERO VILLARROEL', value: '4867' },
  { text: 'ESCUELA PARTICULAR PADRE LUIS AMIGO', value: '4868' },
  { text: 'ESCUELA BASICA FLORIDA', value: '4869' },
  { text: 'LICEO LUIS DE ALAVA', value: '4870' },
  { text: 'LICEO COPIULEMU', value: '4871' },
  { text: 'ESCUELA RAHUIL', value: '4873' },
  { text: 'ESCUELA BASICA GRANERILLO', value: '4874' },
  { text: 'ESCUELA BASICA CANCHA DE LOS MONTERO', value: '4875' },
  { text: 'ESCUELA BASICA LA PAZ', value: '4876' },
  { text: 'ESCUELA BASICA PONEN', value: '4877' },
  { text: 'ESCUELA BASICA PUENTE SIETE', value: '4879' },
  { text: 'ESCUELA BASICA QUEBRADA LAS ULLOA', value: '4882' },
  { text: 'ESCUELA BASICA SAN SEBASTIAN DE MANCO', value: '4886' },
  { text: 'ESCUELA BASICA CRUCERO DE HUARO', value: '4887' },
  { text: 'ESCUELA BASICA PENINHUEQUE', value: '4889' },
  { text: 'ESCUELA BASICA VILLAMAVIDA', value: '4890' },
  { text: 'ESCUELA BASICA ROA', value: '4891' },
  { text: 'ESCUELA BASICA JUAN CHICO', value: '4892' },
  { text: 'PARVULARIO RURAL MANDERSCHEID', value: '4894' },
  { text: 'ESCUELA PARTICULAR UNICORNIO', value: '4896' },
  { text: 'LICEO SAN JUAN BAUTISTA DE HUALQUI', value: '4897' },
  { text: 'ESCUELA MANUEL AMAT Y JUNIET', value: '4898' },
  { text: 'ESCUELA BASICA EL MAITEN', value: '4901' },
  { text: 'ESC. CARLOS ALBERTO FERNANDEZ CASTILLO', value: '4902' },
  { text: 'ESCUELA BASICA SANTA FILOMENA DE PICHACO', value: '4903' },
  { text: 'ESCUELA BASICA RANGUEL', value: '4904' },
  { text: 'ESCUELA QUINQUIBUENO', value: '4905' },
  { text: 'ESCUELA SAN JOSE LA PALMA', value: '4906' },
  { text: 'ESCUELA GOMERO', value: '4907' },
  { text: 'ESCUELA ALEJANDRO VARELA SANTA MARIA', value: '4908' },
  { text: 'ESCUELA UNIHUE', value: '4909' },
  { text: 'ESCUELA GUILLERMO BARBERI MASSA', value: '4910' },
  { text: 'ESCUELA DE CHILLANCITO', value: '4911' },
  { text: 'ESCUELA MAQUEUTO', value: '4912' },
  { text: 'ESCUELA BARRANCAS JUNTAS', value: '4913' },
  { text: 'ESCUELA LA CALLE', value: '4915' },
  { text: 'ESCUELA SANTA SUSANA DE PICHACO', value: '4917' },
  { text: 'ESCUELA AGUA CORTA', value: '4918' },
  { text: 'ESCUELA SAN NICANOR', value: '4920' },
  { text: 'ESCUELA ARMANDO JOSE SANTOS IBANEZ VARGA', value: '4921' },
  { text: 'ESCUELA ALONSO DE ERCILLA', value: '4922' },
  { text: 'ESCUELA PARTICULAR SANTA CRUZ', value: '4923' },
  { text: 'ESCUELA PARTICULAR SANTO DOMINGO', value: '4924' },
  { text: 'LICEO NUEVA ZELANDIA', value: '4925' },
  { text: 'ESCUELA RECAREDO VIGUERAS ARANEDA', value: '4926' },
  { text: 'ESCUELA COLICO ALTO', value: '4927' },
  { text: 'ESCUELA ESPIGADO', value: '4929' },
  { text: 'ESCUELAS LAS CACHANAS', value: '4930' },
  { text: 'ESCUELA PODUCO ALTO', value: '4932' },
  { text: 'ESCUELA CABRERA', value: '4933' },
  { text: 'ESCUELA PAPAL', value: '4934' },
  { text: 'ESCUELA TORRE DORADA', value: '4935' },
  { text: 'ESCUELA PURGATORIO', value: '4936' },
  { text: 'ESCULA  BALSEADERO', value: '4938' },
  { text: 'ESCUELA CURALI', value: '4939' },
  { text: 'ESCUELA CURAMAVIDA', value: '4940' },
  { text: 'ESCUELA PODUCO BAJO', value: '4941' },
  { text: 'ESCUELA TANAHUILLIN', value: '4942' },
  { text: 'ESCUELA CHACAYAL', value: '4943' },
  { text: 'ESCUELA HUALLEREHUE', value: '4944' },
  { text: 'ESCUELA LA GENERALA', value: '4946' },
  { text: 'ESCUELA PARTICULAR CLORINDA AVELLO', value: '4947' },
  { text: 'LICEO POLITECNICO ROSAURO SANTANA RIOS', value: '4948' },
  { text: 'LICEO COMERCIAL PRESIDENTE FREI MONTALVA', value: '4949' },
  { text: 'ESCUELA ESPECIAL LUIS COUSINO SQUELLA', value: '4950' },
  { text: 'LICEO CARLOS COUSI\u00c3\u2018O GOYENECHEA', value: '4951' },
  { text: 'ESCUELA BALDOMERO LILLO FIGUEROA', value: '4952' },
  { text: 'ESCUELA ISIDORA GOYENECHEA', value: '4953' },
  { text: 'ESCUELA BASICA SANTA MARIA DE GUADALUPE', value: '4954' },
  { text: 'ESCUELA BASICA KONRAD ADENAUER', value: '4955' },
  { text: 'ESCUELA BASICA BELLO HORIZONTE', value: '4956' },
  { text: 'ESCUELA BASICA THOMPSON MATTHEWS', value: '4958' },
  { text: 'COLEGIO ANGEL DE PEREDO', value: '4960' },
  { text: 'ESCUELA BASICA COLCURA', value: '4961' },
  { text: 'ESCUELA BASICA CENTENARIO', value: '4967' },
  { text: 'ESC. BAS. CARABINERO ISAIAS GUEVARA', value: '4968' },
  { text: 'LICEO SANTA DORIS', value: '4969' },
  { text: 'ESCUELA PADRE FRANCISCO DE CROZE', value: '4970' },
  { text: 'ESCUELA PARTICULAR SANTA TERESA', value: '4971' },
  { text: 'INST. DE HUM.SAN FRANCISCO DE ASIS', value: '4973' },
  { text: 'ESCUELA PARTICULAR GETSEMANI', value: '4974' },
  { text: 'LICEO INDUSTRIAL FEDERICO W. SCHWAGER', value: '4975' },
  { text: 'LICEO COMERCIAL ANDRES BELLO LOPEZ', value: '4977' },
  { text: 'ESC.BASICA ADULTOS ANTONIO SANCHEZ', value: '4978' },
  { text: 'ESCUELA DIFERENCIAL MARIA ESTER BREVE G.', value: '4979' },
  { text: 'LICEO YOBILO DE CORONEL', value: '4983' },
  { text: 'ESCUELA ROSITA RENARD', value: '4984' },
  { text: 'ESCUELA BASICA PLAYAS NEGRAS', value: '4985' },
  { text: 'ESCUELA ROSA MEDEL AGUILERA', value: '4986' },
  { text: 'ESCUELA BASICA JAVIERA CARRERA', value: '4987' },
  { text: 'ESCUELA RAFAEL SOTOMAYOR BAEZA', value: '4988' },
  { text: 'ESCUELA VICTOR DOMINGO SILVA', value: '4989' },
  { text: 'ESCUELA AMBROSIO OHIGGINS', value: '4990' },
  { text: 'ESCUELA REPUBLICA DE FRANCIA', value: '4991' },
  { text: 'ESCUELA REMIGIO CASTRO ABURTO', value: '4992' },
  { text: 'ESCUELA ADELAIDA MIGUIELES SOTO', value: '4994' },
  { text: 'ESCUELA OCTAVIO SALINAS CARIAGA', value: '4995' },
  { text: 'ESCUELA VISTA HERMOSA', value: '4996' },
  { text: 'ESCUELA JORGE ROJAS MIRANDA', value: '4997' },
  { text: 'ESCUELA ROSA YANEZ RODRIGUEZ', value: '4998' },
  { text: 'ESCUELA BASICA RAMON FREIRE SERRANO', value: '4999' },
  { text: 'ESCUELA ARTURO HUGHES CERNA', value: '5001' },
  { text: 'ESCUELA JUAN JOSE LATORRE BENAVENTE', value: '5002' },
  { text: 'ESCUELA FRANCISCO COLOANE', value: '5003' },
  { text: 'ESCUELA ESCUADRON', value: '5005' },
  { text: 'ESCUELA BASICA PATAGUAL', value: '5006' },
  { text: 'COLEGIO PARTICULAR GABRIELA MISTRAL', value: '5009' },
  { text: 'ESCUELA METODISTA', value: '5010' },
  { text: 'COLEGIO PARTICULAR SAN PEDRO', value: '5012' },
  { text: 'ESCUELA PARTICULAR SAN MARCOS', value: '5015' },
  { text: 'COLEGIO PARTICULAR IGNACIO CARRERA PINTO', value: '5016' },
  { text: 'ESCUELA GENARO RIOS CAMPOS', value: '5019' },
  { text: 'COLEGIO ANIBAL ESQUIVEL TAPIA', value: '5020' },
  { text: 'LICEO POLITECNICO DR RIGOBERTO IGLESIAS', value: '5021' },
  { text: 'ESCUELA DIFERENCIAL', value: '5022' },
  { text: 'ALAMIRO GALLEGOS MUNOZ', value: '5023' },
  { text: 'LICEO ISIDORA RAMOS DE GAJARDO', value: '5024' },
  { text: 'ESCUELA PROFESORA REBECA CASTRO ARANEDA', value: '5025' },
  { text: 'ESCUELA FRESIA GRACIELA MULLER RUIZ', value: '5026' },
  { text: 'ESCUELA BOCA LEBU', value: '5028' },
  { text: 'DOMINGO FAUSTINO SARMIENTO', value: '5029' },
  { text: 'ESCUELA DR.ARNOLDO EBENSPERGER RICHTER', value: '5031' },
  { text: 'ESCUELA   JOSE JOAQUIN PEREZ', value: '5032' },
  { text: 'ESCUELA ARTURO EBENSPERGER RICHTER', value: '5033' },
  { text: 'ESCUELA LA FORTUNA', value: '5034' },
  { text: 'ESCUELA DE ISLA MOCHA', value: '5035' },
  { text: 'ESCUELA RUCA RAQUI', value: '5036' },
  { text: 'ESCUELA PEHUEN', value: '5038' },
  { text: 'ESCUELA GUILLERMO RODRIGUEZ  RIOBIO', value: '5039' },
  { text: 'ESCUELA VILLARRICA', value: '5040' },
  { text: 'ESCUELA EDUARDO BARRIOS', value: '5043' },
  { text: 'ESCUELA PARTICULAR CERRO LA CRUZ', value: '5046' },
  { text: 'ESCUELA LIBERTADOR GENERAL', value: '5047' },
  { text: 'LICEO SAN FELIPE DE ARAUCO', value: '5048' },
  { text: 'ESCUELA BASICA VICENTE MILLAN IRIARTE', value: '5049' },
  { text: 'ESCUELA BASICA MARE NOSTRUM', value: '5050' },
  { text: 'ESCUELA B\u00c3\u0081SICA DE CARAMPANGUE', value: '5051' },
  { text: 'ESCUELA LOS PINOS', value: '5052' },
  { text: 'ESCUELA JORGE IVAN VALENZUELA ZUNIGA', value: '5053' },
  { text: 'ESCUELA BASICA SAN PEDRO DE LARAQUETE', value: '5054' },
  { text: 'ESCUELA VALLE RAMADILLAS', value: '5055' },
  { text: 'ESCUELA BASICA CARLOS SAEZ SAEZ', value: '5056' },
  { text: 'LICEO FILIDOR GAETE', value: '5057' },
  { text: 'ESCUELA HUGO CABRERA AGUIRRE', value: '5059' },
  { text: 'ESCUELA ARMANDO WIESSE FUENTE-ALBA', value: '5060' },
  { text: 'ESCUELA LOMAS DE ANGUILLAS', value: '5062' },
  { text: 'ESCUELA FERMIN IBARRA FRITZ', value: '5064' },
  { text: 'ESCUELA QUILANTRAL', value: '5065' },
  { text: 'ESCUELA BASICA PASO LOS TEMOS', value: '5066' },
  { text: 'ESCUELA MAR LOS PINOS', value: '5067' },
  { text: 'ESCUELA DUIDICO', value: '5068' },
  { text: 'ESCUELA BASICA ALTO YANI', value: '5069' },
  { text: 'ESCUELA BASICA VALLE VERDE', value: '5070' },
  { text: 'ESCUELA VALLE ARAUCO', value: '5072' },
  { text: 'ESCUELA BASICA BRISAS DEL MAR', value: '5073' },
  { text: 'ESCUELA BASICA CESAR MONSALVE FLORES', value: '5074' },
  { text: 'CERRO COLORADO', value: '5078' },
  { text: 'ESCUELA BASICA PEMEREHUE', value: '5080' },
  { text: 'ESCUELA ALTO RAQUI', value: '5081' },
  { text: 'LICEO SAN FRANCISCO DE ASIS', value: '5082' },
  { text: 'ESCUELA RAMIRO ROA GONZALEZ', value: '5085' },
  { text: 'ESCUELA 4 DE OCTUBRE Y CENTRO DE ADULTOS', value: '5086' },
  { text: 'ESCUELA COLICO SUR', value: '5087' },
  { text: 'ESCUELA PABLO NERUDA', value: '5088' },
  { text: 'ESCUELA BUENA ESPERANZA', value: '5090' },
  { text: 'ESCUELA GABRIELA MISTRAL', value: '5091' },
  { text: 'ESCUELA INDEPENDENCIA', value: '5093' },
  { text: 'ESCUELA SANTA TERESA DE LOS ANDES', value: '5094' },
  { text: 'ESCUELA LOS CRUCEROS', value: '5095' },
  { text: 'ESCUELA BAJO LOS RIOS', value: '5097' },
  { text: 'ESCUELA TRONGOL ALTO', value: '5099' },
  { text: 'ESCUELA PLEGARIAS', value: '5100' },
  { text: 'ESCUELA SAN JOSE DE COLICO', value: '5101' },
  { text: 'ESCUELA COLICO NORTE', value: '5103' },
  { text: 'COLEGIO ALONSO DE ERCILLA', value: '5104' },
  { text: 'LICEO POLITECNICO CAUPOLICAN', value: '5105' },
  { text: 'ESCUELA FELIX EYHERAMENDY', value: '5106' },
  { text: 'LICEO T\u00c3\u2030CNICO PROFESIONAL SAN PABLO', value: '5107' },
  { text: 'ESCUELA CLAUDIO FLORES SOTO', value: '5109' },
  { text: 'ESCUELA PILPILCO', value: '5110' },
  { text: 'ESCUELA ZAIDA ARANEDA VIGUERAS', value: '5112' },
  { text: 'ESCUELA ORLANDO DELGADO ZUNIGA', value: '5113' },
  { text: 'ESCUELA GUACOLDA', value: '5114' },
  { text: 'ESCUELA TRONGOL BAJO', value: '5115' },
  { text: 'ESCUELA JOSE M.CAMPOS MENCHACA', value: '5116' },
  { text: 'ESCUELA LOS GUALLES', value: '5117' },
  { text: 'ESCUELA LAS DUNAS', value: '5119' },
  { text: 'ESCUELA INDEPENDENCIA', value: '5120' },
  { text: 'ESCUELA JOSE ULLOA FIERRO', value: '5121' },
  { text: 'LICEO CRISTO REDENTOR', value: '5122' },
  { text: 'ESCUELA BASICA CACIQUE FRANCISCO MELIN', value: '5123' },
  { text: 'LICEO POLITEC. JOSE DE LA CRUZ MIRANDA C', value: '5126' },
  { text: 'ESCUELA LEONCIO ARANEDA FIGUEROA', value: '5127' },
  { text: 'ESCUELA ARTURO PRAT CHACON', value: '5128' },
  { text: 'ESCUELA BASICA RENE ANDRADES TOLEDO', value: '5129' },
  { text: 'ESCUELA BASICA RUBI NELSON SILVA SALAS', value: '5130' },
  { text: 'ESCUELA BASICA HOMERO VIGUERAS A.', value: '5131' },
  { text: 'ESCUELA RICARDO COLOMA DIAZ', value: '5132' },
  { text: 'ESCUELA BASICA LLONCAO', value: '5133' },
  { text: 'ESCUELA BASICA LA GRANJA', value: '5134' },
  { text: 'ESCUELA BASICA PAICAVI', value: '5135' },
  { text: 'ESCUELA BASICA FEDERICO GANA', value: '5140' },
  { text: 'ESCUELA BASICA SALTO DEL HUILLINCO', value: '5143' },
  { text: 'ESCUELA BASICA LLENQUEHUE', value: '5144' },
  { text: 'ESCUELA BASICA GARCIA HURTADO DE MENDOZA', value: '5145' },
  { text: 'ESCUELA BASICA ONOFRE CORREA PASCAL', value: '5146' },
  { text: 'ESCUELA BASICA TRES SAUCES', value: '5147' },
  { text: 'ESCUELA PARTICULAR LUIS CRUZ MARTINEZ', value: '5151' },
  { text: 'ESCUELA PARTICULAR EL RIO', value: '5152' },
  { text: 'COLEGIO INSTITUTO SAN JOSE', value: '5153' },
  { text: 'ESCUELA SAN LUIS DE CONTULMO', value: '5154' },
  { text: 'LICEO POLIVALENTE NAHUELBUTA', value: '5155' },
  { text: 'ESCUELA BASICA GALVARINO', value: '5157' },
  { text: 'ESCUELA BASICA JUAN AGUILERA JEREZ', value: '5158' },
  { text: 'ESCUELA HUALLEPEN BAJO', value: '5159' },
  { text: 'ESCUELA BASICA IRMA RAMIREZ SEPULVEDA', value: '5160' },
  { text: 'ESCUELA HUIDE', value: '5162' },
  { text: 'ESCUELA GRANO DE TRIGO', value: '5163' },
  { text: 'ESCUELA HUALLEPEN ALTO', value: '5165' },
  { text: 'ESCUELA CALEBU', value: '5166' },
  { text: 'ESCUELA NAHUELBUTA ALTO', value: '5167' },
  { text: 'ESCUELA VILLA RIVAS', value: '5168' },
  { text: 'ESCUELA PICHIHUILLINCO', value: '5169' },
  { text: 'ESCUELA HUILLINCO', value: '5170' },
  { text: 'ESCUELA BASICA FRANCISCO ANTONIO ENCINA', value: '5171' },
  { text: 'ESCUELA BASICA JUAN LAVIN ALVEAR', value: '5172' },
  { text: 'ESCUELA EL ALAMO', value: '5174' },
  { text: 'ESCUELA VILLA ALICURA', value: '5175' },
  { text: 'ESCUELA MAHUILQUE', value: '5176' },
  { text: 'ESCUELA BASICA PEDRO ETCHEPARE BORDA', value: '5178' },
  { text: 'ESCUELA PARTICULAR NUEVA AURORA', value: '5180' },
  { text: 'ESCUELA PARTICULAR HUILLINCO ALTO', value: '5181' },
  { text: 'ESCUELA PARTICULAR COLLICO', value: '5182' },
  { text: 'ESCUELA PARTICULAR LLEU-LLEU BAJO', value: '5183' },
  { text: 'ESCUELA PARTICULAR VILLA HERMOSA', value: '5186' },
  { text: 'ESCUELA PARTICULAR BUCHOCO', value: '5188' },
  { text: 'ESCUELA PARTICULAR LICAUQUEN', value: '5189' },
  { text: 'ESCUELA ANA MOLINA', value: '5192' },
  { text: 'ESCUELA HECTOR ISAAC CARRASCO HELDT', value: '5193' },
  { text: 'ESCUELA ELOISA GONZALEZ', value: '5194' },
  { text: 'ESCUELA CERRO NEGRO', value: '5195' },
  { text: 'ESCUELA PRIMER AGUA', value: '5196' },
  { text: 'ESCUELA CASA DE PIEDRA', value: '5197' },
  { text: 'ESCUELA ALTO QUILANTAHUE', value: '5198' },
  { text: 'ESCUELA ULTIMA ESPERANZA', value: '5200' },
  { text: 'ESCUELA PUERTO PALLACO', value: '5201' },
  { text: 'ESCUELA MAPODUNGUN', value: '5202' },
  { text: 'ESCUELA AGUA DE MOLINO', value: '5203' },
  { text: 'ESCUELA LOS MAQUIS', value: '5204' },
  { text: 'ESCUELA CHILLIMAPU', value: '5205' },
  { text: 'ESCUELA PONOTRO HENCHI AMULEI', value: '5207' },
  { text: 'ESCUELA PARTICULAR LOS LINGUES', value: '5208' },
  { text: 'ESC. PART.SANTOS CHAVEZ DE CANIHUAL', value: '5210' },
  { text: 'ESCUELA PARTICULAR RANQUILHUE', value: '5211' },
  { text: 'ESCUELA PARTICULAR NUEVA LAS HUELLAS', value: '5212' },
  { text: 'ESCUELA PARTICULAR LAS MISIONES', value: '5213' },
  { text: 'ESCUELA PARTICULAR AILLINCO', value: '5214' },
  { text: 'LICEO INDUSTRIAL B-5 ANGOL', value: '5215' },
  { text: 'LICEO MERCEDES MANOSALVA AREVALO', value: '5217' },
  { text: 'LICEO ENRIQUE BALLACEY COTTEREAU', value: '5218' },
  { text: 'LICEO TECNICO JUANITA FERNANDEZ SOLAR', value: '5219' },
  { text: 'ESCUELA HERMANOS CARRERA', value: '5220' },
  { text: 'ESCUELA BASICA NAHUELBUTA', value: '5221' },
  { text: 'ESCUELA REPUBLICA FEDERAL ALEMANA', value: '5224' },
  { text: 'COLEGIO MAR\u00c3\u008dA SYLVESTER RASCH', value: '5225' },
  { text: 'ESCUELA DIEGO DUBLE URRUTIA', value: '5226' },
  {
    text: 'ESCUELA JOS\u00c3\u2030 EL\u00c3\u008dAS BOLIVAR HERRERA',
    value: '5227',
  },
  { text: 'ESCUELA VILLA HUEQUEN', value: '5228' },
  { text: 'ESCUELA BASICA ARAGON', value: '5229' },
  { text: 'ESCUELA ESPECIAL ESPANA', value: '5230' },
  { text: 'ESCUELA  BASICA  MIGUEL LUIS AMUNATEGUI', value: '5232' },
  { text: 'ESCUELA BASICA JUAN M. FERRIERE CAIRE', value: '5233' },
  { text: 'ESC BASICA OSCAR MU\u00c3\u2018OZ MORAGA', value: '5238' },
  { text: 'TRARULEMU', value: '5244' },
  { text: 'ESCUELA BASICA EL MAITEN', value: '5247' },
  { text: 'ESCUELA REPUBLICA DE AUSTRIA', value: '5248' },
  { text: 'ESC. BASICA MANUEL RODRIGUEZ', value: '5249' },
  { text: 'ESCUELA REGIMIENTO HUSARES', value: '5250' },
  { text: 'ESCUELA SANTA ADRIANA', value: '5255' },
  { text: 'ESCUELA BASICA CHACAICO', value: '5258' },
  { text: 'ESCUELA DE ITRAQUE', value: '5263' },
  { text: 'COLEGIO SAN FRANCISCO DE ASIS  DE ANGOL', value: '5264' },
  { text: 'COLEGIO ADVENTISTA DE ANGOL', value: '5265' },
  { text: 'COLEGIO SAN JOSE', value: '5266' },
  { text: 'ESCUELA AGRICOLA EL VERGEL', value: '5267' },
  { text: 'ESCUELA PARTICULAR EL MIRADOR', value: '5269' },
  { text: 'LICEO POLITECNICO DOMINGO STA MARIA', value: '5270' },
  { text: 'ESCUELA BASICA LOS NOGALES', value: '5272' },
  { text: 'ESCUELA MUNICIP. LA NOBEL GABRIELA', value: '5273' },
  { text: 'LICEO AGRICOLA FORESTAL MANZANARES', value: '5274' },
  { text: 'ESC. BASICA JULIO MONTT SALAMANCA', value: '5275' },
  { text: 'ESCUELA BASICA TOLPAN', value: '5276' },
  { text: 'SAN FRANCISCO DE ASIS  - RENAICO', value: '5280' },
  { text: 'ESCUELA THOMAS ALBA EDISON', value: '5283' },
  { text: 'ESCUELA BENJAMIN FRANKLIN', value: '5284' },
  { text: 'ESCUELA BASICA VICTOR DURAN PEREZ', value: '5286' },
  { text: 'ESCUELA MICHIGAN EL AMANECER', value: '5288' },
  { text: 'ESCUELA MININCO', value: '5289' },
  { text: 'ESCUELA NICOLAS PEREZ CARDENAS', value: '5290' },
  { text: 'ESCUELA BASICA CANADA', value: '5291' },
  { text: 'ESCUELA BASICA MIGUEL HUENTELEN', value: '5292' },
  { text: 'ESCUELA MUNICIPAL JOEL COLL\u00c3\u008dO MORALES', value: '5294' },
  { text: 'ESCUELA BASICA EL ENCINAR', value: '5297' },
  { text: 'ESCUELA RAHUILMACO', value: '5298' },
  { text: 'ESCUELA BASICA SAN ANDRES', value: '5307' },
  { text: 'ESCUELA BASICA RIO AMARGO', value: '5309' },
  { text: 'ESCUELA BASICA MAPUDANCO', value: '5310' },
  { text: 'ESCUELA BASICA NIBLINTO', value: '5312' },
  { text: 'ESCUELA CHIGUAIHUE', value: '5314' },
  { text: 'COLEGIO PARTIC. WOLFGANG AMADEUS MOZART', value: '5315' },
  { text: 'ESCUELA PARTICULAR SN.JUAN DE LA AMERICA', value: '5322' },
  { text: 'LICEO BRIGADIER CARLOS SCHALCHLI V.', value: '5323' },
  { text: 'ESCUELA MUNICIPAL FRONTERIZA', value: '5324' },
  { text: 'ESCUELA BASICA MALALMAHUIDA', value: '5326' },
  { text: 'ESCUELA DE LIUCURA', value: '5327' },
  { text: 'ESCUELA BASICA MITRAUQUEN', value: '5328' },
  { text: 'ESCUELA BASICA CRUZACO', value: '5329' },
  { text: 'ESC.BASICA MARTA BRUNET', value: '5330' },
  { text: 'ESCUELA BASICA MARIMENUCO', value: '5331' },
  { text: 'ESCUELA BASICA LA ANGOSTURA', value: '5332' },
  { text: 'ESCUELA DE ICALMA', value: '5333' },
  { text: 'ESCUELA BASICA LOS PINOS', value: '5336' },
  { text: 'ESCUELA DE SIERRA NEVADA', value: '5337' },
  { text: 'ESC. BASICA JUSTO SCHWEITZER M.', value: '5338' },
  { text: 'ESCUELA DE TROYO', value: '5339' },
  { text: 'ESC. BASICA LEONTINA VASQUEZ RIVERA', value: '5340' },
  { text: 'ESCUELA BASICA DOMINGO CAMARGO', value: '5341' },
  { text: 'ESCUELA PARTICULAR LONQUIMAY', value: '5342' },
  { text: 'LICEO POLITECNICO C-12 CURACAUTIN', value: '5343' },
  { text: 'ESCUELA LUIS CRUZ MARTINEZ', value: '5345' },
  { text: 'ESCUELA OSVALDO FUENTES BARRERA', value: '5346' },
  { text: 'ESCUELA PATRICIO CHAVEZ SOTO', value: '5347' },
  { text: 'RAMON EDUARDO RAMIREZ HENRIQUEZ', value: '5348' },
  { text: 'ESCUELA ED. DIFERENCIAL DE CURACAUTIN', value: '5350' },
  { text: 'COLEGIO MANUEL BULNES PRIETO', value: '5351' },
  { text: 'ESCUELA BASICA REPUBLICA DE MEXICO', value: '5353' },
  { text: 'ESCUELA LOS PRADOS', value: '5357' },
  { text: 'ESCUELA BASICA COLLICO', value: '5358' },
  { text: 'ESCUELA BASICA LEFUCO', value: '5360' },
  { text: 'ESCUELA RIO BLANCO', value: '5362' },
  { text: 'ESCUELA  BASICA ALEJO TASCON', value: '5363' },
  { text: 'ESCUELA MANCHURIA', value: '5364' },
  { text: 'ESCUELA JOSE CHANIN SILHY', value: '5365' },
  { text: 'ESC. BASICA SAN ARTURO   RADALCO ESTE.', value: '5368' },
  { text: 'ESCUELA DE SANTA JULIA', value: '5371' },
  { text: 'ESCUELA PARTICULAR SANTA ELENA', value: '5372' },
  { text: 'ESCUELA PARTICULAR SANTA EMMA', value: '5373' },
  { text: 'LICEO ALONSO DE ERCILLA Y ZU\u00c3\u2018IGA', value: '5374' },
  { text: 'ESCUELA BASICA SALVADOR ALLENDE', value: '5375' },
  { text: 'ESCUELA BASICA SAN RAMON', value: '5376' },
  { text: 'ESCUELA BASICA TEODOCIO URRUTIA', value: '5378' },
  { text: 'ESCUELA TRICAUCO', value: '5379' },
  { text: 'ECUELA FEDERICO RAYDET', value: '5380' },
  { text: 'ESC. ASENTAMIENTO PABLO NERUDA', value: '5381' },
  { text: 'ESCUELA MILLALEVIA', value: '5382' },
  { text: 'ESCUELA CHACAIMAPU', value: '5385' },
  { text: 'ESCUELA BASICA TEMOCUICUI', value: '5386' },
  { text: 'ESC.PAR.SAN FRANCISCO DE ASIS DE ERCILLA', value: '5387' },
  { text: 'ESCUELA PARTICULAR NUPANGUE', value: '5389' },
  { text: 'ESCUELA PARTICULAR LUJAN', value: '5390' },
  { text: 'ESCUELA PARTICULAR SANTA ROSA', value: '5391' },
  { text: 'ESCUELA PARTICULAR EL PROGRESO', value: '5392' },
  { text: 'LICEO POLITECNICO MANUEL MONTT', value: '5393' },
  { text: 'ESCUELA MARCELA PAZ', value: '5395' },
  { text: 'COLEGIO IGNACIO CARRERA PINTO', value: '5396' },
  { text: 'ESCUELA HEROES DE IQUIQUE', value: '5398' },
  { text: 'ESCUELA ESPECIAL CONFEDERACION SUIZA', value: '5401' },
  { text: 'ESCUELA CLAUDIO MATTE', value: '5403' },
  { text: 'ESCUELA HERNAN TRIZANO AVEZZANA', value: '5404' },
  { text: 'ESCUELA SELVA OSCURA', value: '5406' },
  { text: 'ESCUELA BASICA PATRICIO LINCH', value: '5407' },
  { text: 'ESCUELA PAILAHUEQUE', value: '5408' },
  { text: 'ESCUELA PEHUENCO', value: '5410' },
  { text: 'ESCUELA QUINO', value: '5411' },
  { text: 'ESCUELA BASICA TOQUIHUE', value: '5414' },
  { text: 'ESCUELA BASICA EL PORVENIR', value: '5415' },
  { text: 'ESCUELA BASICA LAS CARDAS', value: '5422' },
  { text: 'ESCUELA BASICA TRANGOL', value: '5423' },
  { text: 'ESCUELA BASICA SAN LUIS', value: '5424' },
  { text: 'ESCUELA BASICA SANTA ELENA', value: '5425' },
  { text: 'ESCUELA BASICA COLO', value: '5430' },
  { text: 'ESCUELA BASICA SAN PEDRO', value: '5431' },
  { text: 'ESCUELA PARTICULAR LA ARAUCANA', value: '5436' },
  { text: 'ESCUELA PARTICULAR BOLLILCO', value: '5437' },
  { text: 'COMPLEJO EDUCACIONAL LUIS DURAND DURAND', value: '5439' },
  { text: 'LICEO LUCILA GODOY ALCAYAGA', value: '5440' },
  { text: 'ESCUELA REPUBLICA DE ISRAEL', value: '5441' },
  { text: 'ESCUELA BASICA EMILIA ROMAGNA', value: '5442' },
  { text: 'ESCUELA PROFESOR JUAN DE LA CRUZ MUNOZ M.', value: '5444' },
  { text: 'ESCUELA DIEGO PORTALES', value: '5446' },
  { text: 'ESC. BASICA ANIDIR', value: '5449' },
  { text: 'ESC. BASICA FUNDO SAN RAIMUNDO', value: '5453' },
  { text: 'ESCUELA REDUCCION CONTRERAS', value: '5454' },
  { text: 'ESC.BASICA QUILQUEN', value: '5455' },
  { text: 'ESC. BASICA FUNDO QUINO', value: '5459' },
  { text: 'ESC. BASICA REDUCCION TEMULEMU', value: '5462' },
  { text: 'ESC. BASICA DIDAICO', value: '5463' },
  { text: 'COLEGIO LOUIS PASTEUR', value: '5465' },
  { text: 'ESCUELA PARTICULAR SANTA ROSA', value: '5466' },
  { text: 'LICEO AGRICOLA Y FORESTAL SUIZO LA PROVI', value: '5467' },
  { text: 'ESCUELA PARTICULAR LORENZO COLIPI', value: '5469' },
  { text: 'ESCUELA BASICA REPUBLICA DE ITALIA', value: '5470' },
  { text: 'ESCUELA MUNICIPAL DE LUMACO', value: '5471' },
  { text: 'ESC. MUNICIPAL PICHIPELLAHUEN', value: '5472' },
  { text: 'ESC. BASICA QUETRAHUE', value: '5473' },
  { text: 'ESC. BASICA RALUN', value: '5474' },
  { text: 'ESC. BASICA LOS COPIHUES', value: '5477' },
  { text: 'ESC. BASICA CHANCO', value: '5479' },
  { text: 'ESCUELA RUCATRARO ALTO', value: '5480' },
  { text: 'ESC. BASICA RUCAYECO', value: '5482' },
  { text: 'ESC. BASICA ALTO LIUCURA', value: '5483' },
  { text: 'ESC. BASICA BUTA RINCON', value: '5485' },
  { text: 'ESC. BASICA MANZANAR', value: '5487' },
  { text: 'ESC. BASICA COMUDE', value: '5490' },
  { text: 'ESC. BASICA REDUCCION CALBUDIR', value: '5492' },
  { text: 'ESCUELA PARTICULAR LAS COLINAS', value: '5493' },
  { text: 'ESCUELA PARTICULAR PICHI-LONCOYAN', value: '5494' },
  { text: 'ESCUELA PARTICULAR QUILLUCO', value: '5496' },
  { text: 'ESCUELA PARTICULAR CURILEBU', value: '5498' },
  { text: 'ESCUELA PARTICULAR GABRIELA MISTRAL', value: '5499' },
  { text: 'ESCUELA PARTICULAR EL EDEN', value: '5503' },
  { text: 'ESCUELA PARTICULAR CALBUCO', value: '5504' },
  { text: 'ESCUELA GENERAL LAGOS', value: '5506' },
  { text: 'ESCUELA PEDRO DE ONA', value: '5508' },
  { text: 'Liceo Bicentenario Ind\u00f3mito De Pur\u00e9n', value: '5509' },
  { text: 'ESCUELA ENZO FERRARI', value: '5510' },
  { text: 'ESC. BASICA AGUA SANTA', value: '5511' },
  { text: 'ESC.BASICA PINGUIDAHUE', value: '5512' },
  { text: 'ESC. BASICA TRANAMAN', value: '5513' },
  { text: 'ESC. BASICA EL VALLE', value: '5515' },
  { text: 'ESC. BASICA COYANCAHUIN', value: '5516' },
  { text: 'ESC. BASICA MANZANAL', value: '5517' },
  { text: 'ESC. BASICA CONUNHUENU', value: '5518' },
  { text: 'ESC. BASICA IPINCO ALTO', value: '5520' },
  { text: 'ESC. BASICA QUILACO', value: '5521' },
  { text: 'ESC. BASICA HUITRANLEBU', value: '5522' },
  { text: 'ESCUELA PELLAHUENCO', value: '5523' },
  { text: 'ESC. BASICA EL LINGUE', value: '5524' },
  { text: 'ESC. BASICA CAUPOLICAN', value: '5525' },
  { text: 'ESCUELA PARTICULAR AGUA SANTA', value: '5529' },
  { text: 'ESCUELA PARTICULAR BOYECO', value: '5530' },
  { text: 'ESCUELA PARTICULAR TRULAUQUEN', value: '5532' },
  { text: 'ESCUELA PARTICULAR SAN BERNARDO', value: '5533' },
  { text: 'ESCUELA PARTICULAR LOS DERRAMES', value: '5535' },
  { text: 'ESCUELA PARTICULAR PICHIHUENOCOLLE', value: '5536' },
  { text: 'ESCUELA PARTICULAR REMEHUEICO', value: '5537' },
  { text: 'ESCUELA GUSTAVO VASQUEZ DIAZ', value: '5538' },
  { text: 'ESCUELA DE LOS SAUCES', value: '5539' },
  { text: 'ESC. BASICA ELENA MULLER M.', value: '5541' },
  { text: 'ESC. BASICA LINO BARBIERI CANTERGIANI', value: '5542' },
  { text: 'ESC. BASICA SAN RAMON ALTO', value: '5544' },
  { text: 'ESC. BASICA OSCAR  CASTRO', value: '5546' },
  { text: 'ESC. BASICA PIVADENCO', value: '5548' },
  { text: 'ESCUELA BASICA VILLA TRINTE', value: '5550' },
  { text: 'ESC. BASICA GUIDO GRANDE', value: '5551' },
  { text: 'ESC. BASICA NAPADIR', value: '5552' },
  { text: 'ESC. BASICA EL MEMBRILLAR', value: '5553' },
  { text: 'ESC. BASICA HUITRANLEBU', value: '5554' },
  { text: 'ESC. BASICA QUEUQUE', value: '5555' },
  { text: 'ESC. BASICA SAN CARLITOS', value: '5556' },
  { text: 'ESCUELA VICENTE PEREZ ROSALES', value: '5557' },
  { text: 'ESC. BASICA NININCO', value: '5558' },
  { text: 'ESCUELA DE CENTENARIO', value: '5561' },
  { text: 'ESC. BASICA PETRONA PAILLALEO', value: '5563' },
  { text: 'Liceo Tecnol\u00f3gico De La Araucania', value: '5567' },
  { text: 'LICEO TECNICO DE TEMUCO', value: '5568' },
  { text: 'LICEO GABRIELA MISTRAL DE TEMUCO', value: '5569' },
  { text: 'COMPLEJO EDUCACIONAL PADRE LAS CASAS', value: '5574' },
  { text: 'ESCUELA ARTURO PRAT', value: '5575' },
  { text: 'ESCUELA LLAIMA', value: '5578' },
  { text: 'ESCUELA MANUEL RODRIGUEZ', value: '5579' },
  { text: 'ESCUELA CAMPOS DEPORTIVOS', value: '5580' },
  { text: 'ESCUELA STANDAR', value: '5582' },
  { text: 'ESCUELA SANTA ROSA', value: '5583' },
  { text: 'ESCUELA JOSE MIGUEL CARRERA', value: '5584' },
  { text: 'ESCUELA VILLA ALEGRE', value: '5585' },
  { text: 'ESCUELA MANUEL RECABARREN', value: '5588' },
  { text: 'ESCUELA MILLARAY', value: '5589' },
  { text: 'COMPLEJO EDUC. UN AMANECER EN LA ARAUCANIA', value: '5590' },
  { text: 'ESCUELA ANDRES BELLO', value: '5592' },
  { text: 'ESCUELA BASICA MARCELA PAZ', value: '5594' },
  { text: 'COLEGIO MUNDO MAGICO', value: '5596' },
  { text: 'ESCUELA ALONSO DE ERCILLA', value: '5597' },
  { text: 'ESCUELA ESPECIAL NIELOL', value: '5598' },
  { text: 'ESCUELA DARIO SALAS', value: '5599' },
  { text: 'ESCUELA DE ADULTOS  MANUEL ROJAS', value: '5600' },
  { text: 'ESCUELA DE PARVULOS EL TRENCITO', value: '5601' },
  { text: 'JARDIN INFANTIL MONTE VERDE', value: '5603' },
  { text: 'ESCUELA PEDRO DE VALDIVIA', value: '5604' },
  { text: 'ESCUELA TURINGIA', value: '5605' },
  { text: 'ESCUELA VILLA CAROLINA', value: '5606' },
  { text: 'ESCUELA LOS AVELLANOS', value: '5608' },
  { text: 'ESCUELA LOS TRIGALES', value: '5611' },
  { text: 'ESCUELA LABRANZA', value: '5614' },
  { text: 'ESCUELA DE PARVULOS CAMPANITA', value: '5617' },
  { text: 'ESCUELA DE PARVULOS SEMILLITA', value: '5619' },
  { text: 'C.E.I.A. SELVA SAAVEDRA', value: '5620' },
  {
    text: 'ESCUELA B\u00c3\u0081SICA BERNARDO \u00c3\u2018ANKO',
    value: '5622',
  },
  { text: 'ESCUELA TRUMPULO CHICO', value: '5623' },
  { text: 'ESCUELA METRENCO', value: '5624' },
  { text: 'ESCUELA TRUF-TRUF.', value: '5625' },
  { text: 'ESCUELA LAUREL HUACHO', value: '5627' },
  { text: 'ESCUELA REDUCCION RALUNCOLLAN', value: '5629' },
  { text: 'ESCUELA MANIO CHICO', value: '5630' },
  { text: 'ESCUELA LICANCO', value: '5631' },
  { text: 'ESCUELA REDUCCION MONTE VERDE', value: '5632' },
  { text: 'ESCUELA CONOCO CHICO', value: '5633' },
  { text: 'ESCUELA NIRRIMAPU', value: '5634' },
  { text: 'ESCUELA TROMEN', value: '5635' },
  { text: 'ESCUELA BOTROLHUE', value: '5636' },
  { text: 'ESCUELA TROMEN BAJO', value: '5637' },
  { text: 'ESCUELA COLPANAO', value: '5638' },
  { text: 'ESCUELA LIRCAY', value: '5639' },
  { text: 'ESCUELA MOLLULCO', value: '5640' },
  { text: 'ESCUELA TROMEN ALTO', value: '5644' },
  { text: 'ESCUELA BOYECO', value: '5645' },
  { text: 'ESCUELA CHOMIO', value: '5646' },
  { text: 'ESCUELA COLLIMALLIN', value: '5647' },
  { text: 'ESCUELA CHAPOD', value: '5648' },
  { text: 'ESCUELA FUNDO MAQUEHUE', value: '5649' },
  { text: 'ESCUELA  PARTICULAR  COLLIN', value: '5651' },
  { text: 'COLEGIO PROVIDENCIA DE TEMUCO', value: '5652' },
  { text: 'LICEO CARLOS CONDELL DE LA HAZA', value: '5653' },
  { text: 'LICEO POLITECNICO PUEBLO NUEVO', value: '5656' },
  { text: 'COMPLEJO EDUCACIONAL JAVIERA CARRERA', value: '5658' },
  { text: 'COMPLEJO EDUCACIONAL PADRE OSCAR MOSER', value: '5663' },
  { text: 'LICEO AUGUSTO WINTER', value: '5664' },
  { text: 'COL.PART.ESP.DE DEF. AUDIT.ANGLICANO', value: '5665' },
  { text: 'ESC.PARTIC. MONS.GUIDO DE RAMBERGA', value: '5667' },
  { text: 'ESCUELA BASICA VISTA VERDE', value: '5668' },
  { text: 'ESCUELA PARTICULAR MADRE ADMIRABLE', value: '5669' },
  { text: 'ESCUELA PARTICULAR ARTURO ARRIAGADA', value: '5675' },
  { text: 'ESC. ESP.RETARDO MENTAL LAS ARAUCARIAS', value: '5677' },
  { text: 'ESCUELA PARTICULAR NTRA.SRA.DEL CARMEN', value: '5678' },
  { text: 'ESC.PART.SAN FRANCISCO DE ASIS DE TEMUCO', value: '5680' },
  { text: 'ESCUELA PARTICULAR FRANCIA', value: '5682' },
  { text: 'ESCUELA PARTICULAR PADRE VENANCIO', value: '5683' },
  { text: 'ESCUELA PART. WENCESLAO VALDIVIA', value: '5684' },
  { text: 'ESCUELA PARTICULAR EL ROBLE', value: '5686' },
  { text: 'ESCUELA PARTICULAR LA ESPIGA', value: '5690' },
  { text: 'ESCUELA PARTICULAR ESTRELLA DE BELEN', value: '5693' },
  { text: 'ESCUELA PARTICULAR ALIANZA', value: '5694' },
  { text: 'ESCUELA PARTICULAR SAN RAFAEL ARCANGEL', value: '5695' },
  { text: 'ESCUELA PARTICULAR LAS AMERICAS', value: '5697' },
  { text: 'ESCUELA PARTICULAR ARAUCANIA', value: '5698' },
  { text: 'ESCUELA PARTICULAR LOS REYES', value: '5700' },
  { text: 'ESCUELA PARTICULAR VILLA IRMA', value: '5701' },
  { text: 'LICEO TECNICO PROF. CENTENARIO', value: '5703' },
  { text: 'ESCUELA PARTICULAR SAN JUAN', value: '5706' },
  { text: 'ESCUELA PARTICULAR LOS TRIGALES', value: '5709' },
  { text: 'LICEO PARTICULAR NAZARETH', value: '5711' },
  { text: 'COLEGIO PARTICULAR I. CULTURA BRITANICA', value: '5713' },
  { text: 'ESCUELA PART.SANTA MARIA DE LA RIBERA', value: '5714' },
  { text: 'PADRE BARTOLOME DE LAS CASAS', value: '5716' },
  { text: 'ESCUELA PARTICULAR CLAUDIO MATTE', value: '5717' },
  { text: 'ESCUELA PARTICULAR DE PARVULOS', value: '5718' },
  { text: 'ESCUELA PARTICULAR ARAUCANIA', value: '5719' },
  { text: 'COLEGIO \u00c3\u2018IELOL CHE KIMUN', value: '5720' },
  { text: 'ESCUELA PARTICULAR PAPELUCHO', value: '5722' },
  { text: 'ESCUELA PARTICULAR SAN BERNARDO', value: '5725' },
  { text: 'COLEGIO MANUEL MONTT', value: '5726' },
  {
    text: 'CENTRO EDUCACIONAL AGROTUR\u00c3\u008dSTICO SANTA CRUZ',
    value: '5729',
  },
  { text: 'ESCUELA PARTICULAR ROBLE HUACHO', value: '5730' },
  { text: 'ESCUELA PARTICULAR MILLAHUECO', value: '5731' },
  { text: 'ESCUELA PARTICULAR MAQUEHUE', value: '5732' },
  { text: 'ESCUELA PARTICULAR BOTRONHUE', value: '5734' },
  { text: 'ESCUELA PARTICULAR HERMANO PASCUAL', value: '5737' },
  { text: 'ESCUELA PART. LOS COPIHUES', value: '5739' },
  { text: 'ESCUELA PARTICULAR SAN MANUEL', value: '5740' },
  { text: 'ESCUELA PARTICULAR RANQUILCO', value: '5742' },
  { text: 'ESCUELA PARTICULAR SAN SILVESTRE', value: '5744' },
  { text: 'ESCUELA PARTICULAR MILLANTU', value: '5745' },
  { text: 'ESCUELA PARTICULAR MONO PAINE', value: '5746' },
  { text: 'ESCUELA  BELLAVISTA DE COYAHUE', value: '5747' },
  { text: 'ESCUELA PARTICULAR LAS LOMAS', value: '5748' },
  { text: 'ESCUELA PARTICULAR CRUZ DE MAYO', value: '5750' },
  { text: 'ESCUELA SAN ANTONIO DE NIENOCO', value: '5751' },
  { text: 'ESCUELA PARTICULAR SAN PEDRO RAPA', value: '5752' },
  { text: 'ESCUELA PARTICULAR SAN MIGUEL', value: '5753' },
  { text: 'ESCUELA PARTICULAR NUEVA MEMBRILLAR', value: '5754' },
  { text: 'ESCUELA PARTICULAR RENGALIL', value: '5756' },
  { text: 'ESCUELA PARTICULAR BOYECO', value: '5759' },
  { text: 'ESCUELA PARTICULAR DIEGO PORTALES', value: '5760' },
  { text: 'ESCUELA SAN MARTIN DE PORRES', value: '5761' },
  { text: 'ESCUELA PARTICULAR MANZANAR DE LLEUPECO', value: '5763' },
  { text: 'ESCUELA PARTICULAR ZANJA', value: '5764' },
  { text: 'ESCUELA PARTICULAR KIMELTU DE PANCO', value: '5765' },
  {
    text: 'ESCUELA B\u00c3\u0081SICA PARTICULAR SUBVENCIONADA GUIDO BUCHER',
    value: '5766',
  },
  { text: 'ESCUELA PARTICULAR TRES CERROS', value: '5767' },
  { text: 'ESCUELA PARTICULAR SAN VICENTE', value: '5768' },
  { text: 'ESCUELA PARTICULAR JUAN ARIAS MANSILLA', value: '5770' },
  { text: 'ESCUELA PARTICULAR LUIS CRUZ MARTINEZ', value: '5773' },
  { text: 'ESCUELA PARTICULAR SAN FRANCISCO', value: '5774' },
  { text: 'ESCUELA PARTICULAR VIRGEN DE GUADALUPE', value: '5776' },
  { text: 'ESCUELA PARTICULAR EL VALLE', value: '5778' },
  { text: 'ESCUELA PARTICULAR EL ESFUERZO', value: '5779' },
  { text: 'ESCUELA PARTICULAR ARAUCO', value: '5781' },
  { text: 'ESCUELA PARTICULAR SIGLO XXI', value: '5782' },
  { text: 'ESCUELA PARTICULAR SAN JOSE', value: '5783' },
  { text: 'ESCUELA PARTICULAR SARGENTO CANDELARIA', value: '5784' },
  { text: 'ESCUELA PARTICULAR SAN MATEO', value: '5785' },
  { text: 'ESCUELA PARTICULAR CENTRAL QUILACO', value: '5787' },
  { text: 'ESCUELA PARTICULAR EL CRUCERO', value: '5790' },
  { text: 'ESCUELA PARTICULAR WITRAMALAL', value: '5791' },
  { text: 'ESCUELA PARTICULAR EL ALBA', value: '5792' },
  { text: 'ESCUELA ANDRES BELLO', value: '5793' },
  { text: 'ESCUELA PARTICULAR PROF.ANDRES AGUAYO', value: '5794' },
  { text: 'ESCUELA PARTICULAR DOCTOR MUHAJIR', value: '5796' },
  { text: 'ESCUELA PARTICULAR REPOCURA', value: '5797' },
  { text: 'ESCUELA PARTICULAR NIRRIMAPU', value: '5798' },
  { text: 'ESCUELA SANTA INES DE CAIVICO', value: '5799' },
  { text: 'ESCUELA PARTICULAR JOSE LUIS SANFUENTES', value: '5800' },
  { text: 'ESCUELA PARTICULAR POETA ERCILLA', value: '5801' },
  { text: 'ESCUELA PARTICULAR PICHI ITINENTO', value: '5803' },
  { text: 'ESCUELA BASICA PARTICULAR CINCO LAUREL', value: '5804' },
  { text: 'ESCUELA PARTICULAR DAVID RIADI MATUS', value: '5806' },
  { text: 'ESCUELA PARTICULAR LA ROCA', value: '5807' },
  { text: 'COLEGIO ALEMAN', value: '5812' },
  { text: 'COLEGIO CENTENARIO', value: '5813' },
  { text: 'COLEGIO SANTA CRUZ', value: '5814' },
  { text: 'ESC. BASICA NUMERO SEIS', value: '5824' },
  { text: 'ESC. BASICA AMELIA GODOY', value: '5825' },
  { text: 'ESCUELA IRENE FREI', value: '5827' },
  { text: 'ESC. BASICA GUACOLDA', value: '5828' },
  { text: 'ESCUELA LOS CACHORROS', value: '5829' },
  { text: 'ESCUELA DE LAUTARO', value: '5830' },
  { text: 'LICEO LOS CASTANOS', value: '5831' },
  { text: 'ESC. BASICA NIERECO', value: '5832' },
  { text: 'ESC. BASICA REWE KIMUN', value: '5833' },
  { text: 'ESC. BASICA ALTO MECO', value: '5834' },
  { text: 'ESC. BASICA VILLA COIHUECO', value: '5835' },
  { text: 'ESCUELA DOLLICO ALTO', value: '5837' },
  { text: 'ESC. BASICA LAS MINAS', value: '5838' },
  { text: 'ESC. BASICA SAN LUIS DE ROBLER-A', value: '5844' },
  { text: 'ESC. BASICA TRES ESQUINAS', value: '5846' },
  { text: 'ESC. BASICA SANTA YOLANDA', value: '5847' },
  { text: 'ESC. BASICA PUMALAL', value: '5849' },
  { text: 'ESC. BASICA VISTA HERMOSA', value: '5850' },
  { text: 'ESC. BASICA CHUMIL', value: '5851' },
  { text: 'ESC. BASICA EL ESCUDO', value: '5852' },
  { text: 'ESC. BASICA VEGA LARGA', value: '5854' },
  { text: 'ESC. BASICA MUCO CHUREO', value: '5855' },
  { text: 'ESC. BASICA MALPICHAHUE', value: '5857' },
  { text: 'ESC.PART.SAN FRANCISCO DE ASIS - LAUTARO', value: '5861' },
  { text: 'ESCUELA PARTICULAR CORAZON DE JESUS', value: '5862' },
  { text: 'ESCUELA PARTICULAR QUILACURA', value: '5868' },
  { text: 'ESCUELA PARTICULAR SANTA TERESA', value: '5869' },
  { text: 'ESCUELA PARTICULAR SANTA TERESITA', value: '5871' },
  { text: 'ESCUELA PARTICULAR HUINCA RAILAO', value: '5872' },
  { text: 'ESCUELA PARTICULAR LOS HUALLES', value: '5873' },
  { text: 'ESCUELA PARTICULAR NUEVA DOLLINCO', value: '5875' },
  { text: 'ESCUELA PARTICULAR SAN RAFAEL', value: '5876' },
  { text: 'ESCUELA PARTICULAR LOS SOLARES', value: '5877' },
  { text: 'ESCUELA PARTICULAR VALLEPENCO', value: '5878' },
  { text: 'LICEO ISABEL POBLETE V.', value: '5879' },
  { text: 'ESCUELA EDUARDO FREI MONTALVA', value: '5880' },
  { text: 'ESCUELA LOS QUIQUES', value: '5885' },
  { text: 'ESCUELA BASICA REHUECOYAN', value: '5886' },
  { text: 'ESC. BASICA PARLAMENTO', value: '5888' },
  { text: 'ESCUELA PARTICULAR LAS CEREZAS', value: '5893' },
  { text: 'ESCUELA PARTICULAR LA ESTRELLA', value: '5894' },
  { text: 'ESCUELA JAPON', value: '5896' },
  { text: 'COLEGIO AMERICA', value: '5897' },
  { text: 'ESCUELA DAGOBERTO GODOY', value: '5899' },
  { text: 'ESC. BASICA VEGA REDONDA', value: '5901' },
  { text: 'ESCUELA MARTIN ALONQUEO PIUTRIN', value: '5902' },
  { text: 'ESC. BASICA COLLIN ALTO', value: '5905' },
  { text: 'ESC. BASICA HOGAR DE PEDREGOSO', value: '5909' },
  { text: 'ESC. BASICA CANTINO', value: '5911' },
  { text: 'ESCUELA PADRE OSVALDO VEGA', value: '5919' },
  { text: 'COMPLEJO EDUCACIONAL PADRE NICOLAS', value: '5921' },
  { text: 'LICEO AGRICOLA CRUZ DEL SUR', value: '5923' },
  { text: 'ESCUELA PARTICULAR CODINHUE', value: '5927' },
  { text: 'ESCUELA PARTICULAR SANTA GERTRUDIS', value: '5930' },
  { text: 'ESCUELA PARTICULAR MALLA', value: '5931' },
  { text: 'ESCUELA PARTICULAR COLONIA MENDOZA', value: '5932' },
  { text: 'ESCUELA PARTICULAR EL NATRE', value: '5933' },
  { text: 'ESCUELA PARTICULAR SANTA TERESITA', value: '5935' },
  { text: 'SAN MIGUEL DE QUINTRILPE', value: '5938' },
  { text: 'ESCUELA PARTICULAR VIRGEN DE FATIMA', value: '5940' },
  { text: 'ESCUELA PARTICULAR SAN ANTONIO', value: '5942' },
  { text: 'ESCUELA PARTICULAR RENICO', value: '5945' },
  { text: 'ESCUELA PARTICULAR CRUZ DEL SUR', value: '5947' },
  { text: 'ESCUELA PARTICULAR SANTA MONICA', value: '5952' },
  { text: 'ESCUELA PARTICULAR LOS ROBLES', value: '5954' },
  { text: 'ESCUELA PARTICULAR MONTERREY', value: '5955' },
  { text: 'LICEO ARTURO VALENZUELA', value: '5959' },
  { text: 'ESCUELA BASICA LAS HORTENCIAS', value: '5960' },
  { text: 'ESCUELA HECTOR VALENZUELA CEA', value: '5962' },
  { text: 'ESC. BASICA LLANQUI LLANQUI', value: '5963' },
  { text: 'ESC. BASICA SAN CAMILO', value: '5964' },
  { text: 'ESCUELA VIDA Y PAZ', value: '5970' },
  { text: 'ESC. BASICA EL ROSAL', value: '5973' },
  { text: 'ESCUELA PARTICULAR RIOS DE AGUA VIVA', value: '5974' },
  { text: 'ESC. BASICA FAJA 2000 HUICHAHUE', value: '5975' },
  { text: 'ESC. BASICA QUINETRU', value: '5977' },
  { text: 'ESC. BASICA HUERERE', value: '5978' },
  { text: 'ESC. BASICA LLAULLAHUE', value: '5980' },
  { text: 'ESCUELA PAULO ARAVENA ARAVENA', value: '5981' },
  { text: 'ESC. BASICA LO SCHMITH', value: '5984' },
  { text: 'ESCUELA LA MANANA', value: '5985' },
  { text: 'ESC. BASICA LEUFUCHE', value: '5987' },
  { text: 'ESCUELA BASICA QUECHEREHUE', value: '5990' },
  { text: 'ESCUELA LEOVIGILDO KLEY', value: '5993' },
  {
    text: 'ESCUELA PARTICULAR SUBVENCIONADA PADRE MARCELINO HUICHAMIL',
    value: '5994',
  },
  { text: 'ESCUELA PARTICULAR QUECHEREHUE', value: '5995' },
  { text: 'ESC. PART. N\u00c2\u00ba 13 MAHUIDANCHE', value: '5997' },
  { text: 'ESCUELA PARTICULAR LA BASTILLA', value: '5998' },
  { text: 'ESCUELA PARTICULAR PADRE BERNABE', value: '5999' },
  { text: 'ESC. PART. STA. ISABEL DE TRAFAMPULLI', value: '6003' },
  { text: 'ESCUELA AURORA DE CHILE', value: '6005' },
  { text: 'ESCUELA PARTICULAR ALAMEDA', value: '6006' },
  { text: 'LICEO LOS ANDES', value: '6007' },
  { text: 'ESC. BASICA MOLULCO', value: '6009' },
  { text: 'ESC. BASICA MOLULCO', value: '6011' },
  { text: 'ESC. BASICA CUMCUMLLAQUE', value: '6012' },
  { text: 'ESC. BASICA CAREN', value: '6013' },
  { text: 'ESC. BASICA CURACALCO', value: '6015' },
  { text: 'ESC. BASICA HUECHELEPUN', value: '6017' },
  { text: 'ESCUELA PARTICULAR SAN GABRIEL', value: '6018' },
  { text: 'ESCUELA PARTICULAR LLAIMA', value: '6019' },
  { text: 'ESCUELA PARTICULAR CAREN', value: '6021' },
  { text: 'ESCUELA PARTICULAR LA SUERTE', value: '6022' },
  { text: 'ESCUELA PARTICULAR PALIHUEPILLAN', value: '6023' },
  { text: 'ESCUELA PARTICULAR EL RETIRO', value: '6024' },
  { text: 'ESCUELA DAHUELHUE', value: '6025' },
  { text: 'ESCUELA PARTICULAR EL SALTO', value: '6026' },
  {
    text: 'COMPLEJO EDUCACIONAL MONSE\u00c3\u2018OR FRCO. VALDES S',
    value: '6027',
  },
  { text: 'ESCUELA RUCA MANKE', value: '6029' },
  { text: 'ESCUELA JERONIMO NECULPAN', value: '6030' },
  { text: 'ESCUELA EL SANTILLO', value: '6031' },
  { text: 'ESCUELA MAMUIL MALAL', value: '6032' },
  { text: 'ESCUELA LICANCURA', value: '6036' },
  { text: 'ESCUELA PUENTE BASA', value: '6037' },
  { text: 'COMPLEJO EDUCACIONAL RUKA NGEN', value: '6038' },
  { text: 'ESCUELA PARTICULAR CATRIPULLI', value: '6039' },
  { text: 'ESCUELA PARTICULAR PUALA', value: '6040' },
  { text: 'ESCUELA PARTICULAR LOS RAULIES', value: '6041' },
  { text: 'ESCUELA PARTICULAR VIRGEN DE RINCONADA', value: '6042' },
  { text: 'ESCUELA PARTICULAR LONCOFILO', value: '6043' },
  { text: 'ESCUELA PARTICULAR MAITE', value: '6044' },
  { text: 'ESCUELA PARTICULAR PANQUE', value: '6045' },
  { text: 'ESCUELA PARTICULAR MAITE ALTO', value: '6046' },
  { text: 'ESCUELA PARTICULAR MAICHIN', value: '6048' },
  { text: 'ESCUELA PARTICULAR LOS SAUCES', value: '6049' },
  { text: 'LICEO DE HOTELERIA Y TURISMO', value: '6051' },
  { text: 'ESCUELA CARLOS HOLZAFEL', value: '6052' },
  { text: 'ESCUELA JOSE MIGUEL MARTINEZ SOTO', value: '6053' },
  { text: 'ESC. BASICA QUELHUE', value: '6054' },
  { text: 'ESCUELA BASICA MUNICIPAL DE EL CLARO', value: '6056' },
  { text: 'ESCUELA HUIFE ALTO', value: '6059' },
  { text: 'ESC. BASICA VILLA SAN PEDRO', value: '6060' },
  { text: 'ESC. BASICA PICHARES', value: '6062' },
  { text: 'ESC. BASICA CANDELARIA', value: '6063' },
  { text: 'ESC. BASICA CARILEUFU', value: '6066' },
  { text: 'ESC.BASICA PAILLACO', value: '6069' },
  { text: 'ESCUELA PARTICULAR NTRA.SRA.DE FATIMA', value: '6071' },
  { text: 'ESCUELA PARTICULAR RAMON GUINEZ', value: '6072' },
  { text: 'ESCUELA PARTICULAR SAN LUIS', value: '6075' },
  { text: 'ESCUELA PARTICULAR CABURGUA', value: '6076' },
  { text: 'ESCUELA PARTICULAR QUETROLELFU', value: '6077' },
  { text: 'ESCUELA SANTA ROSA DE LLAFENCO', value: '6082' },
  { text: 'ESCUELA PARTICULAR RELICURA', value: '6083' },
  { text: 'LICEO ARAUCANIA', value: '6084' },
  { text: 'LICEO POLITECNICO VILLARRICA', value: '6085' },
  { text: 'ESCUELA JOSE ABELARDO NUNEZ', value: '6086' },
  { text: 'ESCUELA ALEXANDER GRAHAM BELL', value: '6087' },
  { text: 'ESCUELA VALENTIN LETELIER', value: '6088' },
  { text: 'ESCUELA VOIPIR DE NANCUL', value: '6089' },
  { text: 'ESCUELA MARIANO LATORRE', value: '6090' },
  { text: 'ESC.ESP.RET.MENTAL BEATO LUIS ORIONE', value: '6091' },
  { text: 'ESCUELA EPUKLEI', value: '6092' },
  { text: 'ESCUELA MOLCO ALTO', value: '6093' },
  { text: 'ESCUELA LAS VERTIENTES', value: '6097' },
  { text: 'ESCUELA CONQUIL', value: '6107' },
  { text: 'ESCUELA MANANTIAL', value: '6108' },
  { text: 'ESCUELA INDUSTRIAL SAN JOSE', value: '6113' },
  { text: 'COMPLEJO EDUCACIONAL SAN AGUSTIN', value: '6115' },
  { text: 'ESCUELA PARTICULAR SAGRADA FAMILIA', value: '6116' },
  { text: 'ESCUELA PARTICULAR NANCUL', value: '6117' },
  { text: 'COLEGIO SANTA CRUZ', value: '6118' },
  { text: 'LICEO PART. LIBERTAD', value: '6119' },
  { text: 'ESCUELA PARTICULAR ALBERTO HURTADO', value: '6120' },
  { text: 'ESCUELA PARTICULAR PUCARA ALTO', value: '6121' },
  { text: 'ESCUELA PARTICULAR ADVENTISTA', value: '6122' },
  { text: 'ESCUELA PARTICULAR ARTURO PRAT', value: '6123' },
  { text: 'ESCUELA PARTICULAR PEDRO AGUIRRE CERDA', value: '6124' },
  { text: 'ESCUELA PARTICULAR NUEVA ESPERANZA', value: '6126' },
  { text: 'ESCUELA PARTICULAR CUDICO', value: '6127' },
  { text: 'ESCUELA PARTICULAR HUECHULELFU', value: '6129' },
  { text: 'ESCUELA PARTICULAR CHAURA', value: '6132' },
  { text: 'ESCUELA PARTICULAR LUIS CRUZ MARTINEZ', value: '6135' },
  { text: 'ESCUELA PARTICULAR SAN LUIS', value: '6137' },
  { text: 'ESCUELA PARTICULAR CALFUTUE', value: '6138' },
  { text: 'ESCUELA PARTICULAR SANTA RITA', value: '6139' },
  { text: 'ESCUELA PARTICULAR NUEVA LONCOTRARO', value: '6140' },
  { text: 'ESCUELA PARTICULAR LIUMALLA', value: '6142' },
  { text: 'ESCUELA PARTICULAR RAYENKO', value: '6143' },
  { text: 'ESCUELA PARTICULAR LOS CIRUELOS', value: '6144' },
  { text: 'ESCUELA PARTICULAR COLONIA CHALLUPEN', value: '6146' },
  { text: 'ESCUELA PARTICULAR NELTUME', value: '6147' },
  { text: 'ESCUELA PARTICULAR SANTA FILOMENA', value: '6149' },
  { text: 'ESCUELA PARTICULAR PUENTE BASA', value: '6151' },
  { text: 'ESCUELA PARTICULAR CURILELFU', value: '6154' },
  { text: 'ESCUELA PARTICULAR SAN FRANCISCO', value: '6155' },
  { text: 'ESCUELA PARTICULAR LOS CIERVOS', value: '6156' },
  { text: 'ESCUELA PARTICULAR VIRGEN CANDELARIA', value: '6157' },
  { text: 'ESCUELA PARTICULAR CARMELITA', value: '6160' },
  { text: 'COLEGIO ALEMAN', value: '6161' },
  { text: 'LICEO JUAN SCHLEYER', value: '6163' },
  { text: 'ESCUELA JUAN SEGUEL', value: '6164' },
  { text: 'ESCUELA RAIMAPU', value: '6165' },
  { text: 'ESCUELA LA ESPERANZA', value: '6166' },
  { text: 'ESC. ESP.RET.MENTAL PAUL HARRIS', value: '6167' },
  { text: 'ESCUELA LENFUEN', value: '6168' },
  { text: 'ESCUELA ARMANDO QUINTULEN', value: '6170' },
  { text: 'ESCUELA RUCAHUE', value: '6173' },
  { text: 'ESCUELA LAS PALMERAS', value: '6175' },
  { text: 'ESCUELA CACIQUE AILLANIR', value: '6177' },
  { text: 'ESCUELA BASICA QUETROCO', value: '6178' },
  { text: 'ESCUELA RURAL EL LLIUCO', value: '6179' },
  { text: 'ESCUELA DOLLINCO', value: '6180' },
  { text: 'ESCUELA COIPUE', value: '6181' },
  { text: 'ESCUELA ALLIPEN', value: '6183' },
  { text: 'ESCUELA PARTICULAR SANTA INES', value: '6188' },
  { text: 'ESCUELA PARTICULAR ARTURO PRAT', value: '6189' },
  { text: 'ESCUELA PARTICULAR GENERAL PRIETO', value: '6190' },
  { text: 'ESCUELA PARTICULAR LAS PATAGUAS', value: '6192' },
  { text: 'ESCUELA PARTICULAR TRALGNA', value: '6196' },
  { text: 'ESCUELA SANTA ELENA FIN - FIN', value: '6197' },
  { text: 'ESCUELA PARTICULAR GUINIMO', value: '6198' },
  { text: 'ESCUELA PARTICULAR EL TESORO', value: '6200' },
  { text: 'ESCUELA PARTICULAR SAN NICANOR', value: '6203' },
  { text: 'ESCUELA PARTICULAR SAN ISIDRO LABRADOR', value: '6204' },
  { text: 'ESCUELA PARTICULAR SAN MANUEL DE LOLEN', value: '6205' },
  { text: 'ESCUELA PARTICULAR ROSARIO VASQUEZ DE V.', value: '6206' },
  { text: 'ESCUELA PARTICULAR RUPAYAN DE MALLOHUE', value: '6207' },
  { text: 'REDUCCI\u00c3\u201cN PAINEMIL', value: '6208' },
  { text: 'LICEO AGRICOLA MANUEL DILLEMS HILL', value: '6210' },
  { text: 'ESCUELA PARTICULAR MAHUIDACHE', value: '6211' },
  { text: 'ESCUELA PARTICULAR RENACER', value: '6214' },
  { text: 'ESCUELA PARTICULAR SAN ANTONIO', value: '6216' },
  { text: 'ESCUELA PARTICULAR RUCAHUE', value: '6217' },
  { text: 'ESCUELA PARTICULAR TRAPILHUE', value: '6219' },
  { text: 'ESCUELA PARTICULAR PATRIA NUEVA', value: '6220' },
  { text: 'ESCUELA PARTICULAR SAN ROQUE', value: '6221' },
  { text: 'ESCUELA PARTICULAR SANTA ELENA', value: '6222' },
  { text: 'ESCUELA UNION LATINOAMERICANA', value: '6224' },
  { text: 'ESCUELA JUAN BTA. CHESTA CH.', value: '6225' },
  { text: 'ESCUELA LAS AMERICAS', value: '6227' },
  { text: 'ESCUELA RIO TOLTEN', value: '6228' },
  { text: 'LICEO MUNICIPAL LA FRONTERA', value: '6230' },
  { text: 'ESC. BASICA LOS GALPONES', value: '6231' },
  { text: 'ESCUELA NUEVO HORIZONTE', value: '6237' },
  { text: 'ESCUELA SUSANA ORTIZ', value: '6244' },
  { text: 'ESCUELA EL ESFUERZO', value: '6245' },
  { text: 'ESCUELA CHADA', value: '6248' },
  { text: 'ESCUELA SAN RAMON', value: '6249' },
  { text: 'ESCUELA RESERVA FORESTAL MAHUIDANCHI', value: '6251' },
  { text: 'LICEO POLITECNICO PITRUFQUEN', value: '6252' },
  { text: 'COMPLEJO EDUC.MONSENOR GUILLERMO HARTL', value: '6253' },
  { text: 'COLEGIO MADRES DOMINICAS', value: '6254' },
  { text: 'ESCUELA PARTICULAR MANHUE', value: '6256' },
  { text: 'ESCUELA PARTICULAR ALTO MIRADOR', value: '6258' },
  { text: 'ESCUELA PARTICULAR CARILAFQUEN', value: '6259' },
  { text: 'ESCUELA PARTICULAR RESERVA RAIN', value: '6262' },
  { text: 'ESCUELA PARTICULAR MUNE BAJO', value: '6263' },
  { text: 'ESCUELA PARTICULAR QUILQUILCO', value: '6264' },
  { text: 'LICEO PARTICULAR SUBV.QUINQUE', value: '6267' },
  { text: 'ESCUELA PARTICULAR HUEFEL COMUY', value: '6268' },
  { text: 'COMPLEJO EDUCACIONAL ANDRES A. GORBEA', value: '6269' },
  { text: 'LICEO JOSE VICTORINO LASTARRIA', value: '6270' },
  { text: 'ESCUELA BASICA CINCO', value: '6271' },
  { text: 'ESCUELA BASICA LICARAYEN', value: '6272' },
  { text: 'ESC.PRESBITERO JOSE AGUSTIN GOMEZ Z.', value: '6273' },
  { text: 'ESCUELA BASICA MUNICIPAL SAN JUSTO', value: '6276' },
  { text: 'ESCUELA MANTAHUE', value: '6278' },
  { text: 'ESCUELA MELIRREHUE', value: '6279' },
  { text: 'ESCUELA BASICA EL RINCO', value: '6280' },
  { text: 'ESCUELA EL LIUCO', value: '6281' },
  { text: 'ESCUELA EL LAUREL', value: '6282' },
  { text: 'ESCUELA CUARTA FAJA', value: '6283' },
  { text: 'ESCUELA BASICA LOS PERALES', value: '6285' },
  { text: 'ESCUELA LOS PLANCHADOS', value: '6286' },
  { text: 'ESCUELA FAJA RICCI', value: '6289' },
  { text: 'ESCUELA PIDENCO ALTO', value: '6290' },
  { text: 'ESCUELA PARTICULAR NTRA.SRA.DEL CARMEN', value: '6294' },
  { text: 'COLEGIO JUAN PABLO II', value: '6300' },
  { text: 'LICEO POLITECNICO ANDRES BELLO', value: '6301' },
  { text: 'LICEO PADRE ALBERTO HURTADO CRUCHAGA', value: '6302' },
  { text: 'ESCUELA EGON ERNTS KEUTMANN BESGEN', value: '6303' },
  { text: 'ESCUELA ALBORADA', value: '6304' },
  { text: 'ESCUELA DOMITILA PINNA PARRA', value: '6305' },
  { text: 'ESCUELA ESPECIAL RETARDO MENTAL WE NEPEN', value: '6308' },
  { text: 'ESCUELA RUCAHUE', value: '6315' },
  { text: 'ESCUELA EL CASTILLO', value: '6317' },
  { text: 'ESCUELA ESMERALDA', value: '6319' },
  { text: 'ESCUELA WINGKUL-NIGEN', value: '6322' },
  { text: 'ESCUELA WENUY KUDAU', value: '6323' },
  { text: 'ESCUELA PUKOYAM', value: '6325' },
  { text: 'ESCUELA BASICA LUMACO SUR', value: '6327' },
  { text: 'ESCUELA QUESQUECHAN', value: '6329' },
  { text: 'ESCUELA EL TUNEL', value: '6330' },
  { text: 'ESCUELA BASICA  NILCAHUIN', value: '6332' },
  { text: 'ESCUELA HUELQUELELFUN', value: '6333' },
  { text: 'ESCUELA NANCAHUE', value: '6335' },
  { text: 'ESCUELA PARTICULAR SANTA CRUZ', value: '6336' },
  { text: 'ESCUELA PARTICULAR JUAN XXIII', value: '6337' },
  { text: 'ESCUELA PARTICULAR COLLICO', value: '6343' },
  { text: 'ESCUELA PARTICULAR LIGLELFUN', value: '6344' },
  { text: 'ESCUELA PARTICULAR PULMAHUE', value: '6345' },
  { text: 'ESCUELA PARTICULAR SUBVENCIONADA LA FAMILIA', value: '6347' },
  { text: 'COMPLEJO EDUCACIONAL MARTIN KLEINKNECHT', value: '6348' },
  { text: 'ESCUELA AGUAS Y GAVIOTAS', value: '6349' },
  { text: 'ESCUELA RAYEN LAFQUEN QUEULE', value: '6350' },
  { text: 'ESCUELA EL SEMBRADOR', value: '6351' },
  { text: 'ESCUELA AMANECER DE VILLA LOS BOLDOS', value: '6352' },
  { text: 'ESCUELA SAN PEDRO', value: '6353' },
  { text: 'ESCUELA FILULAFQUEN', value: '6356' },
  { text: 'ESCUELA BASICA ESTACION TOLTEN', value: '6358' },
  { text: 'ESCUELA DE CAYCHAYEN', value: '6361' },
  { text: 'ESCUELA PUCHILCO', value: '6363' },
  { text: 'ESCUELA LA COLONIA', value: '6367' },
  { text: 'ESCUELA LA CONCEPCION', value: '6370' },
  { text: 'ESCUELA ANTU-LAFQUEN', value: '6371' },
  { text: 'ESCUELA PORMA', value: '6373' },
  { text: 'ESCUELA BASICA RURAL FLOR DEL VALLE', value: '6374' },
  { text: 'ESCUELA DE CAMAGUEY', value: '6377' },
  { text: 'ESCUELA BOROA NORTE', value: '6378' },
  { text: 'ESCUELA PART. SUBV. SAN JOS\u00c3\u02c6 OBRERO', value: '6379' },
  { text: 'ESCUELA PARTICULAR SUBVENCIONADA PADRE ISIDORO', value: '6380' },
  { text: 'ESCUELA PARTICULAR PURALACO', value: '6381' },
  { text: 'ESCUELA PARTICULAR RAQUINCURA', value: '6382' },
  { text: 'ESCUELA PARTICULAR CHANQUIN', value: '6385' },
  { text: 'ESCUELA POCOYAN', value: '6389' },
  { text: 'ESCUELA PARTICULAR ARAUCANA PELEHUE', value: '6390' },
  { text: 'ESCUELA PARTICULAR VILLA BOLDOS', value: '6391' },
  { text: 'ESCUELA PARTICULAR PIREN', value: '6392' },
  { text: 'ESCUELA PARTICULAR FRUTILLAR', value: '6393' },
  { text: 'LICEO MUNICIPAL BARROS ARANA', value: '6397' },
  { text: 'ESCUELA NUEVA ALBORADA', value: '6398' },
  { text: 'ESCUELA HORIZONTES', value: '6399' },
  { text: 'ESCUELA ISLA LLICAN', value: '6400' },
  { text: 'ESCUELA MOLONHUE', value: '6404' },
  { text: 'ESCUELA NOHUALHUE', value: '6407' },
  { text: 'ESCUELA MALALHUE', value: '6410' },
  { text: 'ESCUELA PUYEHUE', value: '6411' },
  { text: 'ESCUELA DE RUCA-CURA', value: '6413' },
  { text: 'ESCUELA LOS TRONCOS', value: '6415' },
  { text: 'COMPLEJO EDUCACIONAL CRISTO REY', value: '6418' },
  { text: 'ESCUELA PARTICULAR PADRE ALEJANDRO ORTEGA', value: '6420' },
  { text: 'ESCUELA PARTICULAR BAUTISTA', value: '6421' },
  { text: 'ESCUELA PARTICULAR HUALPIN', value: '6423' },
  { text: 'ESCUELA PARTICULAR ARTURO ALESSANDRI', value: '6424' },
  { text: 'ESCUELA PARTICULAR QUILIMANZANO', value: '6425' },
  { text: 'ESCUELA PARTICULAR QUILMER', value: '6427' },
  { text: 'ESCUELA PARTICULAR REBECA MATTE BELLO', value: '6429' },
  { text: 'ESCUELA PARTICULAR ALTO CHELLE', value: '6432' },
  { text: 'ESCUELA PARTICULAR HUILO', value: '6433' },
  { text: 'ESCUELA PARTICULAR PORMA', value: '6434' },
  { text: 'ESCUELA PARTICULAR HUIDIMA', value: '6435' },
  { text: 'ESCUELA RUCA COMCHE DE PELECOE', value: '6441' },
  { text: 'ESCUELA PARTICULAR LAS DELICIAS', value: '6442' },
  { text: 'ESCUELA PART. KOM PU LOF NI KIMELTUWE', value: '6443' },
  { text: 'ESCUELA PARTICULAR BELLAVISTA', value: '6444' },
  { text: 'ESCUELA PARTICULAR SANTA IRENE', value: '6445' },
  { text: 'ESCUELA PARTICULAR SAN MIGUEL DE TRAUHUE', value: '6446' },
  { text: 'ESCUELA PARTICULAR GENERAL BONILLA', value: '6448' },
  { text: 'ESCUELA PARTICULAR BERNARDO OHIGGINS', value: '6449' },
  { text: 'LICEO REINO DE SUECIA', value: '6452' },
  { text: 'ESCUELA BASICA COLLICO RANCO', value: '6454' },
  { text: 'ESCUELA BASICA BARTOLO LLANCALEO', value: '6455' },
  { text: 'ESCCUELA BASICA INALAFQUEN', value: '6456' },
  { text: 'ESC. BASICA AUGUSTO WINTER TAPIA', value: '6457' },
  { text: 'ESCUELA BASICA CALOF', value: '6458' },
  { text: 'ESC. BASICA ANTONIO LADINO', value: '6459' },
  { text: 'ESCUELA PARTICULAR SAN SEBASTIAN', value: '6460' },
  { text: 'ESCUELA PARTICULAR PADRE JUAN WEVERING', value: '6461' },
  { text: 'ESCUELA PARTICULAR RONGUIPULLI', value: '6462' },
  { text: 'ESCUELA PARTICULAR EL ALMA', value: '6463' },
  { text: 'ESCUELA PARTICULAR HUAPI', value: '6464' },
  { text: 'LICEO PART. SUBVENC. LA SIERRA', value: '6465' },
  { text: 'ESCUELA PARTICULAR SAN FCO. DE QUIFO', value: '6468' },
  { text: 'ESCUELA PARTICULAR SOL NACIENTE', value: '6471' },
  { text: 'ESCUELA PARTICULAR INES DE SUAREZ', value: '6473' },
  { text: 'ESCUELA PARTICULAR QUIFO', value: '6474' },
  { text: 'ESCUELA PARTICULAR LLAGUEY', value: '6475' },
  { text: 'ESCUELA PARTICULAR EL TEMO', value: '6476' },
  { text: 'ESCUELA PARTICULAR PERQUINAN', value: '6477' },
  { text: 'ESCUELA PARTICULAR PIEDRA ALTA', value: '6478' },
  { text: 'ESCUELA PARTICULAR DEUME', value: '6479' },
  { text: 'ESCUELA PARTICULAR NUEVA RUCATRARO', value: '6480' },
  { text: 'ESCUELA PARTICULAR CHEUCAN', value: '6481' },
  { text: 'ESCUELA PARTICULAR NUEVO QUIFO', value: '6482' },
  { text: 'ESCUELA PARTICULAR GUACOLDA', value: '6483' },
  { text: 'ESCUELA PADRE ERNESTO WILHELM', value: '6485' },
  { text: 'ESCUELA PARTICULAR SAN GASTON', value: '6486' },
  { text: 'ESCUELA PARTICULAR LOS CISNES', value: '6487' },
  { text: 'ESCUELA PARTICULAR DIEGO PORTALES', value: '6488' },
  { text: 'ESCUELA PARTICULAR SANTA CRUZ', value: '6489' },
  { text: 'ESCUELA PARTICULAR MANUEL ROJAS', value: '6490' },
  { text: 'ESCUELA PARTICULAR AUGUSTO WINTER', value: '6491' },
  { text: 'ESCUELA PARTICULAR DAGOBERTO GODOY', value: '6492' },
  { text: 'ESCUELA PARTICULAR DIEGO DE ALMAGRO', value: '6494' },
  { text: 'ESCUELA RUCA RAQUI', value: '6495' },
  { text: 'ESCUELA GABRIELA MISTRAL', value: '6496' },
  { text: 'COMPLEJO EDUCACIONAL CLAUDIO ARRAU LEON', value: '6497' },
  { text: 'ROMILIO ADRIAZOLA', value: '6499' },
  { text: 'ESCUELA DARIO SALAS DIAZ', value: '6500' },
  { text: 'ESCUELA BASICA KIM RUKA', value: '6501' },
  { text: 'ESCUELA BASICA NEHUENTUE', value: '6502' },
  { text: 'ESCUELA TRANAPUENTE', value: '6504' },
  { text: 'ESCUELA BASICA EL CIRCO', value: '6505' },
  { text: 'ESCUELA MUNICIPAL DINAMARCA', value: '6506' },
  { text: 'ESCUELA BASICA DINAMARCA  LUCERO', value: '6508' },
  { text: 'ESCUELA BASICA SANTA CELIA', value: '6509' },
  { text: 'ESCUELA BASICA PAILACOYAN', value: '6510' },
  { text: 'ESCUELA VILLA LAS ARAUCARIAS', value: '6512' },
  { text: 'ESCUELA QUIRIPIO', value: '6514' },
  { text: 'ESCUELA CATRIPULLI', value: '6515' },
  { text: 'ESCUELA BASICA EL MANZANO', value: '6518' },
  { text: 'ESCUELA BASICA QUILLEN', value: '6519' },
  { text: 'ESCUELA BASICA CAMARONES', value: '6521' },
  { text: 'ESCUELA BASICA PUYANGUE', value: '6522' },
  { text: 'ESCUELA BASICA CHOMIO', value: '6523' },
  { text: 'ESCUELA CULLINCO', value: '6524' },
  { text: 'ESC. BASICA CARLOS PALMA LAFUENTE', value: '6525' },
  { text: 'ESCUELA BASICA EL PERAL', value: '6526' },
  { text: 'ESCUELA BASICA ALTO YUPEHUE', value: '6527' },
  { text: 'ESCUELA BASICA BAJO YUPEHUE', value: '6528' },
  { text: 'ESCUELA BASICA MATTE Y SANCHEZ', value: '6529' },
  { text: 'ESC. BASICA PROF.GUILLERMO SALGADO CARRILLO', value: '6530' },
  { text: 'ESCUELA BASICA LOS LAURELES', value: '6535' },
  { text: 'ESCUELA AMULEY', value: '6536' },
  { text: 'ESCUELA BASICA COI COI', value: '6539' },
  { text: 'ESCUELA BASICA COLICO', value: '6540' },
  { text: 'ESCUELA PARTICULAR ADVENTISTA', value: '6542' },
  { text: 'ESCUELA PARTICULAR EL COIGUE', value: '6544' },
  { text: 'ESCUELA PARTICULAR CHANGO', value: '6545' },
  { text: 'ESCUELA PARTICULAR BAJO PELLAHUEN', value: '6546' },
  { text: 'ESCUELA PARTICULAR CENTRO LONCOYAMO', value: '6547' },
  { text: 'ESCUELA PARTICULAR COLONIA LAS NOCHAS', value: '6549' },
  { text: 'ESCUELA PARTICULAR VISTA HERMOSA', value: '6550' },
  { text: 'ESCUELA CODIHUE', value: '6552' },
  { text: 'ESCUELA PARTICULAR ALTO TIRUA', value: '6553' },
  { text: 'ESCUELA PARTICULAR PILMAIQUENCO', value: '6555' },
  { text: 'ESCUELA PARTICULAR LLIHUIN', value: '6556' },
  { text: 'ESCUELA PARTICULAR MIRAFLOR DE PANCUL', value: '6558' },
  { text: 'ESCUELA PARTICULAR EL AMANECER', value: '6560' },
  { text: 'ESCUELA PARTICULAR SANTA INGRID', value: '6561' },
  { text: 'ESCUELA PARTICULAR LA ALBORADA', value: '6562' },
  { text: 'ESCUELA PARTIC.JOSE MIGUEL CARRERA', value: '6564' },
  { text: 'ESCUELA PARTICULAR JAVIERA CARRERA', value: '6566' },
  { text: 'ESCUELA PARTICULAR JOSE ABELARDO NUNEZ', value: '6567' },
  { text: 'ESCUELA PARTICULAR LUIS CRUZ MARTINEZ', value: '6569' },
  { text: 'ESCUELA PARTICULAR PEDRO DE VALDIVIA', value: '6570' },
  { text: 'ESCUELA PARTICULAR RAMON FREIRE', value: '6572' },
  { text: 'ESCUELA PARTICULAR ALONSO DE ERCILLA', value: '6575' },
  { text: 'ESCUELA PARTICULAR CLAUDIO MATTE', value: '6576' },
  { text: 'ESCUELA PARTICULAR CATRIPULLI', value: '6577' },
  { text: 'ESCUELA PARTICULAR LA MONTANA', value: '6578' },
  { text: 'ESCUELA PARTICULAR CAMILO HENRIQUEZ', value: '6580' },
  { text: 'ESCUELA PARTICULAR RUCATRARO', value: '6583' },
  { text: 'LICEO INDUSTRIAL C-16 NUEVA IMPERIAL', value: '6584' },
  { text: 'LICEO LUIS GONZALEZ VASQUEZ', value: '6585' },
  { text: 'LICEO JAMES MUNDELL', value: '6586' },
  { text: 'ESCUELA ALEJANDRO GOROSTIAGA', value: '6587' },
  { text: 'ESCUELA REPUBLICA', value: '6588' },
  { text: 'ESCUELA JUAN XXIII', value: '6589' },
  { text: 'ESC. ESP.RET.MENTAL AVANCEMOS JUNTOS', value: '6590' },
  { text: 'FEDERICO GARC-A LORCA', value: '6591' },
  { text: 'ESCUELA BASICA EL CRUCERO', value: '6593' },
  { text: 'ESCUELA BASICA LOS AVELLANOS', value: '6594' },
  { text: 'ESCUELA BASICA RAYEN RUNGI', value: '6595' },
  { text: 'ESCUELA BASIC RAYEN MAPU', value: '6597' },
  { text: 'ESCUELA BASICA COIHUE CURACO', value: '6599' },
  { text: 'ESCUELA EL COPIHUAL', value: '6600' },
  { text: 'ESCUELA BASICA CATRIANCHE', value: '6602' },
  { text: 'ESCUELA BASICA RAPAHUE', value: '6603' },
  { text: 'ESCUELA LOS CARRERA', value: '6604' },
  { text: 'ESC.BASICA RAYEN MAHUIDA', value: '6605' },
  { text: 'ESC. BASICA JUNTA HUAMAQUI', value: '6606' },
  { text: 'ESC. BASICA LA ARAUCARIA', value: '6608' },
  { text: 'ESC. BASICA SANTOS COLLIPAL', value: '6610' },
  { text: 'ESC. BASICA CHIVILCOYAN', value: '6611' },
  { text: 'ESC. BASICA PICHIRAYEN', value: '6612' },
  { text: 'ESC. BASICA CINCO MANZANOS', value: '6614' },
  { text: 'ESC. BASICA SANTA CAROLINA', value: '6616' },
  { text: 'ESC. BASICA SAN MANUEL', value: '6618' },
  { text: 'ESC. BASICA MALALCHE BAJO', value: '6621' },
  { text: 'ESC. BASICA  CAMPANARIO', value: '6622' },
  { text: 'ESCUELA ARENAS BLANCAS', value: '6623' },
  { text: 'ESC. BASICA EL PROGRESO', value: '6624' },
  { text: 'ESC. BASICA LOS CANELOS', value: '6625' },
  { text: 'ESC. BASICA RUCAPANGUE', value: '6626' },
  { text: 'ESC. BASICA ALTAMIRA', value: '6627' },
  { text: 'ESC. BASICA LIFKO', value: '6628' },
  { text: 'ESC. BASICA NUEVA AURORA', value: '6630' },
  { text: 'ESC. BASICA SANTA MARIA DE BOROA', value: '6633' },
  { text: 'ESC. BASICA LOS ROBLES', value: '6635' },
  { text: 'ESCUELA BASICA MANIO DUCANAN', value: '6639' },
  { text: 'LICEO  AGRICOLA  CHOL CHOL', value: '6641' },
  { text: 'LICEO COMERCIAL DIEGO PORTALES', value: '6642' },
  {
    text: 'LICEO INTERCULTURAL T\u00c3\u2030CNICO PROFESIONAL GUACOLDA',
    value: '6643',
  },
  { text: 'ESCUELA PARTICULAR BELEN', value: '6647' },
  { text: 'LICEO SAN FRANCISCO DE ASIS DE CHOL CHOL', value: '6649' },
  { text: 'COLEGIO ANGLICANO WILLIAM WILSON', value: '6650' },
  { text: 'ESCUELA PARTICULAR GALVARINO', value: '6651' },
  { text: 'ESCUELA PARTICULAR BOROA', value: '6652' },
  { text: 'ESCUELA PARTICULAR COILACO', value: '6653' },
  { text: 'ESCUELA PARTICULAR ENTRE RIOS', value: '6654' },
  { text: 'ESCUELA PARTICULAR LORD COCHRANE', value: '6655' },
  { text: 'ESCUELA PARTICULAR LOS GUINDOS', value: '6656' },
  { text: 'ESCUELA CARRERINE', value: '6657' },
  { text: 'ESCUELA PARTICULAR LOS CONDORES', value: '6658' },
  { text: 'ESCUELA PARTICULAR SANTA ISABEL', value: '6660' },
  { text: 'ESCUELA PARTICULAR LOS COPIHUES', value: '6661' },
  { text: 'ESCUELA PARTICULAR LOMA LARGA', value: '6662' },
  { text: 'ESCUELA PARTICULAR CUDICO', value: '6665' },
  { text: 'ESCUELA PARTICULAR ALMAGRO', value: '6666' },
  { text: 'ESCUELA PARTICULAR RULO', value: '6667' },
  { text: 'ESCUELA PARTICULAR COPINCHE', value: '6668' },
  { text: 'ESCUELA PARTICULAR DOLLIMCO', value: '6669' },
  { text: 'ESCUELA PARTICULAR HUEICO', value: '6670' },
  { text: 'ESCUELA PARTICULAR RENACO', value: '6671' },
  { text: 'ESCUELA PARTICULAR LA AURORA', value: '6672' },
  { text: 'ESCUELA PARTICULAR  PUEL  MAPU', value: '6673' },
  { text: 'ESCUELA PARTICULAR ALTO MANIO', value: '6674' },
  { text: 'ESCUELA PARTICULAR LLANCAHUE', value: '6676' },
  { text: 'ESCUELA PARTICULAR SANTA MARIA', value: '6678' },
  { text: 'ESCUELA PARTICULAR PIUHUICHEN', value: '6679' },
  { text: 'ESCUELA PARTICULAR COIPUCO', value: '6681' },
  { text: 'ESCUELA PARTICULAR WILFREDO PASSAU', value: '6683' },
  { text: 'ESCUELA PARTICULAR SAN ANTONIO', value: '6684' },
  { text: 'ESCUELA PARTICULAR LIDIA RIQUELME', value: '6686' },
  { text: 'ESCUELA PARTICULAR PITRACO TOSCA', value: '6687' },
  { text: 'ESCUELA PARTICULAR TRANAMIL RULO', value: '6688' },
  { text: 'ESCUELA PARTICULAR BANDERA', value: '6689' },
  { text: 'ESCUELA PARTICULAR PEDRO AGUIRRE CERDA', value: '6690' },
  { text: 'ESCUELA PARTICULAR GABRIELA MISTRAL', value: '6691' },
  { text: 'ESCUELA PARTICULAR ARTURO PRAT', value: '6692' },
  { text: 'ESCUELA PARTICULAR ISABEL RIQUELME', value: '6693' },
  { text: 'ESCUELA PARTICULAR FAIZI', value: '6695' },
  { text: 'ESCUELA PARTICULAR L.BERNARDO OHIGGINS', value: '6696' },
  { text: 'ESCUELA PARTICULAR BUENOS AIRES', value: '6698' },
  { text: 'ESCUELA PARTICULAR AMBROSIO OHIGGINS', value: '6699' },
  { text: 'ESCUELA PARTICULAR TRAYENCO', value: '6700' },
  { text: 'ESCUELA PARTICULAR ANIBAL PINTO', value: '6701' },
  { text: 'ESCUELA PARTICULAR INES DE SUAREZ', value: '6702' },
  { text: 'ESCUELA PARTICULAR LAS GAVIOTAS', value: '6703' },
  { text: 'ESCUELA PARTICULAR PROF.NIMIA RIVAS', value: '6705' },
  { text: 'ESCUELA PARTICULAR YAUYAUQUEN', value: '6707' },
  { text: 'LICEO GREGORIO URRUTIA', value: '6708' },
  { text: 'ESCUELA MUNICIPAL RIO QUILLEN', value: '6709' },
  { text: 'ESCUELA BASICA DE LA PIEDRA', value: '6710' },
  { text: 'ESCUELA BASICA MANIUCO', value: '6711' },
  { text: 'ESCUELA SAN JUAN DE AILLINCO', value: '6712' },
  { text: 'ESCUELA MUNICIPAL DE LLUQUENTUE', value: '6714' },
  { text: 'ESCUELA BASICA TRABUNQUILLEM', value: '6715' },
  { text: 'ESC. BASICA QUETRE', value: '6716' },
  { text: 'ESCUELA BASICA DE EL CAPRICHO', value: '6718' },
  { text: 'ESCUELA BASICA CHACAICO', value: '6719' },
  { text: 'ESCUELA REDUCCION PANGUECO', value: '6721' },
  { text: 'ESCUELA BASICA QUINAHUE', value: '6722' },
  { text: 'ESCUELA DE HUAMPOMALLIN', value: '6725' },
  { text: 'ESCUELA BASICA SANTA MARGARITA', value: '6726' },
  { text: 'ESCUELA BASICA TRIF TRIFCO', value: '6728' },
  { text: 'ESCUELA  BASICA PELANTARO', value: '6731' },
  { text: 'ESC. BASICA FORTIN NIELOL', value: '6732' },
  { text: 'ESCUELA PARTICULAR SAN SEBASTIAN', value: '6734' },
  { text: 'ESCUELA PARTICULAR ADVENTISTA', value: '6735' },
  { text: 'ESCUELA PARTICULAR RAPA', value: '6736' },
  { text: 'ESCUELA PARTICULAR PAILLAHUE', value: '6737' },
  { text: 'ESCUELA PARTICULAR REPOCURA', value: '6738' },
  { text: 'ESCUELA MUNICIPAL  NILPE', value: '6739' },
  { text: 'ESCUELA PARTICULAR EL PROGRESO', value: '6741' },
  { text: 'ESCUELA PARTICULAR RENICURA', value: '6743' },
  { text: 'ESCUELA PARTICULAR BELLAVISTA', value: '6745' },
  { text: 'ESCUELA PARTICULAR SAN CARLOS', value: '6746' },
  { text: 'ESCUELA PARTICULAR EL PERAL', value: '6747' },
  { text: 'ESCUELA PARTICULAR EL JARDIN', value: '6748' },
  { text: 'ESCUELA LLOLLETUE', value: '6750' },
  { text: 'LICEO TECNICO VALDIVIA', value: '6752' },
  { text: 'LICEO INDUSTRIAL VALDIVIA', value: '6755' },
  { text: 'LICEO POLIVALENTE LOS AVELLANOS', value: '6756' },
  { text: 'ESCUELA CHILE', value: '6759' },
  { text: 'ESCUELA MEXICO', value: '6762' },
  { text: 'ESCUELA ESPANA', value: '6764' },
  { text: 'COLEGIO DEPORTIVO MUNICIPAL DE VALDIVIA', value: '6765' },
  { text: 'COLEGIO TENIENTE HERNAN MERINO CORREA', value: '6766' },
  { text: 'ESCUELA LEONARDO DA VINCI', value: '6767' },
  { text: 'ESCUELA DIFERENCIAL ANN SULLIVAN', value: '6768' },
  { text: 'COLEGIO DE MUSICA JUAN SEBASTIAN BACH', value: '6770' },
  { text: 'COLEGIO HOLANDA', value: '6771' },
  { text: 'C.E.I.A. NARCISO GARCIA', value: '6772' },
  { text: 'ESCUELA LAS ANIMAS', value: '6773' },
  { text: 'ESCUELA EL LAUREL', value: '6774' },
  { text: 'ESCUELA FEDOR M.DOSTOIEVSKI', value: '6777' },
  { text: 'ESCUELA ADULTOS VALDIVIA', value: '6779' },
  { text: 'ESCUELA FERNANDO SANTIVAN', value: '6780' },
  { text: 'ESCUELA ALEMANIA', value: '6781' },
  { text: 'ESCUELA ANGACHILLA', value: '6785' },
  { text: 'ESCUELA ESPECIAL WALTER SCHMIDT ROESTEL', value: '6786' },
  { text: 'ESCUELA DE NIEBLA JUAN BOSCH', value: '6791' },
  { text: 'ESCUELA CANDIDO MARTINEZ GALLARDO', value: '6793' },
  { text: 'ESCUELA RURAL CURINANCO', value: '6797' },
  { text: 'ESCUELA RURAL PUNUCAPA', value: '6798' },
  { text: 'ESCUELA RURAL CASA BLANCA', value: '6803' },
  { text: 'ESCUELA RURAL LOS GUINDOS', value: '6804' },
  { text: 'ESCUELA RURAL SANTO DOMINGO', value: '6805' },
  { text: 'ESCUELA RURAL PISHUINCO', value: '6807' },
  { text: 'ESCUELA RURAL MISION DE ARIQUE', value: '6814' },
  { text: 'ESCUELA RURAL LOS MOLINOS', value: '6815' },
  { text: 'ESCUELA RURAL CAYUMAPU', value: '6816' },
  { text: 'ESCUELA RURAL ANDRES FRIED KOPP', value: '6817' },
  { text: 'ESCUELA RURAL LOS PELLINES', value: '6818' },
  { text: 'ESCUELA DE PARVULOS N.265 CAPULLITO', value: '6820' },
  { text: 'ESCUELA PARTICULAR SANTA MARTA', value: '6826' },
  { text: 'COLEGIO AUSTRAL', value: '6828' },
  { text: 'COLEGIO NUESTRA SENORA DEL CARMEN', value: '6830' },
  { text: 'ESCUELA PARTICULAR HOGAR DEL NINO', value: '6833' },
  { text: 'ESCUELA PARTICULAR METODISTA', value: '6834' },
  { text: 'COLEGIO ADVENTISTA DE VALDIVIA', value: '6835' },
  { text: 'COLEGIO VALLE DE LOS RIOS', value: '6841' },
  { text: 'LICEO SAN LUIS DE ALBA', value: '6846' },
  { text: 'ESCUELA PARTICULAR EL BOSQUE', value: '6848' },
  { text: 'ESCUELA RURAL JOSE ARNOLDO BILBAO', value: '6852' },
  { text: 'LICEO POLITECNICO PESQUERO', value: '6853' },
  { text: 'ESCUELA RURAL MAIQUILLAHUE', value: '6855' },
  { text: 'ESCUELA RURAL MISSISSIPPI', value: '6857' },
  { text: 'ESCUELA RURAL SAN SEBASTIAN', value: '6862' },
  { text: 'ESCUELA RURAL HUIFCO', value: '6865' },
  { text: 'ESCUELA RURAL ALFONSO OSSES PEREZ', value: '6866' },
  { text: 'ESC.RURAL JORGE ROBERTO FONTANNAZ BLUAS', value: '6867' },
  { text: 'ESCUELA RURAL INIPULLI', value: '6868' },
  { text: 'ESCUELA RURAL MEHUIN BAJO', value: '6872' },
  { text: 'ESCUELA FRAY BERNABE DE LUCERNA', value: '6876' },
  { text: 'ESCUELA RURAL OSVALDO FERNANDEZ V.', value: '6877' },
  { text: 'ESCUELA RURAL PAILLACO', value: '6878' },
  { text: 'ESCUELA RURAL YECO', value: '6879' },
  { text: 'ESCUELA RURAL LINGUENTO', value: '6882' },
  { text: 'ESCUELA RURAL FLORA MARTIN IMIGO', value: '6884' },
  { text: 'ESCUELA RURAL ELISEO JARAMILLO', value: '6885' },
  { text: 'ESCUELA VALLE DE MARIQUINA', value: '6886' },
  { text: 'ESCUELA RURAL CALQUINCO ALTO', value: '6888' },
  { text: 'ESCUELA RURAL CHACAYAL LINGUE', value: '6889' },
  { text: 'ESC.RURAL JUAN POBLETE SAINT-SIMON', value: '6891' },
  { text: 'ESCUELA RURAL PEDRO W. URIBE OPLINGER', value: '6892' },
  { text: 'ESCUELA RURAL TRALCAO', value: '6893' },
  { text: 'ESCUELA PARTICULAR SANTA CRUZ', value: '6895' },
  { text: 'LICEO POLIVALENTE CAMILO HENRIQUEZ G.', value: '6897' },
  { text: 'ESCUELA FELIPE BARTHOU CORBEAUX', value: '6898' },
  { text: 'LICEO   REPUBLICA DEL BRASIL', value: '6899' },
  { text: 'ESCUELA RURAL PANGUINILAHUE', value: '6900' },
  { text: 'ESCUELA RURAL REDUCCION ANTILHUE', value: '6901' },
  { text: 'ESCUELA RURAL RUCAKLEN', value: '6902' },
  { text: 'ESCUELA RURAL PUQUINE BAJO', value: '6903' },
  { text: 'ESCUELA RURAL AYLIN', value: '6905' },
  { text: 'ESCUELA RURAL EL TALLO', value: '6907' },
  { text: 'ESCUELA RURAL MINAS DE HUEIMA', value: '6912' },
  { text: 'ESCUELA RURAL CHOSDOY ALTO', value: '6915' },
  { text: 'ESCUELA ALBERTO CORDOVA LATORRE', value: '6916' },
  { text: 'ESCUELA PARTICULAR PADRE CARLOS', value: '6917' },
  { text: 'ESCUELA PARTICULAR SAN FRANCISCO', value: '6918' },
  { text: 'ESCUELA PARTICULAR SAN SEBASTIAN', value: '6919' },
  { text: 'ESCUELA PARTICULAR GUIDO BECK', value: '6920' },
  { text: 'LICEO AGRICOLA FEMENINA MARIA REINA', value: '6921' },
  { text: 'LICEO PADRE ALCUINO', value: '6922' },
  { text: 'ESCUELA PARTICULAR LOS SAUCES', value: '6924' },
  { text: 'ESCUELA PARTICULAR SANTA ELISA', value: '6925' },
  { text: 'LICEO ALBERTO BLEST GANA', value: '6929' },
  { text: 'ESCUELA FRANCIA', value: '6930' },
  { text: 'ESCUELA NEVADA', value: '6932' },
  { text: 'ESCUELA RURAL FOLILCO', value: '6933' },
  { text: 'ESCUELA NUEVA ESPANA', value: '6934' },
  { text: 'ESCUELA RURAL ANTILHUE', value: '6935' },
  { text: 'ESCUELA RURAL CHANCO', value: '6938' },
  { text: 'ESCUELA RURAL EL VERGEL', value: '6941' },
  { text: 'ESCUELA RURAL EL TREBOL', value: '6942' },
  { text: 'ESCUELA RURAL USTARITZ', value: '6944' },
  { text: 'ESCUELA RURAL LOS BAJOS', value: '6945' },
  { text: 'ESCUELA RURAL COMUNIDAD STA CARLA', value: '6946' },
  { text: 'ESCUELA RURAL LAS HUELLAS', value: '6950' },
  { text: 'ESCUELA RURAL LA VICTORIA', value: '6951' },
  { text: 'ESCUELA RURAL EL SALTO', value: '6953' },
  { text: 'ESCUELA RURAL ENRIQUE HEVIA LABBE', value: '6955' },
  { text: 'ESCUELA RURAL ALICIA MERA OVALLE', value: '6956' },
  { text: 'ESCUELA RURAL TRAFUN', value: '6957' },
  { text: 'ESCUELA CENTROS UNIDOS SAN JUAN', value: '6963' },
  { text: 'ESCUELA PARTICULAR LOS MAITENES', value: '6964' },
  { text: 'ESCUELA PARTICULAR HUAIQUIMILLA', value: '6965' },
  { text: 'ESCUELA PARTICULAR  EL FAROL', value: '6969' },
  { text: 'ESCUELA PARTICULAR  PANCUL', value: '6970' },
  { text: 'ESCUELA COLEGUAL  NUM.32', value: '6972' },
  { text: 'ESCUELA PARTICULAR SANTA JIMENA', value: '6973' },
  { text: 'ESCUELA PARTICULAR COVADONGA', value: '6975' },
  { text: 'ESCUELA PARTICULAR SANTA ANA', value: '6978' },
  { text: 'ESCUELA PARTICULAR FLOR DEL LAGO', value: '6980' },
  { text: 'ESCUELA PARTICULAR SAN PEDRO', value: '6981' },
  { text: 'ESCUELA PARTICULAR MI TIERRA', value: '6982' },
  { text: 'ESCUELA BASICA JOSE M. BALMACEDA F.', value: '6983' },
  { text: 'ESCUELA RURAL NONTUELA', value: '6984' },
  { text: 'ESCUELA FRONTERIZA DE LLIFEN', value: '6986' },
  { text: 'ESCUELA RURAL LONCOPAN', value: '6987' },
  { text: 'ESCUELA RURAL LONCOPAN BAJO', value: '6988' },
  { text: 'ESCUELA RURAL LOS CERRILLOS', value: '6989' },
  { text: 'ESCUELA RURAL EL LLOLLY', value: '6990' },
  { text: 'ESCUELA RURAL ISLA HUAPI', value: '6991' },
  { text: 'ESCUELA RURAL VISTA HERMOSA', value: '6992' },
  { text: 'ESCUELA RURAL PUMOL', value: '6996' },
  { text: 'ESCUELA RURAL HUEINAHUE', value: '7000' },
  { text: 'ESCUELA RURAL CURRINE', value: '7003' },
  { text: 'ESCUELA PARTICULAR MARIA DEOGRACIA', value: '7004' },
  { text: 'LICEO SAN CONRADO DE FUTRONO', value: '7006' },
  { text: 'ESCUELA PARTICULAR FLORIN', value: '7008' },
  { text: 'ESCUELA PARTICULAR CHOLLINCO', value: '7009' },
  { text: 'ESCUELA PARTICULAR CHIHUIO', value: '7011' },
  { text: 'ESCUELA PARTICULAR RADICACION MAIHUE', value: '7012' },
  { text: 'ESCUELA PARTICULAR NONTUELA ALTO', value: '7013' },
  { text: 'LICEO CARLOS HAVERBECK RICHTER', value: '7015' },
  { text: 'ESCUELA BASICA DE CORRAL', value: '7016' },
  { text: 'ESCUELA RURAL TRES CHIFLONES ALTO', value: '7018' },
  { text: 'ESCUELA RURAL CARBONEROS', value: '7020' },
  { text: 'ESCUELA RURAL LA AGUADA', value: '7023' },
  { text: 'ESCUELA RURAL SAN CARLOS', value: '7024' },
  { text: 'ESCUELA RURAL EL HUAPE', value: '7025' },
  { text: 'ESCUELA RURAL CHAIHUIN', value: '7026' },
  { text: 'ESCUELA RURAL LAS COLORADAS', value: '7030' },
  { text: 'LICEO GABRIELA MISTRAL', value: '7031' },
  { text: 'ESCUELA ALABAMA', value: '7032' },
  { text: 'ESCUELA RURAL PUTREGUEL', value: '7034' },
  { text: 'ESCUELA RURAL SANTA HIGIDIA', value: '7037' },
  { text: 'ESCUELA RURAL HUILLICOIHUE', value: '7038' },
  { text: 'ESCUELA RURAL ENRIQUE TALADRIZ', value: '7039' },
  { text: 'ESCUELA RURAL RUNCA', value: '7040' },
  { text: 'LICEO SANTO CURA DE ARS', value: '7044' },
  { text: 'ESCUELA PARTICULAR LAS ALTURAS', value: '7045' },
  { text: 'ESCUELA PARTICULAR SAN JOSE DE FOLILCO', value: '7047' },
  { text: 'LICEO FERNANDO SANTIVAN', value: '7049' },
  { text: 'ESCUELA MARIA ALVARADO GARAY', value: '7050' },
  { text: 'ESCUELA RURAL PANGUILELFUN', value: '7051' },
  { text: 'ESCUELA RURAL PITREN', value: '7057' },
  { text: 'ESCUELA RURAL HUITAG', value: '7058' },
  { text: 'ESCUELA ERNESTO PINTO', value: '7059' },
  { text: 'ESCUELA RURAL LA RINCONADA', value: '7061' },
  { text: 'ESCUELA RURAL PULLINQUE', value: '7062' },
  { text: 'ESCUELA RURAL HUELLAHUE', value: '7063' },
  { text: 'ESCUELA BASICA REPUBLICA DE CHILE', value: '7064' },
  { text: 'ESCUELA RURAL EL MANZANO', value: '7065' },
  { text: 'ESCUELA RURAL CORRELTUE', value: '7068' },
  { text: 'ESCUELA RURAL COZ COZ', value: '7069' },
  { text: 'ESCUELA RURAL LAGO AZUL', value: '7071' },
  { text: 'ESCUELA RURAL LLANCAHUE', value: '7072' },
  { text: 'ESCUELA RURAL CURIHUE', value: '7073' },
  { text: 'ESCUELA RURAL CACIQUE AILLAPAN', value: '7074' },
  { text: 'ESCUELA ESTADIO', value: '7076' },
  { text: 'ESCUELA ALIHUEN', value: '7077' },
  { text: 'ESCUELA RURAL CARRIRINE', value: '7078' },
  { text: 'ESCUELA RURAL MALCHEHUE', value: '7079' },
  { text: 'ESCUELA RURAL RANINTULELFU', value: '7081' },
  { text: 'ESCUELA RURAL BOCATOMA', value: '7083' },
  { text: 'ESCUELA RURAL TIERRA DE ESPERANZA', value: '7085' },
  { text: 'ESCUELA RURAL COIHUECO', value: '7086' },
  { text: 'ESCUELA RURAL CAYUMAPU', value: '7088' },
  { text: 'ESCUELA RURAL LAGO NELTUME', value: '7089' },
  { text: 'ESCUELA RURAL PUNAHUE', value: '7090' },
  { text: 'ESCUELA RURAL REHUEICO', value: '7092' },
  { text: 'ESCUELA RURAL TRAFUN', value: '7093' },
  { text: 'ESCUELA RURAL MILLEUCO', value: '7095' },
  { text: 'ESCUELA RURAL RAGUINTULALFU', value: '7097' },
  { text: 'ESCUELA RURAL LLONQUEN', value: '7100' },
  { text: 'ESCUELA RURAL CACHIN', value: '7101' },
  { text: 'LICEO PADRE SIGISFREDO', value: '7102' },
  { text: 'ESCUELA PART. PADRE ENRIQUE ROMER', value: '7108' },
  { text: 'ESCUELA PARTICULAR PELEHUE', value: '7109' },
  { text: 'ESCUELA PARTICULAR SANTA CLARA', value: '7110' },
  { text: 'ESCUELA PARTICULAR PUCURA', value: '7111' },
  { text: 'ESCUELA PARTICULAR PAMPA NANCUL', value: '7112' },
  { text: 'ESCUELA PARTICULAR LIQUINE', value: '7113' },
  { text: 'ESCUELA FRANCISCO DE ASIS', value: '7114' },
  { text: 'ESCUELA PARTICULAR NUEVA LIQUINE', value: '7115' },
  { text: 'ESCUELA PARTICULAR EL PORVENIR', value: '7116' },
  { text: 'ESCUELA PARTICULAR TRAITRAICO', value: '7118' },
  { text: 'COL. DE ARTES  CIENCIA Y TEC. DA VINCI', value: '7122' },
  { text: 'ESCUELA PARTICULAR TRELEHUENO', value: '7123' },
  { text: 'ESCUELA PARTICULAR PASCUAL ALLCAPANG', value: '7124' },
  { text: 'ESCUELA PARTICULAR PADRE BERGER', value: '7125' },
  { text: 'COLEGIO DE CULTURA Y DIFUSION ARTISTICA', value: '7128' },
  { text: 'ESCUELA  LA UNION', value: '7130' },
  { text: 'ESCUELA PRESIDENTE JORGE ALESSANDRI R.', value: '7131' },
  { text: 'ESC.DIFERENC.VILLA SAN JOSE DE LA UNION', value: '7132' },
  { text: 'ESCUELA RADIMADI', value: '7133' },
  { text: 'ESCUELA HONORIO OJEDA VALDERAS-LA UNION', value: '7135' },
  { text: 'ESCUELA RURAL CATAMUTUN', value: '7136' },
  { text: 'ESCUELA RURAL CHOROICO', value: '7137' },
  { text: 'ESCUELA RURAL PUERTO NUEVO', value: '7138' },
  { text: 'ESCUELA RURAL PURRIHUIN', value: '7139' },
  { text: 'ESCUELA RURAL LOS ESTEROS', value: '7140' },
  { text: 'ESCUELA RURAL FOLLECO', value: '7141' },
  { text: 'ESCUELA RURAL CUINCO', value: '7142' },
  { text: 'ESCUELA RURAL HUILLINCO', value: '7147' },
  { text: 'ESCUELA RURAL SANTA ELISA', value: '7149' },
  { text: 'ESCUELA RURAL ROFUCO', value: '7153' },
  { text: 'ESCUELA RURAL TRAIGUEN', value: '7157' },
  { text: 'ESCUELA RURAL CARIMANCA', value: '7158' },
  { text: 'ESCUELA RURAL SAN MIGUEL', value: '7159' },
  { text: 'ESCUELA RURAL FLOR M. MUNDACA H.', value: '7160' },
  { text: 'ESCUELA RURAL ALDEA CAMPESINA', value: '7166' },
  { text: 'ESCUELA RURAL NAPOLES', value: '7167' },
  { text: 'ESCUELA RURAL LLANCACURA', value: '7168' },
  { text: 'ESCUELA RURAL MASHUE', value: '7170' },
  { text: 'ESCUELA RURAL PILPILCAHUIN', value: '7172' },
  { text: 'ESCUELA RURAL EL HUAPE', value: '7173' },
  { text: 'ESCUELA RURAL LOS CHILCOS', value: '7174' },
  { text: 'ESCUELA RURAL LOS CONALES', value: '7176' },
  { text: 'ESCUELA RURAL HUACAHUE', value: '7178' },
  { text: 'COLEGIO SANTA MARTA', value: '7181' },
  { text: 'COLEGIO PADRE DAMIAN', value: '7183' },
  { text: 'ESCUELA PARTICULAR CAMPO LINDO', value: '7184' },
  { text: 'ESCUELA PARTICULAR LOS AVELLANOS', value: '7185' },
  { text: 'ESCUELA PARTICULAR MONTES AZULES', value: '7186' },
  { text: 'ESCUELA PARTICULAR SAN MIGUEL', value: '7187' },
  { text: 'ESCUELA PARTICULAR TRES VENTANAS', value: '7188' },
  { text: 'ESCUELA PARTICULAR CUMULEUFU', value: '7190' },
  { text: 'ESCUELA PARTICULAR PUMAIHUE', value: '7192' },
  { text: 'ESCUELA PARTICULAR LAGO VERDE', value: '7193' },
  { text: 'ESCUELA PARTICULAR ROBLENTAL', value: '7195' },
  { text: 'ESCUELA PARTICULAR COPIO', value: '7197' },
  { text: 'ESCUELA PARTICULAR CHAMPEL', value: '7198' },
  { text: 'ESCUELA PROYECTO DE FUTURO', value: '7202' },
  { text: 'ESCUELA OLEGARIO MORALES OLIVA', value: '7203' },
  { text: 'ESCUELA NUEVA AURORA', value: '7204' },
  { text: 'ESCUELA ROBERTO OJEDA TORRES', value: '7205' },
  { text: 'ESCUELA RURAL 21 DE MAYO', value: '7206' },
  { text: 'ESCUELA RURAL EL NARANJO', value: '7212' },
  { text: 'ESCUELA RURAL MANAO', value: '7214' },
  { text: 'ESCUELA RURAL ESTRELLA DE CHILE', value: '7217' },
  { text: 'ESCUELA RURAL LA LUMA', value: '7218' },
  { text: 'ESCUELA RURAL LA PENA', value: '7220' },
  { text: 'ESCUELA RURAL EDUVIGES SCHULZ DE MOHR', value: '7225' },
  { text: 'ESCUELA RURAL EL ESFUERZO', value: '7227' },
  { text: 'ESCUELA PARTICULAR ALEMANA', value: '7231' },
  { text: 'ESCUELA PARTICULAR SAN LUIS', value: '7234' },
  { text: 'LICEO VICENTE PEREZ ROSALES', value: '7236' },
  { text: 'ESCUELA BASICA RIO BUENO', value: '7237' },
  { text: 'ESCUELA BASICA PATRICIO LYNCH', value: '7238' },
  { text: 'ESCUELA BASICA SAN JOSE DE FILUCO', value: '7239' },
  { text: 'ESCUELA RURAL CRUCERO', value: '7240' },
  { text: 'ESCUELA RURAL VIVANCO', value: '7242' },
  { text: 'ESCUELA RURAL CARIMALLIN BAJO', value: '7243' },
  { text: 'ESCUELA RURAL COLONIA DIUMEN', value: '7244' },
  { text: 'ESCUELA RURAL EL ROBLEE', value: '7247' },
  { text: 'ESCUELA RURAL TIQUECO', value: '7249' },
  { text: 'ESCUELA RURAL VALLE MANTILHUE BAJO', value: '7250' },
  { text: 'ESCUELA RURAL LA VICTORIA', value: '7251' },
  { text: 'ESCUELA RURAL MANTILHUE ALTO', value: '7252' },
  { text: 'ESCUELA RURAL CURRALHUE GRANDE', value: '7253' },
  { text: 'ESCUELA RURAL LOS COPIHUES', value: '7254' },
  { text: 'ESCUELA RURAL FOLILCO', value: '7256' },
  { text: 'ESCUELA RURAL FUTAHUENTE', value: '7257' },
  { text: 'ESCUELA RURAL NOLGUEHUE', value: '7258' },
  { text: 'ESCUELA RURAL CHAMPULLI', value: '7260' },
  { text: 'ESCUELA RURAL CHIRRE', value: '7261' },
  { text: 'ESCUELA RURAL PISU-PISUE', value: '7262' },
  { text: 'ESCUELA RURAL TRAPI', value: '7266' },
  { text: 'ESCUELA RURAL CURRALHUE CHICO', value: '7268' },
  { text: 'ESCUELA RURAL TRAFUN', value: '7270' },
  { text: 'ESCUELA RURAL EL ARRAYAN', value: '7273' },
  { text: 'ESCUELA RURAL LA GRUTA', value: '7274' },
  { text: 'COLEGIO SANTA CRUZ', value: '7276' },
  { text: 'ESCUELA PART LA AGUADA', value: '7279' },
  { text: 'ESCUELA PARTICULAR NUEVA LUMACO', value: '7282' },
  { text: 'ESCUELA PARTICULAR RUCATAYO', value: '7283' },
  { text: 'ESCUELA PARTICULAR NUEVA PINDACO', value: '7284' },
  { text: 'ESCUELA PARTICULAR BOQUIAL', value: '7285' },
  { text: 'ESCUELA PARTICULAR LOS CASTANOS', value: '7286' },
  { text: 'ESCUELA PARTICULAR FRUTILLAR', value: '7287' },
  { text: 'ESCUELA PARTICULAR PLAYA GRANDE', value: '7288' },
  { text: 'ESCUELA PARTICULAR TRAPI', value: '7289' },
  { text: 'ESCUELA PARTICULAR TREHUACO', value: '7290' },
  { text: 'ESCUELA PARTICULAR MANTILHUE BOQUEAL', value: '7291' },
  { text: 'ESCUELA PARTICULAR NUEVA ESPERANZA', value: '7292' },
  { text: 'ESCUELA PARTICULAR PORVENIR', value: '7295' },
  { text: 'ESCUELA PARTICULAR LOS AZADORES', value: '7296' },
  { text: 'ESCUELA RURAL SANTA ISABEL', value: '7297' },
  { text: 'ESCUELA PARTICULAR EL RADAL', value: '7298' },
  { text: 'ESCUELA RURAL IGNAO', value: '7300' },
  { text: 'ESCUELA RURAL ILIHUE', value: '7301' },
  { text: 'ESCUELA RURAL PITRENO', value: '7302' },
  { text: 'ESCUELA RURAL RININAHUE', value: '7303' },
  { text: 'ESCUELA RURAL CALCURRUPE', value: '7304' },
  { text: 'ESCUELA RURAL ILLAHUAPI', value: '7305' },
  { text: 'ESCUELA RURAL QUILLIN', value: '7306' },
  { text: 'ESCUELA RURAL LA ENSENADA', value: '7307' },
  { text: 'ESCUELA RURAL LA JUNTA', value: '7308' },
  { text: 'ESCUELA RURAL PITRIUCO', value: '7309' },
  { text: 'ESCUELA PARTICULAR AUQUINCO', value: '7311' },
  { text: 'ESCUELA PARTICULAR CARRAN', value: '7312' },
  { text: 'ESCUELA PARTICULAR LOS GUINDOS', value: '7314' },
  { text: 'ESCUELA PARTICULAR RUPUMEICA', value: '7315' },
  { text: 'ESCUELA PARTICULAR POCURA', value: '7316' },
  { text: 'ESCUELA RURAL MAIHUE', value: '7317' },
  { text: 'ESCUELA PARTICULAR HUEIMEN', value: '7318' },
  { text: 'ESCUELA PARTICULAR ILIHUE', value: '7319' },
  { text: 'ESCUELA PARTICULAR CAICAIEN', value: '7321' },
  { text: 'ESCUELA PARTICULAR MAYAY', value: '7322' },
  { text: 'ESCUELA DE ADULTOS LUIS BERTIN SCHWARZENBERG', value: '7323' },
  { text: 'LICEO CARMELA CARVAJAL DE PRAT', value: '7325' },
  { text: 'LICEO INDUSTRIAL DE OSORNO', value: '7326' },
  { text: 'LICEO DE RAHUE', value: '7328' },
  { text: 'INSTITUTO COMERCIAL DE OSORNO', value: '7331' },
  { text: 'ESCUELA JUAN RICARDO SANCHEZ', value: '7332' },
  { text: 'ESCUELA ESPANA', value: '7333' },
  { text: 'ESCUELA BASICA EFRAIN CAMPANA SILVA', value: '7334' },
  { text: 'ESCUELA  SUIZA', value: '7335' },
  { text: 'ESCUELA PAUL HARRIS', value: '7336' },
  { text: 'ESCUELA GARCIA HURTADO DE MENDOZA', value: '7337' },
  { text: 'ESCUELA LEONILA FOLCH LOPEZ', value: '7338' },
  { text: 'ESCUELA CANADA', value: '7339' },
  { text: 'ESCUELA CLAUDIO ARRAU', value: '7340' },
  { text: 'ESC. MONSENOR FRANCISCO VALDES S.', value: '7341' },
  { text: 'ESCUELA MEXICO', value: '7343' },
  { text: 'ESCUELA MODELO N_ 536', value: '7345' },
  { text: 'ESCUELA N_ 46 ITALIA', value: '7346' },
  { text: 'ESCUELA BASICA LAGO RUPANCO', value: '7347' },
  { text: 'ESCUELA BASICA CARLOS CONDELL', value: '7348' },
  { text: 'ESCUELA JOSE IGNACIO ZENTENO', value: '7349' },
  { text: 'ESC. SOCIEDAD DE SOCORRO DE SENORAS', value: '7352' },
  { text: 'ESC. ESPECIAL  ANA AICHELE CARRASCO', value: '7353' },
  { text: 'ESCUELA RURAL LUZ Y SABER', value: '7354' },
  { text: 'ESCUELA RURAL EMILIO SURBER SCHULZ', value: '7355' },
  { text: 'ESCUELA RURAL PELLECO', value: '7356' },
  { text: 'ESCUELA RURAL PUCOIHUE', value: '7357' },
  { text: 'ESCUELA RURAL TRINQUICAHUIN', value: '7359' },
  { text: 'ESCUELA RURAL MARIA LUISA BOMBAL', value: '7366' },
  { text: 'ESCUELA RURAL SANTA ROSA', value: '7368' },
  { text: 'ESCUELA RURAL PICHIL', value: '7369' },
  { text: 'ES UELA RURAL FORRAHUE', value: '7371' },
  { text: 'ESCUELA RURAL CANCHA LARGA', value: '7372' },
  { text: 'ESCUELA BASICA WALTERIO MEYER RUSCA', value: '7377' },
  { text: 'ESCUELA RURAL LUMACO', value: '7380' },
  { text: 'ESCUELA RURAL CHACAYAL', value: '7381' },
  { text: 'ESCUELA RURAL LOS ABEDULES', value: '7382' },
  { text: 'ESCUELA RURAL TACAMO ALTO', value: '7384' },
  { text: 'ESCUELA PARTICULAR ARTURO ALESSANDRI', value: '7385' },
  { text: 'COLEGIO PARTICULAR ESPECIAL JEAN PIAGET', value: '7386' },
  { text: 'COLEGIO SAN JOSE', value: '7388' },
  { text: 'ESCUELA PARTICULAR AURORA DE CHILE', value: '7390' },
  { text: 'COLEGIO BETEL', value: '7391' },
  { text: 'ESCUELA PARTICULAR DE PARVULOS N.255 PENEQUI', value: '7395' },
  { text: 'COLEGIO BALDOMERO LILLO', value: '7396' },
  { text: 'PARVULARIO PENEQUITA DOS', value: '7397' },
  { text: 'COLEGIO SANTA MARTA DE OSORNO', value: '7401' },
  { text: 'ESCUELA PARTICULAR PAULA JARAQUEMADA', value: '7402' },
  { text: 'COLEGIO WILLIAM BOOTH', value: '7403' },
  { text: 'COLEGIO RENE SORIANO BORQUEZ', value: '7404' },
  { text: 'COLEGIO PARTICULAR ADVENTISTA', value: '7405' },
  { text: 'ESCUELA PARVULARIA PEDRO AGUIRRE CERDA', value: '7407' },
  { text: 'ESCUELA VIRGEN DE CANDELARIA', value: '7412' },
  { text: 'LICEO ALIANZA FRANCESA CLAUDE GAY', value: '7414' },
  { text: 'ESCUELA BASICA SAN PABLO', value: '7418' },
  { text: 'ESCUELA BASICA DELICIO CARDENAS', value: '7419' },
  { text: 'ESCUELA RURAL SAN PEDRO', value: '7420' },
  { text: 'ESCUELA RURAL SAN FLORENTINO', value: '7421' },
  { text: 'ESCUELA RURAL QUITRA QUITRA', value: '7422' },
  { text: 'ESC.RURAL ALEJANDRO VASQUEZ BALDEVELLANO', value: '7423' },
  { text: 'ESCUELA BASICA VILLA CARACOL', value: '7424' },
  { text: 'ESCUEAL RURAL QUILEN', value: '7427' },
  { text: 'ESCUELA RURAL DE TRUMAO', value: '7431' },
  { text: 'ESCUELA RURAL JULIO MOHR SCHULER', value: '7432' },
  { text: 'ESCUELA RURAL LA POZA', value: '7433' },
  { text: 'ESCUELA PARTICULAR SANTA CRUZ', value: '7434' },
  { text: 'COLEGIO ALEMAN', value: '7435' },
  { text: 'ESCUELA PARTICULAR QUITRA QUITRA', value: '7436' },
  { text: 'ESCUELA PARTICULAR LOLOLHUE', value: '7437' },
  { text: 'ESCUELA PARTICULAR SANTA ROSA DE COFALMO', value: '7438' },
  { text: 'ESCUELA PARTICULAR PUCOPIO', value: '7440' },
  { text: 'COLEGIO FORESTAL QUILACAHUIN', value: '7441' },
  { text: 'ESCUELA PARTICULAR EL ROBLE', value: '7443' },
  { text: 'ESCUELA PARTICULAR ROSARIO DE LAS ANIMAS', value: '7446' },
  { text: 'ESCUELA ENTRE LAGOS', value: '7448' },
  { text: 'ESCUELA RURAL ARMANDO SCHEUCH EPPLE', value: '7449' },
  { text: 'ESCUELA RURAL LOS PELLINES', value: '7450' },
  { text: 'ESCUELA RURAL EL ENCANTO', value: '7452' },
  { text: 'ESCUELA RURAL LOS RADALES', value: '7453' },
  { text: 'ESCUELA RURAL EL MIRADOR', value: '7457' },
  { text: 'ESCUELA NADI PICHI DAMAS', value: '7458' },
  { text: 'ESCUELA NUEVO PORVENIR', value: '7459' },
  { text: 'ESCUELA RURAL PILMAIQUEN', value: '7460' },
  { text: 'ESCUELA RURAL DESAGUE RUPANCO', value: '7463' },
  { text: 'ESCUELA RURAL DE FUTACUHIN', value: '7464' },
  { text: 'ESCUELA DE TERMAS DE PUYEHUE', value: '7465' },
  { text: 'ESCUELA RURAL SANTA ELVIRA', value: '7469' },
  {
    text: 'LICEO TECNICO PROFESIONAL PEOPLE HELP PEOPLE SE\u00c3\u2018OR WALTER KAUFMANN BAUER',
    value: '7470',
  },
  { text: 'ESCUELA MUNICIPAL PAJARITOS', value: '7471' },
  { text: 'ESCUELA ALBERTO HURTADO', value: '7476' },
  { text: 'ESCUELA RURAL ADMINISTRACION RUPANCO', value: '7477' },
  { text: 'ESCUELA RURAL LAS CASCADAS', value: '7478' },
  { text: 'ESCUELA DE EL ISLOTE', value: '7479' },
  { text: 'ESCUELA DE CARRIL', value: '7480' },
  { text: 'ESCUELA BASICA PAULLIN', value: '7481' },
  { text: 'ESCUELA DE LAS NIEVES', value: '7484' },
  { text: 'ESCUELA RURAL DE LA PELLINADA', value: '7489' },
  { text: 'ESCUELA RURAL PIEDRAS NEGRAS', value: '7491' },
  { text: 'ESCUELA RURAL PICHI RIO NEGRO', value: '7492' },
  { text: 'ESCUELA RURAL LAGUNA BONITA', value: '7493' },
  { text: 'ESCUELA RURAL LAS JUNTAS', value: '7494' },
  { text: 'ESCUELA RURAL NOCHACO', value: '7496' },
  { text: 'ESCUELA RURAL EL VOLCAN', value: '7497' },
  { text: 'ESCUELA RURAL COIHUECO', value: '7498' },
  { text: 'ESCUELA PARTICULAR RIO BLANCO-COIHUECO', value: '7499' },
  { text: 'ESCUELA PARTICULAR JAVIERA CARRERA', value: '7500' },
  { text: 'ESCUELA PARTICULAR NOCHACO', value: '7501' },
  { text: 'ESCUELA PARTICULAR LAS GAVIOTAS', value: '7502' },
  { text: 'ESCUELA PARTICULAR RIO BLANCO-GAVIOTAS', value: '7503' },
  { text: 'LICEO TOMAS BURGOS', value: '7505' },
  { text: 'ESCUELA BERTOLDO HOFMANN KOHLER', value: '7507' },
  { text: 'ESCUELA VILLA LO BURGOS', value: '7508' },
  { text: 'CENTRO EDUCACION INTEGRAL DE ADULTOS', value: '7509' },
  { text: 'ESCUELA RURAL DE CRUCERO VIEJO', value: '7510' },
  { text: 'ESCUELA RURAL ANTONIO FERNANDEZ P.', value: '7511' },
  { text: 'ESCUELA RURAL BAHIA SAN PEDRO', value: '7513' },
  { text: 'ESCUELA RURAL LOS RISCOS', value: '7518' },
  { text: 'ESCUELA RURAL CRUCERO NUEVO', value: '7522' },
  { text: 'ESCUELA RURAL RIO BLANCO', value: '7525' },
  { text: 'ESCUELA RURAL ARTURO PEREZ CANTO', value: '7528' },
  { text: 'ESCUELA BASICA PURRANQUE', value: '7531' },
  { text: 'ESCUELA RURAL DE CONCORDIA', value: '7534' },
  { text: 'ESCUELA RURAL NUEVA ISRAEL', value: '7535' },
  { text: 'COLEGIO PRECIOSA SANGRE', value: '7536' },
  { text: 'ESCUELA MUNICIPAL MANQUEMAPU', value: '7538' },
  { text: 'COLEGIO ALEMAN DE PURRANQUE', value: '7539' },
  { text: 'ESCUELA ANDREW JACKSON', value: '7541' },
  { text: 'LICEO JOSE TORIBIO MEDINA', value: '7542' },
  { text: 'ESCUELA RIO NEGRO', value: '7543' },
  { text: 'ESCUELA BASICA RIACHUELO', value: '7544' },
  { text: 'ESCUELA RURAL PUTRIHUE', value: '7545' },
  { text: 'ESCUELA RURAL QUISQUELELFUN', value: '7546' },
  { text: 'ESCUELA RURAL RAMON PUSCHEL APPEL', value: '7552' },
  { text: 'ESCUELA RURAL SAGLLUE', value: '7553' },
  { text: 'ESCUELA RURAL HUILMA GRANDE', value: '7557' },
  { text: 'ESCUELA RURAL DE CASA DE LATA', value: '7558' },
  { text: 'ESCUELA RURAL LOS CASTANOS', value: '7559' },
  { text: 'ESCUELA RURAL CHEUQUEMO', value: '7561' },
  { text: 'ESCUELA RURAL NANCUAN', value: '7562' },
  { text: 'ESCUELA RURAL COSTA RIO BLANCO', value: '7563' },
  { text: 'ESCUELA RURAL CHAHUILCO', value: '7564' },
  { text: 'ESCUELA RURAL DE SAN FLORENTINO', value: '7565' },
  { text: 'ESCUELA RURAL EL BOLSON', value: '7566' },
  { text: 'ESCUELA CALETA HUELLELHUE', value: '7569' },
  { text: 'COLEGIO SAGRADA FAMILIA', value: '7572' },
  { text: 'ESCUELA MUNICIPAL LLAHUALCO', value: '7573' },
  { text: 'ESCUELA MUNICIPAL PICHIHUILMA', value: '7574' },
  { text: 'ESCUELA PARTICULAR VISTA HERMOSA', value: '7575' },
  { text: 'ESCUELA MUNICIPAL HERNAN MERY', value: '7576' },
  { text: 'ESCUELA AGRICOLA VISTA HERMOSA', value: '7578' },
  { text: 'ESCUELA RURAL DE PULOTRE', value: '7580' },
  { text: 'ESCUELA RURAL DE PUAUCHO', value: '7583' },
  { text: 'ESCUELA RURAL CHOROY TRAIGUEN', value: '7584' },
  { text: 'ESCUELA RURAL DE LOMA DE LA PIEDR', value: '7586' },
  { text: 'ESCUELA RURAL DE PUNINQUE', value: '7587' },
  { text: 'ESCUELA RURAL DE PUCATRIHUE', value: '7588' },
  { text: 'ESCUELA RURAL DE LIUCURA', value: '7590' },
  { text: 'ESCUELA RURAL DE PURREHUIN', value: '7592' },
  { text: 'ESCUELA RURAL DE BAHIA MANSA', value: '7593' },
  { text: 'ESCUELA RURAL DE CARRICO', value: '7596' },
  { text: 'ESCUELA PARTICULAR LAFQUELMAPU', value: '7600' },
  { text: 'ESCUELA PARTICULAR POPOEN', value: '7601' },
  { text: 'ESCUELA PARTICULAR HACIENDA HUITRAPULLI', value: '7602' },
  { text: 'ESCUELA PARTICULAR PANGUIMAPU', value: '7603' },
  { text: 'ESCUELA PARTICULAR PURRUCALHUE', value: '7605' },
  { text: 'ESCUELA PARTICULAR TROSCO', value: '7606' },
  { text: 'ESCUELA PARTICULAR CHANCO', value: '7607' },
  { text: 'ESCUELA PARTICULAR LAUPULLI', value: '7608' },
  { text: 'ESCUELA PARTICULAR QUEMEUMO', value: '7609' },
  { text: 'ESCUELA PARTICULAR CHAMILCO', value: '7610' },
  { text: 'ESCUELA PARTICULAR KINTUYEMAY', value: '7611' },
  { text: 'ESCUELA PARTICULAR CUMILELFU', value: '7612' },
  { text: 'ESCUELA PARTICULAR LOS HUALLES', value: '7613' },
  { text: 'ESCUELA PARTICULAR SN.JUAN DE LA COSTA', value: '7614' },
  { text: 'ESCUELA PARTICULAR HUACAMAPU', value: '7615' },
  { text: 'ESCUELA PARTICULAR MONTE VERDE', value: '7616' },
  { text: 'ESCUELA PARTICULAR PUNOTRO', value: '7617' },
  { text: 'ESCUELA PARTICULAR HUAMPUTUE', value: '7619' },
  { text: 'ESCUELA PARTICULAR MILLAHUAIMO', value: '7620' },
  { text: 'ESCUELA PARTICULAR HUITRAPULLI', value: '7622' },
  { text: 'ESCUELA PARTICULAR PUCATRIHUE', value: '7623' },
  { text: 'ESCUELA ADULTOS C.R.S.', value: '7624' },
  { text: 'LICEO COMERCIAL PUERTO MONTT', value: '7626' },
  { text: 'LICEO ANDRES BELLO', value: '7629' },
  { text: 'ESCUELA ESPANA', value: '7630' },
  { text: 'ESCUELA REPUBLICA ARGENTINA', value: '7631' },
  { text: 'ESCUELA BASICA ANGELMO', value: '7632' },
  { text: 'ESCUELA CAPITAN ARTURO PRAT CHACON', value: '7633' },
  { text: 'ESCUELA MIRASOL', value: '7634' },
  { text: 'ESCUELA BASICA MIRAMAR', value: '7636' },
  { text: 'ESCUELA ARABE-SIRIA', value: '7637' },
  { text: 'ESCUELA MELIPULLI', value: '7638' },
  { text: 'ESCUELA BELLAVISTA', value: '7641' },
  { text: 'ESCUELA BASICA LA COLINA', value: '7642' },
  { text: 'ESCUELA CHILOE', value: '7643' },
  { text: 'ESCUELA SANTA INES', value: '7644' },
  { text: 'ESCUELA ESPECIAL LOS EUCALIPTOS', value: '7645' },
  { text: 'ESCUELA ROTARIO PEDRO A. BRAVO', value: '7646' },
  { text: 'ESCUELA LIBERTAD', value: '7647' },
  { text: 'ESCUELA MARCELA PAZ', value: '7648' },
  { text: 'ESCUELA DE CULTURA Y DIFUSION ARTISTICA', value: '7650' },
  { text: 'LICEO RURAL PIEDRA AZUL', value: '7651' },
  { text: 'ESCUELA RURAL LENCA', value: '7654' },
  { text: 'ESCUELA RURAL MAILLEN', value: '7655' },
  { text: 'ESCUELA BASICA DE PELLUCO', value: '7656' },
  { text: 'ESCUELA RURAL DE CORRENTOSO', value: '7658' },
  { text: 'ESCUELA RURAL ALERCE', value: '7659' },
  { text: 'ESCUELA RURAL COLONIA METRENQUEN', value: '7661' },
  { text: 'ESCUELA SENDA SUR', value: '7662' },
  { text: 'ESCUELA RURAL LOS COLONOS', value: '7663' },
  { text: 'ESCUELA CAYENEL', value: '7664' },
  { text: 'ESCUELA RURAL LA CHAMIZA', value: '7665' },
  {
    text: 'CENTRO DE EDUCACION DE ADULTOS JOSE BERNARDO SUAREZ',
    value: '7667',
  },
  { text: 'ESCUELA RURAL LA CAPILLA', value: '7668' },
  { text: 'ESCUELA RURAL ILQUE', value: '7669' },
  { text: 'ESCUELA RURAL CARE - CHILE', value: '7670' },
  { text: 'ESCUELA RURAL LAGUNITAS', value: '7671' },
  { text: 'ESCUEAL RURAL DE CHAICAS', value: '7672' },
  { text: 'ESCUELA LOS PIONEROS DE S. CHICO', value: '7673' },
  { text: 'ESCUELA RURAL DE TRAPEN', value: '7675' },
  { text: 'ESCUELA RURAL CHINQUIHUE ALTO', value: '7676' },
  { text: 'ESCUELA RURAL METRI', value: '7677' },
  { text: 'ESCUELA RURAL DE HUELMO', value: '7679' },
  { text: 'ESCUELA RURAL COLONIA EL GATO', value: '7680' },
  { text: 'ESCUELA RURAL RIO CHICO', value: '7681' },
  { text: 'ESCUELA RURAL LA PALOMA', value: '7682' },
  { text: 'ESCUELA RURAL EL TEPUAL', value: '7684' },
  { text: 'ESCUELA RURAL LA VARA', value: '7685' },
  { text: 'ESCUELA RURAL MAILLEN-PUQUELDON', value: '7686' },
  { text: 'ESCUELA RURAL LAUCA', value: '7688' },
  { text: 'ESCUELA RURAL PICHI-QUILLAIPE', value: '7689' },
  { text: 'ESCUELA RURAL RIO BLANCO', value: '7690' },
  { text: 'ESCUELA RURAL PUNTILLA TENGLO', value: '7691' },
  { text: 'ESCUELA RURAL CUMBRE CORTADA', value: '7692' },
  { text: 'ESCUELA RURAL PELLINES DEL SALTO', value: '7693' },
  { text: 'ESCUELA RURAL ALTO BONITO', value: '7694' },
  { text: 'ESCUELA RURAL SALTO GRANDE', value: '7695' },
  { text: 'ESCUELA ANAHUAC', value: '7696' },
  { text: 'ESCUELA RURAL CALETA LA ARENA', value: '7698' },
  { text: 'COLEGIO ARRIARAN BARROS', value: '7701' },
  { text: 'INSTITUTO POLITECNICO MARIA AUXILIADORA', value: '7705' },
  { text: 'COLEGIO SANTO TOMAS DE PUERTO MONTT', value: '7706' },
  { text: 'ESCUELA PARTICULAR SAN JOSE', value: '7709' },
  { text: 'COLEGIO PARTICULAR SAN IGNACIO', value: '7710' },
  { text: 'ESCUELA PARTICULAR MANUEL RODRIGUEZ', value: '7712' },
  { text: 'ESCUELA PARTICULAR NUEVA PANITAO', value: '7714' },
  { text: 'ESCUELA PARTICULAR CASCAJAL', value: '7715' },
  { text: 'THE AMERICAN SCHOOL', value: '7718' },
  { text: 'ESCUELA ESPECIAL C.T.I. LOS NOTROS', value: '7719' },
  { text: 'ESCUELA ROSITA NOVARO DE NOVARO', value: '7722' },
  { text: 'ESCUELA GRUPO ESCOLAR PUERTO VARAS', value: '7723' },
  { text: 'COLEGIO NUEVA BRAUNAU', value: '7724' },
  { text: 'ESCUELA RURAL COLONIA RIO SUR', value: '7725' },
  { text: 'ESCUELA RURAL SANTA MARIA', value: '7726' },
  { text: 'ESCUELA RURAL TRES PUENTES', value: '7727' },
  { text: 'ESCUELA RURAL RODOLFO LUCKHEIDE', value: '7728' },
  { text: 'ESCUELA RURAL JOSE WERNER', value: '7729' },
  { text: 'ESC. RURAL REINALDO RADDATZ', value: '7730' },
  { text: 'ESCUELA RURAL JANEQUEO', value: '7732' },
  { text: 'ESCUELA RURAL HARDY MINTE', value: '7738' },
  { text: 'ESCUELA RURAL ELLA MINTE DE ROTH', value: '7739' },
  { text: 'ESCUELA RURAL EPSON DE ENSENADA', value: '7740' },
  { text: 'ESCUELA RURAL RICARDO ROTH SCHUTZ', value: '7741' },
  { text: 'COLEGIO FELMER NIKLITSCHEK', value: '7743' },
  { text: 'ESCUELA PARTICULAR INMACULADA CONCEPCION', value: '7744' },
  { text: 'ESCUELA PARTICULAR LINEA CRUZADA', value: '7745' },
  { text: 'ESCUELA PARTICULAR SANTA GEMITA', value: '7748' },
  { text: 'ESCUELA PARTICULAR ALBERTO DROPPELMANN', value: '7749' },
  { text: 'ESCUELA PART. N\u00c2\u00a6206 MARIA DOLORES', value: '7752' },
  { text: 'ESC.BAS.FRONTERIZA JUAN SOLER MANFREDINI', value: '7753' },
  { text: 'ESCUELA RURAL JOHN KENNEDY', value: '7754' },
  { text: 'ESCUELA RURAL SOBERANIA', value: '7755' },
  { text: 'ESCUELA RURAL CRISTO REY', value: '7756' },
  { text: 'ESCUELA RURAL SANTA AGUEDA', value: '7757' },
  { text: 'ESCUELA RURAL SAN ANTONIO', value: '7758' },
  { text: 'ESCUELA RURAL CLOTILDE ALMONACID', value: '7759' },
  { text: 'ESCUELA RURAL RIO PUELO', value: '7760' },
  { text: 'ESCUELA RURAL LAS CAMELIAS', value: '7761' },
  { text: 'ESCUELA RURAL EST. DE RELONCAVI', value: '7762' },
  {
    text: 'ESCUELA RURAL CAPIT\u00c3\u20acN DE BANDADA CARLOS RODRIGUEZ',
    value: '7763',
  },
  { text: 'ESCUELA RURAL LA PENINSULA DE ROLLIZO', value: '7765' },
  { text: 'ESCUELA RURAL CANUTILLAR', value: '7767' },
  { text: 'ESCUELA RURAL PASO EL BOLSON', value: '7768' },
  { text: 'ESCUELA RURAL LITORAL DE LLAGUEPE', value: '7769' },
  { text: 'ESC. RURAL STA. TERESITA DE LOS ANDES', value: '7770' },
  { text: 'ESCUELA EULOGIO GOYCOLEA GARAY', value: '7773' },
  { text: 'ESCUELA RURAL DE SAN RAFAEL', value: '7774' },
  { text: 'ESCUELA RURAL PARGUA', value: '7775' },
  { text: 'ESCUELA RURAL EL SEMBRADOR', value: '7776' },
  { text: 'ESCUELA RURAL EL ROSARIO', value: '7777' },
  { text: 'ESCUELA RURAL DE ESTERO HUITO', value: '7779' },
  { text: 'ESCUELA RURAL QUEULLIN', value: '7782' },
  { text: 'ESCUELA RURAL CHAUQUEAR', value: '7783' },
  { text: 'ESCUELA RURAL LOS PINIS', value: '7784' },
  { text: 'ESCUELA RURAL QUETROLAUQUEN', value: '7785' },
  { text: 'ESCUELA RURAL DAITAO', value: '7786' },
  { text: 'ESCUELA RURAL QUENU', value: '7787' },
  { text: 'ESCUELA RURAL DE CHAYAHUE', value: '7788' },
  { text: 'ESCUELA RURAL ALONSO DE ERCILLA', value: '7789' },
  { text: 'ESCUELA RURAL SOL DEL PACIFICO', value: '7790' },
  { text: 'ESCUELA RURAL AGUANTAO', value: '7791' },
  { text: 'ESCUELA RURAL MARIO MORALES BECA', value: '7793' },
  { text: 'ESCUELA RURAL EL FARO ILTO', value: '7794' },
  { text: 'ESCUELA RURAL ALFARO', value: '7796' },
  { text: 'ESCUELA RURAL SAN RAMON- ISLA PULUQUI', value: '7797' },
  { text: 'ESCUELA BASICA RURAL EL DAO', value: '7798' },
  { text: 'ESCUELA RURAL MI PATRIA', value: '7799' },
  { text: 'ESCUELA RURAL DE PUTENIO', value: '7801' },
  { text: 'ESCUELA RURAL DE SAN JOSE', value: '7802' },
  { text: 'ESCUELA RURAL SAN AGUSTIN', value: '7803' },
  { text: 'ESCUELA RURAL LA POZA', value: '7804' },
  { text: 'ESCUELA RURAL PEDRO BARRIENTOS BARRIENTOS', value: '7805' },
  { text: 'ESCUELA RURAL ESTERO RULO', value: '7806' },
  { text: 'ESCUELA RURAL DOLORES CANTTIN F.', value: '7807' },
  { text: 'ESCUELA RURAL LA CAMPANA', value: '7808' },
  { text: 'ESCUELA RURAL ISLA CHIDHUAPI', value: '7809' },
  { text: 'ESCUELA RURAL SAN ANTONIO', value: '7810' },
  { text: 'ESCUELA RURAL LOS BAJOS DE MAYELHUE', value: '7811' },
  { text: 'ESCUELA RURAL CARMEN MIRANDA N.', value: '7812' },
  { text: 'ESCUELA RURAL HUAPI - ABTAO', value: '7815' },
  { text: 'ESCUELA RURAL SIETE COLINAS', value: '7816' },
  { text: 'ESCUELA RURAL PENASMO', value: '7818' },
  { text: 'ESCUELA RURAL EL AVELLANAL', value: '7819' },
  { text: 'ESCUELA RURAL CHUCAGUA', value: '7820' },
  { text: 'ESCUELA RURAL ISLA TABON', value: '7821' },
  { text: 'ESCUELA RURAL MACHIL', value: '7822' },
  { text: 'ESCUELA RURAL EL YALE', value: '7823' },
  { text: 'ESCUELA RURAL HUAYUN BAJO', value: '7824' },
  { text: 'ESC.LIBERTADOR GRAL.BDO.OHIGGINS R.', value: '7825' },
  { text: 'COLEGIO SAN MIGUEL', value: '7826' },
  { text: 'LICEO CAPITAN DE FRAGATA FCO. VIDAL G.', value: '7830' },
  { text: 'ESCUELA FRANCISCO CORTES OJEDA', value: '7832' },
  { text: 'ESCUELA BASICA JOSE ABELARDO NUNEZ', value: '7833' },
  { text: 'ESCUELA BASICA ENCARNACION OLIVARES', value: '7834' },
  { text: 'ESCUELA RURAL DORILA AGUILA AGUILAR', value: '7836' },
  { text: 'ESCUELA PADRE NELSON AGUILAR COYAN', value: '7837' },
  { text: 'ESCUELA TEOFISTO CARCAMO', value: '7839' },
  { text: 'ESCUELA RURAL PAULINO VELAZQUEZ A.', value: '7840' },
  { text: 'ESCUELA RURAL PUPALGUIN', value: '7844' },
  { text: 'ESCUELA RURAL JOSE I. URIBE  OYARZO', value: '7846' },
  { text: 'ESCUELA RURAL CHUYAGUEN', value: '7847' },
  { text: 'ESCUELA RURAL AINCO', value: '7849' },
  { text: 'ESCUELA RURAL LOS ARCES', value: '7850' },
  { text: 'ESCUELA RURAL NUEVO AMANECER', value: '7851' },
  { text: 'ESCUELA RURAL JUANITA FERNANDEZ', value: '7852' },
  { text: 'ESCUELA JUANITA GALLARDO', value: '7854' },
  { text: 'ESCUELA RURAL PUELPUN', value: '7855' },
  { text: 'ESCUELA RURAL ASTILLEROS', value: '7856' },
  { text: 'ESCUELA RURAL FRANCISCO HERNANDEZ N.', value: '7858' },
  { text: 'ESCUELA MARIO E. GUZAMN ACEVEDO', value: '7860' },
  { text: 'ESCUELA EL JARDIN DE OLMOPULLI', value: '7861' },
  { text: 'ESCUELA RURAL SAN JORGE', value: '7864' },
  { text: 'ESCUELA ANA BORQUEZ SUBIABRE', value: '7865' },
  { text: 'ESCUELA RURAL HILDA HUNQUEN', value: '7866' },
  { text: 'ESCUELA RURAL LOS CIRUELILLOS', value: '7867' },
  { text: 'ESCUELA LOS PINOS DEL EMPALME', value: '7868' },
  { text: 'ESCUELA CUMBRE DEL B. PENOL', value: '7869' },
  { text: 'ESCUELA PARTICULAR LAS ENCINAS', value: '7871' },
  { text: 'ESCUELA LOS ULMOS', value: '7872' },
  { text: 'ESCUELA RURAL CANITAS', value: '7874' },
  { text: 'ESCUELA RURAL EL ROBLE', value: '7877' },
  { text: 'ESCUELA RURAL PALIHUE', value: '7878' },
  { text: 'ESCUELA RURAL QUILLAGUA', value: '7879' },
  { text: 'ESCUELA RURAL EL MANIO', value: '7880' },
  { text: 'ESCUELA RURAL HUANTRUNES', value: '7881' },
  { text: 'ESCUELA RURAL CULULIL', value: '7882' },
  { text: 'ESCUELA RURAL LAS COLINAS DE PUTRAUTRAO', value: '7884' },
  { text: 'ESCUELA RURAL CARACOL', value: '7887' },
  { text: 'ESCUELA RURAL LA COLONIA', value: '7890' },
  { text: 'ESCUELA RURAL SAN CARLOS', value: '7891' },
  { text: 'ESCUELA PARAGUAY CHICO - EL GATO', value: '7894' },
  { text: 'ESCUELA RURAL SAN PABLO', value: '7895' },
  { text: 'ESCUELA RURAL ESTAQUILLA', value: '7896' },
  { text: 'ESCUELA MANUEL GATICA ARRIAGADA', value: '7897' },
  { text: 'ESCUELA RURAL EL MELI', value: '7898' },
  { text: 'ESCUELA MANIO CHAQUIHUAN', value: '7900' },
  { text: 'ESCUELA RURAL EL SARAO', value: '7901' },
  { text: 'ESCUELA RURAL EL NADI', value: '7903' },
  { text: 'ESCUELA RURAL SERENA ESPERANZA', value: '7904' },
  { text: 'ESCUELA RURAL PARAGUAY CHICO', value: '7905' },
  { text: 'ESCUELA PARTICULAR MIRAMAR', value: '7908' },
  { text: 'ESCUELA PARTICULAR LA ESPERANZA', value: '7910' },
  { text: 'ESCUELA PARTICULAR EL LAUREL', value: '7911' },
  { text: 'ESCUELA PARTICULAR PLANCHADO LOS INDIOS', value: '7913' },
  { text: 'ESCUELA PARTICULAR MIRAMAR BAJO', value: '7915' },
  { text: 'ESCUELA PARTICULAR LOS KLEIN', value: '7916' },
  { text: 'ESCUELA PARTICULAR CORDILLERA VIEJA', value: '7917' },
  { text: 'ESCUELA PARTICULAR FUNDO LA PALOMA', value: '7918' },
  { text: 'ESCUELA PARTICULAR ESTAQUILLA BAJO', value: '7919' },
  { text: 'ESCUELA PARTICULAR EL PROGRESO', value: '7922' },
  { text: 'ESCUELA RURAL SAN ANDRES', value: '7924' },
  { text: 'ESCUELA RURAL CAU CAU', value: '7927' },
  { text: 'ESCUELA RURAL HUEMPELEO', value: '7929' },
  { text: 'ESCUELA RURAL LUCILA GODOY A.', value: '7930' },
  { text: 'ESCUELA RURAL PATO LLICO', value: '7931' },
  { text: 'ESCUELA RURAL LLICO', value: '7932' },
  { text: 'ESCUELA RURAL OLGA SOTO ALVARADO', value: '7933' },
  { text: 'ESCUELA RURAL RINCONADA', value: '7936' },
  { text: 'ESCUELA RURAL AMANCAYES', value: '7937' },
  { text: 'ESCUELA RURAL ENTRE RIOS', value: '7938' },
  { text: 'ESCUELA RURAL LINEA SIN NOMBRE', value: '7939' },
  { text: 'ESCUELA RURAL PARGA', value: '7940' },
  { text: 'LICEO CARLOS IBANEZ DEL CAMPO', value: '7941' },
  { text: 'COLEGIO PURISIMO CORAZON DE MARIA', value: '7942' },
  { text: 'ESCUELA RURAL SANTA MONICA', value: '7944' },
  { text: 'ESCUELA RURAL EL PEUCHEN', value: '7945' },
  { text: 'ESCUELA PARTICULAR PICHI MAULE', value: '7946' },
  { text: 'ESCUELA PARTICULAR LA ARANA', value: '7947' },
  { text: 'ESCUELA PARTICULAR LAS CUYAS', value: '7948' },
  { text: 'ESCUELA PARTICULAR EL TRAIGUEN DE LLICO', value: '7949' },
  { text: 'ESCUELA PARTICULAR EL PATO DE LLICO', value: '7950' },
  { text: 'ESCUELA PARTICULAR LA ESPERANZA', value: '7952' },
  { text: 'ESCUELA PARTICULAR SAN ANTONIO', value: '7953' },
  { text: 'ESCUELA PARTICULAR EL REPIL', value: '7954' },
  { text: 'LICEO MUNICIPAL TECNICO HOLANDA', value: '7956' },
  { text: 'ESCUELA INES GALLARDO ALVARADO', value: '7958' },
  { text: 'ESCUELA BASICA GABRIELA MISTRAL', value: '7959' },
  { text: 'ESCUELA RURAL LOS PELLINES', value: '7961' },
  { text: 'ESCUELA RURAL LONCOTORO', value: '7962' },
  { text: 'ESCUELA RURAL LINEA SOLAR', value: '7966' },
  { text: 'ESCUELA RURAL COLEGUAL', value: '7967' },
  { text: 'ESCUELA DE COLIGUAL SAN JUAN', value: '7968' },
  { text: 'ESCUELA PARTICULAR SAN JOSE', value: '7971' },
  { text: 'ESCUELA ARTURO ALESSANDRI PALMA', value: '7975' },
  { text: 'ESCUELA BERNARDO PHILIPPI', value: '7976' },
  { text: 'ESCUELA RURAL LOS LINARES DE CASMA', value: '7977' },
  { text: 'ESCUELA MARIO PEREZ NAVARRO', value: '7978' },
  { text: 'ESCUELA RURAL PARAGUAY', value: '7982' },
  { text: 'ESCUELA RURAL COLONIA LA RADIO', value: '7983' },
  { text: 'ESCUELA RURAL CARLOS FELMER', value: '7984' },
  { text: 'ESCUELA RURAL CENTINELA LA HUACHA', value: '7985' },
  { text: 'ESCUELA RURAL CARLOS SPRINGER N.', value: '7987' },
  { text: 'ESCUELA PARTICULAR MADRE DE DIOS', value: '7989' },
  { text: 'ESCUELA RURAL COLONIA SAN MARTIN', value: '7990' },
  { text: 'ESCUELA PARTICULAR ICEBERG', value: '7992' },
  { text: 'ESCUELA PARTICULAR LA HUACHA', value: '7993' },
  { text: 'ESCUELA PARTICULAR LA PAZ', value: '7994' },
  { text: 'ESCUELA PARTICULAR 245 SANTA ANA', value: '7996' },
  { text: 'ESCUELA PARTICULAR EL RETAMO', value: '7998' },
  { text: 'INSTITUTO ALEMAN DE FRUTILLAR', value: '8000' },
  { text: 'ESCUELA LUIS URIBE DIAZ', value: '8003' },
  { text: 'ESCUELA INES MUNOZ DE GARCIA', value: '8004' },
  { text: 'ESCUELA AYTUE', value: '8005' },
  { text: 'ESCUELA RURAL PEDRO VELAZQUEZ BONTES', value: '8006' },
  { text: 'ESCUELA RURAL QUELQUEL', value: '8009' },
  { text: 'ESCUELA RURAL CURAHUE', value: '8010' },
  { text: 'ESCUELA RURAL ANA NELLY OYARZUN CARTES', value: '8012' },
  { text: 'ESCUELA RURAL PEDRO URBIOLA', value: '8013' },
  { text: 'ESCUELA RURAL MANUELA CARDENAS BARRIA', value: '8014' },
  { text: 'ESCUELA RURAL  COIHUINCO', value: '8016' },
  { text: 'ESCUELA RURAL YUTUY', value: '8018' },
  { text: 'ESCUELA RURAL QUILQUICO', value: '8019' },
  { text: 'ESCUELA RURAL  PAUL HARRIS', value: '8020' },
  { text: 'ESCUELA RURAL PUACURA', value: '8021' },
  { text: 'ESC.RURAL ERMELINDA SANCHEZ DE CIFUENTES', value: '8022' },
  { text: 'ESCUELA BASICA DE ADULTOS DE CASTRO', value: '8023' },
  { text: 'ESCUELA RURAL DUCAN', value: '8024' },
  { text: 'ESCUELA RURAL OLINDA BORQUEZ BORQUEZ', value: '8027' },
  { text: 'ESCUELA RURAL HUENUCO', value: '8028' },
  { text: 'ESCUELA RURAL LLICALDAD', value: '8029' },
  { text: 'ESCUELA RURAL GAMBOA', value: '8030' },
  { text: 'ESCUELA RURAL LA CHACRA', value: '8031' },
  { text: 'ESCUELA RURAL INES BAZAN', value: '8032' },
  { text: 'ESCUELA RURAL LA ESTANCIA', value: '8033' },
  { text: 'ESCUELA RURAL  PID--PID', value: '8035' },
  { text: 'ESCUELA RURAL LOS ANGELES', value: '8036' },
  { text: 'ESCUELA RURAL LOS ROBLES', value: '8037' },
  { text: 'ESCUELA RURAL SAN MIGUEL', value: '8038' },
  { text: 'ESCUELA RURAL CAPILLA DE LOURDES', value: '8040' },
  { text: 'ESCUELA DIFERENCIAL ANTU- KAU', value: '8041' },
  { text: 'LICEO AGROPECUARIO Y ACUICOLA CHILOE', value: '8043' },
  { text: 'ESCUELA PUDETO', value: '8046' },
  { text: 'ESCUELA ANEXA', value: '8047' },
  { text: 'ESCUELA YERBAS BUENAS', value: '8048' },
  { text: 'ESCUELA RURAL VILLA CHACAO', value: '8049' },
  { text: 'ESCUELA FATIMA', value: '8050' },
  { text: 'ESCUELA RURAL EL PALOMAR', value: '8051' },
  { text: 'ESCUELA RURAL GUAPILACUY', value: '8052' },
  { text: 'ESCUELA RURAL SENDA CHACAO', value: '8053' },
  { text: 'ESCUELA RURAL MANAO', value: '8054' },
  { text: 'ESCUELA RURAL BELBEN', value: '8055' },
  { text: 'ESCUELA RURAL ESTRELLA DE HUILQUECO', value: '8059' },
  { text: 'ESCUELA RURAL GOLFETE DE QUETALMAHUE', value: '8060' },
  { text: 'ESCUELA RURAL PUNTA CHILEN', value: '8061' },
  { text: 'ESCUELA RURAL LA CAPILLA', value: '8063' },
  { text: 'ESCUELA RURAL CATRUMAN', value: '8066' },
  { text: 'ESCUELA RURAL GUABUN', value: '8067' },
  { text: 'ESCUELA RURAL NAL', value: '8071' },
  { text: 'ESCUELA RURAL QUILAR', value: '8075' },
  { text: 'ESCUELA RURAL COGOMO', value: '8080' },
  { text: 'ESCUELA RURAL CAYUCAN', value: '8081' },
  { text: 'ESCUELA RURAL CUMBRE DE LECAM', value: '8082' },
  { text: 'ESCUELA RURAL FELIPE SANTANA DE TEHUACO', value: '8083' },
  { text: 'ESCUELA RURAL SAN MIGUEL DE CONIMO', value: '8085' },
  { text: 'ESCUELA BASICA LUIS MAXIMO OYARZUN VIDAL', value: '8089' },
  { text: 'ESCUELA RURAL CALLE', value: '8091' },
  { text: 'ESCUELA RURAL LUIS ALBERTO SEGOVIA ROSS', value: '8092' },
  { text: 'ESCUELA RURAL CAIPULLI', value: '8094' },
  { text: 'ESCUELA RURAL AGUAS BUENAS', value: '8095' },
  { text: 'ESCUELA BASICA RURAL PUGUENUN', value: '8096' },
  { text: 'ESCUELA RURAL COCOTUE', value: '8099' },
  { text: 'ESCUELA RURAL SOL DEL PACIFICO', value: '8100' },
  { text: 'ESCUELA RURAL HUELDEN', value: '8102' },
  { text: 'ESCUELA RURAL BAHIA LINAO', value: '8103' },
  { text: 'ESCUELA RURAL PUENTE PUNTRA', value: '8104' },
  { text: 'ESCUELA LUIS CRUZ MARTINEZ', value: '8105' },
  { text: 'ESCUELA DIFERENCIAL SAN CARLOS DE ANCUD', value: '8107' },
  { text: 'SEMINARIO CONCILIAR DE ANCUD', value: '8108' },
  { text: 'ESCUELA RURAL JUAN VICTORINO TANGOL', value: '8112' },
  { text: 'ESCUELA RURAL AQUELARRE', value: '8113' },
  { text: 'ESCUELA RURAL LLIUCO', value: '8114' },
  { text: 'ESCUELA RURAL MORRO LOBOS ALTO', value: '8115' },
  { text: 'ESCUELA RURAL HUITE', value: '8116' },
  { text: 'ESCUELA RURAL MONTEMAR', value: '8117' },
  { text: 'ESCUELA RURAL AUCHO', value: '8118' },
  { text: 'ESCUELA RURAL COLO', value: '8119' },
  { text: 'ESCUELA RURAL QUINTERQUEN', value: '8120' },
  { text: 'ESCUELA RURAL SANTA ROSA', value: '8121' },
  { text: 'ESCUELA RURAL PIDO', value: '8122' },
  { text: 'ESCUELA RURAL CAUCAHUE', value: '8124' },
  { text: 'ESCUELA RURAL AUCAR', value: '8126' },
  { text: 'ESCUELA RURAL QUELER', value: '8127' },
  { text: 'ESCUELA RURAL TOCOIHUE', value: '8130' },
  { text: 'ESCUELA RURAL MALUCO', value: '8131' },
  { text: 'ESCUELA DE AULIN-', value: '8132' },
  { text: 'ESCUELA RURAL LINDA VISTA', value: '8133' },
  { text: 'ESCUELA RURAL CONEB', value: '8134' },
  { text: 'ESCUELA RURAL TAC.', value: '8135' },
  { text: 'ESCUELA RURAL ARCHIPIELAGO', value: '8136' },
  { text: 'ESCUELA RURAL VOIGUE', value: '8138' },
  { text: 'ESCUELA DE CHENIAO-ISLAS CHAUQUES', value: '8139' },
  { text: 'ESCUELA RURAL SAN JOSE', value: '8141' },
  { text: 'ESCUELA RURAL BORDEMAR VILLA MECHUQUE', value: '8142' },
  { text: 'ESCUELA RURAL NAYAHUE', value: '8143' },
  { text: 'ESCUELA RURAL QUETALCO', value: '8144' },
  { text: 'ESCUELA RURAL COLEGUAL', value: '8145' },
  { text: 'ESCUELA RURAL TEGUEL', value: '8146' },
  { text: 'ESCUELA RURAL MALLINLEMU', value: '8147' },
  { text: 'ESCUELA RURAL CARIHUEICO', value: '8149' },
  { text: 'ESCUELA RURAL EL PRADO', value: '8150' },
  { text: 'ESCUELA RURAL PROF.HECTOR M. BAHAMONDE N.', value: '8153' },
  { text: 'ESCUELA RURAL DALLICO', value: '8155' },
  { text: 'ESCUELA RURAL KILOMETRO SESENTA', value: '8156' },
  { text: 'ESCUELA RURAL JOSE MARIA ULLOA SALDIVIA', value: '8157' },
  { text: 'ESCUELA RURAL CALEN', value: '8158' },
  { text: 'ESC. RURAL JOSE D. BAHAMONDE B.', value: '8159' },
  { text: 'ESCUELA RURAL CULDEO', value: '8160' },
  { text: 'ESCUELA BASICA DALCAHUE', value: '8161' },
  { text: 'LICEO ALFREDO BARRIA OYARZUN', value: '8162' },
  { text: 'ESCUELA RURAL CHULLEC', value: '8163' },
  { text: 'ESCUELA RURAL TOLQUIEN', value: '8164' },
  { text: 'ESCUELA RURAL EDUARDO FREI MONTALVA', value: '8165' },
  { text: 'ESCUELA RURAL VISTA HERMOSA', value: '8166' },
  { text: 'ESCUELA RURAL HUYAR BAJO', value: '8167' },
  { text: 'ESCUELA RURAL HUYAR ALTO', value: '8169' },
  { text: 'ESCUELA RURAL SAN JAVIER', value: '8170' },
  { text: 'ESCUELA RURAL HUENAO', value: '8173' },
  { text: 'LICEO INSULAR - ACHAO', value: '8174' },
  { text: 'ESCUELA RURAL CAPILLA ANTIGUA DE QUENAC', value: '8175' },
  { text: 'ESCUELA RURAL LA CAPILLA', value: '8176' },
  { text: 'ESCUELA RURAL OSTRICULTURA', value: '8177' },
  { text: 'ESCUELA RURAL FRANCISCO DE VILLAGRA', value: '8179' },
  { text: 'ESCUELA RURAL ALAO', value: '8180' },
  { text: 'ESCUELA RURAL METAHUE', value: '8181' },
  { text: 'ESCUELA RURAL LA VILLA', value: '8182' },
  { text: 'ESCUELA RURAL AMANECER 2000', value: '8183' },
  { text: 'ESCUELA RURAL LLINGUA', value: '8184' },
  { text: 'ESCUELA RURAL LOS PINOS', value: '8186' },
  { text: 'ESCUELA RURAL EL TRANSITO', value: '8187' },
  { text: 'ESCUELA RURAL LA CAPILLA', value: '8188' },
  { text: 'ESC.RURAL TERESA CARDENAS DE PAREDES', value: '8189' },
  { text: 'ESC.RURAL EL ESTERO', value: '8190' },
  { text: 'ESCUELA RURAL SAN FRANCISCO', value: '8191' },
  { text: 'ESCUELA RURAL CONAB', value: '8193' },
  { text: 'ESCUELA PUQUELDON', value: '8195' },
  { text: 'ESCUELA RURAL LAS LAGUNAS - PUCHILCO', value: '8197' },
  { text: 'ESCUELA RURAL SAN JUAN DE LINCAY', value: '8198' },
  { text: 'ESCUELA RURAL SAN AGUSTIN', value: '8200' },
  { text: 'ESCUELA RURAL LAS CAMPANAS -ALDACHILDO', value: '8201' },
  { text: 'ESCUELA RURAL DETIF', value: '8202' },
  { text: 'ESCUELA RURAL SANTA ROSA LIUCURA', value: '8203' },
  { text: 'ESCUELA RURAL ICHUAC', value: '8205' },
  { text: 'LICEO MANUEL JESUS ANDRADE BORQUEZ', value: '8206' },
  { text: 'ESCUELA RURAL NOTUCO', value: '8207' },
  { text: 'ESCUELA RURAL CURACO DE VILUPULLI', value: '8208' },
  { text: 'ESCUELA RURAL ALCALDEO DE RAUCO', value: '8209' },
  { text: 'ESCUELA RURAL QUITRIPULLI', value: '8210' },
  { text: 'ESCUELA RURAL HUILLINCO', value: '8211' },
  { text: 'ESCUELA RURAL EL PULPITO', value: '8213' },
  { text: 'ESCUELA RURAL QUIAO', value: '8214' },
  { text: 'ESCUELA RURAL TARA', value: '8215' },
  { text: 'ESCUELA RURAL PUCATUE', value: '8216' },
  { text: 'ESCUELA RURAL TEUPA', value: '8217' },
  { text: 'ESCUELA RURAL PINDACO', value: '8219' },
  { text: 'ESCUELA RURAL CUCAO', value: '8220' },
  { text: 'ESCUELA RURAL NOTUE', value: '8222' },
  { text: 'ESCUELA RURAL QUILIPULLI', value: '8223' },
  { text: 'ESCUELA RURAL DICHAM', value: '8224' },
  { text: 'ESCUELA RURAL CANAN', value: '8225' },
  { text: 'ESCUELA RURAL QUINCHED', value: '8226' },
  { text: 'ESCUELA RURAL CHANQUIN', value: '8227' },
  { text: 'ESCUELA RURAL VILUPULLI', value: '8228' },
  { text: 'ESCUELA RURAL MELLEICO', value: '8229' },
  { text: 'ESCUELA RURAL RAUCO', value: '8230' },
  { text: 'ESCUELA RURAL TERAO', value: '8231' },
  { text: 'ESCUELA RURAL LOS PETANES', value: '8232' },
  { text: 'ESCUELA RURAL NATRI', value: '8233' },
  { text: 'ESCUELA RURAL MIRAFLORES', value: '8234' },
  { text: 'ESCUELA CHILHUE', value: '8236' },
  { text: 'ESCUELA RURAL PAILDAD', value: '8237' },
  { text: 'ESCUELA RURAL ALQUI', value: '8238' },
  { text: 'ESCUELA RURAL INSTITUTO CORFO PUREO', value: '8239' },
  { text: 'ESCUELA RURAL ALVARO VARGAS MIRANDA', value: '8241' },
  { text: 'ESCUELA RURAL EL MALLIN', value: '8242' },
  { text: 'ESCUELA RURAL CONTUY', value: '8243' },
  { text: 'ESCUELA RURAL DIAZ - LIRA', value: '8244' },
  { text: 'ESCUELA RURAL NEPUE', value: '8246' },
  { text: 'ESCUELA RURAL JUAN A. VERA DIAZ', value: '8247' },
  { text: 'ESCUELA RURAL SAN JOSE DE TRANQUI', value: '8251' },
  { text: 'ESCUELA RURAL LOS CISNES', value: '8253' },
  { text: 'ESCUELA RURAL DETICO', value: '8254' },
  { text: 'ESCUELA EULOGIA BORQUEZ PEREZ', value: '8256' },
  { text: 'ESCUELA RURAL SAN ANTONIO DE CHADMO0', value: '8257' },
  { text: 'ESCUELA RURAL DE RIO MAULE', value: '8258' },
  { text: 'ESCUELA RURAL QUILEN', value: '8260' },
  { text: 'ESCUELA RURAL CHADMO CENTRAL', value: '8261' },
  { text: 'ESCUELA RURAL COLCAO', value: '8262' },
  { text: 'ESCUELA JOSE SANTOS LINCOMAN INAICHEO', value: '8263' },
  { text: 'ESCUELA RURAL ADELA GARCIA GARCIA', value: '8264' },
  { text: 'ESCUELA RURAL COCAUQUE', value: '8265' },
  { text: 'ESCUELA RURAL HUELPUN', value: '8267' },
  { text: 'ESCUELA RURAL OQUELDAN', value: '8268' },
  { text: 'ESCUELA LASTENIA OYARZUN ANDRADE', value: '8269' },
  { text: 'ESCUELA RURAL PELU', value: '8270' },
  { text: 'ESCUELA RURAL PUNTA PAULA', value: '8271' },
  { text: 'ESCUELA RURAL SANTA ROSA', value: '8272' },
  { text: 'ESCUELA RURAL COINCO ALTO', value: '8273' },
  { text: 'ESCUELA RURAL CANDELARIA', value: '8274' },
  { text: 'ESCUELA RURAL TRINCAO', value: '8275' },
  { text: 'ESCUELA RURAL PIEDRA BLANCA', value: '8276' },
  { text: 'ESCUELA RURAL SAN JUAN ISLA CAILIN', value: '8277' },
  { text: 'ESCUELA RURAL YELCHO', value: '8278' },
  { text: 'ESCUELA RURAL CARMEN DOLORES MUNOZ', value: '8280' },
  { text: 'ESCUELA RURAL CHAIGUAO', value: '8281' },
  { text: 'ESCUELA RURAL COINCO', value: '8284' },
  { text: 'ESCUELA RURAL AGUA FRESCA', value: '8285' },
  { text: 'ESCUELA RURAL SAN ANTONIO', value: '8286' },
  { text: 'ESCUELA RURAL AUCHAC', value: '8287' },
  { text: 'ESCUELA RURAL DE YALDAD', value: '8288' },
  { text: 'ESC.RUR.ART.ALUM.MARCELO GUENTEO SOLIS', value: '8289' },
  { text: 'ESCUELA RURAL KUME RUKA WEKETRUMAO', value: '8290' },
  { text: 'ESCUELA DE NAYAHUE-ISLAS DESERTORES', value: '8293' },
  { text: 'ESCUELA DE AUTENI-ISLAS DESERTORES', value: '8294' },
  { text: 'ESCUELA DE CHUIT-ISLAS DESERTORES', value: '8295' },
  { text: 'ESCUELA DE CHULIN-ISLAS DESERTORES', value: '8296' },
  { text: 'ESCUELA DE TALCAN-ISLAS DESERTORES', value: '8298' },
  { text: 'ESCUELA DE CASA DE PESCA', value: '8299' },
  { text: 'ESCUELA RURAL LOYOLA', value: '8300' },
  { text: 'ESCUELA DE BUILL', value: '8301' },
  { text: 'ESCUELA DE CHUMELDEN', value: '8303' },
  { text: 'ESCUELA DE RIO AMARILLO', value: '8304' },
  { text: 'ESCUELA DE CHANA', value: '8305' },
  { text: 'ESCUELA DE VALLE EL FRIO', value: '8306' },
  { text: 'ESCUELA DE HUEQUE', value: '8307' },
  { text: 'ESCUELA DE POYO', value: '8308' },
  { text: 'ESCUELA DE AYACARA', value: '8309' },
  { text: 'ESCUELA RURAL MAURICIO HITCHCOCK', value: '8310' },
  { text: 'ESCUELA DE AULEN', value: '8311' },
  { text: 'ESCUELA DE PICHICOLO', value: '8312' },
  { text: 'ESCUELA RURAL CATARATAS DEL ALERCE', value: '8313' },
  { text: 'ESCUELA RURAL CANDELARIA', value: '8314' },
  { text: 'ESCUELA RURAL SAN PEDRO', value: '8315' },
  { text: 'ESCUELA DE LA POZA-CONTAO', value: '8317' },
  { text: 'ESCUELA DE QUILDACO', value: '8318' },
  { text: 'ESCUELA RURAL VALLE HERMOSO', value: '8319' },
  { text: 'ESCUELA DE MANIHUEICO', value: '8320' },
  { text: 'ESCUELA RURAL CALETA EL MANZANO', value: '8321' },
  { text: 'ESCUELA DE HUINAY', value: '8322' },
  { text: 'ESCUELA RURAL SEMILLERO', value: '8323' },
  { text: 'ESCUELA RURAL QUETEN', value: '8324' },
  { text: 'ESCUELA ANTUPIREN', value: '8325' },
  { text: 'ESCUELA RURAL SAN FRANCISCO', value: '8326' },
  { text: 'ESCUELA RURAL QUIACA', value: '8327' },
  {
    text: 'ESCUELA RURAL JUAN FRANCISCO MALDONADO BARR\u00c3\u008dA',
    value: '8328',
  },
  { text: 'ESCUELA RURAL CORDILLERA NEVADA', value: '8329' },
  { text: 'ESCUELA PARTICULAR AULEN', value: '8330' },
  { text: 'ESCUELA DE FUTALEUFU', value: '8331' },
  { text: 'ESCUELA DE EL ESPOLON', value: '8334' },
  { text: 'ESCUELA DE RIO AZUL', value: '8335' },
  { text: 'ESCUELA RURAL EL LIMITE', value: '8336' },
  { text: 'ESCUELA RURAL LAS ESCALAS', value: '8337' },
  { text: 'ESCUELA DE LONCONAO', value: '8338' },
  { text: 'ESCUELA ROBERTO WHITE GESELL', value: '8339' },
  { text: 'ESCUELA DE RIO MALITO', value: '8340' },
  { text: 'ESCUELA RURAL FRONTERIZA', value: '8341' },
  { text: 'ESCUELA RURAL PUERTO RAMIREZ', value: '8342' },
  { text: 'ESCUELA DE EL TRANQUILO', value: '8344' },
  { text: 'ESCUELA VICTOR DOMINGO SILVA', value: '8346' },
  { text: 'ESCUELA BAQUEDANO', value: '8348' },
  { text: 'ESCUELA PEDRO QUINTANA MANSILA', value: '8349' },
  { text: 'ESCUELA DIFERENCIAL ESPANA', value: '8351' },
  { text: 'ESCUELA NIEVES DEL SUR', value: '8353' },
  { text: 'ESCUELA RURAL PABLO CEA VASQUEZ', value: '8354' },
  { text: 'ESCUELA RURAL PABLO NERUDA', value: '8355' },
  { text: 'ESCUELA RURAL CON INTERNADO RIO BLANCO', value: '8356' },
  { text: 'ESCUELA RURAL VALLE SIMPSON', value: '8357' },
  { text: 'ESCUELA JOSE ANTOLIN SILVA ORMENO', value: '8358' },
  { text: 'ESCUELA RURAL VALLE DE LA LUNA', value: '8361' },
  { text: 'ESCUELA RURAL ARROYO EL GATO', value: '8362' },
  { text: 'ESCUELA LYON COLLEGE', value: '8366' },
  { text: 'ESCUELA MUNICIPAL VILLA AMENGUAL', value: '8370' },
  { text: 'ESC.CON INTERNADO JOSE MIGUEL CARRERA', value: '8371' },
  { text: 'ESCUELA RURAL CON INTERNADO LA TAPERA', value: '8372' },
  { text: 'ESCUELA RURAL SOBERANIA RIO CISNES', value: '8373' },
  { text: 'ESCUELA DIFERENCIAL DESPERTAR', value: '8374' },
  { text: 'ESCUELA BASICA', value: '8376' },
  { text: 'ESCUELA AYSEN', value: '8377' },
  { text: 'ESCUELA PEDRO AGUIRRE CERDA', value: '8379' },
  { text: 'ESCUELA MANIHUALES', value: '8380' },
  { text: 'ESCUELA CARLOS CONDELL', value: '8382' },
  { text: 'ESCUELA ALMIRANTE SIMPSON', value: '8384' },
  { text: 'ESCUELA GUIDO GOMEZ MUNOZ', value: '8388' },
  { text: 'ESCUELA AMANDA LABARCA HUBERSTONE', value: '8389' },
  { text: 'ESCUELA HAMBURGO', value: '8390' },
  { text: 'ESCUELA DE MELINKA', value: '8392' },
  { text: 'ESCUELA DE REPOLLAL', value: '8393' },
  { text: 'ESCUELA TULIO BURGOS RIVERA', value: '8397' },
  { text: 'ESC. LIBERTADOR BERNARDO OHIGGINS RIQUELME', value: '8398' },
  { text: 'ESCUELA DE PUERTO BERTRAND', value: '8399' },
  { text: 'ESCUELA GABRIELA MISTRAL', value: '8401' },
  { text: 'ESCUELA RURAL CERRO CASTILLO', value: '8403' },
  { text: 'ESCUELA AONIKENK', value: '8404' },
  { text: 'ESCUELA RURAL CARRETERA AUSTRAL', value: '8405' },
  { text: 'ESCUELA DE PUERTO SANCHEZ', value: '8407' },
  { text: 'ESC.  BASICA  HERNAN MERINO CORREA', value: '8408' },
  { text: 'ESCUELA PIONEROS DEL SUR', value: '8409' },
  { text: 'ESCUELA MUNICIPAL CDTE LUIS BRAVO BRAVO', value: '8410' },
  { text: 'LICEO POLITECNICO LUIS CRUZ MARTINEZ', value: '8411' },
  { text: 'ESCUELA LIB. BERNARDO OHIGGINS R.', value: '8412' },
  { text: 'ESCUELA CORONEL SANTIAGO BUERAS', value: '8413' },
  { text: 'ESCUELA CAPITAN JUAN LADRILLERO', value: '8415' },
  { text: 'ESC. DIF. NICOLAS MLADINIC DOBRONIC', value: '8416' },
  { text: 'ESCUELA BAUDILIA AVENDANO DE YOUSSUF', value: '8417' },
  { text: 'ESC. PROF. MIGUEL S. MONTECINOS C.', value: '8419' },
  { text: 'ESC. DE CONCENTRACION FRONTERIZA DOROTEA', value: '8420' },
  { text: 'LICEO SALESIANO MONSE\u00c3\u2018OR FAGNANDO', value: '8421' },
  { text: 'LICEO MARIA MAZZARELLO', value: '8422' },
  { text: 'ESC.HOGAR MUN.FRONTERIZA RAMON SERRANO M', value: '8423' },
  { text: 'INSTIT.SUPERIOR DE COMERCIO JOSE MENENDEZ', value: '8424' },
  { text: 'LICEO POLIVALENTE MARIA BEHETY DE MENENDEZ', value: '8425' },
  { text: 'COLEGIO ANDINO', value: '8426' },
  { text: 'LICEO INDUSTRIAL ARMANDO QUEZADA ACHARAN', value: '8427' },
  { text: 'LICEO POLIVALENTE SARA BRAUN', value: '8430' },
  { text: 'CENTRO DE EDUC.INTEGRAL DE ADULTOS CEIA.', value: '8432' },
  { text: 'ESCUELA LIBERTADOR CAP GRAL BDO OHIGGINS', value: '8433' },
  { text: 'ESCUELA ESPANA', value: '8434' },
  { text: 'ESCUELA DIECIOCHO DE SEPTIEMBRE', value: '8435' },
  { text: 'ESCUELA PORTUGAL', value: '8436' },
  { text: 'ESC. CAPITAN ARTURO PRAT CHACON', value: '8437' },
  { text: 'ESCUELA REPUBLICA DE CROACIA', value: '8438' },
  { text: 'ESCUELA JUAN WILLIAMS', value: '8439' },
  { text: 'ESCUELA HERNANDO DE MAGALLANES', value: '8441' },
  { text: 'ESCUELA PEDRO PABLO LEMAITRE', value: '8442' },
  { text: 'ESCUELA ESPECIAL ROTARIO PAUL HARRIS', value: '8443' },
  { text: 'ESCUELA PATAGONIA', value: '8444' },
  { text: 'ESCUELA PEDRO SARMIENTO DE GAMBOA', value: '8448' },
  { text: 'ESCUELA RIO SECO', value: '8449' },
  { text: 'ESCUELA DELLAMIRA REBECA AGUILAR', value: '8450' },
  { text: 'ESCUELA DE PUERTO HARRIS', value: '8452' },
  { text: 'INSTITUTO DON BOSCO', value: '8454' },
  { text: 'INSTITUTO SAGRADA FAMILIA', value: '8457' },
  { text: 'ESCUELA PARTICULAR LA MILAGROSA', value: '8458' },
  { text: 'BERNARDO DE BRUYNE', value: '8467' },
  { text: 'ESCUELA DIEGO PORTALES', value: '8468' },
  { text: 'ESCUELA PUNTA DELGADA', value: '8470' },
  { text: 'LICEO POLIVALENTE HERNANDO DE MAGALLANES', value: '8474' },
  { text: 'ESCUELA LIBERTADOR BDO. OHIGGINS R.', value: '8475' },
  { text: 'ESC. PARTICULAR MARIA AUXILIADORA', value: '8478' },
  { text: 'ESCUELA CERRO SOMBRERO', value: '8479' },
  { text: 'ESCUELA CAPITAN IGNACIO CARRERA PINTO', value: '8482' },
  { text: 'LICEO ALMTE DONALD MC-INTYRE GRIFFITHS', value: '8483' },
  { text: 'ESCUELA PUERTO TORO', value: '8484' },
  { text: 'ESCUELA VILLA LAS ESTRELLAS', value: '8486' },
  { text: 'LICEO VALENTIN LETELIER', value: '8494' },
  { text: 'LICEO POLIV.LIB. GRAL JOSE DE SAN MARTIN', value: '8496' },
  { text: 'LICEO GABRIELA MISTRAL', value: '8497' },
  { text: 'LICEO POLITEC. PDTE. GABRIEL GONZALEZ VIDELA', value: '8501' },
  { text: 'LICEO POLIVALENTE JUAN A.RIOS', value: '8508' },
  { text: 'ESC. BAS. REPUBLICA ORIENTAL DE URUGUAY', value: '8513' },
  { text: 'ESCUELA BASICA CORNELIA OLIVARES', value: '8515' },
  { text: 'LICEO ESTACION CENTRAL', value: '8518' },
  { text: 'ESCUELA BASICA PEDRO AGUIRRE CERDA', value: '8519' },
  { text: 'ESCUELA BASICA PROVINCIA DE CHILOE', value: '8520' },
  { text: 'ESCUELA CARLOS CONDELL DE LA HAZA', value: '8521' },
  { text: 'ESCUELA BASICA REPUBLICA DE COLOMBIA', value: '8522' },
  { text: 'ESCUELA BASICA REPUBLICA DE PANAMA', value: '8523' },
  { text: 'ESCUELA DE PARVULOS ANTU-HUILEN', value: '8529' },
  { text: 'ESCUELA CADETE ARTURO PRAT CHACON', value: '8530' },
  { text: 'ESCUELA BASICA IRENE FREI DE CID', value: '8531' },
  { text: 'ESCUELA BASICA LIBERTADORES DE CHILE', value: '8532' },
  { text: 'ESCUELA BASICA BENJAMIN VICUNA MACKENNA', value: '8533' },
  { text: 'ESCUELA REPUBLICA DE ISRAEL', value: '8536' },
  { text: 'ESCUELA ARNALDO FALABELLA', value: '8537' },
  { text: 'ESCUELA BASICA REPUBLICA DE HAITI', value: '8540' },
  { text: 'LICEO SAN FRANCISCO DE QUITO', value: '8542' },
  { text: 'ESCUELA B\u00c3\u0081SICA ARTURO ALESSANDRI PALMA', value: '8544' },
  { text: 'ESC.BAS.BILINGUE REPUBLICA DEL PARAGUAY', value: '8546' },
  { text: 'ESCUELA NUEVA ZELANDIA', value: '8547' },
  { text: 'ESCUELA BASICA DR LUIS CALVO MACKENNA', value: '8548' },
  { text: 'ESCUELA FERNANDO ALESSANDRI RODRIGUEZ', value: '8549' },
  { text: 'ESCUELA BAS SALVADOR SANFUENTES REP EEUU', value: '8552' },
  { text: 'ESCUELA DE ADULTOS  JORGE ALESSANDRI R.', value: '8553' },
  { text: 'LICEO MUNICIPAL METROPOLITANO DE ADULTOS', value: '8554' },
  { text: 'ESCUELA REPUBLICA EL LIBANO', value: '8555' },
  { text: 'ESCUELA REPUBLICA DE AUSTRIA', value: '8556' },
  {
    text: 'ESCUELA B\u00c3\u0081SICA HUMBERTO VALENZUELA GARC\u00c3\u008dA',
    value: '8558',
  },
  { text: 'ESCUELA REPUBLICA DE ALEMANIA', value: '8561' },
  { text: 'CIUDAD SANTIAGO DE CHILE', value: '8562' },
  { text: 'ESCUELA BASICA REPUBLICA DE MEXICO', value: '8563' },
  { text: 'ESCUELA BASICA REINO DE NORUEGA', value: '8564' },
  { text: 'ESCUELA BASICA REPUBLICA DEL ECUADOR', value: '8569' },
  { text: 'ESCUELA HOGAR DE MENORES', value: '8571' },
  { text: 'ESCUELA BASICA CAMILO MORI', value: '8572' },
  { text: 'ESCUELA BASICA CD.ARTURO MERINO BENITEZ', value: '8573' },
  { text: 'ESCUELA BASICA REYES CATOLICOS', value: '8576' },
  { text: 'ESCUELA BASICA UNION LATINOAMERICANA', value: '8579' },
  { text: 'ESCUELA B\u00c3\u0081SICA F N\u00c2\u00ba 64', value: '8581' },
  { text: 'ESC. CENTRO DE CAPACITACION LABORAL SANTIAGO', value: '8585' },
  { text: 'ESCUELA DIFERENCIAL JUAN SANDOVAL C', value: '8586' },
  { text: 'COLEGIO ALTO PALENA', value: '8598' },
  { text: 'COLEGIO WUNMAN', value: '8601' },
  { text: 'COLEGIO FRANCISCANO MARIA REINA', value: '8613' },
  { text: 'COLEGIO POLIVALENTE PLUS ULTRA', value: '8616' },
  { text: 'ESC. BAS. PART. TERESIANA DE SAN GABRIEL', value: '8623' },
  { text: 'CENTRO EDUC. CASA TALLERES SAN VICENTE DE PAU', value: '8625' },
  { text: 'COLEGIO ECHAURREN', value: '8631' },
  { text: 'LICEO JOSE DOMINGO CANAS', value: '8645' },
  { text: 'COLEGIO POLITECNICO AVDA. INDEPENDENCIA', value: '8654' },
  { text: 'COLEGIO SAN ALBERTO', value: '8657' },
  { text: 'ESCUELA PARTICULAR FRANCISCO ANDRES OLEA', value: '8659' },
  { text: 'LICEO POLIVALENTE ITALIA', value: '8660' },
  { text: 'ESCUELA PARTICULAR GUILLERMO MATTA', value: '8661' },
  { text: 'ESCUELA PARTICULAR HERMANOS MATTE', value: '8663' },
  { text: 'ESC.PARTICULAR PATRONATO SAN ANTONIO', value: '8665' },
  { text: 'COLEGIO SANTA ISABEL', value: '8666' },
  { text: 'ESCUELA PARTICULAR SAN LAZARO', value: '8674' },
  { text: 'ESCUELA MANUEL JOSE IRARRAZAVAL', value: '8676' },
  { text: 'ESC.SILVIA SALAS EDWARDS', value: '8678' },
  { text: 'COLEGIO JEAN JACQUES', value: '8684' },
  { text: 'ESCUELA BASICA PARTICULAR CLUB HIPICO', value: '8685' },
  { text: 'ESCUELA PARTICULAR AMOR DE DIOS', value: '8690' },
  { text: 'ESCUELA PARTICULAR EL PEQUENO ESTUDIANTE', value: '8699' },
  { text: 'ESCUELA INSTITUTO CAMILO HENRIQUEZ', value: '8700' },
  { text: 'ESC. PARTICULAR MARYLAND COLLEGE', value: '8703' },
  { text: 'ESCUELA SAN BENILDO', value: '8706' },
  { text: 'ESCUELA PARTICULAR JUAN PABLO I', value: '8709' },
  { text: 'ESCUELA BASICA DAVID MATARASSO N\u00c2\u00b02', value: '8712' },
  { text: 'ESCUELA PARTICULAR RAMON FREIRE', value: '8714' },
  { text: 'COLEGIO SAO PAULO', value: '8715' },
  { text: 'ESCUELA PARTICULAR SAINT HENRY SCHOOL', value: '8717' },
  { text: 'ESCUELA PARTICULAR DANES', value: '8718' },
  { text: 'ESCUELA PARTICULAR ESPECIAL ALOA', value: '8720' },
  { text: 'ESCUELA PARTICULAR ESPECIAL CEDIN', value: '8721' },
  { text: 'ESCUELA PARTICULAR ESPECIAL STA.JULIANA', value: '8725' },
  { text: 'ESCUELA PARTICULAR THOMAS JEFFERSON', value: '8726' },
  { text: 'COLEGIO GEORGE WASHINGTON', value: '8728' },
  { text: 'ESCUELA PARTICULAR DIVINA MARIA', value: '8739' },
  { text: 'ESCUELA MANUEL MONTT', value: '8780' },
  { text: 'ESCUELA BASICA PARTICULAR STA BERNARDITA', value: '8781' },
  { text: 'ESCUELA BASICA SPENDIX', value: '8793' },
  { text: 'ESCUELA PART MARY AND GEORGE S SCHOOL', value: '8800' },
  { text: 'ESCUELA DE PARVULOS HEYDDIE', value: '8809' },
  {
    text: 'LICEO INDUSTRIAL DE LA CONSTRUCCION VICTOR BEZANILLA SALINAS',
    value: '8812',
  },
  { text: 'LICEO INDUSTRIAL A-22 DE SANTIAGO', value: '8814' },
  { text: 'LICEO JUAN PABLO II DE LAS CONDES', value: '8822' },
  { text: 'ESC. DE EDUC. DIFERENCIAL PAUL HARRIS', value: '8832' },
  { text: 'LICEO MARIA LUISA BOMBAL', value: '8833' },
  { text: 'LICEO SANTA MARIA DE LAS CONDES', value: '8835' },
  { text: 'ESCUELA DE ED.DIFERENCIAL LO BARNECHEA', value: '8837' },
  { text: 'COLEGIO DE ADULTOS FERMIN VIVACETA DE LO BARNECHEA', value: '8839' },
  { text: 'ESCUELA DE FARELLONES', value: '8840' },
  { text: 'COLEGIO PARROQ STA ROSA DE LO BARNECHEA', value: '8841' },
  { text: 'ESCUELA PARTICULAR HOGAR ESPANOL', value: '8843' },
  { text: 'COLEGIO SAN JUAN DE KRONSTADT', value: '8845' },
  { text: 'COLEGIO SAN PATRICIO', value: '8852' },
  { text: 'COLEGIO ANGLO AMERICAN INTERNATIONAL SCHOOL', value: '8860' },
  { text: 'COLEGIO ADVENTISTA LAS CONDES', value: '8861' },
  { text: 'COLEGIO FRANCISCO DE ASIS', value: '8867' },
  { text: 'COLEGIO NIDO DE AGUILAS', value: '8880' },
  { text: 'COLEGIO SANTA URSULA', value: '8904' },
  { text: 'ESCUELA DE PARV.MY MELODY KINDERGARTEN SCHOOL', value: '8912' },
  { text: 'COLEGIO BRITISH HIGH', value: '8921' },
  { text: 'ESCUELA BASICA EL VERGEL', value: '8931' },
  { text: 'ESCUELA DE PROVIDENCIA', value: '8933' },
  { text: 'ESCUELA ABELARDO ITURRIAGA JAMETT', value: '8934' },
  { text: 'ESCUELA ESPECIAL MC-KAY', value: '8936' },
  { text: 'ESCUELA PARTICULAR TERESIANA DE SAN JOSE', value: '8942' },
  { text: 'ESCUELA PARTICULAR ELVIRA ERRAZURIZ', value: '8943' },
  { text: 'COLEGIO LAS AMERICAS', value: '8949' },
  { text: 'SAINT GABRIELS SCHOOL SEDE DIAMELOS', value: '8955' },
  { text: 'COLEGIO LATINOAMERICANO DE INTEGRACION', value: '8956' },
  { text: 'ESCUELA BASICA ASOCIACION MONTESSORI', value: '8957' },
  { text: 'COLEGIO SUPERIOR CAMBRIDGE', value: '8959' },
  {
    text: 'SAINT GABRIELS SCHOOL SEDE ELEODORO YA\u00c3\u2018EZ',
    value: '8970',
  },
  { text: 'COLEGIO CAMPUS COLLEGE', value: '8974' },
  { text: 'SAINT GABRIELS SCHOOL SEDE PASTENE', value: '8986' },
  { text: 'ESCUELA DE PARVULOS MAMPATO', value: '8987' },
  { text: 'COMPLEJO EDUCACIONAL LA REINA', value: '9006' },
  { text: 'LICEO EUGENIO MAR\u00c3\u008dA DE HOSTOS', value: '9007' },
  { text: 'COLEGIO MUNICIPALIZADO CONFEDERAC SUIZA', value: '9008' },
  { text: 'ESCUELA D-231 ESPECIAL DE DESARROLLO', value: '9010' },
  { text: 'COLEGIO SAN CONSTANTINO', value: '9011' },
  { text: 'ESCUELA BASICA YANGTSE EX E-229', value: '9012' },
  { text: 'ESCUELA PALESTINA', value: '9013' },
  { text: 'ESCUELA PARTICULAR SAN LEONARDO MURIALDO', value: '9017' },
  { text: 'ESCUELA HERMANAS DEL NINO JESUS', value: '9025' },
  { text: 'ESCUELA ESPECIAL CTI.LOS COPIHUES   N.3', value: '9026' },
  { text: 'COLEGIO PARTICULAR INFANTES DE LA REINA', value: '9029' },
  { text: 'ESCUELA PARTICULAR ANTINIL', value: '9032' },
  { text: 'COLEGIO EL CARMEN TERESIANO', value: '9035' },
  { text: 'ESCUELA BASICA PART COLEGIO JOSE ARRIETA', value: '9036' },
  { text: 'COLEGIO SAN LUIS DE LAS CONDES', value: '9038' },
  { text: 'ESCUELA DE PARVULOS CHISPITAS', value: '9043' },
  { text: 'ESCUELA BASICA PEQUENO MOZART', value: '9056' },
  { text: 'INSTITUTO SUPERIOR DE COMERCIO DIEGO PORT', value: '9058' },
  { text: 'LICEO POLITECNICO PEDRO DE VALDIVIA', value: '9060' },
  {
    text: 'LICEO POLITECNICO A N\u00c2\u00b0 60 PRESIDENTE MANUEL MONTT',
    value: '9061',
  },
  { text: 'ESCUELA BENJAMIN CLARO VELASCO', value: '9070' },
  { text: 'LICEO CARMELA SILVA DONOSO', value: '9073' },
  { text: 'COMPLEJO EDUC.MUN. BRIGIDA  WALKER.', value: '9077' },
  { text: 'ESCUELA DIFERENCIAL MUNICIPAL AMAPOLAS', value: '9083' },
  { text: 'ESC.PRESIDENTE EDUARDO FREI MONTALVA', value: '9084' },
  { text: 'ESCUELA JOSE BERNARDO SUAREZ', value: '9085' },
  { text: 'ESCUELA AURORA DE CHILE', value: '9086' },
  { text: 'CENTRO EDUC. VALLE HERMOSO', value: '9087' },
  {
    text: 'ESCUELA B\u00c3\u0081SICA JOS\u00c3\u2030 TORIBIO MEDINA',
    value: '9089',
  },
  { text: 'ESCUELA BAS. CENTRO EDUCACIONAL MILLANTU', value: '9090' },
  { text: 'ESCUELA REPUBLICA DE FRANCIA', value: '9091' },
  { text: 'ESCUELA REPUBLICA DE COSTA RICA', value: '9097' },
  { text: 'ESCUELA JUAN BAUTISTA PASTEN', value: '9098' },
  { text: 'ESCUELA GUILLERMO ZANARTU IRIGOYEN', value: '9102' },
  { text: 'ESCUELA UNION NACIONAL ARABE', value: '9103' },
  { text: 'ESCUELA VILLA MACUL', value: '9104' },
  { text: 'CENTRO EDUCACIONAL EDUARDO DE LA BARRA', value: '9105' },
  { text: 'CENTRO EDUCACION MARIANO EGANA', value: '9106' },
  { text: 'LICEO ERASMO ESCALA ARRIAGADA', value: '9107' },
  { text: 'ESCUELA CARLOS HERNANDEZ PENA', value: '9110' },
  { text: 'ESCUELA LUIS  ARRIETA CANAS', value: '9111' },
  { text: 'LICEO MUNICIPALIZADO MANUEL ROJAS', value: '9116' },
  { text: 'ESCUELA E-180 MATILDE HUICI NAVAS', value: '9117' },
  { text: 'ESCUELA TOBALABA', value: '9121' },
  { text: 'ESCUELA JULIO MONTT SALAMANCA', value: '9122' },
  { text: 'ESCUELA BASICA', value: '9125' },
  { text: 'ESCUELA STGO BUERAS Y AVARIAS', value: '9127' },
  { text: 'ESCUELA DE ED.DIFERENCIAL HELLEN KELLER', value: '9128' },
  { text: 'ESCUELA JUAN MOYA MORALES', value: '9131' },
  { text: 'COLEGIO APOSTOL SAN PEDRO', value: '9135' },
  { text: 'ESCUELA PARTICULAR ESPECIAL CEINTRALE', value: '9137' },
  { text: 'ESCUELA PARTICULAR SANTA VICTORIA', value: '9140' },
  { text: 'ESCUELA BASICA PARTICULAR LOS HUSARES', value: '9142' },
  { text: 'ESCUELA BASICA MARTINEZ DE ROZAS', value: '9144' },
  { text: 'ESCUELA PARTICULAR MANUEL ANTONIO MATTA', value: '9145' },
  { text: 'ESCUELA PARTICULAR CARMEN ARRIARAN', value: '9146' },
  { text: 'COLEGIO PARTICULAR N 1 DE NUNOA', value: '9147' },
  { text: 'ESCUELA PARTICULAR REGINA MUNDI', value: '9150' },
  {
    text: 'CENTRO DE CAPACITACI\u00c3\u201cN LABORAL PARA DEFICIENTES MENTALES',
    value: '9153',
  },
  { text: 'ESCUELA BAS. RENACIMIENTO N_ 1', value: '9156' },
  { text: 'COLEGIO PARTICULAR SAN FERNANDO', value: '9158' },
  { text: 'ESCUELA PARTICULAR NUESTRA SRA.DEL PILAR', value: '9162' },
  { text: 'ESCUELA BAS. N_ 850 SANTA SOFIA', value: '9165' },
  { text: 'COLEGIO LIBERTADOR SIMON BOLIVAR', value: '9168' },
  { text: 'ESCUELA SAN JOSE OBRERO', value: '9171' },
  { text: 'COLEGIO POLIV. ROCKET COLLEGE', value: '9172' },
  { text: 'ESCUELA BASICA COLEGIO SANTA MARTA DE PENALOL', value: '9175' },
  { text: 'COLEGIO SANTA MARTA', value: '9179' },
  { text: 'ESC.PARA SORDOS DR. OTTE GABLER', value: '9183' },
  { text: 'ESCUELA PARTICULAR PRECIOSA SANGRE', value: '9184' },
  { text: 'ESC. PART. MARTA BRUNET', value: '9187' },
  { text: 'TALLER DIFER.DOCTOR ALFONSO ASENJO G.', value: '9189' },
  { text: 'ESCUELA PARTICULAR COLEGIO CEDI', value: '9190' },
  { text: 'ESCUELA PARTICULAR WELCOME SCHOOL', value: '9197' },
  { text: 'ESCUELA PARTICULAR SANTIAGO DE CHILE', value: '9201' },
  { text: 'ESCUELA PARTICULAR ESPECIAL PENALOLEN', value: '9204' },
  { text: 'ESCUELA PARTICULAR THE NEW SCHOOL', value: '9205' },
  { text: 'COLEGIO PARTICULAR NUMERO DOS DE NU\u00c3\u2018OA', value: '9206' },
  { text: 'COMPLEJO EDUCACIONAL ESPERANZA', value: '9208' },
  { text: 'ESCUELA PARTICULAR SAN JUAN BAUTISTA', value: '9209' },
  { text: 'ESCUELA PARTICULAR INST.P.DE VALDIVIA', value: '9212' },
  { text: 'COLEGIO CENTRO EDUC.AMERICO VESPUCIO', value: '9213' },
  { text: 'COLEGIO AKROS', value: '9217' },
  { text: 'ESCUELA DE PARAVULOS CEDI', value: '9218' },
  { text: 'INSTITUTO PABLO NERUDA', value: '9228' },
  { text: 'ESCUELA ESPECIAL MIGUEL ARCANGEL', value: '9240' },
  { text: 'COLEGIO FUND. EDUCACION COLEGIO NOTRE DAME', value: '9244' },
  { text: 'ESCUELA DE PARVULOS MUSICAL DON OSITO', value: '9262' },
  { text: 'COLEGIO SANTA GEMA GALGANI', value: '9263' },
  {
    text: 'ESCUELA PARTICULAR N\u00c2\u00ba520 FLORENCE NIGHTINGALE',
    value: '9268',
  },
  { text: 'COLEGIO VICTOR DOMINGO SILVA', value: '9270' },
  { text: 'ESCUELA GUARDIAMARINA ERNESTO RIQUELME', value: '9282' },
  { text: 'ESCUELA BELLAVISTA', value: '9283' },
  { text: 'ESCUELA ELSA SANTIBANEZ', value: '9284' },
  { text: 'ESCUELA MARCELA PAZ', value: '9285' },
  { text: 'ESCUELA REPUBLICA DOMINICANA', value: '9287' },
  { text: 'LICEO NUEVO AMANECER', value: '9288' },
  { text: 'ESCUELA LAS ARAUCARIAS', value: '9289' },
  { text: 'ESCUELA SOTERO DEL RIO', value: '9290' },
  { text: 'ESCUELA AREAS VERDES', value: '9291' },
  { text: 'LICEO POLIVALENTE LOS ALMENDROS', value: '9293' },
  { text: 'ESCUELA LAS LILAS', value: '9296' },
  { text: 'ESCUELA CATALUNA', value: '9297' },
  { text: 'ESCUELA SANTA IRENE', value: '9299' },
  { text: 'ESCUELA LO CANAS', value: '9302' },
  { text: 'ESCUELA VILLAS UNIDAS', value: '9303' },
  { text: 'ESCUELA LOS CEREZOS', value: '9304' },
  { text: 'ESCUELA LOS QUILLAYES', value: '9306' },
  { text: 'ESCUELA  OSCAR CASTRO', value: '9307' },
  { text: 'ESCUELA PARTICULAR UNIDAD DIVINA', value: '9308' },
  { text: 'COLEGIO PARTICULAR ISLA WELLINGTON', value: '9311' },
  { text: 'ESCUELA PARTICULAR ESPECIAL JEAN PIAGET', value: '9323' },
  { text: 'ESCUELA PARTICULAR MSR.DIEGO ROSALES', value: '9324' },
  { text: 'COLEGIO OSMAN PEREZ FREIRE', value: '9332' },
  { text: 'ESCUELA PARTIC.ANTONIO BORQUEZ SOLAR', value: '9333' },
  { text: 'COLEGIO PORTALES', value: '9334' },
  { text: 'ESCUELA PARTICULAR LOS COPIHUES', value: '9335' },
  { text: 'ESCUELA PARTICULAR LORD TOMAS COCHRANE', value: '9337' },
  { text: 'COLEGIO BERTRAND RUSSEL', value: '9338' },
  { text: 'ESCUELA Y COLEGIO POLITECNICO LOS HEROES', value: '9339' },
  { text: 'ESCUELA PART. JOHN PAUL SCHOOL', value: '9341' },
  { text: 'ESCUELA PARTICULAR LAURA ELGUETA', value: '9342' },
  { text: 'ESCUELA PARTICULAR LOS CASTANOS', value: '9345' },
  { text: 'ESCUELA PARTICULAR ESPECIAL NUEVO RUMBO', value: '9348' },
  { text: 'ESCUELA COLEGIO LAANTARO', value: '9351' },
  { text: 'ESCUELA BAS. Y ESPECIAL ANDRES REY', value: '9357' },
  { text: 'ESC. PART. SAINT GERMAINE SCHOOL', value: '9358' },
  { text: 'ESC. PART. RAFAEL SOTOMAYOR B.', value: '9363' },
  { text: 'ESCUELA BASICA PARTICULAR PAICAVI  NUM 1', value: '9366' },
  { text: 'ESCUELA PARTICULAR PAPA JUAN PABLO II', value: '9368' },
  { text: 'CENTRO EDUCACIONAL LONDON', value: '9375' },
  { text: 'ESCUELA ESPECIAL INST.VICUNA MACKENNA', value: '9376' },
  { text: 'COLEGIO POLIV. VICENTE VALDES', value: '9377' },
  { text: 'ESCUELA PARTICULAR VALLE VERDE', value: '9383' },
  { text: 'ESCUELA DE PARVULOS THE RED GARDEN', value: '9393' },
  { text: 'COLEGIO SANTA CECILIA DE LA FLORIDA', value: '9396' },
  { text: 'LICEO POLITECNICO DE SAN JOAQUIN', value: '9408' },
  { text: 'CENTRO EDUCACIONAL HORACIO ARAVENA A.', value: '9411' },
  { text: 'ESCUELA GENERAL BASICA SANTA FE', value: '9413' },
  { text: 'ESCUELA B\u00c3\u0081SICA Y ESPECIAL 470 FRANKFORT', value: '9414' },
  { text: 'ESCUELA TERRITORIO ANTARTICO', value: '9415' },
  { text: 'ESCUELA POETAS DE CHILE', value: '9416' },
  { text: 'ESCUELA LA VICTORIA', value: '9418' },
  { text: 'LICEO MUNICIPAL SAN JOAQUIN', value: '9421' },
  { text: 'ESCUELA CENTRO EDUC. REP. MEXICANA', value: '9422' },
  { text: 'ESCUELA BASICA FRAY CAMILO HENRIQUEZ', value: '9424' },
  { text: 'ESCUELA LLANO SUBERCASEAUX', value: '9426' },
  { text: 'ESCUELA BASICA RICARDO E. LATCHMAN', value: '9428' },
  { text: 'ESCUELA POETA VICTOR DOMINGO SILVA', value: '9429' },
  { text: 'CENTRO EDUC. PROVINCIA DE \u00c3\u2018UBLE', value: '9430' },
  { text: 'ESCUELA VILLA SAN MIGUEL', value: '9431' },
  { text: 'ESCUELA BASICA MUNICIPAL', value: '9433' },
  { text: 'ESC. BAS. Y ESP. SU SANTIDAD JUAN XXIII', value: '9437' },
  { text: 'ESCUELA BAS. LOS HEROES DE YUNGAY', value: '9443' },
  { text: 'ESCUELA ESPECIAL LOS CEDROS DEL LIBANO', value: '9444' },
  { text: 'ESCUELA DE PARVULOS RAYITO DE LUZ', value: '9446' },
  { text: 'ESCUELA B\u00c3\u0081SICA POETA NERUDA (EX-483)', value: '9457' },
  { text: 'ESCUELA BOROA', value: '9458' },
  { text: 'INST. REG. EDUC ADULTOS SAN MIGUEL', value: '9460' },
  { text: 'ESC. ESP. DE ADULTOS HUGO MORALES BIZAMA', value: '9461' },
  { text: 'COLEGIO LA CASTRINA', value: '9467' },
  { text: 'ESCUELA IND. SAN ANTONIO DE PADUA', value: '9468' },
  { text: 'LICEO POLITECNICO SAN LUIS', value: '9472' },
  { text: 'ESCUELA BAS.PART.N 23 COLEGIO SANTA ANA', value: '9473' },
  { text: 'ESCUELA PARTICULAR HANSEL Y GRETEL', value: '9485' },
  { text: 'LICEO PARTICULAR ESPIRITU SANTO', value: '9486' },
  { text: 'ESCUELA INDUSTRIAL PART. LAUTARO', value: '9487' },
  { text: 'LICEO COMERCIAL JAVIERA Y J L CARRERA N1', value: '9489' },
  { text: 'ESCUELA PARTICULAR LUCILA GODOY', value: '9490' },
  { text: 'ESCUELA HOGAR DE CIEGOS SANTA LUCIA', value: '9499' },
  { text: 'COLEGIO POLIV.ADVENTISTA SANTIAGO SUR', value: '9502' },
  { text: 'ESCUELA PARTICULAR PIO DOCE', value: '9503' },
  { text: 'ESCUELA PARTICULAR JOSE A.ALFONSO', value: '9505' },
  { text: 'ESC.BAS.PROFESORA AIDA RAMOS DIAZ', value: '9506' },
  { text: 'ESCUELA PARTICULAR LAURA VICUNA', value: '9507' },
  { text: 'COLEGIO PARTICULAR POBL. ALESSANDRI', value: '9508' },
  { text: 'COLEGIO SUBERCASEAUX COLLEGE', value: '9509' },
  { text: 'COLEGIO PART. ANTONIO ACEVEDO HERNANDEZ', value: '9510' },
  { text: 'ESCUELA PARTICULAR GRAN AVENIDA', value: '9511' },
  { text: 'ESCUELA BASICA PARTIC JACQUELINE KENNEDY', value: '9512' },
  { text: 'LICEO INDUSTRIAL DEL VERBO DIVINO', value: '9516' },
  { text: 'COLEGIO PARTICULAR PADRE FIDEL ABARCA', value: '9518' },
  { text: 'PRINCESS MARGARET COLLEGE', value: '9520' },
  { text: 'ESCUELA ROBERT BADEN POWELL SCHOOL', value: '9525' },
  { text: 'ESCUELA BAS. ALFRED BINET SCHOOL', value: '9526' },
  { text: 'ESCUELA PARTICULAR ECOLE NOEL', value: '9527' },
  { text: 'ESCUELA PARTICULAR LA RAIZ Y LA ESPIGA', value: '9528' },
  { text: 'ESCUELA PARTICULAR MIGUEL DAVILA', value: '9531' },
  { text: 'ESCUELA BASICA PARTICULAR RAINBOW SCHOOL', value: '9533' },
  { text: 'ESCUELA PART.CENTRO EDUC.SANTA MONICA', value: '9536' },
  { text: 'ESCUELA PARTICULAR DIVINA GABRIELA', value: '9537' },
  { text: 'ESC. PART. SANTA CATALINA DE SAN MIGUEL', value: '9539' },
  { text: 'ESCUELA PARTICULAR SAN CARLOS', value: '9540' },
  { text: 'ESCUELA PARTICULAR EL GRECO', value: '9543' },
  { text: 'ESCUELA PARTICULAR AMIGOS', value: '9544' },
  { text: 'ESCUELA BAS. PART. QUEEN & FLOWER COLLEGE', value: '9547' },
  { text: 'ESCUELA PART. FERNANDO DE ARAGON', value: '9549' },
  { text: 'ESCUELA ESPECIAL PARTICULAR PAPELUCHO', value: '9550' },
  { text: 'ESCUELA PARTICULAR LA RONDA DE SN.MIGUEL', value: '9551' },
  { text: 'ESCUELA PARTICULAR MARQUEZ DE OVANDO', value: '9556' },
  { text: 'ESCUELA PARTICULAR ROCIO DE LOS ANGELES', value: '9558' },
  { text: 'ESCUELA PARTICULAR JAVIERA CARRERA', value: '9572' },
  { text: 'ESCUELA BASICA PARTICULAR CAMINITO', value: '9574' },
  { text: 'LICEO INDUSTRIAL DE SAN MIGUEL AGUSTIN ED', value: '9579' },
  { text: 'LICEO POLIVALENTE FRANCISCO FRIAS V.', value: '9582' },
  { text: 'CENTRO EDUCACIONAL MUN.MARIANO LATORRE', value: '9583' },
  { text: 'LICEO COMERCIAL VATE VICENTE HUIDOBRO', value: '9584' },
  { text: 'LICEO DOCTOR ALEJANDRO DEL RIO', value: '9585' },
  { text: 'LICEO MUNICIPALIZADO ARAUCANIA', value: '9586' },
  { text: 'LICEO MALAQUIAS CONCHA', value: '9587' },
  { text: 'ESCUELA BAS. TECNO SUR', value: '9588' },
  { text: 'ESCUELA BELGICA', value: '9590' },
  { text: 'LICEO N523', value: '9591' },
  { text: 'ESCUELA BASICA SENDERO DEL SABER', value: '9592' },
  { text: 'ESCUELA BASICA EDUCADORES DE CHILE', value: '9593' },
  { text: 'ESCUELA CAPITAN AVALOS', value: '9595' },
  { text: 'ESCUELA PABLO DE ROKHA', value: '9597' },
  { text: 'ESCUELA MUNICIPAL VIOLETA PARRA', value: '9598' },
  { text: 'ESCUELA NANIHUE', value: '9600' },
  { text: 'CENTRO EDUCACIONAL MUNICIPAL SAN RAMON', value: '9601' },
  { text: 'COLEGIO NERUDA', value: '9602' },
  { text: 'LICEO MUNICIPALIZADO CENT.ED. LA PINTANA', value: '9604' },
  { text: 'COLEGIO MUNICIPAL PROCERES DE CHILE', value: '9605' },
  { text: 'ESCUELA BAS. LA ARAUCANIA', value: '9606' },
  { text: 'ESCUELA DIFERENCIAL SANTA TERESITA DE LOS AND', value: '9607' },
  { text: 'ESCUELA BAS. SANITAS', value: '9609' },
  { text: 'ESCUELA BAS. POETA OSCAR CASTRO ZUNIGA', value: '9610' },
  { text: 'ESCUELA BASICA TUPAHUE', value: '9611' },
  { text: 'ESCUELA BASICA ISLAS DE CHILE', value: '9612' },
  { text: 'ESCUELA BASICA KARELMAPU', value: '9614' },
  { text: 'LICEO VICTOR JARA', value: '9616' },
  { text: 'LICEO MUNICIPAL LA GRANJA POETA NERUDA', value: '9617' },
  { text: 'ESCUELA BAS. BENJAMIN SUBERCASEAUX', value: '9618' },
  { text: 'ESCUELA BASICA JUAN DE DIOS ALDEA', value: '9620' },
  { text: 'ESCUELA BASICA VILLA LA CULTURA', value: '9625' },
  { text: 'ESCUELA BAS. REINA GUILLERMINA DE HOLANDA', value: '9626' },
  { text: 'ESCUELA BASICA ALIVEN', value: '9629' },
  { text: 'ESCUELA ESPECIAL DE ADULTOS', value: '9631' },
  { text: 'COLEGIO MARISTA MARCELINO CHAMPAGNAT', value: '9634' },
  { text: 'ESCUELA ESPECIAL PART. EDUCADORAS AGAZZI', value: '9635' },
  { text: 'ESCUELA PARTICULAR VENANCIA LEIVA', value: '9636' },
  { text: 'COLEGIO JUAN PABLO II', value: '9638' },
  { text: 'ESCUELA PARTICULAR EMA DIAZ SIERRA', value: '9639' },
  { text: 'ESCUELA PARTICULAR TTE.DAGOBERTO GODOY', value: '9642' },
  { text: 'INSTITUTO COMERCIAL EMA DIAZ SIERRA-DIUR', value: '9643' },
  { text: 'ESCUELA PARTICULAR FRANCISCO DE MIRANDA', value: '9648' },
  { text: 'ESCUELA PRESBITERIANA EL SALVADOR', value: '9653' },
  { text: 'ESCUELA PARTICULAR FRANCISCO RAMIREZ', value: '9654' },
  { text: 'ESCUELA PARTICULAR CLAUDIO MATTE', value: '9655' },
  { text: 'ESCUELA PARTIC PARROQUIAL DOMINGO SAVIO', value: '9660' },
  { text: 'ESCUELA PARTICULAR ELSA RAMIREZ', value: '9663' },
  { text: 'COLEGIO PARTICULAR PUERTO NAVARINO', value: '9664' },
  { text: 'CENTRO EDUCACIONAL SANTA ROSA DEL SUR', value: '9665' },
  { text: 'ESC. PART. CELESTIN FREINET', value: '9666' },
  { text: 'ESC.PART. ESPECIAL NUESTRO MUNDO', value: '9667' },
  { text: 'ESCUELA PARTICULAR FORJADORES DEL FUTURO', value: '9668' },
  { text: 'COLEGIO NUESTRO MUNDO', value: '9669' },
  { text: 'ESCUELA PARTICULAR ARTURO MATTE LARRAIN', value: '9673' },
  { text: 'ESCUELA BASICA ALAS DE AGUILA', value: '9674' },
  { text: 'ESCUELA PARTICULAR SAN MARCELO', value: '9676' },
  { text: 'COMPLEJO EDUC.STA.RITA DE CASIA-ANEXO 1', value: '9680' },
  { text: 'ESCUELA PARTICULAR ELLIOT COLLEGE', value: '9681' },
  { text: 'ESCUELA BASICA PARTIC ESTRELLA DE CHILE', value: '9685' },
  { text: 'LICEO JUAN GOMEZ MILLAS', value: '9688' },
  { text: 'CENTRO DUC.CARDENAL JOSE MARIA CARO', value: '9690' },
  { text: 'LICEO POLITECNICO ABDON CIFUENTES', value: '9691' },
  {
    text: 'INSTITUTO COMERCIAL PADRE ALBERTO HURTADO DE PEDRO AGUIRRE CERDA',
    value: '9694',
  },
  { text: 'LICEO POLIVALENTE EUGENIO PEREIRA SALAS', value: '9695' },
  { text: 'LICEO POLIVALENTE', value: '9697' },
  { text: 'ESCUELA BASICA AVIADORES', value: '9698' },
  { text: 'COLEGIO NACIONES UNIDAS', value: '9699' },
  { text: 'COLEGIO PALESTINO', value: '9700' },
  { text: 'LICEO POLIVALENTE OLOF PALME', value: '9701' },
  { text: 'ESCUELA BASICA MARIO ARCE GATICA', value: '9702' },
  { text: 'ESCUELA ESPERANZA JOVEN', value: '9703' },
  { text: 'ESCUELA LO VALLEDOR', value: '9704' },
  { text: 'ESCUELA BASICA SALOMON SACK', value: '9705' },
  { text: 'ESCUELA BAS. OSCAR ENCALADA YOVANOVICH', value: '9706' },
  { text: 'ESCUELA BLUE STAR COLLEGE', value: '9709' },
  { text: 'ESCUELA BASICA SANTA ADRIANA', value: '9710' },
  { text: 'COMPLEJO EDUCACIONAL FELIPE HERRERA LANE', value: '9713' },
  { text: 'ESCUELA BASICA JOSE MARTI', value: '9714' },
  { text: 'ESCUELA BASICA VILLA SANTA ELENA', value: '9715' },
  { text: 'ESCUELA BASICA ACAPULCO', value: '9716' },
  { text: 'ESCUELA CIUDAD DE LYON', value: '9717' },
  { text: 'ESCUELA BASICA PAUL HARRIS', value: '9718' },
  { text: 'ESCUELA BASICA', value: '9719' },
  { text: 'COLEGIO HERNAN OLGUIN', value: '9720' },
  { text: 'ESCUELA NEMESIO ANTUNEZ', value: '9721' },
  { text: 'LICEO PORTAL DE LA CISTERNA', value: '9722' },
  { text: 'LICEO TENIENTE FRANCISCO MERY AGUIRRE', value: '9726' },
  { text: 'ESCUELA CIUDAD DE BARCELONA', value: '9727' },
  { text: 'ESCUELA DIFERENCIAL PARA NINOS SORDOS', value: '9728' },
  { text: 'ESCUELA VILLA SUR', value: '9729' },
  { text: 'COLEGIO ANTU', value: '9730' },
  { text: 'ESCUELA SERGIO SILVA ACUNA', value: '9732' },
  { text: 'ESCUELA BASICA CLARA  ESTRELLA', value: '9733' },
  { text: 'ESCUELA  RAUL SAEZ SAEZ', value: '9734' },
  { text: 'ESCUELA BASICA BERNARDO OHIGGINS', value: '9736' },
  { text: 'COLEGIO PARQUE LAS AMERICAS', value: '9738' },
  { text: 'ESCUELA BASICA REPUBLICA DE LAS FILIPINAS', value: '9740' },
  { text: 'ESCUELA BASICA COEDUCACIONAL', value: '9741' },
  { text: 'LICEO ELENA CAFFARENA MORICE', value: '9743' },
  { text: 'C.E.I.A.PEDRO AGUIRRE CERDA', value: '9747' },
  { text: 'COLEGIO POLIVALENTE SAINT ORLAND N\u00c2\u00a6 2', value: '9750' },
  { text: 'ESCUELA ESPECIAL PARTICULAR YUNGAY', value: '9760' },
  { text: 'LICEO POLITECNICO GALVARINO N.2', value: '9762' },
  { text: 'CHILEAN EAGLES COLLEGE N.3', value: '9771' },
  { text: 'ESCUELA ESPECIAL NTA SENORA DE LAS PENAS', value: '9772' },
  { text: 'COLEGIO PARTICULAR JOSE ABELARDO NUNEZ', value: '9778' },
  { text: 'ESCUELA BASICA TTE.DAGOBERTO GODOY', value: '9780' },
  { text: 'CENTRO EDUCACIONAL LINCOLN COLLEGE', value: '9782' },
  { text: 'LICEO POLIVALENTE LA CISTERNA N\u00c2\u00b01', value: '9784' },
  { text: 'ROSA MARCKMANN DE GONZALEZ', value: '9786' },
  { text: 'ESCUELA PARTICULAR GRACIELA L.DE IBANEZ', value: '9788' },
  { text: 'ESCUELA PARTICULAR PABLO GOYENECHE IVER', value: '9789' },
  { text: 'ESCUELA PARTICULAR CHILDRENS COLLEGE', value: '9791' },
  { text: 'ESC. PART.ADVENTISTA BUENAVENTURA', value: '9796' },
  { text: 'COMPLEJO EDUC.PART.MONSENOR LUIS A.PEREZ', value: '9799' },
  { text: 'ESCUELA BAS. ROSA ELVIRA MATTE DE PRIETO', value: '9800' },
  { text: 'COLEGIO POLIV. SAINT ORLAND', value: '9801' },
  { text: 'ESCUELA PARTICULAR HISPANO AMERICANO', value: '9803' },
  { text: 'ESCUELA PARTICULAR WALT DISNEY', value: '9804' },
  { text: 'ESCUELA PARTICULAR CAMPANITA', value: '9805' },
  { text: 'ESCUELA PARTICULAR LOCARNO', value: '9807' },
  { text: 'ESCUELA PARTICULAR GUIA ESTUDIANTIL', value: '9808' },
  { text: 'ESCUELA PARTICULAR SAINT PHILLIP OF NERY', value: '9809' },
  { text: 'ESCUELA PART. REPUBLICA ALEMANIA FEDERAL', value: '9811' },
  { text: 'ESCUELA B\u00c3\u0081SICA PART.171 GALVARINO', value: '9814' },
  { text: 'ESCUELA PARTICULAR STA.MARIA MAZZARELLO', value: '9816' },
  { text: 'COLEGIO PARTICULAR KENNEDY', value: '9817' },
  { text: 'ESCUELA PARTICULAR LAS ESPIGAS', value: '9822' },
  { text: 'COMPLEJO EDUCACIONAL STELLA MARIS', value: '9824' },
  { text: 'ESCUELA PARTICULAR ESPECIAL G.MISTRAL', value: '9825' },
  { text: 'ESCUELA PARTICULAR LOS CAPULLITOS', value: '9826' },
  { text: 'ESCUELA PARTICULAR SOL DE CHILE', value: '9828' },
  { text: 'ESCUELA PARTICULAR SAN MARTIN DE PORRES', value: '9830' },
  { text: 'COLEGIO POLITEC. MARIA GRISELDA VALLE S.', value: '9834' },
  { text: 'ESCUELA PARTICULAR MIGUEL DE CERVANTES', value: '9841' },
  { text: 'ESCUELA PARTICULAR NUESTRA INFANCIA', value: '9842' },
  { text: 'COLEGIO GRACE SCHOOL', value: '9845' },
  { text: 'ESCUELA PARTICULAR KAROL C.DE CRACOVIA', value: '9847' },
  { text: 'ESCUELA PARTICULAR LOS LAGOS CHILE', value: '9850' },
  { text: 'ESCUELA PARTICULAR VILLA EL SOL', value: '9852' },
  { text: 'COLEGIO POLIV. SAINT TRINITY COLLEGE', value: '9853' },
  { text: 'COLEGIO PARTICULAR VILLA JESUS', value: '9859' },
  { text: 'CENTRO EDUC.MUNIC. DR. AMADOR NECHME R.', value: '9861' },
  {
    text: 'LICEO POLIVALENTE A N\u00c2\u00b071 GUILLERMO FELIU CRUZ',
    value: '9862',
  },
  { text: 'LICEO JOSE IGNACIO ZENTENO', value: '9864' },
  { text: 'LICEO DR. LUIS VARGAS SALCEDO', value: '9865' },
  { text: 'LICEO COMERCIAL B-72', value: '9866' },
  { text: 'CENTRO DE EDUC. TECN.PROFESIONAL CODEDUC', value: '9867' },
  { text: 'ESCUELA BASICA REPUBLICA DE FRANCIA', value: '9869' },
  { text: 'ESCUELA BASICA CONDORES DE PLATA', value: '9870' },
  { text: 'ESCUELA BASICA PROF.RAMON DEL RIO', value: '9872' },
  { text: 'ESCUELA BASICA PACTO ANDINO', value: '9873' },
  { text: 'ESCUELA LOTHAR KOMMER BRUGER', value: '9874' },
  { text: 'ESCUELA CERRILLOS', value: '9875' },
  { text: 'ESCUELA GENERAL SAN MARTIN', value: '9876' },
  { text: 'ESCUELA GENERAL OHIGGINS', value: '9877' },
  { text: 'ESCUELA PRESIDENTE RIESCO ERRAZURIZ', value: '9878' },
  { text: 'ESCUELA BASICA', value: '9879' },
  { text: 'ESCUELA BASICA JAPON', value: '9880' },
  { text: 'ESCUELA VICENTE REYES PALAZUELOS', value: '9881' },
  { text: 'ESCUELA J.PRIETO VIAL', value: '9882' },
  { text: 'ESCUELA B\u00c3\u0081SICA N 263 RAMON FREIRE', value: '9883' },
  { text: 'ESCUELA LEON HUMBERTO VALENZUELA', value: '9884' },
  { text: 'ESCUELA ESTRELLA REINA DE CHILE', value: '9886' },
  { text: 'ESCUELA EL LLANO DE MAIPU', value: '9887' },
  { text: 'ESCUELA SANTA ADELA', value: '9888' },
  { text: 'LICEO REINO DE DINAMARCA', value: '9889' },
  { text: 'ESCUELA TOMAS VARGAS', value: '9890' },
  { text: 'REPUBLICA DE GUATEMALA', value: '9891' },
  { text: 'ESCUELA LAS AMERICAS', value: '9892' },
  { text: 'ESCUELA ESPECIAL ANDALUE', value: '9893' },
  { text: 'ESCUELA BASICA REINA DE SUECIA', value: '9895' },
  { text: 'POLITECNICO ALEMAN ALBERT EINSTEIN', value: '9900' },
  { text: 'ESCUELA PARTICULAR FRANZ LISZT', value: '9901' },
  { text: 'ESCUELA PARTICULAR ESPECIAL DON ORIONE', value: '9902' },
  { text: 'COLEGIO PART. ASCENSION NICOL', value: '9912' },
  { text: 'COLEGIO ESC.  JOSE MANSO DE VELASCO', value: '9913' },
  { text: 'ESCUELA DE PARVULOS LOS PAISES BAJOS', value: '9916' },
  { text: 'COLEGIO POLIVALENTE PATRICIO MEKIS', value: '9917' },
  { text: 'ESC. BASICA DIVINO JESUS', value: '9920' },
  { text: 'ESCUELA PARTICULAR HOLANDA', value: '9922' },
  { text: 'ESCUELA INDUSTRIAL PARTICULAR CERRILLOS', value: '9923' },
  { text: 'COLEGIO SOFIA INFANTE HURTADO', value: '9926' },
  { text: 'ESCUELA PARTICULAR AMANECER', value: '9928' },
  { text: 'ESCUELA PARTICULAR CHILDRENS SCHOOL', value: '9932' },
  { text: 'LICEO MATER PURISSIMA', value: '9937' },
  { text: 'ESCUELA BASICA NO 3 CAMPOS DE MAIPU', value: '9939' },
  { text: 'COLEGIO PARTICULAR DE ASIS', value: '9941' },
  { text: 'ESCUELA COLEGIO POLITEC.H.DE MAGALLANES', value: '9942' },
  { text: 'ESCUELA DE PARVULOS ENANO GROUMPY', value: '9943' },
  { text: 'COLEGIO HEROES DE MAIPU', value: '9945' },
  { text: 'ESCUELA PARTICULAR LA MONTANA', value: '9946' },
  { text: 'ESCUELA PARTICULAR SAINT RODRIC COLLEGE', value: '9948' },
  { text: 'COLEGIO EL REDENTOR', value: '9950' },
  { text: 'CENTRO EDUCACIONAL SAN ANDRES', value: '9953' },
  { text: 'COLEGIO ROSITA SANCHEZ', value: '9955' },
  { text: 'LICEO INDUSTRIAL ALBERTO WIDMER', value: '9957' },
  { text: 'COLEGIO PARTICULAR ESPECIAL JUAN XXIII', value: '9963' },
  { text: 'ESCUELA ESPECIAL EDUCACIONAL AGAZZI', value: '9968' },
  { text: 'ESC. BASICA PARTIC.SAINT MAURICES', value: '9972' },
  { text: 'LICEO INDUSTRIAL DOMINGO MATTE PEREZ', value: '9981' },
  { text: 'LICEO POLITECNICO', value: '9986' },
  { text: 'ESCUELA PLATON', value: '9987' },
  { text: 'ESCUELA ABATE MOLINA', value: '9991' },
  { text: 'ESCUELA DIEGO PORTALES', value: '9992' },
  { text: 'ESCUELA INGLATERRA', value: '9993' },
  { text: 'ESCUELA ANGELMO', value: '9994' },
  { text: 'ESCUELA INSIGNE GABRIELA', value: '9995' },
  { text: 'ESCUELA ESPANA', value: '9996' },
  { text: 'ESCUELA LO FRANCO', value: '9998' },
  { text: 'ESCUELA ANTUMALAL', value: '9999' },
  { text: 'ESCUELA CALICANTO', value: '10000' },
  { text: 'ESCUELA MENBRILLAR', value: '10001' },
  { text: 'ESCUELA BASICA MUNICIPAL GRENOBLE', value: '10005' },
  { text: 'ESCUELA REPUBLICA DE LA INDIA', value: '10006' },
  { text: 'MUSTAFA KEMAL ATATURK', value: '10010' },
  { text: 'ESCUELA GIL DE CASTRO', value: '10012' },
  { text: 'ESCUELA PARTICULAR ANDRES BELLO', value: '10014' },
  { text: 'ESCUELA OLGA NAVARRO SEPULVEDA', value: '10015' },
  { text: 'ESCUELA PARTICULAR JOSE JOAQUIN PEREZ', value: '10018' },
  { text: 'ESCUELA PARTICULAR SAN JOSE SCHOOL', value: '10019' },
  { text: 'ESCUELA PARTICULAR VICTOR HUGO', value: '10021' },
  { text: 'LICEO ALBERTO HURTADO', value: '10023' },
  { text: 'ESCUELA PARTICULAR MONTE GRANDE', value: '10026' },
  { text: 'ESCUELA N\u00c2\u00b01124 ALIANZA AMERICANA', value: '10028' },
  { text: 'LICEO PARTICULAR ZENON TORREALBA', value: '10032' },
  { text: 'ESCUELA PARTICULAR NUEVO HORIZONTE', value: '10035' },
  { text: 'ESCUELA PARTICULAR PDTE. ABRAHAM LINCOLN', value: '10036' },
  { text: 'COLEGIO SAINT MARK', value: '10041' },
  { text: 'ESCUELA PARTICULAR SAGRADA FAMILIA', value: '10046' },
  { text: 'LICEO POLITECNICO SAN FRANCISCO SOLANO', value: '10052' },
  { text: 'ESCUELA DIFERENCIAL LOS LIRIOS', value: '10056' },
  { text: 'ESCUELA INDUSTRIAL SIMON BOLIVAR', value: '10059' },
  { text: 'ESCUELA PARTICULAR CARMEN CHACON', value: '10063' },
  { text: 'ESCUELA PARTICULAR MARIA CRISTINA', value: '10064' },
  { text: 'COLEGIO MARQUEL', value: '10069' },
  { text: 'LICEO INDUSTRIAL VICENTE PEREZ ROSALES', value: '10073' },
  { text: 'ESCUELA ALIANZA', value: '10074' },
  { text: 'LICEO MUN. CENTRO EDUCACIONAL PUDAHUEL', value: '10077' },
  { text: 'ESCUELA TENIENTE HERNAN MERINO CORREA', value: '10080' },
  { text: 'ESCUELA ESTRELLA DE CHILE', value: '10081' },
  { text: 'ESCUELA PRESIDENTE ROOSEVELT', value: '10083' },
  { text: 'ESCUELA ESTADO DE FLORIDA', value: '10085' },
  { text: 'ESCUELA REPUBLICA DE ITALIA', value: '10086' },
  { text: 'ESCUELA REPUBLICA DE CROACIA', value: '10087' },
  { text: 'ESCUELA HERMINDA DE LA VICTORIA', value: '10088' },
  { text: 'ESCUELA JAIME GOMEZ GARCIA', value: '10089' },
  { text: 'ESCUELA ALEXANDER GRAHAM BELL', value: '10090' },
  { text: 'ESCUELA PROFESORA GLADYS VALENZUELA V', value: '10091' },
  { text: 'ESCUELA GOLDA MEIR', value: '10092' },
  { text: 'ESCUELA MILLAHUE', value: '10093' },
  { text: 'ESCUELA IGNACIO CARRERA PINTO', value: '10095' },
  { text: 'ESCUELA MARISCAL DE AYACUCHO', value: '10097' },
  { text: 'ESCUELA PROVINCIA DE ARAUCO', value: '10098' },
  { text: 'ESCUELA GENERAL RENE ESCAURIAZA', value: '10099' },
  { text: 'ESCUELA EL SALITRE', value: '10100' },
  { text: 'ESCUELA ALBERT EINSTEIN', value: '10102' },
  { text: 'ESCUELA SOR TERESA DE LOS ANDES', value: '10103' },
  { text: 'ESCUELA MONSENOR CARLOS OVIEDO', value: '10104' },
  { text: 'ESCUELA FEDERICO ACEVEDO SALAZAR', value: '10105' },
  { text: 'ESCUELA POETA PABLO NERUDA', value: '10106' },
  { text: 'ESCUELA BASICA PAULO FREIRE', value: '10107' },
  { text: 'ESCUELA LEONARDO DA VINCI', value: '10108' },
  { text: 'ESCUELA DOCTOR TREVISO GIRARDI TONELLI', value: '10109' },
  { text: 'ESCUELA SANTANDER DE ESPANA', value: '10112' },
  { text: 'ESCUELA ELVIRA SANTA CRUZ OSSA', value: '10113' },
  { text: 'ESCUELA REPUBLICA DE ESTADOS UNIDOS', value: '10114' },
  { text: 'COLEGIO NEPTUNO', value: '10116' },
  { text: 'ESCUELA MARIA LUISA BOMBAL', value: '10117' },
  { text: 'ESCUELA POETA VICENTE HUIDOBRO', value: '10119' },
  { text: 'LICEO DE ADULTOS ALBERTO GALLEGUILLOS J.', value: '10120' },
  { text: 'ESCUELA CIUDAD SANTO DOMINGO DE GUZMAN', value: '10121' },
  { text: 'ESCUELA PROF. MANUEL GUERRERO CEBALLOS', value: '10122' },
  { text: 'ESCUELA BASICA MELVIN JONES', value: '10123' },
  { text: 'ESCUELA SAN DANIEL', value: '10124' },
  { text: 'ESCUELA SARGENTO CANDELARIA', value: '10125' },
  { text: 'COMPLEJO EDUCACIONAL CERRO NAVIA', value: '10126' },
  { text: 'ESC.DE EDUCACION DIFERENCIAL QUILLAHUE', value: '10127' },
  { text: 'ESCUELA CENTRO EDUC.INTEGRAL DE ADULTOS', value: '10128' },
  { text: 'LICEO CIUDAD DE BRASILIA', value: '10130' },
  { text: 'ESCUELA LIPANGUE', value: '10133' },
  { text: 'ESC.COMODORO ARTURO MERINO BENITEZ', value: '10134' },
  { text: 'ESCUELA LO BOZA', value: '10135' },
  { text: 'ESCUELA PARTICULAR HELEN RACHELS SCHOOL', value: '10139' },
  { text: 'ESCUELA PARTICULAR FRINGS COLLEGE', value: '10140' },
  { text: 'ESCUELA PARTICULAR DRA.VICTORIA GARCIA', value: '10142' },
  { text: 'ESCUELA PARTICULAR ESPANA', value: '10143' },
  { text: 'ESCUELA PARTICULAR BABILONIA', value: '10147' },
  { text: 'ESCUELA PARTICULAR RAPA NUI', value: '10149' },
  { text: 'ESCUELA PARTICULAR JOSE MIGUEL CARRERA', value: '10150' },
  { text: 'COLEGIO CRISTIAN AND CAREN SCHOOL', value: '10151' },
  { text: 'ESCUELA PARTICULAR ANDANTINO', value: '10152' },
  { text: 'ESCUELA CHARLES SCHOOL-DIURNA', value: '10155' },
  { text: 'ESCUELA JARDIN LO PRADO', value: '10156' },
  { text: 'LICEO SAN PABLO', value: '10157' },
  { text: 'ESCUELA BASICA  MOLOKAI', value: '10158' },
  { text: 'ESCUELA PARTICULAR ROBERT KENNEDY', value: '10159' },
  { text: 'ESCUELA BAS. COLEGIO BAU', value: '10160' },
  { text: 'ESCUELA PARTICULAR SAN FRANCISCO JAVIER', value: '10164' },
  { text: 'ESC. BAS. SANTA BEATRIZ', value: '10167' },
  { text: 'ESCUELA PARTICULAR SAN VICENTE FERRER', value: '10168' },
  { text: 'ESCUELA PARTICULAR VILLA LOURDES', value: '10171' },
  { text: 'ESC BAS PART CENTRO EDUCACIONAL SN PABLO', value: '10172' },
  { text: 'ESCUELA PART. SUNS SCHOOL', value: '10173' },
  { text: 'ESCUELA PARTICULAR ESPECIAL RENACER', value: '10176' },
  { text: 'ESCUELA INDUSTRIAL PUDAHUEL', value: '10181' },
  { text: 'COLEGIO PARTICULAR ED.ELENA CONTRERAS', value: '10182' },
  { text: 'ESCUELA PARTICULAR CARLOS PEZOA VELIZ', value: '10183' },
  { text: 'ESCUELA PARTICULAR LA FRONTERA', value: '10186' },
  { text: 'ESCUELA PARTICULAR MADRE A.EUGENIA', value: '10187' },
  { text: 'ESCUELA PARTICULAR LA CIUDAD EDUCATIVA', value: '10191' },
  { text: 'COLEGIO POLIV. SAINT ORLAND N 3', value: '10193' },
  { text: 'ESCUELA DE PARVULOS PINOCHO', value: '10195' },
  { text: 'ESCUELA JUANA DE LESTONAC', value: '10197' },
  { text: 'ESCUELA BASICA ISABEL LE BRUN', value: '10200' },
  { text: 'ESCUELA THOMAS ALVA EDISON', value: '10201' },
  { text: 'ESCUELA DOMINGO SANTA MARIA GONZALEZ', value: '10202' },
  { text: 'LICEO MUNICIPAL FRANCISCO INFANTE ABBOT', value: '10203' },
  { text: 'ESCUELA CAPITAN JOSE LUIS ARANEDA', value: '10204' },
  { text: 'ESCUELA GENERAL MANUEL BULNES PRIETO', value: '10205' },
  { text: 'ESCUELA REBECA MATTE BELLO', value: '10207' },
  { text: 'ESCUELA GENERAL ALEJANDRO GOROSTIAGA O', value: '10210' },
  { text: 'ESCUELA BASICA CORBETA ESMERALDA', value: '10211' },
  { text: 'ESCUELA JUANA ATALA DE HIRMAS', value: '10212' },
  { text: 'ESC. BASICA MONSERRAT ROBERT DE GARCIA', value: '10216' },
  { text: 'COLEGIO PARTICULAR HELENICO', value: '10217' },
  { text: 'COLEGIO CORAZON DE JESUS DE RENCA', value: '10219' },
  { text: 'COLEGIO PARTICULAR CHARLES DARWIN', value: '10221' },
  { text: 'ESCUELA PARTICULAR ARTURO TORO AMOR', value: '10224' },
  { text: 'ESCUELA PARTIC. COLEGIO BALMACEDA-RENCA', value: '10225' },
  { text: 'ESCUELA PARTICULAR SAN GENARO', value: '10226' },
  { text: 'ESCUELA PARTICULAR PRIMITIVA ECHEVERRIA', value: '10228' },
  { text: 'ESCUELA PARTICULAR JOSE BERNARDO SUAREZ', value: '10229' },
  { text: 'COLEG. POLIV. SANTA MARIA DE LA PROVIDENCIA', value: '10232' },
  { text: 'ESCUELA PARTICULAR SAN FIDEL', value: '10233' },
  { text: 'ESCUELA ESPECIAL PARTICULAR ESPERANZA', value: '10234' },
  { text: 'ESCUELA PARTICULAR JARDIN LOS ACACIOS', value: '10235' },
  { text: 'ESCUELA BASICA SAN NICOLAS', value: '10237' },
  { text: 'ESCUELA ESTADO DE MICHIGAN', value: '10239' },
  { text: 'ESCUELA LUIS CRUZ MARTINEZ', value: '10240' },
  { text: 'ESCUELA BASICA EL MANIO', value: '10241' },
  { text: 'ESCUELA PARTICULAR CANADA', value: '10245' },
  { text: 'ESCUELA BASICA PART PAULA JARAQUEMADA', value: '10247' },
  { text: 'LICEO COMERCIAL NORA VIVIANS MOLINA', value: '10248' },
  { text: 'LICEO POETA FEDERICO GARCIA LORCA', value: '10251' },
  { text: 'LICEO ARTURO PEREZ CANTO', value: '10252' },
  { text: 'LICEO POLIV. ABDON CIFUENTES', value: '10253' },
  { text: 'CENTRO EDUCACIONAL JOSE MIGUEL CARRERA', value: '10254' },
  { text: 'COMPLEJO EDUCACIONAL JUANITA FERNANDEZ SOLAR', value: '10255' },
  { text: 'ESCUELA SARGENTO 2. DANIEL REBOLLEDO', value: '10257' },
  { text: 'LICEO AGUSTIN EDWARDS', value: '10259' },
  { text: 'ESCUELA UNESCO', value: '10260' },
  { text: 'ESCUELA ESPANA', value: '10262' },
  { text: 'ESCUELA D-114', value: '10263' },
  { text: 'ESCUELA SOL NACIENTE', value: '10264' },
  { text: 'ESCUELA HORACIO JOHNSON GANA', value: '10265' },
  { text: 'ESCUELA DRA.ELOISA DIAZ INSUNZA', value: '10266' },
  { text: 'ESCUELA ESCRITORA MARCELA PAZ', value: '10267' },
  { text: 'ESCUELA PUERTO RICO', value: '10268' },
  { text: 'LICEO MUNC.ALMIRANTE GALVARINO RIVEROS', value: '10269' },
  { text: 'CENTRO EDUC.ESCRITORES DE CHILE', value: '10270' },
  { text: 'ESCUELA ARAUCARIAS DE CHILE', value: '10271' },
  { text: 'ESCUELA BASICA CARLOS PRATS G.', value: '10272' },
  { text: 'ESCUELA VALLE DEL INCA', value: '10273' },
  { text: 'ESCUELA ADELAIDA LA FETRA', value: '10277' },
  { text: 'ESCUELA PEDRO AGUIRRE CERDA', value: '10278' },
  { text: 'ESCUELA ALLIPEN', value: '10279' },
  { text: 'CENTRO EDUC. POETA EUSEBIO LILLO', value: '10280' },
  { text: 'ESCUELA ATENEA', value: '10281' },
  { text: 'ESCUELA LUIS GALDAMES', value: '10282' },
  { text: 'ESCUELA AVIADOR DAGOBERTO GODOY F.', value: '10283' },
  { text: 'ESCUELA SANTA VICTORIA DE HUECHURABA', value: '10285' },
  { text: 'ESCUELA BASICA LIKAN-ANTAI', value: '10288' },
  { text: 'ESCUELA LAS CANTERAS', value: '10290' },
  { text: 'ESCUELA VICTOR CUCCUINI', value: '10291' },
  { text: 'ESCUELA ESP. HUMBERTO ARANDA IRRIBARREN', value: '10293' },
  { text: 'ESCUELA MARTA COLVIN', value: '10300' },
  { text: 'ESCUELA CAMILO HENRIQUEZ', value: '10301' },
  { text: 'ESCUELA ANNE ELEONOR ROOSEVELT', value: '10302' },
  { text: 'ESCUELA SANTIAGO DE GUAYAQUIL', value: '10305' },
  { text: 'ESCUELA MUN.HERMANA MARIA GORETTI', value: '10306' },
  { text: 'ESCUELA RAFAEL VALDIVIESO', value: '10307' },
  { text: 'ESCUELA EDUC.DIF. STA. TERESA DE AVILA', value: '10309' },
  { text: 'LICEO PDTE.ARTURO ALESSANDRI-DIURNO', value: '10312' },
  { text: 'LICEO LAS AMERICAS MODERNAS', value: '10321' },
  {
    text: 'ESCUELA B\u00c3\u0081SICA JOS\u00c3\u2030 ABELARDO NU\u00c3\u2018EZ N\u00c2\u00ba 3',
    value: '10324',
  },
  { text: 'ESCUELA PARTICULAR SAN JOSE', value: '10326' },
  { text: 'ESCUELA PARTICULAR SANTA TERESITA', value: '10327' },
  { text: 'COLEGIO ISABEL RIQUELME', value: '10331' },
  { text: 'ESCUELA PARTICULAR EL CARMEN', value: '10332' },
  { text: 'ESCUELA PARTICULAR N.SRA.DE GUADALUPE', value: '10333' },
  { text: 'ESCUELA PATROCINIO EL SEMBRADOR N 2', value: '10334' },
  { text: 'ESCUELA SAN JORGE', value: '10335' },
  { text: 'ESCUELA PARTICULAR SAN DIEGO', value: '10336' },
  { text: 'ESCUELA PARTICULAR MATER DOLOROSA', value: '10337' },
  { text: 'ESCUELA BASICA SANTO DOMINGO', value: '10338' },
  { text: 'ESCUELA PARTICULAR MANUEL RODRIGUEZ', value: '10340' },
  { text: 'ESCUELA BASICA PART. THE LITTLE SCHOOL', value: '10341' },
  { text: 'ESCUELA PARTICULAR FRANCISCO BILBAO', value: '10345' },
  { text: 'ESCUELA BASICA INES DE SUAREZ', value: '10346' },
  { text: 'ESCUELA BASICA PART.MARY ANNE SCHOOL', value: '10348' },
  { text: 'ESCUELA PARTICULAR PARQUE ASUNCION', value: '10351' },
  { text: 'ESC.BASICA PART. NUEVA AURORA DE CHILE', value: '10352' },
  { text: 'ESCUELA ESPECIAL PARTICULAR LA PIRAMIDE', value: '10353' },
  { text: 'COLEGIO PARTICULAR JUAN PABLO', value: '10355' },
  { text: 'ESCUELA PART. SANTA LUISA DE MARILLAC', value: '10359' },
  { text: 'ESCUELA PARTICULAR ZOLTAN DIENES', value: '10361' },
  { text: 'ESCUELA PARTICULAR HNAS.AGAZZI', value: '10362' },
  { text: 'ESCUELA PARTICULAR JAIME EYZAGUIRRE', value: '10363' },
  { text: 'ESCUELA BASICA N 953 JOSE ARTIGAS', value: '10364' },
  { text: 'ESCUELA BAS. ISABEL GONZALEZ CARES', value: '10365' },
  { text: 'ESCUELA PARTICULAR ANDRES ALBERTO', value: '10371' },
  { text: 'ESCUELA PARTICULAR ISLA DE PASCUA', value: '10372' },
  { text: 'ESCUELA PARTICULAR RUTH', value: '10375' },
  { text: 'ESC. PART. UNION LATINOAMERICANA', value: '10376' },
  { text: 'LICEO POLIVALENTE SAINT ANDREWS', value: '10377' },
  { text: 'ESCUELA BASICA PART.BRIGIDA WALKER', value: '10384' },
  { text: 'ESCUELA PART. ADVENTISTA SANTIAGO NORTE', value: '10385' },
  { text: 'ESCUELA ESPECIAL BELLA ESPERANZA', value: '10386' },
  { text: 'LICEO POLIVALENTE RAFAEL DONOSO CARRASCO', value: '10396' },
  { text: 'LICEO INDUSTRIAL DE RECOLETA', value: '10397' },
  { text: 'LICEO REBECA OLIVARES BENITEZ', value: '10398' },
  { text: 'LICEO POLIVALENTE RIGOBERTO FONTT I.', value: '10399' },
  { text: 'ESCUELA BASICA MARCOS GOOYCOLEA CORTES', value: '10400' },
  { text: 'ESCUELA BASICA SANTA TERESA DEL CARMELO', value: '10401' },
  { text: 'ESCUELA ESPECIAL ERNESTO SOTO NEGRETE', value: '10402' },
  { text: 'ESCUELA PREMIO NOBEL PABLO NERUDA', value: '10403' },
  { text: 'ANDALIEN DE COLINA', value: '10404' },
  { text: 'LICEO ESMERALDA', value: '10405' },
  { text: 'ESCUELA BASICA ALGARROBAL', value: '10407' },
  { text: 'ESC.BASICA CORONEL ENRIQUE CABRERA J.', value: '10408' },
  { text: 'ESC.BASICA FRANCISCO PETRINOVIC KARLOVAC', value: '10409' },
  { text: 'ESCUELA BASICA SAN VICENTE DE LO ARCAYA', value: '10410' },
  { text: 'ESCUELA BASICA SANTA MARTA DE LIRAY', value: '10411' },
  { text: 'ESCUELA SAN FRANCISCO DE ASIS', value: '10412' },
  { text: 'ESCUELA PARTICULAR PAPELUCHO', value: '10413' },
  { text: 'ESCUELA PARTICULAR DESIREE', value: '10415' },
  { text: 'CENTRO DE TRATAMIENTO INTEGRAL LOS LAURELES', value: '10416' },
  { text: 'ESCUELA PARTICULAR JUAN CALVINO', value: '10418' },
  { text: 'COMPLEJO EDUCACIONAL DE LAMPA', value: '10419' },
  { text: 'ESCUELA MANUEL SEGOVIA MONTENEGRO', value: '10420' },
  { text: 'ESCUELA REPUBLICA DE POLONIA', value: '10421' },
  { text: 'ESCUELA BASICA CACIQUE COLIN', value: '10422' },
  { text: 'ESCUELA SANTA  BARBARA', value: '10424' },
  { text: 'ESCUELA POLONIA GUTIERREZ C.', value: '10425' },
  { text: 'ESCUELA SANTA ROSA DE LAMPA', value: '10426' },
  { text: 'ESCUELA SANTA SARA', value: '10427' },
  { text: 'ESCUELA EL LUCERO', value: '10428' },
  { text: 'ESCUELA SOL DE SEPTIEMBRE', value: '10429' },
  { text: 'ESCUELA BASICA SAN SEBASTIAN DE BATUCO', value: '10430' },
  { text: 'ESC. ESPECIAL PADRE LUIS GUANELLA', value: '10431' },
  { text: 'LICEO POLIVALENTE MANUEL RODRIGUEZ', value: '10432' },
  { text: 'LICEO HUERTOS FAMILIARES', value: '10433' },
  { text: 'ESCUELA RUNGUE', value: '10435' },
  { text: 'ESCUELA SANTA MATILDE', value: '10436' },
  { text: 'ESCUELA HUECHUN', value: '10439' },
  { text: 'ESCUELA CAPILLA DE CALEU', value: '10441' },
  { text: 'ESCUELA EL LLANO DE CALEU', value: '10442' },
  { text: 'ESCUELA BASICA MONTENEGRO', value: '10443' },
  { text: 'ESCUELA PLAZUELA DE POLPAICO', value: '10444' },
  { text: 'ESCUELA PARTICULAR LA MERCED', value: '10447' },
  { text: 'ESCUELA CAMINO DE LUZ', value: '10449' },
  { text: 'LICEO IND. MUNICIPALIZADO A N_ 116', value: '10453' },
  { text: 'LICEO SAN GERONIMO', value: '10455' },
  { text: 'COLEGIO MAIPO', value: '10457' },
  { text: 'ESCUELA VILLA INDEPENDENCIA', value: '10458' },
  { text: 'ESCUELA REPUBLICA DE GRECIA', value: '10459' },
  { text: 'CENTRO EDUCACIONAL NUEVA CREACION', value: '10460' },
  { text: 'ESCUELA LOS ANDES', value: '10461' },
  { text: 'ESCUELA NONATO COO', value: '10462' },
  { text: 'ESCUELA VILLA PEDRO AGUIRRE CERDA', value: '10464' },
  { text: 'ESCUELA EJERCITO LIBERTADOR', value: '10465' },
  { text: 'LICEO MUNIC.ING.MILITAR JUAN MACKENA O.', value: '10470' },
  { text: 'ESCUELA CASAS VIEJAS', value: '10472' },
  { text: 'ESCUELA OSCAR BONILLA', value: '10473' },
  { text: 'ESCUELA LUIS MATTE LARRAIN', value: '10474' },
  { text: 'ESCUELA GABRIELA', value: '10475' },
  { text: 'ESCUELA LAS PALMAS', value: '10476' },
  { text: 'ESCUELA SAN LUIS GONZAGA', value: '10478' },
  { text: 'ESCUELA PIERRE VAYER', value: '10480' },
  { text: 'ESCUELA JAVIERA CARRERA', value: '10486' },
  { text: 'COLEGIO POLIVALENTE DOMINGO MATTE MESIAS', value: '10487' },
  { text: 'ESCUELA GENOVEVA MOLL BRIONES', value: '10488' },
  { text: 'ESCUELA EMANUEL', value: '10490' },
  { text: 'ESCUELA SANTA JOAQUINA DE VEDRUNA', value: '10491' },
  { text: 'COLEGIO CRISTIANO BELEN', value: '10492' },
  { text: 'ESC. PART. SAN ANDRES', value: '10495' },
  { text: 'ESC. PARTICULAR JOSEFINA GANA DE J.', value: '10497' },
  { text: 'COLEGIO POLIV. EL ALBORADA', value: '10500' },
  { text: 'COLEGIO POLIV. PROFESOR ILDEFONSO CALDERON', value: '10501' },
  { text: 'ESCUELA PARTICULAR MIGUEL CRUCHAGA T.', value: '10502' },
  { text: 'COLEGIO EDUC.PART. COMP.DE MARIA P. ALTO', value: '10503' },
  { text: 'ESCUELA BASICA LOS PINOS', value: '10509' },
  { text: 'ESCUELA DOMINGO FAUSTINO SARMIENTO', value: '10515' },
  { text: 'ESCUELA SANTA RITA', value: '10517' },
  { text: 'ESCUELA LO ARCAYA', value: '10519' },
  { text: 'LICEO  EL PRINCIPAL', value: '10520' },
  { text: 'ESCUELA SAN JUAN DE PIRQUE', value: '10522' },
  { text: 'ESCUELA LA PUNTILLA', value: '10524' },
  { text: 'ESCUELA JULIETA BECERRA ALVAREZ', value: '10527' },
  { text: 'ESCUELA EL CANELO', value: '10528' },
  { text: 'ESCUELA EL MELOCOTON', value: '10529' },
  { text: 'ESCUELA DE CONCENTRACION FRONTERIZA', value: '10530' },
  { text: 'ESCUELA FRONTERIZA', value: '10532' },
  { text: 'ESCUELA LA OBRA', value: '10534' },
  { text: 'ESCUELA BAS.Y ESP. INTEGRADORA EL MANZANO', value: '10536' },
  { text: 'ESCUELA 636 SAN ALFONSO', value: '10537' },
  { text: 'ESCUELA BASICA LAS MELOSAS', value: '10538' },
  { text: 'COLEGIO RAFAEL EYZAGUIRRE', value: '10540' },
  { text: 'CENTRO EDUCACIONAL BALDOMERO LILLO', value: '10542' },
  { text: 'LICEO POLIVALENTE A-127 FIDEL PINOCHET LE-BRUN', value: '10543' },
  { text: 'LICEO IND. MIGUEL AYLWIN GAJARDO', value: '10545' },
  { text: 'ESCUELA PILAR MOLINER DE NUEZ', value: '10546' },
  { text: 'ESCUELA REPUBLICA DEL BRASIL', value: '10547' },
  { text: 'ESCUELA ISABEL RIQUELME', value: '10548' },
  { text: 'ESCUELA L.GRAL. BERNARDO OHIGGINS', value: '10550' },
  { text: 'LICEO POLIV. LUCILA GODOY ALCAYAGA', value: '10551' },
  { text: 'ESCUELA MARCIAL MARTINEZ FERRARI', value: '10553' },
  { text: 'ESCUELA GENERAL RENE SCHNEIDER CHEREAU', value: '10554' },
  { text: 'ESCUELA BASICA BASE EL BOSQUE', value: '10555' },
  { text: 'ESCUELA ALEMANIA', value: '10556' },
  { text: 'ESCUELA GENERAL ALBERTO A. BACHELET MARTINEZ', value: '10557' },
  { text: 'ESCUELA REPUBLICA DE LOS EE.UU. DE AMERICA', value: '10558' },
  { text: 'ESCUELA BERNARDO LEIGHTON', value: '10559' },
  { text: 'ESCUELA JAVIERA CARRERA VERDUGO', value: '10560' },
  { text: 'ESCUELA CLAUDIO ARRAU LEON', value: '10561' },
  { text: 'ESCUELA MANUEL MAGALLANES MOURE', value: '10563' },
  { text: 'ESCUELA REPUBLICA DEL PERU', value: '10564' },
  { text: 'ESCUELA DIEGO PORTALES', value: '10565' },
  { text: 'ESCUELA MAHUIDA', value: '10567' },
  { text: 'ESCUELA ORLANDO LETELIER', value: '10568' },
  { text: 'LICEO NUEVO PORVENIR', value: '10569' },
  { text: 'ESCUELA BASICA DR LUIS SEPULVEDA SALVATI', value: '10570' },
  { text: 'ESCUELA ESCRITORA  MARCELA PAZ', value: '10571' },
  { text: 'LICEO FRAY LUIS BELTRAN', value: '10572' },
  { text: 'CENTRO EDUCACIONAL MATIAS COUSINO', value: '10573' },
  { text: 'ESCUELA ESPANA', value: '10574' },
  { text: 'ESCUELA IGNACIO CARRERA PINTO', value: '10576' },
  { text: 'ESCUELA DE EDUCACION DIFERENCIAL', value: '10577' },
  { text: 'ESCUELA STA. TERESA DE LOS MORROS', value: '10578' },
  { text: 'ESCUELA JOSE NUEZ MARTIN', value: '10579' },
  { text: 'ESCUELA ABRAHAM LINCOLN', value: '10580' },
  { text: 'ESCUELA BASICA ANTUPILLAN', value: '10581' },
  { text: 'LICEO DE ADULTOS PUCARA DE CHENA', value: '10584' },
  { text: 'ESCUELA ELEODORO YANEZ PONCE DE LEON', value: '10586' },
  { text: 'ESCUELA CARDENAL ANTONIO SAMORE', value: '10588' },
  { text: 'ESCUELA HARAS LOS CONDORES', value: '10589' },
  { text: 'ESCUELA TERESA GARCIA HUIDOBRO', value: '10590' },
  { text: 'ESC.BASICA PART.COLEGIO SAINT ARIELI', value: '10594' },
  { text: 'ESCUELA BASICA PARTICULAR ROBERTO LORCA', value: '10595' },
  {
    text: 'ESC. BAS. PART.N\u00c2\u00a649 STA. TERESA DE LOS ANDES',
    value: '10596',
  },
  { text: 'ESCUELA PARTICULAR CRISTO REY', value: '10599' },
  { text: 'ESCUELA PARTICULAR SAN BERNARDO', value: '10601' },
  { text: 'COLEGIO VILLA SANTA MARIA', value: '10604' },
  { text: 'COLEGIO GETSEMANI', value: '10606' },
  { text: 'COLEGIO PARTICULAR SANTA LUCIA', value: '10607' },
  { text: 'COLEGIO SAN JOSE', value: '10610' },
  { text: 'ESCUELA PARTICULAR JOSE MIGUEL CARRERA', value: '10619' },
  {
    text: 'CENTRO EDUCACIONAL JOS\u00c3\u2030 ABELARDO N\u00c3\u0161\u00c3\u2018EZ N\u00c2\u00b01',
    value: '10621',
  },
  { text: 'ESCUELA PARTICULAR MARVIT SCHOOL', value: '10622' },
  { text: 'ESCUELA DIFERENCIAL JUAN SANDOVAL', value: '10623' },
  { text: 'ESCUELA PARTICULAR MARIA MEDIANERA', value: '10625' },
  { text: 'COLEGIO JUAN BAUTISTA DURAN', value: '10626' },
  { text: 'COLEGIO ARAGON', value: '10628' },
  { text: 'ESCUELA PARTICULAR EL BOSQUE', value: '10629' },
  { text: 'COLEGIO QUILLAHUE SAN BERNARDO', value: '10631' },
  { text: 'CENTRO EDUC. DENVER COLORADO SCHOOL', value: '10632' },
  { text: 'ESCUELA RAYEN MAPU', value: '10639' },
  { text: 'COLEGIO DE MAIPO', value: '10640' },
  { text: 'LICEO ALTO JAHUEL', value: '10641' },
  { text: 'LICEO POLIVALENTE LOS GUINDOS', value: '10642' },
  { text: 'ESCUELA VILLASECA', value: '10643' },
  { text: 'LICEO FRANCISCO JAVIER KRUGGER ALVARADO', value: '10645' },
  { text: 'ESCUELA VALDIVIA DE PAINE', value: '10646' },
  { text: 'ESCUELA LO SALINAS', value: '10648' },
  { text: 'ESCUELA HUMBERTO MORENO RAMIREZ', value: '10649' },
  { text: 'ESCUELA LOS ROSALES DEL BAJO', value: '10651' },
  { text: 'ESCUELA VILUCO', value: '10652' },
  { text: 'ESCUELA ESPECIAL DEFIC MENTAL CAMPOSANO', value: '10655' },
  { text: 'ESCUELA LOS AROMOS DE EL RECURSO', value: '10656' },
  { text: 'ESC. ESP. TALLERES PRE-VOCACIONALES DIFERENCI', value: '10659' },
  { text: 'ESCUELA HOGAR REHABILITACION DON ORIONE', value: '10660' },
  { text: 'CENTRO DE EDUC.ESPECIAL HNO.BERNARDO', value: '10661' },
  { text: 'ESCUELA PARTICULAR SAINT MARY', value: '10662' },
  { text: 'CENTRO EDUC. ENRIQUE BERNSTEIN CARABANTE', value: '10663' },
  { text: 'ESCUELA ALEMANIA', value: '10665' },
  { text: 'ESCUELA DE HOSPITAL', value: '10666' },
  { text: 'LICEO  MARIA CARVAJAL FUENZALIDA', value: '10667' },
  { text: 'ESCUELA ELIAS SANCHEZ ORTUZAR', value: '10668' },
  { text: 'ESCUELA  BARBARA KAST RIST', value: '10669' },
  { text: 'ESCUELA CARMEN REVECO NUNEZ', value: '10671' },
  { text: 'COLEGIO  CHALLAY', value: '10672' },
  { text: 'ESCUELA RICARDO SANCHEZ CERDA', value: '10673' },
  { text: 'ESCUELA SENDERO DE CULITRIN', value: '10674' },
  { text: 'ESCUELA  LAS COLONIAS', value: '10675' },
  { text: 'ESCUELA FRANCISCO LETELIER VALDES', value: '10676' },
  { text: 'ESCUELA  HUELQUEN', value: '10677' },
  { text: 'ESCUELA  AGUILA SUR', value: '10679' },
  { text: 'ESCUELA HUGO PINO VILCHEZ', value: '10680' },
  { text: 'LICEO MUNICIPAL POETISA GABRIELA MISTRAL', value: '10686' },
  { text: 'COLEGIO CALERA DE TANGO', value: '10687' },
  { text: 'COLEGIO  LONQUEN', value: '10688' },
  { text: 'ESCUELA EL ROTO CHILENO', value: '10689' },
  { text: 'ESCUELA PARTICULAR SAN IGNACIO', value: '10692' },
  { text: 'ESCUELA PRESIDENTE PRIETO', value: '10694' },
  { text: 'LICEO POLIVALENTE TALAGANTE', value: '10696' },
  { text: 'ESCUELA TALACANTA', value: '10698' },
  { text: 'ESCUELA REPUBLICA DE GRECIA', value: '10699' },
  { text: 'ESCUELA MANUEL RODRIGUEZ ERDOIZA', value: '10702' },
  { text: 'ESCUELA ESTRELLA DE BELEN', value: '10703' },
  { text: 'ESCUELA ALBORADA DE TALAGANTE', value: '10704' },
  { text: 'ESCUELA LUIS UNDURRAGA', value: '10705' },
  { text: 'ESCUELA EL PINO VIEJO DE LONQUEN', value: '10706' },
  { text: 'ESCUELA BAS. COLEGIO NACIONAL', value: '10712' },
  { text: 'INSTITUTO SUBTTE.LUIS CRUZ MARTINEZ', value: '10715' },
  { text: 'ESCUELA BAS. BARTOLOME BLUMENTHAL', value: '10716' },
  { text: 'ESCUELA TECNICA SANTA MARIA MICAELA', value: '10717' },
  { text: 'INSTITUTO TALAGANTE', value: '10719' },
  { text: 'COLEGIO TORREON', value: '10722' },
  { text: 'COLEGIO PARTICULAR INTEGRAL ARTURO PRAT', value: '10723' },
  { text: 'CENTRO DE EDUCACION GENERAL BASICA', value: '10726' },
  { text: 'ESCUELA BASICA EFRAIN MALDONADO TORRES', value: '10729' },
  { text: 'ESC.BASICA SAN ANTONIO DE NALTAGUA', value: '10730' },
  { text: 'LICEO POLIV. LUIS HUMBERTO ACOSTA GAY', value: '10735' },
  { text: 'ESCUELA REPUBLICA DEL ECUADOR', value: '10736' },
  { text: 'ESC. BASICA  JAVIERA CARRERA VERDUGO', value: '10737' },
  { text: 'ESCUELA REPUBLICA DE HONDURAS', value: '10738' },
  { text: 'ESCUELA CHINIGUE EL CRISTO', value: '10740' },
  { text: 'ESCUELA EL REMANSO', value: '10741' },
  { text: 'ESCUELA BAS. DIVINA PROVIDENCIA', value: '10742' },
  { text: 'INSTITUTO SAN FRANCISCO', value: '10743' },
  { text: 'ESCUELA BAS. COLEGIO EMELINA URRUTIA', value: '10744' },
  { text: 'LICEO MUNICIPALIZADO PENAFLOR', value: '10746' },
  { text: 'ESCUELA TERESA DE CALCUTA', value: '10747' },
  { text: 'ESCUELA EMILIA LASCAR', value: '10748' },
  { text: 'LICEO PAUL HARRIS', value: '10749' },
  { text: 'ESCUELA ROSALINA PESCIO VARGAS', value: '10750' },
  { text: 'ESCUELA REPUBLICA ARGENTINA', value: '10752' },
  { text: 'ESCUELA REPUBLICA CHECA', value: '10753' },
  { text: 'ESCUELA MAND EDUARDO FREI MONTALVA', value: '10754' },
  { text: 'ESCUELA DIFERENCIAL ALEGRIA DE VIVIR', value: '10755' },
  { text: 'ESCUELA SONIA PLAZA CASTRO', value: '10756' },
  { text: 'COLEGIO ALBERTO HURTADO CRUCHAGA', value: '10757' },
  { text: 'ESCUELA MALLOCO', value: '10758' },
  { text: 'ESCUELA REPUBLICA DE ISRAEL', value: '10760' },
  { text: 'ESCUELA CRISTAL CHILE', value: '10763' },
  { text: 'ESCUELA LA ESPERANZA', value: '10764' },
  { text: 'ESCUELA PELVIN SAN FRANCISCO DE ASIS', value: '10765' },
  { text: 'ESCUELA DOLORES CATTIN FAUNDEZ', value: '10766' },
  { text: 'ESCUELA BAS. PART. MALLOCO', value: '10767' },
  { text: 'ESCUELA PARTICULAR AUGUSTO DHALMAR', value: '10768' },
  { text: 'ESC.BASICA PART.BENJAMIN VERGARA', value: '10769' },
  { text: 'ESCUELA BAS. PART. COLEGIO CLAUDIO GAY', value: '10771' },
  { text: 'COMPLEJO EDUC.PART. LUIS PASTEUR', value: '10773' },
  { text: 'ESCUELA PARTICULAR EL REFUGIO', value: '10774' },
  { text: 'ESCUELA ESPECIAL DE MELIPILLA', value: '10778' },
  { text: 'LICEO POLITECNICO MUNICIPAL MELIPILLA', value: '10781' },
  { text: 'ESCUELA IGNACIO SERRANO MONTANER', value: '10782' },
  { text: 'LICEO GABRIELA MISTRAL DE MELIPILLA', value: '10783' },
  { text: 'COLEGIO HUILCO ALTO', value: '10784' },
  { text: 'COLEGIO MONS. JAIME LARRAIN BUNSTER', value: '10785' },
  { text: 'ESCUELA SAN JOSE DE LA VILLA', value: '10786' },
  { text: 'ESCUELA GRAL. CAROL URZUA', value: '10789' },
  { text: 'ESCUELA REPUBLICA DEL BRASIL', value: '10790' },
  { text: 'COLEGIO POMAIRE', value: '10791' },
  { text: 'LICEO POLIV. EL BOLLENAR', value: '10792' },
  { text: 'ESCUELA SANTA ROSA ESMERALDA', value: '10794' },
  { text: 'ESCUELA CLAUDIO ARRAU', value: '10795' },
  { text: 'ESCUELA PATRICIO LARRAIN GANDARILLAS', value: '10796' },
  { text: 'ESCUELA PEDRO MARIN ALEMANY', value: '10797' },
  { text: 'ESCUELA BASICA CARMEN BAJO', value: '10798' },
  { text: 'ESCUELA RAMON NOGUERA PRIETO', value: '10799' },
  { text: 'ESCUELA CHOLQUI', value: '10800' },
  { text: 'ESCUELA PUANGUE', value: '10805' },
  { text: 'ESCUELA LIDIA MATTE HURTADO', value: '10810' },
  { text: 'ESCUELA JOSE CAMARENA ESCRIVA', value: '10816' },
  { text: 'ESCUELA HUECHUN', value: '10818' },
  { text: 'ESCUELA RAQUEL FERNANDEZ DE MORANDE', value: '10821' },
  { text: 'ESCUELA PADRE ALBERTO HURTADO', value: '10825' },
  { text: 'ESCUELA BASICA EL PABELLON', value: '10827' },
  {
    text: 'ESC. BAS. NUESTRA SE\u00c3\u2018ORA Y MADRE DEL CARMEN',
    value: '10829',
  },
  { text: 'CENTRO EDUCACIONAL MENESIANO', value: '10833' },
  { text: 'COLEGIO MARAMBIO', value: '10834' },
  { text: 'ESCUELA MARIA PINTO', value: '10835' },
  { text: 'ESCUELA CHOROMBO ALTO', value: '10836' },
  { text: 'ESCUELA LOS RULOS', value: '10837' },
  { text: 'ESCUELA CHOROMBO BAJO', value: '10838' },
  { text: 'ESCUELA LAS MERCEDES', value: '10839' },
  { text: 'ESCUELA SANTA EMILIA', value: '10840' },
  { text: 'ESCUELA BASICA VALLE DE PUANGUE', value: '10842' },
  { text: 'ESCUELA SAN JOSE OBRERO DE CURACAVI', value: '10844' },
  { text: 'ESCUELA FERNANDO CARVAJAL PINTO', value: '10846' },
  { text: 'ESCUELA ELIECER PEREZ VARGAS', value: '10848' },
  { text: 'ESCUELA HERIBERTO ERLWEIN  S.', value: '10849' },
  { text: 'ESCUELA PARTICULAR INSTITUTO SN.LUIS', value: '10851' },
  { text: 'ESCUELA BAS. NTRA. SRA. DE LA GUARDIA', value: '10852' },
  { text: 'LICEO MUNICIPAL DE SAN PEDRO', value: '10854' },
  { text: 'ESCUELA LOICA ARRIBA', value: '10856' },
  { text: 'ESCUELA LOICA ABAJO', value: '10858' },
  { text: 'ESCUELA EL PRADO', value: '10861' },
  { text: 'ESCUELA LLANCAY', value: '10862' },
  { text: 'ESCUELA NIHUE BAJO', value: '10864' },
  { text: 'ESCUELA ENRIQUE REYMOND ALDUNATE', value: '10865' },
  { text: 'ESCUELA LO ENCANADO', value: '10868' },
  { text: 'ESCUELA CORNECHE', value: '10869' },
  { text: 'ESCUELA LA MANGA', value: '10870' },
  { text: 'ESCUELA STA. ROSA LOTESORE', value: '10871' },
  { text: 'LICEO MUNICIPAL SARA TRONCOSO TRONCOSO', value: '10873' },
  { text: 'ESCUELA EL ASIENTO', value: '10877' },
  { text: 'ESCUELA BARRANCAS DE PICHI', value: '10878' },
  { text: 'ESCUELA SAN ALFONSO', value: '10879' },
  { text: 'ESCUELA HACIENDA ALHUE', value: '10880' },
  { text: 'COLEGIO SAN SEBASTIAN', value: '10881' },
  { text: 'ESC. EDUCACION ESPECIAL LOS IBISCOS', value: '10884' },
  { text: 'ESCUELA DE CHITITA', value: '10887' },
  { text: 'CENTRO TRAT. INTEG. LOS TAMARUGOS', value: '10889' },
  { text: 'ESCUELA EJERCITO DE SALVACION', value: '10893' },
  { text: 'ESCUELA DE ILLAPATA', value: '10897' },
  { text: 'JARDIN INFANTIL ACUARELA', value: '10898' },
  { text: 'COL. SAINT MARGARETH ROSE GARDEN', value: '10901' },
  { text: 'ESCUELA BASICA FUERTE BAQUEDANO', value: '10905' },
  { text: 'LICEO PABLO NERUDA', value: '10911' },
  { text: 'ESCUELA VALLE DE PARCOHAYLLA', value: '10912' },
  { text: 'CENTRO CAP.LAB. REINO DE BELGICA', value: '10913' },
  { text: 'ANEXO ESCUELA MANUEL CASTRO RAMOS', value: '10916' },
  { text: 'LICEO S.S JUAN PABLO SEGUNDO', value: '10917' },
  { text: 'ESCUELA DIFERENCIAL SANTA CECILIA', value: '10956' },
  {
    text: 'COLEGIO EVANGELICO EJERCITO DE SALVACION CATHERINE BOOTH',
    value: '10963',
  },
  { text: 'LICEO ELEUTERIO RAMIREZ MOLINA', value: '10967' },
  { text: 'LICEO MAYOR GRAL.(E) OSCAR BONILLA', value: '10968' },
  { text: 'ANEXO LICEO NOCTURNO', value: '10971' },
  { text: 'CENTRO DE CAPACITACION LABORAL ESPERANZA', value: '10973' },
  { text: 'ESCUELA EDUCACION DIFERENCIAL NUEVA LUZ', value: '10974' },
  { text: 'ESCUELA DE PARVULOS SAINT PATRICK S SCH.', value: '10975' },
  { text: 'ESC. PARVULOS PRESBITERIANA EL REDENTOR', value: '10976' },
  { text: 'LICEO A.RENDIC I ANEXO CENTRO PREVENCION FEM', value: '10979' },
  { text: 'ESCUELA FRONTERIZA', value: '11025' },
  { text: 'ESCUELA HORNITOS', value: '11027' },
  { text: 'ESCUELA PADRE LUIS S. SOTO NU\u00c3\u0090EZ', value: '11029' },
  { text: 'ESCUELA ANDRES BELLO', value: '11030' },
  { text: 'SARA CRUZ ALVAYAY', value: '11031' },
  { text: 'ESCUELA CRISTIANA BASICA BETHEL', value: '11032' },
  { text: 'ESCUELA BASICA ANGELINA SALAS OLIVARES', value: '11033' },
  { text: 'LICEO JORGE ALESSANDRI RODRIGUEZ', value: '11034' },
  { text: 'COLEGIO AMBROSIO O HIGGINS', value: '11035' },
  { text: 'ESCUELA JOSE JOAQUIN VALLEJOS', value: '11036' },
  { text: 'LICEO GENERAL RAMON FREIRE', value: '11038' },
  { text: 'CENTRO DE EST Y DES INTEGRAL DEL NINO', value: '11098' },
  { text: 'COLEGIO CONDORIACO', value: '11100' },
  { text: 'ESCUELA MANUEL MAGALLANES MOURE', value: '11102' },
  { text: 'COLEGIO LOS CARRERA', value: '11103' },
  { text: 'COLEGIO PARTICULAR MIGUEL DE CERVANTES', value: '11105' },
  { text: 'LICEO JORGE IRIBARREN CHARLIN DE HURTADO', value: '11110' },
  { text: 'LICEO ALBERTO GALLARDO LORCA', value: '11111' },
  { text: 'BASICA COMUN DELIA ANDRADE DE TELLO', value: '11113' },
  { text: 'COLEGIO NUEVO MUNDO', value: '11114' },
  { text: 'JARDIN INFANTIL EL SOLDADITO', value: '11117' },
  { text: 'JARDIN INFANTIL DEL HOSPITAL DE COQUIMBO', value: '11122' },
  { text: 'JARDIN INFANTIL TO\u00c3\u2018ITO', value: '11127' },
  { text: 'COLEGIO SAN IGNACIO DE LOYOLA', value: '11130' },
  { text: 'COLEGIO PARTICULAR SAN GABRIEL', value: '11133' },
  { text: 'ESCUELA PADRE ALBERTO HURTADO CRUCHAGA', value: '11136' },
  { text: 'JARDIN INFANTIL PILLIN', value: '11138' },
  { text: 'LICEO FERNANDO BINVIGNAT MARIN', value: '11139' },
  { text: 'ESCUELA DIEGO DE ALMEYDA', value: '11144' },
  { text: 'COLEGIO PARTICULAR CALASANZ', value: '11145' },
  { text: 'COLEGIO MANANTIAL', value: '11147' },
  { text: 'ESCUELA BASICA LA PUNTILLA NORTE', value: '11148' },
  { text: 'ESCUELA LA PARRITA', value: '11153' },
  { text: 'ESCUELA BASICA EL TOTORAL', value: '11154' },
  { text: 'LICEO JORGE ALESSANDRI RODRIGUEZ', value: '11155' },
  { text: 'CENTRO DE DETENCION PREVENTIVA', value: '11156' },
  { text: 'COLEGIO PARROQUIAL SAN NICOLAS', value: '11177' },
  { text: 'CENTRO EDUCACIONAL CENINES', value: '11178' },
  { text: 'ESC. DE PARVULOS LA PEQUE\u00c3\u2018A POLITA', value: '11180' },
  { text: 'COLEGIO ALEJANDRO GALAZ', value: '11187' },
  { text: 'ESCUELA PEDRO NOLASCO MOLINA', value: '11191' },
  { text: 'ESCUELA HUINCA', value: '11194' },
  { text: 'CTRO.REC.ATENC.DIVERS.CRAD PAUL PERCY HARRIS', value: '11196' },
  { text: 'ESCUELA SUPERIOR REP.DE VENEZUELA ANEXO', value: '11199' },
  { text: 'ESCUELA PADRE ALBERTO HURTADO', value: '11200' },
  { text: 'COLEGIO FRANCISCO BILBAO BARQUIN', value: '11201' },
  { text: 'COLEGIO PARTICULAR CLAUDIO GAY', value: '11203' },
  { text: 'CENTRO EDUC.ESPECIAL ANN SULLIVAN', value: '11205' },
  { text: 'ESCUELA MUNICIPAL LAS PUERTAS', value: '11206' },
  { text: 'COLEGIO GALILEO GALILEI', value: '11209' },
  { text: 'COL.ALONSO DE ERCILLA PRAT', value: '11214' },
  { text: 'COLEGIO SAINT THOMAS', value: '11217' },
  { text: 'COLEGIO LUIS GALDAMEZ', value: '11220' },
  { text: 'JARDIN INFANTIL PILLIN HOSP  SALVADOR', value: '11221' },
  { text: 'COLEGIO ITALIANO', value: '11223' },
  { text: 'COLEGIO PARTICULAR  BECARB', value: '11224' },
  { text: 'ESCUELA DE PARVULOS LAS ARDILLITAS', value: '11226' },
  { text: 'ESCUELA CARCEL', value: '11228' },
  { text: 'ESCUELA DE ADULTOS CARCEL', value: '11230' },
  { text: 'ESCUELA DE ADULTOS  (CARCEL)', value: '11231' },
  { text: 'ESCUELA JOS\u00c3\u2030 DOMINGO SAAVEDRA', value: '11234' },
  { text: 'ESCUELA DE PARVULOS LOS ALMENDROS', value: '11238' },
  { text: 'JOSEPH LISTER SCHOOL', value: '11241' },
  { text: 'COLEGIO EL COBRE DE LOS ANDES', value: '11242' },
  { text: 'COLEGIO MUNDO INFANTIL', value: '11244' },
  { text: 'COL.EDUC. ESPECIAL DR. ALBERT SCHWEITZER', value: '11245' },
  { text: 'LICEO ELISA ESCOBEDO LA PAZ', value: '11246' },
  { text: 'ESC. ADRIANA ARANGUIZ CERDA', value: '11248' },
  { text: 'ESCUELA MUNICIPAL DE COLHUE', value: '11257' },
  { text: 'ESCUELA DIGNA CAMILO', value: '11261' },
  { text: 'CENTRO PARVULARIO DE CHIMBARONGO', value: '11263' },
  { text: 'COLEGIO ENA BELLEMANS MONTTI', value: '11265' },
  { text: 'ESCUELA GABRIELA MISTRAL', value: '11277' },
  { text: 'ESCUELA ANGEL MARIA', value: '11279' },
  { text: 'ESCUELA CARDONAL PANILONCO', value: '11283' },
  { text: 'CENTRO DE EDUCACION DE ADULTOS', value: '11284' },
  { text: 'LICEO HERIBERTO SOTO SOTO', value: '11286' },
  { text: 'LICEO BERTA ZAMORANO LIZANA', value: '11287' },
  { text: 'ESCUELA DIFERENCIAL SANTA ADRIANA', value: '11318' },
  { text: 'ESCUELA REINO DE DINAMARCA', value: '11323' },
  { text: 'ESCUELA DIFERENCIAL SAN CLEMENTE', value: '11330' },
  { text: 'ESCUELA OSVALDO HIRIART CORVALAN', value: '11333' },
  { text: 'ESCUELA HUAPI ALTO', value: '11334' },
  { text: 'COLEGIO PARTICULAR NOBEL SCHOOL', value: '11336' },
  { text: 'CENTRO DE EDUCACION INTEGRADA DE ADULTOS', value: '11337' },
  { text: 'ESCUELA DIFERENCIAL ESPERANZA', value: '11338' },
  { text: 'ESCUELA SAN ANTONIO', value: '11339' },
  { text: 'ESCUELA CARLOS TRUPP WANNER', value: '11342' },
  { text: 'COLEGIO NUEVA HOLANDA', value: '11343' },
  { text: 'INST.EDUC. DE ADULTOS JAVIERA CARRERA', value: '11344' },
  { text: 'ESCUELA DE PARVULOS SAN CLEMENTE', value: '11347' },
  { text: 'COLEGIO DE MARIA', value: '11348' },
  { text: 'ESCUELA ESPECIAL BELLAVISTA', value: '11350' },
  { text: 'ESCUELA EL GUINDO', value: '11352' },
  {
    text: 'COLEGIO CREACI\u00c3\u201cN CICLO B\u00c3\u0081SICO',
    value: '11388',
  },
  { text: 'ESCUELA GABRIELA MISTRAL', value: '11394' },
  { text: 'ESCUELA BASICA LLOICURA', value: '11395' },
  { text: 'COLEGIO ADVENTISTA', value: '11397' },
  { text: 'ESCUELA MAULE', value: '11398' },
  { text: 'ESCUELA SAN ERNESTO', value: '11399' },
  { text: 'LICEO TRAPAQUEANTE', value: '11400' },
  { text: 'ESCUELA ESPECIAL CONSTITUCION', value: '11401' },
  { text: 'ESCUELA EUSEBIO LILLO', value: '11403' },
  { text: 'ESCUELA SAN LUIS', value: '11404' },
  { text: 'ESCUELA FERNANDO BAQUEDANO', value: '11405' },
  {
    text: 'ESC BASICA Y TECNOL. DIFERENCIAL LAURA VICU\u00c3\u2018A',
    value: '11406',
  },
  { text: 'ESCUELA BASICA LOS OLIVOS', value: '11407' },
  { text: 'ESCUELA PARTICULAR SANTA PILAR', value: '11408' },
  { text: 'ESCUELA MIGUEL DE CERVANTES', value: '11414' },
  { text: 'THE AUKLAND SCHOOL', value: '11415' },
  { text: 'ESCUELA LOS QUIQUES', value: '11418' },
  { text: 'ESCUELA COLICO BAJO', value: '11419' },
  { text: 'COLEGIO METODISTA LAGUNILLAS', value: '11420' },
  { text: 'ESC.BASICA MANTO BLANCO DE TRES MARIAS', value: '11422' },
  { text: 'ESCUELA CIFUENTES  BAJO', value: '11425' },
  { text: 'COLEGIO SANTA HILDA', value: '11429' },
  { text: 'COLEGIO TERESIANO PADRE ENRIQUE', value: '11430' },
  { text: 'ESCUELA DIFERENCIAL MARIA MONTESSORI', value: '11431' },
  { text: 'ESCUELA COLONIA RAYEN-LAFQUEN', value: '11462' },
  { text: 'COLEGIO LATINOAMERICANO', value: '11465' },
  { text: 'ESCUELA PARTICULAR VILCUN', value: '11467' },
  { text: 'ESCUELA PARTICULAR FOLILCO', value: '11471' },
  { text: 'ESCUELA ARAUCARIAS', value: '11472' },
  { text: 'ESCUELA PARTICULAR BASICA ILWEN', value: '11473' },
  { text: 'ESCUELA CARCEL LOS ALPES', value: '11497' },
  { text: 'COMPLEJO EDUCACIONAL PRINCIPE DE GALES', value: '11498' },
  { text: 'ESCUELA PARTICULAR AMADO NERVO', value: '11501' },
  { text: 'ESCUELA BASICA SAN SEBASTIAN DE MAQUEHUE', value: '11509' },
  { text: 'ESCUELA TROMEN MALLIN', value: '11511' },
  { text: 'ESCUELA ESPECIAL AYELEN', value: '11520' },
  { text: 'ESCUELAS  BASICA RENICO GRANDE', value: '11522' },
  { text: 'ESCUELA PARTICULAR HUALAPULLI', value: '11526' },
  { text: 'LICEO POLITECNICO METODISTA LA GRANJA', value: '11527' },
  { text: 'ESCUELA PARTICULAR SANTA ELENA', value: '11528' },
  { text: 'ESCUELA ESPECIAL LOS CANELOS', value: '11529' },
  { text: 'ESCUELA ESPEC.RETARDO MENTAL AMMILLAN', value: '11530' },
  { text: 'ESCUELA PARTICULAR LUIS ISRAEL', value: '11532' },
  { text: 'ESC. RURAL DGO. FAUSTINO SARMIENTO', value: '11539' },
  { text: 'ESCUELA PARTICULAR ALEPUE', value: '11540' },
  { text: 'ESCUELA PARTICULAR MELIQUINA', value: '11542' },
  { text: 'ESCUELA PARTICULAR TRIPAYANTE', value: '11543' },
  { text: 'ESCUELA PARTICULAR MISIONAL PELCHUQUIN', value: '11544' },
  { text: 'ESCUELA PARTICULAR MADRE DE DIOS', value: '11545' },
  { text: 'ESCUELA PARTICULAR NOLGUEHUE', value: '11547' },
  { text: 'ESCUELA CLAUDIO MATTE', value: '11548' },
  { text: 'ESCUELA RURAL NALHUITAD', value: '11553' },
  { text: 'ESCUELA DE ADULTOS DE RIO BUENO', value: '11554' },
  { text: 'ESCUELA PARTICULAR PLAYA ROSADA', value: '11574' },
  { text: 'ESCUELA PARTICULAR LUCILA GODOY ALCAYAGA', value: '11575' },
  { text: 'ESCUELA PARTICULAR LOS RADALES', value: '11576' },
  { text: 'ESCUELA ESPECIAL TALLER LABORAL', value: '11577' },
  { text: 'ESCUELA PARTICULAR YUSTE', value: '11578' },
  { text: 'ESCUELA PARTICULAR LOS CIERVOS', value: '11581' },
  { text: 'ESCUELA PARTICULAR FOLLECO ALTO', value: '11582' },
  { text: 'ESCUELA TRALAHUAPI', value: '11588' },
  { text: 'ESCUELA RURAL UNION CHISCAIHUE', value: '11589' },
  { text: 'ESCUELA RURAL SAN PEDRO', value: '11590' },
  { text: 'LICEO RURAL LLIFEN', value: '11591' },
  { text: 'ESCUELA PARTICULAR EL BUEN PASTOR', value: '11592' },
  { text: 'ESCUELA RURAL MARIA ENRIQUETA CHIGUAY C.', value: '11593' },
  { text: 'COLEGIO ANTILLANCA', value: '11594' },
  { text: 'ESCULA RURAL QUIMAN', value: '11595' },
  { text: 'ESCUELA MUNICIPAL MELIMOYU', value: '11609' },
  { text: 'ESCUELA BASICA RIBERA SUR', value: '11612' },
  { text: 'ESCUELA PARTICULAR CANICU', value: '11674' },
  { text: 'JARDIN INFANTIL CAMPANELLA', value: '11675' },
  { text: 'ESCUELA BASICA LA HUERTA', value: '11676' },
  { text: 'ESCUELA ANDRES ALCAZAR', value: '11677' },
  { text: 'LICEO ADVENTISTA', value: '11678' },
  { text: 'COLEGIO MIGUEL DE CERVANTES', value: '11681' },
  { text: 'SOCIEDAD EDUCACIONAL  LA ARAUCANA', value: '11685' },
  { text: 'ESCUELA REPUBLICA ARGENTINA', value: '11687' },
  { text: 'ESCUELA PUERTA DE LA CORDILLERA', value: '11704' },
  { text: 'COLEGIO LOS EDUCADORES', value: '11705' },
  { text: 'LICEO PARTICULAR LOS ANDES', value: '11706' },
  { text: 'COLEGIO PARTICULAR NINO JESUS', value: '11707' },
  { text: 'COLEGIO PARQUE CENTRAL', value: '11708' },
  { text: 'COLEGIO ALERCE', value: '11709' },
  { text: 'JARDIN INFANTIL EMANUEL', value: '11710' },
  { text: 'ESCUELA LUIS MARTINEZ GONZALEZ', value: '11711' },
  { text: 'ESCUELA PARTICULAR GASPAR CABRALES', value: '11712' },
  { text: 'ESCUELA CHACUIVI', value: '11714' },
  { text: 'COLEGIO PARTICULAR ALBERTO BLEST GANA', value: '11715' },
  { text: 'COLEGIO RUISENOR', value: '11716' },
  { text: 'ESCUELA PARTICULAR JUAN PABLO II', value: '11718' },
  { text: 'ESCUELA PARTICULAR BIO BIO DE LOS ANGELE', value: '11719' },
  { text: 'COLEGIO PARTICULAR SANTA ISABEL', value: '11737' },
  { text: 'ESCUELA PART.TRAPA TRAPA BUTALELBUM', value: '11739' },
  { text: 'ESCUELA PARTICULAR SAN ANDRES', value: '11741' },
  { text: 'COLEGIO BASICO LOS LOBOS', value: '11743' },
  { text: 'ESCUELA CHILLAN VIEJO', value: '11744' },
  { text: 'COLEGIO DIFERENCIAL SANTO DOMINGO', value: '11745' },
  { text: 'ESCUELA PARTICULAR LOS CONFINES', value: '11746' },
  { text: 'ESCUELA ESPECIAL AMERICA DEL SUR', value: '11759' },
  { text: 'ESCUELA PARTICULAR SAN FELIPE NERI', value: '11761' },
  { text: 'COLEGIO LORD COCHRANE', value: '11767' },
  { text: 'ESCUELA ESPECIAL PART RAYITO DE LUZ', value: '11768' },
  { text: 'ESCUELA BASICA GIORDANO BRUNO', value: '11783' },
  { text: 'ESCUELA ESPECIAL PARTICULAR LO HERMIDA', value: '11788' },
  { text: 'ESCUELA BASICA PART.BROTHERS SCHOOL', value: '11789' },
  { text: 'ESC ESPECIAL NUESTRA SENORA DE LOURDES', value: '11791' },
  { text: 'LICEO PARTIC.ALBERTO MAGNO LA FLORIDA', value: '11792' },
  { text: 'ESC BASICA PARTICULAR SAN VALENTIN', value: '11793' },
  { text: 'ESCUELA ESPECIAL PARTICULAR VARESCA', value: '11794' },
  { text: 'COLEGIO SAN CARLOS DE LA FLORIDA', value: '11795' },
  { text: 'ESC PARTICULAR MANUEL VICUNA LARRAIN', value: '11797' },
  { text: 'ESCUELA ESPECIAL PARTICULAR LAS ROSAS', value: '11800' },
  { text: 'ESCUELA ESPECIAL NUEVA ALBORADA', value: '11804' },
  { text: 'COLEGIO POLIVALENTE INGLES', value: '11805' },
  { text: 'ESCUELA BASICA PARTICULAR ARMI', value: '11806' },
  { text: 'ESCUELA PARTICULAR PUMANQUE', value: '11807' },
  { text: 'ESCUELA PARTICULAR SEGUNDO MAURO ORTIZ', value: '11808' },
  { text: 'ESC.PAR.MAURICE AND NATALY SCHOOL', value: '11809' },
  { text: 'LICEO SANTA MARIA EUFRASIA', value: '11811' },
  { text: 'ESCUELA BASICA TOMAS MORO', value: '11812' },
  { text: 'ESCUELA PARTICULAR ALVAREZ DE TOLEDO', value: '11813' },
  { text: 'COLEGIO PESTALOZZI', value: '11814' },
  { text: 'ESCUELA ESPECIAL PARTICULAR SAN CLEMENTE', value: '11816' },
  { text: 'ESCUELA ESPECIAL PARTICULAR SOR TERESA', value: '11828' },
  { text: 'ESCUELA BASICA  1287 SAN MARCOS APOSTOL', value: '11830' },
  { text: 'ESCUELA PARTICULAR ROYAL SCHOOL', value: '11835' },
  { text: 'ESCUELA ESPECIAL PARTICULAR NUEVA SENDA', value: '11836' },
  { text: 'ESCUELA SAINT MARY SCHOOL', value: '11837' },
  { text: 'ESCUELA PART. STA. CLARISA DE COLINA', value: '11838' },
  { text: 'ESCUELA PARTICULAR BELGICA', value: '11845' },
  { text: 'ESCUELA BAS. PARTICULAR MILLARAY', value: '11853' },
  { text: 'ESCUELA BASICA PARTICULAR BRASILIA', value: '11854' },
  { text: 'COLEGIO ALVARO COVARRUBIAS ARLEGUI', value: '11855' },
  { text: 'ESCUELA DE PARVULOS TRIBILIN', value: '11862' },
  { text: 'ESCUELA DE PARVULOS CONEJIN', value: '11865' },
  { text: 'COLEGIO UNIVERSAL SAN FRANCISCO', value: '11867' },
  { text: 'ESC.BAS. PART. COLEGIO HAYDN DE SAN JOAQUIN', value: '11870' },
  { text: 'ESCUELA ESPECIAL ARNOLD GESELL', value: '11878' },
  { text: 'LICEO MUNICIPAL POLIV. MARIA PINTO', value: '11883' },
  { text: 'COLEGIO POLITEC. AVENIDA INDEPENDENCIA', value: '11885' },
  { text: 'ESCUELA BASICA EL CARMELO', value: '11886' },
  { text: 'LICEO MANUEL BULNES DE LA FLORIDA', value: '11898' },
  { text: 'ESC.ESP.SAN MIGUEL DE LA NVA EXTREMADURA', value: '11901' },
  { text: 'ESCUELA BAS. LOS CARRERA', value: '11906' },
  { text: 'ESCUELA PARTICULAR EL ANGEL', value: '11909' },
  { text: 'ESCUELA BASICA N\u00c2\u00ba128 SAN RAMON', value: '11914' },
  { text: 'COLEGIO INFOCAP', value: '11921' },
  { text: 'ESCUELA PARTICULAR EL ABRAZO DE MAIPU', value: '11922' },
  { text: 'ESCUELA ESPECIAL LORENZO EITING', value: '11924' },
  { text: 'ESCUELA BASICA PARTICULAR ROQUER', value: '11926' },
  { text: 'ESCUELA ANTILLANCA', value: '11928' },
  { text: 'ESCUELA DE PARVULOS LAS VERTIENTES', value: '11929' },
  { text: 'CENTRO EDUC.PART.ORDEN DE SAN JORGE', value: '11931' },
  { text: 'ESCUELA ESPECIAL JULIO BERNALDO QUIROS', value: '11932' },
  { text: 'COLEGIO JACQUES COUSTEAU', value: '11936' },
  { text: 'COLEGIO ABERSAN', value: '11942' },
  { text: 'COLEGIO SAN LORENZO', value: '11948' },
  { text: 'COLEGIO CRISOL', value: '11949' },
  { text: 'COLEGIO MONTEVERDE', value: '11950' },
  { text: 'ESCUELA BELEN O\u00c2\u00a6HIGGINS', value: '11952' },
  { text: 'ESCUELA BASICA  PEPITA', value: '11956' },
  { text: 'ESCUELA DE PARVULOS ALVARO COVARRUBIAS A.', value: '11959' },
  { text: 'SAINT CHRISTIAN COLLEGE', value: '11977' },
  { text: 'COLEGIO MIGUEL ANGEL', value: '11979' },
  { text: 'ESCUELA ESPECIAL PARTICULAR CECLA', value: '11980' },
  { text: 'ESCUELA BASICA JUAN PABLO DUARTE', value: '11993' },
  { text: 'LICEO POLIVALENTE BAHIA DARWIN', value: '11994' },
  { text: 'ESCUELA PARTICULAR SUBVENCIONADA ABET', value: '11997' },
  { text: 'ESCUELA BASICA PARTICULAR HUE\u00c3\u2018ECITO', value: '11998' },
  { text: 'COLEGIO PARTICULAR EVANGELICO BETANIA', value: '12001' },
  { text: 'ESCUELA PARTICULAR TOQUI CAUPOLICAN', value: '12002' },
  { text: 'LICEO POLITECNICO CURANILAHUE', value: '12004' },
  { text: 'COLEGIO DON ORIONE', value: '12005' },
  { text: 'LICEO AGRICOLA SAN CARLOS', value: '12006' },
  { text: 'ESCUELA PARTICULAR AMERICO VESPUCIO', value: '12008' },
  { text: 'ESCUELA DE LENGUAJE ANTU', value: '12011' },
  { text: 'JARDIN INFANTIL TIRITA DE PAPEL', value: '12013' },
  { text: 'ESCUELA DE PARVULOS DIVINO MAESTRO', value: '12014' },
  { text: 'COLEGIO CONCEPCION', value: '12015' },
  { text: 'ESCUELA EL RODEO', value: '12018' },
  { text: 'ESCUELA BASICA ENRIQUE ZANARTU PRIETO', value: '12020' },
  { text: 'ESCUELA BASICA CHACAYAL SUR', value: '12022' },
  { text: 'COLEGIO BASICO SAN VICENTE', value: '12023' },
  { text: 'COLEGIO ITAHUE DE CHIGUAYANTE', value: '12025' },
  { text: 'COLEGIO EL ARBOL DE LA VIDA', value: '12027' },
  { text: 'ESCUELA SAN DIEGO DE ALCALA', value: '12031' },
  { text: 'LICEO INDUSTRIAL METODISTA DE CORONEL', value: '12033' },
  { text: 'JARDIN INFANTIL BARQUITO DE PAPEL', value: '12035' },
  { text: 'LICEO POLIVALENTE HERMANAS MAESTRAS DE LA SAN', value: '12037' },
  { text: 'CENTRO EDUC ADULT.MANANTIAL DE AGUA VIVA', value: '12042' },
  { text: 'COLEGIO LORENZO MONDANELLI', value: '12046' },
  { text: 'JARDIN INFANTIL CORAZON DE ORO', value: '12048' },
  { text: 'COLEGIO TECNICO PROFESIONAL DARIO SALAS', value: '12050' },
  { text: 'ESCUELA ESPECIAL DE LA SOLIDARIDAD', value: '12051' },
  { text: 'CENTRO DE CAPACITACION LABORAL APANDI', value: '12052' },
  { text: 'CENTRO ED  ADULTOS AMANCAY', value: '12055' },
  { text: 'ESCUELA BASICA LOS LIBERTADORES', value: '12058' },
  { text: 'ESCUELA GRANJA LOS MAYOS DE ALTO BIO-BIO', value: '12059' },
  { text: 'ESCUELA BASICA EL PIURE', value: '12064' },
  { text: 'ESCUELA BASICA MELA', value: '12065' },
  { text: 'COLEGIO HALLEY', value: '12073' },
  { text: 'ESCUELA PARTICULAR SAN GUILLERMO', value: '12076' },
  { text: 'HERNAN MERINO CORREA', value: '12079' },
  { text: 'ESCUELA DE PARVULOS INNS BRUCK', value: '12080' },
  { text: 'COLEGIO LO ERRAZURIZ', value: '12083' },
  { text: 'COLEGIO CRISTIANO EMMANUEL', value: '12085' },
  { text: 'ESCUELA ESPECIAL NUEVO MUNDO', value: '12092' },
  { text: 'ESC BAS PART COLEGIO CHILLAN', value: '12095' },
  { text: 'COLEGIO ESP. TRANST.LENGUAJE ANAKENA', value: '12097' },
  { text: 'ESC. DE PARVULOS ALBERTO WIDMER N_ 2', value: '12102' },
  { text: 'ESCUELA ESPECIAL DE EDUCACION', value: '12103' },
  { text: 'ESCUELA ESPECIAL PARTICULAR CEDEL', value: '12105' },
  { text: 'ESCUELA PARTIC.DE PARVULOS MI PRINCESITA', value: '12108' },
  { text: 'ESCUELA BASICA LO VELASQUEZ', value: '12113' },
  { text: 'CENTRO EDUCACIONAL FEDERICO GARCIA LORCA', value: '12115' },
  { text: 'COMPLEJO EDUCACIONAL J. MIGUEL CARRERA', value: '12117' },
  { text: 'ESCUELA CENTRO BIBLICO LA FORESTA', value: '12118' },
  { text: 'ESCUELA DIFERENCIAL INTEGRACION', value: '12119' },
  { text: 'ESCUELA BAS. Y ESP. OVIDIO DECROLY', value: '12120' },
  { text: 'ESCUELA MARIA DE LA PAZ', value: '12121' },
  { text: 'ESCUELA EDUCADORA GABRIELA MISTRAL', value: '12122' },
  {
    text: 'ESCUELA B\u00c3\u0081SICA Y ESPECIAL N\u00c2\u00b0352 LAUTRARU',
    value: '12126',
  },
  { text: 'ESCUELA PARTIC SAN ISIDRO DE PERALILLO', value: '12127' },
  { text: 'ESCUELA MARIA TERESA SCHOOL NUM 2', value: '12130' },
  { text: 'ESCUELA ESPECIAL PART SANTIAGO SUR', value: '12136' },
  { text: 'ESCUELA ESPECIAL PARTICULAR GALVARINO', value: '12143' },
  { text: 'CENTRO INTEG EDUC ADULTOS DE PLAYA ANCHA', value: '12146' },
  { text: 'COLEGIO HISPANO AMERICANO', value: '12151' },
  { text: 'ESCUELA PARTICULAR GUILLERMO TELL', value: '12153' },
  { text: 'ESCUELA ESPECIAL DE DESARROLLO', value: '12157' },
  { text: 'COLEGIO DOCTOR OTTO HAHN', value: '12161' },
  { text: 'COLEGIO BLANCO ENCALADA', value: '12167' },
  { text: 'ESCUELA BASICA HUMBERTO VILCHEZ ALZAMORA', value: '12171' },
  { text: 'ESCUELA PARTICULAR MARIANO LATORRE', value: '12175' },
  { text: 'ESCUELA PARTICULAR LUIS CRUZ MARTINEZ', value: '12182' },
  { text: 'COLEGIO SAINT THOMAS COLLEGE', value: '12183' },
  { text: 'ESCUELA PARTICULAR JUAN PABLO I', value: '12184' },
  { text: 'ESCUELA PARTICULAR HELVECIA', value: '12185' },
  { text: 'ESCUELA CERRO ALEGRE', value: '12188' },
  { text: 'ESCUELA RURAL CRUCE FUTAHUENTE', value: '12189' },
  { text: 'ESCUELA PARTICULAR EL MIRADOR', value: '12191' },
  { text: 'INSTITUTO DEL MAR CAPITAN WILLIAMS', value: '12192' },
  { text: 'ESCUELA PARTICULAR RELDEHUE', value: '12193' },
  { text: 'ESCUELA ESPECIAL PARTICULAR REINA MARIA', value: '12221' },
  { text: 'CENTRO EDUCACIONAL SAN ESTEBAN MARTIR', value: '12225' },
  { text: 'ESCUELA BASICA IRARRAZAVAL', value: '12226' },
  { text: 'COLEGIO ESP. DE TRAST. DEL LENG.NAZARENO', value: '12231' },
  { text: 'LICEO POLITECNICO DIEGO PORTALES', value: '12234' },
  { text: 'ESC.PART.COLEGIO LOS HALCONES', value: '12237' },
  { text: 'COLEGIO CORAZON DE JESUS', value: '12241' },
  { text: 'COLEGIO PUDAHUEL', value: '12242' },
  { text: 'ESCUELA N\u00c2\u00ba 1365 R.P. GUSTAVO LE PAIGE', value: '12243' },
  { text: 'COLEGIO EL SEMBRADOR', value: '12244' },
  { text: 'ESC. BASICA JACQUELINE COLLEGE', value: '12245' },
  { text: 'ESCUELA ESPECIAL PONTIFICE JUAN PABLO II', value: '12249' },
  { text: 'COLEGIO BATALLA DE LA CONCEPCION', value: '12251' },
  { text: 'COLEGIO ALCAZAR', value: '12255' },
  { text: 'CENTRO EDUCACIONAL ERNESTO YANEZ RIVERA', value: '12257' },
  { text: 'EMMANUEL MOUNIER', value: '12258' },
  { text: 'CIUDADELA MONTESSORI DE LAS CONDES', value: '12266' },
  { text: 'COLEGIO INSTITUTO SAN CARLOS', value: '12269' },
  { text: 'ESCUELA DE PARV. LOS DUENDECITOS', value: '12272' },
  { text: 'ESC.MUNIC.DE PARVULOS HERNAN DEL SOL', value: '12273' },
  { text: 'ESCUELA BASICA ANEXO PICHILEMU', value: '12299' },
  {
    text: 'COLEGIO ESPA\u00c3\u2018OL DE VI\u00c3\u2018A DEL MAR',
    value: '12301',
  },
  { text: 'COLEGIO SAINT JULIAN COLLEGE', value: '12302' },
  { text: 'COLEGIO ALEXANDER FLEMING', value: '12305' },
  { text: 'ESCUELA FRAY LUIS AMIGO', value: '12307' },
  { text: 'COLEGIO PIRAMIDE', value: '12309' },
  { text: 'CTRO TRAT.Y DESARROLLO DEL LENGUAJE', value: '12310' },
  { text: 'CTRO ESTUDIOS CAPACITACION PARA SORDOS', value: '12311' },
  { text: 'COLEGIO REBECA FERNANDEZ', value: '12312' },
  { text: 'ESCUELA ESPECIAL CARTAGENA', value: '12313' },
  { text: 'ESCUELA ATENAS', value: '12314' },
  { text: 'CENTRO EDUCACIONAL CRISOL', value: '12323' },
  { text: 'DEUTSCHE SCHULE EL BELLOTO', value: '12328' },
  { text: 'COLEGIO CRISTIANO EBEN-EZER ANEXO', value: '12330' },
  { text: 'LICEO POLITECNICO DE CON CON', value: '12332' },
  { text: 'LICEO TECNICO PROFESIONAL DE MINERIA', value: '12336' },
  { text: 'ESC. BASICA MALLA', value: '12364' },
  { text: 'ESCUELA ESPECIAL ARCO IRIS', value: '12366' },
  { text: 'LICEO POLITECNICO SANTA CRUZ', value: '12368' },
  { text: 'ESCUELA JORGE ALESSANDRI RODRIGUEZ', value: '12501' },
  { text: 'COLEGIO  ANDINO', value: '12502' },
  { text: 'COLEGIO PADRE LUIS GALLARDO', value: '12505' },
  { text: 'LICEO PDTE. ANIBAL PINTO GARMENDIA.', value: '12509' },
  { text: 'JARDIN INFANTIL PAPELUCHO', value: '12510' },
  { text: 'JARDIN INFANTIL NOCTILUCAS', value: '12511' },
  { text: 'JARDIN INFANTIL SAN NICOLAS', value: '12512' },
  { text: 'COLEGIO NUSTA KORI', value: '12515' },
  { text: 'COLEGIO DIOCESANO OBISPO LABBE', value: '12518' },
  { text: 'JARDIN INFANTIL CAPERUZO', value: '12519' },
  { text: 'JARDIN INFANTIL EMMANUELITO', value: '12523' },
  { text: 'LICEO COLEGIO METODISTA ROBERT JOHNSON', value: '12534' },
  { text: 'ESCUELA CRISOLVI', value: '12536' },
  { text: 'JARDIN INFANTIL CASCANUECES', value: '12537' },
  { text: 'ESCUELA CHIPANA', value: '12538' },
  { text: 'COLEGIO SAN JUAN DE LA BLACHERE', value: '12539' },
  { text: 'ANEXO ESCUELA THILDA PORTILLO OLIVARES', value: '12542' },
  { text: 'JARDIN INFANTIL EL LLAMITO', value: '12545' },
  { text: 'C.T. C.Y LENGUAJE HISPANO AMERICANO', value: '12549' },
  { text: 'OASIS EN EL DESIERTO', value: '12550' },
  { text: 'ESCUELA ANEXO SIBAYA', value: '12552' },
  { text: 'J.  I.  ANATIRI', value: '12553' },
  { text: 'ESCUELA DE SOGA', value: '12554' },
  { text: 'JARDIN INFANTIL AYMARA AYRAMPITO', value: '12555' },
  { text: 'JARDIN INFANTIL PECECITO DORADO', value: '12556' },
  { text: 'C.TRAST. DE LA COMUNIC. AMANECER', value: '12557' },
  { text: 'COLEGIO LITTLE STARS', value: '12559' },
  { text: 'ESCUELA LAONZANA', value: '12562' },
  { text: 'COLEGIO METODISTA WILLIAM TAYLOR', value: '12566' },
  { text: 'COLEGIO SAN ANTONIO DE MATILLA', value: '12567' },
  { text: 'JARDIN INFANTIL MANDALA GARDEN', value: '12568' },
  { text: 'JARDIN INFANTIL BETHEL DE ARICA', value: '12569' },
  { text: 'COLEGIO ALTA CORDILLERA', value: '12570' },
  { text: 'LICEO SUPERIOR SINAI', value: '12576' },
  { text: 'ESCUELA LATINOAMERICANA', value: '12579' },
  { text: 'JARDIN INFANTIL ECOSEMILLITA', value: '12584' },
  { text: 'J.  I.  MI RINCON', value: '12585' },
  { text: 'COLEGIO REINA DEL DESIERTO', value: '12588' },
  { text: 'COLEGIO HISPANO ITALIANA', value: '12590' },
  { text: 'J.I.SAINT MARGARET ROSE GARDEN', value: '12593' },
  { text: 'COLEGIO ANTAMARA', value: '12594' },
  { text: 'JARDIN INFANTIL ANAKENA', value: '12599' },
  { text: 'JARDIN INFANTIL PINTITAS', value: '12600' },
  { text: 'JARDIN INFANTIL MOISES', value: '12601' },
  { text: 'ESCUELA BASICA CORONA SCHOOL', value: '12604' },
  { text: 'ACADEMIA IQUIQUE HOSPICIO', value: '12605' },
  { text: 'JARDIN INFANTIL LOS TATITAS', value: '12606' },
  { text: 'JARDIN INFANTIL MIS PRIMEROS PASOS', value: '12607' },
  { text: 'ESCUELA DE LENGUAJE INTI-PAXI', value: '12609' },
  { text: 'LICEO INSTITUTO COMERCIAL DE ARICA', value: '12610' },
  { text: 'JARDIN INFANTIL BAMBI', value: '12612' },
  { text: 'JARIN INFANTIL TALPIOT', value: '12613' },
  { text: 'J. I.   MARAZUL', value: '12615' },
  { text: 'ESCUELA BASICA ESTRELLA DEL SUR', value: '12617' },
  { text: 'JARDIN INFANTIL HAPPY DAY', value: '12619' },
  { text: 'JARDIN INFANTIL PAPALOTE', value: '12620' },
  { text: 'JARDIN INFANTIL DSTEPHANO', value: '12621' },
  { text: 'JARDIN INFANTIL PEQUENO ARRAU', value: '12622' },
  { text: 'ESCUELA SAN ANDRES DE PICA', value: '12623' },
  { text: 'C. DES. LENG. MANUEL ANTONIO MATTA', value: '12629' },
  { text: 'COLEGIO LEONARDO DA VINCI', value: '12630' },
  { text: 'COLEGIO SIMON BOLIVAR', value: '12632' },
  { text: 'COLEGIO SAN LORENZO DE TARAPACA', value: '12634' },
  { text: 'JARDIN INFANTIL ACADEMIN', value: '12635' },
  { text: 'COLEGIO NIMARA', value: '12636' },
  { text: 'COLEGIO ACADEMIA TARAPACA', value: '12638' },
  { text: 'COLEGIO DE LA COSTA', value: '12646' },
  { text: 'JARDIN INFANTIL HAPPY GARDEN', value: '12648' },
  { text: 'LICEO SUPERIOR DIEGO PORTALES', value: '12649' },
  { text: 'L.POLIV. SAGRADO CORAZON DE HOSPICIO', value: '12650' },
  { text: 'COLEGIO SANTO DOMINGO SAVIO', value: '12652' },
  { text: 'ESCUELA ACADEMIA SINAI', value: '12654' },
  { text: 'COLEGIO SAN PEDRO', value: '12655' },
  { text: 'LICEO AGR. TEC. PROF. PADRE FRANCISCO NAPOLI', value: '12658' },
  { text: 'COLEGIO DEL ALBA', value: '12659' },
  { text: 'ESC. ESP. DE LENGUAJE MONSERRAT', value: '12660' },
  { text: 'J.  I.  PUKARA', value: '12661' },
  { text: 'JARDIN INFANTIL PERSONITAS', value: '12662' },
  { text: 'JARDIN INFANTIL CATITA', value: '12663' },
  { text: 'ESCUELA SAN SANTIAGO DE MACAYA', value: '12664' },
  { text: 'JARDIN INFANTIL SAN ANDRES', value: '12666' },
  { text: 'ESCUELA SOTOCA', value: '12668' },
  { text: 'ESC.ESP.DE TRANS. DE LA COM. ARUSINA', value: '12670' },
  { text: 'COLEGIO SALESIANO DE IQUIQUE', value: '12672' },
  { text: 'J. I.  MY FRIEND', value: '12674' },
  { text: 'ESC. ESP. DE  LENGUAJE  MILLARAY', value: '12675' },
  { text: 'JARDIN INFANTIL DADU', value: '12676' },
  { text: 'JARDIN INFANTIL CARITAS CONTENTAS', value: '12678' },
  { text: 'ESC.TRANS.DE LA COMUN. IKI  ARU', value: '12680' },
  { text: 'ESC.TRAST.DE LA COM.FLOR DE LIRIO', value: '12681' },
  { text: 'ACADEMIA IQUIQUE BULNES', value: '12682' },
  { text: 'LICEO COLEGIO DEPORTIVO', value: '12683' },
  { text: 'ESCUELA BASICA CANCOSA DE CANCOSA', value: '12684' },
  { text: 'ESC.ESP. DE TRASTORNO DE LA COMUN ISLUGA', value: '12685' },
  { text: 'LICEO ACADEMIA NACIONAL', value: '12686' },
  { text: 'COLEGIO GOLDEN NORTH', value: '12688' },
  { text: 'JARDIN INFANTIL JESUS DE NAZARETH', value: '12691' },
  { text: 'COLEGIO MACAYA', value: '12693' },
  { text: 'COLEGIO MOSAICOS', value: '12694' },
  { text: 'ESCUELA ESP DE LENGUAJE PARINA', value: '12695' },
  { text: 'LICEO TECNICO PROF. DE ADULTOS PUKARA', value: '12696' },
  { text: 'ESC. ESPECIAL DE TRASTORNOS AUDIMED IQUIQUE', value: '12697' },
  { text: 'ESC ESP DE LENGUAJE STA CAROLINA DE MATILLA', value: '12698' },
  { text: 'ESC. ESP. DE LENGUAJE KHANA ARU', value: '12699' },
  { text: 'ESC. ESP. TRANST. COM. SANTA LAURA', value: '12700' },
  { text: 'J.  I. LITTLE SUN', value: '12702' },
  { text: 'JARDIN INFANTIL AMANECER', value: '12704' },
  { text: 'JARDIN INFANTIL DON OSITO', value: '12705' },
  { text: 'ESCUELA ESPECIAL JACARANDA', value: '12708' },
  { text: 'ACADEMIA NERUDIANA', value: '12709' },
  { text: 'COLEGIO HUANTAJAYA', value: '12710' },
  { text: 'LICEO ACADEMIA SINAI', value: '12711' },
  { text: 'COLEGIO  CHILE NORTE', value: '12712' },
  { text: 'CARDENAL RAUL SILVA HENRIQUEZ', value: '12713' },
  { text: 'ESC.PARV.DE LENGUAJE DIVINO NINO JESUS', value: '12714' },
  { text: 'COLEGIO MARAN-ATHA', value: '12715' },
  { text: 'COLEGIO MIRAMAR', value: '12716' },
  { text: 'JARDIN INFANTIL AMTIRE', value: '12717' },
  { text: 'J.  I. MI MUNDO', value: '12718' },
  { text: 'LICEO PABLO NERUDA', value: '12719' },
  { text: 'COLEGIO ACUARELLA DE ARICA', value: '12720' },
  { text: 'JARDIN INFANTIL CASTILLLO DEL SABER', value: '12721' },
  { text: 'JARDIN INFANTIL GIRASOLES', value: '12722' },
  { text: 'J.  I. AGU', value: '12724' },
  { text: 'ESCUELA ESPECIAL PADRE PIO', value: '12725' },
  { text: 'COLEGIO MONTE CARMELO', value: '12726' },
  {
    text: 'ESCUELA ESPECIAL DE LENG. PIECECITOS DE NI\u00c3\u2018O',
    value: '12727',
  },
  { text: 'JARDIN INFANTIL CANTA LUNA', value: '12728' },
  { text: 'LICEO TEC. PROF. DE ADULTOS CORESOL', value: '12730' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE LOS ANDES', value: '12731' },
  { text: 'ESC ESP DE LENGUAJE COLINA CAMPESTRE', value: '12732' },
  { text: 'JARDIN INFANTIL LA GRANJITA', value: '12733' },
  { text: 'ESC ESP DE LENGUAJE ESPISANT', value: '12734' },
  { text: 'ACADEMIA POZO ALMONTE', value: '12736' },
  { text: 'ESC.ESP. DE LENGUAJE SANTA LUCIA', value: '12738' },
  { text: 'ESC ESP DE LENGUAJE OASIS DEL SABER', value: '12739' },
  { text: 'COLEGIO LATIONOAMERICANO  LAS PARINAS', value: '12741' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE INTI - JALLU', value: '12742' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE VILENKA', value: '12746' },
  { text: 'COLEGIO RUPANIC SCHOOL', value: '12747' },
  { text: 'ESCUELA ESP. DE LENG MANANTIAL DEL SABER', value: '12748' },
  { text: 'COLEGIO MARISTA HERMANO FERNANDO', value: '12749' },
  { text: 'LICEO DE ADULTOS JUNIOR COLLEGE', value: '12750' },
  { text: 'ESCUELA DE LENGUAJE KERIMA LTDA.', value: '12751' },
  { text: 'ESC ESP  DE LENGUAJE MI RAYITO DE SOLAZ', value: '12753' },
  { text: 'JARDIN INFANTIL DAELY', value: '12756' },
  { text: 'JARDIN INFANTIL SAMCA ARUMANTI DE IQUIQUE', value: '12757' },
  { text: 'LICEO CEIA DE IQUIQUE', value: '12758' },
  { text: 'LICEO CAMI\u00c3\u2018A', value: '12759' },
  { text: 'ESCUELA BASICA FRANCISCO FORGIONE', value: '12761' },
  { text: 'COLEGIO BAUTISTA LOIS HART', value: '12800' },
  { text: 'FUND.EDUC.COL.FEMENINO MADRE DEL ROSARIO', value: '12802' },
  { text: 'ESCUELA DE PARVULOS CARINOSITOS 1', value: '12805' },
  { text: 'ESCUELA KAMAC MAYU', value: '12810' },
  { text: 'ESCUELA DE PARVULOS QUILLA ANTAY', value: '12811' },
  { text: 'ESCUELA DE PARVULOS RENATITO', value: '12814' },
  { text: 'ESC  PARV  LOS BAMBINOS', value: '12815' },
  { text: 'ESCUELA MI HIJO', value: '12820' },
  { text: 'ESCUELA DE PARVULOS SEMILLITA', value: '12822' },
  { text: 'COLEGIO CALAMA', value: '12823' },
  { text: 'COL  SUNFLOWER SCHOOL', value: '12824' },
  { text: 'ESCUELA ARTURO PRAT CHACON  ANEXO', value: '12827' },
  { text: 'LICEO DE ESTUDIOS CONTABLES Y ADMINISTR.', value: '12830' },
  { text: 'ESCUELA DE PARVULOS TIERNO AMANECER', value: '12831' },
  { text: 'COLEGIO RIO LOA', value: '12836' },
  { text: 'COLEGIO PARTICULAR BET- EL', value: '12837' },
  { text: 'ESCUELA JUAN PABLO II', value: '12840' },
  { text: 'LICEO AGROPECUARIO LIKAN ANTAI', value: '12842' },
  { text: 'ESCUELA DE PARVULOS SAN GABRIEL', value: '12845' },
  { text: 'COL  CHANARES', value: '12846' },
  { text: 'ESC  PARV  LOS 7 ENANITOS DEL BOSQUE', value: '12847' },
  { text: 'LICEO EXPERIMENTAL ARTISTICO Y APLICACIO', value: '12848' },
  { text: 'COLEGIO PARTICULAR SAN NICOLAS', value: '12853' },
  { text: 'LICEO COMERCIAL COMPUTACIONAL STA SARA', value: '12855' },
  { text: 'COLEGIO DIVINA PASTORA', value: '12860' },
  { text: 'ESCUELA DE PARVULOS KING LIONS SCHOOL', value: '12861' },
  { text: 'ESCUELA LAPICITO DE COLOR', value: '12862' },
  { text: 'ESC.DE PARVULOS LA CASITA DE CHOCOLATE', value: '12865' },
  { text: 'COLEGIO EBEN EZER', value: '12868' },
  { text: 'ESCUELA DE PARVULOS GATO CON BOTAS', value: '12869' },
  { text: 'C.E.I.A. ANTONIO RENDIC.', value: '12870' },
  { text: 'ESCUELA BASICA VALENTIN LETELIER', value: '12871' },
  { text: 'ESCUELA MEJILLONES', value: '12872' },
  { text: 'COLEGIO MI HIJO N_2', value: '12878' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE VIOLETA PARRA', value: '12879' },
  { text: 'ESCUELA DE PARVULOS INTI PANNI', value: '12882' },
  { text: 'COL. INTERNACIONAL ANTOFAGASTA LTDA.', value: '12884' },
  { text: 'ESCUELA DE PARVULOS MI MUNDO MAGICO', value: '12886' },
  { text: 'ESC.ESPEC.DE LENGUAJE CAMINO DE AMOR', value: '12888' },
  { text: 'EL PRINCIPITO FELIZ', value: '12889' },
  { text: 'MIS MAGICAS PALABRAS', value: '12890' },
  { text: 'ESC. PARV. MINNIES KIDS', value: '12932' },
  { text: 'ESCUELA DE PARVULOS SAN LUCIANO', value: '12934' },
  { text: 'COLEGIO PROVIDENCIA', value: '12935' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE NAZARETH', value: '12936' },
  { text: 'LICEO POLITECNICO', value: '12937' },
  { text: 'SAN NICOLITO', value: '12939' },
  { text: 'ESCUELA ALONDRA ROJAS BARRIOS', value: '12941' },
  { text: 'ESCUELA GABRIELA MISTRAL', value: '12942' },
  { text: 'COLEGIO TECNICO INDUSTRIAL DON BOSCO', value: '12943' },
  { text: 'REVERENDO PADRE PATRICIO CARIOLA', value: '12944' },
  { text: 'ESCUELA ECOLOGICA PADRE HURTADO', value: '12945' },
  { text: 'ESCUELA DE PARVULOS NINO DE BELEN', value: '12948' },
  { text: 'ESC. PARV. SNOOPY 2', value: '12949' },
  { text: 'ESCUELA EDUCACION ESPECIAL RAICES', value: '12951' },
  { text: 'ESCUELA DE PARVULOS ALBERT EINSTEIN SCHOOL', value: '12952' },
  { text: 'LOS PANDITAS', value: '12953' },
  { text: 'ESCUELA BASICA JAVIERA CARRERA', value: '12955' },
  { text: 'ESC. PARV. ANSCO', value: '12956' },
  { text: 'THE GIANT SCHOOL ANTOFAGASTA', value: '12958' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE MIS MAGICAS PALA', value: '12959' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE RIMAY ARU', value: '12960' },
  { text: 'LICEO RADOMIRO TOMIC ROMERO', value: '12961' },
  { text: 'ESCUELA ELMO FUNEZ CARRIZO', value: '12962' },
  { text: 'COLEGIO SAN PATRICIO', value: '12966' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE MARGARETH', value: '12967' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE SAN SEBASTIAN', value: '12968' },
  { text: 'ESCUELA DE PARVULOS MUNDO KIDS', value: '12969' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE MONTESSORI', value: '12971' },
  { text: 'COLEGIO LA CONCEPCION', value: '12972' },
  { text: 'COLEGIO INGLES-ALEMAN', value: '12974' },
  { text: 'ESCUELA DE PARVULOS ABEJITA', value: '12975' },
  { text: 'ESCUELA DE PARVULOS PLANETA TIERRA', value: '12979' },
  { text: 'GRAN AVENIDA SUR', value: '12980' },
  { text: 'COLEGIO ESPECIAL LAURENT CLERC', value: '12982' },
  { text: 'ESCUELA DE P\u00c3\u20acRVULOS DREAM SCHOOL', value: '12983' },
  { text: 'ESCUELA DE PARVULOS LA ESTACION', value: '12985' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE MONTESSORI 2', value: '12986' },
  { text: 'ESC. ESP. DE LENG. ARCO IRIS DE PALABRAS', value: '12987' },
  { text: 'COLEGIO PARTICULAR CALDERA', value: '13103' },
  { text: 'ESCUELA MANUEL ORELLA ECHANEZ', value: '13104' },
  { text: 'ESC. ESPECIAL PARTICULAR LOS CONEJITOS', value: '13105' },
  { text: 'LICEO T.P PAULINO Y MARGARITA CALLEJAS', value: '13106' },
  { text: 'JARDIN INFANTIL PARTICULAR   AGAZZI', value: '13107' },
  { text: 'JARDIN INFANTIL   BAMBI', value: '13108' },
  { text: 'INSTITUTO DON BOSCO DE COPIAPO', value: '13111' },
  { text: 'COLEGIO SAN AGUSTIN DE ATACAMA', value: '13112' },
  { text: 'ESCUELA BASICA RURAL JAIME PROHENS', value: '13116' },
  { text: 'ESC. BASICA MARTA EMILIANA AGUILAR ZERON', value: '13118' },
  { text: 'CENTRO DE DESARROLLO DEL LENGUAJE MANUEL', value: '13120' },
  { text: 'ESC.BASICA CAPITAN RAFAEL TORREBLANCA', value: '13121' },
  { text: 'CENTRO EDUC.INTEGRADA ADULTOS  C.E.I.A', value: '13122' },
  { text: 'JARDIN INFANTIL PILLIN', value: '13123' },
  { text: 'COLEGIO FELIX SUSAETA', value: '13124' },
  { text: 'SCUOLA ITALIANA GIUSSEPPE VERDI', value: '13125' },
  { text: 'ESCUELA RURAL MOISES LOPEZ TRUJILLO', value: '13128' },
  { text: 'ESCUELA MANUEL RODRIGUEZ', value: '13133' },
  { text: 'ESCUELA MIREYA ZULETA ASTUDILLO', value: '13134' },
  { text: 'ESCUELA BASICA IGNACIO DOMEYKO', value: '13135' },
  { text: 'JARDIN INFANTIL ARCO IRIS', value: '13136' },
  { text: 'ESCUELA BASICA MIGUEL ZAMBRANO RODRIGUEZ', value: '13138' },
  { text: 'JARDIN INFANTIL  MI BEBE', value: '13139' },
  { text: 'ESC. ESP.DE TRASTORNOS DE LA COMUNICACIO', value: '13141' },
  { text: 'JARDIN  INFANTIL  CARRUSEL', value: '13142' },
  { text: 'BYRON GIGOUX JAMES', value: '13143' },
  { text: 'LICEO TECNOLOGICO DE COPIAPO', value: '13145' },
  { text: 'ESC.INDUSTRIAL SALESIANA CRISTO REDENTOR', value: '13146' },
  { text: 'CENTRO DE TRASTORNO DE COM.SN.FRANCISCO', value: '13148' },
  { text: 'COLEGIO PARTICULAR ALMENAR', value: '13149' },
  { text: 'ESCUELA TRASTORNOS DE LA COMUNICACION', value: '13152' },
  { text: 'ESCUELA EL CHANAR', value: '13154' },
  { text: 'JARDIN INFANTIL MI RAYITO DE SOL', value: '13155' },
  { text: 'LICEO TECNICO PROFESIONAL HEROES DE ATACAMA', value: '13156' },
  { text: 'ESC.ESP.CENTRO TRAST.DE LA COMUNICAC.', value: '13157' },
  { text: 'ESCUELA DIFERENCIAL PUKARA', value: '13162' },
  { text: 'ESCUELA EL PALOMAR', value: '13163' },
  { text: 'JARDIN INFANTIL PARTICULAR PEQUITAS', value: '13164' },
  { text: 'ESCUELA EDMUNDO QUEZADA ARAYA', value: '13167' },
  { text: 'LICEO EL PALOMAR', value: '13168' },
  { text: 'ESCUELA TRAST. LENGUAJE RAYITO DE SOL', value: '13169' },
  { text: 'ESCUELA BASICA SARA CORTES CORTES', value: '13170' },
  { text: 'ESCUELA MARTA COLVIN', value: '13171' },
  { text: 'ESCUELA ESP.TRAST.COMUNIC. AMANCAY', value: '13172' },
  { text: 'CENTRO DE EDUCACION INTEGRADA DE ADULTOS', value: '13176' },
  { text: 'ESCUELA VILLA LAS PLAYAS', value: '13177' },
  { text: 'COLEGIO HISPANO AMERICA', value: '13178' },
  { text: 'ESCUELA EMILIA SCHWABE RUMOHR', value: '13181' },
  { text: 'ESC. DE LENGUAJE CREPONIA', value: '13182' },
  { text: 'ESC.ESP.HOSPITALARIA HOSPITAL SAN JOSE DEL C', value: '13183' },
  { text: 'LICEO POLITECNICO', value: '13185' },
  { text: 'CENTRO DE EDUCACION INTEGRADA DE ADULTOS', value: '13186' },
  { text: 'ESC. ESP. DE LENGUAJE RAYITO DE SOL II', value: '13187' },
  { text: 'COLEGIO SAN FRANCISCO DE LA SELVA', value: '13190' },
  { text: 'ESC. ESP. DE LENG. LAURA VICUNA', value: '13191' },
  { text: 'JARDIN INFANTIL  JAKA ALI', value: '13194' },
  { text: 'ESP. DE LENGUAJE RINCON DEL SABER', value: '13195' },
  { text: 'ESC. ESP. DE LENGUAJE STELLA MARIS', value: '13196' },
  { text: 'ESC. DE LENGUAJE MUNDO MAGICO', value: '13197' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE MI ESTACION', value: '13198' },
  { text: 'ESC. ESP. DE LENGUAJE MIS RAICES', value: '13199' },
  { text: 'ESC. ESP. DE LENGUAJE NUEVA JUVENTUD', value: '13200' },
  { text: 'ESCUELA PARTICULAR CERRO BLANCO', value: '13302' },
  { text: 'COLEGIO CONEJITO CHIMBUN Y SUS AMIGOS', value: '13303' },
  { text: 'TRINITY SCHOOL', value: '13305' },
  { text: 'ESC. BASICA LA HIGUERA DE PUNITAQUI', value: '13309' },
  { text: 'JARDIN INFANTIL THE LITTLE PRINCE', value: '13310' },
  { text: 'ESCUELA PARTICULAR CHEPICA', value: '13312' },
  { text: 'COLEGIO CRISTOBAL COLON', value: '13314' },
  { text: 'COLEGIO PARTICULAR TONGOY', value: '13320' },
  { text: 'COLEGIO SANTA MARIA DE BELEN N_ 162', value: '13324' },
  { text: 'ESCUELA JOSE RAFAEL SALINAS', value: '13325' },
  { text: 'JARDIN INF  DE LA UNIVERSIDAD DE LA SERENA', value: '13328' },
  { text: 'JARDIN INFANTIL HAPPY KING', value: '13329' },
  { text: 'COLEGIO PARTICULAR PIERROT', value: '13330' },
  { text: 'JARDIN INFANTIL PIN UNO- PIN DOS', value: '13331' },
  { text: 'ESC. FAMILIAR AGRICOLA VALLE DEL ELQUI', value: '13333' },
  { text: 'ESCUELA BASICA JOSE IGNACIO ZENTENO', value: '13336' },
  { text: 'JARDIN INFANTIL SAN DANIEL', value: '13339' },
  { text: 'COLEGIO PART. KOMVUX - COQUIMBO', value: '13341' },
  { text: 'COLEGIO PARTICULAR SAN FRANCISCO JAVIER', value: '13342' },
  { text: 'COLEGIO AMERICANO', value: '13344' },
  { text: 'JARDIN INFANTIL LE PETIT  ENFANT', value: '13350' },
  { text: 'LICEO POLIV.PADRE JOSE HERDE P-LHER', value: '13352' },
  { text: 'SAINT JOHN S SCHOOL', value: '13353' },
  { text: 'JARDIN INFANTIL EL CASTILLO DEL SABER', value: '13357' },
  { text: 'ESCUELA  NUEVA TALCUNA', value: '13358' },
  { text: 'COLEGIO SAN NICOLAS', value: '13360' },
  { text: 'KIDS WORLD SCHOOL', value: '13361' },
  { text: 'ESCUELA BASICA LOS ANGELES DE RAPEL', value: '13362' },
  { text: 'ESCUELA BASICA MUNICIPAL LA GRANJITA', value: '13363' },
  { text: 'ESCUELA BASICA MUNICIPAL EL PIDEN', value: '13364' },
  { text: 'ESCUELA BASICA MINILLAS', value: '13365' },
  { text: 'COLEGIO DEL ALBA', value: '13370' },
  { text: 'COLEGIO PARTICULAR LEONARDO DA VINCI', value: '13373' },
  { text: 'ESCUELA BASICA EL MEMBRILLO', value: '13375' },
  { text: 'COLEGIO SAN MANUEL', value: '13376' },
  { text: 'COLEGIO SER', value: '13378' },
  { text: 'ESCUELA BASICA CUMBRE DE LOS ANDES', value: '13379' },
  { text: 'ESCUELA BASICA MUNICIPAL LOS PERALES', value: '13380' },
  { text: 'JARDIN INFANTIL RICITOS DORADOS', value: '13389' },
  { text: 'JARDIN INFANTIL MUNDO CLUB', value: '13393' },
  { text: 'CORAZON DE JESUS', value: '13394' },
  { text: 'ESCUELA ESPECIAL HOLANDA', value: '13395' },
  { text: 'CENTRO EST.Y DES.INTEGRAL DEL NINO', value: '13396' },
  { text: 'JARDIN INFANTIL TISKA MAMA', value: '13398' },
  { text: 'JARDIN INFANTIL CINDERELLA', value: '13401' },
  { text: 'JARDIN INFANTIL LOS ROBLECITOS', value: '13403' },
  { text: 'JARDIN INFANTIL MUNDO FELIZ', value: '13405' },
  { text: 'JARDIN INFANTIL PIECECITOS DE NINO', value: '13406' },
  { text: 'COLEGIO PARTICULAR ANTONIO VARAS', value: '13409' },
  { text: 'JARDIN INFANTIL RUN RUN', value: '13410' },
  { text: 'JARDIN INFANTIL FUERTE ALEGRIA', value: '13411' },
  { text: 'COLEGIO BASICO RENACER DE CERRILLOS', value: '13412' },
  { text: 'LICEO DE ADULTOS MAX PLANCK', value: '13415' },
  { text: 'COLEGIO ARTISTICO CULTURAL FORM-ARTE', value: '13416' },
  { text: 'COLEGIO ELQUI', value: '13417' },
  { text: 'COLEGIO NUESTRA SENORA DE ANDACOLLO', value: '13420' },
  { text: 'ESCUELA BASICA AMANECER', value: '13423' },
  { text: 'JARDIN INFANTIL SUE\u00c3\u2018O AZUL', value: '13424' },
  { text: 'COLEGIO SAN LUCAS', value: '13426' },
  { text: 'COLEGIO LOS CONQUISTADORES', value: '13427' },
  { text: 'ESCUELA BASICA SAN ISIDRO DE CUZ CUZ', value: '13428' },
  { text: 'COLEGIO MONTEGRANDE', value: '13437' },
  { text: 'COLEGIO ESPANOL', value: '13445' },
  { text: 'MARIA EDUCA', value: '13446' },
  { text: 'JARDIN INFANTIL JESUS DE NAZARET', value: '13451' },
  { text: 'JARDIN INFANTIL MICHEY MOUSE', value: '13453' },
  { text: 'ESCUELA ESPECIAL ILLAPEL', value: '13455' },
  { text: 'COLEGIO SAINT GERMAIN', value: '13456' },
  { text: 'JARDIN INFANTIL MI BEBITO', value: '13457' },
  { text: 'JARDIN INFANTIL CAMPANITA', value: '13459' },
  { text: 'JARDIN INFANTIL  HAPPY HOUSE', value: '13460' },
  { text: 'LICEO CARMEN AURORA RODRIGUEZ HENRIQUEZ', value: '13461' },
  { text: 'COLEGIO CERRO GUAYAQUIL', value: '13462' },
  { text: 'COLEGIO CARLOS CONDELL DE LA HAZA', value: '13463' },
  { text: 'ESCUELA BASICA JESUS NAZARENO', value: '13465' },
  { text: 'COLEGIO SANTA MARIA DEL REFUGIO', value: '13467' },
  { text: 'JARDIN INFANTIL GRAN MOZART', value: '13469' },
  { text: 'ESC. ESP. DE TRAST. DE LA COM.EUSEBIO LILLO', value: '13470' },
  { text: 'ESC. ESPECIAL DE TRAN. DE LA COM. SANTA LUISA', value: '13471' },
  { text: 'ESC. ESP. DE TRANST. DE LA COM. NUEVO AMANECE', value: '13473' },
  { text: 'COLEGIO LA MISION', value: '13474' },
  { text: 'COLEGIO SAN MARTIN DE PORRES', value: '13475' },
  { text: 'JARDIN INFANTIL EL MUNDO DE LOS PELUSITAS', value: '13476' },
  { text: 'ESCUELA ESP.DE TRAST.DE LA COM. EL SENDERO', value: '13479' },
  { text: 'ESCUELA ESPECIAL PALABRITAS', value: '13480' },
  { text: 'ESCUELA ESPECIAL GALILEO', value: '13481' },
  { text: 'ESC. ESPECIAL DE TRAST. DE LA COMUN. PLUMA D', value: '13482' },
  { text: 'ESCUELA ESP. TRANS. DE LA COM. ENTREMUNDOS', value: '13484' },
  { text: 'ESCUELA ESPECIAL HABLA PALABRA', value: '13485' },
  { text: 'JARDIN INFANTIL EL RINCON DE LOS NINOS', value: '13487' },
  { text: 'ESCUELA ESP. DE TRANS. DE LA COM. NUEVA BELEN', value: '13488' },
  { text: 'COLEGIO MARIA EDUCA', value: '13489' },
  { text: 'COLEGIO ALTAZOR', value: '13491' },
  { text: 'JARDIN INFANTIL PIECITO', value: '13492' },
  { text: 'ESCUELA DE LENGUAJE RENACER', value: '13493' },
  { text: 'ESCUELA BASICA LA VILLA', value: '13494' },
  { text: 'COLEGIO DE ADULTOS ADOLFO KOLPING', value: '13496' },
  { text: 'ESCUELA BASICA ALTOS DE PECHEN', value: '13498' },
  { text: 'ESC.ESP.DE TRANST. DE LA COM. CEDIN - TIERRA', value: '13499' },
  { text: 'ESC.ESP.DE TRANST.DE LA COM. CUNA DE CONDORES', value: '13500' },
  { text: 'JARDIN INFANTIL PUCARA', value: '13501' },
  { text: 'COLEGIO VALENTIN LETELIER', value: '13503' },
  { text: 'COLEGIO SAN LORENZO', value: '13504' },
  { text: 'ESC.ESP.DE TRANST.ESPEC. DE LENG. SAN SEBASTI', value: '13505' },
  { text: 'COLEGIO AYELEN', value: '13506' },
  { text: 'JARDIN INFANTIL LES EFANTS', value: '13507' },
  { text: 'JARDIN INFANTIL CRISTIANO EL ARCA DE NOE', value: '13509' },
  { text: 'ESC.ESP.DE TRANST. ESPEC. DEL LENGUAJE GUAYAS', value: '13510' },
  { text: 'COLEGIO JOAQUIN VICU\u00c3\u0090A LARRAIN', value: '13512' },
  { text: 'INSTITUTO DEMETRIO TELLO ULLOA', value: '13513' },
  { text: 'COLEGIO MARIA DE ANDACOLLO', value: '13514' },
  { text: 'ESCUELA ESPECIAL Y LENGUAJE ROCIO', value: '13515' },
  { text: 'ESC. ESP. DEL TRASTORNO DEL LENGUAJE SAN GUIL', value: '13517' },
  { text: 'COLEGIO ARAUCO', value: '13518' },
  { text: 'JARDIN INFANTIL LOS ENANITOS', value: '13522' },
  { text: 'ESCUELA ESPECIAL ALCAZAR', value: '13524' },
  { text: 'COLEGIO OLIMPO', value: '13525' },
  { text: 'COLEGIO AGUILA MAYOR', value: '13527' },
  { text: 'COLEGIO ADULTOS SAN LUIS', value: '13528' },
  { text: 'JARDIN INFANTIL EL BOSQUE', value: '13529' },
  { text: 'ESC. DE TRAST. ESPECIFICOS DE  LEGUAJE JOSE M', value: '13530' },
  { text: 'ESC. ESP.TRASTORNO LENGUAJE MANATI', value: '13531' },
  { text: 'ESCUELA DE PARVULOS HAPPY KINDER', value: '13532' },
  { text: 'ESC.ESP.DE TRAST.ESPECIFICOS DEL LENGUAJE AYE', value: '13534' },
  { text: 'COLEGIO CERRO GRANDE', value: '13535' },
  { text: 'JARDIN INFANTIL SANTA ANNA', value: '13536' },
  { text: 'JARDIN INFANTIL PARVUS', value: '13538' },
  { text: 'ESC. ESP. DE TRAS. ESP. DEL LENGUAJE LATINOAM', value: '13539' },
  { text: 'ESC.ESP.DE LENG.HABLA PALABRA NORTE', value: '13540' },
  { text: 'ESCUELA ESPECIAL SANTA ELENA', value: '13541' },
  { text: 'COLEGIO IRMA SALAS SILVA', value: '13542' },
  { text: 'ESCUELA ESPECIAL KIMELTU', value: '13543' },
  { text: 'JARDIN INFANTIL CASCANUECES', value: '13544' },
  { text: 'ESCUELA BASICA SAN FRANCISCO DE BORJA', value: '13545' },
  { text: 'COLEGIO MANANTIAL', value: '13551' },
  { text: 'COLEGIO CRISTIANO LA SERENA', value: '13552' },
  { text: 'COLEGIO SANTA HELENA COLLEGE', value: '13553' },
  { text: 'ESCUELA ESPECIAL KREATIVITAS', value: '13554' },
  { text: 'ESCUELA BASICA REPUBLICA DE ITALIA', value: '13557' },
  { text: 'INSTITUTO DE ADM. Y COMERCIO ESTADO DE ISRAEL', value: '13558' },
  { text: 'ESCUELA REPUBLICA DE GRECIA', value: '13559' },
  { text: 'ESCUELA PADRE ALBERTO HURTADO CRUCHAGA', value: '13560' },
  { text: 'ESCUELA JUAN PABLO II', value: '13562' },
  { text: 'COLEGIO NUESTRA SE\u00c3\u2018ORA DEL ROSARIO', value: '13563' },
  { text: 'COLEGIO MANANTIALES DE ELQUI', value: '13565' },
  { text: 'ESCUELA  DE LENGUAJE SAN LORENZO', value: '13566' },
  { text: 'ESC.ESP.DE TRAS.ESPEC. DEL LENGUAJE RINCON DE', value: '13567' },
  { text: 'ESC.ESP.DE TRAST.ESPEC.DE LENGUAJE AMANKAY', value: '13568' },
  { text: 'ESCUELA ESPECIAL RAYEN', value: '13569' },
  { text: 'ESCUELA MUNICIPAL VILLA SANTA ROSA', value: '13570' },
  { text: 'JARDIN INFANTIL EL MUNDO DE LOS PELUSITAS', value: '13572' },
  { text: 'COLEGIO TAMELCURA', value: '13573' },
  { text: 'COLEGIO CERVANTES', value: '13574' },
  { text: 'ESC.ESP.DE TRAST.ESPEC.DEL LENGUAJE PADRE ALB', value: '13575' },
  { text: 'LICEO TECNICO FEMENINO LAS COMPANIAS', value: '13576' },
  { text: 'ESC. ESP. DE TRAS. ESPEC. DEL LENG. MABEL CON', value: '13577' },
  { text: 'COLEGIO SAN ISIDRO', value: '13579' },
  { text: 'COLEGIO PAULO FREIRE', value: '13580' },
  { text: 'COLEGIO TECNICO PROFESIONAL FLORENCIA NIGHTIN', value: '13582' },
  { text: 'ESCUELA PARA ADULTOS AMIGOS DEL PADRE HURTADO', value: '13584' },
  {
    text: 'JARDIN INFANTIL MI PEQUE\u00c3\u2018O SUE\u00c3\u2018O AZUL',
    value: '13585',
  },
  { text: 'COLEGIO BASICO CHRIST SCHOOL', value: '13586' },
  { text: 'COLEGIO ESPANOL FERMIN ZUNIGA', value: '13587' },
  { text: 'JARDIN INFANTIL PASO A PASITO', value: '13588' },
  { text: 'JARDIN INFANTIL CACHORRITOS', value: '13589' },
  { text: 'LICEO EL INGENIO', value: '13590' },
  { text: 'CENTRO INTEGRAL DE ADULTOS LIMARI', value: '13591' },
  { text: 'LICEO TECNICO PROF. ADULTOS CORESOL DE LA SER', value: '13592' },
  { text: 'COLEGIO EUSEBIO LILLO PUNTA MIRA', value: '13593' },
  { text: 'ESCUELA ESPECIAL DEL LENGUAJE UNIVERSO', value: '13594' },
  { text: 'JARDIN INFANTIL SAN LUIS', value: '13596' },
  { text: 'ESCUELA ESP DE TRASTORNO DEL LENGUAJE VALLE D', value: '13597' },
  { text: 'ESCUELA ESPECIAL DEL ARTE DE HABLAR', value: '13598' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE MUNDO DE PALABRA', value: '13599' },
  { text: 'ESCUELA ESPECIAL DEL LENGUAJE BORDEMAR', value: '13601' },
  { text: 'ESCUELA ESPECIAL KONA - VARUA', value: '13602' },
  { text: 'COLEGIO RAKIDUAM', value: '13604' },
  { text: 'COLEGIO LEONARDO DA VINCI - VICU\u00c3\u0090A', value: '13606' },
  { text: 'ESC. ESPECIAL DE LENGUAJE ALTO DEL MIRAMAR', value: '13607' },
  { text: 'COLEGIO GOLDEN HIND SCHOOL', value: '13608' },
  { text: 'ESCUELA  ESP. DE LENGUAJE CORDILLERA', value: '13609' },
  { text: 'COLEGIO  INTERCULTURAL', value: '13610' },
  { text: 'CENTRO DE EDUC. INTEGRAL DE ADULTOS ANDACOLLO', value: '13611' },
  { text: 'COLEGIO JOSE MARTI PEREZ', value: '13612' },
  { text: 'ESC. ESP. DE LENGUAJE HISPANOAMERICANA', value: '13613' },
  { text: 'JARDIN INFANTIL PEQUE\u00c3\u2018O MUNDO', value: '13616' },
  { text: 'JARDIN INFANTIL RUISE\u00c3\u2018OR', value: '13617' },
  { text: 'JARDIN INFANTIL CHARLIE BROWN', value: '13618' },
  { text: 'JARDIN INFANTIL PADRE JOSE', value: '13619' },
  { text: 'JARDIN INFANTIL MI PEQUE\u00c3\u2018O GENIO', value: '13620' },
  { text: 'COLEGIO DISCOVERY', value: '13621' },
  { text: 'JARDIN INFANTIL ANDALUE', value: '13622' },
  { text: 'ESC.ESP. DE LENGUAJE SAN CARLOS', value: '13623' },
  { text: 'ESC. ESPECIAL DE LENGUAJE GEMITA DE GALGANI', value: '13625' },
  { text: 'COLEGIO SAN LUIS', value: '13626' },
  { text: 'COLEGIO BASICO SAN SEBASTIAN', value: '13627' },
  { text: 'JARDIN INFANTIL MELODIA', value: '13629' },
  { text: 'ESCUELA ESPECIAL DESPERTARES', value: '13630' },
  { text: 'COLEGIO HORIZONTES', value: '13632' },
  { text: 'ESCUELA SAN MARINO COLLEGE', value: '13633' },
  { text: 'JARDIN INFANTIL LOS PATRONCITOS', value: '13634' },
  { text: 'ESC.ESP.DE LENG.HORIZONTES DE PALABRAS', value: '13636' },
  { text: 'COLEGIO HELLEN KELLER PE\u00c3\u2018UELAS', value: '13637' },
  { text: 'LICEO MIXTO LOS ANDES', value: '14201' },
  { text: 'COLEGIO PANQUEHUE', value: '14202' },
  { text: 'LICEO AGRICOLA DE QUILLOTA', value: '14206' },
  { text: 'ESCUELA ESPECIAL HELLEN KELLER', value: '14209' },
  { text: 'COLEGIO BECARB II', value: '14210' },
  { text: 'SAINT MARY SCHOOL', value: '14212' },
  { text: 'ESCUELA DE PARVULOS VALLE DE NARAU', value: '14213' },
  { text: 'LICEO AGRICOLA CHRISTA MOCK', value: '14215' },
  { text: 'LICEO AGRICOLA DE LONGOTOMA', value: '14216' },
  { text: 'ESCUELA DE PARVULOS BUGS BUNNY', value: '14219' },
  { text: 'ESC  PART  KORC SCHOOL', value: '14224' },
  { text: 'INSTITUTO DE CAPACITACION TEC.PROF.ITPSA', value: '14225' },
  { text: 'COLEGIO LITTLE HOME', value: '14233' },
  { text: 'ESCUELA PART. LORENZO LUZURIAGA', value: '14234' },
  { text: 'COL.NUESTRA SRA.DE LAS MERCEDES', value: '14237' },
  { text: 'COLEGIO MACUL', value: '14240' },
  { text: 'COLLEGE SAINT ANDRE', value: '14247' },
  { text: 'COLEGIO ALBAMAR', value: '14249' },
  { text: 'INSTITUTO CULTURAL Y DE EDUC  PERMANENTE', value: '14250' },
  { text: 'ESCUELA DE PARVULOS GIRASOL', value: '14251' },
  { text: 'ESCUELA DE PARVULOS KINTU', value: '14254' },
  { text: 'ESCUELA DE PARVULOS LOBITO MARINO', value: '14255' },
  { text: 'ESCUELA DE PARVULOS CARACOLITO DE MAR', value: '14256' },
  { text: 'ESCUELA DE PARVULOS LOS DELFINES', value: '14257' },
  { text: 'ESC. DE PARVULOS PECESITOS DE COLORE', value: '14263' },
  { text: 'ESCUELA  SAINT BENEDICT COLLEGE', value: '14265' },
  { text: 'COLEGIO NAZCA BELEN', value: '14266' },
  { text: 'ESCUELA DE PARVULOS MIGUEL FENOLLERA', value: '14268' },
  { text: 'ESCUELA DE PARVULOS PELUSITAS', value: '14269' },
  { text: 'COLEGIO GOBERNADOR CONCHA Y SALVATIERRA', value: '14270' },
  { text: 'ESCUELA ESPECIAL HUMBERTO MOATH', value: '14271' },
  { text: 'ESCUELA DE PARVULOS NADINO', value: '14275' },
  { text: 'COLEGIO SAGRADA FAMILIA', value: '14280' },
  { text: 'LICEO OBISPO ANTONIO CASTRO', value: '14281' },
  { text: 'COLEGIO ESPECIAL BRILLO DE LUNA', value: '14283' },
  { text: 'COLEGIO NUEVA PROVIDENCIA', value: '14288' },
  { text: 'COLEGIO ADVENTISTA', value: '14289' },
  { text: 'COLEGIO  LOUIS LE GRAND', value: '14292' },
  { text: 'COLEGIO ADVENTISTA ANEXO', value: '14299' },
  { text: 'CENTRO DE CAPACITACION LABORAL', value: '14300' },
  { text: 'CENTRO DE CAPACIT. E INSERCION LABORAL JUAN P', value: '14303' },
  { text: 'ESCUELA PARTICULAR ARBOLEDA', value: '14304' },
  { text: 'CENTRO DE TRATAMIENTO AUTISTA', value: '14305' },
  { text: 'COLEGIO LATINO AMERICANO', value: '14307' },
  { text: 'COLEGIO ITALIANO SAN PEDRO', value: '14308' },
  { text: 'CENTRO INTEGRAL EDUCACIONAL LINDA CORREA', value: '14310' },
  { text: 'COLEGIO THOMAS ALVA EDISON', value: '14314' },
  { text: 'COLEGIO VICTOR ANTONIO', value: '14315' },
  { text: 'COLEGIO EMANUEL', value: '14316' },
  { text: 'ESCUELA DE PARVULOS CRISPA KA', value: '14318' },
  { text: 'ESCUELA DE PARVULOS ROSAM', value: '14322' },
  { text: 'COLEGIO JOSEFINA MAGASICH ARZE', value: '14323' },
  { text: 'COLEGIO WILLIAM JAMES', value: '14324' },
  { text: 'LICEO PARROQUIAL SAN ANTONIO GOMEZ CARRENO', value: '14328' },
  { text: 'ANEXO LICEO JOSE MANUEL BORGONO NUNEZ', value: '14329' },
  { text: 'ESCUELA  BASICA  ARTURO PRAT', value: '14330' },
  { text: 'COLEGIO FRAY ANDRES', value: '14331' },
  { text: 'COLEGIO PEHUEN', value: '14332' },
  { text: 'LICEO TECN. PROF. OBISPO RAFAEL LIRA INFANTE', value: '14336' },
  { text: 'INST.DEL DISCAP.VISUAL ANTONIO MOSQUETE', value: '14347' },
  { text: 'COLEGIO ESPIRITU SANTO', value: '14348' },
  { text: 'COLEGIO SAINT GREGORY COLLEGE', value: '14351' },
  { text: 'ESCUELA DE PARVULOS PALOMA', value: '14353' },
  { text: 'ESCUELA DE PARVULOS LILIPUT', value: '14354' },
  { text: 'COLEGIO LOS REYES', value: '14359' },
  { text: 'ESC.ESPEC. ARCO IRIS BAJO EL SOL ANEXO', value: '14362' },
  { text: 'COLEGIO JORGE WILLIAMS', value: '14364' },
  { text: 'COLEGIO CHARLES DICKENS', value: '14365' },
  { text: 'INSTITUTO BALDOR', value: '14371' },
  { text: 'KING EDWARDS SCHOOL 1', value: '14372' },
  { text: 'COLEGIO DIVINA MAESTRA', value: '14375' },
  { text: 'COLEGIO SAN CARLOS', value: '14376' },
  { text: 'SANTO DOMINGO COUNTRY SCHOOL', value: '14377' },
  { text: 'CAERNARFON COLLEGE', value: '14380' },
  { text: 'COLEGIO EL VALLE DE CASABLANCA', value: '14381' },
  { text: 'ESCUELA DE PARVULOS TIRITAS DE PAPEL II', value: '14386' },
  { text: 'COLEGIO SAN NICOLAS EL OLIVAR', value: '14387' },
  { text: 'CTRO INTEGRAL EDUCAC LINDA CORREA', value: '14392' },
  { text: 'ESCUELA DE PARVULOS SAN LUIS', value: '14394' },
  { text: 'COLEGIO EDUPAC', value: '14395' },
  { text: 'COLEGIO MANNEKEN PIS', value: '14396' },
  { text: 'COLEGIO CRISTIANO DE QUILLOTA', value: '14397' },
  { text: 'CENTRO DE ATENCION ANDALUE', value: '14398' },
  { text: 'LICE TEC.CARLOS ALESSANDRI ALTAMIRANO', value: '14400' },
  { text: 'COLEGIO MONTESSORI YERPUN', value: '14402' },
  { text: 'ESCUELA PARV  ESTRELLITAS DE BELEN', value: '14409' },
  { text: 'ESCUELA DE PARVULOS ANNY SCHOOL', value: '14411' },
  { text: 'COLEGIO SAN PABLO', value: '14412' },
  { text: 'ESCUELA SANTA CLARA', value: '14413' },
  { text: 'COLEGIO EDUCENTER', value: '14414' },
  { text: 'COLEGIO PAIDOS', value: '14417' },
  { text: 'COLEGIO PANAL  ANEXO', value: '14418' },
  { text: 'COLEGIO EL ALBA', value: '14420' },
  { text: 'CENTRO DE EDUCACION DE ADULTOS  CEAVI', value: '14421' },
  { text: 'ESCUELA DE PARVULOS BAMBI', value: '14423' },
  { text: 'ESCUELA DE PARVULOS GARFILHO', value: '14432' },
  { text: 'COLEGIO LITTLE HOME KIDS', value: '14440' },
  { text: 'ESCUELA DE PARVULOS DUCKY S GARDEN', value: '14444' },
  { text: 'ESCUELA DE PARVULOS   BAMBI', value: '14446' },
  { text: 'ESCUELA DE PARVULOS   PERSONITAS', value: '14447' },
  { text: 'COLEGIO LUTERANO CONCORDIA', value: '14452' },
  { text: 'COLEGIO LOS LIBERTADORES', value: '14453' },
  { text: 'ESCUELA DE PARVULOS LOS CLAVELES', value: '14457' },
  { text: 'ESCUELA DE PARVULOS CAMPANITA', value: '14459' },
  { text: 'ESCUELA PARVULOS PIECECITOS DE NINO', value: '14460' },
  { text: 'CENTRO DE ESTUDIOS SAN IGNACIO', value: '14462' },
  { text: 'CTRO.INTEGRAL DE EDUCACION ALBORADA', value: '14463' },
  { text: 'COLEGIO VALLE DEL ACONCAGUA', value: '14476' },
  { text: 'ESCUELA BASICA MUNICIPAL ARAUCARIA', value: '14479' },
  { text: 'COLEGIO NUEVO HORIZONTE', value: '14482' },
  { text: 'COLEGIO MAESE DA VINCI', value: '14487' },
  { text: 'COLEGIO MANANTIAL', value: '14490' },
  { text: 'CTRO.EDUC.ADULTOS PEDRO DE VALDIVIA', value: '14492' },
  { text: 'ESC. ESPECIAL SAN JUAN DE DIOS', value: '14493' },
  { text: 'COLEGIO EVANGELICO LABRANZA DE DIOS', value: '14494' },
  { text: 'ESC. DE PARVULOS DUENDE MELODIA', value: '14497' },
  { text: 'ESCUELA DE PARVULOS SOL Y LUNA', value: '14499' },
  { text: 'ESC. DE LENGUAJE PIPAN VINA', value: '14500' },
  { text: 'COLEGIO CURIMON', value: '14502' },
  { text: 'ESCUELA DE PARVULOS KORC', value: '14503' },
  { text: 'COLEGIO CRISTIANO CON-CON', value: '14504' },
  { text: 'COLEGIO NUESTRO TIEMPO', value: '14507' },
  { text: 'ESCUELA DE PARVULOS TIA PATRICIA N_ 2', value: '14509' },
  { text: 'COLEGIO SANTA BARBARA DE LA REINA', value: '14511' },
  { text: 'ESCUELA DE PARVULOS FANTASIA', value: '14512' },
  { text: 'ESCUELA DE PARVULOS NIDO DE LUNA', value: '14513' },
  { text: 'COLEGIO EL ARRAYAN', value: '14514' },
  { text: 'COLEGIO GABRIELA MISTRAL', value: '14515' },
  { text: 'ESCUELA  ESPECIAL CANEC', value: '14516' },
  { text: 'ESCUELA TRASTORNOS DE COMUNICACION APOQUINDO', value: '14517' },
  { text: 'COLEGIO BUENAVENTURA JOGLAR AMANDI', value: '14518' },
  { text: 'ESCUELA DE PARVULOS STAR GARDEN', value: '14520' },
  { text: 'ESC. SAINT PATRICK SCHOOL', value: '14521' },
  { text: 'LIONS SCHOOL', value: '14523' },
  { text: 'COLEGIO LOS CAPULLITOS', value: '14524' },
  { text: 'CTRO.EDUC.Y CAPAC.AD.FCO.BILBAO', value: '14525' },
  { text: 'COLEGIO ALONSO DE QUINTERO', value: '14526' },
  { text: 'KING EDWARDS SCHOOL 2', value: '14527' },
  { text: 'ESC.ESPEC.LENG. MIS NUEVAS PALABRAS', value: '14531' },
  { text: 'COLEGIO CRISTIANO LOS PINOS', value: '14533' },
  { text: 'COLEGIO AMANCAY LIMACHE', value: '14534' },
  { text: 'COLEGIO MILLAHUE', value: '14535' },
  { text: 'COLEGIO ADONAY PUKALAN', value: '14537' },
  { text: 'COL.SANTO DOMINGO DE GUZMAN', value: '14538' },
  { text: 'ESCUELA DE LENGUAJE SANTA INES', value: '14539' },
  { text: 'COLEGIO PATRICIO LYNCH', value: '14541' },
  { text: 'CENTR.ESC.TRAT.DEL LENGUAJE PAIHUEN', value: '14542' },
  { text: 'ESCUELA DE PARVULOS ITALITO', value: '14543' },
  { text: 'COLEGIO  MERCEDES LEMUS ZAMORA', value: '14545' },
  { text: 'ESCUELA RUBEN DARIO', value: '14546' },
  { text: 'CENTRO DE ESTUDIOS DALBADIE', value: '14547' },
  { text: 'COLEGIO LOS AROMOS', value: '14548' },
  { text: 'ESCUELA DE PARVULOS TIA XIMENA', value: '14550' },
  { text: 'ESCUELA DE LENGUAJE LOS ALMENDRALES', value: '14551' },
  { text: 'COLEGIO SAN NICOLAS DE CANAL CHACAO', value: '14552' },
  { text: 'CTRO.DE EST.DES.Y TRAT.DEL LENGUAJE LOGOS', value: '14554' },
  { text: 'CTRO DE ESTIMULACION TEMPRANA LAS ROSAS', value: '14557' },
  { text: 'ESCUELA ESPECIAL LOURDES', value: '14559' },
  { text: 'ESCUELA DE PARVULOS SOL NACIENTE', value: '14561' },
  { text: 'VERDOYHAM SCHOOL', value: '14565' },
  { text: 'ESCUELA DE PARVULOS SAN GABRIEL', value: '14566' },
  { text: 'ESCUELA DEL LENGUAJE  NACAREL', value: '14569' },
  { text: 'ESC.ESPECIAL DE LENGUAJE PALABRITAS', value: '14572' },
  { text: 'ESC. RURAL PARA EL CAJON DE SAN PEDRO', value: '14573' },
  { text: 'CTRO.EDUC.Y ATENC INTEG A LA DIVERSIDAD', value: '14577' },
  { text: 'ESC.TRAST.DE LA COM. Y LENG. LAS VIOLETAS', value: '14578' },
  { text: 'ESCUELA DE PARVULOS CREPITO', value: '14579' },
  { text: 'COLEGIO BOSTON', value: '14580' },
  { text: 'ESCUELA DE PARVULOS CLARITO DE SOL', value: '14583' },
  { text: 'COLEGIO SAN IGNACIO DE LOYOLA', value: '14587' },
  {
    text: 'ESCUELA DE TRAST. DE LENGUAJE CELAN PAICAV\u00c3\u009d',
    value: '14588',
  },
  { text: 'COLEGIO TRAST.DE LA COMUNIC MATICES', value: '14589' },
  { text: 'CTRO INTEG.EDUCAC. AGUA Y SOL', value: '14590' },
  { text: 'COLEGIO DE ADULTOS FRITZ ENCALADA', value: '14592' },
  { text: 'COLEGIO VALLE DE ARAUCO', value: '14593' },
  { text: 'COLEGIO QUILLOTA TERRANOVA', value: '14594' },
  { text: 'COLEGIO POETA DANIEL DE LA VEGA', value: '14599' },
  { text: 'COLEGIO SPEIRO', value: '14601' },
  { text: 'COLEGIO SIGLO  XXI', value: '14602' },
  { text: 'COLEGIO PUERTO PAZ', value: '14606' },
  { text: 'COLEGIO JUANITA FERNANDEZ', value: '14608' },
  { text: 'COLEGIO CARDENAL OVIEDO', value: '14609' },
  { text: 'ESCUELA DE PARVULOS PRINCIPITO', value: '14616' },
  { text: 'COLEGIO ANA ROMAN WALDNER', value: '14621' },
  { text: 'COLEGIO SAN AGUSTIN', value: '14622' },
  { text: 'CENTRO DE ESTUDIOS IGNACIO DOMEYKO', value: '14625' },
  { text: 'CENTRO DE ESTUDIOS IBERO CHILE', value: '14628' },
  { text: 'COLEGIO CASTELIANO', value: '14629' },
  { text: 'ESCUELA DE PARVULOS HAPPY KIDS', value: '14630' },
  { text: 'ESCUELA DE PARVULOS SANTA TERESITA', value: '14631' },
  { text: 'ESCUELA DE PARVULOS HEIDI', value: '14633' },
  { text: 'COLEGIO DE LENGUAJE EVERITO', value: '14636' },
  { text: 'COLEGIO HYATT', value: '14637' },
  { text: 'ESC.DE TRAST.DE LA COMUNIC.YAMANKI', value: '14638' },
  { text: 'COLEGIO GHERARDELLI', value: '14639' },
  { text: 'COLEGIO  PAULA  VIVANCO', value: '14641' },
  { text: 'COLEGIO CRISTIANO EMBAJADORES DEL REY', value: '14642' },
  { text: 'CASABLANCA BILINGUAL SCHOOL', value: '14643' },
  { text: 'ESCUELA SANTA MARIA DE LA ESPERANZA', value: '14645' },
  { text: 'COLEGIO SAN FRANCISCO DE ASIS', value: '14649' },
  { text: 'COLEGIO INGLES ALTAZOR', value: '14650' },
  { text: 'NUEVO COLEGIO CAMBRIDGE', value: '14654' },
  { text: 'ESCUELA ESPECIAL AMOR Y ESPERANZA', value: '14655' },
  { text: 'COL EXPERIM.NINOS CANTORES DE VINA D', value: '14657' },
  { text: 'CTRO.ESTIMULAC.DEL LENGUAJE ANTIYAL', value: '14658' },
  { text: 'COLEGIO INGLES SAN ANFELI', value: '14659' },
  { text: 'C E D I P', value: '14662' },
  { text: 'ESCUELA ESPECIAL ARAMDA', value: '14663' },
  { text: 'ESCUELA PARVULOS MUNDO FELIZ', value: '14664' },
  { text: 'COL.AUD.Y LENG.NTRA. SRA.DE LOURDES', value: '14666' },
  { text: 'CENTRO EDUCACION DE ADULTOS PLACILLA', value: '14668' },
  { text: 'ESCUELA DE PARVULOS GOTITA DE LUNA', value: '14669' },
  { text: 'COLEGIO SAN SEBASTIAN', value: '14670' },
  { text: 'COLEGIO BLAISE PASCAL', value: '14672' },
  { text: 'COLEGIO NUEVO MILENIO', value: '14674' },
  { text: 'COLEGIO SAN SEBASTIAN DE AKIVI', value: '14675' },
  { text: 'COLEGIO CANEC VALPARAISO', value: '14676' },
  { text: 'COLEGIO CAPITAN ARTURO PRAT CHACON', value: '14677' },
  { text: 'ESCUELA JUAN DE SAAVEDRA', value: '14678' },
  { text: 'ESCUELA DE PARVULOS PEQUEGENIOS', value: '14681' },
  { text: 'COLEGIO CENTILEN', value: '14685' },
  { text: 'ESCUELA DE PARVULOS LOS PUMITAS', value: '14686' },
  { text: 'COLEGIO GEA', value: '14687' },
  { text: 'ESC DE PARVULOS MI PEQUENO CLUB', value: '14690' },
  { text: 'ESCUELA DE PARVULOS GABRIELITA', value: '14691' },
  { text: 'ESC.ESPEC.DE LENGUAJE NOGALES', value: '14692' },
  { text: 'ESCUELA DE LENGUAJE AMANKAY', value: '14693' },
  { text: 'ESC. PARVULOS MI PEQUENO MUNDO', value: '14694' },
  { text: 'ESCUELA DE PARVULOS PINIPON', value: '14695' },
  { text: 'COLEGIO CORDILLERA', value: '14697' },
  { text: 'ESCUELA DE LENGUAJE LAS VEGAS', value: '14698' },
  { text: 'COLEGIO FENIX', value: '14699' },
  { text: 'ESCUELA DE LENGUAJE OTE MOANA', value: '14702' },
  { text: 'THE KINGSTOWN SCHOOL', value: '14703' },
  { text: 'ESC.DE LENG. SEMBRANDO PALABRAS', value: '14705' },
  { text: 'COLEGIO SAN FRANCISCO', value: '14706' },
  { text: 'COLEGIO PORTALIANO', value: '14707' },
  { text: 'ESC ESTER DE LA TORRE VILLARROEL', value: '14708' },
  { text: 'CTRO. ATENC INT.DE AUDIC.Y LENG.MARIA MADRE', value: '14709' },
  { text: 'CTRO DE ESTUDIOS ALONSO DE ERCILLA', value: '14711' },
  { text: 'COLEGIO HORIZONTE', value: '14714' },
  { text: 'COLEGIO PRINCIPE DE ASTURIAS', value: '14718' },
  { text: 'MATURANA SCHOOL', value: '14719' },
  { text: 'ESC.DE LENGUAJE NUEVO AMANECER', value: '14721' },
  { text: 'ESCUELA DE PARVULOS SOLRIE', value: '14723' },
  { text: 'COLEGIO VALLE DE QUILLOTA', value: '14724' },
  { text: 'ESCUELA DE LENGUAJE NAYEL', value: '14725' },
  { text: 'ESCUELA DE LENGUAJE ARTYLEN', value: '14726' },
  { text: 'ESCUELA DE PARVULOS NENITA', value: '14727' },
  { text: 'JARDIN INFANTIL  ANDALUE', value: '14728' },
  { text: 'ESC. DE LENGUAJE ARINGA POKI', value: '14730' },
  { text: 'CTRO INTEG EDUC.NTRA.SRA.DEL ENCUENTRO', value: '14731' },
  { text: 'ESCUELA DE LENGUAJE SAN BENITO', value: '14733' },
  { text: 'ESCUELA DE PARVULOS TIA LUZ', value: '14735' },
  { text: 'JARDIN INFANTIL MI OSITO', value: '14736' },
  { text: 'CTRO EDUCAT INTEGRAL RAYEN', value: '14737' },
  { text: 'JARDIN INFANTIL TRES OSITOS', value: '14738' },
  { text: 'ESCUELA DE LENGUAJE TRIGAL', value: '14739' },
  { text: 'ESCUELA DE LENGUAJE PALABRITAS', value: '14742' },
  { text: 'JARDIN INFANTIL MIS COLORES', value: '14744' },
  { text: 'JARDIN INFANTIL MI PEQUENO MUNDO', value: '14747' },
  { text: 'JARDIN INFANTIL ABRACADABRA', value: '14748' },
  { text: 'COLEGIO BILBAO - EIM.', value: '14749' },
  { text: 'COLEGIO GREENLAND SAN FELIPE', value: '14750' },
  { text: 'COLEGIO MONTEALEGRE', value: '14753' },
  { text: 'JARDIN INFANTIL JUNTITOS', value: '14754' },
  { text: 'ESCUELA DE LENGUAJE MIS VIOLETAS', value: '14755' },
  { text: 'JARDIN INFANTIL TERRALEGRE', value: '14756' },
  { text: 'CENTRO EDUC.PARA SORDOS KETRAWE', value: '14757' },
  { text: 'JARDIN INFANTIL ANDALICAN', value: '14758' },
  { text: 'COLEGIO ADULTOS ALICIA MONCKEBERG', value: '14759' },
  { text: 'COLEGIO PADRE ZANANDREA', value: '14760' },
  { text: 'COLEGIO DE ADULTOS ISAAC NEWTON', value: '14761' },
  { text: 'COLEGIO PARTICULAR ANDES-CHILE', value: '14762' },
  { text: 'ESCUELA DE LENGUAJE RAYEN', value: '14765' },
  { text: 'ESC. DE LENGUAJE TERRANOVA', value: '14766' },
  { text: 'ESCUELA DE LENGUAJE PAIDEIA', value: '14767' },
  { text: 'CTRO.ESTIM.DEL LENG.NUEVA ESPERANZA', value: '14769' },
  { text: 'COL.PRECURSOR FRANCISCO DE MIRANDA', value: '14770' },
  { text: 'COLEGIO GUARDIAMARINA RIQUELME', value: '14773' },
  { text: 'ESCUELA DE LENGUAJE SAN FRANCISCO', value: '14774' },
  { text: 'COLEGIO MONTESOL 2', value: '14775' },
  { text: 'JARDIN INFANTIL NUBESOL', value: '14776' },
  { text: 'COLEGIO SAN NICOLAS', value: '14778' },
  { text: 'COLEGIO MAR ABIERTO', value: '14779' },
  { text: 'ESC.DE LENGUAJE PALABRAS MAGICAS', value: '14781' },
  { text: 'COLEGIO ANTUMAPU', value: '14782' },
  { text: 'COLEGIO NUEVA ERA SIGLO XXI', value: '14783' },
  { text: 'CENTRO CAID LTDA.  CABILDO', value: '14785' },
  { text: 'ESC.TRAST. LENGUAJE RAYITO DE SOL', value: '14787' },
  { text: 'COLEGIO PAPA JUAN PABLO II', value: '14788' },
  { text: 'ESC. ESPECIAL VIDA NUEVA ELIM', value: '14789' },
  { text: 'COL.DE ADULTOS ELEUTERIO RAMIREZ', value: '14791' },
  { text: 'ESC.DE PARV.EL PEQUENO PEHUEN', value: '14792' },
  { text: 'ESCUELA DE LENGUAJE ALONQUEO', value: '14793' },
  { text: 'COLEGIO SOL DE AMERICA', value: '14796' },
  { text: 'ESCUELA DE LENGUAJE CAICURA', value: '14798' },
  { text: 'CTRO. DE RECURSOS ALTAVIDA', value: '14799' },
  { text: 'COLEGIO ESPECIAL ARMONIA', value: '14800' },
  { text: 'COLEGIO LAS PALMAS', value: '14801' },
  { text: 'ESCUELA DE LENGUAJE ARCOIRIS', value: '14802' },
  { text: 'ESCUELA DE PARVULOS SONRISAS', value: '14803' },
  { text: 'COLEGIO SAN BLAS', value: '14804' },
  { text: 'COLEGIO EL QUISCO', value: '14805' },
  { text: 'ESC.DE PARVULOS ARBOL DE LA VIDA', value: '14806' },
  { text: 'CTRO.EDUC.INTEG.ALGUIEN DENTRO DE MI', value: '14808' },
  { text: 'ESCUELA DE LENGUAJE SAN RAFAEL', value: '14809' },
  { text: 'COLEGIO DE LENGUAJE AYELEN', value: '14810' },
  { text: 'ESCUELA DE LENGUAJE PAICAVI', value: '14811' },
  { text: 'COLEG.DE LENGUAJE LOS CAPULLITOS', value: '14812' },
  { text: 'JARDIN INFANTIL CHARLIE BROWN', value: '14814' },
  { text: 'ESCUELA DE LENGUAJE EL GEKO', value: '14816' },
  { text: 'COLEGIO NUMANCIA', value: '14818' },
  { text: 'COLEGIO CERVANTINO', value: '14819' },
  { text: 'COLEGIO SANTA MARIA COLLEGE', value: '14820' },
  { text: 'JARDIN INFANTIL CORRE Y VUELA', value: '14821' },
  { text: 'COLEGIO ALBORADA DEL MAR', value: '14822' },
  { text: 'COLEGIO ANTONIO ZANOLETTI', value: '14823' },
  { text: 'COLEGIO EVEREST CENTRAL', value: '14824' },
  { text: 'NUEVO COLEGIO PART. DE CARTAGENA', value: '14825' },
  { text: 'ESC.ESTIMUL.LENG. PEQUENAS VOCES', value: '14828' },
  { text: 'ESCUELA MULTIDEFICIT AMANECER', value: '14829' },
  { text: 'ESCUELA DE PARVULOS HAPPY BOYS', value: '14831' },
  { text: 'ESC.ESP.DE LENGUAJE DIVINA MISERICORDIA', value: '14832' },
  { text: 'ESC. ESPEC.DE LENGUAJE PRINCIPITO', value: '14833' },
  { text: 'JARDIN INFANTIL GOLONRISAS', value: '14834' },
  { text: 'ESCUELA ESP. DE LENGUAJE YIREH', value: '14836' },
  { text: 'JARDIN INFANTIL BURBUJITAS', value: '14837' },
  { text: 'PARVULARIO EL OLIVITO', value: '14838' },
  { text: 'JARDIN INFANTIL NUBELUZ', value: '14839' },
  { text: 'ESC. ESPEC. NUEVA ESPERANZA', value: '14840' },
  { text: 'ESC.ESPEC. DE LENGUAJE ANTU', value: '14845' },
  { text: 'CENTRO EDUCACIONAL CEVAL LTDA.', value: '14846' },
  { text: 'JARDIN INFANTIL TIA PAOLA', value: '14847' },
  { text: 'ESCUELA PART. ANNY SCHOOL', value: '14848' },
  { text: 'ESCUELA ESPECIAL QUILLAGUA', value: '14850' },
  { text: 'JARDIN INFANTIL TIA MONONA', value: '14851' },
  { text: 'JARDIN INFANTIL LITTLE EBEN-EZER', value: '14853' },
  { text: 'ESC. ESPEC. DE LENGUAJE PEQUENINO', value: '14854' },
  { text: 'CTRO. EDUC. PARA PARVULOS HAPPY KIDS', value: '14855' },
  { text: 'SUNNYLAND SCHOOL', value: '14856' },
  { text: 'ESC. ESPECIAL DE LENGUAJE EDUCATEL', value: '14859' },
  { text: 'COLEGIO HERMANO EUGENIO EYRAUD', value: '14860' },
  { text: 'COLEGIO NAZAREO', value: '14862' },
  { text: 'ESC.ESPEC DE LENGUAJE SAN GABRIEL', value: '14863' },
  { text: 'ESCUELA ESPECIAL TALITAKUM', value: '14864' },
  { text: 'COLEGIO TECNICO ALIANZA EDUCACIONAL', value: '14865' },
  { text: 'COLEGIO ALTAZOR', value: '14866' },
  { text: 'COLEGIO LOS FORJADORES', value: '14867' },
  { text: 'LICEO TECNICO AGRICOLA OBISPO RAFAEL LIRA INF', value: '14868' },
  { text: 'JARDIN INFANTIL MINILANDIA', value: '14869' },
  { text: 'COLEGIO ENTRE VALLES', value: '14870' },
  { text: 'COLEGIO ALIMAPU', value: '14871' },
  { text: 'ESCUELA DE LENGUAJE ANTU AINIL', value: '14872' },
  { text: 'COLEGIO BAUTISTA JESUS MI REFUGIO', value: '14873' },
  { text: 'CENTRO DE ESTUDIOS FRANCISCO BILBAO', value: '14874' },
  { text: 'ESC. ESP. DE LENGUAJE JARDIN DEL MAR', value: '14876' },
  { text: 'LICEO SAN ESTEBAN', value: '14877' },
  { text: 'ESCUELA DE PARVULOS EBENEZERITO', value: '14878' },
  { text: 'LICEO PART  MIXTO SAN FELIPE', value: '14879' },
  { text: 'ESC.ESPECIAL DE LENGUAJE GIRASOL', value: '14880' },
  { text: 'LICEO ALDEA EDUCATIVA RAPA NUI', value: '14881' },
  { text: 'ESC.ESPECIAL DE LENGUAJE OROLONCO', value: '14882' },
  { text: 'ESCUELA DE LENGUAJE ALIWEN', value: '14883' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE EVERITO', value: '14884' },
  { text: 'COLEGIO LEONARDO DA VINCI', value: '14885' },
  { text: 'ESCUELA DE PARVULOS LILIPUT', value: '14886' },
  { text: 'ESCUELA ESPECIAL SOL Y LUNA', value: '14887' },
  { text: 'ESCUELA ESPECIAL CICED', value: '14890' },
  { text: 'ESCUELA PARV. PEQUE\u00c3\u2018OS CIENTIFICOS', value: '14891' },
  { text: 'ESCUELA DE PARVULOS ANDALUE', value: '14893' },
  { text: 'ESCUELA ESP. DE LENGUAJE MILLANTU', value: '14894' },
  { text: 'ESCUELA DE PARVULOS MI MUNDO', value: '14895' },
  { text: 'COLEGIO SAN HERNALDO', value: '14896' },
  { text: 'ESC. ESPECIAL DE LENGUAJE ALBERTO HURTADO', value: '14897' },
  { text: 'ESCUELA DE PARVULOS EMILITA', value: '14898' },
  { text: 'ESCUELA DE PARVULOS ALTAMIRA', value: '14899' },
  { text: 'ESCUELA DE PARVULOS ARDILLITA', value: '14900' },
  { text: 'COLEGIO SIMON BOLIVAR', value: '14901' },
  { text: 'COLEGIO FUNDADORES DE LA CALERA', value: '14902' },
  { text: 'ESC.ESP.DE LENG.NI\u00c3\u2018O DIVINO', value: '14903' },
  { text: 'ESCUELA DE PARVULOS CASCANUECES', value: '14904' },
  { text: 'ESCUELA DE PARVULOS GREENWICH', value: '14905' },
  { text: 'ESCUELA DE PARVULOS ALLANAY', value: '14906' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ANTU', value: '14907' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE PAIHUEN-MAPU', value: '14909' },
  { text: 'CENTRO DE ESTUDIOS SAN IGNACIO', value: '14910' },
  { text: 'COLEGIO SAN ANTONIO DE VILLA ALEMANA', value: '14912' },
  { text: 'COLEGIO GALILEO', value: '14913' },
  { text: 'ESC.DE PARV. SAN PABLO DE LA CRUZ', value: '14914' },
  { text: 'ESCUELA DE PARVULOS ALIANZA ARTYLEN', value: '14915' },
  { text: 'ESCUELA DE PARVULOS PARAISO', value: '14916' },
  { text: 'SCIENCE\u00c2\u00b4S COLLEGE', value: '14917' },
  { text: 'ESC. PARVULOS ANTUKAMEL', value: '14918' },
  { text: 'COLEGIO ALEMAN AMADEUS', value: '14919' },
  { text: 'ESCUELA DE PARVULOS ADVENTISTA VALPARAISO', value: '14920' },
  { text: 'ESCUELA DE PARVULOS HORMIGUITAS', value: '14921' },
  { text: 'COLEGIO LAS ACACIAS', value: '14922' },
  { text: 'COLEGIO WINTERHILL VI\u00c3\u2018A DEL MAR', value: '14923' },
  { text: 'ESC.ESP. DE LENGUAJE ACUARELA DEL MAR', value: '14924' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE A\u00c3\u203aKEN', value: '14926' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE DEL SOL', value: '14927' },
  { text: 'ESCUELA ESP.DE LENGUAJE TIERRA MADRE', value: '14928' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE KUMELEN', value: '14929' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE MANANTIAL', value: '14930' },
  { text: 'ESCUELA ESP.DE LENGUAJE VOCES DEL VALLE', value: '14931' },
  { text: 'ESCUELA ESP.DE LENGUAJE CAICURA EPU', value: '14932' },
  { text: 'ESC. ESP. DE LENG. CUMBRES DE ACONCAGUA', value: '14933' },
  { text: 'COLEGIO PARTICULAR LUCILA GODOY ALCAYAGA', value: '15501' },
  { text: 'INSTITUTO MONSENOR LECAROS', value: '15502' },
  { text: 'ESCUELA DUENDE MELODIA', value: '15503' },
  { text: 'COLEGIO PARTICULAR SUBV. CHILDREN SCHOOL', value: '15515' },
  { text: 'JARDIN INFANTIL TOPO GIGIO', value: '15518' },
  { text: 'CHARLY SCHOOL', value: '15522' },
  { text: 'COLEGIO SANTA CRUZ DE UNCO', value: '15524' },
  { text: 'ESCUELA MUNICIPAL AMERICA', value: '15526' },
  { text: 'JARDIN INFANTIL MUNDO FELIZ', value: '15531' },
  { text: 'ESCUELA SANTA TERESA DE AVILA', value: '15535' },
  { text: 'GARDEN SNOOPY', value: '15536' },
  { text: 'JARDIN INFANTIL PEQUENO MUNDO FELIZ', value: '15538' },
  { text: 'COLEGIO CRIPTOCARYA ALBA', value: '15544' },
  { text: 'ESCUELA DE AUDICION Y LENGUAJE CRECER', value: '15551' },
  { text: 'EL PEQUENO MOZART', value: '15554' },
  { text: 'ESCUELA ESPECIAL FRAY AVE MARIA', value: '15557' },
  { text: 'JARDIN INFANTIL PASCUALITA', value: '15561' },
  { text: 'ESCUELA PUERTECILLO', value: '15569' },
  { text: 'ESCUELA BASICA GALVARINO VALENZUELA MORAGA', value: '15570' },
  { text: 'COLEGIO PARTICULAR LA PRIMAVERA', value: '15571' },
  { text: 'LICEO MUNICIPAL DE ADULTOS SANTA CRUZ', value: '15574' },
  { text: 'ESCUELA BASICA ALTO NERQUIHUE- LOLOL', value: '15577' },
  { text: 'COLEGIO PARTICULAR AMERICA', value: '15578' },
  { text: 'COLEGIO PARTICULAR ALMA MATER', value: '15579' },
  { text: 'COLEGIO SAN MIGUEL ARCANGEL', value: '15582' },
  { text: 'LICEO TECNICO PROFESIONAL EL TAMBO', value: '15583' },
  { text: 'COLEGIO CRISTIANO RESURRECCION', value: '15585' },
  { text: 'COLEGIO TIA MONICA', value: '15586' },
  { text: 'SAINT GREGORY COLLEGE', value: '15588' },
  { text: 'COLEGIO AMERICANO', value: '15593' },
  { text: 'COLEG.TERESIANO JUANITA FERNANDEZ SOLAR', value: '15594' },
  { text: 'JARDIN INFANTIL ARDILLITA', value: '15595' },
  { text: 'INSTITUTO SAN VICENTE DE TAGUA TAGUA', value: '15596' },
  { text: 'COLEGIO PROVIDENCIA JARDIN INFANTIL', value: '15597' },
  { text: 'JARDIN INFANTIL COLORIN COLORADO', value: '15598' },
  { text: 'ALBERTO HURTADO CRUCHAGA', value: '15600' },
  { text: 'LICEO COMERCIAL WEBER', value: '15603' },
  { text: 'COLEGIO HUMANISTA INTEGRADO', value: '15605' },
  { text: 'CENTRO TRAST. Y TRAT. LENG. CHOIN RAYEN', value: '15607' },
  { text: 'ESCUELA SAN HERNAN', value: '15608' },
  { text: 'COLEGIO PARTIC  SAN JOSE DE LA MONTANA', value: '15610' },
  { text: 'JARDIN INFANTIL HAPPY WORLD', value: '15613' },
  { text: 'ESCUELA EL NARANJAL', value: '15614' },
  { text: 'ESCUELA QUEBRADA NUEVO REINO', value: '15615' },
  { text: 'COLEGIO PARTICULAR EL REAL', value: '15621' },
  { text: 'COLEGIO PARTICULAR LOMAS BLANCAS', value: '15622' },
  { text: 'COLEGIO SAN FRANCISCO', value: '15627' },
  { text: 'JARDIN INFANTIL SAN FRANCISCO', value: '15628' },
  { text: 'COLEGIO PARTICULAR SUBVENCIONADO RAICES', value: '15629' },
  { text: 'TRINITY COLLEGE', value: '15631' },
  { text: 'COLEGIO SAN ANGELO', value: '15632' },
  { text: 'BRITISH COLLEGE L.T.D.', value: '15633' },
  { text: 'CENTRO DE ESTIMULACION TEMPRANA LAS ENCINAS', value: '15641' },
  { text: 'INSTITUTO CRISTIANO EDUMASTER COLLEGE', value: '15643' },
  { text: 'COLEGIO AUDICION Y LENG. SAN GASPAR', value: '15644' },
  { text: 'COLEGIO NAZARETH', value: '15650' },
  { text: 'CENTTRO TRAST.LENGUAJE NUESTRA ESPERAN', value: '15653' },
  { text: 'CENTRO TRAST.LENGUAJE LOS BRUJITOS', value: '15656' },
  { text: 'JARDIN INFANTIL LOS PAJARITOS DE ASIS', value: '15658' },
  { text: 'JARDIN INFANTIL CARRUSEL', value: '15659' },
  { text: 'CENTRO REHAB. DEL LENGUAJE ORAL CERLO', value: '15660' },
  { text: 'COLEGIO DIVINA ESPERANZA', value: '15661' },
  { text: 'INSTITUTO SAN LORENZO', value: '15662' },
  { text: 'ESCUELA DEL LENGUAJE SANTA MARIA', value: '15663' },
  { text: 'LICEO INTEGRADO DE ADULTOS', value: '15665' },
  { text: 'COLEGIO TOMAS GUAGLEN', value: '15666' },
  { text: 'JARDIN INFANTIL DIVINA PROVIDENCIA DE JESUS', value: '15669' },
  { text: 'C.DE TRANS.DE LA COMUNIC. STA.TERESA DE JESUS', value: '15672' },
  {
    text: 'ESC. ESP.  EL ROBLE  CENTRO DE ATENCION A NECES. EDUC. ESP.',
    value: '15673',
  },
  { text: 'COL. ESTIM. DEL LENGUAJE SANT. TRINIDAD', value: '15674' },
  { text: 'CENTRO TRASTORNOS DEL LENGUAJE VOCECITAS', value: '15675' },
  { text: 'JARDIN INFANTIL GIRASOLES INTERACTIVOS', value: '15677' },
  { text: 'JARDIN INFANTIL AVENTURAS MAGICAS', value: '15679' },
  { text: 'CENTRO EDUCATIVO INTEGRAL MARIA MAGDALENA', value: '15681' },
  { text: 'COLEGIO MAGISTER', value: '15682' },
  { text: 'COLEGIO EVELYN S SCHOOL', value: '15683' },
  { text: 'ESCUELA MUNICIPAL DE LENGUAJE SANTA CRUZ', value: '15687' },
  { text: 'JARDIN INFANTIL PADRE HURTADO', value: '15689' },
  { text: 'COLEGIO LOS CIPRESES', value: '15690' },
  { text: 'ECUELA DE LENGUAJE LOS PALTOS', value: '15691' },
  { text: 'ESCUELA DE LENGUAJE CUMBRES BLANCAS', value: '15692' },
  { text: 'JARDIN INFANTIL GENTE CHICA', value: '15694' },
  { text: 'JARDIN INFANTIL MELODY', value: '15695' },
  { text: 'JARDIN INFANTIL TIA MONICA', value: '15696' },
  { text: 'ESCUELA DE LENGUAJE SAN IGNACIO', value: '15698' },
  { text: 'COLEGIO LA REPUBLICA', value: '15700' },
  { text: 'COLEGIO SANTA TERESA', value: '15705' },
  { text: 'CENTRO DE LENGUAJE SABERES', value: '15706' },
  { text: 'ESCUELA ESPECIAL DE NERQUIHUE', value: '15708' },
  { text: 'JARDIN INFANTIL RAYEN', value: '15711' },
  { text: 'CENTRO TRAST. DEL LENGUAJE ORAL ALBORADA', value: '15712' },
  { text: 'COLEGIO DE LENGUAJE SAN AGUSTIN DE PICHILEMU', value: '15713' },
  { text: 'ESCUELA DE TRASTORNOS DE LA COMUNICACION LA C', value: '15714' },
  { text: 'ESCUELA DE LENGUAJE CHARLES DARWIN', value: '15715' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE RUCALHUE', value: '15716' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ALCALA', value: '15717' },
  { text: 'COLEGIO FRAY ANDRES', value: '15719' },
  { text: 'LICEO MUNICIPAL ZOILA ROSA CARRENO', value: '15720' },
  { text: 'LICEO PARTICULAR CARDENAL RAUL SILVA HENRIQUE', value: '15722' },
  { text: 'CENTRO EDUCACIONAL INTEGRAL DE ADULTOS LOS ROBLES', value: '15723' },
  { text: 'ESCUELA FERNANDA AEDO FAUNDEZ', value: '15724' },
  { text: 'LICEO SAINT GREGORY\u00c2\u00aaS', value: '15725' },
  { text: 'COLEGIO SAN SEBASTIAN SCHOOL', value: '15726' },
  { text: 'COLEGIO MUNICIPAL HUALLILEN', value: '15728' },
  { text: 'ESCUELA DE LENGUAJE LA GRANJITA', value: '15729' },
  { text: 'COLEGIO ESPANA', value: '15731' },
  { text: 'COLEGIO CRISTIANO ADONAY', value: '15732' },
  { text: 'JARDIN INFANTIL SAN BENITO', value: '15734' },
  {
    text: 'ESCUELA TRAST. DE LA COMUNIC. SANTA ROSA DE PELEQUEN',
    value: '15736',
  },
  {
    text: 'ESCUELA TRAST. DE LA COMUNIC. NUESTRA SRA. DEL PILAR',
    value: '15738',
  },
  { text: 'COLEGIO CHIMBARONGO', value: '15739' },
  { text: 'ESCUELA DE LENGUAJE SAN ANDRES', value: '15740' },
  { text: 'ESCUELA  DE LENGUAJE SANTA MARIA DE LA COMUNA', value: '15741' },
  { text: 'ESCUELA DE ESTIMUL. DE LENGUAJE CHARLES DARWIN', value: '15742' },
  { text: 'COLEGIO SAN SEBASTIAN', value: '15743' },
  { text: 'COLEGIO ALMENAR', value: '15744' },
  { text: 'COLEGIO VALLE DE COLCHAGUA', value: '15745' },
  { text: 'MONTE CASTELLO', value: '15746' },
  { text: 'COLEGIO DE EDUCACION ESPECIAL MOSTAZAL', value: '15747' },
  { text: 'ESCUELA ESPECIAL MARIA ALICIA PONCE', value: '15748' },
  { text: 'COLEGIO LAS AMERICAS', value: '15750' },
  { text: 'ESCUELA DE LENGUAJE CHARLES DARWIN', value: '15751' },
  { text: 'ESCUELA NORORIENTE', value: '15753' },
  { text: 'CENTRO DE RECURSOS EDUCATIVO INTEGRARTE', value: '15754' },
  { text: 'COLEGIO SAN NICOLAS', value: '15755' },
  { text: 'CENTRO EDUC. INT. DE ADULTOS SEMPER', value: '15756' },
  { text: 'COLEGIO PART. SUBV. SAN ESTEBAN', value: '15757' },
  { text: 'COLEGIO CHRISTIAN COLLEGE', value: '15758' },
  { text: 'ESC. ESP. DE LENGUAJE JUNTITOS', value: '15760' },
  { text: 'ESCUELA ESPECIAL MADRE MARIA MAZZARELLO', value: '15761' },
  { text: 'ESCUELA DULCE AMANECER', value: '15762' },
  { text: 'COLEGIO ANTUHUE', value: '15763' },
  { text: 'ELENA GAETE DARBEAUX', value: '15764' },
  { text: 'CHARLES DARWIN', value: '15765' },
  { text: 'COLEGIO DIEGO PORTALES', value: '15767' },
  { text: 'COLEGIO SANTA FILOMENA', value: '15768' },
  { text: 'LICEO SANTA CRUZ DE TRIANA', value: '15769' },
  { text: 'ESCUELA DIVINO MAESTRO', value: '15770' },
  { text: 'COLEGIO DEL ALBA', value: '15773' },
  { text: 'ESCUELA AGRICOLA DON GREGORIO', value: '15774' },
  { text: 'LICEO TECNICO PROFESIONAL SANTA ROSA', value: '15775' },
  { text: 'COLEGIO AVE FENIX', value: '15776' },
  { text: 'COLEGIO JUAN LUIS VIVES', value: '15777' },
  { text: 'CENTRO EDUC. ACUARELA TE ACOGE', value: '15778' },
  { text: 'COLEGIO HERMANO DE ASIS', value: '15779' },
  { text: 'ESCUELA ESPECIAL DE PICHIDEGUA', value: '15780' },
  { text: 'LICEO MUNICIPAL DE CODEGUA', value: '15781' },
  { text: 'CENTRO EDUCATIVO ESPECIAL CREEMOS', value: '15782' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE CODEGUA', value: '15784' },
  {
    text: 'ESCUELA ESPECIAL DE LENGUAJE NUESTRA SRA. DEL ROSARIO',
    value: '15785',
  },
  { text: 'JARDIN INFANTIL MIS TESORITOS PUFFI', value: '15786' },
  { text: 'COMPLEJO EDUCACIONAL LAS ARAUCARIAS', value: '15787' },
  { text: 'ESCUELA ESP. DE LENG. GIORDANO BRUNO', value: '15788' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE RAICES', value: '15789' },
  { text: 'ESCUELA ESPECIAL AYUDANDO A CRECER', value: '15790' },
  { text: 'ESCUELA ESPECIAL DIFERENCIAL SAN ANDRES', value: '15791' },
  { text: 'COLEGIO INTERAMERICANO', value: '15793' },
  { text: 'JARDIN INFANTIL PEQUITAS', value: '15795' },
  { text: 'ESC. ESP.DE LENGUAJE SAN FRANCISCO DE ASIS', value: '15796' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE SAN FRANCISCO DE', value: '15798' },
  { text: 'COLEGIO DE LENGUAJE PADRE PIO', value: '15799' },
  { text: 'ESC. ESP. DE LENGUAJE EL SEMBRADOR', value: '15800' },
  { text: 'JARDIN INFANTIL INMACULADA CONCEPCION', value: '15801' },
  { text: 'JARDIN INFANTIL SAN FRANCISCO', value: '15803' },
  { text: 'ESCUELA ESPECIAL SAN VALENTIN', value: '15804' },
  { text: 'ESCUELA ESPECIAL NUEVO AMANECER', value: '15805' },
  { text: 'JARDIN INFANTIL SEMILLITA CANELO', value: '15806' },
  { text: 'COLEGIO ALERCE', value: '15807' },
  { text: 'LICEO DE PAREDONES', value: '15808' },
  { text: 'OLIVAR COLLEGE', value: '15809' },
  { text: 'LICEO MANUEL DE SALAS', value: '15810' },
  { text: 'COLEGIO ANGOSTURA', value: '15811' },
  { text: 'COLEGIO BASICO VIOLETA PARRA SANDOVAL', value: '15812' },
  { text: 'JARDIN INFANTIL VILLA ESPERANZA', value: '15813' },
  { text: 'JARDIN INFANTIL MI CASITA EN EL BOSQUE', value: '15814' },
  { text: 'ESCUELA DE LENGUAJE RAYITO DE SOL', value: '15815' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ALTAZOR', value: '15818' },
  { text: 'COLEGIO DE LENGUAJE PADRE PIO PERALILLO', value: '15819' },
  { text: 'COLEGIO SAN MIGUEL DE REMA', value: '15820' },
  { text: 'ESCUELA DE LENGUAJE PUCARA', value: '15821' },
  { text: 'ESCUELA DE LENGUAJE EL ARCA DE CRISTOBAL', value: '15822' },
  { text: 'ESCUELA DE LENGUAJE HAKUNA MATATA', value: '15823' },
  { text: 'ESC ESP. DE LENGUAJE NUESTRA SRA DE LOURDES', value: '15824' },
  { text: 'ESCUELA DE LENGUAJE SAN JOSE E.I.R.L.', value: '15825' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE SAN EXPEDITO', value: '15826' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE LOS ALERCES', value: '15827' },
  { text: 'COLEGIO SAN NICOLAS DE BARI', value: '15828' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ABRAPALABRA', value: '15829' },
  { text: 'COLEGIO LA MISION', value: '15830' },
  { text: 'ESC. DIFERENCIAL GUSTAVO RAMIREZ MORENO', value: '16406' },
  { text: 'COLEGIO ABATE MOLINA', value: '16410' },
  {
    text: 'LICEO BICENTENARIO DE MOLINA MARIA DEL TR\u00c3\u0081NSITO DE LA CRUZ',
    value: '16424',
  },
  { text: 'COLEGIO ESMERALDA', value: '16427' },
  { text: 'ESC. MONSENOR MANUEL LARRAIN ERRAZURIZ', value: '16428' },
  { text: 'ESCUELA DIFERENCIAL LAS ILUSIONES', value: '16429' },
  { text: 'LICEO AGRIC.PADRE ALBERTO HURTADO', value: '16432' },
  { text: 'CENTRO EDUCACIONAL LUIS RUTTEN', value: '16434' },
  { text: 'CENTRO INTEGRAL EDUCACION TALCA', value: '16443' },
  { text: 'COLEGIO EDUARDO MARTIN ABEJON', value: '16444' },
  { text: 'COLEGIO SAN DANIEL', value: '16445' },
  { text: 'COLEGIO JUAN PIAMARTA', value: '16446' },
  { text: 'INSTITUTO SANTA MARTA', value: '16448' },
  { text: 'COLEGIO SANTA FE', value: '16449' },
  { text: 'COLEGIO ALBORADA', value: '16453' },
  { text: 'ESCUELA CARCELARIA LAS DUNAS DE CHANCO', value: '16454' },
  { text: 'ESCUELA DE PARVULOS SEMILLITA', value: '16455' },
  { text: 'ESCUELA PARTICULAR VILLA BAVIERA', value: '16456' },
  { text: 'CENTRO EDUCACIONAL APUMANQUE', value: '16457' },
  { text: 'INSTITUTO EDUCACIONAL DE LA MADERA', value: '16459' },
  { text: 'ESCUELA PADRE ALBERTO HURTADO', value: '16460' },
  { text: 'COLEGIO LYONS SCHOOL', value: '16461' },
  { text: 'C.E.I. DE ADULTOS PADRE HURTADO', value: '16462' },
  { text: 'CENTRO DE TRASTORNOS DE LA COMUNICACION', value: '16466' },
  { text: 'CENTRO INTEG.EDUC.ADULTO PABLO NERUDA', value: '16467' },
  { text: 'ESCUELA BASICA DE COLBUN', value: '16468' },
  { text: 'COLEGIO PABLO NERUDA', value: '16469' },
  { text: 'JARD\u00c3\u008dN INFANTIL RAYEN MONTESSORI', value: '16471' },
  { text: 'ESC.ESPECIAL TRASTORNOS DE LA COMUNICACI', value: '16472' },
  { text: 'ESCUELA TALLER LABORAL UNPADE', value: '16479' },
  { text: 'COLEGIO MANSO DE VELASCO', value: '16484' },
  { text: 'COLEGIO GARDEN COLLEGE', value: '16485' },
  { text: 'COLEGIO ADVENTISTA MARANATA', value: '16488' },
  { text: 'COLEGIO BALTAZAR', value: '16489' },
  { text: 'CENTRO DE LENGUAJE MARCELA PAZ', value: '16490' },
  { text: 'COLEGIO ALBERT EINSTEIN', value: '16491' },
  { text: 'INSTITUTO VALENTIN LETELIER', value: '16492' },
  { text: 'COLEGIO CRISTIANO DE CURICO', value: '16494' },
  { text: 'COLEGIO ANDES DE TALCA', value: '16497' },
  { text: 'JARDIN INFANTIL PIN Y PON', value: '16499' },
  { text: 'JARDIN INFANTIL CAMPANITA', value: '16501' },
  { text: 'COLEGIO CORDILLERA', value: '16502' },
  { text: 'CENTRO EDUCACIONAL BUBI', value: '16504' },
  { text: 'ESCUELA CHACARILLAS', value: '16506' },
  { text: 'JUAN SALVADOR COLLEGE', value: '16507' },
  { text: 'COLEGIO CENTRO EDUCACIONAL VYGOTSKY', value: '16509' },
  { text: 'ESCUELA ENRIQUE WEISS', value: '16510' },
  { text: 'CENTRO EDUCACIONAL ADONAY', value: '16513' },
  { text: 'COLEGIO RENACER', value: '16517' },
  { text: 'COLEGIO PARTICULAR SEBASTIAN', value: '16518' },
  { text: 'COLEGIO KAIROS', value: '16520' },
  { text: 'ESC.ESPECIAL DE TRASTORNO DE LA COMUNICACION', value: '16521' },
  { text: 'ESC.TRASTORNOS DE LENGUAJE HANS CHRISTIAN AND', value: '16523' },
  { text: 'ESCUELA DE LENGUAJE TALCA', value: '16525' },
  { text: 'COLEGIO LOS ALERCES', value: '16526' },
  { text: 'JARDIN INFANTIL MININOS', value: '16527' },
  { text: 'ESC.ESPECIAL TRASTORNOS DE LA COMUNIC. MIS SO', value: '16530' },
  { text: 'CENTRO DE LENGUAJE Y PSICOPEDAGOGIA DALUZ', value: '16533' },
  { text: 'JARDIN INFANTIL ABC', value: '16534' },
  { text: 'COLEGIO SAN MARCOS', value: '16535' },
  { text: 'JARDIN  INFANTIL  MIS  PRIMEROS  PASOS', value: '16536' },
  { text: 'ESCUELA  DE  LENGUAJE  CEL', value: '16537' },
  { text: 'COLEGIO  SAN  GABRIEL', value: '16539' },
  { text: 'CENTRO  EDUCATIVO  PEUMAYEN', value: '16541' },
  { text: 'ESCUELA DE LENGUAJE MAZAPAN', value: '16542' },
  { text: 'ESCUELA PARVULOS ALDEA DE LOS NINOS', value: '16543' },
  { text: 'ESCUELA DE LENGUAJE PAUL HARRIS', value: '16544' },
  { text: 'CENTRO EDUCACIONAL INGLES', value: '16546' },
  { text: 'MI JARDIN Y YO', value: '16548' },
  { text: 'COLEGIO PALENCIA SC.', value: '16549' },
  { text: 'COLEGIO SAN JORGE', value: '16550' },
  { text: 'LICEO POLIVALENTE DE RAUCO', value: '16551' },
  { text: 'ESCUELA LENGUAJE BELEN', value: '16552' },
  { text: 'ESCUELA DE LENGUAJE MANANTIAL', value: '16553' },
  { text: 'ESCUELA DE LENGUAJE CEL', value: '16554' },
  { text: 'COLEGIO CORDILLERA', value: '16556' },
  { text: 'CENTRO DE LENGUAJE CAUQUENES', value: '16557' },
  { text: 'CENTRO EDUCACIONAL TERRANOVA', value: '16558' },
  { text: 'CENTRO DE LENGUAJE SAN JAVIER', value: '16560' },
  { text: 'CENTRO LENGUAJE  EL CANELO', value: '16561' },
  { text: 'CEDEL LIMITADA', value: '16563' },
  { text: 'LICEO TECNICO PROFESIONAL SIMON BOLIVAR', value: '16564' },
  { text: 'ESCUELA DE LENGUAJE PRINCIPITO', value: '16565' },
  { text: 'COLEGIO ESPECIAL DE MARIA', value: '16566' },
  { text: 'JARDIN INFANTIL SAN PABLO', value: '16567' },
  { text: 'ESCUELA DE LENGUAJE SAN NICOLAS', value: '16568' },
  { text: 'COLEGIO LOS HEROES', value: '16569' },
  { text: 'ESCUELA DE LENGUAJE RAYENCO', value: '16570' },
  { text: 'ESCUELA DIFERENCIAL LOS LAGOS', value: '16571' },
  { text: 'ESCUELA ESPECIAL HIERBAS BUENAS', value: '16572' },
  { text: 'EMA ESCAJADIO GARCIA', value: '16574' },
  { text: 'CENTRO DE LENGUAJE CEDEL', value: '16575' },
  { text: 'ESCUELA DE LENGUAJE LAS NIEVES', value: '16577' },
  { text: 'CENTRO DE LENGUAJE CEDEL', value: '16578' },
  { text: 'ESC. PASO INTERNACIONAL PEHUENCHE', value: '16580' },
  { text: 'ESCUELA DE ADMINISTRACION Y COMERCIO', value: '16583' },
  { text: 'ESCUELA DE LENGUAJE GIRASOL', value: '16584' },
  { text: 'CENTRO EDUCACIONAL IRIS', value: '16585' },
  { text: 'ESCUELA DE LENGUAJE RAYITO DE SOL', value: '16586' },
  { text: 'LICEO POLIVALENTE SAGRADA FAMILIA', value: '16587' },
  { text: 'COLEGIO SAN ALFONSO DE EL BOLDO', value: '16588' },
  { text: 'COLEGIO EL QUILLAY', value: '16589' },
  { text: 'ESC.ESP.DE TRAST.DEL LENGUAJE SAN VALENTIN', value: '16590' },
  { text: 'ESCUELA DE LENGUAJE ARRAYAN', value: '16591' },
  { text: 'ESCUELA LENGUAJE SAN CLEMENTE', value: '16592' },
  { text: 'COLEGIO EL SEMBRADOR', value: '16594' },
  { text: 'ESCUELA DE LENGUAJE ANTUPIREN', value: '16595' },
  { text: 'ESCUELA PARV. PEQUENOS MAESTROS', value: '16596' },
  { text: 'ESCUELA DE LENGUAJE ZARCILLO', value: '16597' },
  { text: 'COLEGIO VERBUM', value: '16598' },
  { text: 'ESCUELA LENGUAJE PROSPERIDAD', value: '16599' },
  { text: 'COLEGIO ALTA CUMBRE', value: '16600' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ALTAMIRA', value: '16601' },
  { text: 'CENTRO LENGUAJE DALUZ  2', value: '16602' },
  { text: 'ESC. LENGUAJE ARCOIRIS', value: '16603' },
  { text: 'INSTITUTO LATINOAMERICANO-EUROPEO DE', value: '16604' },
  { text: 'ESCUELA DE PARVULOS SAN AGUSTIN', value: '16606' },
  { text: 'ESCUELA DE LENGUAJE ALBORADA', value: '16607' },
  { text: 'COLEGIO ANTILHUE', value: '16608' },
  { text: 'ESCUELA DE LENGUAJE EDUCAR', value: '16610' },
  { text: 'ESCUELA DE LENGUAJE BELEN', value: '16613' },
  { text: 'COLEGIO PABLO NERUDA', value: '16614' },
  { text: 'ESC.DE LENGUAJE Y JARDIN INFANTIL ECOLOGICO', value: '16615' },
  { text: 'ESCUELA DE TRANSTORNOS DE LENGUAJE EMMANUEL', value: '16616' },
  { text: 'SALA CUNA Y JARDIN INFANTIL MICKEY MOUSE', value: '16617' },
  { text: 'ESCUELA DE LENGUAJE BAMBI', value: '16619' },
  { text: 'ESCUELA DE LENGUAJE GARDEN SCHOOL', value: '16622' },
  { text: 'ESCUELA DE LENGUAJE RAIGUEN', value: '16623' },
  { text: 'COLEGIO  ANTARES', value: '16624' },
  { text: 'COLEGIO PABLO DE ROKHA', value: '16625' },
  { text: 'ESCUELA DE PARVULOS LOS ARCILLEROS', value: '16629' },
  { text: 'CENTRO EDUCATIVO DE LENGUAJE ANDALEN', value: '16630' },
  { text: 'ESCUELA DE LENGUAJE TORREBLANCA', value: '16631' },
  { text: 'ESCUELA DE LENGUAJE ABEJITA MAYA', value: '16633' },
  { text: 'COLEGIO POLITECNICO AQUELARRE', value: '16634' },
  { text: 'ESCUELA DE LENGUAJE MILLAHUE', value: '16636' },
  { text: 'ESCUELA DE LENGUAJE ESTRELLITA FUGAZ', value: '16637' },
  { text: 'JARDIN INFANTIL CASCANUECES', value: '16638' },
  { text: 'ESCUELA INTY LLAN', value: '16639' },
  { text: 'ESCUELA DE LENGUAJE SAN VALENTIN SUR ORIENTE', value: '16640' },
  { text: 'COLEGIO ANTAMARO', value: '16642' },
  { text: 'COLEGIO LEONARDO DA VINCI', value: '16644' },
  { text: 'COLEGIO LAS ESTRELLITAS', value: '16645' },
  { text: 'ESCUELA DE LENGUAJE ARCOIRIS', value: '16646' },
  { text: 'COLEGIO ESPECIAL CRECER', value: '16647' },
  { text: 'ESCUELA ESPECIAL SAN VICENTE', value: '16649' },
  { text: 'JARDIN INFANTIL CAPULLITO', value: '16651' },
  { text: 'CENTRO EDUCACIONAL CEDEL', value: '16652' },
  { text: 'ESCUELA DE LENGUAJE PRIMAVERA', value: '16653' },
  { text: 'ESCUELA DIFERENCIAL LOS GERANIOS', value: '16654' },
  { text: 'ESCUELA HOSPITAL DE CURICO', value: '16655' },
  { text: 'LICEO VICTORIA', value: '16656' },
  { text: 'LICEO NUESTRA SENORA DE LAS MERCEDES', value: '16658' },
  { text: 'ESCUELA DE LENGUAJES EDUCALEN', value: '16659' },
  { text: 'ESCUELA DE PARVULOS PRINCIPITO DE SANTA ANA', value: '16661' },
  { text: 'JARDIN INFANTIL CASTILLO PALABRAS MAGICAS', value: '16662' },
  { text: 'ESCUELA DE LENGUAJE CARACOLA', value: '16663' },
  { text: 'ESCUELA DE PARVULOS SAN JOSE DE CALASANZ', value: '16664' },
  { text: 'JARDIN INFANTIL SONRISAS', value: '16665' },
  { text: 'ESCUELA DE LENGUAJE RENACER', value: '16666' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE VICTORIA', value: '16667' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE NINO JESUS', value: '16668' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE CARACOLA', value: '16670' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE SAN ESTEBAN', value: '16671' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ALHUE', value: '16672' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE CLUB DE LEONES D', value: '16673' },
  { text: 'ESCUELA ESPEC. DE LENGUAJE ALFREDO GIDI JALIL', value: '16675' },
  { text: 'LICEO COMPLEJO EDUCACIONAL JAVIERA CARRERA', value: '16676' },
  { text: 'COLEGIO IRIS RETAMAL', value: '16677' },
  { text: 'CTRO. EDUCACIONAL Y ESC. DE LENGUAJE PABLO FR', value: '16679' },
  { text: 'COL GRAL. DE DIVISION EMILIO SOTOMAYOR BAEZA', value: '16682' },
  { text: 'ESCUEA ESPECIAL DE LENGUAJE MILLARAY', value: '16683' },
  { text: 'COLEGIO HENRI CETTY', value: '16685' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE REY LEON', value: '16686' },
  { text: 'CENTRO PEDAGOGICO PREESCOLAR VALLE DEL MAULE', value: '16687' },
  { text: 'COLEGIO ESPECIAL DE DISCAPACIDADES MULTIPLES', value: '16689' },
  { text: 'COLEGIO SUYAI', value: '16690' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE GIRASOL', value: '16692' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE SEMBRANDO PALABR', value: '16693' },
  { text: 'ESCUELA DE LENGUAJE REMOLINO', value: '16694' },
  { text: 'ESCUELA BASICA DE ADMINISTRACION Y COMERCIO', value: '16695' },
  { text: 'ESCUELA HOSPITAL LINARES', value: '16696' },
  { text: 'INSTITUTO DE INNOVACION TECNOLOGICA DIEGO POR', value: '16697' },
  { text: 'CENTRO EDUCACIONAL KIMEL', value: '16698' },
  { text: 'ESCUELA ESPECIAL UNPADE', value: '16699' },
  { text: 'ESC.DE LENGUAJE Y JARDIN INFANTIL NELTUME', value: '16701' },
  { text: 'ESC.ESPECIAL DE LENGUAJE HABLAPALABRAS', value: '16702' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE MIS PRIMERAS PAL', value: '16703' },
  { text: 'COLEGIO CLEMENTINOS', value: '16704' },
  { text: 'LICEO ASCENCION JARA SEGURA', value: '16706' },
  { text: 'COLEGIO PARTICULAR JOSEFINA MEDEL', value: '16708' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE APRENDER', value: '16709' },
  {
    text: 'ESCUELA DE LENGUAJE Y JARDIN INFANTIL PEQUE\u00c3\u2018O',
    value: '16711',
  },
  { text: 'JARDIN INFANTIL MAGIC CASTLE', value: '16712' },
  { text: 'COLEGIO SAN PABLO', value: '16713' },
  { text: 'COLEGIO EL BOLDO', value: '16715' },
  { text: 'COLEGIO SANTA MADRE DE DIOS', value: '16717' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ANTONIO CASTRO A', value: '16718' },
  { text: 'COLEGIO LOS CASTA\u00c3\u2018OS', value: '16720' },
  { text: 'ESCUELA ESP. CENTRO DE INTEGRACION PADRE PIO', value: '16721' },
  { text: 'COLEGIO CRISTIANO DE EDUC. DE ADULTOS EL SEMB', value: '16722' },
  { text: 'ESCUELA HOSPITALARIA DE CAUQUENES', value: '16723' },
  { text: 'ESCUELA ESPECIAL DIFERENCIAL SOL Y LUNA', value: '16725' },
  { text: 'COLEGIO DE ADULTOS PROMAUCAES', value: '16727' },
  { text: 'COLEGIO SANTO TOMAS DE TALCA', value: '16728' },
  { text: 'INSTITUTO INGLES', value: '16729' },
  { text: 'ESCUELA ADMINISTRACION Y COMERCIO HUMANISTA C', value: '16730' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ENSE\u00c3\u2018ARTE', value: '16731' },
  { text: 'ESCUELA DE PARVULOS LOS ENANITOS', value: '16732' },
  { text: 'COLEGIO ALTAS CUMBRES DE SAN CLEMENTE', value: '16733' },
  { text: 'JARDIN INFANTIL MIS TESOROS', value: '16734' },
  { text: 'ESCUELA DE LENGUAJE EL CASTILLO INFANTIL', value: '16735' },
  { text: 'COLEGIO EL CANELO 1', value: '16737' },
  { text: 'CLARO DE LUNA CENTRO DE DESARROLLO COGNITIVO', value: '16739' },
  { text: 'COLEGIO SAN GABRIEL ARCANGEL', value: '17600' },
  { text: 'CENTRO DE ED  INTEGRAL DIEGO PORTALES', value: '17602' },
  { text: 'COL. TECNICO PROFESIONAL LOS ACACIOS', value: '17635' },
  { text: 'ESC.CENTRO ECOEDUCATIVO LAS TRANCAS.', value: '17636' },
  { text: 'ESCUELA ANEXO', value: '17637' },
  { text: 'COLEGIO SANTO TOMAS DE AQUINO', value: '17638' },
  { text: 'ESCUELA BASICA EL PILME', value: '17640' },
  { text: 'ESCUELA BASICA CANA DULCE', value: '17641' },
  { text: 'JARDIN INFANTIL FABIOLA', value: '17642' },
  { text: 'LICEO AGRICOLA DE NEGRETE', value: '17643' },
  { text: 'PARVULARIO COLEGIO ADVENTISTA DE COMCEP.', value: '17644' },
  { text: 'TALLER DE CAPACITACION LABORAL UNPADE', value: '17647' },
  { text: 'COLEGIO PART. KENNEDY SCHOOL', value: '17648' },
  { text: 'CENTRO DE CAPACITACION URCAE', value: '17650' },
  { text: 'COLEGIO RAIQUEN', value: '17652' },
  { text: 'JARDIN INFANTIL SEMILLA', value: '17653' },
  { text: 'CENTRO EDUC. INTEGRADA DE ADULTOS', value: '17654' },
  { text: 'ESCUELA MUNICIPAL CARRIZAL - MENIR', value: '17655' },
  { text: 'INSTITUTO DE HUMANIDADES ENRIQUE CURTI CANOBBIO', value: '17657' },
  { text: 'SCUOLA ITALIANA DI CONCEPCION', value: '17660' },
  { text: 'LICEO CLAUDIO ARRAU LEON', value: '17662' },
  { text: 'LICEO LA ASUNCION ANEXO 2', value: '17671' },
  { text: 'LICEO SANTA RITA DE LOS ANGELES', value: '17674' },
  { text: 'ANEXO COMEWEALTH SCHOOL', value: '17679' },
  { text: 'COLEGIO ADVENTISTA CONCEPCION', value: '17686' },
  { text: 'COLEGIO TERESIANO LOS ANGELES', value: '17687' },
  { text: 'COLEGIO LICANRAY', value: '17689' },
  { text: 'BEATO DAMIAN DE MOLOKAI', value: '17690' },
  { text: 'COLEGIO GOLDEN SCHOOL', value: '17692' },
  { text: 'COLEGIO BASICO NUEVA LOS LOBOS', value: '17693' },
  { text: 'JARDIN INFANTIL LOS CANELITOS', value: '17696' },
  { text: 'SOCIEDAD EDUCACIONAL LA ARAUCANA', value: '17697' },
  { text: 'CENTRO ESTIMULACION TEMPRANA LOS NARANJO', value: '17699' },
  { text: 'CENTRO DE EDUCACION ADULTOS PITAGORAS', value: '17701' },
  { text: 'INSTITUTO SAN SEBASTIAN', value: '17702' },
  { text: 'COLEGIO ESPIRITU SANTO', value: '17703' },
  { text: 'ESCUELA AMANDA LABARCA', value: '17704' },
  { text: 'ESCUELA BALMACEDA SAAVEDRA L.', value: '17709' },
  { text: 'ESCUELA BASICA EL MIRADOR', value: '17710' },
  { text: 'ESCUELA BASICA EL ESPINO', value: '17711' },
  { text: 'ESCUELA ACUMAR', value: '17715' },
  { text: 'JARDIN INFANTIL WONDERFUL WORDL', value: '17718' },
  { text: 'COLEGIO PARTICULAR CONTINENTAL', value: '17719' },
  { text: 'ESCUELA DIEGO PORTALES', value: '17723' },
  { text: 'ESCUELA PARTICULAR RENACER', value: '17724' },
  { text: 'COLEGIO SAN ESTEBAN DE BULNES', value: '17725' },
  { text: 'CENTRO EVANGELICO PARA EDUC..ADULTOS', value: '17726' },
  { text: 'COLEGIO EL BOSQUE', value: '17728' },
  { text: 'JARDIN INFANTIL MI NIDO DE MULCHEN', value: '17731' },
  { text: 'COLEGIO Y JARDIN INFANTIL CARI\u00c3\u2018OSITOS', value: '17732' },
  { text: 'COLEGIO CAMILO HENRIQUEZ', value: '17733' },
  { text: 'COLEGIO DARIO SALAS', value: '17735' },
  { text: 'COLEGIO PARROQUIAL SAN JOSE', value: '17737' },
  { text: 'JARDIN INFANTIL ANIBAL ESQUIBEL TAPIA', value: '17739' },
  { text: 'ESCUELA REINO DE SUECIA', value: '17741' },
  { text: 'ESCUELA BASICA EDUARDO FREI MONTALBA', value: '17742' },
  { text: 'COLEG. STERNENKINDER NINOS DE LAS ESTREL', value: '17745' },
  { text: 'COLEGIO OLIMPIA GUZMAN BELLO', value: '17746' },
  { text: 'JARDIN INFANTIL NUEVO CAPULLITO', value: '17747' },
  { text: 'ESCUELA PUCARA', value: '17749' },
  { text: 'ESCUELA VILLA LA GRANJA', value: '17751' },
  { text: 'ESC. PART. DIFERENCIAL ALTO DEL REY', value: '17753' },
  { text: 'CENTRO DE EDUCACION DE ADULTOS INTECH', value: '17754' },
  { text: 'JARDIN INFANTIL CUNCUNITA', value: '17756' },
  { text: 'ESC. PART. BAJO QUILANTAHUE', value: '17762' },
  { text: 'ESC. PART. CUYIMPALIHUE', value: '17763' },
  { text: 'ESC. PART. ARMANDO ZUNINO ZUNINO', value: '17764' },
  { text: 'COLEGIO MADRE PAULINA', value: '17765' },
  { text: 'COLEGIO SAN JOSE', value: '17766' },
  { text: 'JARDIN INFANTIL COPITOS DE NIEVE', value: '17767' },
  { text: 'PARVULARIO EL NAZARENO', value: '17768' },
  { text: 'ESC. ESP. DE TRASTORNO DE LA COMUNICACION MIL', value: '17771' },
  { text: 'LICEO POLITECNICO CANETE', value: '17772' },
  { text: 'LICEO TECNICO FORESTAL ESCUADRON', value: '17773' },
  { text: 'JARDIN INFANTIL MI PEQUENO AMOR', value: '17774' },
  { text: 'CENTRO EDUC.PREBAS.DIFER.AMANECER', value: '17776' },
  { text: 'COLEGIO SAN JUAN DE DIOS', value: '17778' },
  { text: 'COLEGIO PACIFIC SCHOOL', value: '17779' },
  { text: 'C.I.E.A. INDUSCAP', value: '17780' },
  { text: 'COL.DE LENGUAJE SENDEROS DEL BIO/BIO', value: '17781' },
  { text: 'LICEO RIOS DE CHILE', value: '17782' },
  {
    text: 'CENTRO DE CAPACITACI\u00c3\u201cN Y ESTUDIOS LABORALES UNPADE CHILLAN',
    value: '17784',
  },
  { text: 'ESCUELA VILLA CENTINELA SUR', value: '17785' },
  { text: 'COLEGIO SAN PABLO', value: '17786' },
  { text: 'ESCUELA ORLANDO VERA VILLARROEL', value: '17787' },
  { text: 'COLEGIO AMANECER', value: '17788' },
  { text: 'CENTRO DE ATENCION INFANTIL TAMBORIN', value: '17791' },
  { text: 'COLEGIO CONCEPCION DE SAN CARLOS', value: '17793' },
  { text: 'INST.PROF.Y CENTRO DE FOR.TEAC.STA.LUCIA E.IN', value: '17795' },
  { text: 'COLEGIO PARA ADULTOS RENACER', value: '17796' },
  { text: 'ARAUCARIA SCHOOL', value: '17797' },
  { text: 'COLEGIO ACUMAR', value: '17798' },
  { text: 'ESC. ESP. TRAST.COMUN. NAHUEL', value: '17799' },
  { text: 'JARDIN INFANTIL GOLDEN KINDS', value: '17801' },
  { text: 'INSTITUTO DOWN', value: '17802' },
  { text: 'JARDIN INFANTIL MINIMUNDO', value: '17804' },
  { text: 'JARDIN INFANTIL CRECECONMIGO', value: '17805' },
  { text: 'JARDIN INFANTIL SAN NICOLAS', value: '17806' },
  { text: 'ESCUELA DE LENGUAJE JESUS MAESTRO', value: '17807' },
  { text: 'ESCUELA DE LENGUAJE SANTISIMA TRINIDAD', value: '17809' },
  { text: 'CENTRO DE EDUCACION DE ADULTO QUIMAHUE', value: '17810' },
  { text: 'COLEGIO CONCEPCION CHIGUAYANTE', value: '17812' },
  { text: 'ESCUELA CACIQUE LEVIAN', value: '17813' },
  { text: 'ESCUELA ALTO CABRERO', value: '17814' },
  { text: 'ESC.DIF.CON TRASTORNO LENGUAJE MI VENTANA', value: '17816' },
  { text: 'COLEGIO PARTICULAR FRANCYS', value: '17817' },
  { text: 'LICEO TECNICO PROFESIONAL DE LA MADERA', value: '17818' },
  { text: 'CENTRO DE LENGUAJE EL UMBRAL', value: '17821' },
  { text: 'ESC. ESP. DE TRANST. COMUN DOMINGO PARRA', value: '17822' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE WENGA', value: '17823' },
  { text: 'COLEGIO CLARO DE LUNA COLLEGE', value: '17824' },
  { text: 'ESCUELA DE PARVULOS EVANGELICO BETH-EL', value: '17828' },
  { text: 'CENTRO DE ESTUDIO LA ARAUCANA', value: '17829' },
  { text: 'CENTRO PSICOP. DE ESTIMULACION TEMPRANA  CADI', value: '17830' },
  { text: 'ESC.ESP.TRASTORNO DE LA COMUNICACION ABRAPALA', value: '17832' },
  { text: 'COLEGIO SAN FERNANDO', value: '17834' },
  { text: 'JARDIN INFANTIL ANIBAL ESQUIVEL', value: '17835' },
  { text: 'ESCIELA DE PARVULOS SAN FRANCISCO', value: '17836' },
  { text: 'ESCUELA DE PARVULOS EL ARENAL', value: '17837' },
  { text: 'ESCUELA BASICA NAHUELBUTA', value: '17840' },
  { text: 'LICEO CAUPOLICAN', value: '17841' },
  { text: 'CENTRO EDUCACION INTEGRAL DE ADULTOS', value: '17846' },
  { text: 'INSTIT.DE EDUC. DE ADULTOS RUBEN CAMPOS LOPEZ', value: '17847' },
  { text: 'YIRE LICEO POLITECNICO DE COIHUECO', value: '17848' },
  { text: 'ESC. ESP. DE LENGUAJE Y JARDIN INFANTIL LOS A', value: '17852' },
  { text: 'COLEGIO VILLA NONGUEN', value: '17854' },
  { text: 'LICEO OBISPO SAN MIGUEL', value: '17857' },
  { text: 'COLEGIO ALMONDALE', value: '17859' },
  { text: 'COLEGIO NUEVAS PALABRAS', value: '17860' },
  { text: 'JARDIN INFANTIL MATEITO', value: '17861' },
  { text: 'JARDIN INFANTIL ADVENTISTA DE CHILLAN', value: '17863' },
  { text: 'JARDIN INFANTIL PASITO A PASITO', value: '17864' },
  { text: 'JARDIN INFANTIL BOTECITO DE PAPEL', value: '17865' },
  { text: 'JARDIN INFANTIL MONTESSORI', value: '17868' },
  { text: 'PEQUE\u00c3\u2018A LULU', value: '17869' },
  { text: 'JARDIN INFANTIL RUCA-AYUTUN', value: '17870' },
  { text: 'JARDIN INFANTIL TIMONEL LA ALEGRIA DE APRENDE', value: '17871' },
  { text: 'ESCUELA DE LENGUAJE AMANECER', value: '17872' },
  { text: 'EDELMIRA VERGARA QUINONES', value: '17874' },
  { text: 'COLEGIO SAN JOAQUIN', value: '17875' },
  { text: 'AMERICAN JUNIOR COLLEGE', value: '17876' },
  { text: 'COLEGIO PADRE ALBERTO HURTADO LOS ANGELES', value: '17877' },
  { text: 'ESC.ESP.DE TRANST.DE LA COMUNICACION SAINT BE', value: '17878' },
  { text: 'C.E.I.A. JANEQUEO-CONCEPCION', value: '17879' },
  { text: 'C.E.I.A. ADELAIDA MORENO', value: '17880' },
  { text: 'C.E.I.A.FERMIN FIERRO LUENGO', value: '17881' },
  { text: 'ESC. ESP. DE TRASTORNO DE LA COMUNCACION  AYL', value: '17882' },
  { text: 'COLEGIO SAN TERESA DE LOS ANDES - LOS ANGELES', value: '17883' },
  { text: 'ESC. DE TRASTORNOS DEL LENGUAJE TITIRIMUNDI', value: '17884' },
  { text: 'ESC.ESP.DE TRASTORNO DE LA COMUNICACION DINAB', value: '17886' },
  { text: 'ESCUELA ESPECIAL SOL DE LOS ANGELES', value: '17888' },
  { text: 'JARDIN INFANTIL RINCON DE LOS NINOS', value: '17889' },
  { text: 'ESCUELA MARTA COLVIN ANDRADE', value: '17892' },
  { text: 'COLEGIO DE WESSEX SCHOOL CHILLAN', value: '17893' },
  { text: 'CENTRO DE ESTIMULACION TEMPRANA ELIM', value: '17894' },
  { text: 'COL. DE TRASTORNO DE LA COMUNIC. SAN FERNANDO', value: '17895' },
  { text: 'ESCUELA GLORIAS NAVALES', value: '17897' },
  { text: 'ESCUELA SERGIO MARTIN ALAMOS', value: '17898' },
  { text: 'ESCUELA ESPECIAL CERES', value: '17899' },
  { text: 'ESCUELA DE LEGUAJE EL FARO', value: '17901' },
  { text: 'COLEGIO TERESA DE LOS ANDES', value: '17902' },
  { text: 'SEBASTIAN SCHOOL', value: '17903' },
  { text: 'ESCUELA DE LENGUAJE HUALPEN', value: '17909' },
  { text: 'ESCUELA DE LENGUAJE ARCO IRIS', value: '17910' },
  { text: 'ESC.ESP.TRAST.DE LA COMUNIC.SAN RODRIG', value: '17911' },
  { text: 'COLEGIO CREACION CONCEPCION', value: '17912' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE TIEMPO NUEVO', value: '17914' },
  { text: 'COLEGIO DOMINGO PARRA CORVALAN', value: '17915' },
  { text: 'DAFNE ELVIRA ZAPATA ROZAS', value: '17916' },
  { text: 'JARDIN INFANTIL PINTITA', value: '17917' },
  { text: 'COLEGIO HISPANO AMERICANO RIO VIEJO', value: '17920' },
  { text: 'THE PACIFIC SCHOOL', value: '17922' },
  { text: 'ESCUELA NACIMIENTO DE NUESTRO SENOR', value: '17924' },
  { text: 'JARDIN INFANTIL SALA CUNA TUTUMPI', value: '17925' },
  { text: 'ESCUELA DE LENGUAJE 20 DE AGOSTO', value: '17926' },
  { text: 'JARDIN INFANTIL CASCANUECES', value: '17927' },
  { text: 'JARDIN INFANTIL MI MUNDO', value: '17928' },
  { text: 'ESCUELA EL LLANO', value: '17930' },
  { text: 'LICEO TEC.PROFESIONAL ESPIRITU SANTO', value: '17931' },
  { text: 'CENTRO ESTIMULAC. TEMPRANA EGO SUM', value: '18001' },
  { text: 'ESCUELA JOSE FRANCISCO PINO MEDINA', value: '18002' },
  { text: 'ESCUELA DE LENGUAJE SAN NICOLAS', value: '18003' },
  { text: 'LIC. TEC.PROF.ALONSO DE ERCILLA Y ZUNIGA', value: '18004' },
  { text: 'ESCUELA ELISE MOTTART', value: '18006' },
  { text: 'ESCUELA ESPECIAL AMPALU', value: '18008' },
  { text: 'CEIA PAUL PERCIVAL HARRIS', value: '18009' },
  { text: 'ESC. LENGUAJE SAN FERNANDO CHILLAN VIEJO', value: '18010' },
  { text: 'ESC. ESPEC. DE LENGUAJE SENDEROS DE SAN PEDRO', value: '18011' },
  { text: 'ESCUELA MARTA COLVIN ANDRADE', value: '18012' },
  { text: 'ESCUELA BASICA LOS CONQUISTADORES', value: '18014' },
  { text: 'ESCUELA BASICA FORJADORES DE CHILE', value: '18015' },
  { text: 'ESCUELA BASICA PUEBLO SECO', value: '18016' },
  { text: 'LICEO TECNICO PROFESIONAL VIOLETA PARRA SANDO', value: '18017' },
  { text: 'JARDIN INFANTIL TIERNO AMANECER', value: '18018' },
  { text: 'ESCUELA DE LENGUAJE ALTO DE CHIGUAYANTE', value: '18020' },
  { text: 'ESCUELA DIEGO PORTALES PALAZUELOS', value: '18021' },
  { text: 'C.E.I.A. PADRE CARLOS PUENTES FIGUEROA', value: '18023' },
  { text: 'ESC. ESP. DISC.AUDIT. T. COMUNIC.HABLAME DE A', value: '18024' },
  { text: 'ESCUELA  DE LENGUAJE MAR AZUL', value: '18025' },
  { text: 'ESCUELA DE LENGUAJE SAN SEBASTIAN', value: '18026' },
  { text: 'ESCUELA DE LENGUAJE TIMONEL', value: '18027' },
  { text: 'COLEGIO CIUDAD EDUCATIVA', value: '18028' },
  { text: 'ESCUELA DE LENGUAJE SANTA MARIETTA', value: '18029' },
  { text: 'ESCUELA DE LENGUAJE CICEL', value: '18030' },
  { text: 'ESCUELA DE LENGUAJE FLORIDA', value: '18031' },
  { text: 'CENTRO DE CAP.LABORAL DE EDUC.ESP. PAULO FREI', value: '18032' },
  { text: 'COLEGIO SOUTHERN COLLEGE S.A.', value: '18034' },
  { text: 'COLEGIO SAN AGUSTIN', value: '18035' },
  { text: 'LICEO RALCO', value: '18037' },
  { text: 'ESCUELA DIFERENCIAL RAYITO DE SOL', value: '18038' },
  { text: 'JARDIN INF. Y ESC. LENGUAJE MAISON DE L ENFA', value: '18039' },
  { text: 'ESCUELA DE LENGUAJE PORVENIR', value: '18040' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE WENGA', value: '18042' },
  { text: 'ESCUELA DE LENGUAJE LOMAS COLORADAS', value: '18043' },
  { text: 'ESCUELA DE LENGUAJE TITIRIMUNDI', value: '18044' },
  { text: 'CENTRO DE CAPACITACION LABORAL BERNARDO OHI', value: '18045' },
  { text: 'JARDIN INFANTIL HADA CAMPANITA', value: '18046' },
  { text: 'ESCUELA DIFERENCIAL PREBASICA BAO BAB', value: '18047' },
  { text: 'JARDIN ANIN KUDAO', value: '18048' },
  { text: 'COLEGIO LA FUENTE', value: '18050' },
  { text: 'ESCUELA BASICA DIFERENCIAL ARCO IRIS', value: '18051' },
  { text: 'ESCUELA DE LENGUAJE CHILEDUCA', value: '18052' },
  { text: 'CENTRO DE NIV. Y CAPAC. PARA ADULTOS MADRE MA', value: '18054' },
  { text: 'COLEGIO MOZART SCHULE', value: '18055' },
  { text: 'ESCUELA DE LENGUAJE BULNES', value: '18061' },
  { text: 'ESCUELA DE LENGUAJE INALAF', value: '18062' },
  { text: 'ESCUELA DE LENGUAJE BELEN', value: '18063' },
  { text: 'ESCUELA DE LENGUAJE VALENTINA', value: '18064' },
  { text: 'ESCUELA NUEVA REPUBLICA', value: '18065' },
  { text: 'COLEGIO AURORA DE CHILE SUR', value: '18066' },
  {
    text: 'CENTRO INTEGRAL DE EDUCACI\u00c3\u201cN HIGH SCOPE LTDA',
    value: '18069',
  },
  { text: 'JARDIN INFANTIL MI CASTILLITO', value: '18071' },
  { text: 'JARDIN INFANTIL JUAN BAUTISTA', value: '18073' },
  { text: 'ESCUELA DE LENGUAJE SANTA JUANA', value: '18074' },
  { text: 'COLEGIO JAHVE NISI', value: '18075' },
  { text: 'JARDIN INFANTIL KARAMELO', value: '18076' },
  { text: 'CENTRO DE EXPLORACION CAPAC. LABORAL SAN RAFA', value: '18077' },
  { text: 'ESCUELA DE LENGUAJE EL VALLE', value: '18078' },
  { text: 'ESCUELA DE LENGUAJE ASERRIN ASERRAN', value: '18079' },
  { text: 'LICEO POLITECNICO CARAMPANGUE', value: '18080' },
  { text: 'ESCUELA  DE LENGUAJE EDUCERE', value: '18081' },
  { text: 'ESCUELA DE ADULTOS INTECAP', value: '18082' },
  { text: 'ESCUELA DE LENGUAJE MY DISNNEY', value: '18085' },
  { text: 'ESCUELA DE LENGUAJE MI DESPERTAR', value: '18086' },
  { text: 'DINABEC COLLEGE', value: '18087' },
  { text: 'CENTRO DE FORMACION LABORAL SAN ANDRES', value: '18088' },
  { text: 'ESCUELA DE LENGUAJE BAMBI', value: '18089' },
  { text: 'COLEGIO SAN LORENZO', value: '18090' },
  { text: 'ESUELA ESPECIAL LOS NARANJOS', value: '18091' },
  { text: 'ESCUELA DE LENGUAJE LARAQUETE', value: '18092' },
  { text: 'COLEGIO EL VALLE DE HUALQUI', value: '18093' },
  { text: 'CHRISTIAN COLLEGE', value: '18094' },
  { text: 'ESCUELA DE LENGUAJE SAN PABLO', value: '18095' },
  { text: 'ESCUELA DE LENGUAJE ALBORADA', value: '18096' },
  { text: 'COLEGIO ALMONDALE LOMAS', value: '18097' },
  { text: 'ESCUELA TOMAS LAGO', value: '18099' },
  { text: 'CENTRO DE FORMACION LABORAL EDUCERE', value: '18100' },
  { text: 'ESCUELA DE LENGUAJE ATRAPA PALABRAS', value: '18101' },
  { text: 'COLEGIO PAULO FREIRE', value: '18102' },
  { text: 'CENTRO DE RECURSOS EDUCACIONALES ESPECIALES P', value: '18104' },
  { text: 'ESCUELA DE LENGUAJE GIRASOL', value: '18105' },
  { text: 'ESCUELA ESPECIAL DEL MAR', value: '18106' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE SEMILLITA', value: '18107' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE QUIRIHUE', value: '18108' },
  { text: 'ESCUELA ESPECIAL DIFERENCIAL SOL NACIENTE', value: '18109' },
  { text: 'JARDIN INFANTIL PAPELUCHO', value: '18110' },
  { text: 'COMPLEJO EDUCACIONAL GLORIA MENDEZ BRIONES', value: '18111' },
  { text: 'LICEO INES ENRIQUEZ FRODDEN', value: '18112' },
  { text: 'ESCUELA ESPECIAL LOS GIRASOLES', value: '18113' },
  { text: 'COLEGIO A-LAFKEN', value: '18114' },
  { text: 'JARDIN INFANTIL SALA CUNA CHINITA', value: '18115' },
  { text: 'JARDIN INFANTIL SNOOPY', value: '18116' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE MATILDA', value: '18119' },
  {
    text: 'ESC. ESPECIAL DE LENGUAJE PEQUE\u00c3\u2018OS TESOROS',
    value: '18121',
  },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE CIDNEE', value: '18122' },
  { text: 'ESCUELA DE LENGUAJE CABRERO', value: '18123' },
  { text: 'COLEGIO SANTA TERESITA', value: '18124' },
  { text: 'ESCUELA DIFERENCIAL BEETHOVEN', value: '18125' },
  { text: 'COLEGIO PORVENIR SCHOOL', value: '18126' },
  { text: 'CENTRO EDUCACIONAL ALBORADA', value: '18127' },
  { text: 'COLEGIO SANTO TOMAS', value: '18128' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE AMANECER', value: '18130' },
  { text: 'ESC. ESP. DE LENGUAJE ENTRE PALABRAS', value: '18131' },
  { text: 'CENTRO EDUC. ESPECIAL LUIS ESPINOZA PIERRETTI', value: '18132' },
  { text: 'CENTRO DE EST.TEMPRANA . Y BASICA ESP. PASO A', value: '18133' },
  { text: 'JARDIN INFANTIL CANTACUENTOS', value: '18138' },
  { text: 'ESCUELA DE LENGUAJE RAYEN-ANTU', value: '18139' },
  { text: 'JARDIN INFANTIL EBEN EZER', value: '18140' },
  { text: 'CENTRO ESTIMULACION TEMPRANA PRINCESITA MISIN', value: '18142' },
  { text: 'ESCUELA  DIFERENCIAL  ESTRELLITA DE BELEN', value: '18143' },
  { text: 'ESC. ESP. DE LANGUAJE PADRE ALBERTO HURTADO', value: '18144' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE COLIBRI', value: '18145' },
  { text: 'CENTRO DIF. ESTIMULACION TEMPRANA MANANTIAL', value: '18146' },
  { text: 'COLEGIO EDUCA BIO/BIO', value: '18147' },
  { text: 'COLEGIO RUCALHUE', value: '18149' },
  { text: 'ESCUELA DIFERENCIAL ASPAUT CHIGUAYANTE', value: '18150' },
  { text: 'INSTITUTO DE ATENCION A LA DIVERSIDAD INAD', value: '18152' },
  { text: 'CENTRO PSICOPEDAGOGICO EMMANUEL', value: '18153' },
  { text: 'ESC. ESP. DE LENGUAJE TIMONEL CORONEL', value: '18154' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ARAUCO', value: '18155' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE AGUA DE PEMUCO', value: '18156' },
  { text: 'ESC. ESPECIAL DE LENGUAJE RAYEN', value: '18157' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE LICANRAY', value: '18158' },
  { text: 'ESCUELA DE LENGUAJE ALMENDRA', value: '18159' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE CAMPANITA', value: '18160' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ANTUKUYEN', value: '18162' },
  { text: 'COLEGIO GRAN BRETA\u00c3\u2018A', value: '18163' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE VILLA HERMOSA', value: '18164' },
  { text: 'CENTRO CAPACITACION LABORAL MIRANDO EL FUTURO', value: '18166' },
  { text: 'ESCUELA ESP. DE LENGUAJE ARAUCARIA', value: '18167' },
  { text: 'ESC. ESPECIAL DE LENGUAJE BUEN RETIRO', value: '18168' },
  { text: 'CENTRO DE ESTIMULACION TEMPRANA ANTU', value: '18169' },
  { text: 'COLEGIO MONTE \u00c3\u0081GUILA COLLEGE', value: '18170' },
  { text: 'COLEGIO AMANECER TALCAHUANO', value: '18172' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE LAS PALMERITAS', value: '18173' },
  { text: 'CENTRO FORMACION LABORAL LIWENKO', value: '18175' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE NUEVO FUTURO', value: '18176' },
  { text: 'CENTRO INT. EDUCACIONAL TECNOLOGICA CURAMAVID', value: '18177' },
  { text: 'ESC. ESP. DE LENGUAJE JARDIN DE PALABRAS', value: '18178' },
  { text: 'COLEGIO HARVARD COLLEGE', value: '18180' },
  {
    text: 'INST. HUMANIDADES MONSE\u00c3\u2018OR JOSE MANUEL SANTO',
    value: '18181',
  },
  { text: 'COLEGIO PER SE', value: '18183' },
  { text: 'COLEGIO BORDERIO', value: '18184' },
  { text: 'JARDIN INFANTIL LOS PEQUE\u00c3\u2018OS ARTESANOS', value: '18185' },
  { text: 'JARDIN INFANTIL LOS PECECITOS', value: '18186' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE BOSQUE MIO', value: '18187' },
  { text: 'ESCUELA DE LENGUAJE LLACOLEN', value: '18188' },
  { text: 'ESCUELA DE LENGUAJE AMULEN', value: '18189' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ALCAZAR', value: '18190' },
  { text: 'ESCUELA DE LENGUAJE PALABRAS DE VIDA', value: '18191' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE HUEPIL', value: '18192' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE KETRAWUE', value: '18193' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE PALABRITAS', value: '18194' },
  {
    text: 'ESCUELA ESPECIAL DE LENGUAJE PEQUE\u00c3\u2018OS SUE\u00c3\u2018OS',
    value: '18195',
  },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE LLAIPEN', value: '18197' },
  { text: 'COLEGIO QUILLON', value: '18199' },
  { text: 'CENTRO DE ESTIMULACION TEMPRANA ANGELITOS', value: '18200' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ALONKURA', value: '18202' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE KIMALU', value: '18203' },
  { text: 'JARDIN INFANTIL ZAPATITO JUGUETON', value: '18204' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE BOSQUE MAGICO', value: '18205' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE AMAPOLA', value: '18206' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE PINTO Y APRENDO', value: '18207' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ALTO DEL LAJA', value: '18208' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE AYUN-ELUN', value: '18209' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE SAN FRANCISCO DE', value: '18210' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE MIS DULCES PALAB', value: '18211' },
  { text: 'ESCUELA DE LENGUAJE EDUPLAY', value: '18212' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ADONAY', value: '18213' },
  { text: 'JARDIN INFANTIL Y ESC. LENGUAJE PRIMEROS PASO', value: '18214' },
  { text: 'JARDIN INFANTIL GLOBITOS', value: '18216' },
  { text: 'COLEGIO NUEVOS HORIZONTES', value: '18218' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE FLOR DE JAZMIN', value: '18219' },
  { text: 'ESCUELA ESP. DE LENGUAJE NUEVA ESPERANZA', value: '18220' },
  { text: 'ESC. ESP.DE LENGUAJE EL MUNDO DE NI\u00c3\u2018OS', value: '18221' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE PASITOS', value: '18222' },
  { text: 'COLEGIO EL FARO', value: '18223' },
  { text: 'ESC. ESP. DE LENG. GOLDEN HOUSE', value: '18224' },
  { text: 'ESC. ESP. DE LENGUAJE CANTO DE LUNA', value: '18225' },
  { text: 'ESC. ESP. DE LENGUAJE PALABRAS M\u00c3\u0081GICAS', value: '18226' },
  { text: 'ESC. ESPECIAL DE LENGUAJE ALTO TUCAPEL', value: '18227' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE INTECAP', value: '18228' },
  { text: 'COLEGIO INGL\u00c3\u2030S PALABRAS DE VIDA', value: '18230' },
  { text: 'ESCCUELA. ESP. DE LENG. PALABRAS DE VIDA', value: '18231' },
  { text: 'ESCUELA DE LENGUAJE ARBOLIRIS', value: '18233' },
  { text: 'COLEGIO ALTAZOR', value: '18234' },
  { text: 'ESCUELA DE LENGUAJE ALTUE', value: '18235' },
  { text: 'ESC ESP DIFY DE LENG. MAISON DE L`ENFACE', value: '18236' },
  { text: 'COLEGIO AMANECER SAN CARLOS', value: '18237' },
  { text: 'ESCUELA DE LENGUAJE ALBORADA', value: '18238' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE MANQUIMAVIDA', value: '18239' },
  { text: 'JARDIN INFANTIL JUGANDO APRENDO', value: '18240' },
  { text: 'CENTRO EDUCACION INTEG DE ADULTOS NAHUELQUIN', value: '18241' },
  { text: 'COLEGIO INGL\u00c3\u2030S PALABRAS DE VIDA', value: '18243' },
  { text: 'CENTRO LABORAL DE EDUCACION ESPECIAL CIDNEE', value: '18244' },
  { text: 'ESC ESP DE LENGUAJE ELENA CABRERO TORO', value: '18245' },
  { text: 'COLEGIO SAN NICOL\u00c3\u0081S', value: '18247' },
  { text: 'ESCUELA EL RENOVAL', value: '18248' },
  { text: 'COLEGIO INSTITUTO CRISTIANO GRACIA Y PAZ', value: '18249' },
  { text: 'JARD\u00c3\u008dN INFALTIL ARCOIRIS', value: '18250' },
  { text: 'COLEGIO ALTURAS DE CHILL\u00c3\u0081N', value: '18251' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE MI ANGEL', value: '18252' },
  { text: 'ESCUELA ESPECIA DE LENGUAJE JUAN PABLO II', value: '18253' },
  { text: 'ESCUELA ESP. DE LENGUAJE SANTA CATALINA', value: '18254' },
  { text: 'ESCUELA ESP. DE LENGUAJE EFRAIN AEDO', value: '18255' },
  { text: 'ESCUELA ANEXA DE PELEHUITO', value: '19902' },
  {
    text: 'IER. LICEO T\u00c3\u2030CNICO PROFESIONAL HUISCAPI',
    value: '19904',
  },
  { text: 'LICEO POLITECNICO EMA ESPINOZA CORREA', value: '19906' },
  { text: 'ESC. ESPECIAL RETARDO MENTAL CLARET', value: '19907' },
  { text: 'ESCUELA PARTICULAR SAN LORENZO', value: '19910' },
  { text: 'ESCUELA PARTICULAR BOLLILCO', value: '19911' },
  { text: 'ESC. BASICA CRUZ DEL SUR', value: '19912' },
  { text: 'COMPLEJO EDUCACIONAL LOS SAUCES', value: '19913' },
  { text: 'ESC.ESP.RET.MENTAL FEYENTUN', value: '19914' },
  { text: 'ESCUELA ESPECIAL ERICO HORNUNG', value: '19918' },
  { text: 'ESCUELA PARTICULAR APOCALIPSIS', value: '19919' },
  { text: 'INSTITUTO CAMILO HENRIQUEZ', value: '19921' },
  { text: 'ESCUELA PARTICULAR ANTUMALAL', value: '19922' },
  { text: 'ESCUELA NRO 15  AMI', value: '19923' },
  { text: 'LICEO PARTICULAR COMERCIAL CARAHUE', value: '19925' },
  { text: 'ESCUELA ESPECIAL RETARDO MENTAL', value: '19926' },
  { text: 'ESCUELA BASICA VOLCAN LLAIMA', value: '19927' },
  { text: 'ESCUELA PARTICULAR SAN IGNACIO', value: '19928' },
  { text: 'ESC. PART. BASICA COMUN BOLIL', value: '19930' },
  { text: 'ESCUELA ESPECIAL DAME LA MANO', value: '19931' },
  { text: 'JARDIN INFANTIL BAMBI', value: '19933' },
  { text: 'ESCUELA PARTICULAR EL DESPERTAR', value: '19934' },
  { text: 'ESCUELA PARTICULAR ALFA Y OMEGA', value: '19944' },
  { text: 'ESCUELA ESPECIAL TULIO ORA ALARCON', value: '19945' },
  { text: 'ESCUELA LAURA VICUNA', value: '19947' },
  { text: 'ESCUELA PARTICULAR PAULA JARAQUEMADA', value: '19948' },
  { text: 'ESCUELA PARTICULAR SANTA OLGA', value: '19949' },
  { text: 'ESCUELA PARTICULAR SAN ANDRES', value: '19950' },
  { text: 'ESCUELA PARTICULAR EL PILAR', value: '19951' },
  { text: 'COLEGIO ANGOL', value: '19952' },
  { text: 'ESCUELA BILINGUE AMUL KEWUN', value: '19953' },
  {
    text: 'ESCUELA ESPECIAL DE TRASTORNOS DE LA COMUNICACION ORAL DOCKSTA',
    value: '19954',
  },
  { text: 'ESCUELA PARTICULAR QUINQUEN', value: '19958' },
  { text: 'COLEGIO JUAN XXIII', value: '19959' },
  { text: 'COLEGIO ANTUMALEN', value: '19960' },
  { text: 'SOUTHERN OXFORD SCHOOL', value: '19962' },
  { text: 'ESC. ESPECIAL PART. ALENKURA', value: '19964' },
  { text: 'ESCUELA PARTICULAR TERESA DE LOS ANDES', value: '19965' },
  { text: 'ESCUELA PARTICULAR ADVENTISTA', value: '19968' },
  { text: 'ESC.ESPECIAL SAN CRISTOBAL', value: '19969' },
  { text: 'ESCUELA ESPECIAL HABLAARTE', value: '19973' },
  { text: 'COMPLEJO EDUCACIONAL LA FRONTERA', value: '19974' },
  { text: 'COMPLEJO EDUCACIONAL EDUCASE', value: '19975' },
  { text: 'ESCUELA RADALCO', value: '19976' },
  { text: 'COLEGIO NUEVA CONCEPCION', value: '19981' },
  { text: 'COLEGIO DE EDUCACION ADULTOS VIDA Y PAZ', value: '19982' },
  { text: 'ESCUELA BASICA PARTICULAR EMPRENDER', value: '19983' },
  { text: 'COLEGIO HOLANDA', value: '19984' },
  { text: 'ESCUELA BASICA MUNICIPAL EL MAITEN', value: '19986' },
  { text: 'JARDIN INFANTIL LOS PEQUES', value: '19992' },
  { text: 'C.E.I.A. ANTONIO ACEVEDO HERNANDEZ', value: '19993' },
  { text: 'ESCUELA NUEVA MENETUE', value: '19996' },
  { text: 'ESCUELA CHANCO MARIHUAL BAJO', value: '19998' },
  { text: 'ESCUELA PARTICULAR GALLETUE', value: '19999' },
  { text: 'C.E.I.A.  ALERTA', value: '20001' },
  { text: 'ESCUELA DE LA COMUNICACION ICALMA', value: '20002' },
  { text: 'COLEGIO EL LABRADOR', value: '20008' },
  { text: 'ESCUELA PARTICULAR CHILE', value: '20009' },
  { text: 'ESCUELA ENRIQUE TENORIO FUENTES', value: '20010' },
  { text: 'ESCUELA ESPECIAL NTRA.SENORA DEL PILAR', value: '20011' },
  { text: 'CENTRO DE EDUC. ADULTOS PAULO FREIRE', value: '20012' },
  { text: 'ESCUELA PARTICULAR KIMELTUN', value: '20013' },
  { text: 'ESC.PART.SAN FRANCISCO DE COIHUE', value: '20015' },
  { text: 'COLEGIO DE APLICACION', value: '20016' },
  { text: 'ESCUELA SAN JUAN DE DIOS', value: '20018' },
  { text: 'SUN FLOWER SCHOOL', value: '20019' },
  { text: 'ESCUELA PARTICULAR VOIPIR SECO', value: '20022' },
  { text: 'ESCUELA PARTICULAR HUENTE', value: '20024' },
  { text: 'ESCUELA ARTISTICA ARMANDO DUFEY BLANC', value: '20025' },
  { text: 'ESCUELA MAPU- LAFKEN', value: '20026' },
  { text: 'ESCUELA HUERTOS MINEROS', value: '20027' },
  { text: 'ESCUELA SANTA VICTORIA', value: '20029' },
  { text: 'ESC.ESPEC.ESDELENG TRAST.DE LA COMUNIC..', value: '20030' },
  { text: 'ESCUELA PARTICULAR TRAGUA TRAGUA', value: '20033' },
  { text: 'ESCUELA PARTICULAR ARTURO PRAT', value: '20034' },
  { text: 'ESCUELA PARTICULAR CLAUDIO ARRAU', value: '20041' },
  { text: 'ESC. PART. LUCILA GODOY ALCAYAGA', value: '20042' },
  { text: 'CENTRO DE EDUCACION DE ADULTOS LEFXARV', value: '20043' },
  { text: 'CTRO.EDUC.ADULTOS T.P. EL SEMBRADOR', value: '20044' },
  { text: 'ESCUELA PART. MISS CLARA BRINCEFIELD', value: '20046' },
  {
    text: 'CENTRO DE ESTUDIOS DE LAS COMUNICACIONES PARA EL TRABAJO',
    value: '20047',
  },
  { text: 'ESCUELA MALLEARAUCO', value: '20051' },
  { text: 'COMPLEJO EDUCACIONAL VICTORIA', value: '20052' },
  { text: 'LICEO TECNICO PROFESIONAL HUALPIN', value: '20053' },
  { text: 'ESCUELA GASPAR HUENCHUMAN', value: '20054' },
  { text: 'ESCUELA RAYEN MAPU', value: '20056' },
  { text: 'ESCUELA ESPECIAL LAS LILAS DE TRAIGUEN', value: '20058' },
  { text: 'ESCUELA ESPECIAL LAGO AZUL', value: '20060' },
  { text: 'COLEGIO DE LENGUAJE PEHUEN', value: '20061' },
  { text: 'CENTRO DE EDUC.I.ADUL.MIGUEL DE CERVANTES', value: '20063' },
  { text: 'BERNARDO OHIGGINSS', value: '20064' },
  { text: 'JARDIN INFANTIL RAYITO DE SOL', value: '20065' },
  { text: 'CENTRO DE ESTUDIOS Y CAPACITACION LIMITADA', value: '20066' },
  { text: 'ESCUELA FRANCISO QUEREBAN', value: '20067' },
  { text: 'ESCUELA PARTICULAR SAINT GEORGE', value: '20068' },
  { text: 'ESCUELA PART. DE ADULTOS GETSEMANI', value: '20070' },
  { text: 'ESCUELA PARTICULAR LA DEHESA', value: '20071' },
  { text: 'CENTRO EDUC.INTEGRAL ADULTOS ACROPOLIS', value: '20073' },
  { text: 'CAMBRIDGE COLLEGE PRIMAVERA', value: '20074' },
  { text: 'ESCUELA MIRTHA AVILA VALDES', value: '20075' },
  { text: 'CENTRO EDUC.INTEGRAL ADULTOS FUTURO', value: '20078' },
  { text: 'ESCUELA PARTICULAR JUVENCIO VALLE', value: '20080' },
  { text: 'ESCUELA PARTICULAR SAN MATIAS', value: '20081' },
  { text: 'ESCUELA PART.NUESTRA SENORA DEL ROSARIO', value: '20082' },
  { text: 'ESCUELA PARTICULAR CHIHUIMPILLI', value: '20084' },
  { text: 'COLEGIO GOLDEN SCHOOL', value: '20085' },
  { text: 'ESCUELA ARCO IRIS', value: '20087' },
  { text: 'ESCUELA POETISA GABRIELA MISTRAL', value: '20088' },
  { text: 'C.E.I.A VILCUN', value: '20089' },
  { text: 'COLEGIO PUMAHUE TEMUCO', value: '20091' },
  { text: 'JARDIN INFANTIL BICHITOS', value: '20092' },
  { text: 'ESCUELA PARTICULAR LA ESPERANZA', value: '20094' },
  { text: 'COLEGIO CAMILO HENRIQUEZ DE PEDREGOSO', value: '20095' },
  { text: 'COLEGIO BETANIA', value: '20096' },
  { text: 'ESCUELA ESPECIAL ALFONSO RECART', value: '20097' },
  { text: 'ESCUELA FEDERICO GARCIA LORCA', value: '20098' },
  { text: 'ESCUELA ALIWEN DE LLAMUCO', value: '20099' },
  { text: 'JARDIN INFANTIL CIUDAD DEL PARVULO', value: '20100' },
  { text: 'ESCUELA PART.BASICA ESPECIAL CONILE', value: '20102' },
  { text: 'LICEO MUNICIPAL LUMACO', value: '20103' },
  { text: 'JARDIN INFANTIL MI MUNDO', value: '20106' },
  { text: 'ESCUELA PARTICULAR MADRIGAL', value: '20108' },
  { text: 'CENTRO DE EDUCACI-N DE ADULTOS PAULO FREIRE', value: '20110' },
  { text: 'ESCUELA BASICA PART VISTA HERMOSA', value: '20113' },
  { text: 'LICEO AMERICO VESPUCIO', value: '20114' },
  { text: 'ESCUELA LOS ALAMOS', value: '20117' },
  { text: 'ESCUELA SANTA TERESITA DE IMPERIAL', value: '20119' },
  { text: 'COLEGIO JOSE GIORDANO', value: '20120' },
  { text: 'ESCUELA MUNICIPAL LOS ARRAYANES', value: '20121' },
  { text: 'ESCUELA TRANI-TRANI', value: '20122' },
  { text: 'LICEO TECNICO PROFESIONAL PAILAHUEQUE', value: '20123' },
  { text: 'LICEO TECN. PROF. FORESTAL PEHUEN', value: '20127' },
  { text: 'ESCUELA GRACIA Y PAZ', value: '20129' },
  { text: 'COLEGIO DE ADULTOS SOL DE AMERICA', value: '20131' },
  { text: 'LICEO JOS\u00c3\u02c6 MIGUEL CARRERA', value: '20132' },
  { text: 'ESCUELA BASICA NINOS FELICES', value: '20133' },
  { text: 'ESCUELA PARTICULAR RUKA LINC', value: '20135' },
  { text: 'LICEO POLITECNICO LOS NOGALES', value: '20136' },
  { text: 'COLEGIO INNOV-ARTE', value: '20137' },
  { text: 'LICEO TECNOLOGICO MONTEMARIA', value: '20139' },
  { text: 'ESCUELA PART. APRENDIENDO A VIVIR', value: '20140' },
  { text: 'ESCUELA PARTICULAR EMANUEL', value: '20141' },
  { text: 'ESCUELA PARTICULAR TRIPAHUE-ANTU', value: '20142' },
  { text: 'ESCUELA PARTICULAR EL MIRADOR', value: '20144' },
  { text: 'ESCUELA GOLDEN HOUSE', value: '20145' },
  { text: 'ESCUELA MILLARAYEN', value: '20146' },
  { text: 'RUKA PEWEN', value: '20147' },
  { text: 'ESCUELA PARTICULAR PADRE HURTADO', value: '20149' },
  { text: 'ESCUELA PARTICULAR RENICO', value: '20150' },
  { text: 'LICEO PARTICULAR DE ADULTOS HOREB', value: '20151' },
  { text: 'ESCUELA PARTICULAR LA FORESTA', value: '20152' },
  { text: 'ESCUELA PARTICULAR PUCON NEVADOS', value: '20153' },
  { text: 'ESCUELA BASICA ANTU RAYEN', value: '20154' },
  { text: 'ESCUELA ESP. DE LENGUAJE ANTUMAPU', value: '20155' },
  { text: 'JARDIN INFANTIL PEQUENAS SEMILLAS', value: '20156' },
  { text: 'COLEGIO ALTAS CUMBRES', value: '20158' },
  { text: 'ESCUELA PART. SUBVENCIONADA AMANCAY', value: '20161' },
  { text: 'ESCUELA PART. REINO DE SUECIA', value: '20162' },
  { text: 'LICEO AGRICOLA SAN SEBASTIAN', value: '20164' },
  { text: 'ESCUELA PARTICULAR SUENOS DORADOS', value: '20165' },
  { text: 'JARDIN INFANTIL HORMIGUITA', value: '20168' },
  { text: 'LICEO JUAN PABLO II', value: '20175' },
  { text: 'LICEO DE ADULTOS CAUTIN', value: '20176' },
  { text: 'JARDIN INFANTIL ESTRELLA DE BELEN', value: '20177' },
  { text: 'JARDIN INFANTIL RAYEN-MAPU', value: '20178' },
  { text: 'ESCUELA PARTICULAR EL ESTERO', value: '20179' },
  { text: 'ESC.CRISTIANA DESARROLLO INTEGRAL', value: '20180' },
  { text: 'COLEGIO JUAN PABLO II', value: '20182' },
  { text: 'LICEO COEDUCACIONAL INTERCULTURAL PABLO NERU', value: '20183' },
  { text: 'LICEO SAN SEBASTIAN', value: '20184' },
  { text: 'COLEGIO SAN GABRIEL', value: '20186' },
  { text: 'ESCUELA PARTICULAR NUEVO AMANECER', value: '20187' },
  { text: 'COLEGIO PARTICULAR EXCELSIOR', value: '20189' },
  { text: 'LICEO TECNICO PROFESIONAL PUERTO SAAVEDRA', value: '20190' },
  { text: 'ESCUELA PARTICULAR JORGE CRUCES VALLEJOS', value: '20192' },
  { text: 'COMPLEJO EDUCACIONAL MAQUEHUE', value: '20193' },
  { text: 'COLEGIO INGLES MI MUNDO', value: '20194' },
  { text: 'JARDIN INFANTIL MI CASITA', value: '20195' },
  { text: 'COLEGIO EDUCACION DE ADULTOS NAHUEL', value: '20196' },
  { text: 'JARDIN INFANTIL CASITA DEL BOSQUE', value: '20197' },
  { text: 'ESCUELA MUNICIPAL GABRIELA MISTRAL', value: '20200' },
  { text: 'ESCUELA KUMUN NEWEN', value: '20201' },
  { text: 'ESCUELA PARTICULAR SAN ALBERTO', value: '20202' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE CRE-SER', value: '20203' },
  { text: 'ESCUELA ESPECIAL RUCA MAHUIDA', value: '20204' },
  { text: 'ESCUELA PARTICULAR HABIT-ART', value: '20205' },
  { text: 'ESCUELA ESP.LENGUAJE ANDALUE', value: '20206' },
  { text: 'COLEGIO EDUC. DE ADULTOS NAHUEL', value: '20208' },
  { text: 'COLEGIO RAITRAI DE PUCON', value: '20209' },
  { text: 'COLEGIO INGLES BRITISH ROYAL SCHOOL', value: '20211' },
  { text: 'COLEGIO HEBREO', value: '20212' },
  { text: 'COLEGIO PEDRO DE VALDIVIA', value: '20213' },
  { text: 'COLEGIO DE EDUC. DE ADULTOS ANDES', value: '20214' },
  { text: 'ESCUELA PARTICULAR SAN LEONARDO', value: '20215' },
  { text: 'JARDIN INFANTIL ALEN', value: '20216' },
  { text: 'ESCUELA PART. TEMUCO COLLEGE', value: '20218' },
  { text: 'COLEGIO  ADENAUER', value: '20219' },
  { text: 'JARDIN INFANTIL MARIA TERESA FUENZALIDA', value: '20221' },
  { text: 'ESCUELA PARTICULAR INALKO', value: '20222' },
  { text: 'ESCUELA ESPECIAL LIWEN', value: '20223' },
  { text: 'ESCUELA DE LENGUAJE MANANTIAL', value: '20225' },
  { text: 'COLEGIO NEWHARVEST', value: '20226' },
  { text: 'COLEGIO JUAN PABLO II', value: '20227' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ARCO IRIS', value: '20228' },
  { text: 'JARDIN INFANTIL PEQUE\u00c3\u2018O SEMBRADOR', value: '20229' },
  { text: 'LICEO PARTICULAR SAN ROQUE', value: '20230' },
  { text: 'COLEGIO DE ADULTOS INAPEWMA', value: '20232' },
  { text: 'JARDIN INFANTIL RAKIDUAM', value: '20233' },
  { text: 'JARDIN INFANTIL DE COLORES', value: '20234' },
  { text: 'ESCUELA DE LENGUAJE PASO A PASO', value: '20237' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE  VICTORIA', value: '20239' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE CAPULLITO', value: '20240' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE COLEN', value: '20242' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE PEKES', value: '20243' },
  { text: 'COLEGIO DE ADULTOS RAYENCO', value: '20244' },
  { text: 'COLEGIO DE ADULTOS TRINIDAD', value: '20245' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ALEMANIA', value: '20246' },
  { text: 'ESC. ESPECIAL LENGUAJE STA. PATRICIA', value: '20247' },
  { text: 'LICEO MUNICIPAL TROVOLHUE', value: '20248' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE RAICES DEL SUR', value: '20250' },
  { text: 'COLEGIO DE ADULTOS WALMAPU', value: '20251' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE WILEF', value: '20252' },
  { text: 'THE FAMILY SCHOOL', value: '20254' },
  { text: 'JARDIN INFANTIL CLARO DE LUNA', value: '20256' },
  { text: 'ESCUELA DE LENGUAJE SUYAI', value: '20257' },
  { text: 'LICEO CUMBRES DE LABRANZA', value: '20258' },
  { text: 'ESCUELA SAN MIGUEL DE IMPERIALITO', value: '20259' },
  { text: 'COLEGIO FILADELFIA', value: '20260' },
  { text: 'ESCUELA RURAL LOS COPIHUES', value: '22002' },
  { text: 'LICEO TECNICO PROFESIONAL REMEHUE', value: '22004' },
  { text: 'COLEGIO ARTISTICO SANTA CECILIA', value: '22007' },
  { text: 'ESCUELA PARTICULAR TICAHUE', value: '22008' },
  { text: 'COLEGIO SANTA MARIA', value: '22009' },
  { text: 'COLEGIO CHILOE', value: '22010' },
  { text: 'ESCUELA PARTICULAR RAIQUEN', value: '22011' },
  { text: 'LICEO PUNTA DE RIELES', value: '22012' },
  { text: 'ESCUELA ESPECIAL LOS CIRUELILLOS', value: '22013' },
  { text: 'COLEGIO BAQUEDANO', value: '22014' },
  { text: 'ESCUELA RURAL INCOPULLI', value: '22015' },
  { text: 'ESCUELA PARTICULAR CARRAN CHICO', value: '22016' },
  { text: 'ESCUELA PARTICULAR ADVENTISTA', value: '22019' },
  { text: 'COLEGIO CAHUALA', value: '22020' },
  { text: 'LICEO LAS AMERICAS', value: '22021' },
  { text: 'LICEO AGRICOLA RADIO 24', value: '22024' },
  { text: 'ESCUELA PARTICULAR SAN MIGUEL', value: '22025' },
  { text: 'LICEO HORNOPIREN', value: '22027' },
  { text: 'STAR COLLEGE', value: '22029' },
  { text: 'JARDIN INFANTIL LOS CARI\u00c3\u2018OSITOS', value: '22038' },
  { text: 'CENTRO EDUCACIONAL PAZ Y AMOR', value: '22041' },
  { text: 'ESCUELA PARTICULAR DE PULELO', value: '22042' },
  { text: 'ESCUELA RURAL EL PROGRESO', value: '22045' },
  { text: 'ESCUELA BASICA ANEXA G-614', value: '22048' },
  { text: 'ESCUELA PART. LAS CONCHILLAS CHANGUE', value: '22049' },
  { text: 'LICEO BENJAMIN MUNOZ GAMERO', value: '22050' },
  { text: 'ESC. ESPECIAL DE LENGUAJE PEKE LINES', value: '22051' },
  { text: 'LICEO AGRICOLA SAN JAVIER', value: '22062' },
  { text: 'CENTRO EDUC.ADULTOS PAULO FREIRE', value: '22066' },
  { text: 'LICEO POLITECNICO ANTULAFKEN', value: '22067' },
  { text: 'JARDIN INFANTIL RAYITO DE SOL', value: '22070' },
  { text: 'ESCUELA RURAL ACUY', value: '22072' },
  { text: 'ESCUELA PARTICULAR LLAQUITO', value: '22077' },
  { text: 'CENTRO EDUCACIONAL MAIHUE', value: '22078' },
  { text: 'ESCUELA PARTICULAR N\u00c2\u00b0 327 SEMBRADOR', value: '22079' },
  { text: 'LICEO COMERCIAL LEONARDO DA VINCI', value: '22080' },
  { text: 'LIC. AGR. Y FORESTAL PEOPLE HELP PEOPLE', value: '22081' },
  { text: 'ESC. BASICA ALMIRANTE JUAN J. LATORRE', value: '22083' },
  { text: 'LICEO POLITECNICO ANTULAFQUEN', value: '22084' },
  { text: 'COLEGIO LAS QUEMAS', value: '22086' },
  { text: 'JARDIN INFANTIL FANTASIA', value: '22087' },
  { text: 'CENTRO DE EDUCACION INTEGRADA DE ADULTOS', value: '22089' },
  { text: 'JARDIN INFANTIL RAYITO DE LUZ', value: '22091' },
  { text: 'ESCUELA PARTICULAR LOS HALCONES', value: '22092' },
  { text: 'ESCUELA BASICA SAN LUIS', value: '22093' },
  { text: 'COLEGIO WANELEN WE', value: '22094' },
  { text: 'ESCUELA PARTICULAR EL HUIRO', value: '22095' },
  { text: 'ESCUELA PARTICULAR JUANITA FERNANDEZ SOLAR', value: '22096' },
  { text: 'LICEO AGROPECUARIO Y FORESTAL LIPINGUE', value: '22097' },
  { text: 'ESCUELA RURAL INIO', value: '22098' },
  { text: 'ESCUELA RURAL EL VARAL', value: '22100' },
  { text: 'ESCUELA DIFERENCIAL ASPADEP', value: '22101' },
  { text: 'CENTRO DE REHAB.PARALIS.CEREBRAL CEREPA', value: '22103' },
  { text: 'ESCUELA BASICA FRESIA', value: '22105' },
  { text: 'LICEO TECNICO MONSENOR FCO VALDES S.', value: '22108' },
  { text: 'ESCUELA PARTICULAR MALIHUE', value: '22111' },
  { text: 'ESCUELA RURAL PUNTA WHITE', value: '22112' },
  { text: 'LICEO FRAY PABLO DE ROYO', value: '22113' },
  { text: 'LICEO FRAY LUIS LEON', value: '22114' },
  { text: 'JARDIN INFANTIL ARLEQUIN', value: '22116' },
  { text: 'COLEGIO SAN ANDRES', value: '22119' },
  { text: 'ESCUELA PARTICULAR COMUY', value: '22125' },
  { text: 'JARDIN INFANTIL EL TALLITO', value: '22127' },
  { text: 'ESCUELA  ALLA KINTUY', value: '22130' },
  { text: 'ESCUELA ESP. DE LENG. PALABRAS MAGICAS', value: '22133' },
  { text: 'ESCUELA RURAL BONIFACIO', value: '22134' },
  { text: 'JARDIN INFANTIL LA CAMPI\u00c3\u2018A', value: '22137' },
  { text: 'ESCUELA RURAL EL TIGRE', value: '22138' },
  { text: 'ESCUELA ESPECIAL LAURA VICUNA', value: '22139' },
  { text: 'LICEO IND.ING.RICARDO FENNER R.', value: '22140' },
  { text: 'ESCUELA RURAL BLANCHARD', value: '22142' },
  { text: 'COLEGIO PUERTO VARAS', value: '22144' },
  { text: 'ESCUELA RURAL EL MIRADOR', value: '22145' },
  { text: 'COLEGIO ABRAHAM LINCOLN', value: '22146' },
  { text: 'ESCUELA DE PARVULOS CARPE DIEM', value: '22147' },
  { text: 'ESCUELA PART. EL PARQUE PONHUIPA', value: '22148' },
  { text: 'LICEO AGRICOLA DE ANCUD', value: '22151' },
  { text: 'ESCUELA PARTICULAR ESTRELLA SOLITARIA', value: '22153' },
  { text: 'JARDIN INFANTIL LOS ZARAPITOS', value: '22156' },
  { text: 'ESCUELA PARTICULAR EL PRADO', value: '22158' },
  { text: 'ESCUELA PARTICULAR EL MINERO', value: '22159' },
  { text: 'MARTIN LUTHER KING COLLEGE', value: '22160' },
  { text: 'ESCUELA PARTICULAR PUILE', value: '22162' },
  { text: 'JARDIN INFANTIL LAS HORMIGUITAS', value: '22163' },
  { text: 'ESCUELA PARTICULAR MARANATA', value: '22165' },
  { text: 'JARDIN INFANTIL CASITA ENCANTADA', value: '22172' },
  { text: 'JARDIN INFANTIL BAMBI', value: '22173' },
  { text: 'ESCUELA PARTICULAR OROMO DE LA PIEDRA', value: '22174' },
  { text: 'ESCUELA PABLO NERUDA', value: '22175' },
  { text: 'ESCUELA BASICA PADRE HURTADO', value: '22176' },
  { text: 'ESCUELA PART.HUMBERTO HERNANDEZ', value: '22180' },
  { text: 'ESCUELA PARTICULAR RALUYA', value: '22181' },
  { text: 'ESCUELA PARTICULAR RUBEN BASTIDAS', value: '22184' },
  { text: 'ESC. PART. CONDE DE LEMU', value: '22186' },
  { text: 'LICEO TECNICO MANUEL BAQUEDANO', value: '22187' },
  { text: 'LICEO SAN FRANCISCO', value: '22189' },
  { text: 'ESCUELA PARTICULAR EBEN EZER', value: '22190' },
  { text: 'ESCUELA PARTICULAR CUFEO ALTO', value: '22194' },
  { text: 'COLEGIO CRISTIANO BETESDA', value: '22195' },
  { text: 'COLEGIO QUELLON', value: '22196' },
  { text: 'ESCUELA PARTICULAR LOMAS DEL SOL', value: '22198' },
  { text: 'CENTRO PARA LA INTEGRACION JEROME BRUNER', value: '22201' },
  { text: 'COLEGIO LACUY', value: '22203' },
  { text: 'ESCUELA DE PARVULOS REY SALOMON', value: '22204' },
  { text: 'ESCUELA PARTICULAR SAN SEBASTIAN', value: '22207' },
  { text: 'ESCUELA RURAL EL LLOLLE', value: '22209' },
  { text: 'COLEGIO CAHUALA INSULAR', value: '22211' },
  { text: 'ESC. RURAL PIEDRA LILE', value: '22214' },
  { text: 'PUFUDI SCHOOL', value: '22218' },
  { text: 'ESCUELA SANTA CECILIA', value: '22219' },
  { text: 'ESC. PARTICULAR FRANCISCO COLOANE', value: '22220' },
  { text: 'ESCUELA FRAY LEONARDO', value: '22221' },
  { text: 'ESCUELA PARTICULAR ELISUR', value: '22222' },
  { text: 'CENTRO EDUCACIONAL LOS CARRERA', value: '22223' },
  { text: 'COLEGIO PROYECCION SIGLO XXI', value: '22224' },
  { text: 'ESC. PARTICULAR CHAQUIAN', value: '22225' },
  { text: 'COLEGIO LAURA VICUNA', value: '22226' },
  { text: 'COLEGIO AUSTRALIS', value: '22227' },
  { text: 'ESCUELA PARTICULAR LAS QUEMAS', value: '22228' },
  { text: 'ESCUELA BASICA LICARAYEN', value: '22229' },
  { text: 'COLEGIO JUAN XXIII', value: '22230' },
  { text: 'CENTRO DE EDUC. INTEGRAL DE ADULTOS PLENITUD', value: '22232' },
  { text: 'COLEGIO SAN VICENTE DE PAUL', value: '22234' },
  { text: 'BLAS PASCAL SCHOOL', value: '22236' },
  { text: 'JARDIN INFANTIL ESPIGUITA', value: '22238' },
  { text: 'JARDIN INFANTIL PILMAIQUEN', value: '22239' },
  { text: 'ESCUELA DE PARVULOS LOS PUMITAS', value: '22240' },
  { text: 'COLEGIO DE PARVULOS MI RINCON', value: '22241' },
  { text: 'ESCUELA PARTICULAR ESMERALDA', value: '22244' },
  { text: 'ESCUELA PARTICULAR NUEVO MILENIO', value: '22245' },
  { text: 'COLEGIO SHADDAI', value: '22246' },
  { text: 'INSTITUTO ALEMAN PURRANQUE', value: '22248' },
  { text: 'JARDIN INFANTIL MI PEQUENO SALESIANO M.AUXIL.', value: '22249' },
  { text: 'ESC. PART. PROF. JOSE VELASQUEZ VARGAS', value: '22253' },
  { text: 'COLEGIO ADOLFO KOLPING', value: '22255' },
  { text: 'CENTRO PARA LA ESTIMULACION DEL LENGUAJE INF', value: '22256' },
  { text: 'ESCUELA PARTICULAR PORVENIR', value: '22257' },
  { text: 'ESCUELA PARTICULAR SOL NACIENTE', value: '22258' },
  { text: 'JARDIN INFANTIL CRISPIN', value: '22259' },
  { text: 'COLEGIO SANTA ANA', value: '22260' },
  { text: 'ESCUELA PARTICULAR PABLO NERUDA', value: '22261' },
  { text: 'COLEGIO SAN CRISTOBAL', value: '22262' },
  { text: 'COLEGIO SAN MARCOS', value: '22263' },
  { text: 'GREEN COUNTRY SCHOOL', value: '22265' },
  { text: 'ESCUELA HERMINDA JARAMILLO QUINTANA', value: '22267' },
  { text: 'ESCUELA PARTICULAR GABRIELA MISTRAL', value: '22268' },
  { text: 'ESCUELA PARTICULAR TRAFUN CHICO', value: '22269' },
  { text: 'COLEGIO DE NINAS NUESTRA SENORA DE LOURDES', value: '22270' },
  { text: 'LICEO TECNICO LUIS PASTEUR', value: '22271' },
  { text: 'ESCUELA PARTICULAR MONSERRAT', value: '22274' },
  { text: 'COLEGIO PARTICULAR GRACIA PAZ', value: '22275' },
  { text: 'LICEO DE ADULTOS LORD COCHRANE', value: '22276' },
  { text: 'COLEGIO NACIONAL DE LA UNION', value: '22277' },
  { text: 'ESCUELA PARTICULAR HORIZONTE', value: '22279' },
  { text: 'ESCUELA PARTICULAR ALONSO DE ERCILLA', value: '22280' },
  { text: 'ESC. ESP. DE LENGUAJE NUEVA LENGUA', value: '22282' },
  { text: 'COLEGIO SAN MIGUEL', value: '22283' },
  { text: 'ESCUELA PARTICULAR HUALINTO', value: '22284' },
  { text: 'COLEGIO LOS TORREONES', value: '22286' },
  { text: 'JARDIN INFANTIL JEAN PIAGET', value: '22290' },
  { text: 'COLEGIO KIMEL', value: '22291' },
  { text: 'ESCUELA PARTICULAR LA BARRA', value: '22292' },
  { text: 'ESCUELA ESPECIAL SAN AGUSTIN', value: '22293' },
  { text: 'ESC.TALLER PARA AUTISTAS BERNARD RIMLAND', value: '22294' },
  { text: 'CORPORACION DE EDUCACION LA ARAUCANA', value: '22296' },
  { text: 'ESCUELA PARTICULAR DE PUNTA GRUESA', value: '22301' },
  { text: 'ESC.BAS.INTEG. STEPHEN HAWKING', value: '22302' },
  { text: 'COLEGIO PUERTO MONTT', value: '22306' },
  { text: 'CENTRO DE EDUCACION DE ADULTOS QUELLON', value: '22307' },
  { text: 'ESCUELA PARA AUTISTAS CAMINO DE ESPERANZA', value: '22308' },
  {
    text: 'COLEGIO INGL\u00c3\u2030S MABEL CONDEMAR\u00c3\u008dN',
    value: '22309',
  },
  { text: 'ESCUELA RURAL YERBAS BUENAS', value: '22310' },
  { text: 'ESCUELA PARTICULAR HUILLON', value: '22312' },
  { text: 'COLEGIO CARDENAL RAUL SILVA HENRIQUEZ', value: '22313' },
  { text: 'ESCUELA PARTICULAR CAUPOLICAN', value: '22315' },
  { text: 'ESCUELA PARTICULAR INAQUE', value: '22316' },
  { text: 'ESCUELA PARTICULAR SAN ANTONIO', value: '22317' },
  { text: 'JARDIN INFANTIL DUENDELIN', value: '22318' },
  { text: 'COLEGIO PRINCIPE DE ASTURIAS', value: '22319' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE KAUKALEM', value: '22320' },
  { text: 'ESCUELA DE LENGUAJE FOR FARIS', value: '22321' },
  { text: 'FAYOL SCHOOL', value: '22322' },
  { text: 'ESCUELA PARTICULAR LA POZA', value: '22323' },
  { text: 'ESCUELA PARTICULAR CHOVI-SAN JUAN', value: '22325' },
  { text: 'COLEGIO GABRIELA MISTRAL', value: '22327' },
  { text: 'CENTRO EDUCACIONAL SAN AGUSTIN', value: '22330' },
  { text: 'ESCUELA FRANCIA', value: '22333' },
  { text: 'ESCUELA PARTICULAR EL ARRAYAN', value: '22334' },
  { text: 'ESC. ESP.DE AUD.Y LENG. JOAQUIN DE LOS ANDES', value: '22336' },
  { text: 'ESCUELA PARTICULAR LOS CASTANOS', value: '22337' },
  { text: 'ESCUELA PARTICULAR PEDERNAL ALTO', value: '22338' },
  { text: 'COLEGIO GHANDI', value: '22339' },
  { text: 'ESCUELA PARTICULAR EL COPIHUE', value: '22340' },
  { text: 'ESCUELA PARTICULAR DELIA DOMINGUEZ', value: '22342' },
  { text: 'COLEGIO SAN SEBASTIAN', value: '22343' },
  { text: 'ESCUELA PARTICULAR SANTA ROSA', value: '22346' },
  { text: 'ESCUELA PARTICULAR SAGRADO CORAZON', value: '22348' },
  { text: 'ESCUELA PARTICULAR SICHAHUE', value: '22349' },
  { text: 'JARDIN INFANTIL PAPELUCHO', value: '22350' },
  { text: 'ESCUELA PARTICULAR EL DESPERTAR', value: '22352' },
  { text: 'ESCUELA PARTICULAR TRULLUN MAPU', value: '22353' },
  { text: 'ESCUELA EL MAITEN', value: '22354' },
  { text: 'COLEGIO SAN ANDRES', value: '22355' },
  { text: 'COLEGIO PAIDEIA', value: '22356' },
  { text: 'JARDIN INFANTIL AGUALUNA II', value: '22357' },
  { text: 'COLEGIO PARTICULAR ANTARES DE ALERCE', value: '22361' },
  { text: 'CENTRO DE LENGUAJE KALEM', value: '22363' },
  { text: 'ESCUELA DE LENGUAJE KALEM', value: '22364' },
  { text: 'COLEGIO ROBERT PACE', value: '22366' },
  { text: 'ESCUELA PARTICULAR BOSQUE VERDE', value: '22367' },
  { text: 'JARDIN INFANTIL LUNITA', value: '22370' },
  { text: 'COMPLEJO EDUCACIONAL SAN CRESCENTE', value: '22372' },
  { text: 'ESCUELA PARTICULAR MILLARAY', value: '22373' },
  { text: 'ESCUELA PARTICULAR ALLA MAPU', value: '22375' },
  { text: 'ESCUELA DE PARVULOS MONTESSORI CHILOE', value: '22377' },
  { text: 'ESCUELA LENGUAJE ABRAPALABRA', value: '22379' },
  { text: 'ESCUELA BASICA SECTOR ORIENTE', value: '22380' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE SAN JUAN', value: '22382' },
  { text: 'ESCUELA PARTICULAR ROSALIA OJEDA SANCHEZ', value: '22383' },
  { text: 'JARDIN INFANTIL CAQUITO', value: '22385' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE GIRASOL', value: '22387' },
  { text: 'CENTRO DE EDUC. DE ADULTOS SANDROCK', value: '22388' },
  { text: 'COLEGIO EBEN-EZER', value: '22389' },
  { text: 'ESCUELA PARTICULAR CANDELARIA', value: '22390' },
  { text: 'JARDIN INFANTIL ELITE II', value: '22391' },
  { text: 'ESCUELA ESPECIAL SANTA HELENA', value: '22394' },
  { text: 'JARDIN INFANTIL PRINCIPITO', value: '22395' },
  { text: 'ESCUELA PARTICULAR LA COLONIA', value: '22396' },
  { text: 'COL.TEC.PROF.STA.TERESA DE LOS ANDES', value: '22397' },
  { text: 'COLEGIO ALIWEN', value: '22398' },
  { text: 'ESCUELA PARTICULAR DOLLINCO', value: '22400' },
  { text: 'CENTRO DE EDUCACION DE ADULTOS ESMERALDA', value: '22401' },
  { text: 'ESCUELA DE LA COMUNICACI-N ALEXANDRIA', value: '22402' },
  { text: 'ESC. DE CULT. Y DIF. ART. FRIDOLINA BARRIENTO', value: '22403' },
  { text: 'CENTRO DE EDUCACION DIEGO PORTALES', value: '22405' },
  { text: 'ESCUELA PARTICULAR JEAN PIAGET', value: '22408' },
  { text: 'COLEGIO TENAUN ALTO', value: '22413' },
  { text: 'ESCUELA PAMPA RIOS', value: '22414' },
  { text: 'CENTRO EDUCACIONAL INSPROL', value: '22416' },
  { text: 'ESCUELA PARTICULAR SAN PIO DE PIELTRECINA', value: '22417' },
  { text: 'ESCUELA BASICA KIMUN LAWAL', value: '22418' },
  { text: 'ESCUELA PADRE ALBERTO HURTADO', value: '22419' },
  { text: 'ESCUELA NUEVA PENSYLVANIA', value: '22420' },
  { text: 'CENTRO DE INTEGRACION LABORAL', value: '22421' },
  { text: 'COLEGIO CHARLES DARWIN', value: '22422' },
  { text: 'JARDIN INFANTIL MANITOS TRAVIESAS', value: '22424' },
  { text: 'ESCUELA PARTICULAR CURAMO', value: '22425' },
  { text: 'ESCUELA PARTICULAR EMMANUEL', value: '22427' },
  { text: 'ESCUELA PADRE LUIS BELTRAN', value: '22428' },
  { text: 'ESCUELA PARTICULAR WE LIWEN', value: '22429' },
  { text: 'COLEGIO CRECER', value: '22430' },
  { text: 'ESCUELA PARTICULAR PUERTO ESPERANZA', value: '22433' },
  { text: 'THE MISSION COLLEGE', value: '22436' },
  { text: 'ESCUELA ESPECIAL TALLERES LABORALES INPROA', value: '22438' },
  { text: 'COLEGIO TERRA NOVA', value: '22439' },
  { text: 'COLEGIO MAPU MALEN', value: '22441' },
  { text: 'ESCUELA LLEQUEN', value: '22444' },
  { text: 'CENTRO DE EDUC. DE ADULTOS ELIER', value: '22445' },
  { text: 'CENT.EDUC.INTEG.ADULTOS PROFASOC', value: '22446' },
  { text: 'CENTRO EDUCACIONAL TRAF TREMUN', value: '22447' },
  { text: 'ESCUELA PARTICULAR EL CARDO', value: '22448' },
  { text: 'ESCUELA PARTICULAR LA PRADERA', value: '22451' },
  { text: 'COLEGIO MOUNTAIN GREEN SCHOOL', value: '22452' },
  { text: 'COLEGIO PRECIOSA SANGRE II', value: '22454' },
  { text: 'COLEGIO PARVULARIO GENESIS', value: '22455' },
  { text: 'COLEGIO SAN PABLO', value: '22456' },
  { text: 'ESCUELA DIFERENCIAL CELIPRAS', value: '22458' },
  { text: 'COLEGIO LAICO VALDIVIA', value: '22459' },
  { text: 'COLEGIO NUEVO HORIZONTE', value: '22461' },
  { text: 'COLEGIO BERNARDO FELMER NIKLITSCHEK', value: '22462' },
  { text: 'JARDIN INFANTIL SAN SEBASTIAN', value: '22463' },
  { text: 'LICEO POLIVALENTE DALCAHUE', value: '22464' },
  { text: 'JARDIN INFANTIL PALABRAS MAGICAS', value: '22465' },
  { text: 'LICEO DE ADMINISTRACION Y COMERCIO SAN SEBAST', value: '22466' },
  { text: 'COLEGIO LAFQUEN MONTESSORI', value: '22467' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE AMAPOLA', value: '22468' },
  { text: 'JARDIN INFANTIL BAMBI Y CELIN', value: '22471' },
  { text: 'JARDIN INFANTIL MANZANITA', value: '22472' },
  { text: 'CENTRO DE EDUCACION DE ADULTOS APRENDER', value: '22473' },
  { text: 'CENTRO EDUCACION ADULTOS APRENDER', value: '22475' },
  { text: 'COLEGIO SAN JOSE', value: '22476' },
  { text: 'COLEGIO POLITECNICO DEGLI MONTI', value: '22478' },
  { text: 'ESCUELA DE LENGUAJE AYELEN', value: '22479' },
  { text: 'COLEGIO LOS ALERCES DE PUERTO VARAS', value: '22480' },
  { text: 'CENTRO EDUCACIONAL AMANCAY', value: '22482' },
  { text: 'LICEO BICENTENARIO DE EXCELENCIA ALTAMIRA', value: '22483' },
  { text: 'COLEGIO DE ADULTOS PUDETO', value: '22485' },
  { text: 'ESCUELA SAN FRANCISCO DE LLENEHUE', value: '22486' },
  { text: 'CENTRO INT. DE EDUC. GABRIELA PASCHUAN', value: '22487' },
  { text: 'ESCUELA PARTICULAR RAYEN QUITRAL', value: '22489' },
  { text: 'ESCUELA PARTICULAR TICALHUE', value: '22492' },
  { text: 'ESCUELA VICENTE PEREZ ROSALES', value: '22493' },
  { text: 'LICEO TECN. PROF. AGRIC. MARIT. BOSQUE NATIVO', value: '22494' },
  { text: 'COLEGIO PARTICULAR CARDENAL RAUL SILVA HENRIQ', value: '22495' },
  { text: 'CENTRO EDUCACIONAL SAN NICOLAS', value: '22496' },
  { text: 'INSTITUTO TECNICO BERTA VILLEGAS OYARZUN', value: '22499' },
  { text: 'COLEGIO AGUILAS DEL SUR', value: '22503' },
  { text: 'LICEO FRANCISCO COLOANE', value: '22504' },
  { text: 'ESCUELA ALEMANIA', value: '22509' },
  { text: 'COLEGIO INMACULADO CORAZON DE MARIA', value: '22512' },
  { text: 'CENTRO INTEGRAL DE ADULTOS TREUCANCHE', value: '22514' },
  { text: 'INSTITUTO CRISTIANO GRACIA Y PAZ', value: '22516' },
  { text: 'C.E.I.A COMUNIDAD COLLICO', value: '22517' },
  { text: 'LICEO SAN FRANCISCO JAVIER', value: '22518' },
  { text: 'COLEGIO MIRADOR DEL LAGO', value: '22519' },
  { text: 'ESCUELA DE LENGUAJE MIS PALABRAS', value: '22520' },
  { text: 'ESCUELA DE LENGUAJE EL UMBRAL', value: '22521' },
  { text: 'COLEGIO SAN MARTIN DE LAS LOMAS', value: '22522' },
  { text: 'JARDIN INFANTIL ANGELITO', value: '22525' },
  { text: 'JARDIN INFANTIL LOS CISNES', value: '22526' },
  { text: 'CENTRO EDUCACIONAL SAN SEBASTIAN', value: '22527' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE KALEM RAHUE', value: '22529' },
  { text: 'JARDIN INFANTIL CARACOL', value: '22530' },
  { text: 'ESCUELA CLAUDIO ARRAU LEON', value: '22531' },
  { text: 'ESCUELA EL BOSQUE', value: '22532' },
  { text: 'COLEGIO MON MAPU', value: '22533' },
  { text: 'ESCUELA GRACEMAR', value: '22534' },
  { text: 'ESCUELA TERESA DE LOS ANDES', value: '22535' },
  { text: 'CENTRO EDUCACIONAL SAN SEBASTIAN', value: '22536' },
  { text: 'COLEGIO FRANCISCA BELEN', value: '22537' },
  { text: 'ESCUELA JOSE MANUEL BALMACEDA', value: '22539' },
  { text: 'COLEGIO SAN ALBERTO HURTADO', value: '22542' },
  { text: 'INSTITUTO CECAL SUR', value: '22545' },
  { text: 'GREEN COLLEGE', value: '22546' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE PULMAHUE', value: '22547' },
  { text: 'ESCUELA PARTICULAR EVANGELICA MONTE SINAI', value: '22548' },
  { text: 'CTRO.EDUC.TEC.PROF.ADULT.NUEVO.HORIZONTE', value: '22549' },
  { text: 'JARDIN INFANTIL BLANCANIEVES', value: '22550' },
  { text: 'LICEO TECNICO PROFESIONAL GABRIELA MISTRAL', value: '22551' },
  { text: 'ESCUELA PARTICULAR SAGRADA FAMILIA', value: '22552' },
  { text: 'LICEO INDUSTRIAL ALERCE', value: '22553' },
  { text: 'ESCUELA BASICA SAN CARLOS DE CHONCHI', value: '22554' },
  { text: 'ESCUELA PARTICULAR COLONIA DEGAN', value: '22556' },
  { text: 'COLEGIO ARRAYAN', value: '22557' },
  { text: 'ESCUELA NUEVA COLLILELFU', value: '22558' },
  { text: 'COLEGIO COLONOS DE ALERCE', value: '22560' },
  { text: 'COLEGIO ESTRELLA DE BELEN', value: '22561' },
  { text: 'LICEO TECNICO ADOLFO MATTHEI', value: '22564' },
  { text: 'COLEGIO EL PILAR', value: '22565' },
  { text: 'ESCUELA PARTICULAR BICENTENARIO', value: '22566' },
  { text: 'JARDIN INFANTIL ZONA DE NINOS', value: '22567' },
  { text: 'JARDIN INFANTIL LOS ANGELITOS', value: '22568' },
  { text: 'CENTRO DE ESTIMULACION TEMPRANA INKA POYEN', value: '22571' },
  { text: 'ESCUELA ESPECIAL TALLER LABORAL RIE', value: '22573' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE CRECER', value: '22574' },
  { text: 'JARDIN INFANTIL GASPARIN', value: '22575' },
  { text: 'ESCUELA DE PARVULOS CHILHUE', value: '22576' },
  { text: 'JARDIN INFANTIL LOS CACHORRITOS', value: '22577' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ABRACADABRA', value: '22578' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ANDORRA', value: '22579' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE LAS VOCALES', value: '22580' },
  { text: 'COLEGIO RAICES DE LEMUY', value: '22581' },
  { text: 'JARDIN INFANTIL CARRUSEL', value: '22583' },
  { text: 'ESCUELA PARTICULAR MI FUTURO', value: '22584' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE HABLARTE', value: '22585' },
  { text: 'COLEGIO CRISTIANO BELEN', value: '22588' },
  { text: 'ESCUELA PARTICULAR ISLA LLAHUEN', value: '22589' },
  { text: 'JARDIN INFANTIL DIENTECITO DE LECHE', value: '22590' },
  { text: 'JARDIN INFANTIL BLANCA NIEVES', value: '22591' },
  { text: 'JARDIN INFANTIL PEQUENA CASA EN LA PRADERA', value: '22592' },
  { text: 'COMPLEJO EDUCACIONAL LOS GIRASOLES', value: '22593' },
  { text: 'JARDIN INFANTIL Y SALA CUNA CRECE', value: '22594' },
  { text: 'CENTRO INCLUSIVO DE PARVULOS INALUN', value: '22596' },
  { text: 'LICEO TECNICO PROFESIONAL SAN JOSE', value: '22597' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE MARIA PAZ', value: '22599' },
  { text: 'ESCUELA DE PARVULOS DUENDELIN', value: '22601' },
  { text: 'SAINT PAUL COLLEGE', value: '22602' },
  { text: 'ESCUELA ESPECIAL UN MUNDO ESPECIAL', value: '22603' },
  { text: 'CENTRO DE EDUCACION ADULTOS APRENDER', value: '22604' },
  { text: 'ESCUELA INTEGRADA JUAN PABLO II', value: '22606' },
  { text: 'COLEGIO EL LABRADOR', value: '22608' },
  { text: 'COLEGIO CHILENO NORTEAMERICANO', value: '22609' },
  { text: 'ESCUELA PARTICULAR NIDO DE CISNES', value: '22610' },
  { text: 'COLEGIO VIVALDI', value: '22611' },
  { text: 'CENTRO EDUCACIONAL GARYES', value: '22612' },
  { text: 'ESCUELA PARTICULAR CRECER', value: '22613' },
  { text: 'ESCUELA ESP. DE LENG. LEV VIGOTSKY', value: '22614' },
  { text: 'ESCUELA PARTICULAR OMILEN ANTU', value: '22615' },
  { text: 'COLEGIO MOZART', value: '22616' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE RELMU DUNGUN', value: '22617' },
  { text: 'ESCUELA DIFERENCIAL CELIPRAS', value: '22618' },
  { text: 'ESCUELA PARTICULAR ANTUMAPU', value: '22620' },
  { text: 'COLEGIO CALBUCO', value: '22621' },
  { text: 'ESCUELA DE PARVULOS AYELEN', value: '22623' },
  { text: 'COLEGIO DE ADULTOS BONILLA', value: '22624' },
  { text: 'INSTITUTO POLITECNICO', value: '22626' },
  { text: 'HAMPTON COLLEGE', value: '22627' },
  { text: 'JARDIN INFANTIL ARBOLIRIS', value: '22628' },
  { text: 'COLEGIO LOS CONQUISTADORES', value: '22629' },
  { text: 'CENTRO EDUC. DE INT. Y FORM. LABORAL RIOS DE', value: '22630' },
  { text: 'JARDIN INFANTIL CORDILLERA', value: '22632' },
  { text: 'LICEO TEC. PROF. DE ADULTOS CORESOL DE VALDIV', value: '22633' },
  { text: 'INSTITUTO PRINCIPE DE ASTURIAS', value: '22634' },
  { text: 'NEW SCHOOL', value: '22635' },
  { text: 'COLEGIO SANTA RITA DE CASCIA', value: '22637' },
  { text: 'LICEO TEC. PROF. DE ADULTOS CORESOL DE PTO. M', value: '22638' },
  { text: 'ESCUELA HOSPITALARIA VALDIVIA', value: '22639' },
  { text: 'JARDIN INFANTIL LOS CARRERA', value: '22640' },
  { text: 'COLEGIO SAGRADA FAMILIA', value: '22641' },
  { text: 'ESCUELA ESPECIAL ANDRES BELLO', value: '22643' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ATENEA', value: '22645' },
  { text: 'ROYAL SCHOOL', value: '22646' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE GIRASOLES', value: '22647' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE LOS CISNES', value: '22648' },
  { text: 'ESCUELA DE PARVULOS LAMISTRAL', value: '22649' },
  { text: 'ESCUELA PROFESORA ELIANA TRIVI\u00c3\u2018O', value: '22650' },
  { text: 'JARDIN INFANTIL Y SALA CUNA LUNITA', value: '22651' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE LAWAL', value: '22652' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE DEL SABER', value: '22654' },
  { text: 'LICEO CARELMAPU', value: '22655' },
  { text: 'COLEGIO LLACOLEN', value: '22656' },
  { text: 'COLEGIO PARTICULAR GOLETA ANCUD', value: '22657' },
  { text: 'CENTRO EDUCACIONAL EMANUEL', value: '22658' },
  { text: 'ESTABLECIMIENTO EDUC. DE INTEGRACION LABORAL', value: '22659' },
  { text: 'CENTRO DE ESTUDIOS LA ARAUCANA', value: '22660' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE DIALECTA', value: '22661' },
  { text: 'COLEGIO MONTE VERDE', value: '22663' },
  { text: 'LICEO POLITECNICO MIRASOL', value: '22664' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE BOSQUEMAR', value: '22665' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE JUAN BAUTISTA II', value: '22666' },
  { text: 'CENTRO EDUCACIONAL AMADOR CARDENAS PAREDES', value: '22668' },
  { text: 'COLEGIO FRANCISCO HERNANDEZ ORTIZ', value: '22671' },
  { text: 'COLEGIO ALTAS CUMBRES', value: '22672' },
  { text: 'LICEO POLIVALENTE DE QUEILEN', value: '22674' },
  { text: 'ESCUELA HOSPITALARIA HOSPITAL DE PUERTO MONTT', value: '22675' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE EL TESORO DEL SA', value: '22676' },
  { text: 'ESCUELA ESPECIAL Y TALLER LABORAL RAICES', value: '22677' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE TECNOLOGICA', value: '22679' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ACUARELA DE PALA', value: '22680' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ALIWEN', value: '22682' },
  { text: 'COLEGIO BRITISH ROYAL SCHOOL PUERTO VARAS', value: '22683' },
  { text: 'ESCUELA PARTICULAR SAN BENITO', value: '22685' },
  { text: 'ESCUELA BASICA LAS CAMELIAS', value: '22686' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE SEMBRANDO PALABR', value: '22687' },
  { text: 'COLEGIO BOSQUES DE ALERCE', value: '22688' },
  { text: 'COLEGIO AYTUE', value: '22690' },
  { text: 'LICEO FRANCISCO HERNANDEZ ORTIZ-PIZARRO', value: '22691' },
  { text: 'PATAGONIA COLLEGE', value: '22692' },
  { text: 'ESCUELA HOSPITALARIA HOSPITAL DE ANCUD', value: '22693' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE BARQUITO A VAPOR', value: '22694' },
  { text: 'COLEGIO SAN LUCAS DE VALDIVIA', value: '22738' },
  { text: 'CENTRO EDUCACIONAL INFANTIL MELIANTU', value: '22739' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE RAIMAPU', value: '22741' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ABRACADBRA LTDA', value: '22742' },
  { text: 'GARDEN COLLEGE', value: '22743' },
  { text: 'ESCUELA DE LENGUAJE AMANKAY', value: '22744' },
  { text: 'JARDIN INFANTIL TRENCITO DE LOS SUE\u00c3\u2018OS', value: '22745' },
  { text: 'CENTRO EDUCACION ADULTOS WICLEF', value: '22746' },
  { text: 'CENTRO EDUCATIVO SAGRADO CORAZON DE JESUS', value: '22747' },
  { text: 'ESCUELA PARTICULAR COUNTRY SCHOOL', value: '22749' },
  { text: 'LICEO PEOPLE HELP PEOPLE', value: '22750' },
  { text: 'LICEO POLITEC.WERNER GROB STOLZENBACH', value: '22752' },
  { text: 'ESCUELA PARTICULAR ADONAI', value: '22753' },
  { text: 'CTRO. EDUC.ESTIM. INTEGRAL HUELEMU', value: '22754' },
  { text: 'LICEO TCO. PROF. DE RIO BUENO', value: '22755' },
  { text: 'COLEGIO AUSTRAL LANCO', value: '22756' },
  { text: 'CENTRO DE CAPAC.LAB. ALERCE ANDINO', value: '22757' },
  { text: 'LICEO POLIT. PROFESIONAL IGNAO', value: '22758' },
  { text: 'MASTER COLLEGE', value: '22759' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE WORDS WISE', value: '22760' },
  { text: 'BIG HOUSE JARDIN INFANTIL', value: '22761' },
  { text: 'COLEGIO ESPECIAL CELIPRAS', value: '22762' },
  { text: 'GREEN HOUSE JARDIN INFANTIL', value: '22763' },
  { text: 'C.E.I.O.D. E INTERVENCION N.E.E.', value: '22766' },
  { text: 'ESC.PART. ALMIRANTE ENRIQUE SIMPSON', value: '24200' },
  { text: 'JARDIN INFANTIL DAME LA MANO', value: '24205' },
  { text: 'COLEGIO SAGRADA FAMILIA', value: '24209' },
  { text: 'ESC. PART.MADRE DE LA DIVINA PROVIDENCIA', value: '24210' },
  { text: 'ESCUELA ALTAMIRA DE COYHAIQUE', value: '24214' },
  { text: 'CENTRO DE EDUCACION INTEGRADA DE ADULTOS', value: '24215' },
  { text: 'ESCUELA BASICA DE CHILE CHICO', value: '24216' },
  { text: 'ESC.NUESTRA SRA DE LA DIVINA PROVIDENCIA', value: '24218' },
  { text: 'ESCUELA ANEXA INDEPENDENCIA', value: '24220' },
  { text: 'ESCUELA DE LENGUAJE KALEM', value: '24223' },
  { text: 'COLEGIO EL CAMINO', value: '24226' },
  { text: 'ESCUELA LITORAL AUSTRAL', value: '24229' },
  { text: 'ESCUELA ESPECIAL PRE-BASICA CLUB DE LEONES', value: '24232' },
  { text: 'ESCUELA FRANCISCO XAVIER BUTINA', value: '24233' },
  { text: 'COLEGIO CAMPO DE HIELO', value: '24236' },
  { text: 'CEIA  JOSEFINA MENDEZ E.I.R.L.', value: '24237' },
  { text: 'CENTRO DE ESTUDIOS PATAGONIA LTDA', value: '24238' },
  { text: 'CENTRODE ESTUDIOS PATAGONIA DE AYSEN', value: '24241' },
  { text: 'ESCUELA GENERAL MANUEL BULNES P.', value: '24302' },
  { text: 'SOC. EDUCATIVA PIERRE FAURE Y CIA LTDA.', value: '24305' },
  { text: 'ESCUELA PARVULARIA PEDRO AGUIRRE CERDA', value: '24310' },
  { text: 'COLEGIO FRANCES', value: '24311' },
  { text: 'CENTRO DE CAPAC. LABORAL LEON HUMBERTO SEGUEL', value: '24312' },
  { text: 'ESCUELA VILLA LAS NIEVES', value: '24313' },
  { text: 'LICEO POLITEC.CARDENAL RAUL SILVA HENRIQUEZ', value: '24316' },
  { text: 'COLEGIO PUERTO NATALES', value: '24317' },
  { text: 'ESCUELA PADRE ALBERTO HURTADO CRUCHAGA', value: '24318' },
  { text: 'TALLER LABORAL DE UNPADE', value: '24320' },
  { text: 'TALLER LABORAL CRUZ DEL SUR', value: '24321' },
  { text: 'ESCUELA BASICA RURAL SENO OBSTRUCCION', value: '24322' },
  { text: 'COLEGIO RUBEN DARIO', value: '24324' },
  { text: 'ESCUELA RURAL CERRO GUIDO', value: '24325' },
  { text: 'LICEO EXPERIMENTAL UMAG', value: '24327' },
  { text: 'FUNDACI\u00c3\u201cN PARA EL DESARROLLO', value: '24330' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE IERUN TALJ', value: '24331' },
  { text: 'CEIA CARLOS YANEZ MOYA', value: '24332' },
  { text: 'CENTRO EDUC.ESPECIAL CLUB DE LEONES CRUZ DEL', value: '24333' },
  { text: 'ESCUELA PARVULARIA JOSH KEE', value: '24334' },
  { text: 'ESC. ESP. DE LENGUAJE NUEVO SOL', value: '24335' },
  { text: 'ESC. ESP. DE LENGUAJE SANTA LAURA', value: '24336' },
  { text: 'COLEGIO LUTERANO', value: '24338' },
  { text: 'ESC. ESP. DE TRASTORNOS DE LA COMUNICACION AL', value: '24339' },
  { text: 'ESCUELA BASICA PARTICULAR DEUTSCHLAND', value: '24400' },
  { text: 'COLEGIO CAPITAN PASTENE', value: '24401' },
  { text: 'LICEO MUNICIPALIZADO MARCELO ASTORECA C.', value: '24403' },
  { text: 'COLEGIO POLIVALENTE LOVAINA', value: '24405' },
  { text: 'ESCUELA BASICA PARTICULAR KINDS SCHOOL', value: '24406' },
  { text: 'COLEGIO SANTA TERESA DE JESUS DE LOS ANDES', value: '24407' },
  { text: 'COLEGIO FINLANDIA', value: '24412' },
  { text: 'ESCUELA PARTICULAR SANTA ANA DE LA LUZ', value: '24419' },
  { text: 'ESCUELA BASICA COLEGIO VILLA LOGRONO', value: '24420' },
  { text: 'COLEGIO SAN JUAN DIEGO', value: '24423' },
  { text: 'COLEGIO PARTICULAR LA UNION', value: '24424' },
  { text: 'ESCUELA PARTICULAR PHILIPPE COUSTEAU', value: '24426' },
  { text: 'ESCUELA BASICA PART.ARCANGEL SAN GABRIEL', value: '24428' },
  { text: 'ESC.ESPECIAL C.CAPACITACION LAB.DE PAINE', value: '24430' },
  { text: 'COLEGIO HAYDN DE LA FLORIDA', value: '24431' },
  { text: 'CENTRO DE EDUCACION DIFERENCIAL ARMONIA', value: '24434' },
  { text: 'COLEGIO MERRYLAND', value: '24438' },
  { text: 'LICEO AGRICOLA SANTA ANA', value: '24440' },
  { text: 'ESCUELA ESPECIAL OPEN DOOR', value: '24442' },
  { text: 'LICEO MUNICIPAL CHILOE', value: '24443' },
  { text: 'LICEO INDUSTRIAL HARDWARE', value: '24444' },
  { text: 'LICEO MUNICIPAL EL ROBLE', value: '24445' },
  { text: 'COMPLEJO EDUC. AGRICOLA DE TALAGANTE', value: '24446' },
  { text: 'COLEGIO DE ADULTOS FEDESO', value: '24454' },
  { text: 'COLEGIO EL SEMBRADOR ANEXO 1', value: '24455' },
  { text: 'ESC. BAS.TALLERES PREVOC.HOGAR DE CRISTO', value: '24459' },
  { text: 'ESCUELA DE PARVULOS EL OLYMPO', value: '24461' },
  { text: 'ESCUELA DE PARVULOS LAS BRUJITAS', value: '24462' },
  { text: 'ESCUELA BASICA MERCEDES MARIN DEL SOLAR', value: '24464' },
  { text: 'ANEXO COLEGIO LO ERRAZURIZ', value: '24467' },
  { text: 'COLEGIO TEC.HOTELERIA Y GASTRONOMIA ACHIGA CO', value: '24473' },
  { text: 'ESC. ESPECIAL PART.NUESTRO HORIZONTE', value: '24484' },
  { text: 'CENTRO DE EDUCACION ESPECIAL COOCENDE', value: '24487' },
  { text: 'ESC. PART.BASICA SAINT PHILLIP OF NERY 2', value: '24489' },
  { text: 'ESCUELA PARVULOS BERNADETTE SOUBIROUS', value: '24493' },
  { text: 'COLEGIO COMERCIAL DE PENAFLOR', value: '24496' },
  { text: 'ESCUELA BASICA PART.THE NEW SCHOOL ANEXO', value: '24499' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ALIMALINA', value: '24503' },
  { text: 'ESCUELA PART.THE LITTLE SCHOOL ANEXA', value: '24505' },
  { text: 'COLEGIO EL GOLF', value: '24506' },
  { text: 'ANEXO ESCUELA BASICA SAN JAVIER', value: '24508' },
  { text: 'ESC. PART. JARDIN INFANTIL PULGARCITO', value: '24510' },
  { text: 'ESC. BAS.MUNICIPAL MERCEDES FONTECILLA', value: '24520' },
  { text: 'ESCUELA BASICA PART.BLAS CANAS', value: '24558' },
  { text: 'PARVULARIO COLEGIO LONDON', value: '24601' },
  { text: 'ESCUELA DE PARVULOS NUESTRO HOGAR', value: '24607' },
  { text: 'ESCUELA ESP. SANTA MARIA DE RENCA', value: '24612' },
  { text: 'ESCUELA PARVULOS SANTA JULIA', value: '24617' },
  { text: 'ESCUELA DE PARVULOS COLORIN COLORADO', value: '24618' },
  { text: 'MIGUEL DE CERVANTES Y SAAVEDRA ANEXO A-8', value: '24622' },
  { text: 'ESCUELA JORGE ALESSANDRI RODRIGUEZ ANEXO', value: '24623' },
  { text: 'COLEGIO ETIEVAN', value: '24627' },
  { text: 'ESCUELA DE PARVULOS CABALLITO BLANCO', value: '24629' },
  { text: 'COLEGIO ALEMAN DE SANTIAGO', value: '24642' },
  { text: 'COLEGIO ALEMAN DE SANTIAGO', value: '24643' },
  { text: 'COLEGIO IBEROAMERICANO', value: '24647' },
  { text: 'ESCUELA DE PARVULOS SAMORITO', value: '24649' },
  { text: 'ESCUELA BASICA CINCO PINOS', value: '24654' },
  { text: 'COLEGIO CRISTIANO BETHEL II', value: '24657' },
  { text: 'COLEGIO EL ALMENDRAL', value: '24664' },
  { text: 'COLEGIO SAN MANUEL', value: '24675' },
  { text: 'COLEGIO LARRAIN', value: '24678' },
  { text: 'COLEGIO PETER COLLEGE - ANEXO', value: '24682' },
  { text: 'ESCUELA PARTICULAR QUILLAHUE', value: '24684' },
  { text: 'LICEO POLIVALENTE SANTIAGO DE COMPOSTELA', value: '24686' },
  { text: 'CTRO.EDUC.CATOLICO DIDASCALIO STA. MARIA', value: '24689' },
  { text: 'COLEGIO MAITENES', value: '24699' },
  { text: 'CENTRO EDUC.ADULTOS AMERICO VESPUCIO', value: '24700' },
  { text: 'ESCUELA BASICA VERDE VALLE', value: '24705' },
  { text: 'ESCUELA BASICA ACADEMIA MALLOCO', value: '24707' },
  { text: 'CRISTOBAL COLON DE MELIPILLA', value: '24715' },
  { text: 'ESCUELA BASICA LOS NAVIOS', value: '24716' },
  { text: 'COLEGIO NUESTRA SENORA DE GUADALUPE', value: '24717' },
  { text: 'COLEGIO LEONARDO DA VINCI DE LAS CONDES', value: '24721' },
  { text: 'ESC. BASICA PART.PADRE ALBERTO HURTADO', value: '24722' },
  { text: 'COLEGIO KENDAL ENGLISH SCHOOL', value: '24723' },
  { text: 'JUGENDLAND SCHULE', value: '24725' },
  { text: 'ESC.BAS.PART.COLEGIO HALLEY - ANEXO', value: '24732' },
  { text: 'COLEGIO SAN ANDRES DE COLINA', value: '24733' },
  { text: 'ESCUELA DE PARVULOS  PEQUITAS', value: '24737' },
  { text: 'ESCUELA PARVULOS PIN PIN SERAFIN', value: '24738' },
  { text: 'THE CHILDRENS WORDL', value: '24740' },
  { text: 'ESCUELA ESPECIAL PARTICULAR CRECER', value: '24742' },
  { text: 'TALLERES PREVOCACIONALES SAN FRANCISCO', value: '24750' },
  { text: 'COMPLEJO EDUC. EDUARDO CUEVAS VALDES', value: '24751' },
  { text: 'ESC.PARVULOS HERMANAS DE BETANIA', value: '24752' },
  { text: 'CEIA GEORGINA SALAS DINAMARCA', value: '24754' },
  { text: 'ESCUELA ESPECIAL PART.CENTRO EDUC.RAYEN', value: '24755' },
  { text: 'COLEGIO CRISTIANO BETHEL  N 3', value: '24758' },
  { text: 'ESC.NUESTRA SENORA DEL CARMEN DE CURACAV', value: '24759' },
  { text: 'SAN JUAN DE LAS CONDES', value: '24761' },
  { text: 'LICEO ADULTOS PART.LAS AMERICAS MODERNAS', value: '24763' },
  { text: 'ESCUELA PARTICULAR SUBV. SAN JUAN', value: '24764' },
  { text: 'ESCUELA DE PARV. LANCAHUE', value: '24765' },
  { text: 'COLEGIO EL SEMBRADOR ANEXO 2', value: '24767' },
  { text: 'ESCUELA DE PARVULOS LOS PATITOS DE SAN PATRIC', value: '24768' },
  { text: 'COLEGIO SAN ISAAC JOGUES', value: '24769' },
  { text: 'ESCUELA B\u00c3\u0081SICA Y ESPECIAL BARROS LUCO', value: '24782' },
  { text: 'COLONIAL DE PIRQUE', value: '24783' },
  { text: 'VILLA UNIVERSIDAD GABRIELA MISTRAL', value: '24787' },
  { text: 'COLEGIO EL PRADO', value: '24790' },
  { text: 'COLEGIO EMAUS', value: '24795' },
  { text: 'COLEGIO FLORIDA HIGH SCHOOL', value: '24800' },
  { text: 'ESCUELA BASICA PART GRATUITA CASA AZUL', value: '24803' },
  { text: 'ESCUELA ESPECIAL SGTO.CADELARIA', value: '24804' },
  { text: 'ESCUELA DE PARVULOS LA SEMILLITA', value: '24806' },
  { text: 'ESCUELA BASICA PARTICULAR PUDAHUEL ANEXO', value: '24808' },
  { text: 'ESC. BASICA PART.JUANITA FERNANDEZ SOLAR', value: '24809' },
  { text: 'COLEGIO ENSENADA', value: '24814' },
  { text: 'ESCUELA DE PARV HOSP. CLIN DE LA U. DE CHILE', value: '24815' },
  { text: 'ESCUELA BASICA MADRIGAL', value: '24817' },
  { text: 'COLEGIO SUPERIOR CAMBRIDGE ANEXO', value: '24818' },
  { text: 'ESC. BAS. PDTE. SALVADOR ALLENDE G.', value: '24822' },
  { text: 'INSTITUTO DOCENCIA', value: '24832' },
  { text: 'COLEGIO POLIV. SAN LUIS BELTRAN', value: '24843' },
  { text: 'MI RINCON', value: '24851' },
  { text: 'ESCUELA ANEXO BASICA PART.VILLA LOURDES', value: '24854' },
  { text: 'ESCUELA BASICA TEGUALDA', value: '24856' },
  { text: 'ANEXO CRECES', value: '24857' },
  { text: 'ESCUELA BASICA PARTICULAR EMPRENDER', value: '24866' },
  { text: 'ES.ESP.PART.PUERTA ABIERTA', value: '24868' },
  { text: 'ESCUELA  ESPECIAL PART.PUDAHUEL NORTE', value: '24875' },
  { text: 'ESC.BASICA PROF.AURELIA ROJAS BURGOS', value: '24876' },
  { text: 'ESCUELA ESPECIAL PART.ARNOLD GESELL II', value: '24879' },
  { text: 'ESCUELA ESPECIAL GUENIPILLAN', value: '24880' },
  { text: 'ESCUELA BASICA ESCRITOR PABLO NERUDA', value: '24881' },
  { text: 'CENTRO DE TRASTORNOS DE LA COMUNICACION', value: '24882' },
  { text: 'ESCUELA B\u00c3\u0081SICA MUNICIPAL SAN LUIS', value: '24883' },
  { text: 'ESCUELA BASICA PART. HUMBOLDT', value: '24885' },
  { text: 'LICEO MONSENOR ENRIQUE ALVEAR', value: '24889' },
  { text: 'COLEGIO PABLO DE TARSO', value: '24891' },
  { text: 'COLEGIO POLIVALENTE ARAUCARIA', value: '24892' },
  { text: 'ESCUELA NOVOMAR', value: '24893' },
  { text: 'COLEGIO ARAUCARIA CORDILLERA', value: '24894' },
  { text: 'INSTITUTO DE TABANCURA DE PROVIDENCIA', value: '24896' },
  { text: 'COLEGIO FARMLAND SCHOOL', value: '24897' },
  { text: 'COLEGIO SAN FRANCISCO MISIONERO', value: '24898' },
  { text: 'LICEO REBECA OLIVARES B.', value: '24900' },
  { text: 'COLEGIO MADRE DE JESUS', value: '24903' },
  { text: 'ESCUELA DE PARVULOS LOS PICAPIEDRAS', value: '24904' },
  { text: 'ESCUELA BASICA DOLMEN', value: '24906' },
  { text: 'COLEGIO  SANTA MARIA DE PIRQUE', value: '24907' },
  { text: 'LICEO DE ADULTOS PART.FERMIN VIVACETA', value: '24911' },
  { text: 'COLEGIO SANTA MONICA DE MELIPILLA', value: '24912' },
  { text: 'COLEGIO NUESTRA SENORA DE LA MERCED', value: '24913' },
  { text: 'ESCUELA BASICA TACORA', value: '24916' },
  { text: 'ESCUELA DALCAHUE SUR', value: '24918' },
  { text: 'ESC. BAS. PART. ALBERT SCHWITZER LA FLORIDA', value: '24920' },
  { text: 'ESCUELA DEL LENGUAJE SAN CLEMENTE', value: '24924' },
  { text: 'CENTRO EDUCACIONAL DE ADULTOS', value: '24926' },
  { text: 'ESCUELA ESPECIAL SAN JUDAS TADEO', value: '24928' },
  { text: 'CENTRO EDUCACIONAL FUNDACION PAULA JARAQUEMAD', value: '24930' },
  { text: 'ESC.PART.ALVARO COVARRUBIAS ARLEGUI ANEX', value: '24931' },
  { text: 'ESC.ESPECIAL PARTICULAR PALABRAS MAGICAS', value: '24932' },
  { text: 'COLEGIO POLIV. SIEMBRA', value: '24935' },
  { text: 'ESC DE PARVULOS PART.EJERCITO DE SALVACION', value: '24937' },
  { text: 'ESC. ESP.NUESTRA  SENORA DE SAN GERONIMO', value: '24939' },
  { text: 'ESCUELA ESP. PART. EL MONTE', value: '24942' },
  { text: 'COLEGIO DESIREE', value: '24945' },
  { text: 'TECNICO  PORTEZUELO', value: '24947' },
  { text: 'ESCUELA ESPECIAL PARTICULAR ARCA DE NOE', value: '24952' },
  { text: 'COLEGIO EL REDENTOR', value: '24954' },
  { text: 'ESC. ESPECIAL PLANETA DE LOS NI\u00c3\u2018OS', value: '24957' },
  { text: 'COMPL.EDUCACIONAL BRIGIDA WALKER  ANEXO', value: '24959' },
  { text: 'ESCUELA BASICA PARTICULAR HORIZONTE 11', value: '24960' },
  { text: 'ESC.PARVULOS RENACER ALBORADA', value: '24961' },
  { text: 'ESCUELA BAS. PART. DE SANTA MARIA', value: '24963' },
  { text: 'COLEGIO SAN FELIPE', value: '24966' },
  { text: 'ESC.TRASTORNOS DE LA EDUCACION AURORA', value: '24968' },
  { text: 'COLEGIO PADRE HURTADO DE PUDAHUEL', value: '24969' },
  { text: 'COLEGIO EL ENCUENTRO', value: '24971' },
  { text: 'ESCUELA BAS. NUESTRA SENORA MARIA INMACULADA', value: '24972' },
  { text: 'ESCUELA ESPECIAL PART.ANA CRUCHAGA T.', value: '24980' },
  { text: 'ESCUELA BASICA QUERUBIN SCHOOL', value: '24983' },
  { text: 'COLEGIO KENDAL ENGLISH SCHOOL', value: '24985' },
  { text: 'ESCUELA ANDES DEL SUR', value: '24987' },
  { text: 'COMPLEJO EDUC. LUIS PASTEUR  ANEXO', value: '24989' },
  { text: 'ESCUELA ESPECIAL PART EL ENCUENTRO', value: '24994' },
  { text: 'COLEGIO SAN FERNANDO DE PUENTE ALTO', value: '24995' },
  { text: 'ESCUELA SANTA MARIA DE PENALOLEN', value: '24997' },
  { text: 'ESCUELA PROFESORA MARIA LUISA SEPULVEDA', value: '24999' },
  { text: 'ESCUELA BASICA PADRE ALBERTO HURTADO', value: '25002' },
  { text: 'ESC. ESPECIAL PARTIC.LOS ALMENDRALES', value: '25003' },
  { text: 'ESC. BAS.SAN AGUSTIN DE CERRILLOS', value: '25005' },
  { text: 'LICEO VALLE DE LLUTA', value: '25009' },
  { text: 'ESCUELA DE PARVULOS SAINT FLOWER', value: '25011' },
  { text: 'CENTRO DE EDUCACION PAULA JARAQUEMADA', value: '25014' },
  { text: 'CENTRO DE LENGUAJE MARCELA PAZ', value: '25015' },
  { text: 'ESC.BASICA SAN MARCELO  ANEXO', value: '25016' },
  { text: 'ESC. BAS. PATR. WILLINS HOOVER KURT', value: '25017' },
  { text: 'ESC.BASICA PARTICULAR SAN PABLO APOSTOL', value: '25019' },
  { text: 'INSTITUTO SAN PABLO MISIONERO', value: '25020' },
  { text: 'ESCUELA ESPECIAL PARTICULAR MILLANTU', value: '25022' },
  { text: 'COLEGIO POLIV. FRANCISCO DE VILLAGRA', value: '25026' },
  { text: 'CTRO. ESTIMULAC. DEL LENGUAJE CELQUI', value: '25030' },
  { text: 'ESCUELA ESPECIAL PART. VOCES', value: '25031' },
  { text: 'ESCUELA BASICA PART. LAS PLEYADES', value: '25034' },
  { text: 'ESCUELA ESPECIAL PARTICULAR  AUMEN', value: '25036' },
  { text: 'COLEGIO JOSE M.BALMACEDA DE MELIPILLA', value: '25038' },
  { text: 'ESC. BAS.PART.FRANCISCO DE AGUIRRE', value: '25039' },
  { text: 'COLEGIO MARIA ELENA', value: '25041' },
  { text: 'ESCUELA BASICA LOS BOSQUINOS', value: '25042' },
  { text: 'ESCUELA VOLCAN SAN JOSE', value: '25043' },
  { text: 'COLEGIO PARTICULAR PLAYGROUND', value: '25045' },
  { text: 'CENTRO PROFES..DE ESTIMULOS DE LENGUAJE', value: '25046' },
  { text: 'ESCUELA ANTILHUE DE PUDAHUEL', value: '25047' },
  { text: 'COLEGIO PARTICULAR SAN MATEO', value: '25050' },
  { text: 'COLEGIO CSA ESTUDIOS FUTURO PROVIDENCIA', value: '25054' },
  { text: 'CENTRO EDUCACIONAL LARUN RAYUN', value: '25059' },
  { text: 'COLEGIO POLIVALENTE RAUL\u00c3\u008d', value: '25061' },
  { text: 'ESC. ANTONIO BROQUEZ S. ANEXO ESC. 993', value: '25062' },
  { text: 'COLEGIO POLIVALENTE EDUCADORA ELENA ROJAS', value: '25068' },
  { text: 'COLEGIO NAVARRA', value: '25070' },
  { text: 'COLEGIO JOSE ABELARDO NUNEZ MURUA', value: '25071' },
  { text: 'SANTA MARIA DEL PILAR DE LA FLORIDA', value: '25073' },
  { text: 'ESC.ESP.TRAT.DE LA COMUNICION EDEN', value: '25075' },
  { text: 'ESC. DE PARV.BEATO PADRE ALBERTO HURTADO', value: '25077' },
  { text: 'ESCUELA PART.COMANDANTE CARLOS CONDELL', value: '25078' },
  { text: 'ESCUELA ESPECIAL PART.JESUS NAZARENO', value: '25079' },
  { text: 'ESCUELA ESPECIAL PARTICULAR ANTAI', value: '25080' },
  { text: 'ESCUELA RUDOLF DECK WERTH', value: '25084' },
  { text: 'COLEGIO NOBEL', value: '25087' },
  { text: 'COLEGIO LOS JAZMINES', value: '25089' },
  { text: 'ESCUELA ESPECIAL PARTICULAR PALOMAR', value: '25092' },
  { text: 'COLEGIO PART.SAN ESTEBAN DE LAS VISCACHA', value: '25094' },
  { text: 'COLEGIO PARTICULAR LOGRONO', value: '25095' },
  { text: 'ESC. BAS. EJERCITO DE SALVACION', value: '25098' },
  { text: 'ESC. ESPEC. CAMPANITA DE LA GRANJA', value: '25103' },
  { text: 'ESCUELA ESPECIAL PAR. CELQUI', value: '25109' },
  { text: 'ESCUELA DE PARVULOS BARRIE MONTESSORI', value: '25111' },
  { text: 'ESCUELA PART. PEHUEN', value: '25112' },
  { text: 'ESCUELA ESPECIAL PARTICULAR PIPAN', value: '25115' },
  { text: 'T Y C SPECIAL SCHOOL', value: '25117' },
  { text: 'ESC.DE TRAST.PRIM. DE LA COM.CHACABUCO', value: '25118' },
  { text: 'ESCUELA ESPECIAL PARTICULAR GENESIS', value: '25119' },
  { text: 'COLEGIO SAN ANTONIO DE COLINA', value: '25121' },
  { text: 'ESCUELA DE PARVULOS ALADDIN', value: '25125' },
  { text: 'ESCUELA BASICA SAINT FRANCIS COLLEGE', value: '25129' },
  { text: 'ESCUELA BASICA   LOS CEIBOS', value: '25130' },
  {
    text: 'ESC ESP N\u00c2\u00ba 1637 MAGDALENA AVALOS CRUZ ASPAUT',
    value: '25131',
  },
  { text: 'ESCUELA PART. MASTER SCHOOL DE LAMPA', value: '25132' },
  { text: 'COMPLEJO EDUCACIONAL SAN ALFONSO', value: '25136' },
  { text: 'ESCUELA ESPECIAL PARTICULAR AYELEN', value: '25137' },
  { text: 'COLEGIO ALBERT EINSTEIN', value: '25138' },
  { text: 'COLEGIO  WILLQUIMVOE', value: '25139' },
  { text: 'COLEGIO ANDINO ANTILLANCA', value: '25142' },
  { text: 'ESCUELA ESPECIAL PARTICULAR ANTIRAY', value: '25145' },
  { text: 'THE CHILDREN\u00c2\u00a6S WORDL N\u00c2\u00a62', value: '25148' },
  { text: 'DALCAHUE SUR N\u00c2\u00a6 2', value: '25152' },
  { text: 'ESCUELA ESPECIAL PARTICULAR LUNA NUEVA', value: '25154' },
  { text: 'ESC. PARTICULAR ALFARERO', value: '25155' },
  { text: 'ESC. BAS. PARTICULAR 1650 MIRAVALLE', value: '25157' },
  { text: 'ESCUELA DE PARVULOS PULGARCITO', value: '25158' },
  { text: 'COLEGIO VICTORIANO', value: '25160' },
  { text: 'COLEGIO DE MIRAFLORES DE MALLOCO', value: '25161' },
  { text: 'ESC. PARTICULAR RAIN BONV', value: '25162' },
  { text: 'COLEGIO PART. LOS OLMOS DE PTE. ALTO', value: '25166' },
  { text: 'ESCUELA DE PARVULOS KINDER PANDO', value: '25169' },
  { text: 'COLEGIO PSICOPEDAGOGICO JUAN WESLEY', value: '25170' },
  { text: 'ESC. BASICA MUNICIPAL RISOPATRON', value: '25173' },
  { text: 'CENTRO EDUCACIONAL DE ADULTOS EL PRADO', value: '25174' },
  { text: 'COLEGIO SAN NICOLAS DE MAIPU', value: '25175' },
  { text: 'ESC.ESPECIAL NUESTRA SRA.DEL PILAR', value: '25179' },
  { text: 'COLEGIO RAYEN MAHUIDA', value: '25180' },
  { text: 'LICEO ALCALDE JORGE INDO', value: '25182' },
  { text: 'COLEGIO MUNIC.  SAN SEBASTIAN DE RINCONADA', value: '25186' },
  { text: 'ESCUELA ESPECIAL PARTICULAR N_ 1666 SANDELI', value: '25187' },
  {
    text: 'ESCUELA B\u00c3\u0081SICA Y ESPECIAL N\u00c2\u00b090 AMANECER',
    value: '25188',
  },
  { text: 'ESCUELA BASICA FUTURO LAS MERCEDES', value: '25189' },
  { text: 'ESC. ESPECIAL HERNAN LARRAIN PERO', value: '25191' },
  { text: 'ESCUELA ESP. SAN NECTARIO', value: '25192' },
  { text: 'ESCUELA MUNICIPAL VALLE DE LUNA', value: '25194' },
  { text: 'COL.PARTICULAR SAN VALENTIN DE MAIPU', value: '25197' },
  { text: 'COLEGIO AMANCAY DE LA FLORIDA', value: '25199' },
  { text: 'ESCUELA BAS. Y ESP. N_ 115 RENACER', value: '25201' },
  { text: 'ESCUELA EDUCACION ESPECIAL ABECEDARIO', value: '25203' },
  { text: 'ESC.ESP.ONCOL.HOSP.ROBERTO DEL RIO', value: '25204' },
  { text: 'ESC. PART. CHRIST SCHOOL', value: '25206' },
  { text: 'ESC. ESP. NTRA SRA. DEL BUEN CONSEJO', value: '25208' },
  { text: 'ESC.ESPECIAL FUNDAC.NUESTROS HIJOS', value: '25209' },
  { text: 'ESC. BASICA N_ 116 ONCOLOG. DR. SOTERO DEL', value: '25210' },
  { text: 'ESCUELA PART.ESPECIAL CORPAMEG', value: '25211' },
  { text: 'INSTITUTO NACIONAL DE REHABILITACION PAC', value: '25212' },
  { text: 'ESC.1679 HOSPITAL SAN BORJA ARRIARAN', value: '25213' },
  { text: 'COLEGIO POLIV. GERONIMO DE ALDERETE', value: '25215' },
  { text: 'ESC. ESPECIAL SAN ANTONIO DE PUENTE ALTO', value: '25216' },
  { text: 'ESC. ESPECIAL ARTESANOS DE LA VIDA', value: '25217' },
  { text: 'ESC. ESPEICIAL VOCES II', value: '25219' },
  { text: 'COLEGIO ALMA MATER', value: '25220' },
  { text: 'ESC. ESPECIAL 120 MULTIVERSO', value: '25222' },
  { text: 'ESCUELA BASICA RAYITO DE LUZ DE QUILICURA', value: '25225' },
  { text: 'ESC. PART. SAN FCO. DE ASIS PARA NINOS SORDOS', value: '25226' },
  { text: 'ESCUELA ESPECIAL MADRE TERESA DE CALCUTA', value: '25227' },
  { text: 'ESC.BAS.Y ESP.INTEGRAL STA. ROSA DE CHENA.', value: '25230' },
  { text: 'ESC. ESP. PART SERAFIN DE MACUL', value: '25232' },
  { text: 'LICEO DE ADULTOS POETA VICENTE HUIDOBRO', value: '25235' },
  { text: 'ESCUELA ESPECIAL SU SANTIDAD JUAN PABLO II', value: '25236' },
  { text: 'COLEGIO DE ADULTOS GLADYS LAZO', value: '25237' },
  { text: 'COLEGIO CENTRO EDUCACIONAL ALTAIR', value: '25238' },
  { text: 'COLEGIO SAINT JAMES SCHOOL', value: '25241' },
  { text: 'ESC. ESP. SEMILLITA DE JESUS', value: '25244' },
  { text: 'CENTRO INNOVATIVO LA PUERTA DE PENALOLEN', value: '25247' },
  { text: 'ESCUELA ESPECIAL NEWEN', value: '25251' },
  { text: 'ESCUELA ESPECIAL LUNA AZUL', value: '25254' },
  { text: 'ESCUELA INMACULADA CONCEPCION', value: '25255' },
  { text: 'ESCUELA BASICA THE FOREST COLLEGE', value: '25256' },
  { text: 'ESCUELA NORMAY SCHOOL', value: '25257' },
  { text: 'COLEGIO POLIV. SANTA CECILIA DE MAIPU', value: '25258' },
  { text: 'ESC.ESPECIAL LOS COPIHUES DEL BOSQUE', value: '25260' },
  { text: 'ESCUELA DE PARVULOS ILLAPITAS', value: '25261' },
  { text: 'ESC.ESP.EL PRINCIPITO DE EL BOSQUE', value: '25263' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE RAYUN', value: '25264' },
  { text: 'COLEGIO NUEVO DIEGO DE ALMAGRO', value: '25269' },
  { text: 'COLEGIO PART. DE ADULTOS ITSA', value: '25270' },
  { text: 'PROFESOR FRANCISCO VERGARA BOBADILLA', value: '25271' },
  { text: 'ESC.PARVULOS PARTICULAR  LOS ANGELITOS', value: '25272' },
  { text: 'ESCUELA ESP. PART. EDUC. LAUDELINA ARANEDA', value: '25273' },
  { text: 'ESCUELA BASICA NUEVA LAS CUMBRES', value: '25275' },
  { text: 'ESCUELA ESPECIAL SANTIAGO APOSTOL', value: '25277' },
  { text: 'COLEGIO CAMPANARIO', value: '25278' },
  { text: 'ESCUELA PARTICULAR SALVADOR DALI', value: '25279' },
  { text: 'ESCUELA BASICA PARTICULAR BREMEN', value: '25280' },
  { text: 'ESCUELA ESPECIAL BAULIRURIRU', value: '25281' },
  { text: 'ESC.PART.ESPECIAL LA CONCEPCION DE COLINA', value: '25283' },
  { text: 'ESUELA ESPECIAL DE LENGUAJE PIRAMIDE', value: '25284' },
  { text: 'ESCUELA PARTICULAR  COMUNICATE', value: '25286' },
  { text: 'ESCUELA BASICA PARTICULAR ESJELAVI', value: '25287' },
  { text: 'ESC. BAS. Y ESP. CENTRO INTEGRAL ALTAIR DE BA', value: '25288' },
  { text: 'ESC. DE PARV. Y ESP. LUIS SEMBRADOR', value: '25289' },
  { text: 'ESCUELA BASICA PARTICULAR EL REY', value: '25290' },
  { text: 'CENTRO EDUCACIONAL HUGO TRIVELLI FRANZOLINI', value: '25291' },
  { text: 'ESCUELA ESPEC.PART. SANTA TERESA DE JESUS', value: '25294' },
  { text: 'ESC. ESPEC. LENGUAJE LOS CHIQUITINES', value: '25296' },
  { text: 'ESCUELA ESPECIAL Y LENGUAJE ROCIO', value: '25297' },
  { text: 'ESCUELA ESPECIAL PARTICULAR LUDILEN', value: '25298' },
  { text: 'ESC.BAS.NUEVOS CASTANOS DE MAIPU', value: '25300' },
  { text: 'ESC.ESPEC.SAGRADA FAMILIA DE MAIPU', value: '25301' },
  { text: 'ESCUELA ESPECIAL STELLA MARIS DE NUNOA', value: '25302' },
  { text: 'CENTRO EDUCACIONAL LAURA VICUNA', value: '25303' },
  { text: 'ESCUELA ESPECIAL ARCOIRIS DE EL BOSQUE', value: '25305' },
  { text: 'ESCUELA ESPECIAL TODOS LOS SANTOS', value: '25306' },
  { text: 'ESCUELA ESPECIAL OTTAWA', value: '25307' },
  { text: 'COLEGIO SAN NICOL\u00c3\u0081S DI\u00c3\u0081CONO', value: '25310' },
  {
    text: 'ESCUELA B\u00c3\u0081SICA 1737 LOS ALERCES DE MAIP\u00c3\u0161',
    value: '25314',
  },
  { text: 'ESCUELA PUERTO FUTURO', value: '25315' },
  { text: 'ESCUELA BASICA N_ 1739 PUELMAPU', value: '25316' },
  { text: 'ESC. ESP. PART PALOMAR DE QUILICURA', value: '25317' },
  { text: 'ESC. BAS. Y ESP. PART. KIMKELEN', value: '25319' },
  { text: 'ESCUELA  ESPEC. VIRGEN DE LAS PENAS', value: '25320' },
  { text: 'CENTRO EDUCACIONAL DE ADULTOS RAFAEL SOTOMAYO', value: '25322' },
  { text: 'ESCUELA BASICA QUITALMAHUE', value: '25324' },
  { text: 'ESC  ESP. PART. SAN JOSE DE TALAGANTE', value: '25325' },
  { text: 'ESC. ESPEC. PART. LAS CAMELIAS', value: '25327' },
  { text: 'INSTITUTO CRISTIANO LUIS GANDARILLAS', value: '25328' },
  { text: 'COLEGIO PART. FUNCASE DE PUENTE ALTO', value: '25330' },
  { text: 'ESCUELA BASICA PART. CRISTIANO DE LOS HEROES', value: '25331' },
  { text: 'COLEGIO MONTESSORI PUCALAN', value: '25332' },
  { text: 'ESC. ESPECIAL PART. MARTA Y BERTA', value: '25333' },
  { text: 'ESCUELA BASICA RAICES ALTAZOR', value: '25334' },
  { text: 'LICEO MUNICIPAL DE ADULTO MIGUEL CAMPINO LARRAIN', value: '25339' },
  { text: 'ESCUELA BASICA EL SAUCE', value: '25340' },
  { text: 'ESCUELA RAIMAPU-TIERRA FLORIDA', value: '25342' },
  { text: 'ESCUELA BASICA NELQUIHUE', value: '25344' },
  { text: 'ESCUELA PARVULARIA PARTICULAR FRANCISCO DE AS', value: '25346' },
  { text: 'COLEGIO SEBASTIAN EL CANO SAN BERNARDO', value: '25347' },
  { text: 'COLEGIO PARTICULAR MELFORD COLLEGE', value: '25349' },
  { text: 'ESC. PART. CRISTIANO ORIENTE', value: '25350' },
  { text: 'ESCUELA ESPECIAL PARTICULAR KIMANTU', value: '25351' },
  { text: 'COLEGIO POLIV. PATRICIO MEKIS DE PADRE HURTAD', value: '25352' },
  { text: 'ESCUELA ESPECIAL DEL LENGUAJE ROMIYANCO', value: '25353' },
  { text: 'ESCUELA ESPECIAL JESUS DEL BOSQUE', value: '25354' },
  { text: 'ESC. DE PARVULOS PART 103 EL PRINCIPITO DE LO', value: '25355' },
  { text: 'ESC. BASICA LA PRADERA DE CURACAVI', value: '25356' },
  { text: 'ESCUELA ESPECIAL CAPULLITO', value: '25358' },
  { text: 'COLEGIO METODISTA DE SANTIAGO', value: '25359' },
  { text: 'ESCUELA ESP. PART.  ANTUKUYEN', value: '25361' },
  { text: 'ESC.PART. TALLERES PREVOCACIONALES PADRE HURT', value: '25362' },
  { text: 'ESC. ESP. PUERTA DEL SOL', value: '25363' },
  { text: 'ESCUELA ESPECIAL PARTICULAR SANTA MARIA DE VI', value: '25364' },
  { text: 'COLEGIO AUSTRALIA', value: '25365' },
  { text: 'COLEGIO SANTIAGO', value: '25367' },
  { text: 'COLEGIO PART. CARDENAL CARLOS OVIEDO CAVADA', value: '25368' },
  { text: 'ESCUELA ESPECIAL MISTRAL', value: '25370' },
  { text: 'COLEGIO SANTA MARIA DE PAINE', value: '25371' },
  { text: 'ESCUELA DE PARVULOS ANTINIL N_ 3', value: '25372' },
  { text: 'COLEGIO SAN RAFAEL ARCANGEL', value: '25373' },
  { text: 'ESCUELA ESPECIAL RUCAMANQUE', value: '25375' },
  { text: 'ESCUELA ESPECIAL NUEVA CORDILLERA N_ 1762', value: '25376' },
  { text: 'ESCUELA ESPECIAL PARTICULAR DESPERTARES', value: '25377' },
  { text: 'ESCUELA DE PARVULOS KIMN', value: '25379' },
  { text: 'ESCUELA PARTICULAR EDIAL II', value: '25380' },
  { text: 'ESC. ESPECIAL PART. REYES DE ESPANA', value: '25381' },
  { text: 'COLEGIO SAINT CHARLES COLLEGE LA FLORIDA', value: '25382' },
  { text: 'ESC. ESP. CENT. DES. INTEG. DE LA COMUN. ADON', value: '25383' },
  { text: 'ESCUELA ESPECIAL 1768 RENACER', value: '25384' },
  { text: 'ESCUELA HERMANOS CARRERA', value: '25385' },
  { text: 'ESC.BASICA PART. ACONCAGUA DE PUDAHUEL', value: '25390' },
  { text: 'ESCUELA ESPECIAL PARTICULAR ANGELES', value: '25392' },
  { text: 'ESC. ESP. NINOS DE LA LUNA', value: '25394' },
  { text: 'COLEGIO BETTERLAND SCHOOL', value: '25395' },
  { text: 'ESCUELA ESPECIAL PART. ACONCAGUA DE PUDAHEL N', value: '25397' },
  { text: 'ESC. ESPECIAL 1775 SAN ANTONIO II', value: '25398' },
  { text: 'ESCUELA ESPECIAL PART. TRIPANTU', value: '25399' },
  { text: 'ESC. ESP. CHILE CUBA', value: '25400' },
  { text: 'ESCUELA ESPECIAL CARRUCEL', value: '25401' },
  { text: 'ESC. ESPECIAL GULLIVER', value: '25403' },
  { text: 'ESCUELA ESPECIAL PARTICULAR ARLEQUIN', value: '25404' },
  { text: 'ESCUELA ESPECIAL PART. TRAGALUZ', value: '25405' },
  { text: 'ESCUELA ESPECIAL MARIO BAEZA', value: '25406' },
  { text: 'ESCUELA ESPECIAL GABRIELA MISTRAL', value: '25408' },
  { text: 'ESCUELA ESPECIAL  MATICES', value: '25409' },
  { text: 'ESCUELA ESPECIAL PARTICULAR 1785 CAIL', value: '25412' },
  { text: 'ESC. DE PARV. Y ESP. ENANITOS', value: '25413' },
  { text: 'ESCUELA ESPEC. PART. ARCO IRIS DE RECOLETA', value: '25414' },
  { text: 'ESC. ESPECIAL TIEMPO NUEVO', value: '25415' },
  { text: 'ESCUELA PARTICULAR 1788 EDEN DE SAN RAMON', value: '25417' },
  { text: 'COLEGIO POLIV. SAN BERNARDO ABAD', value: '25418' },
  { text: 'ESC. PARV. Y ESP. GABRIELA MISTRAL DE MAIPU', value: '25420' },
  { text: 'ESCUELA ESPECIAL ARCANGEL GABRIEL', value: '25421' },
  { text: 'COLEGIO PARTICULAR IGNACIO SERRANO', value: '25423' },
  { text: 'ESC.ESP. PART. EL OLIVAR', value: '25425' },
  { text: 'ESC. ESP. PART. PALU', value: '25426' },
  { text: 'ESCUELA ESPECIAL BELEN DE MAIPU', value: '25427' },
  { text: 'ESC. ESP. PART. KADES BARNEA', value: '25428' },
  { text: 'ESC. ESP. PART. LOS AROMOS DE MAIPU', value: '25429' },
  { text: 'ESCUELA PARTICULAR N_ 1796 NUEVO HORIZONTE', value: '25430' },
  { text: 'ESCUELA BASICA PART SANTA MARIA DE ESMERALDA', value: '25431' },
  { text: 'ESCUELA ESP. RUCAMALEN', value: '25433' },
  { text: 'COLEGIO PARTICULAR FORJADORES', value: '25434' },
  { text: 'ESCUELA BASICA DEL PONIENTE', value: '25435' },
  { text: 'COLEGIO PART. SOCHIDES RENCA', value: '25436' },
  { text: 'ESC. BASICA Y ESP.  EL NAZARENO', value: '25437' },
  { text: 'ESCUELA ESPECIAL ADENNUN N_ 2', value: '25440' },
  { text: 'COLEGIO TALAGANTE GARDEN SCHOOL', value: '25442' },
  { text: 'ESC  ESP PART  PUERTA DEL SOL DE LA REINA', value: '25443' },
  { text: 'ESCUELA  ESP. N_1804 SAN JOSE', value: '25445' },
  { text: 'ESC. PARVULOS BILIBRI', value: '25446' },
  { text: 'COLEGIO VALLE DE MALLARAUCO', value: '25447' },
  { text: 'CENTRO EDUC. NINO DIOS DE MALLOCO', value: '25448' },
  { text: 'COLEGIO SALTAIRAM', value: '25450' },
  { text: 'ESC. ESP. NTRA. SRA. DEL BUEN CONSEJO I', value: '25451' },
  { text: 'COLEGIO PART. ANDINO ANTUQUELEN', value: '25454' },
  { text: 'COLEGIO POLIVALENTE FALCON COLLEGE', value: '25458' },
  { text: 'ESC. ESP. PART. PABLO NERUDA', value: '25459' },
  { text: 'ESC. ESP. PART. LA PAMPA', value: '25460' },
  { text: 'ESCUELA ESPECIAL PART. NINOS DE LA REINA', value: '25461' },
  { text: 'COLEGIO ALTO GABRIELA', value: '25462' },
  { text: 'ESC. BAS. PART.  JERUSALEN', value: '25465' },
  { text: 'ESCUELA DE PARVULOS EL PORVENIR', value: '25466' },
  { text: 'ESC. BAS. PART. SAN JUAN LEONARDI', value: '25467' },
  { text: 'ESCUELA DE PARV. ICHUAC', value: '25470' },
  { text: 'COLEGIO PART. KING EDWARDS SCHOOL I', value: '25471' },
  { text: 'ESCUELA ESPECIAL PART. GUENIPILLAN - MAIPU', value: '25473' },
  { text: 'ESCUELA BASICA  ANIDA', value: '25474' },
  { text: 'COLEGIO PART. PADRE JOSE KENTENICH', value: '25475' },
  { text: 'COLEGIO JOSE LUIS LEGRANGE DE LA CISTERNA', value: '25480' },
  { text: 'ESC. PART. ARTISTICA EL TRIGAL', value: '25482' },
  { text: 'ESC PART. SIGLO XXI DE LAMPA', value: '25484' },
  { text: 'ESC. BASICA  SAN BENITO DE COLINA', value: '25485' },
  { text: 'ESC. ESP. NTRA. SRA. DEL BUEN CONSE', value: '25490' },
  { text: 'ESCUELA BASICA PARTICULAR TRUPAN', value: '25492' },
  { text: 'ESC. DE PARV.CAMPANITA DE SAN MIGUEL', value: '25497' },
  { text: 'ESCUELA ESPEC.STA. TERESA DE AVILA', value: '25500' },
  { text: 'COLEGIO SAN ANDRES DE MAIPU', value: '25501' },
  { text: 'COLEGIO DE ADULTOS JOSE ABELARDO NUNEZ', value: '25502' },
  { text: 'COLEGIO DE ADULTOS JOSE ABELARDO NUNEZ-SAN BE', value: '25503' },
  { text: 'COLEGIO DE ADULTOS JOSE ABELARDO NUNEZ EL BOS', value: '25504' },
  { text: 'ESCUELA ESPECIAL PARTICULAR BATUCO', value: '25506' },
  { text: 'ESC. BASICA PARTICULAR SAN PABLO', value: '25507' },
  { text: 'ESCUELA ESPECIAL DESPERTAR DE LO ESPEJO', value: '25510' },
  { text: 'ESCUELA DE PARV. BRITISH NURSERY SCHOOL', value: '25511' },
  { text: 'ESCUELA ESPECIAL  NINO DE JESUS', value: '25513' },
  { text: 'INSTITUTO DE EDUCACION DE ADULTOS MACUL', value: '25514' },
  { text: 'ESCUELA ESP. PART. ELEFANTE MELODIA', value: '25515' },
  { text: 'ESCUELA ESPECIAL PADRE PIO COLLEGE', value: '25516' },
  { text: 'ESC. ESP. PART MADRE MARIA MAZZARELLO', value: '25517' },
  { text: 'ESC. DE PARVULOS PART.  GIROLIN', value: '25518' },
  { text: 'COL. PART. SAGRADO CORAZON DE JESUS DE LA RE', value: '25520' },
  { text: 'CENTRO EDUCACIONAL ADULTOS KAIROS', value: '25524' },
  { text: 'ESCUELA ESPECIAL PART. N_ 110  TRINIDAD FERR', value: '25527' },
  { text: 'ESCUELA ESPECIAL PARTICULAR ROMPE MI SILENCIO', value: '25528' },
  { text: 'ESCUELA ESPECIAL  GEORGINA DE LAS NIEVES', value: '25529' },
  { text: 'ESCUELA ESPECIAL LOS CORCELES', value: '25530' },
  { text: 'COLEGIO DE ADULTOS SANTA VICENTA MARIA', value: '25531' },
  { text: 'ESCUELA ESPECIAL PARTICULAR MARTIN PESCADOR', value: '25532' },
  { text: 'ESCUELA BAS. Y ESP. SAN JOSE DE ISLA DE MAIPO', value: '25533' },
  { text: 'ESC. ESP. PARTICULAR MANANTIAL', value: '25534' },
  { text: 'ESC. ESP. PART. N_ 1846 ACUARELA', value: '25535' },
  { text: 'ESCUELA DE PARV. Y ESPECIAL PELUSITA', value: '25537' },
  { text: 'EJERCITO LIBERTADOR DE CERRILLOS', value: '25539' },
  { text: 'COLEGIO MONTE OLIVO DE PUENTE ALTO', value: '25540' },
  { text: 'COLEGIO SANTA BARBARA H.S.', value: '25542' },
  { text: 'COLEGIO POLIV. SAN CRISTOBAL APOSTOL', value: '25543' },
  { text: 'ESC. ESP. Y BAS. FRANCES DE LA PINTANA', value: '25544' },
  { text: 'ESCUELA ESPECIAL PART. N_ 1850 TRALEN', value: '25545' },
  { text: 'ESCUELA ESPECIAL PART. MERCEDES', value: '25546' },
  { text: 'ESCUELA PARTICULAR NUEVA ESMERALDA', value: '25547' },
  { text: 'ESCUELA DE PARV. PART. NUEVO ANTUMALAL', value: '25549' },
  { text: 'ESCUELA ESP. MANANTIAL DEL BOSQUE', value: '25551' },
  { text: 'ESCUELA ESPECIAL EL NIDITO', value: '25554' },
  { text: 'ESCUELA PART. DE LENGUAJE APORE', value: '25555' },
  { text: 'ESC BASICA PART EMILIA GONZALEZ ESPINOZA', value: '25557' },
  { text: 'COLEGIO POLIVALENTE HERNAN AGUIRRE MAC-KAY', value: '25559' },
  { text: 'ESCUELA ESPECIAL  PARTICULAR MELILLAN', value: '25560' },
  { text: 'ESCUELA DIVINO MAESTRO', value: '25561' },
  { text: 'ESC BASICA PART SAN JOSE DE LA FAMILIA', value: '25562' },
  { text: 'ESC. ESP. PARTICULAR  MI CASITA', value: '25563' },
  { text: 'ESCUELA ESPECIAL PART. TALENTOS', value: '25564' },
  { text: 'ESC ESP PART PROF RAQUEL TORRES GUZMAN', value: '25565' },
  { text: 'ESC ESP PART RAYITO DE LUZ DE QTA NORMAL', value: '25566' },
  { text: 'ESCUELA BAS. Y ESP. ANTILLANCA DE TALAGANTE', value: '25568' },
  { text: 'ESC ESPECAIL PARTICULAR  MI FAMILIA', value: '25569' },
  { text: 'ESCUELA ESPECIAL PART. MAHUIDANCHE', value: '25572' },
  { text: 'ESC. DE PARV. Y ESP. PART. CENTILEN', value: '25573' },
  { text: 'ESCUELA ESPECIAL PART. MELODIA DE LA FLORIDA', value: '25574' },
  { text: 'ESCUELA ESPECIAL PART. ALAMEDA', value: '25575' },
  { text: 'ESCUELA BASICA PART. SAN JORGE DE PUDAHUEL', value: '25576' },
  { text: 'CENTRO EDUC. DE EST. Y DES. DEL LENGUAJE PEHU', value: '25578' },
  { text: 'ESCUELA ESP. SAN JOSE OBRERO', value: '25581' },
  { text: 'ESCUELA ESP. PART. GIRASOL DE RECOLETA', value: '25582' },
  { text: 'ESC. ESP. PART. SANTISIMA TRINIDAD DE PUDAHUE', value: '25583' },
  { text: 'ESCUELA ESPECIAL PART. UNAMKALEN', value: '25585' },
  { text: 'ESCUELA ESP. PART. RAIHUEN', value: '25586' },
  { text: 'LICEO TECNICO PROFESIONAL DE BUIN', value: '25591' },
  { text: 'CENTRO EDUCATIVO LA PUERTA', value: '25592' },
  { text: 'MARY ANNE SCHOOL DE QUILICURA', value: '25593' },
  { text: 'ESCUELA ESP. PART. SOL Y LUNA', value: '25594' },
  { text: 'ESC. ESPECIAL PART. BELLA ACUARELA', value: '25595' },
  { text: 'ESCUELA ESPECIAL PART. ANTULEMU', value: '25596' },
  { text: 'COLEGIO PART. SAN PEDRO DE QUILICURA', value: '25599' },
  { text: 'ESCUELA PARV. MY HAPPY SCHOOL', value: '25601' },
  { text: 'ESC. PART. PABLO APOSTOL DE BUIN', value: '25602' },
  { text: 'ESCUELA ESP. NUEVO MUNDO DE LA GRANJA', value: '25604' },
  { text: 'ESCUELA ESP. SANTA CECILIA DE SAN BERNARDO', value: '25606' },
  { text: 'ESCUELA ESP. BOSQUE DE NINOS', value: '25607' },
  {
    text: 'ESC. ESP. N\u00c2\u00ba 109 SAN VALENTIN DE TALAGANTE',
    value: '25608',
  },
  { text: 'COLEGIO PADRE CHAMINADE', value: '25609' },
  { text: 'ESCUELA ESP. TREM TREMO', value: '25610' },
  { text: 'ESCUELA BASICA BARRIE MONTESSORI N\u00c2\u00ba 2', value: '25611' },
  { text: 'ESC. DE PARV. Y ESP. AMANECER DE PADRE HURTA', value: '25612' },
  { text: 'ESC. ESP. SAN ANDRES DE LO BARNECHEA', value: '25614' },
  { text: 'COLEGIO POLIVALENTE SAINT PETER COLLEGE', value: '25615' },
  { text: 'ESCUELA ESPECIAL LA GRANJA', value: '25616' },
  { text: 'ESC. ESP. MILLARAY DE PUENTE ALTO', value: '25618' },
  { text: 'ESCUELA ESP. ENLANCES', value: '25619' },
  { text: 'ESCUELA ESPECIAL EDUCCERE', value: '25621' },
  { text: 'ESCUELA ESPECIAL PART. ABRA PALABRA', value: '25622' },
  { text: 'ESC. BAS. Y ESP. NUEVA INTEGRAL ALTAZOR', value: '25624' },
  { text: 'ESCUELA PARVULOS INST. SWEET N1', value: '25627' },
  { text: 'ESCUELA ESPECIAL EL ALBA DE LA CISTERNA', value: '25629' },
  { text: 'LICEO POLIV. SAN JOSE DE LO BARNECHEA', value: '25630' },
  { text: 'ESCUELA ESPECIAL PASO A PASO', value: '25631' },
  { text: 'ESCUELA PARVULOS PART. GENTECITA', value: '25632' },
  { text: 'COLEGIO ADULTOS  ALFRED NOBEL', value: '25633' },
  { text: 'ESCUELA ESPECIAL BELEN DE QTA. NORMAL', value: '25636' },
  { text: 'ESCUELA ESPECIAL CASTORCITO', value: '25638' },
  { text: 'ESCUELA ESPECIAL JACARANDA', value: '25639' },
  { text: 'COLEGIO  MANQUECURA PUENTE ALTO', value: '25640' },
  { text: 'ESCUELA ESP. ANTU-MAWIDA', value: '25641' },
  { text: 'ESCUELA BAS. MUNIC. CUYUNCAVI', value: '25642' },
  { text: 'THE INTERNATIONAL PREPARATORY SCHOOL', value: '25643' },
  { text: 'COLEGIO PART. NTRA. SRA. MARIA INMACULADA DEL', value: '25645' },
  { text: 'ESCUELA PART. ANTAL', value: '25646' },
  { text: 'ESC. ESP. PART. SAN LORENZO DE ISLA DE MAIPO', value: '25647' },
  { text: 'ESCUELA ESPECIAL SEMILLITA DE JESUS II', value: '25649' },
  { text: 'COLEGIO AMERICAN BRITISH COLLEGE', value: '25650' },
  { text: 'ESCUELA ESPECIAL HOSPITAL FELIX BULNES', value: '25652' },
  { text: 'COLEGIO EVEREST', value: '25654' },
  { text: 'ESC. ESPECIAL PASITOS', value: '25656' },
  { text: 'ESCUELA ESPECIAL PART. PACKAMAWA', value: '25657' },
  { text: 'ESCUELA ESPECIAL PART. SANTA JAVIERA', value: '25658' },
  { text: 'ESCUELA DE PARVULOS ARTECOLOR', value: '25659' },
  { text: 'ESC. ESP. CASABIERTA-COANIQUEM', value: '25660' },
  { text: 'ESCUELA DE PARV. CAPULLITOS DE SAN BERNARDO', value: '25661' },
  { text: 'ESCUELA DE PARVULOS REMOLINO', value: '25662' },
  { text: 'ESCUELA DE PARVULOS MYCKEY', value: '25663' },
  { text: 'ESCUELA ESP. EL SEMBRADOR DE CERRILLOS', value: '25664' },
  { text: 'ESCUELA ESP. GROWING SCHOOL', value: '25667' },
  { text: 'ESCUELA ESP. SANTA GABRIELA', value: '25668' },
  { text: 'COLEGIO HIGHLANDS', value: '25669' },
  { text: 'ESCUELA ESPECIAL PART. AYELETTE', value: '25670' },
  { text: 'COLEGIO SAN MARTIN DE PORRES DE LA PINTANA', value: '25671' },
  { text: 'CENTRO EDUC. DE ADULTOS CARDENAL RAUL SILVA H', value: '25672' },
  { text: 'ESCUELA INSTITUTO RAMON FREIRE', value: '25674' },
  { text: 'COLEGIO POLIVALENTE ELISA VALDES', value: '25676' },
  { text: 'ESCUELA BASICA  SISTER VERENANCE', value: '25677' },
  { text: 'COLEGIO OXFORD', value: '25681' },
  { text: 'ESCUELA ESP. PART. HORIZONTE MANQUEHUE', value: '25683' },
  { text: 'ESC. DE PARV. PART. MI PEQUENO MUNDO DE SAN R', value: '25688' },
  { text: 'COLEGIO MADRE DE LA DIVINA PROVIDENC', value: '25693' },
  { text: 'ESCUELA BAS. PART. OHIGGINS', value: '25697' },
  { text: 'COLEGIO JAIME GUZM\u00c3\u0081N ERRAZURIZ', value: '25698' },
  { text: 'ASHELL ENGLISH COLLEGE SAN MIGUEL', value: '25699' },
  { text: 'COLEGIO LOS ALPES MAIPU', value: '25700' },
  { text: 'ESCUELA DE PARVULOS MIS AMIGUITOS', value: '25705' },
  { text: 'ESCUELA BAS. CONTINENTAL SCHOOL N_ 3', value: '25708' },
  { text: 'ESCUELA ESPECIAL PART. DAME LA MANO', value: '25710' },
  { text: 'ESC. BASICA MUNICIPAL PAULA JARAQUEMADA ALQUI', value: '25711' },
  { text: 'COLEGIO PART. MANANTIAL DE LA FLORIDA', value: '25713' },
  { text: 'COLEGIO PART. NEW HEINRICH HIGH SCHOOL', value: '25716' },
  { text: 'ESC. DE PARVULOS LOS OSITOS DE PUDAHUEL', value: '25719' },
  { text: 'COLEGIO PART. ALTAMIRA-ADULTOS', value: '25723' },
  { text: 'ESCUELA PART. NAHUEL', value: '25725' },
  { text: 'ESCUELA PARTICULAR SANTA LAURA DE MELIPILLA', value: '25726' },
  { text: 'ESCUELA DE PARVULOS SAN JOSE DE PROVIDENCIA', value: '25731' },
  { text: 'ESCUELA PART. SANTA TERESA DE QUILICURA', value: '25733' },
  { text: 'CENTRO EDUCACIONAL DE ADULTOS SAN ALFONSO', value: '25735' },
  { text: 'CENTRO EDUC. DE ADULTOS ISABEL LA CATOLICA', value: '25736' },
  { text: 'COLEGIO PART. ACROPOLIS', value: '25737' },
  {
    text: 'ESCUELA BASICA PARTICULAR SAN JOSE DE  MELIP\u00c2\u00a6',
    value: '25738',
  },
  { text: 'ESC. ESP. PART. SANTA TERESITA DE LOS ANDES', value: '25740' },
  { text: 'ESC. ESPECIAL RUGENDAS', value: '25741' },
  { text: 'ESCUELA ESP. PART. S.M. CRECER', value: '25742' },
  { text: 'ESC. DE PARVULOS PART. LA FAROLA', value: '25743' },
  { text: 'ESC. DE PARV. Y ESP. CARACOLA', value: '25747' },
  { text: 'ESC. DE PARVULOS PART. CARACOL DE MAIPU', value: '25748' },
  { text: 'COLEGIO PART. ALICANTE DEL ROSAL', value: '25749' },
  { text: 'ESCUELA ESPECIAL SONRISA DE NINOS', value: '25750' },
  { text: 'CENTRO DE EDUC. INTEGRADA DE ADULTOS TALAGANT', value: '25752' },
  { text: 'CENTRO EDUC. PRINCIPADO DE ASTURIA ADULTO', value: '25753' },
  { text: 'ESC. ESPECIAL LAS ESPIGAS DE ESTACION CENTRAL', value: '25754' },
  { text: 'ESCUELA ESPECIAL PART. ELIAS CANESSA VERGARA', value: '25756' },
  { text: 'ESC. ESP. PART. TRIGAL DE HUECHURABA', value: '25757' },
  { text: 'ESC. ESP. PART. DULCE COMPANIA', value: '25760' },
  { text: 'ESC. ESP. PART. JESUS DEL BOSQUE II', value: '25762' },
  { text: 'ESC. DE PARV. Y ESP. CASABLANCA DE SAN BERNAR', value: '25764' },
  { text: 'ESC. ESPECIAL PART. AULENCO', value: '25765' },
  { text: 'COLEGIO SAN JORGE DE LAS CONDES', value: '25767' },
  { text: 'COLEGIO PART. EXTREMADURA DE VITACURA', value: '25768' },
  { text: 'ESSC. ESP. PART. DIFERENCIAL CERRILLOS', value: '25769' },
  { text: 'LICEO NACIONAL DE MAIPU', value: '25770' },
  { text: 'ESCUELA DE PARV. PART. HAPPY GARDEN', value: '25772' },
  { text: 'ESCUELA ESP. PART. SAGRADA FAMILIA DE SAN BER', value: '25773' },
  { text: 'ESCUELA ESP. PART. ARRAYAN', value: '25774' },
  { text: 'ESC. PART. PARV. HEIDI GARDEN SCHOOL', value: '25776' },
  { text: 'ESC. ESP. PART. ARAUCARIAS DE PENALOLEN', value: '25782' },
  { text: 'ESCUELA ESP. PART. ARBOLIRIS', value: '25784' },
  { text: 'ESCUELA ESPECIAL PARTICULAR KINERET', value: '25786' },
  { text: 'ESC. ESP. PART. DIEGO THOMPSON', value: '25787' },
  { text: 'ESCUELA BASICA ANA FRANK', value: '25788' },
  { text: 'ESC.PARV.KINDER GARDEN RAYITO DE SOL', value: '25789' },
  { text: 'COLEGIO POLIV. DIEGO PORTALES DE MAIPU', value: '25790' },
  { text: 'ESCUELA ESP. PART. RIGOBERTA MENCHU', value: '25791' },
  { text: 'ESCUELA ESP. PART. SANTA MARIA DE QUILICURA', value: '25792' },
  { text: 'ESC. ESP. PART. GABRIELA MISTRAL DE PENALOLEN', value: '25793' },
  { text: 'ESCUELA B-SICA PUCARA LASANA', value: '25797' },
  { text: 'ESC. BAS. PART. ERNESTINA KRISCHUK', value: '25799' },
  { text: 'ESCUELA DE PARVULOS PART. ARCA DE NOE', value: '25800' },
  { text: 'ESCUELA ESP. LA ESPIGA', value: '25801' },
  { text: 'ESC. PART. ALBERT SCHWEITZER', value: '25803' },
  { text: 'ESCUELA ESP. PART. LA PASCANA', value: '25807' },
  { text: 'ESC. BAS. PART. LAS NACIONES', value: '25808' },
  { text: 'ESC.ESP. PART.SAN VICENTE DE PAUL DE CONCHAL-', value: '25809' },
  { text: 'ESCUELA ESP. PART. INSTITUTO GASAL', value: '25811' },
  { text: 'LICEO MUNICIP. DE ADULTOS PEDRO J. RODRIGUEZ', value: '25812' },
  { text: 'ESC.PARVULOS Y ESPC. SAYEN', value: '25814' },
  { text: 'COLEGIO CENTRO DE EDUC PERM.DE ADULTOS S', value: '25817' },
  { text: 'ESCUELA ESP. PART. SAN PIO DE PIETRELCINA', value: '25819' },
  { text: 'ESCUELA DE PARV SAN ANTONIO MARIA ZACCARIA II', value: '25822' },
  { text: 'ESCUELA EMAUS DE MAIPU', value: '25823' },
  { text: 'ESCUELA BASICA  SAN MIGUEL ARCANGEL DE LA', value: '25825' },
  { text: 'ESCUELA BASICA MILLAWE', value: '25826' },
  { text: 'ESC. ESPECIAL PART. JAN VAN DIJK', value: '25828' },
  { text: 'ESCUELA BASICA PARTICULAR CONTEMPORA', value: '25831' },
  { text: 'ESCUELA BASICA SAINT PAUL MONTESSORI SCHOOL', value: '25833' },
  { text: 'ESCUELA ESP. PART. EL PRINCIPITO DE LO HERRER', value: '25834' },
  { text: 'ESCUELA PART. ROSA JARAQUEMADA', value: '25836' },
  { text: 'ESCUELA BAS. MY GARDEN SCHOOL', value: '25838' },
  { text: 'ESC. BAS. Y ESP. CELEI', value: '25839' },
  { text: 'ESCUEL PARV. ABRA CADABRA', value: '25840' },
  { text: 'ESCUELA PARV. SAN ANTONIO MARIA ZACCARIA', value: '25841' },
  { text: 'ESCUELA PART. SAN MARCELO N_ 3', value: '25845' },
  { text: 'ESCUELA ESP. PART. SANTA ROSA DE MELIPILLA', value: '25847' },
  { text: 'ESC. PART. EL ARRAYAN DE MAIPU', value: '25851' },
  { text: 'CENTRO ESTI. DE HAB. COMUNICATIVAS AMERICA', value: '25854' },
  { text: 'ESCUELA ESP. PART. APRAVI', value: '25856' },
  { text: 'ESCUELA ESP. PART. HAPPY CHILDREN', value: '25857' },
  { text: 'ESCUELA ESP. PART. RALUI', value: '25859' },
  { text: 'ESCUELA ESP. PART. CORDILLERA ORIENTE', value: '25860' },
  { text: 'ESCUELA ESP. PART. CAPULLITOS DE SOL', value: '25862' },
  { text: 'SAN IGNACIO COLLEGE', value: '25865' },
  { text: 'ESCUELA PART. AMANECER DE LA GRANJA', value: '25867' },
  { text: 'ESCUELA ESPECIAL FUNDAC LEOPOLDO DONNEBAUM', value: '25868' },
  { text: 'ESCUELA ESP. PART. SAN NICOLAS', value: '25869' },
  { text: 'ESCUELA DE PARV. CARRUSEL DE AMIGOS', value: '25872' },
  { text: 'ESCUELA ESP. DE LENGUAJE PLAZA SESAMO', value: '25873' },
  { text: 'COLEGIO DE ADULTOS PART. VASCO DE GAMA', value: '25874' },
  { text: 'COLEGIO CENTRO EDUC. Y FAMILIAR PTE ALTO', value: '25876' },
  { text: 'ESCUELA ESP. SAN NICOLAS DE BELEN', value: '25877' },
  { text: 'ESCUELA ESP. PART. AMANTU', value: '25878' },
  { text: 'ESCUELA ESPECIAL PART. PACKAMAWA', value: '25879' },
  { text: 'ESCUELA ESP. PART. TECNOLOGICA', value: '25880' },
  { text: 'ESCUELA ESP. PART. PATAGONIA', value: '25881' },
  { text: 'COLEGIO NOBEL GABRIELA MISTRAL', value: '25882' },
  { text: 'ESC. ESP. PART. SAN MATEO DEL BOSQUE', value: '25883' },
  { text: 'ESCUELA ESP. PART. ACONCAGUA DE COLINA', value: '25884' },
  { text: 'ESCUELA ESPECIAL RICALHUE', value: '25886' },
  { text: 'ESCUELA ESPECIAL PART. ARCO IRIS', value: '25887' },
  { text: 'ESCUELA ESPECIAL DE LENGUJE MIS AMIGUITOS', value: '25890' },
  { text: 'ESCUELA PART. INSTITUTO S.A', value: '25897' },
  { text: 'COLEG. POLIV. NUEVO CENTRO EDUC. JOSE ABELA', value: '25899' },
  { text: 'ESC. ESP. VOCARE', value: '25900' },
  { text: 'ESC. EVANG. PENTECOSTAL DR. WILLIS C. HOOVER', value: '25901' },
  { text: 'ESC. DE PARV. Y ESP. RAHUE', value: '25902' },
  { text: 'ESCUELA ESP. MI ESPACIO', value: '25903' },
  { text: 'ESCUELA ESP. PART. VALLE DEL SOL', value: '25904' },
  { text: 'ESCUELA DE PARVULOS TRENCITO FELIZ', value: '25905' },
  { text: 'ESCUELA ESP. PARTICULAR OSCAR CASTRO', value: '25906' },
  { text: 'ESCUELA ESP. PART. SAN JOSE DE SAN BERNARDO', value: '25907' },
  { text: 'ESCUELA ESPECIAL ARCOIRIS', value: '25909' },
  { text: 'ESCUELA ESP. PART. SAN JORGE DE QUINTA NORMAL', value: '25912' },
  { text: 'ESCUELA ESP. PART. CHARLES DE GAULLE', value: '25913' },
  { text: 'ESCUELA DE PARV. PART. SAN JORGE DE COLINA', value: '25914' },
  { text: 'ESCUELA BAS. SAN SEBASTIAN DE COLINA', value: '25916' },
  { text: 'ESCUELA DE PARVULOS SAN SEBASTIAN GARDEN', value: '25917' },
  { text: 'ESCUELA ESP. PART. CAMINO A BELEN N\u00c2\u00a6 2', value: '25918' },
  { text: 'ESCUELA BASICA NEHUEN', value: '25919' },
  { text: 'ESCUELA ESP. PART. CALIN', value: '25920' },
  { text: 'COLEGIO CENTRO EDUCACIONAL ROUSSEAU', value: '25921' },
  { text: 'COLEGIO TERRA AUSTRALIS', value: '25922' },
  { text: 'ESCUELA ESP. PADRE PIO', value: '25923' },
  { text: 'COLEGIO POLIV. JERUSALEN DE LAMPA', value: '25926' },
  { text: 'ESCUELA BASICA TERRA DI BIMBI', value: '25927' },
  { text: 'ESCUELA BASICA ALAMIRO', value: '25928' },
  { text: 'COLEGIO PADRE PEDRO ARRUPE SAGRADA FAMILIA', value: '25929' },
  { text: 'ESCUELA ESP. SANTA RITA DE CASIA DE QTA. NORM', value: '25931' },
  { text: 'COLEGIO DE ADULTOS LONDON DE LA FLORIDA', value: '25932' },
  { text: 'ESCUELA BASICA ALBORADA SCHOOL', value: '25933' },
  { text: 'ESCUELA ESPECIAL LA ISLA', value: '25935' },
  { text: 'COLEGIO NUEVO HORIZONTE DE PUENTE ALTO', value: '25936' },
  { text: 'ESC. DE PARV. Y ESPECIAL COMUNICA', value: '25937' },
  { text: 'LICEO DE ADULTOS CEIA DE LA PINTANA', value: '25938' },
  { text: 'ESCUELA DE PARV. PARQUE OHIGGINS', value: '25940' },
  { text: 'ESCUELA PART. SPRING COLLEGE N_ 2', value: '25941' },
  { text: 'ESCUELA ESPECIAL MIRADOR AZUL', value: '25943' },
  { text: 'ESCUELA PART. PARTHENON COLLEGE', value: '25944' },
  { text: 'ESCUELA PARVULOS MY SECOND HOME', value: '25946' },
  { text: 'COLEGIO DE ADULTOS VALLE DE AZAPA', value: '25948' },
  { text: 'COLEGIO SEMPER ALTIUS', value: '25950' },
  { text: 'COLEGIO DE ADULTOS CARELMAPU DE CONCHALI', value: '25951' },
  { text: 'ESCUELA DE PARV. BERNARD COLLEGE DE SAN BERNA', value: '25952' },
  { text: 'ESC. ESP.PART. SAN AGUSTIN DE INDEPENDENCIA', value: '25953' },
  { text: 'ESC. BAS. Y ESP. NTRA. SRA. DE LAS NIEVES', value: '25954' },
  { text: 'ESCUELA BASICA LOS PINITOS', value: '25957' },
  { text: 'ESCUELA BASICA MIRASOL DE SANTIAGO', value: '25958' },
  { text: 'ESC. ESPECIAL HOSPITAL SAN JUAN DE DIOS', value: '25959' },
  { text: 'CENTRO EDUC. PADRE ALBERTO HURTADO DE SAN BER', value: '25960' },
  { text: 'ESCUELA ESP. PART. ACONCAGUA DE BATUCO', value: '25964' },
  { text: 'ESCUELA ESP. LAS BARRANCAS', value: '25965' },
  { text: 'ESCUELA PARV. OASIS DE MAIPU', value: '25966' },
  { text: 'ESCUELA PARVULOS MELODIA AZUL', value: '25968' },
  { text: 'COLEGIO AUSTRALIAN COLLEGE TERCER MILENIO', value: '25969' },
  { text: 'ESCUELA BAS. Y ESP. EDUCAR', value: '25970' },
  { text: 'ESCUELA ESP. ESTACION ACUARELA', value: '25971' },
  { text: 'ESCUELA ESP. DIVINO MAESTRO DE CERRILLOS', value: '25972' },
  { text: 'ESC. BASICA  JARDIN DEL ARCO IRIS', value: '25976' },
  { text: 'COLEGIO DE AD. SANTA MARIA DEL TRABAJO DE EST', value: '25977' },
  { text: 'CENTRO EDUCACIONAL DE ADULTOS CEDUCA', value: '25978' },
  { text: 'ESCUELA DE PARV. CIUDAD BEBE', value: '25979' },
  {
    text: 'CENTRO EDUCACIONAL DE ADULTOS PADRE ALBERTO HURTADO',
    value: '25982',
  },
  { text: 'ESCUELA DE PARVULOS TERESITA', value: '25983' },
  { text: 'ESCUELA BAS. ALFREDO DREYSE BELSER', value: '25984' },
  { text: 'COLEGIO JUAN LUIS UNDURRAGA ANINAT', value: '25988' },
  { text: 'ESCUELA ESP. INTEGRACION PLENA', value: '25989' },
  { text: 'ESCUELA BAS. AMANKAY DE LAMPA', value: '25991' },
  { text: 'ESCUELA ESP. SAN JUAN DE DIOS', value: '25993' },
  { text: 'ESCUELA ESP. PABLO NERUDA DE LA FLORIDA', value: '25994' },
  { text: 'CENTRO POLITEC. CARLOS CONDELL DE LA CISTERNA', value: '25995' },
  { text: 'ESCUELA ESP. EL CARMEN', value: '25996' },
  { text: 'ESCUELA ESP. KINCUIN', value: '25997' },
  { text: 'ESCUELA ESP. TU ESPERANZA', value: '25998' },
  { text: 'ESCUELA ESP. SOL DE LA REINA', value: '26000' },
  { text: 'ESCUELA DE PARV. PASTORCITOS DE MARIA', value: '26002' },
  { text: 'ESC. ESPECIAL ELSA MATILDE ULRICH JARA', value: '26003' },
  { text: 'ESCUELA ESP. RENACERES', value: '26004' },
  { text: 'ESCUELA ESP. MI MUNDO EN PALABRAS', value: '26005' },
  { text: 'COLEGIO ECOLOGICO PAINE', value: '26006' },
  { text: 'ESCUELA ESPECIAL VOCES DE BUIN', value: '26008' },
  { text: 'CENTRO EDUC. DE ADULTOS EL ALERCE DE PENALOLE', value: '26009' },
  { text: 'COLEGIO MODERNO PAINE', value: '26012' },
  { text: 'ESCUELA ESP.  JOSE MAZA FERNANDEZ', value: '26013' },
  { text: 'ESCUELA ESP. BILBAO', value: '26014' },
  { text: 'ESC.BASICA Y ESP.MARIA DE LOS ANGELES DE BUIN', value: '26015' },
  { text: 'ESCUELA ESP. ESPERANZA DE EL BOSQUE', value: '26016' },
  { text: 'ESCUELA BAS. KINGS SCHOOL', value: '26017' },
  { text: 'ESCUELA ESP. GENESIS 2005', value: '26019' },
  { text: 'ESCUELA ESP. IVUN CUPAL CATEMU', value: '26020' },
  { text: 'ESC. DE PARV. Y ESP. SAN PIO DE TALAGANTE', value: '26021' },
  { text: 'ESCUELA ESP. FERNANDA FRIAS RETAMAL', value: '26022' },
  { text: 'COLEGIO SANTA BARBARA COLLEGE', value: '26025' },
  { text: 'COLEGIO DE AD. INSTITUTO NUEVA IMAGEN', value: '26027' },
  { text: 'COLEGIO EMMANUEL HIGH SCHOOL', value: '26028' },
  { text: 'ESCUELA ESP. CREDERE', value: '26029' },
  { text: 'COLEGIO DE ADULTOS INSTITUTO NUEVO BILBAO', value: '26030' },
  { text: 'ESCUELA DE PARV. MI PRIMERA AVENTURA', value: '26031' },
  {
    text: 'INSTITUTO DE EDUCACI\u00c3\u201cN DE ADULTOS LA CASTRINA',
    value: '26032',
  },
  { text: 'COLEGIO POLIV. SAN CARLOS DE QUILICURA', value: '26033' },
  { text: 'ESCUELA PART. SAN JOSE DE LAMPA', value: '26035' },
  {
    text: 'ESCUELA ESPECIAL N 2086 HOSPITAL CLINICO PONTIFICIA UNIVERSIDAD CAT\u00c3\u201cLICA DE CHILE',
    value: '26036',
  },
  { text: 'INSTITUTO ESTADOS AMERICANOS LO BARNECHEA', value: '26037' },
  { text: 'ESCUELA BAS. SAN MATEO SCHOOL DE CONCHALI', value: '26039' },
  { text: 'COLEGIO DE ADULTOS ANSELMO URBANO CADIZ', value: '26042' },
  { text: 'ESCUELA SANTA TERESA DE LOS ANDES', value: '26043' },
  { text: 'ESCUELA BAS. Y ESP. LIKAN-RAY DE LA PINTANA', value: '26044' },
  { text: 'ESCUELA  SAN PEDRO VALLE GRANDE', value: '26045' },
  { text: 'COLEGIO  MANQUECURA CIUDAD DE LOS VALLES', value: '26046' },
  { text: 'ESCUELA DE PARV. PIN PON', value: '26047' },
  { text: 'COLEGIO DE ADULTOS ALFRED NOBEL EL BOSQUE', value: '26048' },
  { text: 'ESCUELA DE PARV. TIA LORENA', value: '26050' },
  { text: 'ESCUELA DE PARV. EL CASTILLO', value: '26051' },
  { text: 'ESCUELA DE PARV. CRECER FELIZ', value: '26052' },
  { text: 'COLEGIO ATENAS', value: '26053' },
  { text: 'COLEGIO DE ADULTOS INSTITUTO ROGERIANO', value: '26054' },
  { text: 'ESCUELA DE PARVULOS LOS ENANITOS', value: '26057' },
  { text: 'ESCUELA DE PARV. ANAKENA', value: '26058' },
  { text: 'ESCUELA DE PARV. Y ESPECIAL NADEL', value: '26060' },
  { text: 'COLEGIO DE ADULTO LAURA VICUNA DE RENCA', value: '26061' },
  { text: 'COLEGIO DE AD. SAN JAVIER DE SAN MIGUEL', value: '26062' },
  { text: 'COLEGIO DE AD. INSTITUTO HUMBOLDT', value: '26063' },
  { text: 'ESCUELA ESP. SAN MARTIN', value: '26064' },
  { text: 'ESC. PARV. ITACA', value: '26065' },
  { text: 'ESC. DE PARV. SEMILLITA MONTESSORI', value: '26066' },
  { text: 'ESCUELA BAS. LICARITO', value: '26068' },
  { text: 'CENTRO EDUC. REGULAR DE ADULTOS CEDEA', value: '26070' },
  { text: 'ESCUELA DE PARVULOS Y ESP. DA VINCE', value: '26071' },
  { text: 'ESC. DE PARV. COPITO DE NIEVE', value: '26073' },
  { text: 'ESCUELA BAS. SAN JOSE DE PENALOLEN', value: '26075' },
  { text: 'ESCUELA DE PARVULOS OESTE', value: '26076' },
  { text: 'COLEGIO DE ADULTOS SEMBRADOR SAN BENITO', value: '26077' },
  { text: 'ESCUELA DE PARVULOS HANSEL Y GRETEL', value: '26078' },
  { text: 'ESCUELA DE PARV. HELLO CHILDREN', value: '26079' },
  { text: 'COLEGIO SAINT ANDREW', value: '26080' },
  { text: 'ESCUELA ESP. DICKENS COLLEGE', value: '26081' },
  { text: 'ESCUELA DE PARVULOS HAMELIN', value: '26082' },
  { text: 'COLEGIO SAN ALBERTO HURTADO', value: '26083' },
  { text: 'ESCUELA BAS. Y ESP. EL BOSQUE DE RENCA', value: '26084' },
  { text: 'COLEGIO DE ADULTOS PRESBITERIANO DE MAIPU', value: '26085' },
  { text: 'COLEGIO DE ADULTOS HERNANDO DE MAGALLANES', value: '26087' },
  { text: 'ESCUELA DE PARVULOS SANTA GEMITA DE GALGANI', value: '26088' },
  { text: 'ESCUELA DE PARV. GIRASOL DE MAIPU', value: '26090' },
  { text: 'ESC. DE PARV. SEMILLITA DE LA FLORIDA', value: '26091' },
  { text: 'COLEGIO LOS ROBLES DEL CURATO', value: '26092' },
  { text: 'ESCUELA ESPECIAL TONKI TONKI TON', value: '26093' },
  { text: 'COLEGIO LAS AMERICAS DE PAINE', value: '26094' },
  { text: 'ESCUELA ESP. ALDEBARAN', value: '26097' },
  { text: 'ESCUELA ESPECIAL DANICALIN', value: '26098' },
  { text: 'ESCUELA DE PARV. MANZANITA', value: '26099' },
  { text: 'ESCUELA ESP. EL RIEL', value: '26100' },
  { text: 'ESCUELA ESP. INTEGRA', value: '26101' },
  { text: 'ESCUELA DE PARV. LI-MARLIN', value: '26102' },
  { text: 'ESC. ESP. NUESTRA SE\u00c3\u2018ORA DE COVADONGA', value: '26103' },
  { text: 'ESCUELA ESP. TERESIANA DEL ESFUERZO', value: '26104' },
  { text: 'ESCUELA ESP. RUTH DE CONCHALI', value: '26106' },
  { text: 'ESCUELA ESPECIAL BARCELONA', value: '26107' },
  { text: 'ESC. BAS. Y ESP. SAN ANDRES DE PENAFLOR', value: '26108' },
  { text: 'ESC. DE PARV. Y ESP. PUKARAY', value: '26111' },
  { text: 'ESCUELA ESP. RINCONADA', value: '26113' },
  { text: 'ESCUELA ESP. LA VILLETE', value: '26114' },
  { text: 'ESCUELA ESP. SILABAS', value: '26116' },
  { text: 'ESCUELA B\u00c3\u0081SICA N 149 SAN MARCEL', value: '26117' },
  { text: 'ESCUELA BAS. NEWTON SCHOOL', value: '26120' },
  { text: 'ESCUELA ESP. CAMILA BINFA', value: '26121' },
  { text: 'ESCUELA DE PARV. ANGEL DE LA GUARDA', value: '26123' },
  { text: 'ESCUELA BAS. ELLEN GOULD SCHOOL', value: '26125' },
  { text: 'ESC. ESP. MI NUEVO ARLEQUIN', value: '26126' },
  { text: 'ESC. DE PARV. Y ESP. KIMANTU DE PENAFLOR', value: '26128' },
  { text: 'ESCUELA BAS. MARIA JESUS', value: '26129' },
  { text: 'ESC. BAS. Y ESP. CHRIST SCHOOL DE PUDAHUEL', value: '26130' },
  { text: 'COLEGIO QUIMAY', value: '26134' },
  { text: 'ESC. BAS. DEL REAL', value: '26137' },
  { text: 'ESCUELA ESP. TRAGALUZ DEL BOSQUE', value: '26138' },
  { text: 'ESCUELA BAS. VILLA SAN IGNACIO', value: '26139' },
  { text: 'ESCUELA ESP. ANDALUE', value: '26140' },
  { text: 'ESCUELA DE PARV. MI-SOL', value: '26141' },
  { text: 'ESCUELA DE PARVULOS NUBELUZ', value: '26142' },
  { text: 'ESCUELA ESP. ANTIYAL', value: '26144' },
  { text: 'ESC. BAS. LA CANTERA DE MAPUHUE', value: '26145' },
  { text: 'ESC. ESP. ALTA-VIDA', value: '26147' },
  { text: 'ESC. ESP. CENTRO DE RECURSOS SUYAY', value: '26148' },
  { text: 'ESCUELA ESP. SANTO TOMAS APOSTOL', value: '26149' },
  { text: 'ESCUELA BAS. FITZROY COLLEGE', value: '26150' },
  { text: 'ESCUELA ESP. ACTIVACION DE LA INTELIGENCIA SE', value: '26151' },
  { text: 'ESCUELA BASICA SAN PEDRO APOSTOL DE PAINE', value: '26152' },
  { text: 'ESCUELA BASICA COLEGIO PE\u00c3\u2018ALOLEN', value: '26155' },
  { text: 'LICEO MUNICIPAL DE BATUCO', value: '26157' },
  { text: 'ESCUELA BAS. AKORI', value: '26158' },
  { text: 'ESCUELA ESP. ANTUKUYEN DE EL MONTE', value: '26159' },
  { text: 'ESCUELA DE PARV. CARRUSEL DE MAIPU', value: '26161' },
  { text: 'ESCUELA ESPECIAL NEWEN DE PUENTE ALTO', value: '26163' },
  { text: 'COLEGIO SAN JOSE DE CERRILLOS', value: '26164' },
  { text: 'ESCUELA DE PARV. MI MUNDO', value: '26165' },
  { text: 'ESCUELA ESP. ISRAELA DE SUAREZ', value: '26166' },
  { text: 'ESCUELA ESP. MI ISLITA', value: '26169' },
  { text: 'ESCUELA BASICA REMBRANDT', value: '26171' },
  { text: 'ESCUELA BAS. FALCON COLLEGE LITTLE', value: '26172' },
  { text: 'ESCUELA DE PARV. SANTA TERESITA DE JESUS', value: '26174' },
  {
    text: 'ESCUELA ESPECIAL NUESTRA SE\u00c2\u00a5ORA DE MONSERRAT',
    value: '26175',
  },
  { text: 'ESC. DE PARV. MADRE BERNARDA MORIN DE PROVIDE', value: '26176' },
  { text: 'ESCUELA DE PARV. MARIA MONTESORI DE PUENTE AL', value: '26178' },
  { text: 'ESCUELA DE PARV. LA CASITA ENCANTADA', value: '26180' },
  { text: 'ESCUELA DE PARV. ACUARELA DE LA FLORIDA', value: '26181' },
  { text: 'ESCUELA ESPECIAL TRIPANTU DE LA FLORIDA', value: '26182' },
  { text: 'ESCUELA DE PARV. BLANCA NIEVES DE LA FLORIDA', value: '26183' },
  { text: 'ESC. DE PARV. MI PARAGUITA', value: '26185' },
  { text: 'ESCUELA DE PARV. ANGELUZ', value: '26186' },
  { text: 'ESCUELA DE PARV. LOS PEQUES', value: '26187' },
  { text: 'ESC. DE PARV. MY LITTLE GARDEN DE PUENTE ALTO', value: '26188' },
  { text: 'ESCUELA DE PARV. BAM-BAM', value: '26189' },
  { text: 'ESCUELA DE PARV. FUTURAMA', value: '26191' },
  { text: 'ESCUELA DE PARV. SANTA TERESITA DE LOS ANDES', value: '26194' },
  { text: 'ESCUEL DE PARV. LOS PIRINCHOS', value: '26195' },
  { text: 'ESCUELA DE PARV. LOS CARI\u00c3\u2018OSITOS', value: '26197' },
  { text: 'ESC. DE PARV. NUEVO SIGLO DE EST. CENTRAL', value: '26199' },
  { text: 'ESCUELA DE PARV. PUDU', value: '26200' },
  { text: 'COLEGIO DE AD. EDUCAP', value: '26201' },
  { text: 'ESCUELA ESP. MI MUNDO EN PALABRAS DE BUIN', value: '26202' },
  { text: 'ESC. DE PARV. GIRASOL DE LA FARFANA', value: '26204' },
  { text: 'ESCUELA DE PARV. PASITOS', value: '26205' },
  { text: 'ESCUELA DE PARV. AMERICAN ACADEMY JUNIOR', value: '26207' },
  { text: 'ESCUELA DE PARV. JARDIN INFANTIL MIRO', value: '26208' },
  { text: 'COLEGIO SAN JUAN DIEGO DE GUADALUPE', value: '26209' },
  { text: 'ESCUELA BASICA LA VILLETE', value: '26210' },
  { text: 'ESCUELA DE PARVULOS N193 VALLE DEL SOL', value: '26211' },
  { text: 'ESC. DE PARVULOS JARD. INFANTIL ARTISTICO VAL', value: '26212' },
  { text: 'ESCUELA DE PARV. OHIGGINS', value: '26213' },
  {
    text: 'CENTRO DE EDUCACI\u00c3\u201cN DE ADULTOS BERNARDO O\u00c2\u00b4HIGGINS DE MAIP\u00c3\u0161',
    value: '26214',
  },
  { text: 'ESCUELA DE PARV. ESTRELLITAS MAGICAS', value: '26215' },
  { text: 'ESCUELA DE PARV. MUSICAL GARFIELD', value: '26216' },
  { text: 'ESCUELA DE PARV. MI FANTASIA', value: '26218' },
  { text: 'CENTRO EDUC. GOYENECHEA', value: '26219' },
  { text: 'ESCUELA DE PARV. TIO RICO', value: '26221' },
  { text: 'ESCUELA ESP. SANTA MARIA DE EL BOSQUE', value: '26222' },
  { text: 'ESCUELADEPARVULOS PIECESITOS DE NINOS', value: '26223' },
  { text: 'ESCUELA ESP. CANTOS NUEVOS', value: '26224' },
  { text: 'COLEGIO DE ADULTOS ROCKET', value: '26225' },
  { text: 'ESCUELA DE PARV. ARMONIA', value: '26226' },
  { text: 'ESCUELA ESP. ARCA DE LOS NI\u00c3\u2018OS', value: '26227' },
  { text: 'ESCUELA BAS. ECHAURREN N\u00c2\u00b0 2', value: '26228' },
  { text: 'ESCUELA DE PARVULOS Y ESPECIAL YAMPAI', value: '26229' },
  { text: 'ESCUELA ESP. SOL NACIENTE', value: '26230' },
  { text: 'ESCUELA ESP. ALEGRIA DE NI\u00c3\u2018OS', value: '26231' },
  { text: 'ESCUELA ESP. CANTARITO DE GREDA', value: '26232' },
  { text: 'ESCUELA BASICA PARTICULAR PAICAVI DE LAMPA', value: '26235' },
  { text: 'ESCUELA ESP. DIVERSIDAD', value: '26236' },
  { text: 'ESCUELA ESPECIAL AGORA', value: '26237' },
  { text: 'ESCUELA BASICA ALEMAN DEL VERBO DIVINO', value: '26238' },
  { text: 'ESCUELA DE PARV. Y ESP. AMANECER DE EL BOSQUE', value: '26239' },
  { text: 'ESCUELA ESPECIAL SEMILLITAS DE EL BOSQUE', value: '26240' },
  { text: 'ESCUELA ESP. SAN CLEMENTE DE HUECHURABA', value: '26241' },
  { text: 'ESCUELA ESP. CANTARES', value: '26242' },
  { text: 'ESCUELA ESP. SAN CARLOS DE MELIPILLA', value: '26243' },
  { text: 'ESCUELA BAS. SAN ESTEBAN DE MELIPILLA', value: '26244' },
  { text: 'ESCUELA BAS. CRISTIANO EL SEMBRADOR', value: '26245' },
  { text: 'ESCUELA ESP. PROFESORA ELSA BENITEZ', value: '26246' },
  { text: 'ESCUELA DE PARV. LA VILLITA', value: '26247' },
  { text: 'ESCUELA BASICA MIRAFLORES DE LAMPA', value: '26249' },
  { text: 'ESCUELA BAS. MISIONERO DE AGOSTINI', value: '26250' },
  { text: 'ESCUELA ESP. SAN BERNARDO', value: '26252' },
  { text: 'COLEGIO SANTA MARIA GORETTI DE PADRE HUR', value: '26254' },
  { text: 'ESCUELA ESP. CLEMENTE DE JESUS', value: '26255' },
  { text: 'ESCUELA ESP. PLAZUELA ENCANTADA', value: '26256' },
  { text: 'ESCUELA ESP. FLORECER', value: '26257' },
  { text: 'ESCUELA DE PARV. HEIDI DE LO ESPEJO', value: '26258' },
  { text: 'ESCUELA ESP. ANTOBEL', value: '26259' },
  { text: 'ESCUELA PART. BOSTON COLLEGE PUDAHUEL', value: '26260' },
  { text: 'ESCUELA ESP. SANTA CATALINA DE TALAGANTE', value: '26261' },
  { text: 'CENTRO EDUC. ESPECIAL HANS ASPERGER', value: '26262' },
  {
    text: 'ESCUELA ESP. EL PALACIO DE LOS NI\u00c3\u2018OS DE SAN B',
    value: '26263',
  },
  { text: 'ESCUELA ESP. SEMILLITA DE RECOLETA', value: '26264' },
  { text: 'COLEGIO CARPE DIEM DE CURACAVI', value: '26266' },
  { text: 'ESCUELA ESP. RUCA RAYEN', value: '26267' },
  { text: 'ESCUELA ESP. ARCOIRIS DE BUIN', value: '26270' },
  { text: 'ESCUELA BAS. VALLE VERDE', value: '26271' },
  { text: 'ESCUELA BASICA WESTON ACADEMY', value: '26272' },
  { text: 'ESCUELA ESP. MONTE CARMELO DE MAIPU', value: '26273' },
  { text: 'ESCUELA BAS. REINA NORTE', value: '26274' },
  { text: 'ESCUELA ESPECIAL KITARI', value: '26275' },
  { text: 'ESCUELA ESP. NI\u00c3\u2018O JESUS DE SAN JOAQUIN', value: '26276' },
  { text: 'ESCUELA BASICA ARISTA VITAE', value: '26278' },
  { text: 'ESCUELA DE PARV. SEVILLA', value: '26280' },
  { text: 'ESCUELA ESPECIAL EL TREBOL', value: '26281' },
  { text: 'ESCUELA ESP. CLINICA DAVILA', value: '26283' },
  { text: 'ESCUELA DE PARVULOS MELFORD', value: '26285' },
  { text: 'COLEGIO DE ADULTOS ANTU-ANAY', value: '26286' },
  { text: 'ESCUELA BASICA BRUNNENWEG', value: '26287' },
  { text: 'ESCUELA ESP. DESPERTARES DE PEDRO AGUIRRE CER', value: '26289' },
  { text: 'ESCUELA DE PARVULOS WESTON ACADEMY', value: '26290' },
  { text: 'LICEO MUNICIPAL LA FLORIDA', value: '26292' },
  { text: 'ESCUELA BAS. INTEGRAL ENLACES DE LAMPA', value: '26293' },
  { text: 'ESC. PART. EL SAUCE', value: '26295' },
  { text: 'ESCUELA BASICA MONTAHUE', value: '26297' },
  { text: 'ESCUELA LA ARAUCARIA DE MAIPU', value: '26298' },
  { text: 'ESCUELA ESP. EPUMALEN', value: '26299' },
  { text: 'ESC. PARV. LOS ANGELITOS DE MAIPU', value: '26300' },
  { text: 'COLEGIO DE ADULTOS JUAN RAMON JIMENEZ', value: '26302' },
  { text: 'COLEGIO ENRIQUE ALVEAR DE CERRO NAVIA', value: '26303' },
  { text: 'ESCUELA BAS. PE\u00c3\u2018IHUEN ANDINO', value: '26304' },
  { text: 'COLEGIO MONTAHUE DE PE\u00c3\u2018ALOLEN', value: '26305' },
  { text: 'ESC. ESP. DE COLORES PANDO', value: '26306' },
  { text: 'ESC. DE PARV. LA CASITA FELIZ', value: '26308' },
  { text: 'ESCUELA ESPECIAL  MAGOS', value: '26309' },
  { text: 'ESCUELA DE PARVULOS PASITOS DE QUILICURA', value: '26310' },
  { text: 'ESCUELA BASICA LINCOLN INTERN ACADEMY VALLE N', value: '26311' },
  { text: 'ESCUELA ESP. ALTUE DE CERRO NAVIA', value: '26316' },
  { text: 'ESC. PARV. ANT\u00c3\u0161 K\u00c3\u0161YEN', value: '26317' },
  { text: 'ESCUELA ESPECIAL SANTA RITA DE CASIA DE LA GR', value: '26318' },
  { text: 'ESCUELA DE PARV. TIA YAYI', value: '26319' },
  { text: 'ESC. ESP. CORAZON DE JESUS DE SAN BERNARDO', value: '26320' },
  { text: 'ESC. DE PARV. JARDIN INFANTIL GIRASOL DE SAN', value: '26321' },
  { text: 'ESC. PARV. SAN BENITO', value: '26322' },
  { text: 'ESC. ESP. SAN FRANCISCO DE LA PINTANA', value: '26323' },
  { text: 'EST. EDUC. PART. ARCANGEL GABRIEL N\u00c2\u00b0 2', value: '26324' },
  { text: 'ESC. ESP. PART. CARAMELOS DE LUZ', value: '26325' },
  { text: 'JARD\u00c3\u008dN INFANTIL CHICUREO', value: '26326' },
  { text: 'ESC. ESP. ANTILAF DE PE\u00c3\u2018AFLOR', value: '26327' },
  { text: 'COLEGIO ANTUQUENU ANDINO', value: '26328' },
  { text: 'ESC. ESP. PEUMAYEN DE MAIPU N\u00c2\u00b02', value: '26330' },
  { text: 'C. INTEGRAL DE AD. PROFESORA TERESA MOYA REYE', value: '26333' },
  { text: 'ESC. ESP. EL CANELO DE PUENTE ALTO', value: '26334' },
  { text: 'ESCUELA BASICA DUNALASTAIR VALLE NORTE', value: '26335' },
  { text: 'ESC. PARV. PABLITO NERUDA Y GABRIELA MISTRAL', value: '26336' },
  { text: 'ESCUELA ESPECIAL ADAES', value: '26337' },
  { text: 'ESC. DE PARV. CASPER', value: '26338' },
  { text: 'ESC. PARV. ADRIANNA BERZINS', value: '26340' },
  { text: 'ESC. BAS. NUEVA ESPERANZA DE EL BOSQUE', value: '26341' },
  { text: 'ESC. DE PARV. LOS DUENDECITOS DE LA GRANJA', value: '26342' },
  { text: 'ESC. ESP. MI MUNDO DE \u00c3\u2018U\u00c3\u2018OA', value: '26343' },
  { text: 'ESCUELA DE PARVULOS Y ESPECIAL CRISOL DE EL', value: '26344' },
  { text: 'ESC. BAS. EJERCITO DE SALVACION DE SANTIAGO', value: '26345' },
  { text: 'ESC. ESP. SANTA GEMA GALGANI', value: '26347' },
  { text: 'ESCUELA DE PARVULOS N 2251 ANDALUE DE SAN J', value: '26348' },
  { text: 'ESC ESP. CENTROS DE RETOS MULTIPLES LUZ Y ESP', value: '26349' },
  { text: 'ESCUELA ESP. SAN MARTIN DE PORRES', value: '26350' },
  { text: 'ESCUELA ESPECIAL N\u00c2\u00b02253 ANTULAF', value: '26351' },
  { text: 'ESC. PROFESOR FELIX ALVAREZ', value: '26352' },
  { text: 'ESCUELA ESP. ALTAZOR DE ESTACION CENTRAL', value: '26354' },
  { text: 'ESCUELA DE LENGUAJE MILLARAHUE', value: '26355' },
  {
    text: 'ESCUELA ESPECIAL N\u00c2\u00b0 2258 NI\u00c3\u2018O JESUS DE LA GR',
    value: '26356',
  },
  { text: 'ESCUELA ESPECIAL UN MUNDO DE PALABRAS', value: '26357' },
  { text: 'ESCUELA ESPECIAL CREA', value: '26358' },
  { text: 'ESCUELA ESPECIAL GABRIELA RUBIO', value: '26359' },
  { text: 'ESC. PARV. UN RINCON DE ALEGRIA', value: '26360' },
  { text: 'ESC. ESP. EL PRINCIPITO DE LA FLORIDA', value: '26361' },
  { text: 'COLEGIO SAN FRANCISCO DE ASIS DE SAN BERNARDO', value: '26362' },
  { text: 'ESCUELA ESPECIAL MONTESOL', value: '26364' },
  { text: 'COLEGIO SAN ALBERTO HURTADO DE PUDAHUEL', value: '26365' },
  { text: 'ESCUELA BASICA BOSTON COLLEGE DE SAN BERNARDO', value: '26367' },
  { text: 'COLEGIO SAN FRANCISCO DE SALES', value: '26368' },
  { text: 'ESCUELA BASICA LUNA NUEVA DE LA PINTANA', value: '26369' },
  { text: 'ESC. ESP. SAN ANTONIO DE LO PRADO', value: '26370' },
  { text: 'COLEGIO DE ADULTOS LOS LIBERTADORES DE MAIPU', value: '26371' },
  { text: 'ESCUELA BASICA SAN LUCAS DE LO ESPEJO', value: '26372' },
  { text: 'ESCUELA DE PARVULOS Y ESPECIAL SANTA TERESA', value: '26373' },
  { text: 'ESCUELA PATRONA DE LOURDES', value: '26378' },
  { text: 'COLEGIO SANTIAGO', value: '26379' },
  { text: 'COLEGIO NUEVA ERA SIGLO XXI SEDE PUENTE ALTO', value: '26381' },
  { text: 'ESCUELA ESPECIAL SANTA BLANCA', value: '26382' },
  { text: 'COLEGIO LOS ROBLES DEL COPIHUE', value: '26383' },
  { text: 'COLEGIO TEC. PROF. SAN RAMON LA CISTERNA', value: '26384' },
  { text: 'ESCUELA ESP. ANDELEN', value: '26386' },
  { text: 'ESC. BAS. Y ESP. COLLEGE PADRE HURTADO', value: '26387' },
  { text: 'ESCUELA ESP. SAN CRISTOBAL DE PUENTE ALTO', value: '26388' },
  { text: 'ESC. PARV.JARDIN INFANTIL COLONIAL DE LOS HAL', value: '26390' },
  { text: 'ESC. PARV. MI SONRISA', value: '26391' },
  { text: 'ESC. ALTAS CUMBRES DEL ROSAL', value: '26392' },
  { text: 'ESCUELA DE PARVULOS EL CANELO DE EL BOSQUE', value: '26393' },
  { text: 'ESCUELA DE PARVULOS Y ESPECIAL SAN FRANCISCO', value: '26395' },
  { text: 'ESCUELA ESPECIAL 2274 MATER', value: '26396' },
  { text: 'ESCUELA ESP. DE LENGUAJE CARAMELO', value: '26397' },
  { text: 'ESCUELA DE PARVULOS BURBUJITAS', value: '26398' },
  { text: 'ESCUELA DE PARVULOS UNICORNIO', value: '26402' },
  { text: 'INSTITUTO SEMBRADOR DE PE\u00c3\u2018AFLOR', value: '26403' },
  { text: 'COLEGIO HERMANOS CARRERA DE CHILE', value: '26405' },
  {
    text: 'ESCUELA ESPECIAL N\u00c2\u00b0 2278 NUESTRAS HUELLAS',
    value: '26406',
  },
  { text: 'ESCUELA ESP SANTA INES DE LA PAZ', value: '26407' },
  {
    text: 'ESC.ESPECIAL N\u00c2\u00ba 2279 SAN EXPEDITO DE LAMPA',
    value: '26408',
  },
  {
    text: 'ESCUELA RUCAMALEN DE EL BOSQUE INES VILLANUEVA E.I.R.L.',
    value: '26409',
  },
  { text: 'ESCUELA ESPECIAL VIVAN LOS NI\u00c3\u2018OS', value: '26410' },
  { text: 'COLEGIO NOVA TERRA', value: '26411' },
  { text: 'ESCUELA DE PARVULOS FANTASIAS', value: '26412' },
  { text: 'ESCUELA ESPECIAL N\u00c2\u00ba 168 NAJU', value: '26414' },
  { text: 'ESCUELA ESPECIAL CONGUILLIO', value: '26415' },
  { text: 'COLEGIO PREMILITAR CAPITAN IGNACIO CARRERA PINTO', value: '26416' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE MALEN', value: '26419' },
  {
    text: 'ESCUELA ESPECIAL N\u00c2\u00ba 2284 LOS ANGELITOS FELICE',
    value: '26420',
  },
  { text: 'ESCUELA DE PARVULOS EL ARCA DE NOE', value: '26421' },
  { text: 'ESCUELA ESPECIAL OSCARITO Y SUS AMIGOS', value: '26422' },
  { text: 'COLEGIO SCHOOL TIME', value: '26423' },
  { text: 'ESCUELA BASICA N\u00c2\u00ba 2286 LAMPA', value: '26424' },
  { text: 'ESCUELA ESP INTEGRAL DE PE\u00c3\u2018AFLOR', value: '26425' },
  { text: 'COLEGIO ESPECIAL HOSPITALARIO CON TODO EL COR', value: '26426' },
  { text: 'SCUOLA IMPERIALE', value: '26428' },
  { text: 'ESC DE PARVULOS MI RINCON MAGICO', value: '26429' },
  { text: 'ESCUELA DE PARVULOS AMAPOLA', value: '26431' },
  { text: 'ESCUELA ESPECIAL MI MUNDO EN PALABRAS', value: '26432' },
  { text: 'ESCUELA B\u00c3\u0081SICA PADRE ALVARO LAVIN', value: '26434' },
  { text: 'ESCUELA ESP SANTA MARCELA CRECER', value: '26435' },
  { text: 'COLEGIO TERRAUSTRAL DEL SOL', value: '26436' },
  { text: 'ESC ESP SAN GABRIEL DE LA FLORIDA', value: '26438' },
  { text: 'ESCUELA ESPECIAL NIDO DE PALABRAS', value: '26439' },
  { text: 'ESCUELA ESPECIAL JESUS ANGEL GAZO', value: '26441' },
  { text: 'ESC ESP STA MARTA DE PADRE HURTADO', value: '26442' },
  { text: 'ESCUELA ESPECIAL RENACER', value: '26443' },
  { text: 'ESCUELA ESPECIAL VENTANAL', value: '26445' },
  { text: 'ESCUELA DE LENGUAJE AMERICA II', value: '26446' },
  {
    text: 'ESCUELA ESPECIAL SANTA BARBARA DE P\u00c3\u2018AFLOR',
    value: '26447',
  },
  { text: 'ESCUELA ESPECIAL ELUNEY', value: '26448' },
  { text: 'ESCUELA DE LENGUAJE MIS TRES ANGELITOS', value: '26449' },
  { text: 'ESCUELA ESPECIAL PARAISO', value: '26450' },
  { text: 'ESCUELA ESPECIAL FLORES DE BOLLENAR', value: '26451' },
  { text: 'ESCUELA ESPECIAL ANTU-MAWEN', value: '26452' },
  { text: 'TIEMPO DE CRECER', value: '26453' },
  { text: 'COLEGIO SANTIAGO EMPRENDEDORES', value: '26454' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE DE JAVIG', value: '26455' },
  { text: 'ESCUELA ESPECIAL SANTA AMELIA', value: '26456' },
  { text: 'ESCUELA ESPECIAL MI MUNDO EN PALABRAS', value: '26457' },
  { text: 'ESCUELA ESPECIAL ANCHIMALLEN', value: '26459' },
  { text: 'ESCUELA BASICA JOSE MARIA DE LA CRUZ', value: '26460' },
  { text: 'EL ARCA DE LOS NI\u00c3\u2018OS LO ESPEJO', value: '26462' },
  { text: 'ESCUELA BASICA KINDERHAUS', value: '26463' },
  { text: 'ESCUELA DE LENGUAJE AMERICA', value: '26464' },
  { text: 'COLEGIO INSTITUTO RAM\u00c3\u201cN FREIRE', value: '26465' },
  { text: 'ESCUELA BASICA ELIODORO MATTE OSSA', value: '26466' },
  { text: 'ESCUELA ESPECIAL CAUQUENES', value: '26467' },
  { text: 'ESCUELA ESPECIAL UNIVERSAL', value: '26468' },
  { text: 'ESCUELA ESPECIAL EL ARCA DE LOS NI\u00c3\u2018OS', value: '26469' },
  { text: 'ESCUELA DE PARVULOS EL CASTILLO DE LOS BAJITO', value: '26470' },
  { text: 'ESCUELA ESPECIAL AGUSTINA', value: '26471' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ANTU', value: '26472' },
  { text: 'ESCUELA ESPECIAL VISTA HERMOSA', value: '26473' },
  { text: 'ESCUEL ESPECIAL BAMB\u00c3\u0161', value: '26474' },
  { text: 'BOSTON COLLEGE HUECHURABA', value: '26476' },
  { text: 'ESCUELA ESPECIAL MILLARAY', value: '26477' },
  { text: 'ESCUELA ESPECIAL PLAY COLLEGE', value: '26478' },
  { text: 'ESCUELA ESPECIAL PLAY COLLEGE II', value: '26479' },
  { text: 'ESCUELA DE LENGUAJE LUZ DE ESPERANZA', value: '26480' },
  { text: 'ESCUELA ESPECIAL LA MORENITA', value: '26481' },
  { text: 'COLEGIO INGLES SAN JOSE DE LINDEROS', value: '26482' },
  { text: 'Escuela especial de Lenguaje los clarines', value: '26483' },
  { text: 'ESCUELA ESPECIAL EL PASTORCITO', value: '26484' },
  { text: 'ESCUELA ESPECIAL N 200 CARAMELO II', value: '26485' },
  { text: 'ESCUELA ESPECIAL PIRQUE', value: '26487' },
  { text: 'ESCUELA DE LENGUAJE RAYITOS DE SOL', value: '26488' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE EL LUCERO', value: '26490' },
  { text: 'ESCUELA DE PARVULOS GUSANITO N\u00c2\u00ba2', value: '26491' },
  { text: 'ESCUELA DE LENGUAJE GUSANITO', value: '26493' },
  { text: 'ESCUELA BASICA SAN JAVIER DEL BOSQUE', value: '26494' },
  { text: 'ESCUELA ESPECIAL NUEVA ESPERANZA', value: '26495' },
  { text: 'ESCUELA ESPECIAL AMIGOS DEL BOSQUE', value: '26496' },
  { text: 'ESCUELA ESPECIAL MIS ANGELITOS', value: '26497' },
  { text: 'ESCUELA ESPECIAL CREACIONES', value: '26498' },
  { text: 'COLEGIO INTECTUR', value: '26499' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE SAN GABRIEL', value: '26500' },
  { text: 'LICEO LA GRANJA', value: '26501' },
  { text: 'ESCUELA DE PARVULOS KIDS PLACE', value: '26502' },
  { text: 'COLEGIO SAINT LOUIS SCHOOL', value: '26503' },
  { text: 'COLEGIO DE ADULTO CLOTARIO BLEST RIFFO', value: '26505' },
  { text: 'ESC. DE PARVULOS Y ESPECIAL SANTA JOSEFINA', value: '26506' },
  { text: 'COLEGIO SAN FRANCISCO DE PAINE', value: '26507' },
  { text: 'ESCUELA ESPECIAL MANDARINA', value: '26509' },
  { text: 'ESCUELA ESPECIAL INTEGRAL DE CARABINEROS', value: '26510' },
  { text: 'ESCUELA ESPECIAL GRIBEL DE LA GRANJA', value: '26512' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE LILIPUT', value: '26513' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE BOY HAPPY', value: '26514' },
  { text: 'COLEGIO C.I.E.A. GARCIA HURTADO DE MENDOZA', value: '26515' },
  { text: 'ESCUELA ESPECIAL NUEVO MUNDO PAC', value: '26517' },
  { text: 'ESCUELA ALTO MAWIDA', value: '26518' },
  { text: 'LICERO VESPERTINO DE ADULTOS FUTURO', value: '26519' },
  { text: 'ESC. ESP. JERUSALEN DE QUINTA NORMAL', value: '26520' },
  { text: 'ESCUELA ESPECIAL MAGOS DE RENCA', value: '26521' },
  { text: 'ESC. ESPECIAL STA. MARGARITA DE PAINE', value: '26522' },
  { text: 'ESC. ESP. MAGICAS PALABRAS', value: '26523' },
  { text: 'COLEGIO ANTIMANQUE', value: '26524' },
  { text: 'ESCUELA ESPECIAL TERESITA DE COLINA', value: '26526' },
  { text: 'ESCUELA ESPECIAL SAGRADA FAMILIA', value: '26527' },
  { text: 'ESC. DE LENGUAJE PIERO VON FALKENBERG', value: '26528' },
  { text: 'ESCUELA ESPECIAL ALTIOR', value: '26529' },
  { text: 'ESCUELA ESPECIAL ESPERANZA NUEVA', value: '26530' },
  { text: 'COLEGIO DE ADULTOS ESCUELA DEL CARI\u00c3\u2018O', value: '26531' },
  { text: 'ESCUELA BASICA SANTA MARIA DE LOS ANDES', value: '26532' },
  { text: 'ESCUELA ESPECIAL ARBOLIRIS', value: '26533' },
  { text: 'ESCUELA DE LENGUAJE "LA GRANJITA"', value: '26534' },
  { text: 'ESCUELA ESPECIAL N\u00c2\u00b0 2338 SONSOLES', value: '26535' },
  { text: 'ESCUELA ESPECIAL N\u00c2\u00ba 2339 "ATRAVIA"', value: '26536' },
  { text: 'ESCUELA ESPECIAL JUGUEMOS EN EL BOSQUE', value: '26537' },
  { text: 'COLEGIO TERRAUSTRAL OESTE S.A', value: '26538' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE MI CLUB RYMAI', value: '26540' },
  { text: 'ESCUELA ESPECIAL N\u00c2\u00ba 206 COLORES', value: '26541' },
  { text: 'ESCUELA ESPECIAL MUNDO INFANTIL RUTA SUR', value: '26543' },
  { text: 'ESCUELA ESPECIAL COSAS DE NINOS', value: '26544' },
  { text: 'THE INTERNATIONAL SCHOOL ARICA', value: '30001' },
  { text: 'COLEGIO EL ROBLE', value: '30002' },
  { text: 'COLEGIO JUAN PABLO II', value: '30003' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ARCO IRIS', value: '30004' },
  { text: 'COLEGIO MARIA MONTESSORI', value: '30005' },
  { text: 'COLEGIO HISPANO', value: '30006' },
  { text: 'ESC. ESP. LENG. LA GRANJITA SCHOOL', value: '30007' },
  {
    text: 'ESC.ESP.LENG.DIVINO NI\u00c3\u2018O JESUS DE ARICA',
    value: '30009',
  },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ESTRELLITA MUSIKAL', value: '30010' },
  { text: 'COLEGIO AMARU ANKU SCHOOL', value: '30012' },
  { text: 'ESCUELA EL AROMO', value: '31001' },
  { text: 'ESC. ESP. TRANS. DE LENG SAN MIGUEL', value: '31003' },
  { text: 'COL. EDUC VICTOR MANUEL GIOVANETTI ASTUDILLO', value: '31005' },
  { text: 'ESCUELA DE  LENGUAJE ALONQUEO', value: '31009' },
  { text: 'ESCUELA ESPECIAL CAPULLITO DE SOL DE ISLA DE', value: '31029' },
  { text: 'ESCUELA PRE MILITAR HEROES DE LA CONCEPCION', value: '31030' },
  { text: 'ESCUELA ESPECIAL JESUS DE PRAGA', value: '31032' },
  { text: 'ESCUELA ESPECIAL ANTAY', value: '31033' },
  { text: 'COLEGIO HUGO LANDAURO HENRIQUEZ', value: '31034' },
  { text: 'ESCUELA ESPECIAL ENCANTA PALABRAS', value: '31035' },
  { text: 'ESC. PARV.Y ESP MUNDOPALABRA DE BUIN', value: '31036' },
  { text: 'INSTITUTO CUMBRES DE CONDORES ORIENTE', value: '31037' },
  { text: 'ESCUELA ESPECIAL DE  LENGUAJE TEMPUS', value: '31038' },
  { text: 'COLEGIO DE ADULTOS ALTAZOL DE SANTIAGO', value: '31039' },
  { text: 'ESCUELA DE LENGUAJE "LA DAVILITA"', value: '31041' },
  { text: 'COLEGIO SAN ANDRES DE CALERA DE TANGO', value: '31042' },
  { text: 'ESCUELA ESPECIAL EL PORVENIR', value: '31043' },
  { text: 'COLEGIO DE ADULTOS EDUCAP', value: '31044' },
  { text: 'ESCUELA ESPECIAL ANTILLANCA', value: '31046' },
  { text: 'CENTRO EDUCACIONAL LIFE SUPPORT', value: '31047' },
  { text: 'COMPLEJO EDUC. ADULTOS CALETA SUR', value: '31048' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE NIDO DE LUZ', value: '31049' },
  { text: 'ESCUELA DE PARVULOS SAN AGUSTIN', value: '31050' },
  { text: 'ESCUELA ESPECIAL SAN LUIS DEL BOSQUE', value: '31051' },
  { text: 'COLEGIO VILLA EL SOL', value: '31052' },
  { text: 'ESCUELA ESPECIAL PALABRAS MAGICAS', value: '31053' },
  { text: 'COLEGIO EL LABRADOR', value: '31054' },
  { text: 'ESCUELA  DE PARVULOS LOS CASTA\u00c3\u2018OS', value: '31055' },
  { text: 'ESCUELA ESPECIAL SANTA ANA', value: '31056' },
  { text: 'ESCUELA ESPECIAL ALTO BUIN', value: '31057' },
  {
    text: 'ESCUELA  DE  PARVULOS N\u00c2\u00b02351 LA  PATA  RENATA',
    value: '31060',
  },
  { text: 'ESCUELA DE PARVULOS SAN JOSE SCHOOL', value: '31061' },
  { text: 'ESCUELA ESPECIAL PIECECITOS DE NI\u00c3\u2018OS', value: '31063' },
  { text: 'LICEO MASTER SCHOOL', value: '31064' },
  { text: 'LICEO TECNOLOGICO ENRIQUE KIRBERG B', value: '31065' },
  { text: 'COLEGIO LOS ROBLES DE LOS LIBERTADORES', value: '31066' },
  { text: 'ESCUELA DE PARVULOS MAGICOS COLORES', value: '31067' },
  { text: 'COLEGIO TERRA MONTE', value: '31068' },
  { text: 'ESCUELA ESPECIAL NUEVA AURORA', value: '31069' },
  { text: 'ESCUELA ESPECIAL EL RINCON DE JOSEFINA', value: '31072' },
  { text: 'ESCUELA DE PARVULOS Y ESPECIAL MANITOS CREATI', value: '31073' },
  { text: 'LICEO BICENTENARIO DE NI\u00c3\u2018AS DE MAIPU', value: '31074' },
  { text: 'ESCUELA ESPECIAL PANDY', value: '31077' },
  { text: 'LICEO BICENTENARIO SAN PEDRO DE PUENTE ALTO', value: '31078' },
  { text: 'COLEGIO INGLES', value: '31079' },
  { text: 'COLEGIO RENACER TP', value: '31080' },
  { text: 'ESCEULA DE LENGUAJE MIS PRIMERAS PALABRAS', value: '31081' },
  { text: 'ESCUELA DE LENGUAJE PEQUE\u00c3\u2018O ROBLE', value: '31138' },
  { text: 'ESCULA DE LENGUAJE MARIPOSITAS', value: '31144' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE MUNDO RAVALEN', value: '31145' },
  { text: 'COLEGIO HOSP. CLINICA LOS TIEMPOS', value: '31146' },
  { text: 'ESCUELA ESPECIAL LAS PEPAS', value: '31152' },
  { text: 'AULA HOSPITALARIA SAN ANTONIO', value: '31338' },
  { text: 'ESC. PARVULOS CASITA DE CRISTAL', value: '40000' },
  { text: 'ESCUELA DE PARVULOS OSITO', value: '40001' },
  { text: 'COLEGIO LEONARDO DA VINCI', value: '40006' },
  { text: 'JARDIN INFANTIL MIS PRIMEROS PASOS 2', value: '40007' },
  { text: 'INSTITUTO DE EDUCACION PARA EL ADULTO', value: '40008' },
  { text: 'CTRO.APOYO A LA EDUC.ESPEC.DE PUTAENDO', value: '40009' },
  { text: 'ESCUELA ESPECIAL SANTA TERESITA', value: '40010' },
  { text: 'JARDIN INFANTIL KIM RUKA', value: '40012' },
  { text: 'CTRO.INT.EDUC.ESP.NUEVA SIEMBRA', value: '40013' },
  { text: 'COLEGIO ANTU-LEMU', value: '40014' },
  { text: 'ESCUELA DE LENGUAJE SAN RAFAEL', value: '40015' },
  { text: 'ESC.ESPEC. DE LENGUAJE KAU KALEM', value: '40016' },
  { text: 'COLEGIO INFANTES DE LIMACHE', value: '40017' },
  { text: 'ESC. ESPEC. DE TRANST. ESPECIF.DEL LENGUAJE A', value: '40018' },
  { text: 'JARDIN INFANTIL ARCO IRIS', value: '40020' },
  { text: 'JARDIN INFANTIL KINDERLAND', value: '40021' },
  { text: 'COLEGIO SAN ALBERTO', value: '40023' },
  { text: 'LICEO TECNICO MUNICIPAL', value: '40024' },
  { text: 'LICEO REQUINOA', value: '40025' },
  { text: 'JARDIN INFANTIL DISNEYLANDIA', value: '40026' },
  { text: 'COLEGIO PASIONISTAS DE QUILPUE', value: '40027' },
  { text: 'ESCUELA ESPECIAL NUEVA ESPERANZA', value: '40028' },
  { text: 'LICEO POLIVALENTE PAIHUANO', value: '40029' },
  { text: 'ESC. ESP. DE LENGUAJE CARITA FELIZ', value: '40030' },
  { text: 'JARDIN INFANTIL VALLE DEL ENCANTO', value: '40031' },
  { text: 'COLEGIO DOMINGO FAUSTINO SARMIENTO', value: '40033' },
  { text: 'ESC.ESP. DE LENGUAJE PATITO MARINO', value: '40034' },
  { text: 'ESCUELA ESPECIAL ACUARELA', value: '40035' },
  { text: 'ESC. ESPECIAL DE LENGUAJE ALIWEN', value: '40037' },
  { text: 'COLEGIO WHIPPLE SCHOOL ORIENTE', value: '40038' },
  { text: 'AULA HOSPITALARIA MALEN-KAI WE\u00c3\u2018I', value: '40041' },
  { text: 'COLEGIO CASTILLA Y ARAGON', value: '40042' },
  { text: 'COLEGIO SUE\u00c3\u2018O DEL MA\u00c3\u2018ANA', value: '40043' },
  { text: 'CTRO ATENCION A LA DIVERSIDAD RAYUN', value: '40045' },
  { text: 'JARDIN INFANTIL TIA KITTY', value: '40046' },
  { text: 'COLEGIO SANTO TOMAS DE LAS ACACIAS', value: '40047' },
  { text: 'ESC.DISCAPACIDAD INTELECTUAL NADIEL', value: '40048' },
  { text: 'CTRO.ESTIM.DEL LENGUAJE SAN VALENTIN', value: '40049' },
  { text: 'JARDIN INFANTIL MIS PEQUE\u00c3\u2018OS ANGELITOS', value: '40050' },
  { text: 'ESC.ESP.DE TRAST.ESP DEL LENG.MI PANAL', value: '40051' },
  { text: 'ESC. ESP. DE TRANST. ESP DEL LENGUAJE G.MISTR', value: '40052' },
  { text: 'ESCUELA SANTA LAURA', value: '40054' },
  { text: 'ESC. ESP. TRANS. DEL LENG. CORDILLERA SINDEMP', value: '40055' },
  { text: 'ESC ESPECIAL DE LENGUAJE PUCARA', value: '40056' },
  { text: 'JARDIN INFANTIL ARCOIRIS', value: '40057' },
  { text: 'JARDIN INFANTIL MY LITTLE ANGEL', value: '40058' },
  { text: 'JARDIN INFANTIL INDIGO', value: '40059' },
  { text: 'JARDIN INFANTIL MI REINO DE COLORES', value: '40060' },
  { text: 'ESC.ESP.TRANS.ESPEC.DEL LENGUAJE LLAKOLEN', value: '40061' },
  { text: 'ESC ESPEC DE LENGUAJE ALONQUEO-BELLOTO', value: '40062' },
  { text: 'ESC.ESPEC.LENGUAJE SAN JOSE', value: '40063' },
  { text: 'COLEGIO AMERICO VESPUCIO', value: '40064' },
  { text: 'COLEGIO HERMANO CESAREO GOMEZ', value: '40065' },
  { text: 'ESCUELA DE PARVULOS ARCOIRIS', value: '40066' },
  { text: 'ESCUELA DE LENGUAJE Y TRAST.DE LA COM.PALABRI', value: '40068' },
  { text: 'ESC ESP. DE LENGUAJE MUNDO MAGICO', value: '40069' },
  { text: 'COLEGIO LANGUAGE SCHOOL', value: '40071' },
  { text: 'COLEGIO MONTE SION', value: '40073' },
  { text: 'ESC.ESP.DE TRAST. ESPEC.DEL LENG.JARDIN DE SU', value: '40074' },
  { text: 'ESCUELA ESPECIAL TERRA MATER', value: '40075' },
  { text: 'COLEGIO ADULTOS LAS VIOLETAS', value: '40076' },
  { text: 'ESCUELA CARDENAL RAUL SILVA HENRIQUEZ', value: '40078' },
  { text: 'JARDIN INFANTIL MELODIA', value: '40079' },
  { text: 'LICEO FERMIN DEL REAL CASTILLO', value: '40080' },
  { text: 'ESCUELA DE PARVULOS SAGRADO CORAZON DE JESUS', value: '40081' },
  { text: 'ESC ESP.DE LENG SAN FRANCISCO DE ASIS', value: '40082' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE NAHUEL', value: '40083' },
  { text: 'ESC.ESPECIAL DE LENGUAJE ANTILLANKA', value: '40085' },
  { text: 'JARDIN INFANTIL CARRUSEL', value: '40086' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE LOS ALMENDROS', value: '40089' },
  { text: 'ESCUELA ESPECIAL SANATORIO MARITIMO SN JUAN D', value: '40090' },
  { text: 'JARDIN INFANTIL LAS GOLONDRINAS', value: '40092' },
  { text: 'ESCUELA DE LENGUAJE KOALA', value: '40093' },
  { text: 'JARDIN INFANTIL TESIC-TESAC', value: '40094' },
  { text: 'ESCUELA RAYEN PAINE', value: '40095' },
  { text: 'JARDIN INFANTIL MAMPATO', value: '40097' },
  { text: 'LICEO TECNICO PROFESIONAL PAPUDO', value: '40099' },
  { text: 'COLEGIO NUESTRA ESPERANZA', value: '40101' },
  { text: 'ESC. TEC. INTERCULTURAL MIRADOR', value: '40102' },
  { text: 'ESCUELA TRASTORNO DEL LENGUAJE Y COM. SAMAL', value: '40104' },
  { text: 'JARDIN INFANTIL MUNDO PEQUE\u00c3\u2018O', value: '40105' },
  { text: 'ESC. ESPECIAL DE LENGUAJE EDUCERE', value: '40106' },
  { text: 'ESC. ESP. DE LENGUAJE TORNASOL', value: '40107' },
  { text: 'COLEGIO SAINT MATTHEW', value: '40110' },
  { text: 'JARDIN INFANTIL MAGIC GARDEN', value: '40111' },
  { text: 'COLEGIO DE ADULTOS AGUILA REAL', value: '40112' },
  { text: 'ESC.ESP. DE LENGUAJE RAYITO DE SOL', value: '40113' },
  { text: 'LICEO ORIENTE', value: '40114' },
  { text: 'CENTRO EDUCACIONAL PAULO FREIRE', value: '40115' },
  { text: 'ESCUELA PARTICULAR SAN SEBASTIAN DE CUYINHUE', value: '40116' },
  { text: 'ESCUELA ESP. DE LENGUAJE AMANCAY', value: '40119' },
  { text: 'ESC.ESP.LENGUAJE HUASCO EDUCA', value: '40121' },
  { text: 'ESC.ESP.DE LENG. MI PEQUE\u00c3\u2018O RINCON', value: '40122' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE GABRIELA MISTRAL', value: '40123' },
  { text: 'ESC. ESP. LENG. JOSE GRIMALDI ACOTTO', value: '40124' },
  { text: 'COLEGIO PUMAHUE CURAUMA', value: '40125' },
  { text: 'COLEGIO RAUL SILVA HENRIQUEZ', value: '40126' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ARCO IRIS', value: '40127' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ILWEN', value: '40130' },
  { text: 'JARDIN INFANTIL SNOOPY', value: '40132' },
  { text: 'ESCUELA CARCEL', value: '40133' },
  { text: 'ESCUELA ESPECIAL PEHUEN', value: '40135' },
  { text: 'ESCUELA ESP.DE LENGUAJE AMANCAY', value: '40136' },
  { text: 'COLEGIO SINAI', value: '40137' },
  { text: 'ESCUELA DE LENGUAJE DIDASKALOS', value: '40138' },
  { text: 'COLEGIO PIEDRA NEGRA', value: '40139' },
  { text: 'ESC. ESP. DE LENGUAJE LOS GIRASOLES LTDA.', value: '40140' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE SANTA ANA', value: '40141' },
  { text: 'ESC. ESP. DE LENGUAJE MI CASTILLO', value: '40142' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE LE PAROLE', value: '40143' },
  { text: 'JARDIN INFANTIL CURIE', value: '40144' },
  { text: 'ESCUELA ESPECIAL GERMINA', value: '40145' },
  { text: 'COLEGIO SAN RAMON', value: '40146' },
  { text: 'JARDIN INFANTIL HELENA BLAVATSKY', value: '40147' },
  { text: 'ESC.LENGUAJE SAN SEBASTIAN DE MAFIL', value: '40149' },
  { text: 'ESC. DE LENGUAJE MI SILABARIO', value: '40150' },
  { text: 'ESCUELA ESPECIAL MI SOL', value: '40152' },
  { text: 'JARDIN INFANTIL ESTRELLITA DE BELEN', value: '40153' },
  { text: 'ESCUELA DE LENGUAJE NUEVO INTI', value: '40154' },
  { text: 'COLEGIO DIEGO VEL\u00c3\u0081ZQUEZ', value: '40155' },
  { text: 'JARDIN INFANTIL WILKA', value: '40156' },
  {
    text: 'ESC ESP TRAST DE LA COMUN ARUSI\u00c3\u2018A LAS TARKAS',
    value: '40157',
  },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE FANTASIA', value: '40158' },
  { text: 'ESC ESP DE LENG RAMONA HENRIQUEZ ORTEGA', value: '40159' },
  { text: 'CTRO.EDUCACION INTEGRADA DE ADULTOS SAN FRANC', value: '40160' },
  { text: 'ESCUELA DE LENGUAJE LA UNION', value: '40161' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE CASTILLO DE PALA', value: '40163' },
  { text: 'ESC.ESP.LENG.ESTRELLITA MUSIKAL DE ARICA', value: '40164' },
  { text: 'ESC.ESP.LENG.HABLAPALABRAS', value: '40166' },
  { text: 'ESC.ESP.DE LENGUAJE MAS SOL', value: '40167' },
  { text: 'ESC.ESP.LENG LOS BENJAMINES', value: '40168' },
  { text: 'COLEGIO DIFERENCIAL COLIBR\u00c3\u008d', value: '40169' },
  {
    text: 'ESCUELA ESPECIAL DE LENGUAJE COMPA\u00c3\u2018IA DE JESU',
    value: '40170',
  },
  { text: 'ENGLISH COLLEGE SAGRADO CORAZON DE MARIA', value: '40171' },
  { text: 'ESCUELA ESP. DE LENGUAJE ILLAWARA', value: '40172' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE VICTORIA', value: '40173' },
  { text: 'ESCUELA ESPECIAL EL TENVILU', value: '40174' },
  { text: 'C.ED.INT.ADUL RUKANTU LOS LAGOS', value: '40175' },
  { text: 'COLEGIO SAN MATIAS', value: '40176' },
  { text: 'COLEGIO IRQIILLARIY', value: '40177' },
  { text: 'ESC. ESPECIAL LENGUAJE ABRACADABRA', value: '40178' },
  { text: 'JARDIN INFANTIL Y SALA CUNA DEL ANGEL', value: '40181' },
  { text: 'COLEGIO ESTACION', value: '40184' },
  { text: 'JARDIN INFANTIL LONDON INTERNATIONAL ACADEMY', value: '40185' },
  { text: 'COLEGIO DE ADULTOS GALILEO', value: '40186' },
  { text: 'PARVULARIO HAPPY CHILDREN', value: '40187' },
  { text: 'ESCUELA BASICA RIN CON DE PALABRAS', value: '40189' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE LOS COLORES', value: '40190' },
  { text: 'JARDIN INFANTIL MONTESSORI SAN ANDRES', value: '40191' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE PLAYLAND', value: '40192' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE FLOR DEL VALLE', value: '40193' },
  { text: 'COLEGIO DOMINGO SANTA MARIA', value: '40194' },
  { text: 'ESC. ESP. DE LENG. SAN JOSE DE MONT', value: '40195' },
  { text: 'ESC ESPECIAL DE LENGUAJE KUNAMASTA', value: '40197' },
  { text: 'COLEGIO SENDA', value: '40199' },
  { text: 'JARDIN INFANTIL EL MUNDO DE LOS ANGELITOS', value: '40200' },
  { text: 'COLEGIO MONTESSORI MILLANT\u00c3\u0161', value: '40202' },
  {
    text: 'COLEGIO HERIBERTO BALDINO ACU\u00c3\u2018A CASTILLO',
    value: '40203',
  },
  {
    text: 'ESCUELA ESPECIAL DE LENGUAJE PEQUE\u00c3\u2018AS VOCES',
    value: '40204',
  },
  { text: 'ESCUELA ESPECIAL COANIL', value: '40205' },
  { text: 'CENT.DE EDUC.INTEG.DE ADULT.PUELMAPU', value: '40206' },
  { text: 'ESCUELA ESPECIAL PAX TERRA', value: '40207' },
  { text: 'COLEGIO TECNICO PROFESIONAL ALTUE', value: '40208' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ELEFANTE MELODIA', value: '40209' },
  { text: 'ESC ESP DE LENGUAJE NIDOS DEL SABER', value: '40210' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE CHISPITAS ALEGRE', value: '40212' },
  { text: 'ESCUELA DE PARVULOS ARCA DE NOE', value: '40213' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE MONTSERRAT EDUCA', value: '40216' },
  { text: 'CENTRO .ESPECIAL CORP. CLUB DE LEONES CRUZ DE', value: '40217' },
  { text: 'CENTRO DE RETOS MULTIPLES EDUCAR Y CRECER', value: '40218' },
  { text: 'COLEGIO SAGRADA FAMILIA', value: '40219' },
  { text: 'ESC. ESP. LENG. SEMILLITAS DE AMOR', value: '40225' },
  { text: 'ESCUELA ESPECIAL LOS ARRAYANES', value: '40226' },
  { text: 'COLEGIO TECNOLOGICO DE ARICA', value: '40230' },
  { text: 'COLEGIO CORDILLERA', value: '40231' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE KAILIN', value: '40233' },
  { text: 'JARDIN INFANTIL EBEN EZER EIRL', value: '40234' },
  { text: 'ESCUELA DE TRASTORNOS DEL LENGUAJE TIA SANDRA', value: '40235' },
  { text: 'COLEGIO DE LENGUAJE PADRE PIO SAN FERNANDO', value: '40236' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ANTUPIREN', value: '40237' },
  { text: 'ESCUELA ESPECIAL ESPERANZA VIVA', value: '40239' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ARCOIRIS', value: '40240' },
  { text: 'COLEGIO SAN JOSE', value: '40241' },
  { text: 'COLEGIO BICENTENARIO', value: '40242' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE LA TRINIDAD', value: '40243' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ILLIMANI', value: '40244' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE AMAPOLAS', value: '40245' },
  { text: 'ESCUELA ESPECIAL URUCHI', value: '40247' },
  { text: 'COLEGIO LOS FRESNOS', value: '40248' },
  { text: 'JARDIN INFANTIL AYEKANTUN', value: '40249' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE EL GEKITO', value: '40250' },
  { text: 'LICEO JUAN XXIII-VILLA ALEMANA', value: '40251' },
  {
    text: 'LICEO JOS\u00c3\u2030 CORT\u00c3\u2030S BROWN-RECREO',
    value: '40252',
  },
  { text: 'ESCUELA ESPECIAL AUDIMED -  LOS AROMOS', value: '40253' },
  { text: 'JARDIN INFANTIL Y SALA CUNA EL SOLDADITO', value: '40254' },
  { text: 'ESCUELA ESPEC.DE LENGUAJE CASABLANCA', value: '40255' },
  { text: 'COLEGIO TECNICO NACIONES UNIDAS', value: '40256' },
  { text: 'COLEGIO PILLANLIKAN', value: '40257' },
  { text: 'ESC.ESP.DE LENG Y JARDIN INFANTIL REMOLINOS', value: '40258' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ALONQUEO', value: '40259' },
  { text: 'INSTITUTO IBERO CHILE', value: '40260' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE KEWEN', value: '40261' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ULTIMA ESPERANZA', value: '40262' },
  { text: 'JARDIN INFANTIL PARTICULAR "ROTATIN"', value: '40264' },
  { text: 'CENTRO EDUCATIVO RENACER-ESC ESP Y TALLER LAB', value: '40265' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ENTRETEPALABRAS', value: '40266' },
  { text: 'ESC.ESP.LENG.Y J.INF.CASTILLO DE SONRISAS', value: '40267' },
  { text: 'JARDIN INFANTIL MUNDO MELODIA', value: '40268' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE SAN JUAN BOSCO', value: '40269' },
  { text: 'ESCUELA DE LENGUAJE YATI\u00c3\u2018A', value: '40270' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE CUNCUNITA AMARIL', value: '40271' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE SANTA INES', value: '40272' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE TIERRA DE ANGELE', value: '40273' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE MATICES', value: '40275' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE LANKUYEN', value: '40276' },
  { text: 'SCUOLA ITALIANA VILLA ALEMANA', value: '40278' },
  { text: 'JARDIN INFANTIL AULA MAGICA', value: '40279' },
  { text: 'CENTRO DE EDUCACION ESPECIAL BELLAVISTA', value: '40281' },
  { text: 'COMUNIDAD DE APRENDIZAJE VINCULOS CASTRO', value: '40282' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE INANTUE', value: '40283' },
  { text: 'COLEGIO ANDALUE', value: '40284' },
  { text: 'COLEGIO PARTICULAR DA VINCI SCHOOL', value: '40285' },
  { text: 'DUC IN ALTUM! COLEGIO PARA ADULTOS', value: '40286' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE LOURDES', value: '40287' },
  { text: 'COLEGIO GENE BARBER SJ', value: '40288' },
  { text: 'INSTITUTO BICENTENARIO J.MIGUEL CARRERA', value: '40289' },
  { text: 'ESCUELA DE ADULTOS MONTULN KIMK\u00c3\u2039LEM', value: '40290' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ELUM KIMU', value: '40291' },
  { text: 'JARDIN INFANTIL BAMBI', value: '40292' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE SAN JOAQUIN', value: '40293' },
  { text: 'RAICES DE QUELLON', value: '40296' },
  { text: 'COLEGIO INNOVASUR', value: '40297' },
  { text: 'COLEGIO BERNARDO O`HIGGINS', value: '40298' },
  { text: 'COLEGIO ROBLES', value: '40299' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ANTIYAL LAS COMP', value: '40300' },
  { text: 'LICEO POLITECNICO DE QUELLON', value: '40301' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE EL ARBOL', value: '40302' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE CHOCOLATITO', value: '40303' },
  { text: 'ESCUELA PARTICULAR RIO DE LA PLATA', value: '40304' },
  { text: 'COLEGIO JUAN PABLO II', value: '40305' },
  {
    text: 'ESCUELA ESPECIAL DE LENGUAJE PEQUE\u00c3\u2018O ARCOIRIS',
    value: '40307',
  },
  { text: 'COMUNIDAD DE APRENDIZAJE VINCULOS PUERTO MONT', value: '40308' },
  { text: 'ESCUELITA ESPECIAL DE LENGUAJE MAMI\u00c3\u2018A', value: '40309' },
  { text: 'COLEGIO PUCARA', value: '40310' },
  { text: 'COLEGIO CAUPOLICAN', value: '40311' },
  { text: 'COLEGIO ESPECIAL SAN LORENZO', value: '40312' },
  { text: 'ESC. ESPECIAL TECNOLOGICA LAS PALMAS', value: '40314' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE VALLE DE NANCAGU', value: '40315' },
  { text: 'PUMANQUE COLLEGE', value: '40316' },
  { text: 'ESCUELA ESPECIAL LENGUAJE AMAUTA', value: '40317' },
  { text: 'ESCUELA ESPECIAL CORPADIS', value: '40318' },
  { text: 'COLEGIO PART. SUB. CUMBRES DEL CHOAPA', value: '40319' },
  { text: 'COLEGIO ACADEMIA TARAPACA ORELLA', value: '40320' },
  { text: 'COLEGIO DE ADULTOS BRILLA EL SOL DE LA SERENA', value: '40321' },
  { text: 'ESC. ESP. DE TRAST. DEL LENGUAJE CORDILLERA P', value: '40322' },
  { text: 'SALA CUNA Y JARDIN INFANTIL RELMU', value: '40323' },
  { text: 'ESC. ESP. DE TRAST. ESPEC. DE LENGUAJE ALTUE', value: '40324' },
  { text: 'COLEGIO MASTTAY', value: '40325' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE HABLA PALABRA', value: '40326' },
  { text: 'ESCUELA DIEGO RIVERA', value: '40328' },
  { text: 'COLEGIO ROBERTO BRAVO', value: '40329' },
  { text: 'COLEGIO SAN FRANCISCO DE VALLE HERMOSO', value: '40331' },
  { text: 'ESC ESP DE LENGUAJE ENTRETENI\u00c3\u2018OS', value: '40332' },
  { text: 'ESC. ESPEC. DE LENGUAJE LLANQUIRAY', value: '40333' },
  { text: 'AULA HOSPITALARIA AYUUKELEN EPU', value: '40334' },
  { text: 'AULA HOSPITALARIA AYUUKELEN', value: '40335' },
  { text: 'COLEGIO NIMARA', value: '40336' },
  { text: 'ACONCAGUA EDUCA', value: '40338' },
  { text: 'LICEO DE ALTO DEL CARMEN', value: '40340' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE SEMILLITAS', value: '40341' },
  { text: 'ESCUELA ESPEC. DE LENGUAJE REY CARLOS', value: '40342' },
  { text: 'COLEGIO CREACION LA ARAUCANA PUERTO MONTT', value: '40343' },
  { text: 'CENTRO EDUCACIONAL VICTORIA ESPERANZA', value: '40348' },
  { text: 'COLEGIO BOSQUEMAR', value: '40351' },
  { text: 'LICEO TEC.PROFESIONAL PEDRO AGUIRRE CERDA', value: '40352' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE SAN ENRIQUE', value: '40353' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE SANTA CRUZ', value: '40359' },
  { text: 'ESCUELA ESPECIAL MI MUNDO', value: '40360' },
  { text: 'JARDIN INFANTIL REMOLINO', value: '40362' },
  { text: 'COLEGIO ALCAZAR DE ARICA', value: '40363' },
  { text: 'ESC.ESP.DE LENGUAJE CUMBRES DE PETORCA', value: '40364' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ANTIHUAL', value: '40365' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE PALABRITAS', value: '40366' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ARREBOL', value: '40367' },
  { text: 'ESC ESP DE LENG SENDERO DEL SABER', value: '40368' },
  { text: 'ESCUELA DE EDUCACION ESPECIAL AMANECER', value: '40369' },
  { text: 'COLEGIO PUKALAN DE ALGARROBO', value: '40370' },
  { text: 'COLEGIO SAN CARLOS DE LAS CABRAS', value: '40371' },
  { text: 'ESCUELA ESPECIAL DE LENJUAJE BAMBOO', value: '40372' },
  { text: 'JARDIN INFANTIL MI MUNDO', value: '40373' },
  { text: 'COLEGIO ESPECIAL ESTRELLA DE LUZ', value: '40374' },
  { text: 'ESC ESP  DE LENGUAJE GOTITAS DE ROCIO', value: '40377' },
  { text: 'ESC.ESPEC.DE LENGUAJE EDUCATEL PLACERES', value: '40378' },
  { text: 'ESC.ESPEC.DE LENGUAJE PEQUE\u00c3\u2018OS REYES', value: '40379' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE BETEL', value: '40380' },
  { text: 'COLEGIO ACONCAGUA EDUCA', value: '40381' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE ARTELIN', value: '40382' },
  { text: 'ESCUELA BASICA "MIL PAISAJES-QUEMCHI"', value: '40383' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE MATEITO\u00c2\u00b4S', value: '40384' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE SOL Y LUNA', value: '40385' },
  { text: 'ESC.ESPEC.DE LENGUAJE EXPLORA AMANCAY', value: '40386' },
  {
    text: 'JARDIN INFANTIL Y SALACUNA MI PEQUE\u00c3\u2018O GENIO',
    value: '40387',
  },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE MATISSE', value: '40388' },
  { text: 'ESCUELA HOSPITALARIA ALIANZA', value: '40390' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE VICENTE HUIDOBRO', value: '40391' },
  {
    text: 'SCUOLA ITALIANA ARTURO DELL ORO VI\u00c3\u2018A DEL MAR',
    value: '40393',
  },
  {
    text: 'ESC.ESP.TRAST.DE LA COMUNICACI\u00c3\u201cN HIRONDELLE',
    value: '40394',
  },
  { text: 'COLEGIO JOHN WALL HOLCOMB', value: '40395' },
  { text: 'ESC ESP DE LENG CAMPO VERDE', value: '40396' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE EDUCA INFANCIA', value: '40397' },
  { text: 'ESCUELA ESPECIAL DE LENGUAJE MATICES', value: '40398' },
  { text: 'COLEGIO NAZARET', value: '40399' },
  { text: 'CENTRO DE EDUCACION INTEGRAL DE ADULTOS SANTA', value: '40400' },
  { text: 'ESC ESP DE LENGUAJE EL DESPERTAR', value: '40401' },
  { text: 'AULA HOSPITALARIA SAN PABLO', value: '40402' },
  { text: 'ESCUELA DE LENGUAJE HAPPY DAY', value: '40405' },
  { text: 'LICEO DE ADULTOS HERBERT VARGAS WALLIS', value: '8541' },
  { text: 'COLEGIO ALTO DEL MAIPO', value: '31253' },
  { text: 'COLEGIO BOSTON COLLEGE ALTO MACUL', value: '31387' },
  { text: 'NETLANDSCHOOL', value: '31340' },
  {
    text: 'CENTRO EDUCACION INTEGRAL ADULTOS CLAUDIO MATTE PEREZ',
    value: '3741',
  },
  { text: 'LICEO NACIONAL BICENTENARIO DE EXCELENCIA', value: '31293' },
  { text: 'ESCUELA PARTICULAR PDTE.JOSE J.PRIETO', value: '9656' },
  { text: 'COLEGIO POLITEC.NTRA.SRA.DE LA PRESENTAC', value: '10830' },
  { text: 'COLEGIO  INSTITUTO MANQUEHUE', value: '31428' },
  { text: 'LICEO MATER POPULI DEI', value: '31002' },
  { text: 'ESCUELA  E INSTITUTO DE MADRID', value: '9481' },
  { text: 'C.E.I.A. CALDERA', value: '13193' },
  { text: 'CENTRO TECNICO EDUCACIONAL SAN CAYETANO', value: '31388' },
  { text: 'AMAZING GRACE ENGLISH SCHOOL', value: '12781' },
  { text: 'LICEO BICENTENARIO DE TEMUCO', value: '20266' },
  { text: 'COLEGIO GRACE COLLEGE', value: '31276' },
  { text: 'Colegio Valles Del Maipo', value: '16886' },
  { text: 'COLEGIO THE SOUTHLAND', value: '31499' },
  { text: 'LICEO COMERCIAL DIEGO PORTALES PALAZUELO', value: '4162' },
  {
    text: 'COLEGIO TECNICO PROFESIONAL PROFESOR ENRIQUE SALINAS BUSCOVICH',
    value: '31116',
  },
  { text: 'Colegio Los Alerces De Talagante', value: '16807' },
  { text: 'Liceo Bicentenario Italia', value: '31295' },
  { text: 'Liceo Bicentenario de Talca', value: '16748' },
  { text: 'Instituto Domingo Eyzaguirre', value: '12775' },
  { text: 'Instituto Antonio Varas', value: '31346' },
  { text: 'Colegio Los Pensamientos', value: '31161' },
  { text: 'COLEGIO ALICANTE DEL VALLE', value: '31327' },
  { text: 'LICEO BICENTENARIO DE TALAGANTE', value: '31294' },
  { text: 'Liceo Cientifico Humanista La Chimba', value: '31343' },
  { text: 'Colegio Fraternidad', value: '31110' },
  { text: 'LICEO BICENTENARIO DE VI\u00c3\u2018A DEL MAR', value: '1676' },
  { text: 'SAN GABRIEL ENGLISH COLLEGE', value: '16896' },
  { text: 'LICEO POLIT\u00c3\u2030CNICO LOS ARENALES', value: '31345' },
  { text: 'INSTITUTO CHILE ASIA PACIFICO', value: '31012' },
  { text: 'COLEGIO ALMONDALE VALLE', value: '31119' },
  {
    text: 'LICEO BICENTENARIO DE EXCELENCIA FRANCISCO BILBAO BARQUIN DE QUILICURA',
    value: '31299',
  },
  { text: 'LICEO BICENT. PROV.STA. TERESA DE LOS ANDES', value: '31071' },
  { text: 'Lic.padre Alberto Hurtado Cruchaga', value: '12551' },
  { text: 'Liceo Bicentenario De Vallenar', value: '13202' },
  { text: 'Liceo Bicentenario Ciudad De Los Rios Valdivia', value: '31010' },
  { text: 'Centro Educacional Integral De Adult Acuario', value: '31167' },
  { text: 'LICEO BICENTENARIO DE CORONEL', value: '31103' },
  { text: 'Liceo Alto Cordillera De La Florida', value: '31432' },
  { text: 'Liceo Industrial De Rengo', value: '15843' },
  { text: 'LICEO ARTURO ALESSANDRI PALMA', value: '16754' },
  {
    text: 'LICEO POLIVALENTE REP\u00c3\u0161BLICA DEL PARAGUAY',
    value: '31128',
  },
  { text: 'Liceo Bicentenario De Cauquenes', value: '16751' },
  { text: 'OGR', value: '0' },
  { text: 'Colegio Palmares Oriente', value: '31378' },
  { text: 'Colegio Palmares Valle los C\u00f3ndores', value: '31379' },
  { text: 'Preuniversitario FEUC', value: '500000' },
  { text: 'COMPLEJO EDUCACIONAL MAIPU ANEXO RINCONADA', value: '500001' },
  { text: 'COLEGIO ALTOMONTE VILLA ALEMANA', value: '14952' },
  { text: 'ESCUELA DESARROLLO DE TALENTOS FEN', value: '500002' },
  { text: 'INSTITUTO CUMBRES DE CONDORES PONIENTE', value: '31153' },
  { text: 'CENTRO DE ESTUDIOS BORDEMAR', value: '40407' },
  { text: 'Fundaci\u00f3n Colabora de la Fuerza A\u00e9rea', value: '500003' },
  { text: 'Ensayo Presencial - Liceo Bicentenario Italia', value: '1031295' },
  { text: 'Ensayo Presencial - COLEGIO SUPERIOR DEL MAIPO', value: '1010608' },
  { text: 'Ensayo Presencial - COLEGIO MADRE PAULINA', value: '1017765' },
  {
    text: 'Ensayo Presencial - COLEGIO AURORA DE CHILE CHIGUAYANTE',
    value: '1017843',
  },
  { text: 'Ensayo Presencial - LICEO OBISPO SAN MIGUEL', value: '1017857' },
  { text: 'Ensayo Presencial - COLEGIO AURORA DE CHILE SUR', value: '1018066' },
  {
    text: 'Ensayo Presencial - ESCUELA BASICA REPUBLICA DE ISRAEL',
    value: '1004577',
  },
  {
    text: 'Ensayo Presencial - LICEO TECNICO FEMENINO A-29 DE CONCEPCION',
    value: '1004533',
  },
  {
    text: 'Ensayo Presencial - LICEO COMERCIAL ENRIQUE OYARZUN MONDACA',
    value: '1004534',
  },
  { text: 'Ensayo Presencial - LICEO DE NINAS', value: '1004553' },
  {
    text: 'Ensayo Presencial - COLEGIO REPUBLICA DEL BRASIL',
    value: '1004564',
  },
  { text: 'Ensayo Presencial - COLEGIO ESPANA', value: '1004574' },
  {
    text: 'Ensayo Presencial - LICEO SALESIANO DOMINGO SAVIO',
    value: '1004632',
  },
  { text: 'Ensayo Presencial - COLEGIO MARIA INMACULADA', value: '1004663' },
  { text: 'Ensayo Presencial - COLEGIO SANTA EUFRASIA', value: '1004664' },
  {
    text: 'Ensayo Presencial - LICEO TECN. PROFESIONAL JORGE SANCHEZ U.',
    value: '1004672',
  },
  {
    text: 'Ensayo Presencial - ESCUELA PARTICULAR PADRE LUIS AMIGO',
    value: '1004868',
  },
  {
    text: 'Ensayo Presencial - \tCOL. TECNICO PROFESIONAL LOS ACACIOS',
    value: '1017635',
  },
  { text: 'Ensayo Presencial - COLEGIO AMANECER', value: '1017788' },
  { text: 'Ensayo Presencial - COLEGIO EINSTEIN', value: '1017815' },
  {
    text: 'Ensayo Presencial - COLEGIO CONCEPCION SAN PEDRO',
    value: '1017606',
  },
  {
    text: 'Ensayo Presencial - LICEO COMERCIAL PROFESOR SERGIO MORAGA ARCIL',
    value: '1004707',
  },
  { text: 'Ensayo Presencial - LICEO LA ASUNCION', value: '1004762' },
  { text: 'Ensayo Presencial - COLEGIO AMANECER TALCAHUANO', value: '1018172' },
  {
    text: 'Ensayo Presencial - LICEO VICENTE ALBERTO PALACIOS VALDES',
    value: '1004829',
  },
  {
    text: 'Ensayo Presencial - Liceo Bicentenario Ciudad De Los Rios Valdivia',
    value: '1031010',
  },
  {
    text: 'Ensayo Presencial - INSTITUTO COMERCIAL DE VALDIVIA',
    value: '1006751',
  },
  {
    text: 'Ensayo Presencial - INSTITUTO ITALIA DE VALDIVIA',
    value: '1022540',
  },
  { text: 'Ensayo Presencial - LICEO ARMANDO ROBLES RIVERA', value: '1006754' },
  { text: 'Ensayo Presencial - COLEGIO COLONOS DE ALERCE', value: '1022560' },
  {
    text: 'Ensayo Presencial - INSTITUTO ALEMAN DE PUERTO MONTT',
    value: '1007717',
  },
  { text: 'Ensayo Presencial - COLEGIO DOMINGO SANTA MARIA', value: '1022434' },
  {
    text: 'Ensayo Presencial - LICEO INDUSTRIAL EULOGIO GORDO MONEO',
    value: '1000279',
  },
  { text: 'Ensayo Presencial - NORTH AMERICAN COLLEGE', value: '1010892' },
  {
    text: 'Ensayo Presencial - COLEGIO CARDENAL ANTONIO SAMORE',
    value: '1010915',
  },
  { text: 'Ensayo Presencial - COLEGIO ARICA COLLEGE', value: '1012587' },
  { text: 'Ensayo Presencial - \tLICEO OCTAVIO PALMA PEREZ', value: '1000004' },
  { text: 'Ensayo Presencial - LICEO DOMINGO SANTA MARIA', value: '1000052' },
  {
    text: 'Ensayo Presencial - COLEGIO PARROQUIAL PADRE NEGRO',
    value: '1000440',
  },
  { text: 'Ensayo Presencial - LICEO POLITECNICO BELEN', value: '1000430' },
  { text: 'Ensayo Presencial - COLEGIO PROVIDENCIA', value: '1000575' },
  {
    text: 'Ensayo Presencial - COLEGIO PART.SANTA TERESA DE JESUS',
    value: '1011107',
  },
  {
    text: 'Ensayo Presencial - COLEGIO SANTA MARIA EUFRASIA',
    value: '1000766',
  },
  { text: 'Ensayo Presencial - COLEGIO LA PROVIDENCIA', value: '1000768' },
  {
    text: 'Ensayo Presencial - COMPLEJO EDUCACIONAL CLAUDIO ARRAU LEON',
    value: '1006497',
  },
  {
    text: 'Ensayo Presencial - LICEO INTERCULTURAL TECNICO PROFESIONAL GUACOLDA',
    value: '1006643',
  },
  { text: 'Ensayo Presencial - LICEO PABLO NERUDA', value: '1005570' },
  {
    text: 'Ensayo Presencial - LICEO POLITECNICO PUEBLO NUEVO',
    value: '1005656',
  },
  {
    text: 'Ensayo Presencial - LICEO CAMILO HENRIQUEZ DE TEMUCO',
    value: '1005666',
  },
  {
    text: 'Ensayo Presencial - COMPLEJO EDUCACIONAL PADRE NICOLAS',
    value: '1005921',
  },
  {
    text: 'Ensayo Presencial - L.POLIV. SAGRADO CORAZON DE HOSPICIO',
    value: '1012650',
  },
  { text: 'Ensayo Presencial - COLEGIO SAMCA ARUMANTI', value: '1012533' },
  { text: 'Ensayo Presencial - COLEGIO HUMBERSTONE', value: '1012667' },
  {
    text: 'Ensayo Presencial - COLEGIO HISPANO BRITANICO IQUIQUE',
    value: '1012669',
  },
  { text: 'Ensayo Presencial - LICEO MARIA AUXILIADORA', value: '1000127' },
  { text: 'Ensayo Presencial - LICEO ACADEMIA IQUIQUE', value: '1000132' },
  {
    text: 'Ensayo Presencial - COLEGIO ACADEMIA TARAPACA ORELLA',
    value: '1040320',
  },
  {
    text: 'Ensayo Presencial - LICEO COMERCIAL DE LOS ANDES',
    value: '1001195',
  },
  { text: 'Ensayo Presencial - LICEO MARTA BRUNET', value: '1003638' },
  { text: 'Ensayo Presencial - LICEO LOS ANGELES A-59', value: '1004163' },
  {
    text: 'Ensayo Presencial - LICEO MIGUEL ANGEL CERDA LEIVA',
    value: '1004404',
  },
  { text: 'Ensayo Presencial - LICEO LATINOAMERICANO', value: '1002375' },
  {
    text: 'Ensayo Presencial - INSTITUTO DE INNOVACION TECNOLOGICA DIEGO PORTALES',
    value: '1016697',
  },
  { text: 'Ensayo Presencial - COLEGIO ANTILHUE', value: '1016608' },
  { text: 'Ensayo Presencial - LICEO ABATE MOLINA', value: '1002973' },
  { text: 'Ensayo Presencial - LICEO SANTA TERESITA', value: '1003005' },
  {
    text: 'Ensayo Presencial - LICEO MUNICIPAL POETISA GABRIELA MISTRAL',
    value: '1010686',
  },
  {
    text: 'Ensayo Presencial - CENTRO POLITECNICO PARTICULAR CONCHALI',
    value: '1025396',
  },
  {
    text: 'Ensayo Presencial - COLEGIO POLIVALENTE PLUS ULTRA',
    value: '1008616',
  },
  { text: 'Ensayo Presencial - COLEGIO POLIV. SAINT ORLAND', value: '1009801' },
  {
    text: 'Ensayo Presencial - CENTRO DE EDUC. TECN.PROFESIONAL CODEDUC',
    value: '1009867',
  },
  {
    text: 'Ensayo Presencial - COLEGIO POLIVALENTE PATRICIO MEKIS',
    value: '1009917',
  },
  {
    text: 'Ensayo Presencial - COLEGIO POLIV. ALEJANDRO FLORES',
    value: '1010313',
  },
  { text: 'Ensayo Presencial - INSTITUTO ANDES', value: '1025099' },
  { text: 'Ensayo Presencial - LICEO INSTITUTO NACIONAL', value: '1008485' },
  { text: 'Ensayo Presencial - COLEGIO ALTO PALENA', value: '1008598' },
  { text: 'Preuniversitario Padre Hurtado', value: '50004' },
  {
    text: 'Ensayos presenciales_LICEO COMERCIAL COMPUTACIONAL STA SARA',
    value: '1012855',
  },
  {
    text: 'Ensayos presenciales_COL. INTERNACIONAL ANTOFAGASTA LTDA.',
    value: '1012884',
  },
  {
    text: 'Ensayos presenciales_LICEO PARTICULAR EBEN EZER II',
    value: '1012891',
  },
  {
    text: 'Ensayos presenciales_THE GIANT SCHOOL ANTOFAGASTA',
    value: '1012958',
  },
  {
    text: 'Ensayos presenciales_LICEO COMERCIAL JERARDO MUNOZ CAMPO',
    value: '1000280',
  },
  {
    text: 'Ensayos presenciales_LICEO TECNICO DE ANTOFAGASTA\t',
    value: '1000283',
  },
  {
    text: 'Ensayos presenciales_LICEO DOMINGO HERRERA RIVERA',
    value: '1000287',
  },
  { text: 'Ensayos presenciales_NETLANDSCHOOL', value: '1031340' },
  {
    text: 'Ensayos presenciales_Liceo Cientifico Humanista La Chimba',
    value: '1031343',
  },
  { text: 'Ensayos presenciales_INS. SANTA MARIA', value: '1000358' },
  {
    text: 'Ensayos presenciales_COL. THE ANTOFAGASTA BRITISH SCHOOL',
    value: '1000361',
  },
  { text: 'Ensayos presenciales_COLEGIO CHILE NORTE', value: '1012712' },
  { text: 'Ensayos presenciales_COLEGIO MIRAMAR', value: '1012716' },
  {
    text: 'Ensayos Presenciales - LICEO COMERCIAL ARMANDO BRAVO BRAVO',
    value: '1005216',
  },
  { text: 'Ensayos presenciales_JOVINA NARANJO FERNANDEZ', value: '1000005' },
  {
    text: 'Ensayos Presenciales - LICEO TECNICO JUANITA FERNANDEZ SOLAR',
    value: '1005219',
  },
  {
    text: 'Ensayos Presenciales - LICEO PARTICULAR COMERCIAL CARAHUE',
    value: '1019925',
  },
  {
    text: 'Ensayos presenciales-COLEGIO SAN MARCOS DE ARICA',
    value: '1000056',
  },
  { text: 'Ensayos Presenciales - LICEO GREGORIO URRUTIA', value: '1006708' },
  {
    text: 'Ensayos Presenciales - LICEO H-C JORGE TEILLIER SANDOVAL',
    value: '1005823',
  },
  { text: 'Ensayos presenciales - COLEGIO ALEMAN DE ARICA', value: '1000060' },
  {
    text: 'Ensayos Presenciales - COMPLEJO EDUCACIONAL PADRE LAS CASAS',
    value: '1005574',
  },
  {
    text: 'Ensayos Presenciales - COMPLEJO EDUCACIONAL PADRE OSCAR MOSER',
    value: '1005663',
  },
  { text: 'Ensayos presenciales - JUNIOR COLLEGE', value: '1000069' },
  { text: 'Ensayos Presenciales - LICEO ISABEL POBLETE V.', value: '1005879' },
  { text: 'Ensayos presenciales - COLEGIO FRANCIS SCHOOL', value: '1013313' },
  {
    text: 'Ensayos Presenciales - LICEO DE CIENCIAS Y HUMANIDADES',
    value: '1006223',
  },
  {
    text: 'Ensayos Presenciales - LICEO POLITECNICO PITRUFQUEN',
    value: '1006252',
  },
  {
    text: 'Ensayos Presenciales - COMPLEJO EDUC.MONSENOR GUILLERMO HARTL',
    value: '1006253',
  },
  { text: 'Ensayos Presenciales - INSTITUTO CLARET', value: '1005654' },
  {
    text: 'Ensayos Presenciales - ESCUELA Y LICEO MONTESSORI',
    value: '1005659',
  },
  { text: 'Ensayos Presenciales - COLEGIO BAUTISTA', value: '1005810' },
  { text: 'Ensayos Presenciales - COLEGIO AMERICA', value: '1005897' },
  { text: 'Ensayos presenciales - SAINT JOHNS SCHOOL', value: '1013384' },
  {
    text: 'Ensayos presenciales - LICEO CARLOS IBANEZ DEL CAMPO',
    value: '1007941',
  },
  {
    text: 'Ensayos presenciales - COLEGIO NUESTRA SENORA DE ANDACOLLO',
    value: '1013420',
  },
  { text: 'Ensayos Presenciales - LICEO PUNTA DE RIELES', value: '1022012' },
  { text: 'Ensayos presenciales - LICEO GREGORIO CORDOVEZ', value: '1000517' },
  { text: 'Ensayos Presenciales - COLEGIO SAN CRISTOBAL', value: '1022262' },
  {
    text: 'Ensayos Presenciales - COLEGIO INGLES MABEL CONDEMARIN',
    value: '1022309',
  },
  {
    text: 'Ensayos presenciales - LICEO POLITECNICO DE OVALLE',
    value: '1000705',
  },
  {
    text: 'Ensayos Presenciales - LICEO CARMELA CARVAJAL DE PRAT',
    value: '1007325',
  },
  { text: 'Ensayos Presenciales - LICEO ELEUTERIO RAMIREZ', value: '1007329' },
  {
    text: 'Ensayos presenciales - COLEGIO LEONARDO DA VINCI - VICU\u00c3\u0090A',
    value: '1013606',
  },
  {
    text: 'Ensayos Presenciales - INSTITUTO COMERCIAL DE OSORNO',
    value: '1007331',
  },
  {
    text: 'Ensayos Presenciales - COLEGIO SANTA MARTA DE OSORNO',
    value: '1007401',
  },
  { text: 'Ensayos presenciales - LICEO LOS CONDORES', value: '1012603' },
  { text: 'Ensayos Presenciales - COLEGIO PUERTO MONTT', value: '1022306' },
  {
    text: 'Ensayos Presenciales - LICEO COMERCIAL PUERTO MONTT',
    value: '1007626',
  },
  {
    text: 'Ensayos presenciales - ACADEMIA IQUIQUE HOSPICIO',
    value: '1012605',
  },
  {
    text: 'Ensayos Presenciales - LICEO DE HOMBRES MANUEL MONTT',
    value: '1007627',
  },
  {
    text: 'Ensayos presenciales - LICEO SUPERIOR DIEGO PORTALES',
    value: '1012649',
  },
  {
    text: 'Ensayos Presenciales - LICEO ISIDORA ZEGERS DE HUNEEUS',
    value: '1007628',
  },
  { text: 'Ensayos Presenciales - LICEO FRAY PABLO DE ROYO', value: '1022113' },
  {
    text: 'Ensayos presenciales - LICEO LIBERT. GRAL.BERNARDO OHIGGINS',
    value: '1000107',
  },
  {
    text: 'Ensayos Presenciales - LICEO RECTOR ABDON ANDRADE COLOMA',
    value: '1007129',
  },
  { text: 'Ensayos Presenciales - COLEGIO CHARLES DARWIN', value: '1011680' },
  {
    text: 'Ensayos presenciales - ESCUELA DOMINGO SANTA MARIA',
    value: '1000110',
  },
  {
    text: 'Ensayos Presenciales - INSTIT.SUPERIOR DE COMERCIO JOSE MENENDEZ',
    value: '1008424',
  },
  { text: 'Ensayos Presenciales - INSTITUTO DON BOSCO', value: '1008454' },
  { text: 'Ensayos Presenciales - LICEO MARIA AUXILIADORA', value: '1008455' },
  {
    text: 'Ensayos presenciales - COLEGIO DIOCESANO OBISPO LABBE',
    value: '1012518',
  },
  { text: 'Ensayos Presenciales - COLEGIO MAHATMA GANDHI', value: '1040295' },
  { text: 'Ensayos presenciales - COLEGIO MARIA REINA', value: '1012573' },
  { text: 'Ensayos Presenciales - LICEO SAMCA ARUMANTI', value: '1012591' },
  { text: 'Ensayos Presenciales - COLEGIO LOS REYES', value: '1014359' },
  { text: 'Ensayos Presenciales - COLEGIO ACONCAGUA', value: '1001757' },
  {
    text: 'Ensayos Presenciales - COLEGIO HISPANO AMERICANO',
    value: '1012151',
  },
  {
    text: 'Ensayos Presenciales - LICEO PARROQUIAL SAN ANTONIO GOMEZ CARRENO',
    value: '1014328',
  },
  { text: 'Ensayos Presenciales - COLEGIO CASTELIANO', value: '1014629' },
  {
    text: 'Ensayos Presenciales - COLEGIO SAN ESTEBAN DE BULNES',
    value: '1017725',
  },
  { text: 'Ensayos Presenciales - LICEO MANUEL BULNES', value: '1003976' },
  {
    text: 'Ensayos Presenciales - ESCUELA JOSE HIPOLITO SALAS Y TORO',
    value: '1004571',
  },
  {
    text: 'Ensayos Presenciales - INSTITUTO SUPERIOR DE COMERCIO PROFESOR FDO. PEREZ BECERRA',
    value: '1003640',
  },
  {
    text: 'Ensayos Presenciales - LICEO AGRICOLA A-8 DE CHILLAN',
    value: '1003739',
  },
  {
    text: 'Ensayos Presenciales - LICEO COMERCIAL ANDRES BELLO LOPEZ',
    value: '1004977',
  },
  {
    text: 'Ensayos Presenciales - COLEGIO TERESIANO LOS ANGELES',
    value: '1017687',
  },
  {
    text: 'Ensayos Presenciales - LICEO COMERCIAL DIEGO PORTALES PALAZUELO',
    value: '1004162',
  },
  {
    text: 'Ensayos Presenciales - COLEGIO SAN RAFAEL ARCANGEL',
    value: '1004263',
  },
  {
    text: 'Ensayos Presenciales - COLEGIO PADRE MANUEL DALZON',
    value: '1017850',
  },
  {
    text: 'Ensayos presenciales - COLEGIO SANTO TOMAS DE CURICO',
    value: '1002787',
  },
  { text: 'Ensayos Presenciales - ESCUELA BASICA CRISOL', value: '1004408' },
  {
    text: 'Ensayos Presenciales - LICEO POLIVALENTE TOMAS HERRERA VEGA',
    value: '1003961',
  },
  { text: 'Ensayos presenciales - COLEGIO JUAN PIAMARTA', value: '1016446' },
  {
    text: 'Ensayos Presenciales - LICEO BERTA ZAMORANO LIZANA',
    value: '1011287',
  },
  {
    text: 'Ensayos presenciales - INSTITUTO LATINOAMERICANO-EUROPEO DE EDUCACI\u00d3N',
    value: '1016604',
  },
  {
    text: 'Ensayos presenciales - COLEGIO SAN IGNACIO DE TALCA',
    value: '1016627',
  },
  {
    text: 'Ensayos presenciales - LICEO MARTA DONOSO ESPEJO',
    value: '1002935',
  },
  { text: 'Ensayos Presenciales - INSTITUTO ANDRES BELLO', value: '1002995' },
  {
    text: 'Ensayos Presenciales - COLEGIO POLIVALENTE SAN AGUSTIN DE EL BOSQUE',
    value: '1025464',
  },
  {
    text: 'Ensayos Presenciales - INSTITUTO MONSENOR LECAROS',
    value: '1015502',
  },
  {
    text: 'Ensayos presenciales - CENTRO EDUCACIONAL DE HUECHURABA',
    value: '1010250',
  },
  { text: 'Ensayos Presenciales - LICEO TECNICO A-4', value: '1002102' },
  {
    text: 'Ensayos Presenciales - LICEO MUNICIPAL OSCAR CASTRO ZUNIGA',
    value: '1002110',
  },
  {
    text: 'Ensayos Presenciales - COLEGIO PARTICULAR THE GARDEN SCHOOL',
    value: '1009331',
  },
  { text: 'Ensayos Presenciales - LICEO JAVIERA CARRERA', value: '1008487' },
  {
    text: 'Ensayos Presenciales - COLEGIO SAN MIGUEL DE LOS ANDES',
    value: '1012077',
  },
  {
    text: 'Ensayos presenciales - COLEGIO INSTITUTO RAM\u00c3\u201cN FREIRE',
    value: '1026465',
  },
  {
    text: 'Ensayos Presenciales - CENTRO POLITECNICO PARTICULAR DE NUNOA',
    value: '1012217',
  },
  { text: 'Ensayos Presenciales - COLEGIO EL REDENTOR', value: '1009950' },
  { text: 'Preuniversitario Tesla', value: '500005' },
  { text: 'PuntajeNacional Chile', value: null },
  { text: 'Colegio Cabo De Hornos', value: '20441' },
  { text: 'Regimiento Los \u00c1ngeles UST', value: '500006' },
  { text: 'Ensayos masivos Universidad Mayor', value: '1040321' },
];



// WEBPACK FOOTER //
// ./src/variables/schoolList.js